
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3LqyI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("8ntLI")).default);
$parcel$export(module.exports, "useNaturalLanguageMode", () => (parcelRequire("iUwEA")).useNaturalLanguageMode);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $8ntLI = parcelRequire("8ntLI");

var $iUwEA = parcelRequire("iUwEA");

});
parcelRegister("8ntLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9364b529abd095e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "JQLBuilderWithAIEntryPoint", () => $a9364b529abd095e$export$b07dda773b3e2fba);

var $aklPX = parcelRequire("aklPX");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $7jTnu = parcelRequire("7jTnu");

var $c1Djs = parcelRequire("c1Djs");

var $bUnif = parcelRequire("bUnif");

var $6zXPf = parcelRequire("6zXPf");

var $4xbv3 = parcelRequire("4xbv3");

var $epTsa = parcelRequire("epTsa");

var $iUwEA = parcelRequire("iUwEA");

var $1tqww = parcelRequire("1tqww");

var $2QWuu = parcelRequire("2QWuu");

var $5wvgO = parcelRequire("5wvgO");

var $4tvLM = parcelRequire("4tvLM");
const $a9364b529abd095e$var$JQLBuilderWithAI = ({ onToggleAi: onToggleAi, fragmentKey: fragmentKey, maybeHydrationQueryReference: maybeHydrationQueryReference, ...props })=>{
    const data = (0, $j4oe4.useFragment)((0, $aklPX.default), fragmentKey);
    const isAtlassianIntelligenceEnabled = !!data?.shouldShowAtlassianIntelligence;
    const userPreferencesData = data?.userPreferences || null;
    // when cleaning up getWillShowNav4() remove useState(...) and rename isNLMode to isNaturalLanguageMode
    const [isNaturalLanguageMode, setIsNaturalLanguageMode] = (0, $eJOHy.useState)(false);
    const [isNLMode, { toggleNaturalLanguageMode: toggleNaturalLanguageMode, exitNaturalLanguageMode: exitNaturalLanguageMode }] = (0, $iUwEA.useNaturalLanguageMode)();
    const jqlDebuggerStoreActions = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bUnif.useJqlDebuggerStoreActions)() : undefined;
    if ((0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) jqlDebuggerStoreActions?.setExitNaturalLanguageMode(exitNaturalLanguageMode);
    const autoFocusNLToggle = (0, $eJOHy.useRef)(false);
    const [autoFocusState, setAutoFocusState] = (0, $eJOHy.useState)(false);
    // This function is used to reset the autofocus of the NL2JQL toggle button as part of the NL2JQL CTA Experiment,
    // which uses the new Atlaskit button where the autofocus bug is present.
    const onToggleBlur = (0, $eJOHy.useCallback)(()=>{
        setAutoFocusState(false);
    }, []);
    const onToggleNaturalLanguageMode = (0, $eJOHy.useCallback)(()=>{
        if (!(0, $6zXPf.getWillShowNav4)()) {
            onToggleAi && onToggleAi(!isNaturalLanguageMode);
            setIsNaturalLanguageMode(!isNaturalLanguageMode);
            if ((0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) // When the user enters the NL mode, we want to reset the JQL debugger so that two AI experiences are not live simultaneously
            // Current isNaturalLanguageMode is false -> means that onToggleNaturalLanguageMode was called to enter the NaturalLanguage Mode
            {
                if (!isNaturalLanguageMode) jqlDebuggerStoreActions?.resetStatus('ON_ENTER_NL_MODE');
            }
        } else {
            onToggleAi && onToggleAi(!isNLMode);
            toggleNaturalLanguageMode();
            if ((0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) // When the user enters the NL mode, we want to reset the JQL debugger so that two AI experiences are not live simultaneously
            // Current isNLMode is false -> means that onToggleNaturalLanguageMode was called to enter the NaturalLanguage Mode
            {
                if (!isNLMode) jqlDebuggerStoreActions?.resetStatus('ON_ENTER_NL_MODE');
            }
        }
        // Return focus to the toggle button when exiting NL mode
        autoFocusNLToggle.current = true;
        setAutoFocusState(true);
    }, [
        isNLMode,
        isNaturalLanguageMode,
        onToggleAi,
        toggleNaturalLanguageMode,
        jqlDebuggerStoreActions
    ]);
    (0, $eJOHy.useEffect)(()=>{
        autoFocusNLToggle.current = false;
    });
    // Delegate to JQLBuilder if NL is not enabled
    if (!isAtlassianIntelligenceEnabled) return (0, $7jTnu.fg)('nin_request_hydrate_query_earlier') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c1Djs.default), {
        ...props,
        userPreferencesData: userPreferencesData,
        beforeControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tqww.AIPremiumUpsellButtonPopup), null),
        maybeHydrationQueryReference: maybeHydrationQueryReference
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c1Djs.default), {
        ...props,
        userPreferencesData: userPreferencesData,
        beforeControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tqww.AIPremiumUpsellButtonPopup), null)
    });
    // The gate "ai-event-for-nl2jql-cta-change" is the targeting gate for the NL2JQL CTA Experiment. We use this as the autofucs
    // bug only appears on the experiment variant when we use the new Atlaskit button.
    // Bug explanation: https://www.loom.com/share/3485291b949c47a28e21e7ebc813d8ba?sid=78a8c293-8485-4861-92e9-077a45d7e8c5
    const JQLBuilderWithAIComponent = (0, $7jTnu.fg)('nin_request_hydrate_query_earlier') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c1Djs.default), {
        ...props,
        userPreferencesData: userPreferencesData,
        maybeHydrationQueryReference: maybeHydrationQueryReference,
        beforeControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5wvgO.NaturalLanguageToggle), {
            autoFocus: (0, $7jTnu.fg)('ai-event-for-nl2jql-cta-change') ? autoFocusState : autoFocusNLToggle.current,
            onClick: onToggleNaturalLanguageMode,
            fragmentRef: data,
            ...(0, $7jTnu.fg)('ai-event-for-nl2jql-cta-change') ? {
                onToggleBlur: onToggleBlur
            } : {}
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c1Djs.default), {
        ...props,
        userPreferencesData: userPreferencesData,
        beforeControls: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5wvgO.NaturalLanguageToggle), {
            autoFocus: (0, $7jTnu.fg)('ai-event-for-nl2jql-cta-change') ? autoFocusState : autoFocusNLToggle.current,
            onClick: onToggleNaturalLanguageMode,
            fragmentRef: data,
            ...(0, $7jTnu.fg)('ai-event-for-nl2jql-cta-change') ? {
                onToggleBlur: onToggleBlur
            } : {}
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilderWithAi",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        attributes: {
            isAiAvailable: isAtlassianIntelligenceEnabled,
            isAiEnabled: (0, $6zXPf.getWillShowNav4)() ? isNLMode : isNaturalLanguageMode
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4tvLM.SpotlightTourContainer), {
        userPreferences: userPreferencesData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $a9364b529abd095e$var$jqlBuilderWrapperStyles,
        ...(0, $7jTnu.fg)('render_jql_builder_in_ssr') ? false ? {
            'data-ssr-placeholder': 'jql-builder-with-ai'
        } : {
            'data-ssr-placeholder-replace': 'jql-builder-with-ai'
        } : {},
        "data-vc": `jql-builder-with-ai${false ? '-ssr' : ''}`
    }, (0, $6zXPf.getWillShowNav4)() && isNLMode || isNaturalLanguageMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2QWuu.NaturalLanguageToJQLWrapper), {
        ...props,
        onBack: onToggleNaturalLanguageMode,
        userPreferences: userPreferencesData
    }) : JQLBuilderWithAIComponent)));
};
var $a9364b529abd095e$export$2e2bcd8739ae039 = $a9364b529abd095e$var$JQLBuilderWithAI;
const $a9364b529abd095e$export$b07dda773b3e2fba = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9364b529abd095e$var$JQLBuilderWithAI, props);
const $a9364b529abd095e$var$jqlBuilderWrapperStyles = (0, $5Wv5g.xcss)({
    // JQL editor height is 52px for both "Basic" and "JQL" views
    // This can cause a layout shift when switching to the AI searchbox
    // Prior to using a min height on the common parent, the approach taken to avoid the layout shift is by using a matching margin
    // Using the min-height on the common parent is more immune for future changes in the AI search field effective height
    minHeight: '52px'
});

});
parcelRegister("aklPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $85418c704551619d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<87faaa1bbe4769cbca56503d4e11c68c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $85418c704551619d$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "atlassianIntelligenceProductFeature"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "ui_jqlBuilderWithAi_JQLBuilderWithAI",
        "selections": [
            {
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "feature",
                                "variableName": "atlassianIntelligenceProductFeature"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "atlassianIntelligenceProductFeatureInput"
                    },
                    v0 /*: any*/ 
                ],
                "kind": "ScalarField",
                "name": "shouldShowAtlassianIntelligence"
            },
            {
                "kind": "FragmentSpread",
                "name": "naturalLanguageToggle_jqlBuilderWithAi"
            },
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "spotlightTourContainer_jqlBuilderWithAi"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "naturalLanguageToJqlWrapper_jqlBuilderWithAi"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_jqlBuilder_JQLBuilder"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$85418c704551619d$var$node.hash = "ded14f441227ee258bb1f97921cfaf47";
var $85418c704551619d$export$2e2bcd8739ae039 = $85418c704551619d$var$node;

});

parcelRegister("c1Djs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdea910db13502ff$export$2e2bcd8739ae039);

var $epxdu = parcelRequire("epxdu");

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $jvwCK = parcelRequire("jvwCK");

var $j4oe4 = parcelRequire("j4oe4");

var $g8Az8 = parcelRequire("g8Az8");

var $5kYyR = parcelRequire("5kYyR");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $hHzDA = parcelRequire("hHzDA");

var $cWcbh = parcelRequire("cWcbh");

var $8KuTC = parcelRequire("8KuTC");

var $ch9En = parcelRequire("ch9En");

var $4xbv3 = parcelRequire("4xbv3");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $56qWy = parcelRequire("56qWy");

var $gQyru = parcelRequire("gQyru");

var $3JHgj = parcelRequire("3JHgj");

var $bAZUe = parcelRequire("bAZUe");

var $lw8qf = parcelRequire("lw8qf");
// Inline query when cleaning up nin_migrate_jql_builder_to_refetchable_query
/* eslint-disable @atlassian/relay/graphql-naming */ const $cdea910db13502ff$var$JQLBUILDER_FRAGMENT = (0, $epxdu.default);
const $cdea910db13502ff$var$JQLBuilderOld = ({ onPerformanceMark: onPerformanceMark, ...props })=>{
    const userPreferencesRef = (0, $j4oe4.useFragment)($cdea910db13502ff$var$JQLBUILDER_FRAGMENT, props.userPreferencesData);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "unhandled",
        packageName: "jiraJqlBuilder",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $g8Az8.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilder",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8KuTC.PerformanceContext).Provider, {
        value: onPerformanceMark || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bAZUe.JQLBuilderUIOld), {
        ...props,
        userPreferences: userPreferencesRef ?? null
    }))));
};
const $cdea910db13502ff$var$JQLBuilder = ({ query: query, viewContext: viewContext = null, scope: scope = null, projectKeys: projectKeys, searchModes: searchModes = [
    (0, $56qWy.SEARCH_MODE_ADVANCED),
    (0, $56qWy.SEARCH_MODE_BASIC)
], searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION), showOrderByPicker: showOrderByPicker, hideTextSearchInput: hideTextSearchInput = false, onPerformanceMark: onPerformanceMark, maybeHydrationQueryReference: maybeHydrationQueryReference, ...props })=>{
    const { onLoad: onLoad } = props;
    // Persist mode used in loading state to send in analytics
    const loadingModeRef = (0, $eJOHy.useRef)();
    const onLoadingMode = (0, $eJOHy.useCallback)((mode)=>{
        loadingModeRef.current = mode;
        onLoad?.(mode);
    }, [
        onLoad
    ]);
    const userPreferencesRef = (0, $j4oe4.useFragment)($cdea910db13502ff$var$JQLBUILDER_FRAGMENT, props.userPreferencesData);
    const searchModeResponse = userPreferencesRef?.jqlBuilderSearchMode;
    const selectedSearchMode = (0, $gQyru.toSearchModeWithBasicModeFallback)(searchModeResponse);
    if (searchModes.length === 0) throw new Error('Search mode should be non empty');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const uniqueSearchModes = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(searchModes);
    const isSearchModeToggleEnabled = uniqueSearchModes ? uniqueSearchModes.length > 1 : true;
    const irremovableFields = (0, $hHzDA.useIrremovableFields)(props.basicModeVisibleFields ?? (0, $hHzDA.DEFAULT_IRREMOVABLE_FIELDS)());
    const accountId = (0, $8q7lT.useAccountId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const initialJql = (0, $eJOHy.useRef)(query);
    const initialContextJql = (0, $3JHgj.useContextJql)({
        jql: initialJql.current,
        projectKeys: projectKeys
    });
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8qf.JQLBuilderFallback), {
        query: query,
        searchModes: searchModes,
        onLoad: onLoadingMode,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: props.searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    });
    const [initialQueryRef, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $cWcbh.HYDRATION_QUERY), (0, $7jTnu.fg)('nin_request_hydrate_query_earlier') ? maybeHydrationQueryReference : undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (!initialQueryRef) loadQuery({
            accountId: accountId ?? '',
            cloudId: cloudId,
            includeUser: initialJql.current.length > 0 && !!accountId,
            includeJira: initialJql.current.length > 0,
            jql: initialContextJql,
            isFilter: false,
            filterAri: '',
            viewContext: viewContext,
            scope: scope,
            isPlanReleaseFeatureToggleEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')
        }, {
            fetchPolicy: 'store-or-network',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
    /* Here we only need to initialise the query reference so we fire for the client on mount.
       We allow useRefetchableFragment in JQLBuilderUI to handle the refetching. */ // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "unhandled",
        packageName: "jiraJqlBuilder",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $g8Az8.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilder",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8KuTC.PerformanceContext).Provider, {
        value: onPerformanceMark || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jql-builder-main",
        fallback: fallback
    }, initialQueryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bAZUe.default), {
        query: query,
        searchModes: searchModes,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        uniqueSearchModes: uniqueSearchModes,
        hideTextSearchInput: hideTextSearchInput,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker,
        viewContext: viewContext,
        scope: scope,
        projectKeys: projectKeys,
        userPreferences: userPreferencesRef ?? null,
        initialQueryRef: initialQueryRef,
        onLoadingMode: onLoadingMode,
        loadingModeRef: loadingModeRef,
        ...props
    }) : fallback))));
};
var $cdea910db13502ff$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('nin_migrate_jql_builder_to_refetchable_query'), /*#__PURE__*/ (0, $eJOHy.memo)($cdea910db13502ff$var$JQLBuilder), /*#__PURE__*/ (0, $eJOHy.memo)($cdea910db13502ff$var$JQLBuilderOld));

});
parcelRegister("epxdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa95694d357fe4c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ab8189a4d60e37ca33c72cc50edbd6c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8fa95694d357fe4c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_jqlBuilder_JQLBuilder",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_jqlBuilder_JQLBuilderUI"
        },
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$8fa95694d357fe4c$var$node.hash = "939f009c6569621eae121104d8e94579";
var $8fa95694d357fe4c$export$2e2bcd8739ae039 = $8fa95694d357fe4c$var$node;

});

parcelRegister("g8Az8", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $57d2792abb57212f$export$c7209ce2e0d060ea);

var $dSzMM = parcelRequire("dSzMM");
const $57d2792abb57212f$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $dSzMM.isLoaderError)(error)
    });

});

parcelRegister("hHzDA", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IRREMOVABLE_FIELDS", () => $8dfb0535a129c1b9$export$10049973e0522c22);
$parcel$export(module.exports, "useIrremovableFields", () => $8dfb0535a129c1b9$export$28001ca0e14d9f37);
$parcel$export(module.exports, "useIrremovableFieldsAnalyticsAttributes", () => $8dfb0535a129c1b9$export$1b10c62780608464);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $f1Zdy = parcelRequire("f1Zdy");

var $6XJko = parcelRequire("6XJko");

var $dTJxm = parcelRequire("dTJxm");

var $81EFh = parcelRequire("81EFh");
const $8dfb0535a129c1b9$export$10049973e0522c22 = ()=>(0, $6XJko.isVisualRefreshEnabled)() ? [
        'project',
        'assignee',
        'type',
        'status'
    ] : [
        'project',
        'type',
        'status',
        'assignee'
    ];
/**
 * These are the built-in irremovable fields that, for convenience, can be referenced by key when
 * setting the `basicModeVisibleFields` prop. E.g.
 * ```
 * <JQLBuilder basicModeVisibleFields={['assignee']} />
 * ```
 *
 * **Any fields added here must have a unique jqlTerm across the Jira instance, usually system fields**
 *
 * TODO - Note Text is not considered an irremovable field, this will be addressed in:
 * https://jplat.jira.atlassian.cloud/browse/EM-7497
 */ const $8dfb0535a129c1b9$var$getBuiltInIrremovableFields = (formatMessage)=>(0, $6XJko.isVisualRefreshEnabled)() ? {
        [(0, $dTJxm.PROJECT_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.PROJECT),
            displayName: formatMessage((0, $81EFh.default).refinementProject)
        },
        [(0, $dTJxm.ASSIGNEE_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.ASSIGNEE),
            displayName: formatMessage((0, $81EFh.default).refinementAssignee)
        },
        [(0, $dTJxm.TYPE_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.TYPE),
            displayName: formatMessage((0, $81EFh.default).refinementType)
        },
        [(0, $dTJxm.STATUS_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.STATUS),
            displayName: formatMessage((0, $81EFh.default).refinementStatus)
        },
        [(0, $dTJxm.RESOLUTION_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.RESOLUTION),
            displayName: formatMessage((0, $81EFh.default).refinementResolution)
        },
        [(0, $dTJxm.LABELS_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.LABELS),
            displayName: formatMessage((0, $81EFh.default).refinementLabels)
        }
    } : {
        [(0, $dTJxm.PROJECT_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.PROJECT),
            displayName: formatMessage((0, $81EFh.default).refinementProject)
        },
        [(0, $dTJxm.TYPE_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.TYPE),
            displayName: formatMessage((0, $81EFh.default).refinementType)
        },
        [(0, $dTJxm.STATUS_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.STATUS),
            displayName: formatMessage((0, $81EFh.default).refinementStatus)
        },
        [(0, $dTJxm.ASSIGNEE_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.ASSIGNEE),
            displayName: formatMessage((0, $81EFh.default).refinementAssignee)
        },
        [(0, $dTJxm.RESOLUTION_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.RESOLUTION),
            displayName: formatMessage((0, $81EFh.default).refinementResolution)
        },
        [(0, $dTJxm.LABELS_FIELD_JQL_TERM)]: {
            ...(0, $dTJxm.LABELS),
            displayName: formatMessage((0, $81EFh.default).refinementLabels)
        }
    };
const $8dfb0535a129c1b9$var$getInvalidCustomFieldProperties = ({ displayName: displayName, jqlTerm: jqlTerm, fieldType: fieldType, searchTemplate: searchTemplate, operators: operators })=>{
    const invalidFieldProps = [];
    if (!displayName) invalidFieldProps.push('displayName');
    if (!jqlTerm) invalidFieldProps.push('jqlTerm');
    if (!fieldType) invalidFieldProps.push('fieldType');
    if (!searchTemplate) invalidFieldProps.push('searchTemplate');
    if (!operators || operators.length === 0) invalidFieldProps.push('operators');
    return invalidFieldProps;
};
const $8dfb0535a129c1b9$export$28001ca0e14d9f37 = (irremovableFieldsConfig)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const irremovableFields = (0, $eJOHy.useMemo)(()=>{
        const builtInFields = $8dfb0535a129c1b9$var$getBuiltInIrremovableFields(formatMessage);
        const entries = irremovableFieldsConfig.map((keyOrField)=>{
            /*
       * keyOrField is a string, map it to a built-in system field
       */ if (typeof keyOrField === 'string') {
                const builtInField = builtInFields[keyOrField];
                if (!builtInField) throw new Error(`useIrremovableFields hook received an unsupported key: ${keyOrField}`);
                return [
                    keyOrField,
                    builtInField
                ];
            }
            /*
       * keyOrField is an IrremovableField, perform some basic validaiton and add it to the Map
       */ const invalidFieldProps = $8dfb0535a129c1b9$var$getInvalidCustomFieldProperties(keyOrField);
            if (invalidFieldProps.length > 0) {
                (0, $gYnSx.default)({
                    event: createAnalyticsEvent({}),
                    // forces contextual attributes be included
                    meta: {
                        id: 'useIrremovableFields',
                        packageName: (0, $dTJxm.PACKAGE_NAME),
                        teamName: (0, $dTJxm.TEAM_NAME)
                    },
                    attributes: {
                        fieldType: keyOrField.fieldType,
                        searchTemplate: keyOrField.searchTemplate,
                        invalidFieldProps: invalidFieldProps.join(',')
                    }
                });
                throw new Error('useIrremovableFields hook received an unsupported field');
            }
            /*
       * everything in JQL Builder relies on jqlTerm being lower case, otherwise weird behaviour
       * will occur when comparing the JQL query with these fields while generating pickers
       */ const jqlTerm = keyOrField.jqlTerm.toLowerCase();
            const field = {
                ...keyOrField,
                jqlTerm: jqlTerm
            };
            return [
                jqlTerm,
                field
            ];
        });
        return new Map(entries);
    }, [
        createAnalyticsEvent,
        formatMessage,
        irremovableFieldsConfig
    ]);
    return irremovableFields;
};
const $8dfb0535a129c1b9$export$1b10c62780608464 = (irremovableFields)=>(0, $eJOHy.useMemo)(()=>{
        const irremovableFieldTypes = [
            ...irremovableFields.values()
        ].map(({ fieldType: fieldType })=>fieldType);
        const irremovableFieldCount = irremovableFields.size;
        const isDefaultIrremovableFields = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(Array.from(irremovableFields.keys()), $8dfb0535a129c1b9$export$10049973e0522c22());
        return {
            irremovableFieldTypes: irremovableFieldTypes,
            irremovableFieldCount: irremovableFieldCount,
            isDefaultIrremovableFields: isDefaultIrremovableFields
        };
    }, [
        irremovableFields
    ]);

});
parcelRegister("dTJxm", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $6c46fe1fee573462$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $6c46fe1fee573462$export$d57b6b390e78d90f);
$parcel$export(module.exports, "jqlAnonymizerVisitor", () => $6c46fe1fee573462$export$8b46ceeb1d0f7a0f);
$parcel$export(module.exports, "PROJECT_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$a94927c1053f515e);
$parcel$export(module.exports, "TYPE_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$92a0328342946939);
$parcel$export(module.exports, "STATUS_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$b9f8115d86beaf2e);
$parcel$export(module.exports, "ASSIGNEE_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$fe13eb78c06cd416);
$parcel$export(module.exports, "RESOLUTION_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$45a7314200effcd0);
$parcel$export(module.exports, "LABELS_FIELD_JQL_TERM", () => $6c46fe1fee573462$export$952c102639c1ed96);
$parcel$export(module.exports, "TEXT", () => $6c46fe1fee573462$export$d597759d33be802e);
$parcel$export(module.exports, "PROJECT", () => $6c46fe1fee573462$export$fe791c4fa892e400);
$parcel$export(module.exports, "TYPE", () => $6c46fe1fee573462$export$b87f371cbc396fcf);
$parcel$export(module.exports, "STATUS", () => $6c46fe1fee573462$export$e50006273435e7d4);
$parcel$export(module.exports, "ASSIGNEE", () => $6c46fe1fee573462$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "RESOLUTION", () => $6c46fe1fee573462$export$f1a6ce22cbb7eb32);
$parcel$export(module.exports, "LABELS", () => $6c46fe1fee573462$export$79b91d4669dcadcb);
$parcel$export(module.exports, "SPRINT", () => $6c46fe1fee573462$export$a316570a0dbfd2b0);
$parcel$export(module.exports, "AFFECTED_VERSION", () => $6c46fe1fee573462$export$d02178e10ccc3ea);
$parcel$export(module.exports, "FIX_VERSION", () => $6c46fe1fee573462$export$4c55d92eb3c27f18);
$parcel$export(module.exports, "PARENT", () => $6c46fe1fee573462$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "COMPONENT", () => $6c46fe1fee573462$export$af1e30ebbae9df3b);
$parcel$export(module.exports, "CREATOR", () => $6c46fe1fee573462$export$39a35fc5bd7af053);
$parcel$export(module.exports, "REPORTER", () => $6c46fe1fee573462$export$6d7021166edc895c);
$parcel$export(module.exports, "dateSearchTemplates", () => $6c46fe1fee573462$export$ffcdf2c6c4831acc);
$parcel$export(module.exports, "userFieldSearchTemplates", () => $6c46fe1fee573462$export$6616be37c70ab33f);
$parcel$export(module.exports, "EPIC_LINK", () => $6c46fe1fee573462$export$19f652d3d336f069);
$parcel$export(module.exports, "appearanceMap", () => $6c46fe1fee573462$export$c743cc8f0e853412);
$parcel$export(module.exports, "FunctionName", () => $6c46fe1fee573462$export$4b826ede0e88b93);
$parcel$export(module.exports, "KeywordName", () => $6c46fe1fee573462$export$84606816405f7142);
$parcel$export(module.exports, "OperandValues", () => $6c46fe1fee573462$export$1ab4f98e21fe0811);
$parcel$export(module.exports, "CASCADE_SELECT_FIELD_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$3e3df380922ad777);
$parcel$export(module.exports, "CASCADE_OPTION_FUNCTION_NAME", () => $6c46fe1fee573462$export$cd361098212837ad);
$parcel$export(module.exports, "NUMBER_RANGE_FIELD_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$4e0f2021e5a6dd20);
$parcel$export(module.exports, "NUMBER_RANGE_PICKER_ALLOWED_OPERATORS", () => $6c46fe1fee573462$export$787eee4b393220a3);
$parcel$export(module.exports, "CMDB_FIELD_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$51829c816d2b6247);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$33aa1485e40ffbb7);
$parcel$export(module.exports, "JSM_ORGANIZATIONS_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$b7429d5dab3b6ce5);
$parcel$export(module.exports, "JSM_WORK_CATEGORY_SEARCH_TEMPLATE", () => $6c46fe1fee573462$export$6f9d9c0166c7b52d);
$parcel$export(module.exports, "AQL_FUNCTION_NAME", () => $6c46fe1fee573462$export$ee8b282423818e0d);
$parcel$export(module.exports, "IQL_FUNCTION_NAME", () => $6c46fe1fee573462$export$c91c40035dea81da);
$parcel$export(module.exports, "ADD_FILTER_DROPDOWN", () => $6c46fe1fee573462$export$65639c30130233cb);
$parcel$export(module.exports, "ISSUE_KEY", () => $6c46fe1fee573462$export$5daa28d10e23592);
$parcel$export(module.exports, "getTextSearchInputField", () => $6c46fe1fee573462$export$3274f6964f86ac9b);

var $fRacX = parcelRequire("fRacX");
var $lNgEH = parcelRequire("lNgEH");
const $6c46fe1fee573462$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderBasic';
const $6c46fe1fee573462$export$d57b6b390e78d90f = 'empanada';
const $6c46fe1fee573462$export$8b46ceeb1d0f7a0f = new (0, $fRacX.JqlAnonymizerVisitor)();
const $6c46fe1fee573462$var$TEXT_FIELD_JQL_TERM = 'text';
const $6c46fe1fee573462$var$TEXT_FIELDS_FIELD_JQL_TERM = 'textfields';
const $6c46fe1fee573462$export$a94927c1053f515e = 'project';
const $6c46fe1fee573462$export$92a0328342946939 = 'type';
const $6c46fe1fee573462$export$b9f8115d86beaf2e = 'status';
const $6c46fe1fee573462$export$fe13eb78c06cd416 = 'assignee';
const $6c46fe1fee573462$export$45a7314200effcd0 = 'resolution';
const $6c46fe1fee573462$export$952c102639c1ed96 = 'labels';
const $6c46fe1fee573462$export$d597759d33be802e = {
    jqlTerm: $6c46fe1fee573462$var$TEXT_FIELD_JQL_TERM,
    searchTemplate: 'text',
    fieldType: 'text',
    operators: [
        (0, $lNgEH.OPERATOR_LIKE)
    ]
};
const $6c46fe1fee573462$export$fe791c4fa892e400 = {
    jqlTerm: $6c46fe1fee573462$export$a94927c1053f515e,
    searchTemplate: 'project',
    fieldType: 'project',
    operators: [
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_NOT_EQUALS)
    ]
};
const $6c46fe1fee573462$export$b87f371cbc396fcf = {
    jqlTerm: $6c46fe1fee573462$export$92a0328342946939,
    searchTemplate: 'issuetype',
    fieldType: 'issuetype',
    operators: [
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_NOT_EQUALS)
    ]
};
const $6c46fe1fee573462$export$e50006273435e7d4 = {
    jqlTerm: $6c46fe1fee573462$export$b9f8115d86beaf2e,
    searchTemplate: 'status',
    fieldType: 'status',
    operators: [
        (0, $lNgEH.OPERATOR_WAS_NOT_IN),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_WAS_NOT),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_WAS_IN),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_WAS),
        (0, $lNgEH.OPERATOR_CHANGED)
    ]
};
const $6c46fe1fee573462$export$f8f7545d2bb78afb = {
    jqlTerm: $6c46fe1fee573462$export$fe13eb78c06cd416,
    searchTemplate: 'assignee',
    fieldType: 'assignee',
    operators: [
        (0, $lNgEH.OPERATOR_CHANGED),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_WAS_NOT),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_WAS),
        (0, $lNgEH.OPERATOR_WAS_NOT_IN),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_WAS_IN),
        (0, $lNgEH.OPERATOR_NOT_IN)
    ]
};
const $6c46fe1fee573462$export$f1a6ce22cbb7eb32 = {
    jqlTerm: $6c46fe1fee573462$export$45a7314200effcd0,
    searchTemplate: 'resolution',
    fieldType: 'resolution',
    operators: [
        (0, $lNgEH.OPERATOR_WAS_NOT),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_LT_EQUALS),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_GT),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_GT_EQUALS),
        (0, $lNgEH.OPERATOR_WAS_NOT_IN),
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_WAS_IN),
        (0, $lNgEH.OPERATOR_WAS),
        (0, $lNgEH.OPERATOR_LT),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_CHANGED)
    ]
};
const $6c46fe1fee573462$export$79b91d4669dcadcb = {
    jqlTerm: $6c46fe1fee573462$export$952c102639c1ed96,
    searchTemplate: 'labels',
    fieldType: 'labels',
    operators: [
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_EQUALS)
    ]
};
const $6c46fe1fee573462$export$a316570a0dbfd2b0 = {
    jqlTerm: 'sprint',
    searchTemplate: 'com.pyxis.greenhopper.jira:gh-sprint-searcher',
    fieldType: 'com.pyxis.greenhopper.jira:gh-sprint',
    operators: [
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_NOT_EQUALS)
    ]
};
const $6c46fe1fee573462$export$d02178e10ccc3ea = {
    jqlTerm: 'affectedversion',
    searchTemplate: 'versions',
    fieldType: 'versions',
    operators: [
        (0, $lNgEH.OPERATOR_LT_EQUALS),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_LT),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_GT_EQUALS),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_GT),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_IN)
    ]
};
const $6c46fe1fee573462$export$4c55d92eb3c27f18 = {
    jqlTerm: 'fixversion',
    searchTemplate: 'fixVersions',
    fieldType: 'fixVersions',
    operators: [
        (0, $lNgEH.OPERATOR_LT_EQUALS),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_LT),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_GT_EQUALS),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_GT),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_IN)
    ]
};
const $6c46fe1fee573462$export$e0dfb65d1047c53c = {
    jqlTerm: 'parent',
    searchTemplate: 'parent',
    fieldType: 'parent',
    operators: [
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_IS_NOT)
    ]
};
const $6c46fe1fee573462$export$af1e30ebbae9df3b = {
    jqlTerm: 'component',
    searchTemplate: 'components',
    fieldType: 'components',
    operators: [
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_IS_NOT)
    ]
};
const $6c46fe1fee573462$export$39a35fc5bd7af053 = {
    jqlTerm: 'creator',
    searchTemplate: 'creator',
    fieldType: 'creator',
    operators: [
        (0, $lNgEH.OPERATOR_NOT_IN),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_IS_NOT)
    ]
};
const $6c46fe1fee573462$export$6d7021166edc895c = {
    jqlTerm: 'reporter',
    searchTemplate: 'reporter',
    fieldType: 'reporter',
    operators: [
        (0, $lNgEH.OPERATOR_CHANGED),
        (0, $lNgEH.OPERATOR_EQUALS),
        (0, $lNgEH.OPERATOR_NOT_EQUALS),
        (0, $lNgEH.OPERATOR_WAS_NOT),
        (0, $lNgEH.OPERATOR_IS_NOT),
        (0, $lNgEH.OPERATOR_WAS),
        (0, $lNgEH.OPERATOR_WAS_NOT_IN),
        (0, $lNgEH.OPERATOR_IS),
        (0, $lNgEH.OPERATOR_IN),
        (0, $lNgEH.OPERATOR_WAS_IN),
        (0, $lNgEH.OPERATOR_NOT_IN)
    ]
};
const $6c46fe1fee573462$export$ffcdf2c6c4831acc = new Set([
    'updated',
    'created',
    'duedate',
    'resolutiondate',
    'com.atlassian.jira.plugin.system.customfieldtypes:datetimerange',
    'com.atlassian.jira.plugin.system.customfieldtypes:daterange',
    'statuscategorychangedate',
    'com.atlassian.jira.toolkit:LastCommentDateSearcher',
    'com.atlassian.jira.ext.charting:firstreponsedatesearcher',
    'com.atlassian.jpo:jpo-custom-field-baseline-start-searcher',
    'com.atlassian.jpo:jpo-custom-field-baseline-end-searcher',
    'com.atlassian.servicedesk:sd-request-feedback-date-searcher'
]);
const $6c46fe1fee573462$export$6616be37c70ab33f = new Set([
    'assignee',
    'reporter',
    'creator',
    'com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher',
    'com.atlassian.jira.plugin.system.customfieldtypes:next-gen-people-searcher',
    'com.atlassian.jira.toolkit:participantsearcher',
    'com.atlassian.jira.toolkit:lastparticipantsearcher',
    'com.atlassian.servicedesk:sd-request-participants-searcher'
]);
const $6c46fe1fee573462$export$19f652d3d336f069 = {
    jqlTerm: 'epic link',
    searchTemplate: 'com.pyxis.greenhopper.jira:gh-epic-link-searcher'
};
const $6c46fe1fee573462$export$c743cc8f0e853412 = {
    BLUE_GRAY: 'default',
    MEDIUM_GRAY: 'default',
    BROWN: 'default',
    GREEN: 'success',
    YELLOW: 'inprogress',
    WARM_RED: 'removed'
};
const $6c46fe1fee573462$export$4b826ede0e88b93 = {
    currentUser: 'currentUser',
    standardIssueTypes: 'standardIssueTypes',
    subTaskIssueTypes: 'subTaskIssueTypes',
    membersOf: 'membersOf',
    releasedVersions: 'releasedVersions',
    unreleasedVersions: 'unreleasedVersions'
};
const $6c46fe1fee573462$export$84606816405f7142 = {
    empty: 'empty'
};
const $6c46fe1fee573462$export$1ab4f98e21fe0811 = {
    currentUser: {
        value: 'currentUser()',
        type: (0, $f38290926d0398e2$export$19c7c729db381f9d)
    },
    empty: {
        value: 'EMPTY',
        type: (0, $f38290926d0398e2$export$f6049126fd97001f)
    },
    standardIssueTypes: {
        value: 'standardIssueTypes()',
        isList: true,
        type: (0, $f38290926d0398e2$export$19c7c729db381f9d)
    },
    subTaskIssueTypes: {
        value: 'subTaskIssueTypes()',
        isList: true,
        type: (0, $f38290926d0398e2$export$19c7c729db381f9d)
    },
    membersOf: {
        value: 'membersOf',
        isList: true,
        hasArgs: true,
        template: 'membersOf("$1")',
        type: (0, $f38290926d0398e2$export$19c7c729db381f9d)
    },
    releasedVersions: {
        value: 'releasedVersions()',
        isList: true,
        type: (0, $f38290926d0398e2$export$19c7c729db381f9d)
    },
    unreleasedVersions: {
        value: 'unreleasedVersions()',
        isList: true,
        type: (0, $f38290926d0398e2$export$19c7c729db381f9d)
    }
};
const $6c46fe1fee573462$export$3e3df380922ad777 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselectsearcher';
const $6c46fe1fee573462$export$cd361098212837ad = 'cascadeOption';
const $6c46fe1fee573462$export$4e0f2021e5a6dd20 = 'com.atlassian.jira.plugin.system.customfieldtypes:numberrange';
const $6c46fe1fee573462$export$3e72793810b8a135 = 'jql-builder-basic-textarea.ui.text-area';
const $6c46fe1fee573462$export$796f418f6ff91516 = 'jql-builder-basic-textarea.ui.update-button';
const $6c46fe1fee573462$export$787eee4b393220a3 = [
    (0, $lNgEH.OPERATOR_LT_EQUALS),
    (0, $lNgEH.OPERATOR_GT_EQUALS)
];
const $6c46fe1fee573462$export$51829c816d2b6247 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-searcher';
const $6c46fe1fee573462$export$33aa1485e40ffbb7 = 'com.atlassian.servicedesk:vp-origin-searcher';
const $6c46fe1fee573462$export$b7429d5dab3b6ce5 = 'com.atlassian.servicedesk:sd-customer-organizations-searcher';
const $6c46fe1fee573462$export$6f9d9c0166c7b52d = 'com.atlassian.jira.plugins.work-category-field:work-category-field-searcher';
const $6c46fe1fee573462$export$ee8b282423818e0d = 'aqlFunction';
const $6c46fe1fee573462$export$c91c40035dea81da = 'iqlFunction';
const $6c46fe1fee573462$export$65639c30130233cb = 'ADD_FILTER_DROPDOWN';
const $6c46fe1fee573462$export$5daa28d10e23592 = 'issuekey';
const $6c46fe1fee573462$export$3274f6964f86ac9b = ()=>$6c46fe1fee573462$var$TEXT_FIELDS_FIELD_JQL_TERM;

});
parcelRegister("fRacX", function(module, exports) {

$parcel$export(module.exports, "JqlAnonymizerVisitor", () => $9a1d951a19ae90ad$export$17681d1ffeaac612);

var $5PYvb = parcelRequire("5PYvb");
var $Z73OY = parcelRequire("Z73OY");

var $jr72q = parcelRequire("jr72q");

var $7ivol = parcelRequire("7ivol");
const $9a1d951a19ae90ad$var$ANONYMIZED_FIELD = '"?"';
const $9a1d951a19ae90ad$var$ANONYMIZED_VALUE = '"?"';
const $9a1d951a19ae90ad$var$CUSTOM_FIELD_PATTERN = /^cf\[\d+]$/i;
const $9a1d951a19ae90ad$var$privacySafeFields = new Set((0, $Z73OY.PRIVACY_SAFE_FIELDS));
const $9a1d951a19ae90ad$var$getPrivacySafeFieldName = (field)=>{
    // Privacy safe field name (Jira field)
    if ($9a1d951a19ae90ad$var$privacySafeFields.has(field.value.toLowerCase())) return field.text;
    // Custom field identifier, e.g. cf[10001]
    if ($9a1d951a19ae90ad$var$CUSTOM_FIELD_PATTERN.test(field.value)) return field.text;
    // Collapsed custom field
    const match = field.text.match((0, $5PYvb.COLLAPSED_CUSTOM_FIELD_PATTERN));
    if (match) return `"?[${match[1]}]"`;
    // Other field names that can potentially contain UGC
    return $9a1d951a19ae90ad$var$ANONYMIZED_FIELD;
};
class $9a1d951a19ae90ad$export$17681d1ffeaac612 extends (0, $7ivol.AbstractJastVisitor) {
    defaultResult() {
        return '';
    }
    constructor(...args){
        super(...args), this.visitQuery = (query)=>{
            const where = query.where ? query.where.accept(this) : undefined;
            const orderBy = query.orderBy ? query.orderBy.accept(this) : undefined;
            return [
                where,
                orderBy
            ].filter((0, $jr72q.notUndefined)).join(' ');
        }, this.visitField = (field)=>{
            const name = $9a1d951a19ae90ad$var$getPrivacySafeFieldName(field);
            if (field.properties && field.properties.length) {
                const properties = field.properties.map((property)=>{
                    const key = property.key ? property.key.text : '';
                    const path = property.path ? property.path.map((arg)=>arg.text).join('') : '';
                    return `[${key}]${path}`;
                }).join('');
                return `${name}${properties}`;
            }
            return name;
        }, this.visitTerminalClause = (terminalClause)=>{
            const field = terminalClause.field.accept(this);
            const operator = terminalClause.operator ? terminalClause.operator.text : undefined;
            const operand = terminalClause.operand ? terminalClause.operand.accept(this) : undefined;
            const predicates = terminalClause.predicates.map((predicate)=>predicate.accept(this));
            return [
                field,
                operator,
                operand,
                ...predicates
            ].filter((0, $jr72q.notUndefined)).join(' ');
        }, this.visitCompoundClause = (compoundClause)=>{
            const operator = compoundClause.operator.value;
            return compoundClause.clauses.map((clause)=>{
                // Nested compound clauses should be wrapped in parentheses
                return clause.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b) ? `(${clause.accept(this)})` : clause.accept(this);
            }).join(` ${operator} `);
        }, this.visitNotClause = (notClause)=>{
            // Nested compound clauses should be wrapped in parentheses
            const nestedClause = notClause.clause.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b) ? `(${notClause.clause.accept(this)})` : notClause.clause.accept(this);
            return `${notClause.operator.value} ${nestedClause}`;
        }, this.visitValueOperand = ()=>{
            return $9a1d951a19ae90ad$var$ANONYMIZED_VALUE;
        }, this.visitListOperand = (listOperand)=>{
            return `(${listOperand.values.map((value)=>value.accept(this)).join(', ')})`;
        }, this.visitFunctionOperand = (functionOperand)=>{
            const functionName = functionOperand.function.text;
            const functionArguments = functionOperand.arguments.map(()=>$9a1d951a19ae90ad$var$ANONYMIZED_VALUE).join(', ');
            return `${functionName}(${functionArguments})`;
        }, this.visitKeywordOperand = (keywordOperand)=>{
            return keywordOperand.value;
        }, this.visitPredicate = (predicate)=>{
            const operator = predicate.operator.text;
            const operand = predicate.operand ? predicate.operand.accept(this) : undefined;
            return [
                operator,
                operand
            ].filter((0, $jr72q.notUndefined)).join(' ');
        }, this.visitOrderBy = (orderBy)=>{
            const orderByFields = orderBy.fields.map((orderByField)=>{
                const field = orderByField.field.accept(this);
                const direction = orderByField.direction ? orderByField.direction.value : undefined;
                return [
                    field,
                    direction
                ].filter((0, $jr72q.notUndefined)).join(' ');
            });
            return `${0, $8ff9fbbb483161a6$export$ca51f5fd60a74517} ${orderByFields.join(', ')}`;
        };
    }
}

});
const $27a6760b07fae18c$export$7a58b23488ea076b = 'compound';
const $27a6760b07fae18c$export$ae56b4ef248a2b6a = 'terminal';
const $27a6760b07fae18c$export$e356b89f8c8d2fcb = 'not';

parcelRegister("5PYvb", function(module, exports) {

$parcel$export(module.exports, "TEAM_CUSTOM_FIELD_TYPE", () => $2d726408f91778fc$export$7db5aa892c7d5359);
$parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN", () => $2d726408f91778fc$export$72fbd4b3f260d743);
$parcel$export(module.exports, "COLLAPSED_CUSTOM_FIELD_PATTERN_NO_QUOTES", () => $2d726408f91778fc$export$4b8ecf135de492a1);
// This is a list of field types expected as collapsed fields, e.g. of the form
// name[fieldtype]. The square brackets are retained to allow us to more easily
// differentiate these from regular fields.
// Currently these are being used in `jql-insights-listener.ts` to allow us to
// collect data about the usage of some custom field types.
// All field type names here must be in lower case
const $2d726408f91778fc$export$7db5aa892c7d5359 = '[team]';
const $2d726408f91778fc$export$72fbd4b3f260d743 = /^['"].+\[(\D+)]['"]$/i;
const $2d726408f91778fc$export$4b8ecf135de492a1 = /^.+\[(\D+)]$/i;

});

const $8ff9fbbb483161a6$export$ca51f5fd60a74517 = 'ORDER BY';
const $8ff9fbbb483161a6$export$6d60017b9e092e73 = 'ASC';
const $8ff9fbbb483161a6$export$2ea27ea5f2121899 = 'DESC';

parcelRegister("Z73OY", function(module, exports) {

$parcel$export(module.exports, "ASSIGNEE_FIELD", () => $93a903548aefffc1$export$f7a08bf17a7ac661);
$parcel$export(module.exports, "CREATED_FIELD", () => $93a903548aefffc1$export$9063bfeedbc1236f);
$parcel$export(module.exports, "DUE_DATE_FIELD", () => $93a903548aefffc1$export$f4a47f55547a932c);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD", () => $93a903548aefffc1$export$2d5a62a3515ad4c6);
$parcel$export(module.exports, "LAST_VIEWED_FIELD", () => $93a903548aefffc1$export$eac61537b9fdb3be);
$parcel$export(module.exports, "PRIORITY_FIELD", () => $93a903548aefffc1$export$de14210faa5f2099);
$parcel$export(module.exports, "PROJECT_FIELD", () => $93a903548aefffc1$export$aa5680ad8f8be9fc);
$parcel$export(module.exports, "REPORTER_FIELD", () => $93a903548aefffc1$export$d64150fd9c66969c);
$parcel$export(module.exports, "RESOLUTION_DATE_FIELD", () => $93a903548aefffc1$export$f603d3cf4c8489e8);
$parcel$export(module.exports, "STATUS_FIELD", () => $93a903548aefffc1$export$3068d6fae4de53c8);
$parcel$export(module.exports, "SUMMARY_FIELD", () => $93a903548aefffc1$export$9b9fe8882c3e0da3);
$parcel$export(module.exports, "TYPE_FIELD", () => $93a903548aefffc1$export$e53b76a613c435e0);
$parcel$export(module.exports, "UPDATED_FIELD", () => $93a903548aefffc1$export$7101642b50bf10bc);
$parcel$export(module.exports, "RESOLUTION_FIELD", () => $93a903548aefffc1$export$252fb981af0e2e4e);
$parcel$export(module.exports, "PRIVACY_SAFE_FIELDS", () => $93a903548aefffc1$export$49017cdca0837b83);
const $93a903548aefffc1$export$f7a08bf17a7ac661 = 'assignee';
const $93a903548aefffc1$export$9063bfeedbc1236f = 'created';
const $93a903548aefffc1$export$f4a47f55547a932c = 'duedate';
const $93a903548aefffc1$export$28d0e5e03b779eff = 'issuekey';
const $93a903548aefffc1$export$2d5a62a3515ad4c6 = 'issuetype';
const $93a903548aefffc1$export$eac61537b9fdb3be = 'lastviewed';
const $93a903548aefffc1$export$de14210faa5f2099 = 'priority';
const $93a903548aefffc1$export$aa5680ad8f8be9fc = 'project';
const $93a903548aefffc1$export$d64150fd9c66969c = 'reporter';
const $93a903548aefffc1$export$ad2fb2fa5ecb427a = 'resolved';
const $93a903548aefffc1$export$f603d3cf4c8489e8 = 'resolutiondate';
const $93a903548aefffc1$export$3068d6fae4de53c8 = 'status';
const $93a903548aefffc1$export$f4d2dc00d9b9c983 = 'statuscategory';
const $93a903548aefffc1$export$9b9fe8882c3e0da3 = 'summary';
const $93a903548aefffc1$export$23ca38ad884e35f1 = 'text';
const $93a903548aefffc1$export$b3e1b98671aae084 = 'textfields';
const $93a903548aefffc1$export$e53b76a613c435e0 = 'type';
const $93a903548aefffc1$export$7101642b50bf10bc = 'updated';
const $93a903548aefffc1$export$c7761054d987f9ab = 'affectedversion';
const $93a903548aefffc1$export$9ae86b690ef8ceed = 'approvals';
const $93a903548aefffc1$export$4b5a561405c5f211 = 'category';
const $93a903548aefffc1$export$a3ff506aee89f5de = 'component';
const $93a903548aefffc1$export$6a045eda3865d703 = 'description';
const $93a903548aefffc1$export$b6b1af0981f1891e = 'development';
const $93a903548aefffc1$export$39df30b837789c3 = 'environment';
const $93a903548aefffc1$export$8723b724f0b3ac65 = 'epic link';
const $93a903548aefffc1$export$4b5030dff66bb705 = 'filter';
const $93a903548aefffc1$export$3ec395376855802f = 'fixversion';
const $93a903548aefffc1$export$a8945db82fc2e785 = 'labels';
const $93a903548aefffc1$export$bf9df74e065af482 = 'parent';
const $93a903548aefffc1$export$252fb981af0e2e4e = 'resolution';
const $93a903548aefffc1$export$64238d76a1dc0703 = 'sprint';
const $93a903548aefffc1$export$62edbfa1bb10b91 = 'assignee.property';
const $93a903548aefffc1$export$5afd9733860db123 = 'creator.property';
const $93a903548aefffc1$export$3ccfe20fd4420801 = 'issue.property';
const $93a903548aefffc1$export$d955a5d923cc59e6 = 'project.property';
const $93a903548aefffc1$export$ed42e707855fc6a4 = 'reporter.property';
const $93a903548aefffc1$export$3b63269c1c533321 = 'voter.property';
const $93a903548aefffc1$export$bd7061bb445305dd = 'watcher.property';
const $93a903548aefffc1$export$49017cdca0837b83 = [
    $93a903548aefffc1$export$f7a08bf17a7ac661,
    $93a903548aefffc1$export$9063bfeedbc1236f,
    $93a903548aefffc1$export$f4a47f55547a932c,
    $93a903548aefffc1$export$28d0e5e03b779eff,
    $93a903548aefffc1$export$2d5a62a3515ad4c6,
    $93a903548aefffc1$export$eac61537b9fdb3be,
    $93a903548aefffc1$export$de14210faa5f2099,
    $93a903548aefffc1$export$aa5680ad8f8be9fc,
    $93a903548aefffc1$export$d64150fd9c66969c,
    $93a903548aefffc1$export$ad2fb2fa5ecb427a,
    $93a903548aefffc1$export$f603d3cf4c8489e8,
    $93a903548aefffc1$export$3068d6fae4de53c8,
    $93a903548aefffc1$export$f4d2dc00d9b9c983,
    $93a903548aefffc1$export$9b9fe8882c3e0da3,
    $93a903548aefffc1$export$23ca38ad884e35f1,
    $93a903548aefffc1$export$b3e1b98671aae084,
    $93a903548aefffc1$export$e53b76a613c435e0,
    $93a903548aefffc1$export$7101642b50bf10bc,
    $93a903548aefffc1$export$c7761054d987f9ab,
    $93a903548aefffc1$export$9ae86b690ef8ceed,
    $93a903548aefffc1$export$4b5a561405c5f211,
    $93a903548aefffc1$export$a3ff506aee89f5de,
    $93a903548aefffc1$export$6a045eda3865d703,
    $93a903548aefffc1$export$b6b1af0981f1891e,
    $93a903548aefffc1$export$39df30b837789c3,
    $93a903548aefffc1$export$8723b724f0b3ac65,
    $93a903548aefffc1$export$4b5030dff66bb705,
    $93a903548aefffc1$export$3ec395376855802f,
    $93a903548aefffc1$export$a8945db82fc2e785,
    $93a903548aefffc1$export$bf9df74e065af482,
    $93a903548aefffc1$export$252fb981af0e2e4e,
    $93a903548aefffc1$export$64238d76a1dc0703,
    // entity properties
    $93a903548aefffc1$export$62edbfa1bb10b91,
    $93a903548aefffc1$export$5afd9733860db123,
    $93a903548aefffc1$export$3ccfe20fd4420801,
    $93a903548aefffc1$export$d955a5d923cc59e6,
    $93a903548aefffc1$export$ed42e707855fc6a4,
    $93a903548aefffc1$export$3b63269c1c533321,
    $93a903548aefffc1$export$bd7061bb445305dd
];

});


const $f38290926d0398e2$export$38accfc5a5d1c113 = 'value';
const $f38290926d0398e2$export$f6049126fd97001f = 'keyword';
const $f38290926d0398e2$export$19c7c729db381f9d = 'function';
const $f38290926d0398e2$export$fabec4aebba3f4df = 'list';
const $f38290926d0398e2$export$1c46dca02aac24dd = 'empty';


parcelRegister("81EFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c98bf047f4c36a4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3c98bf047f4c36a4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementProject: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-project",
        "defaultMessage": "Project"
    },
    refinementStatus: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-status",
        "defaultMessage": "Status"
    },
    refinementStatusCategory: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-status-category",
        "defaultMessage": "Status category"
    },
    refinementSummary: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-summary",
        "defaultMessage": "Summary"
    },
    refinementAssignee: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-assignee",
        "defaultMessage": "Assignee"
    },
    refinementReporter: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-reporter",
        "defaultMessage": "Reporter"
    },
    refinementType: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-type",
        "defaultMessage": "Type"
    },
    refinementPriority: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-priority",
        "defaultMessage": "Priority"
    },
    refinementResolution: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-resolution",
        "defaultMessage": "Resolution"
    },
    refinementUpdated: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-updated",
        "defaultMessage": "Updated date"
    },
    refinementCreated: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-created",
        "defaultMessage": "Created date"
    },
    refinementDueDate: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-due-date",
        "defaultMessage": "Due date"
    },
    refinementResolutionDate: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-resolution-date",
        "defaultMessage": "Resolution date"
    },
    refinementComponent: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-component",
        "defaultMessage": "Component"
    },
    refinementParent: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-parent",
        "defaultMessage": "Parent"
    },
    refinementFixVersion: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-fix-version",
        "defaultMessage": "Fix version"
    },
    refinementAffectedVersion: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-affected-version",
        "defaultMessage": "Affects version"
    },
    refinementLabel: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-label",
        "defaultMessage": "Label"
    },
    refinementLabels: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-labels",
        "defaultMessage": "Labels"
    },
    refinementEpicLink: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-epic-link",
        "defaultMessage": "Epic link"
    },
    refinementSprint: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-sprint",
        "defaultMessage": "Sprint"
    },
    refinementCreator: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-creator",
        "defaultMessage": "Creator"
    },
    refinementDescription: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-description",
        "defaultMessage": "Description"
    },
    refinementEnvironment: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-environment",
        "defaultMessage": "Environment"
    },
    refinementNotFound: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-not-found",
        "defaultMessage": "Unknown Field"
    },
    refinementProjectGalaxia: {
        "id": "jql-builder-basic.utils.get-field-display-name-by-field-id.refinement-project-galaxia",
        "defaultMessage": "Space"
    }
});

});


parcelRegister("cWcbh", function(module, exports) {

$parcel$export(module.exports, "HYDRATION_QUERY", () => $d5c7b8ce5b358373$export$988ee43373cb9bb2);
$parcel$export(module.exports, "useHydrationQueryLoader", () => $d5c7b8ce5b358373$export$b318e912f6cbc59b);

var $8jMVZ = parcelRequire("8jMVZ");

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");
const $d5c7b8ce5b358373$export$988ee43373cb9bb2 = (0, $8jMVZ.default);
const $d5c7b8ce5b358373$export$9562d1ce91742cb1 = (variables)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const [isFetching, setIsFetching] = (0, $eJOHy.useState)(false);
    // Variables for last completed prefetch (i.e. fetchQuery) operation
    const [prefetchedVariables, setPrefetchedVariables] = (0, $eJOHy.useState)(variables);
    const [fetchPolicy, setFetchPolicy] = (0, $eJOHy.useState)('store-or-network');
    // Variables used by in-flight request, used to deduplicate requests
    const inFlightRequest = (0, $eJOHy.useRef)();
    const inFlightVariables = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(variables, prefetchedVariables) && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(variables, inFlightVariables.current)) {
            // Cancel previous in-flight request to stop further processing (and prevent race conditions) if a new one comes in
            inFlightRequest.current?.unsubscribe();
            inFlightVariables.current = variables;
            setIsFetching(true);
            // Prefetch data, then update returned variables on complete
            inFlightRequest.current = (0, $j4oe4.fetchQuery)(environment, $d5c7b8ce5b358373$export$988ee43373cb9bb2, variables, {
                fetchPolicy: 'store-or-network',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    setPrefetchedVariables(variables);
                    setFetchPolicy('store-only');
                    setIsFetching(false);
                    inFlightVariables.current = undefined;
                },
                error: (error)=>{
                    setIsFetching(false);
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'hydrateJqlBuilderQuery',
                            packageName: 'jiraJqlBuilderCommon',
                            teamName: 'empanada'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    }, [
        environment,
        prefetchedVariables,
        variables
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            variables: prefetchedVariables,
            fetchPolicy: fetchPolicy,
            isFetching: isFetching
        }), [
        prefetchedVariables,
        fetchPolicy,
        isFetching
    ]);
};
const $d5c7b8ce5b358373$export$b318e912f6cbc59b = (query, viewContext, scope = null)=>{
    const accountId = (0, $8q7lT.useAccountId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { variables: variables, fetchPolicy: fetchPolicy, isFetching: isFetching } = $d5c7b8ce5b358373$export$9562d1ce91742cb1({
        accountId: accountId ?? '',
        cloudId: cloudId,
        includeUser: query.length > 0 && !!accountId,
        includeJira: query.length > 0,
        jql: query,
        isFilter: false,
        filterAri: '',
        viewContext: viewContext,
        scope: scope,
        isPlanReleaseFeatureToggleEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')
    });
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)($d5c7b8ce5b358373$export$988ee43373cb9bb2);
    // @see https://hello.atlassian.net/wiki/spaces/~104598762/pages/2206935637/Why+do+we+need+to+re-hydrate+the+refinement+bar+on+every+change
    // Tl;DR – We refetch hydration data on every query change (instead of just fetching it on mount) for two reasons:
    // 1. There are external JQL changes that don't unmount the basic mode component and require hydration
    //    (e.g. changing filters in the sidebar, or clicking on the Reset button)
    // 2. We also rely on hydration API to render the invalid state when a particular field value is out of scope for
    //    the current query (e.g. if a selected status doesn't belong to one of the selected projects) – we could
    //    technically avoid rehydrating in this case if there isn't a change to scoping fields (like project or issue
    //    type), but it's probably not worth the extra complexity
    (0, $eJOHy.useEffect)(()=>{
        loadQuery(variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        });
    }, [
        fetchPolicy,
        loadQuery,
        variables
    ]);
    return [
        queryReference,
        isFetching
    ];
};

});

parcelRegister("8KuTC", function(module, exports) {

$parcel$export(module.exports, "PerformanceContext", () => $7cf4b0d12119b93a$export$39bcde15aa963086);
$parcel$export(module.exports, "usePerformanceContext", () => $7cf4b0d12119b93a$export$851a2d8ae957dc96);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

const $7cf4b0d12119b93a$export$39bcde15aa963086 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
const $7cf4b0d12119b93a$export$851a2d8ae957dc96 = ()=>(0, $eJOHy.useContext)($7cf4b0d12119b93a$export$39bcde15aa963086);

});

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("56qWy", function(module, exports) {

$parcel$export(module.exports, "SEARCH_MODE_BASIC", () => $8645a6ff5f3a8efb$export$f963d14b266e4d2e);
$parcel$export(module.exports, "SEARCH_MODE_ADVANCED", () => $8645a6ff5f3a8efb$export$aad1d9eb9b751555);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", () => $8645a6ff5f3a8efb$export$87c41a6b3123c00f);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", () => $8645a6ff5f3a8efb$export$a7a000706ebc3ba8);
$parcel$export(module.exports, "DEFAULT_SEARCH_MODE", () => $8645a6ff5f3a8efb$export$e1eb2ddab803c5ec);
$parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", () => $8645a6ff5f3a8efb$export$70c8f980e4a50682);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", () => $8645a6ff5f3a8efb$export$4dab29e715a4e6fb);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", () => $8645a6ff5f3a8efb$export$59848395da0b4bcb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $8645a6ff5f3a8efb$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $8645a6ff5f3a8efb$export$d57b6b390e78d90f);
const $8645a6ff5f3a8efb$export$f963d14b266e4d2e = 'basic';
const $8645a6ff5f3a8efb$export$aad1d9eb9b751555 = 'advanced';
const $8645a6ff5f3a8efb$export$87c41a6b3123c00f = 'BASIC';
const $8645a6ff5f3a8efb$export$a7a000706ebc3ba8 = 'ADVANCED';
const $8645a6ff5f3a8efb$export$e1eb2ddab803c5ec = $8645a6ff5f3a8efb$export$f963d14b266e4d2e;
const $8645a6ff5f3a8efb$export$70c8f980e4a50682 = {
    [$8645a6ff5f3a8efb$export$f963d14b266e4d2e]: $8645a6ff5f3a8efb$export$f963d14b266e4d2e,
    [$8645a6ff5f3a8efb$export$aad1d9eb9b751555]: 'JQL'
};
const $8645a6ff5f3a8efb$export$4dab29e715a4e6fb = 'Left';
const $8645a6ff5f3a8efb$export$59848395da0b4bcb = 'Right';
const $8645a6ff5f3a8efb$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
const $8645a6ff5f3a8efb$export$d57b6b390e78d90f = 'empanada';

});

parcelRegister("gQyru", function(module, exports) {

$parcel$export(module.exports, "toSearchModeWithBasicModeFallback", () => $55476173f94cb033$export$7c0f55a4bd3730ea);
$parcel$export(module.exports, "toServerSearchMode", () => $55476173f94cb033$export$32a166cc1b3e6927);

var $56qWy = parcelRequire("56qWy");
function $55476173f94cb033$export$7c0f55a4bd3730ea(value) {
    switch(value){
        case 0, $56qWy.SERVER_SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SEARCH_MODE_ADVANCED;
        default:
            return 0, $56qWy.DEFAULT_SEARCH_MODE;
    }
}
function $55476173f94cb033$export$32a166cc1b3e6927(mode) {
    switch(mode){
        case 0, $56qWy.SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SERVER_SEARCH_MODE_ADVANCED;
        default:
            return 0, $56qWy.SERVER_SEARCH_MODE_BASIC;
    }
}

});

parcelRegister("3JHgj", function(module, exports) {

$parcel$export(module.exports, "useContextJql", () => $24965b3e406f3b24$export$68b4e7df5f221bf);

var $eJOHy = parcelRequire("eJOHy");

var $2poie = parcelRequire("2poie");
var $eM3Eu = parcelRequire("eM3Eu");
var $lNgEH = parcelRequire("lNgEH");
var $3c1PD = parcelRequire("3c1PD");

var $dTJxm = parcelRequire("dTJxm");
const $24965b3e406f3b24$var$isProjectKey = (projectKey)=>Boolean(projectKey);
const $24965b3e406f3b24$export$68b4e7df5f221bf = ({ jql: jql, projectKeys: projectKeys })=>{
    return (0, $eJOHy.useMemo)(()=>{
        /**
		 * context jql based on projectKeys
		 */ const sanitizedProjectKeys = projectKeys?.filter($24965b3e406f3b24$var$isProjectKey) ?? [];
        if (sanitizedProjectKeys.length === 0) return jql;
        const jast = new (0, $eM3Eu.JastBuilder)().build(jql);
        jast.query?.appendClause((0, $2poie.default).terminalClause((0, $2poie.default).field((0, $dTJxm.PROJECT_FIELD_JQL_TERM)), (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IN)), (0, $2poie.default).listOperand(sanitizedProjectKeys.map((0, $2poie.default).valueOperand))), (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
        return (0, $3c1PD.print)(jast, {
            operatorCase: 'upper'
        });
    }, [
        jql,
        projectKeys
    ]);
};

});
const $f6a7331f12a1b6ec$export$6d6d48d210d3ca97 = 'and';
const $f6a7331f12a1b6ec$export$7b8f0a728d79a753 = 'or';


parcelRegister("bAZUe", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderUIOld", () => $18b4aa5832501970$export$328ac4451491d9e0);
$parcel$export(module.exports, "default", () => $18b4aa5832501970$export$2e2bcd8739ae039);

var $lOB0a = parcelRequire("lOB0a");

var $1mWlF = parcelRequire("1mWlF");

var $eJOHy = parcelRequire("eJOHy");

var $jvwCK = parcelRequire("jvwCK");

var $j4oe4 = parcelRequire("j4oe4");

var $hHzDA = parcelRequire("hHzDA");

var $cWcbh = parcelRequire("cWcbh");

var $ch9En = parcelRequire("ch9En");

var $4Py7k = parcelRequire("4Py7k");

var $7jTnu = parcelRequire("7jTnu");

var $8FAu5 = parcelRequire("8FAu5");

var $70el7 = parcelRequire("70el7");

var $56qWy = parcelRequire("56qWy");

var $gQyru = parcelRequire("gQyru");

var $cX22j = parcelRequire("cX22j");

var $3JHgj = parcelRequire("3JHgj");

var $b2CbD = parcelRequire("b2CbD");

var $lw8qf = parcelRequire("lw8qf");

var $8ShlV = parcelRequire("8ShlV");
const $18b4aa5832501970$export$66ac472152813d8b = (0, $1mWlF.default);
/* eslint-enable @atlassian/relay/graphql-naming */ const $18b4aa5832501970$var$JQLBuilderUI = ({ userPreferences: userPreferences, searchModes: searchModes = [
    (0, $56qWy.SEARCH_MODE_ADVANCED),
    (0, $56qWy.SEARCH_MODE_BASIC)
], onUpdateSearchMode: onUpdateSearchMode, selectedSearchMode: selectedSearchMode, isSearchModeToggleEnabled: isSearchModeToggleEnabled, irremovableFields: irremovableFields, uniqueSearchModes: uniqueSearchModes, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode = false, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, projectKeys: projectKeys, showOrderByPicker: showOrderByPicker, viewContext: viewContext = null, scope: scope = null, initialQueryRef: initialQueryRef, onLoadingMode: onLoadingMode, loadingModeRef: loadingModeRef, ...props })=>{
    const userPreferencesData = (0, $j4oe4.useFragment)($18b4aa5832501970$export$66ac472152813d8b, userPreferences);
    const saveSearchModePreference = (0, $b2CbD.useSearchModeMutation)(userPreferencesData ?? null);
    const contextJql = (0, $3JHgj.useContextJql)({
        jql: props.query,
        projectKeys: projectKeys
    });
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const hydrationQueryData = (0, $j4oe4.usePreloadedQuery)((0, $cWcbh.HYDRATION_QUERY), initialQueryRef);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [hydrationData, hydrationRefetch] = (0, $j4oe4.useRefetchableFragment)((0, $lOB0a.default), hydrationQueryData);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ const hydratedJql = (0, $eJOHy.useMemo)(()=>{
        const hydrationResult = hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery ?? hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter;
        if (hydrationResult?.__typename === 'JiraJqlHydratedQuery') return hydrationResult.jql ?? undefined;
    }, [
        hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery,
        hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter
    ]);
    const onSearchModeChange = (0, $eJOHy.useCallback)((searchMode, reason)=>{
        // Update the search mode preference when the reason is matching the allowed list
        // Note: The reasons currently used below were chosen to match previous behaviour when the new reason "QueryUnsupported" was introduced
        if (reason === 'UserTriggered' || reason === 'ExternalTriggered') saveSearchModePreference(searchMode);
        onUpdateSearchMode?.(searchMode, reason);
    }, [
        onUpdateSearchMode,
        saveSearchModePreference
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8qf.JQLBuilderFallback), {
        query: props.query,
        searchModes: searchModes,
        onLoad: onLoadingMode,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jql-builder-ui",
        fallback: fallback
    }, hydrationData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8FAu5.HydrationQueryProvider), {
        query: (0, $4Py7k.default),
        refetch: hydrationRefetch,
        contextJql: contextJql,
        hydratedJql: hydratedJql,
        ...(0, $7jTnu.fg)('jql_builder_add_view_context_to_hydration_query') && {
            viewContext: viewContext
        },
        scope: scope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $70el7.QuerySupportedContainer), {
        query: props.query,
        excludedFields: props.excludedFields,
        jqlMessages: props.jqlMessages,
        hydrationData: hydrationData,
        simplifiedOperators: hideOperatorDropdownBasicMode,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    }, uniqueSearchModes.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cX22j.SingleSearchModeContainer), {
        searchMode: uniqueSearchModes[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ShlV.JQLBuilderUIImpl), {
        searchModes: uniqueSearchModes,
        hydrationData: hydrationData,
        selectedSearchMode: selectedSearchMode,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        scope: scope,
        ...props
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cX22j.SelectedSearchModeContainer), {
        searchMode: selectedSearchMode,
        onSearchModeChange: onSearchModeChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ShlV.JQLBuilderUIImpl), {
        searchModes: uniqueSearchModes,
        hydrationData: hydrationData,
        selectedSearchMode: selectedSearchMode,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        scope: scope,
        ...props
    })))) : fallback);
};
const $18b4aa5832501970$export$328ac4451491d9e0 = ({ userPreferences: userPreferences, searchModes: searchModes = [
    (0, $56qWy.SEARCH_MODE_ADVANCED),
    (0, $56qWy.SEARCH_MODE_BASIC)
], onUpdateSearchMode: onUpdateSearchMode, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode = false, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION), projectKeys: projectKeys, showOrderByPicker: showOrderByPicker, viewContext: viewContext = null, scope: scope = null, ...props })=>{
    const { onLoad: onLoad } = props;
    // Persist mode used in loading state to send in analytics
    const loadingModeRef = (0, $eJOHy.useRef)();
    const onLoadingMode = (0, $eJOHy.useCallback)((mode)=>{
        loadingModeRef.current = mode;
        onLoad?.(mode);
    }, [
        onLoad
    ]);
    const userPreferencesData = (0, $j4oe4.useFragment)($18b4aa5832501970$export$66ac472152813d8b, userPreferences);
    const searchModeResponse = userPreferencesData?.jqlBuilderSearchMode;
    const selectedSearchMode = (0, $gQyru.toSearchModeWithBasicModeFallback)(searchModeResponse);
    const saveSearchModePreference = (0, $b2CbD.useSearchModeMutation)(userPreferencesData ?? null);
    if (searchModes.length === 0) throw new Error('Search mode should be non empty');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const uniqueSearchModes = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))(searchModes);
    const contextJql = (0, $3JHgj.useContextJql)({
        jql: props.query,
        projectKeys: projectKeys
    });
    const [hydrationQueryRef, isHydrating] = (0, $cWcbh.useHydrationQueryLoader)(contextJql, viewContext, scope);
    const isSearchModeToggleEnabled = uniqueSearchModes ? uniqueSearchModes.length > 1 : true;
    const onSearchModeChange = (0, $eJOHy.useCallback)((searchMode, reason)=>{
        // Update the search mode preference when the reason is matching the allowed list
        // Note: The reasons currently used below were chosen to match previous behaviour when the new reason "QueryUnsupported" was introduced
        if (reason === 'UserTriggered' || reason === 'ExternalTriggered') saveSearchModePreference(searchMode);
        onUpdateSearchMode?.(searchMode, reason);
    }, [
        onUpdateSearchMode,
        saveSearchModePreference
    ]);
    const irremovableFields = (0, $hHzDA.useIrremovableFields)(props.basicModeVisibleFields ?? (0, $hHzDA.DEFAULT_IRREMOVABLE_FIELDS)());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jql-builder-ui",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8qf.JQLBuilderFallback), {
            query: props.query,
            searchModes: searchModes,
            selectedSearchMode: selectedSearchMode,
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            beforeControls: props.beforeControls,
            renderExtraControls: props.renderExtraControls,
            excludedFields: props.excludedFields,
            components: props.components,
            irremovableFields: irremovableFields,
            hideTextSearchInput: hideTextSearchInput,
            searchPlaceholder: searchPlaceholder,
            searchModeSwitcherLocation: searchModeSwitcherLocation,
            showOrderByPicker: showOrderByPicker
        })
    }, hydrationQueryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $70el7.QuerySupportedContainerOld), {
        query: props.query,
        excludedFields: props.excludedFields,
        jqlMessages: props.jqlMessages,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        simplifiedOperators: hideOperatorDropdownBasicMode,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    }, uniqueSearchModes.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cX22j.SingleSearchModeContainer), {
        searchMode: uniqueSearchModes[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ShlV.JQLBuilderUIImplOld), {
        searchModes: uniqueSearchModes,
        hydrationQueryRef: hydrationQueryRef,
        selectedSearchMode: selectedSearchMode,
        isHydrating: isHydrating,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        scope: scope,
        ...props
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cX22j.SelectedSearchModeContainer), {
        searchMode: selectedSearchMode,
        onSearchModeChange: onSearchModeChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ShlV.JQLBuilderUIImplOld), {
        searchModes: uniqueSearchModes,
        hydrationQueryRef: hydrationQueryRef,
        selectedSearchMode: selectedSearchMode,
        isHydrating: isHydrating,
        onUpdateSearchMode: onUpdateSearchMode,
        hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        contextJql: contextJql,
        showOrderByPicker: showOrderByPicker,
        loadingModeRef: loadingModeRef,
        viewContext: viewContext,
        scope: scope,
        ...props
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8qf.JQLBuilderFallback), {
        query: props.query,
        onLoad: onLoadingMode,
        searchModes: searchModes,
        selectedSearchMode: selectedSearchMode,
        isSearchModeToggleEnabled: isSearchModeToggleEnabled,
        beforeControls: props.beforeControls,
        renderExtraControls: props.renderExtraControls,
        excludedFields: props.excludedFields,
        components: props.components,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        searchModeSwitcherLocation: searchModeSwitcherLocation,
        showOrderByPicker: showOrderByPicker
    }));
};
var $18b4aa5832501970$export$2e2bcd8739ae039 = $18b4aa5832501970$var$JQLBuilderUI;

});
parcelRegister("lOB0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ca526ef62eeae0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9039d7634b1fe022fca270dadf01420a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $4Py7k = parcelRequire("4Py7k");
const $64ca526ef62eeae0$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "accountId"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "includeUser"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "isPlanReleaseFeatureToggleEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $4Py7k.default)
            }
        },
        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "useHydratedValues"
            },
            {
                "kind": "FragmentSpread",
                "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
            },
            {
                "kind": "FragmentSpread",
                "name": "useQuery"
            },
            {
                "kind": "FragmentSpread",
                "name": "useHydratedValues_cascadeSelectPicker"
            },
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v2 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v2 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$64ca526ef62eeae0$var$node.hash = "7e21dbd6ea1814b23402a1d8df10c1a7";
var $64ca526ef62eeae0$export$2e2bcd8739ae039 = $64ca526ef62eeae0$var$node;

});
parcelRegister("4Py7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfb3821c0fd07ae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7f0a72ee9896d6253ec53180bedf2198>>
 * @relayHash c5dcbe8f669c934018c8f20fbbc93b8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16dfdce3bf40db2e81ecfeeb0047aa00e9b4f3bdcdaca17ad0b1ebbeef7ded36
const $8dfb3821c0fd07ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeJira"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeUser"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilter"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isPlanReleaseFeatureToggleEnabled"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scope"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewContext"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        v1 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "picture"
        },
        v2 /*: any*/ 
    ], v4 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v5 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                },
                v2 /*: any*/ 
            ]
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v11 = [
        v1 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "condition": "isPlanReleaseFeatureToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "shouldExcludeInScope"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v9 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v3 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v1 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                v2 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        },
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HydrationRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HydrationRefetchQuery",
            "selections": [
                {
                    "condition": "includeUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "accountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeJira",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "query",
                                                            "variableName": "jql"
                                                        },
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQuery",
                                                    "plural": false,
                                                    "selections": v11 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isFilter",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "id",
                                                            "variableName": "filterAri"
                                                        },
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "hydrateJqlQueryForFilter",
                                                    "plural": false,
                                                    "selections": v11 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "16dfdce3bf40db2e81ecfeeb0047aa00e9b4f3bdcdaca17ad0b1ebbeef7ded36",
            "metadata": {},
            "name": "HydrationRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8dfb3821c0fd07ae$var$node.hash = "7e21dbd6ea1814b23402a1d8df10c1a7";
var $8dfb3821c0fd07ae$export$2e2bcd8739ae039 = $8dfb3821c0fd07ae$var$node;

});


parcelRegister("1mWlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5280866e2f2276c4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2b5dbf7906b653869505f67a354896a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5280866e2f2276c4$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_jqlBuilder_JQLBuilderUI",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "searchMode_useSearchMode_JQLBuilder"
        },
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$5280866e2f2276c4$var$node.hash = "9fbe210abfde6a98b4eff53d65746395";
var $5280866e2f2276c4$export$2e2bcd8739ae039 = $5280866e2f2276c4$var$node;

});

parcelRegister("8FAu5", function(module, exports) {

$parcel$export(module.exports, "useHydrationQuery", () => $08132779e00b6aa2$export$9992ca387dbb4d57);
$parcel$export(module.exports, "HydrationQueryProvider", () => $08132779e00b6aa2$export$bb83aa31c9e87b59);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");
const $08132779e00b6aa2$var$HydrationQueryContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    hydrationQueryIsFetching: false,
    hydrationQueryContextJql: ''
});
$08132779e00b6aa2$var$HydrationQueryContext.displayName = 'HydrationQueryContext';
const $08132779e00b6aa2$export$9992ca387dbb4d57 = ()=>(0, $eJOHy.useContext)($08132779e00b6aa2$var$HydrationQueryContext);
const $08132779e00b6aa2$export$bb83aa31c9e87b59 = ({ refetch: refetch, query: query, contextJql: contextJql, hydratedJql: hydratedJql, children: children, viewContext: viewContext, scope: scope })=>{
    const [hydrationQueryIsFetching, setHydrationQueryIsFetching] = (0, $eJOHy.useState)(false);
    const cloudId = (0, $kEUB1.useCloudId)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const inFlightRequest = (0, $eJOHy.useRef)();
    const inFlightContextJql = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        const shouldRefetch = contextJql !== hydratedJql && contextJql !== inFlightContextJql.current;
        if (shouldRefetch) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            inFlightContextJql.current = contextJql;
            // eslint-disable-next-line jira/ff/inline-usage
            const variables = {
                filterAri: '',
                includeFilter: false,
                jql: contextJql,
                accountId: atlassianAccountId ?? '',
                includeJira: true,
                includeUser: true,
                cloudId: cloudId,
                isFilter: false,
                ...(0, $7jTnu.fg)('jql_builder_add_view_context_to_hydration_query') && {
                    viewContext: viewContext
                },
                scope: scope,
                isPlanReleaseFeatureToggleEnabled: (0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')
            };
            setHydrationQueryIsFetching(true);
            // Prefetch data, then update returned variables on complete
            inFlightRequest.current = (0, $j4oe4.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    refetch(variables, {
                        fetchPolicy: 'store-only',
                        onComplete: ()=>{
                            setHydrationQueryIsFetching(false);
                            inFlightContextJql.current = undefined;
                        }
                    });
                },
                error: (error)=>{
                    setHydrationQueryIsFetching(false);
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'hydrateJqlBuilderQuery',
                            packageName: 'jiraJqlBuilder',
                            teamName: 'empanada'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    }, [
        atlassianAccountId,
        cloudId,
        contextJql,
        environment,
        hydratedJql,
        query,
        refetch,
        setHydrationQueryIsFetching,
        viewContext,
        scope
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            hydrationQueryIsFetching: hydrationQueryIsFetching,
            hydrationQueryContextJql: hydratedJql
        }), [
        hydrationQueryIsFetching,
        hydratedJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08132779e00b6aa2$var$HydrationQueryContext.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("70el7", function(module, exports) {

$parcel$export(module.exports, "QuerySupportedContainerOld", () => $92286b5c84adb411$export$f94eb234c660c8a5);
$parcel$export(module.exports, "QuerySupportedContainer", () => $92286b5c84adb411$export$34660422c2aeae3d);
$parcel$export(module.exports, "useIsQuerySupported", () => $92286b5c84adb411$export$8ce0898530622ab2);

var $76KWb = parcelRequire("76KWb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $9JtRn = parcelRequire("9JtRn");

var $22GDK = parcelRequire("22GDK");

var $7jTnu = parcelRequire("7jTnu");

var $cWcbh = parcelRequire("cWcbh");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $8FAu5 = parcelRequire("8FAu5");
const $92286b5c84adb411$export$7b6dd859fbd6fe77 = (0, $76KWb.default);
/* eslint-enable @atlassian/relay/graphql-naming,  @atlassian/relay/unused-fields */ const $92286b5c84adb411$var$useQuerySupportedOld = ({ currentJql: currentJql, excludedFields: excludedFields = [], jqlErrors: jqlErrors, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, simplifiedOperators: simplifiedOperators, hideTextSearchInput: hideTextSearchInput, contextJql: contextJql })=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    onPerformanceMark({
        mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_HYDRATE_START
    });
    /* eslint-disable @atlassian/relay/query-restriction */ const hydratedData = (0, $j4oe4.usePreloadedQuery)((0, $cWcbh.HYDRATION_QUERY), hydrationQueryRef);
    onPerformanceMark({
        mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_HYDRATE_END
    });
    const fieldsHydrationData = (0, $j4oe4.useFragment)($92286b5c84adb411$export$7b6dd859fbd6fe77, hydratedData);
    /* eslint-enable @atlassian/relay/query-restriction */ return (0, $eJOHy.useMemo)(()=>{
        const fieldsData = {};
        if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: (0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? field.field.operators?.map((0, $22GDK.mapOperators)) ?? [] : field.field.operators.map((0, $22GDK.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        else if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQueryForFilter.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: (0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? field.field.operators?.map((0, $22GDK.mapOperators)) ?? [] : field.field.operators.map((0, $22GDK.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        const isLastHydrationQuery = contextJql !== hydrationQueryRef?.variables.jql;
        const querySupported = !jqlErrors?.length && /**
     * Relay run one render iteration with isHydrating false but with the old data,
     * so we check if the jql matches the current hydration query.
     */ (isHydrating || isLastHydrationQuery ? /**
    * If we are hydrating, we run a complexity check without checking operators.
    * This allow us to show advanced mode loading state if we already know the query is too complex.
    * For Example, when we have multiple compound clauses or have unsupported nodes
    */ !(0, $9JtRn.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) : /**
    * Complete complexity check using hydrated data.
    */ !(0, $9JtRn.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            fieldsData: fieldsData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput
        }));
        return {
            querySupported: querySupported
        };
    }, [
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields,
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields,
        contextJql,
        hydrationQueryRef?.variables.jql,
        currentJql,
        isHydrating,
        excludedFields,
        hideTextSearchInput,
        simplifiedOperators,
        jqlErrors?.length
    ]);
};
const $92286b5c84adb411$export$f94eb234c660c8a5 = ({ query: query, excludedFields: excludedFields = [], jqlMessages: jqlMessages, children: children, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating = false, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false, contextJql: contextJql })=>{
    const jqlErrors = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>(jqlMessages || []).filter((e)=>e.type === 'error'), [
        jqlMessages
    ]);
    const { querySupported: querySupported } = $92286b5c84adb411$var$useQuerySupportedOld({
        currentJql: query,
        excludedFields: excludedFields,
        jqlErrors: jqlErrors,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        simplifiedOperators: simplifiedOperators,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    });
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            querySupported: querySupported
        }), [
        querySupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92286b5c84adb411$var$QuerySupportedContext.Provider, {
        value: contextValue
    }, children);
};
const $92286b5c84adb411$var$useQuerySupported = ({ currentJql: currentJql, excludedFields: excludedFields = [], jqlErrors: jqlErrors, hydrationData: hydrationData, simplifiedOperators: simplifiedOperators, hideTextSearchInput: hideTextSearchInput, contextJql: contextJql })=>{
    const fieldsHydrationData = (0, $j4oe4.useFragment)($92286b5c84adb411$export$7b6dd859fbd6fe77, hydrationData);
    const { hydrationQueryIsFetching: hydrationQueryIsFetching, hydrationQueryContextJql: hydrationQueryContextJql } = (0, $8FAu5.useHydrationQuery)();
    return (0, $eJOHy.useMemo)(()=>{
        const fieldsData = {};
        if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: (0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? field.field.operators?.map((0, $22GDK.mapOperators)) ?? [] : field.field.operators.map((0, $22GDK.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        else if (fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields) fieldsHydrationData.jira.jqlBuilder.hydrateJqlQueryForFilter.fields.forEach((field)=>{
            if (field?.jqlTerm && field?.field?.searchTemplate?.key && field?.field.type) fieldsData[field.jqlTerm] = {
                jqlTerm: field.jqlTerm,
                searchTemplate: field.field.searchTemplate.key,
                operators: (0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? field.field.operators?.map((0, $22GDK.mapOperators)) ?? [] : field.field.operators.map((0, $22GDK.mapOperators)),
                fieldType: field.field.type,
                hydratedValues: field.values
            };
        });
        const isLastHydrationQuery = contextJql !== hydrationQueryContextJql;
        const querySupported = !jqlErrors?.length && /**
     * Relay run one render iteration with isHydrating false but with the old data,
     * so we check if the jql matches the current hydration query.
     */ (hydrationQueryIsFetching || isLastHydrationQuery ? /**
    * If we are hydrating, we run a complexity check without checking operators.
    * This allow us to show advanced mode loading state if we already know the query is too complex.
    * For Example, when we have multiple compound clauses or have unsupported nodes
    */ !(0, $9JtRn.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) : /**
    * Complete complexity check using hydrated data.
    */ !(0, $9JtRn.isQueryTooComplex)({
            jql: currentJql,
            excludedFields: excludedFields,
            fieldsData: fieldsData,
            simplifiedOperators: simplifiedOperators,
            hideTextSearchInput: hideTextSearchInput
        }));
        return {
            querySupported: querySupported
        };
    }, [
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQuery?.fields,
        fieldsHydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter?.fields,
        contextJql,
        hydrationQueryContextJql,
        hydrationQueryIsFetching,
        currentJql,
        excludedFields,
        hideTextSearchInput,
        simplifiedOperators,
        jqlErrors?.length
    ]);
};
const $92286b5c84adb411$var$QuerySupportedContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    querySupported: true
});
const $92286b5c84adb411$export$34660422c2aeae3d = ({ query: query, excludedFields: excludedFields = [], jqlMessages: jqlMessages, children: children, hydrationData: hydrationData, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false, contextJql: contextJql })=>{
    const jqlErrors = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>(jqlMessages || []).filter((e)=>e.type === 'error'), [
        jqlMessages
    ]);
    const { querySupported: querySupported } = $92286b5c84adb411$var$useQuerySupported({
        currentJql: query,
        excludedFields: excludedFields,
        jqlErrors: jqlErrors,
        hydrationData: hydrationData,
        simplifiedOperators: simplifiedOperators,
        hideTextSearchInput: hideTextSearchInput,
        contextJql: contextJql
    });
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            querySupported: querySupported
        }), [
        querySupported
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92286b5c84adb411$var$QuerySupportedContext.Provider, {
        value: contextValue
    }, children);
};
const $92286b5c84adb411$export$8ce0898530622ab2 = ()=>(0, $eJOHy.useContext)($92286b5c84adb411$var$QuerySupportedContext);

});
parcelRegister("76KWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $498b3a5c03879a12$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cadfeece8c60fcae6af121a26753782b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $498b3a5c03879a12$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v6 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useQuery",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$498b3a5c03879a12$var$node.hash = "4d890a45a4dfda4ffe64d79e9bb649dd";
var $498b3a5c03879a12$export$2e2bcd8739ae039 = $498b3a5c03879a12$var$node;

});

parcelRegister("9JtRn", function(module, exports) {

$parcel$export(module.exports, "isQueryTooComplex", () => $12dab411be6d5dcb$export$4a510b220f67686c);

var $eM3Eu = parcelRequire("eM3Eu");

var $dTJxm = parcelRequire("dTJxm");

var $b06aK = parcelRequire("b06aK");

var $dFEPL = parcelRequire("dFEPL");

var $iA72F = parcelRequire("iA72F");

var $dHNhH = parcelRequire("dHNhH");

var $cugAS = parcelRequire("cugAS");
const $12dab411be6d5dcb$var$haveKnownUnsupportedOperators = (clauses)=>clauses.some((clause)=>clause.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) && clause.operator && (0, $cugAS.getUnsupportedOperators)().includes(clause.operator.value));
const $12dab411be6d5dcb$var$isClauseTooComplex = ({ clauses: clauses, searchTemplate: searchTemplate, hydratedValues: hydratedValues })=>{
    // Date
    // Or if we don't know the value while not hydrated and can show basic picker
    if (!searchTemplate || (0, $dTJxm.dateSearchTemplates).has(searchTemplate)) return clauses.length > 2 || $12dab411be6d5dcb$var$haveKnownUnsupportedOperators(clauses);
    // Cascading Select
    if (searchTemplate === (0, $dTJxm.CASCADE_SELECT_FIELD_SEARCH_TEMPLATE)) {
        const unambiguousCascadeFieldValue = (0, $dFEPL.findUnambiguousCascadeFieldValue)({
            clause: clauses[0],
            hydratedValues: hydratedValues
        });
        return clauses.length !== 1 || unambiguousCascadeFieldValue === undefined;
    }
    // Number Range & Work Ratio
    if (searchTemplate === (0, $dTJxm.NUMBER_RANGE_FIELD_SEARCH_TEMPLATE) || searchTemplate === 'workratio') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const operatorValues = clauses.map((clause)=>clause?.operator?.value.toString());
        return clauses.length > 2 || clauses.length === 2 && !(0, $dTJxm.NUMBER_RANGE_PICKER_ALLOWED_OPERATORS).every((op)=>operatorValues.includes(op));
    }
    // CMDB/AQL
    if (searchTemplate === (0, $dTJxm.CMDB_FIELD_SEARCH_TEMPLATE)) return clauses.length !== 1 || (0, $iA72F.isCmdbClauseTooComplexForBasicMode)(clauses[0]);
    // Default
    return clauses.length > 1;
};
const $12dab411be6d5dcb$export$4a510b220f67686c = ({ jql: jql, excludedFields: excludedFields = [], fieldsData: fieldsData, shouldValidateOperators: shouldValidateOperators = true, simplifiedOperators: simplifiedOperators = false, hideTextSearchInput: hideTextSearchInput = false })=>{
    const jast = new (0, $eM3Eu.JastBuilder)().build(jql);
    if (jast.errors.length) return true;
    try {
        const jqlClauseCollectingVisitor = new (0, $dHNhH.JqlClauseCollectingVisitor)(shouldValidateOperators, excludedFields, fieldsData, simplifiedOperators);
        const result = jast.query && jast.query.accept(jqlClauseCollectingVisitor);
        if (!result) return false;
        return(// Check if text search input clause is hidden
        result.textSearchInputClause && hideTextSearchInput || // Check if text search input clause is invalid
        !(0, $b06aK.default).validate(result.textSearchInputClause) || // Check if any clause is too complex
        Object.keys(result.clauseMap).some((key)=>{
            const clauses = result.clauseMap[key];
            const searchTemplate = fieldsData?.[key]?.searchTemplate;
            return $12dab411be6d5dcb$var$isClauseTooComplex({
                clauses: clauses,
                searchTemplate: searchTemplate,
                hydratedValues: fieldsData?.[key]?.hydratedValues
            });
        }));
    } catch (error) {
        return true;
    }
};

});
parcelRegister("b06aK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5570b954469d950$export$2e2bcd8739ae039);

var $2poie = parcelRequire("2poie");
var $lNgEH = parcelRequire("lNgEH");
var $3c1PD = parcelRequire("3c1PD");

var $7jTnu = parcelRequire("7jTnu");

var $cwFCg = parcelRequire("cwFCg");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $i08rO = parcelRequire("i08rO");
/**
 * Check if search input clause is valid
 */ const $c5570b954469d950$var$validate = (compoundClause)=>{
    if (!compoundClause) return true;
    try {
        compoundClause.accept((0, $7jTnu.fg)('shplxi_628_text_search_input_concurrent_fix') ? new (0, $cwFCg.TextSearchInputValueCollectingVisitor)((0, $dTJxm.getTextSearchInputField)()) : new (0, $i08rO.TextSearchInputVisitor)());
        return true;
    } catch (e) {
        return false;
    }
};
/**
 * Return value of search input clause or undefined if it's invalid or empty
 */ const $c5570b954469d950$var$value = (textSearchClause)=>{
    if (!textSearchClause) return undefined;
    try {
        return textSearchClause.accept((0, $7jTnu.fg)('shplxi_628_text_search_input_concurrent_fix') ? new (0, $cwFCg.TextSearchInputValueCollectingVisitor)((0, $dTJxm.getTextSearchInputField)()) : new (0, $i08rO.TextSearchInputVisitor)());
    } catch (e) {
        return undefined;
    }
};
const $c5570b954469d950$var$createTextSearchInputClause = ({ quotedKeyword: quotedKeyword, isIssueKey: isIssueKey })=>{
    const textSearchInputClause = (0, $2poie.default).terminalClause((0, $2poie.default).field((0, $dTJxm.getTextSearchInputField)()), (0, $2poie.default).operator((0, $lNgEH.OPERATOR_LIKE)), (0, $2poie.default).byText.valueOperand(quotedKeyword));
    if (isIssueKey) {
        const issueKeyClause = (0, $2poie.default).terminalClause((0, $2poie.default).field((0, $dTJxm.ISSUE_KEY)), (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS)), (0, $2poie.default).byText.valueOperand(quotedKeyword));
        return (0, $2poie.default).compoundClause((0, $2poie.default).compoundOperator((0, $f6a7331f12a1b6ec$export$7b8f0a728d79a753)), [
            textSearchInputClause,
            issueKeyClause
        ]);
    }
    return textSearchInputClause;
};
/**
 * Update search input clause with new value
 */ const $c5570b954469d950$var$update = (ast, textSearchInputClause, val)=>{
    if (!$c5570b954469d950$var$validate(textSearchInputClause)) return ast.represents;
    if (val === undefined || val === null || val === '') {
        if (textSearchInputClause) textSearchInputClause.remove();
        else return ast.represents;
    } else {
        const isIssueKey = (0, $i08rO.isIssueKeyValue)(val);
        const quotedKeyword = (0, $eiIzV.wrapWithQuotes)((0, $eiIzV.escapeBackslashes)(val));
        const newTextSearchInputClause = $c5570b954469d950$var$createTextSearchInputClause({
            quotedKeyword: quotedKeyword,
            isIssueKey: isIssueKey
        });
        if (textSearchInputClause) textSearchInputClause.replace(newTextSearchInputClause);
        else ast.query?.appendClause(newTextSearchInputClause, (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
    }
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};
const $c5570b954469d950$var$TextFieldType = {
    validate: $c5570b954469d950$var$validate,
    value: $c5570b954469d950$var$value,
    update: $c5570b954469d950$var$update
};
var $c5570b954469d950$export$2e2bcd8739ae039 = $c5570b954469d950$var$TextFieldType;

});
parcelRegister("cwFCg", function(module, exports) {

$parcel$export(module.exports, "TextSearchInputValueCollectingVisitor", () => $4acbb70ad602b81d$export$19f47a2bab0f2a92);

var $7ivol = parcelRequire("7ivol");
var $2nXMg = parcelRequire("2nXMg");
var $lNgEH = parcelRequire("lNgEH");
const $4acbb70ad602b81d$var$areTerminalClauses = (clauses)=>{
    for (const clause of clauses){
        if (clause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) return false;
    }
    return true;
};
const $4acbb70ad602b81d$var$ISSUE_KEY_REGEXP = new RegExp('^[A-Z][A-Z0-9]+-[0-9]+$', 'i');
const $4acbb70ad602b81d$export$ac7a009e7c9d6434 = (value)=>value !== undefined && value !== null && $4acbb70ad602b81d$var$ISSUE_KEY_REGEXP.test(value);
class $4acbb70ad602b81d$export$19f47a2bab0f2a92 extends (0, $7ivol.AbstractJastVisitor) {
    constructor(textSearchInputJqlTerm){
        super(), this.visitCompoundClause = (compoundClause)=>{
            // Only allow one compound clause with 2 or 3 terminal clauses using OR operator
            if (compoundClause.clauses.length > 2 || compoundClause.clauses.length < 1 || compoundClause.operator.value !== (0, $f6a7331f12a1b6ec$export$7b8f0a728d79a753) || !$4acbb70ad602b81d$var$areTerminalClauses(compoundClause.clauses)) throw new Error('Invalid search input clause');
            const valueMap = {};
            const value = compoundClause.clauses.reduce((result, terminalClause)=>{
                const clauseFieldName = terminalClause.field.value.toLowerCase();
                // Use same fieldName for key and issuekey (they are aliases)
                const fieldName = clauseFieldName === 'key' ? 'issuekey' : clauseFieldName;
                // Check if there are duplicated fields
                if (valueMap[fieldName]) throw new Error(`Duplicated field ${fieldName}`);
                else valueMap[fieldName] = true;
                return this.aggregateResult(terminalClause.accept(this), result);
            }, undefined);
            // Check if all required fields are present
            if (!valueMap[this.textSearchInputJqlTerm] || valueMap.issuekey !== undefined && !valueMap.issuekey) throw new Error('Missing required field in search input');
            return value;
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            // Only allow terminal clause with value operand
            if (terminalClause.operand?.operandType !== (0, $f38290926d0398e2$export$38accfc5a5d1c113)) throw new Error(`Invalid operandType ${terminalClause.operand?.operandType}`);
            if (fieldName === this.textSearchInputJqlTerm) {
                if (terminalClause.operator?.value !== (0, $lNgEH.OPERATOR_LIKE)) throw new Error(`Invalid operator in ${fieldName}`);
                return terminalClause.operand.value;
            }
            // Issue key check
            if (fieldName === 'issuekey' || fieldName === 'key') {
                if (terminalClause.operator?.value !== (0, $lNgEH.OPERATOR_EQUALS)) throw new Error(`Invalid operator in ${fieldName}`);
                if (!$4acbb70ad602b81d$export$ac7a009e7c9d6434(terminalClause.operand.value)) throw new Error(`Invalid value in ${fieldName}`);
                return terminalClause.operand.value;
            }
            throw new Error(`Invalid field ${fieldName}`);
        }, this.aggregateResult = (aggregate, nextResult)=>{
            // We only allow using same value in all terminal clauses
            if (nextResult !== undefined && aggregate !== nextResult) throw new Error('Mismatched values in search input');
            return aggregate;
        };
        this.textSearchInputJqlTerm = textSearchInputJqlTerm;
    }
    defaultResult() {
        throw new Error('Invalid search input clause');
    }
    shouldVisitNextChild(node) {
        // Skip visiting operand subtrees, which aren't needed for clause collection and can make a big impact on performance
        return !(0, $2nXMg.isOperandNode)(node);
    }
}

});
parcelRegister("2nXMg", function(module, exports) {

$parcel$export(module.exports, "isOperandNode", () => $64690240e652aff4$export$a9cf79e8f09322ba);

const $64690240e652aff4$export$a9cf79e8f09322ba = (maybeOperandNode)=>maybeOperandNode.type === (0, $66bb7f5e87fdacb6$export$d2f212d8ddbc8d1d);

});
const $66bb7f5e87fdacb6$export$98dda21ec825792 = 'query';
const $66bb7f5e87fdacb6$export$2d205682cc545947 = 'clause';
const $66bb7f5e87fdacb6$export$d2f212d8ddbc8d1d = 'operand';
const $66bb7f5e87fdacb6$export$da0f73edded4a63d = 'order_by';



parcelRegister("eiIzV", function(module, exports) {

$parcel$export(module.exports, "generateOptions", () => $edcde80b412d6934$export$c21133b4499f5374);
$parcel$export(module.exports, "generateErrorOptions", () => $edcde80b412d6934$export$b1b163cf4487fb60);
$parcel$export(module.exports, "fireJqlBuilderBasicErrorAnalytics", () => $edcde80b412d6934$export$2704bef70095c059);
$parcel$export(module.exports, "wrapWithQuotes", () => $edcde80b412d6934$export$125e49598117a72);
$parcel$export(module.exports, "escapeBackslashes", () => $edcde80b412d6934$export$fbd15c27bb7e257c);
$parcel$export(module.exports, "isPickerPropType", () => $edcde80b412d6934$export$353a391606dc3779);
$parcel$export(module.exports, "isTextAreaPropType", () => $edcde80b412d6934$export$96188d366777c3f5);

var $gYnSx = parcelRequire("gYnSx");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");
const $edcde80b412d6934$export$c21133b4499f5374 = (options, totalCount, endCursor)=>({
        options: options,
        totalCount: totalCount === undefined ? null : totalCount,
        endCursor: endCursor
    });
const $edcde80b412d6934$export$b1b163cf4487fb60 = (error)=>$edcde80b412d6934$export$c21133b4499f5374([
        {
            optionType: 'error',
            error: error,
            onRetry: ()=>undefined
        }
    ]);
const $edcde80b412d6934$export$2704bef70095c059 = (id, searchTemplate, error)=>(0, $gYnSx.default)({
        meta: {
            id: id,
            packageName: (0, $dTJxm.PACKAGE_NAME),
            teamName: (0, $dTJxm.TEAM_NAME)
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            searchTemplate: searchTemplate
        }
    });
const $edcde80b412d6934$export$125e49598117a72 = (text)=>`"${text.replace(/"/g, '\\"')}"`;
const $edcde80b412d6934$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
const $edcde80b412d6934$export$353a391606dc3779 = (propType)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.values((0, $eqSys.PickerPropTypes)).includes(propType);
const $edcde80b412d6934$export$96188d366777c3f5 = (propType)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.values((0, $eqSys.TextAreaPropTypes)).includes(propType);

});
parcelRegister("eqSys", function(module, exports) {

$parcel$export(module.exports, "PickerTypes", () => $2053dbea53d14225$export$823060bb41f9b9ce);
$parcel$export(module.exports, "PickerPropTypes", () => $2053dbea53d14225$export$8673a3795efdab32);
$parcel$export(module.exports, "TextAreaPropTypes", () => $2053dbea53d14225$export$84f313a0fe939ad2);
$parcel$export(module.exports, "GenericPropTypes", () => $2053dbea53d14225$export$39db718405e40735);
const $2053dbea53d14225$export$823060bb41f9b9ce = {
    CascadeSelect: 'CascadeSelect',
    DateTime: 'DateTime',
    DueDate: 'DueDate',
    DateTimeRange: 'DateTimeRange',
    NumberRange: 'NumberRange',
    Picker: 'Picker',
    Text: 'Text',
    TextArea: 'TextArea',
    BooleanType: 'BooleanType',
    Unsupported: 'Unsupported'
};
const $2053dbea53d14225$export$8673a3795efdab32 = {
    CommonWithEmpty: 'CommonWithEmpty',
    Common: 'Common',
    IssueType: 'IssueType',
    Project: 'Project',
    Sprint: 'Sprint',
    Version: 'Version',
    User: 'User',
    Group: 'Group'
};
const $2053dbea53d14225$export$84f313a0fe939ad2 = {
    Text: 'Text',
    Number: 'Number',
    Aql: 'Aql',
    ExactText: 'ExactText'
};
const $2053dbea53d14225$export$39db718405e40735 = {
    NoProp: 'NoProp'
};

});


parcelRegister("i08rO", function(module, exports) {

$parcel$export(module.exports, "isIssueKeyValue", () => $22b0d6b02a33df3c$export$ac7a009e7c9d6434);
$parcel$export(module.exports, "TextSearchInputVisitor", () => $22b0d6b02a33df3c$export$d5784d52b31adc66);

var $7ivol = parcelRequire("7ivol");
var $lNgEH = parcelRequire("lNgEH");

var $dTJxm = parcelRequire("dTJxm");

var $1EcNA = parcelRequire("1EcNA");
const $22b0d6b02a33df3c$var$areTerminalClauses = (clauses)=>{
    for (const clause of clauses){
        if (clause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) return false;
    }
    return true;
};
const $22b0d6b02a33df3c$var$ISSUE_KEY_REGEXP = new RegExp('^[A-Z][A-Z0-9]+-[0-9]+$', 'i');
const $22b0d6b02a33df3c$export$ac7a009e7c9d6434 = (value)=>value !== undefined && value !== null && $22b0d6b02a33df3c$var$ISSUE_KEY_REGEXP.test(value);
class $22b0d6b02a33df3c$export$d5784d52b31adc66 extends (0, $7ivol.AbstractJastVisitor) {
    defaultResult() {
        throw new (0, $1EcNA.InvalidTextSearchInputError)('Invalid search input clause');
    }
    constructor(...args){
        super(...args), this.visitCompoundClause = (compoundClause)=>{
            // Only allow one compound clause with 1 or 2 terminal clauses using OR operator
            if (compoundClause.clauses.length > 2 || compoundClause.clauses.length < 1 || compoundClause.operator.value !== (0, $f6a7331f12a1b6ec$export$7b8f0a728d79a753) || !$22b0d6b02a33df3c$var$areTerminalClauses(compoundClause.clauses)) throw new (0, $1EcNA.InvalidTextSearchInputError)('Invalid search input clause');
            const valueMap = {};
            const value = compoundClause.clauses.reduce((result, terminalClause)=>{
                const clauseFieldName = terminalClause.field.value.toLowerCase();
                // Use same fieldName for key and issuekey (they are aliases)
                const fieldName = clauseFieldName === 'key' ? 'issuekey' : clauseFieldName;
                // Check if there are duplicated fields
                if (valueMap[fieldName]) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Duplicated field ${fieldName}`);
                else valueMap[fieldName] = true;
                return this.aggregateResult(terminalClause.accept(this), result);
            }, undefined);
            // Check if all required fields are present
            if (!valueMap[(0, $dTJxm.getTextSearchInputField)()] || valueMap.issuekey !== undefined && !valueMap.issuekey) throw new (0, $1EcNA.InvalidTextSearchInputError)('Missing required field in search input');
            return value;
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            // Only allow terminal clause with value operand
            if (terminalClause.operand?.operandType !== (0, $f38290926d0398e2$export$38accfc5a5d1c113)) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid operandType ${terminalClause.operand?.operandType}`);
            if (fieldName === (0, $dTJxm.getTextSearchInputField)()) {
                if (terminalClause.operator?.value !== (0, $lNgEH.OPERATOR_LIKE)) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid operator in ${fieldName}`);
                return terminalClause.operand.value;
            }
            // Issue key check
            if (fieldName === 'issuekey' || fieldName === 'key') {
                if (terminalClause.operator?.value !== (0, $lNgEH.OPERATOR_EQUALS)) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid operator in ${fieldName}`);
                if (!$22b0d6b02a33df3c$export$ac7a009e7c9d6434(terminalClause.operand.value)) throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid value in ${fieldName}`);
                return terminalClause.operand.value;
            }
            throw new (0, $1EcNA.InvalidTextSearchInputError)(`Invalid field ${fieldName}`);
        }, this.aggregateResult = (aggregate, nextResult)=>{
            // We only allow using same value in all terminal clauses
            if (nextResult !== undefined && aggregate !== nextResult) throw new (0, $1EcNA.InvalidTextSearchInputError)('Mismatched values in search input');
            return aggregate;
        };
    }
}

});
parcelRegister("1EcNA", function(module, exports) {

$parcel$export(module.exports, "InvalidTextSearchInputError", () => $1db0525c379e013d$export$d6efcb4541a8aae7);
class $1db0525c379e013d$export$d6efcb4541a8aae7 extends Error {
}

});



parcelRegister("dFEPL", function(module, exports) {

$parcel$export(module.exports, "findUnambiguousCascadeFieldValue", () => $202a1712754808b7$export$b146240c7e4a7cf6);


var $dTJxm = parcelRequire("dTJxm");
const $202a1712754808b7$export$d6b4e2aa5cb86d59 = 'JiraJqlCascadingOptionFieldValue';
const $202a1712754808b7$var$isHydrationJqlValueOrError = (value)=>value?.__typename === 'JiraJqlQueryHydratedValue' || value?.__typename === 'JiraJqlQueryHydratedError';
const $202a1712754808b7$var$matchValueToClause = (hydratedValues, clauseValue)=>clauseValue ? hydratedValues?.find((fieldValue)=>$202a1712754808b7$var$isHydrationJqlValueOrError(fieldValue) && fieldValue?.jqlTerm?.toLowerCase() === clauseValue?.toLowerCase()) : undefined;
const $202a1712754808b7$var$isCascadingOptionFieldValue = (value)=>value?.__typename === 'JiraJqlCascadingOptionFieldValue';
/**
 * Returns the hydrated select option state (both parent and child) that the
 * cascading select picker accepts
 */ const $202a1712754808b7$var$getCascadingSelectStateFromFieldValue = (value)=>{
    if (!value?.optionId || !value?.displayName) return undefined;
    if (value.parentOption?.optionId && value.parentOption?.displayName) return {
        childOption: {
            label: value.displayName,
            value: value.optionId
        },
        parentOption: {
            label: value.parentOption.displayName,
            value: value.parentOption.optionId
        }
    };
    return {
        parentOption: {
            label: value.displayName,
            value: value.optionId
        }
    };
};
const $202a1712754808b7$var$getInvalidCascadingSelectOption = (valueOrError)=>({
        label: valueOrError.jqlTerm,
        value: valueOrError.jqlTerm,
        isInvalid: true
    });
/**
 * Handles determining the correct hydration to use for values from the `cascadeOption` function
 *
 * @param parent The JqlHydrationValue containing the possible parent options (or hydration error)
 * @param child  The JqlHydrationValue containing the possible child options (or hydration error)
 */ const $202a1712754808b7$var$getCascadingSelectStateForFunction = (parent, child)=>{
    // If there is no parent, then there cannot be a child either
    if (!parent) return undefined;
    // If the parent is invalid, then we can assume that the child is also invalid
    if (parent?.__typename === 'JiraJqlQueryHydratedError') return {
        parentOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(parent),
        childOption: child ? $202a1712754808b7$var$getInvalidCascadingSelectOption(child) : undefined
    };
    // Find the parent option values. Parent options have parentOption set to null
    const parentValues = parent?.values?.filter($202a1712754808b7$var$isCascadingOptionFieldValue).filter((parentValue)=>!parentValue?.parentOption);
    // If there is no child, then we can return the parent option.
    if (!child && parentValues?.length === 1) return $202a1712754808b7$var$getCascadingSelectStateFromFieldValue(parentValues[0]);
    // If there were multiple possible parents and no children, then it is ambiguous and we will return none
    if (!child) return undefined;
    if (child?.__typename === 'JiraJqlQueryHydratedError') // If the child is invalid, we can at least attempt to salvage the parent
    return parentValues?.length === 1 ? {
        ...$202a1712754808b7$var$getCascadingSelectStateFromFieldValue(parentValues[0]),
        childOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(child)
    } : {
        parentOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(parent),
        childOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(child)
    };
    // Find the child option values. Child options have parentOption set to a parent option. We can
    // use that to find the children that match a parent option found above
    const childValues = child?.values?.filter($202a1712754808b7$var$isCascadingOptionFieldValue).filter((childValue)=>parentValues?.some((parentValue)=>childValue?.parentOption && parentValue?.optionId === childValue?.parentOption.optionId));
    // If there is only one child value, we can return the parent and child option, otherwise the
    // clause is ambiguous
    if (childValues?.length === 1) return $202a1712754808b7$var$getCascadingSelectStateFromFieldValue(childValues[0]);
};
const $202a1712754808b7$export$b146240c7e4a7cf6 = ({ hydratedValues: hydratedValues, clause: clause })=>{
    if (clause?.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) return;
    // Handle the case where clause is a list with mupltiple values
    if (clause?.operand?.operandType === (0, $f38290926d0398e2$export$fabec4aebba3f4df) && clause?.operand?.values?.length > 1) return;
    // Handle the case where clause is a cascadeOption function (with at most two arguments)
    if (clause?.operand?.operandType === (0, $f38290926d0398e2$export$19c7c729db381f9d) && clause?.operand?.function.value === (0, $dTJxm.CASCADE_OPTION_FUNCTION_NAME) && clause?.operand?.arguments && clause?.operand?.arguments.length <= 2) {
        const { operand: operand } = clause;
        return $202a1712754808b7$var$getCascadingSelectStateForFunction(// Find the field value that matches the first argument of the cascadeOption function (parent)
        $202a1712754808b7$var$matchValueToClause(hydratedValues, operand?.arguments[0]?.value), // Find the field value that matches the second argument of the cascadeOption function (child)
        $202a1712754808b7$var$matchValueToClause(hydratedValues, operand?.arguments[1]?.value));
    }
    // Handle the case where clause is a single value or a list with one value
    if (clause?.operand?.operandType !== (0, $f38290926d0398e2$export$f6049126fd97001f)) {
        let clauseValue = '';
        // Get the value of the clause depending on the operand type
        switch(clause?.operand?.operandType){
            case 0, $f38290926d0398e2$export$fabec4aebba3f4df:
                if (clause?.operand?.values?.[0]?.operandType !== (0, $f38290926d0398e2$export$38accfc5a5d1c113)) return;
                clauseValue = clause?.operand?.values?.[0]?.value;
                break;
            case 0, $f38290926d0398e2$export$38accfc5a5d1c113:
                clauseValue = clause?.operand?.value;
                break;
            default:
                return;
        }
        // Match the clause value to a field value
        const matchedValue = $202a1712754808b7$var$matchValueToClause(hydratedValues, clauseValue);
        if (matchedValue?.__typename === 'JiraJqlQueryHydratedError') // If there's a hydration error, the best we can do is assume it's the parent
        // This assumption resulsts in a better UX than kicking the user to advanced mode
        // with no further information.
        return {
            parentOption: $202a1712754808b7$var$getInvalidCascadingSelectOption(matchedValue)
        };
        // If there is more than one matched value, the clause is ambiguous, otherwise we can get
        // the parent and child option
        if (matchedValue?.values && matchedValue.values.length === 1 && $202a1712754808b7$var$isCascadingOptionFieldValue(matchedValue.values[0])) return $202a1712754808b7$var$getCascadingSelectStateFromFieldValue(matchedValue.values[0]);
    }
    return undefined;
};

});

parcelRegister("iA72F", function(module, exports) {

$parcel$export(module.exports, "isCmdbClauseTooComplexForBasicMode", () => $8b7cd1373c7f6adc$export$eed7916f3400f094);


var $dTJxm = parcelRequire("dTJxm");
const $8b7cd1373c7f6adc$export$eed7916f3400f094 = (clause)=>clause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) || clause.operand?.operandType !== (0, $f38290926d0398e2$export$19c7c729db381f9d) || ![
        (0, $dTJxm.AQL_FUNCTION_NAME).toLowerCase(),
        (0, $dTJxm.IQL_FUNCTION_NAME).toLowerCase()
    ].includes(clause.operand?.function.value.toLowerCase()) || clause.operand?.arguments.length !== 1;

});

parcelRegister("dHNhH", function(module, exports) {

$parcel$export(module.exports, "JqlClauseCollectingVisitor", () => $ff2625dd751d7e4a$export$566c7abb4018442d);

var $16aVR = parcelRequire("16aVR");

var $7ivol = parcelRequire("7ivol");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $4G98k = parcelRequire("4G98k");

var $bgVBN = parcelRequire("bgVBN");
class $ff2625dd751d7e4a$export$566c7abb4018442d extends (0, $7ivol.AbstractJastVisitor) {
    /**
	 *
	 * @param shouldValidateOperators {boolean} - When true, when visiting a terminal clause, will
	 * compare the clause's operator to the allowed operators for the matching field in the
	 * `fieldsData` arg
	 * @param excludedFields
	 * @param fieldsData {FieldDataMap} - This is data transformed from the hydration query. We
	 * assume all of the fields are 1:1 with those in the AST since the same JQL query was used when
	 * calling hydration query
	 * @param simplifiedOperators
	 */ constructor(shouldValidateOperators = true, excludedFields = [], fieldsData, simplifiedOperators = false){
        super(), this.visitCompoundClause = (compoundClause)=>{
            const operator = compoundClause.operator.value;
            if (operator === (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), {
                clauseMap: {}
            });
            if (operator === (0, $f6a7331f12a1b6ec$export$7b8f0a728d79a753)) // The only supported OR clause is for the text search refinement. Downstream validators are responsible for
            // checking if the compound clause is valid for text search.
            // If future refinements emerge that also use OR clauses then this logic would need to change to perform some
            // type of shape matching against the clause to find the correct refinement key.
            return {
                clauseMap: {},
                textSearchInputClause: compoundClause
            };
            throw new (0, $bgVBN.UnsupportedRefinementError)(`Compound clauses using the operator '${operator}' is not supported`);
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            if (this.shouldValidateOperators) {
                if (this.excludedFields.includes(fieldName)) throw new (0, $bgVBN.UnsupportedRefinementError)(`Field with name '${fieldName}' of type ${terminalClause.clauseType} is not supported`);
                const operator = terminalClause.operator?.value ?? '';
                if (this.fieldsData) {
                    const fieldData = this.fieldsData[fieldName];
                    const { allowedOperators: allowedOperators, pickerType: pickerType } = (0, $4G98k.getPickerType)({
                        searchTemplate: fieldData.searchTemplate,
                        fieldType: fieldData.fieldType,
                        operators: fieldData.operators,
                        simplifiedOperators: this.simplifiedOperators
                    });
                    if (pickerType !== (0, $eqSys.PickerTypes).Unsupported && allowedOperators) {
                        const isAllowedOperator = allowedOperators.map((allowedOperator)=>allowedOperator.value.toLowerCase()).includes(operator.toLowerCase());
                        if (!isAllowedOperator) throw new (0, $bgVBN.UnsupportedRefinementError)(`Field with value '${fieldName}' and searchTemplate '${fieldData.searchTemplate}' of type ${terminalClause.clauseType} is using an unsupported operator [${operator}]`);
                    }
                } else throw new (0, $bgVBN.UnsupportedRefinementError)('Field data should be defined to validate operators');
            }
            if (fieldName === (0, $dTJxm.getTextSearchInputField)()) return {
                clauseMap: {},
                textSearchInputClause: terminalClause
            };
            return {
                clauseMap: {
                    [terminalClause.field.value.toLowerCase()]: [
                        terminalClause
                    ]
                }
            };
        };
        this.shouldValidateOperators = shouldValidateOperators;
        this.excludedFields = excludedFields;
        this.fieldsData = fieldsData;
        this.simplifiedOperators = simplifiedOperators;
    }
    visitNotClause() {
        throw new (0, $bgVBN.UnsupportedRefinementError)('JqlClauseCollectingVisitor visited an unsupported node while traversing the AST');
    }
    defaultResult() {
        return {
            clauseMap: {}
        };
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ aggregateResult(aggregate, nextResult) {
        if (nextResult.textSearchInputClause && aggregate.textSearchInputClause) throw new (0, $bgVBN.UnsupportedRefinementError)('Too many text search input clause clauses');
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return {
            clauseMap: (0, (/*@__PURE__*/$parcel$interopDefault($16aVR)))(nextResult.clauseMap, aggregate.clauseMap, (destValue, srcValue)=>srcValue.concat(destValue ?? [])),
            textSearchInputClause: aggregate.textSearchInputClause === undefined ? nextResult.textSearchInputClause : aggregate.textSearchInputClause
        };
    }
}

});
parcelRegister("4G98k", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedPickerType", () => $551a53a929efa123$export$fb7c01070886ad20);
$parcel$export(module.exports, "getPickerType", () => $551a53a929efa123$export$42840c00d43e8a94);

var $7jTnu = parcelRequire("7jTnu");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $avTix = parcelRequire("avTix");
const $551a53a929efa123$export$fb7c01070886ad20 = ({ searchTemplate: searchTemplate, fieldType: fieldType })=>({
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        pickerType: (0, $eqSys.PickerTypes).Unsupported,
        propType: (0, $eqSys.GenericPropTypes).NoProp
    });
const $551a53a929efa123$var$getPickerData = ({ searchTemplate: searchTemplate, fieldType: fieldType, pickerType: pickerType, propType: propType, fieldOperators: fieldOperators, simplifiedOperators: simplifiedOperators = false })=>({
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        pickerType: pickerType,
        propType: propType,
        allowedOperators: (0, $avTix.getAllowedOperators)({
            pickerType: pickerType,
            fieldOperators: fieldOperators,
            propType: propType,
            simplifiedOperators: simplifiedOperators
        })
    });
const $551a53a929efa123$export$42840c00d43e8a94 = ({ searchTemplate: searchTemplate, fieldType: fieldType, operators: fieldOperators, simplifiedOperators: simplifiedOperators })=>{
    const commonAttributes = {
        searchTemplate: searchTemplate,
        fieldType: fieldType,
        fieldOperators: fieldOperators,
        simplifiedOperators: simplifiedOperators
    };
    switch(searchTemplate){
        case 'textFields':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Text,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'text':
        case 'summary':
        case 'description':
        case 'environment':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:textsearcher':
        case 'comment':
        case 'com.pyxis.greenhopper.jira:gh-epic-label-searcher':
        case 'jira.polaris:textsearcher':
        case 'com.atlassian.jira.ext.charting:textsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).TextArea,
                propType: (0, $eqSys.TextAreaPropTypes).Text
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:exacttextsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).TextArea,
                propType: (0, $eqSys.TextAreaPropTypes).ExactText
            });
        case 'created':
        case 'updated':
        case 'resolutiondate':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).DateTime,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:daterange':
        case 'statuscategorychangedate':
        case 'com.atlassian.jpo:jpo-custom-field-baseline-start-searcher':
        case 'com.atlassian.jpo:jpo-custom-field-baseline-end-searcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).DateTime,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.toolkit:LastCommentDateSearcher':
        case 'com.atlassian.jira.ext.charting:firstreponsedatesearcher':
        case 'com.atlassian.servicedesk:sd-request-feedback-date-searcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:datetimerange':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).DateTimeRange,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'duedate':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).DueDate,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'labels':
        case 'priority':
        case 'resolution':
        case 'status':
        case 'statusCategory':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:labelsearcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:multiselectsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Common
            });
        case 'journey':
            return (0, $7jTnu.fg)('jsm-journey-jql-builder-m1') ? $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            }) : $551a53a929efa123$export$fb7c01070886ad20({
                searchTemplate: searchTemplate,
                fieldType: fieldType
            });
        case 'components':
        case 'parent':
        case 'com.pyxis.greenhopper.jira:gh-epic-link-searcher':
        case 'ticketCategory':
        case 'com.pyxis.greenhopper.jira:gh-epic-status-searcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            });
        case 'versions':
        case 'fixVersions':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Version
            });
        case 'assignee':
        case 'creator':
        case 'reporter':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).User
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:userpickergroupsearcher':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:next-gen-people-searcher':
        case 'com.atlassian.jira.toolkit:participantsearcher':
        case 'com.atlassian.jira.toolkit:lastparticipantsearcher':
        case 'com.atlassian.servicedesk:sd-request-participants-searcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).User
            });
        case 'issuetype':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).IssueType
            });
        case 'project':
        case 'com.atlassian.jira.plugin.system.customfieldtypes:projectsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Project
            });
        case 'com.pyxis.greenhopper.jira:gh-sprint-searcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Sprint
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:grouppickersearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).Group
            });
        case 0, $dTJxm.CASCADE_SELECT_FIELD_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).CascadeSelect,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'com.atlassian.jira.plugin.system.customfieldtypes:exactnumber':
        case 'com.pyxis.greenhopper.jira:jsw-story-points-searcher':
        case 'jira.polaris:exact-number-searcher':
        case 'com.atlassian.servicedesk:sd-request-feedback-searcher':
        case 'com.atlassian.jira.toolkit:commentcountsearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).TextArea,
                propType: (0, $eqSys.TextAreaPropTypes).Number
            });
        case 'com.atlassian.jira.toolkit:lastcommentersearcher':
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).BooleanType,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 'workratio':
        case 0, $dTJxm.NUMBER_RANGE_FIELD_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).NumberRange,
                propType: (0, $eqSys.GenericPropTypes).NoProp
            });
        case 0, $dTJxm.CMDB_FIELD_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).TextArea,
                propType: (0, $eqSys.TextAreaPropTypes).Aql
            });
        case 0, $dTJxm.JSM_REQUEST_TYPE_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            });
        case 0, $dTJxm.JSM_ORGANIZATIONS_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            });
        case 'category':
            return (0, $7jTnu.fg)('nin_project_category_field_in_jql_builder') ? $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            }) : $551a53a929efa123$export$fb7c01070886ad20({
                searchTemplate: searchTemplate,
                fieldType: fieldType
            });
        case 0, $dTJxm.JSM_WORK_CATEGORY_SEARCH_TEMPLATE:
            return $551a53a929efa123$var$getPickerData({
                ...commonAttributes,
                pickerType: (0, $eqSys.PickerTypes).Picker,
                propType: (0, $eqSys.PickerPropTypes).CommonWithEmpty
            });
        default:
            return $551a53a929efa123$export$fb7c01070886ad20({
                searchTemplate: searchTemplate,
                fieldType: fieldType
            });
    }
};

});
parcelRegister("avTix", function(module, exports) {

$parcel$export(module.exports, "getAllowedOperators", () => $53df303d3ff15a5d$export$e56c61b51c1beb84);

var $2poie = parcelRequire("2poie");
var $lNgEH = parcelRequire("lNgEH");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $eiIzV = parcelRequire("eiIzV");
const $53df303d3ff15a5d$var$SIMPLIFIED_PICKER_ALLOWED_OPERATORS = [
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS)),
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IN))
];
const $53df303d3ff15a5d$var$PICKER_ALLOWED_OPERATORS = [
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS)),
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_NOT_EQUALS)),
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IN)),
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_NOT_IN)),
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IS)),
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IS_NOT))
];
const $53df303d3ff15a5d$var$TEXT_PICKER_ALLOWED_OPERATORS = [
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_LIKE))
];
const $53df303d3ff15a5d$export$362ce0c36f9a70b6 = (propType)=>{
    if (!(0, $eiIzV.isTextAreaPropType)(propType)) throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    switch(propType){
        case (0, $eqSys.TextAreaPropTypes).Number:
        case (0, $eqSys.TextAreaPropTypes).ExactText:
            return [
                (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS))
            ];
        case (0, $eqSys.TextAreaPropTypes).Text:
            return [
                (0, $2poie.default).operator((0, $lNgEH.OPERATOR_LIKE))
            ];
        case (0, $eqSys.TextAreaPropTypes).Aql:
            return [
                (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IN))
            ];
        default:
            throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    }
};
const $53df303d3ff15a5d$var$DATE_PICKER_ALLOWED_OPERATORS = [
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_LT_EQUALS)),
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_GT_EQUALS))
];
const $53df303d3ff15a5d$var$CASCADE_SELECT_PICKER_ALLOWED_OPERATORS = [
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IN)),
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS))
];
const $53df303d3ff15a5d$var$BOOLEAN_PICKER_ALLOWED_OPERATORS = [
    (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS))
];
const $53df303d3ff15a5d$var$getPickerOperators = (fieldOperators)=>$53df303d3ff15a5d$var$PICKER_ALLOWED_OPERATORS.filter((allowedOperator)=>fieldOperators.findIndex((fieldOperator)=>allowedOperator.value === fieldOperator) >= 0);
const $53df303d3ff15a5d$export$e56c61b51c1beb84 = ({ pickerType: pickerType, fieldOperators: fieldOperators = [], propType: propType = (0, $eqSys.GenericPropTypes).NoProp, simplifiedOperators: simplifiedOperators })=>{
    switch(pickerType){
        case (0, $eqSys.PickerTypes).Text:
            return $53df303d3ff15a5d$var$TEXT_PICKER_ALLOWED_OPERATORS;
        case (0, $eqSys.PickerTypes).TextArea:
            return $53df303d3ff15a5d$export$362ce0c36f9a70b6(propType);
        case (0, $eqSys.PickerTypes).DateTime:
        case (0, $eqSys.PickerTypes).DueDate:
        case (0, $eqSys.PickerTypes).DateTimeRange:
            return $53df303d3ff15a5d$var$DATE_PICKER_ALLOWED_OPERATORS;
        case (0, $eqSys.PickerTypes).Picker:
            return !simplifiedOperators ? $53df303d3ff15a5d$var$getPickerOperators(fieldOperators) : $53df303d3ff15a5d$var$SIMPLIFIED_PICKER_ALLOWED_OPERATORS;
        case (0, $eqSys.PickerTypes).CascadeSelect:
            return $53df303d3ff15a5d$var$CASCADE_SELECT_PICKER_ALLOWED_OPERATORS;
        case (0, $eqSys.PickerTypes).NumberRange:
            return (0, $dTJxm.NUMBER_RANGE_PICKER_ALLOWED_OPERATORS).map((op)=>(0, $2poie.default).operator(op));
        case (0, $eqSys.PickerTypes).BooleanType:
            return $53df303d3ff15a5d$var$BOOLEAN_PICKER_ALLOWED_OPERATORS;
        default:
            return [];
    }
};

});


parcelRegister("bgVBN", function(module, exports) {

$parcel$export(module.exports, "UnsupportedRefinementError", () => $e453bb6cf708ace1$export$251a1c8599975384);
/**
 * This represents an error when trying to map a JQL AST to a collection of refinements supported by NIN. If the JAST
 * contains syntax or fields not supported by the refinement bar then this error will be thrown.
 */ class $e453bb6cf708ace1$export$251a1c8599975384 extends Error {
}

});


parcelRegister("cugAS", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedOperators", () => $81a39631283da7a2$export$4b9252b112620e15);

var $lNgEH = parcelRequire("lNgEH");
const $81a39631283da7a2$var$UNSUPPORTED_OPERATORS = [
    ...(0, $lNgEH.CHANGED_OPERATORS),
    ...(0, $lNgEH.WAS_OPERATORS),
    ...(0, $lNgEH.WAS_IN_OPERATORS)
];
const $81a39631283da7a2$export$4b9252b112620e15 = ()=>$81a39631283da7a2$var$UNSUPPORTED_OPERATORS;

});


parcelRegister("22GDK", function(module, exports) {

$parcel$export(module.exports, "mapOperators", () => $f85bde50706c5a2f$export$ad17522432f44705);

var $lNgEH = parcelRequire("lNgEH");
const $f85bde50706c5a2f$export$ad17522432f44705 = (jiraJqlOpeartor)=>{
    switch(jiraJqlOpeartor){
        case 'EQUALS':
            return 0, $lNgEH.OPERATOR_EQUALS;
        case 'NOT_EQUALS':
            return 0, $lNgEH.OPERATOR_NOT_EQUALS;
        case 'IS':
            return 0, $lNgEH.OPERATOR_IS;
        case 'IN':
            return 0, $lNgEH.OPERATOR_IN;
        case 'IS_NOT':
            return 0, $lNgEH.OPERATOR_IS_NOT;
        case 'NOT_IN':
            return 0, $lNgEH.OPERATOR_NOT_IN;
        case 'CONTAINS':
            return 0, $lNgEH.OPERATOR_LIKE;
        case 'DOES_NOT_CONTAIN':
            return 0, $lNgEH.OPERATOR_NOT_LIKE;
        case 'WAS_NOT_IN':
            return 0, $lNgEH.OPERATOR_WAS_NOT_IN;
        case 'WAS_NOT':
            return 0, $lNgEH.OPERATOR_WAS_NOT;
        case 'WAS_IN':
            return 0, $lNgEH.OPERATOR_WAS_IN;
        case 'WAS':
            return 0, $lNgEH.OPERATOR_WAS;
        case 'CHANGED':
            return 0, $lNgEH.OPERATOR_CHANGED;
        case 'GREATER_THAN':
            return 0, $lNgEH.OPERATOR_GT;
        case 'GREATER_THAN_OR_EQUAL':
            return 0, $lNgEH.OPERATOR_GT_EQUALS;
        case 'LESS_THAN':
            return 0, $lNgEH.OPERATOR_LT;
        case 'LESS_THAN_OR_EQUAL':
            return 0, $lNgEH.OPERATOR_LT_EQUALS;
        default:
            throw new Error(`Operator ${jiraJqlOpeartor} not supported`);
    }
};

});

parcelRegister("5fhUb", function(module, exports) {

$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $f65791ff64431993$export$5fd6d8ece357700d);
// Performance marks
const $f65791ff64431993$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $f65791ff64431993$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $f65791ff64431993$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $f65791ff64431993$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $f65791ff64431993$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $f65791ff64431993$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $f65791ff64431993$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $f65791ff64431993$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $f65791ff64431993$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $f65791ff64431993$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $f65791ff64431993$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $f65791ff64431993$var$JQL_BUILDER_ADVANCED_END
};

});


parcelRegister("cX22j", function(module, exports) {

$parcel$export(module.exports, "SelectedSearchModeContainer", () => $86935b0bddd08828$export$d19caa48d475b9e3);
$parcel$export(module.exports, "SingleSearchModeContainer", () => $86935b0bddd08828$export$a70c1ee31d8bd058);
$parcel$export(module.exports, "useSelectedSearchMode", () => $86935b0bddd08828$export$af5effaed2abb303);

var $eJOHy = parcelRequire("eJOHy");

var $j9mbu = parcelRequire("j9mbu");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $56qWy = parcelRequire("56qWy");

var $70el7 = parcelRequire("70el7");
const $86935b0bddd08828$var$getSafeSearchMode = (mode)=>{
    switch(mode){
        case 0, $56qWy.SEARCH_MODE_BASIC:
            return 0, $56qWy.SEARCH_MODE_BASIC;
        case 0, $56qWy.SEARCH_MODE_ADVANCED:
            return 0, $56qWy.SEARCH_MODE_ADVANCED;
        default:
            return undefined;
    }
};
const $86935b0bddd08828$var$SelectedSearchModeContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    searchMode: (0, $56qWy.DEFAULT_SEARCH_MODE),
    setSelectedSearchMode: ()=>null
});
const $86935b0bddd08828$var$getValidSelectedSearchMode = (searchMode, querySupported)=>{
    if (searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)) return 0, $56qWy.SEARCH_MODE_ADVANCED;
    if (searchMode === (0, $56qWy.SEARCH_MODE_BASIC) && querySupported) return 0, $56qWy.SEARCH_MODE_BASIC;
    return 0, $56qWy.SEARCH_MODE_ADVANCED;
};
const $86935b0bddd08828$export$d19caa48d475b9e3 = ({ children: children, searchMode: searchMode, onSearchModeChange: onSearchModeChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { querySupported: querySupported } = (0, $70el7.useIsQuerySupported)();
    (0, $j9mbu.useRunOnce)(()=>{
        // Send analytics on inital load (like when you open a url with a query too complex)
        if (!querySupported && searchMode !== (0, $56qWy.SEARCH_MODE_ADVANCED)) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queryTooComplex triggered', {
            searchMode: searchMode
        });
    });
    const [searchModeInternal, setSearchModeInternal] = (0, $eJOHy.useState)($86935b0bddd08828$var$getValidSelectedSearchMode(searchMode, querySupported));
    if (!querySupported && searchModeInternal !== (0, $56qWy.SEARCH_MODE_ADVANCED)) {
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'queryTooComplex triggered', {
            searchMode: searchModeInternal
        });
        setSearchModeInternal((0, $56qWy.SEARCH_MODE_ADVANCED));
    }
    (0, $eJOHy.useEffect)(()=>{
        if (!querySupported && searchMode === (0, $56qWy.SEARCH_MODE_BASIC) && searchModeInternal === (0, $56qWy.SEARCH_MODE_ADVANCED)) onSearchModeChange?.((0, $56qWy.SEARCH_MODE_ADVANCED), 'QueryUnsupported');
    }, [
        onSearchModeChange,
        querySupported,
        searchMode,
        searchModeInternal
    ]);
    const setSelectedSearchMode = (0, $eJOHy.useCallback)((newSearchMode, userTriggered)=>{
        const safeSearchMode = $86935b0bddd08828$var$getSafeSearchMode(newSearchMode);
        if (!safeSearchMode) return;
        setSearchModeInternal(safeSearchMode);
        onSearchModeChange?.(safeSearchMode, userTriggered ? 'UserTriggered' : 'ExternalTriggered');
        if (userTriggered) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'switchJQLEditor', {
            switchToEditor: (0, $56qWy.mapSearchModeToAnalyticAtribute)[safeSearchMode]
        });
    }, [
        createAnalyticsEvent,
        onSearchModeChange
    ]);
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            searchMode: searchModeInternal,
            setSelectedSearchMode: setSelectedSearchMode
        }), [
        searchModeInternal,
        setSelectedSearchMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86935b0bddd08828$var$SelectedSearchModeContext.Provider, {
        value: contextValue
    }, children);
};
const $86935b0bddd08828$export$a70c1ee31d8bd058 = ({ children: children, searchMode: searchMode })=>{
    const contextValue = (0, $eJOHy.useMemo)(()=>({
            searchMode: searchMode,
            setSelectedSearchMode: ()=>null
        }), [
        searchMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86935b0bddd08828$var$SelectedSearchModeContext.Provider, {
        value: contextValue
    }, children);
};
const $86935b0bddd08828$export$af5effaed2abb303 = ()=>(0, $eJOHy.useContext)($86935b0bddd08828$var$SelectedSearchModeContext);

});
parcelRegister("j9mbu", function(module, exports) {

$parcel$export(module.exports, "useRunOnce", () => $889f0a6dfaaee3b5$export$a3576ea6e6df583c);

var $eJOHy = parcelRequire("eJOHy");
const $889f0a6dfaaee3b5$export$a3576ea6e6df583c = (cb, identifier)=>{
    const ref = (0, $eJOHy.useRef)(true);
    const identifierRef = (0, $eJOHy.useRef)(identifier);
    if (identifierRef.current !== identifier) {
        ref.current = true;
        identifierRef.current = identifier;
    }
    if (ref.current) cb();
    ref.current = false;
};

});


parcelRegister("b2CbD", function(module, exports) {

$parcel$export(module.exports, "useSearchModeMutation", () => $ef4d773a3cb60086$export$f4f7ced39b30a5ad);

var $g3Cs9 = parcelRequire("g3Cs9");

var $ekTTy = parcelRequire("ekTTy");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $kEUB1 = parcelRequire("kEUB1");

var $cECwI = parcelRequire("cECwI");

var $56qWy = parcelRequire("56qWy");

var $gQyru = parcelRequire("gQyru");
const $ef4d773a3cb60086$var$SEARCH_MODE_KEY_IN_RELAY_STORE = 'jqlBuilderSearchMode';
/**
 * Simple updater util function for setting the user's preferred JQL Search mode
 * in the Relay store when a mutation was either successful or failed - we update the
 * store regardless so that the search mode does not spontaneously change when
 * switching between the AI container search modes.
 */ const $ef4d773a3cb60086$var$relayStoreUpdater = (store, userPreferencesData, searchMode)=>{
    if (typeof userPreferencesData?.__id === 'string') {
        const record = store.get(userPreferencesData.__id);
        record?.setValue(searchMode, $ef4d773a3cb60086$var$SEARCH_MODE_KEY_IN_RELAY_STORE);
    }
};
const $ef4d773a3cb60086$export$f4f7ced39b30a5ad = (userPreferences)=>{
    /*
   * TODO
   * Why is there a relay fragment in a hook?!
   * Right now, we manually update the `jqlBuilderSearchMode` record in relay store.
   * We update it manually because the field is not a Node type and hence Relay cannot
   * automatically manage the store state for us.
   * Instead, we need to manually grab the __id, find the record and update it with the
   * mutation value so that the two are kept in sync.
   * This is a temporary measure until the graphQL schema is updated.
   * The fragment is in the hook for convenience, this hook is only called from
   * one component: `src/packages/jql-builder/src/ui/index.tsx`
   * In fact we can probably move this hook back into a UI component potentially.
   */ const userPreferencesData = (0, $j4oe4.useFragment)((0, $ekTTy.default), userPreferences || null);
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $g3Cs9.default));
    return (0, $eJOHy.useCallback)((mode)=>{
        if (!isAnonymous) {
            const serverSearchMode = (0, $gQyru.toServerSearchMode)(mode);
            commitMutation({
                variables: {
                    cloudId: cloudId,
                    searchMode: (0, $gQyru.toServerSearchMode)(mode)
                },
                onError: (error)=>{
                    (0, $gYnSx.default)({
                        sendToPrivacyUnsafeSplunk: true,
                        error: error,
                        meta: {
                            id: 'mainSelectedJqlBuilderModeMutation',
                            packageName: (0, $56qWy.PACKAGE_NAME),
                            teamName: (0, $56qWy.TEAM_NAME)
                        }
                    });
                    (0, $j4oe4.commitLocalUpdate)(environment, (store)=>$ef4d773a3cb60086$var$relayStoreUpdater(store, userPreferencesData ?? null, serverSearchMode));
                },
                updater: (store)=>$ef4d773a3cb60086$var$relayStoreUpdater(store, userPreferencesData ?? null, serverSearchMode)
            });
        }
    }, [
        cloudId,
        commitMutation,
        environment,
        isAnonymous,
        userPreferencesData
    ]);
};

});
parcelRegister("g3Cs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $478a7af77749c321$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7a4f9b2c7ea46621cd664591e142a2b>>
 * @relayHash 5d62b62066d2e4341b25445f5710faf6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea28f854d9d34cb357f7b0a2d32ddcfaabb301d65019ccde74b53cf76b1aeb39
const $478a7af77749c321$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchMode"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchMode",
                                    "variableName": "searchMode"
                                }
                            ],
                            "concreteType": "JiraJQLBuilderSearchModeMutationPayload",
                            "kind": "LinkedField",
                            "name": "setJQLBuilderSearchMode",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "userSearchMode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "ea28f854d9d34cb357f7b0a2d32ddcfaabb301d65019ccde74b53cf76b1aeb39",
            "metadata": {},
            "name": "searchModeJqlBuilder_updateJQLBuilderSearchModeMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$478a7af77749c321$var$node.hash = "92ba3afb837dca41d4ee89012d43ffd1";
var $478a7af77749c321$export$2e2bcd8739ae039 = $478a7af77749c321$var$node;

});

parcelRegister("ekTTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e1b29d8bdd078d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c834bed95690edeb5b5d9f5778b02b05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $06e1b29d8bdd078d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "searchMode_useSearchMode_JQLBuilder",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraUserPreferences"
};
$06e1b29d8bdd078d$var$node.hash = "b610d5310493b4f35efc509255a102c4";
var $06e1b29d8bdd078d$export$2e2bcd8739ae039 = $06e1b29d8bdd078d$var$node;

});


parcelRegister("lw8qf", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderFallback", () => $05cda189142557bf$export$61e39bbfd9e09552);

var $eJOHy = parcelRequire("eJOHy");

var $7tpWk = parcelRequire("7tpWk");
var $hDiPV = parcelRequire("hDiPV");

var $6MO8n = parcelRequire("6MO8n");

var $4GZBG = parcelRequire("4GZBG");

var $9JtRn = parcelRequire("9JtRn");

var $6zXPf = parcelRequire("6zXPf");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $56qWy = parcelRequire("56qWy");

var $6bDCV = parcelRequire("6bDCV");

var $9HnR3 = parcelRequire("9HnR3");

var $cOgRS = parcelRequire("cOgRS");

var $7bFFO = parcelRequire("7bFFO");

var $7ebli = parcelRequire("7ebli");

var $jn1oF = parcelRequire("jn1oF");
const $05cda189142557bf$export$61e39bbfd9e09552 = ({ selectedSearchMode: selectedSearchMode, searchModes: searchModes, query: query, onLoad: onLoad, isSearchModeToggleEnabled: isSearchModeToggleEnabled, renderExtraControls: renderExtraControls, beforeControls: beforeControls, excludedFields: excludedFields, components: components, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation = (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION), showOrderByPicker: showOrderByPicker })=>{
    const onJqlBuilderBasicLoad = (0, $eJOHy.useCallback)(()=>{
        onLoad && onLoad((0, $56qWy.SEARCH_MODE_BASIC));
    }, [
        onLoad
    ]);
    const searchModeCandidate = (0, $eJOHy.useMemo)(()=>{
        if (selectedSearchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)) return 0, $56qWy.SEARCH_MODE_ADVANCED;
        return (0, $9JtRn.isQueryTooComplex)({
            jql: query,
            excludedFields: excludedFields,
            shouldValidateOperators: false,
            hideTextSearchInput: hideTextSearchInput
        }) ? (0, $56qWy.SEARCH_MODE_ADVANCED) : (0, $56qWy.SEARCH_MODE_BASIC);
    }, [
        excludedFields,
        hideTextSearchInput,
        query,
        selectedSearchMode
    ]);
    /**
	 * ⚠️ This code contains architectural problems that now occur since JQL Builder being used in pages
	 * other than NIN. Since the introduction of `searchModes`, situations can arise where the
	 * computed searchMode may not exist in the available options set in `searchModes[]`. For example
	 * when `searchModes === ['basic']` but the computed search mode is set to `advanced` due to
	 * a query being too complex - LDR to do: https://hello.atlassian.net/l/cp/YrdVZ0fa
	 */ const searchMode = (0, $eJOHy.useMemo)(()=>{
        let resolvedSearchMode = searchModeCandidate;
        if (!searchModes?.length) resolvedSearchMode = searchModeCandidate;
        else resolvedSearchMode = searchModes.includes(searchModeCandidate) ? searchModeCandidate : searchModes[0];
        // Preload package depending on the resolved search mode
        if (resolvedSearchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)) (0, $hDiPV.preloadJQLEditor)();
        else if (!(0, $7jTnu.fg)('render_jql_builder_in_ssr')) // @deprecated render_jql_builder_in_ssr will load JQL Builder basic mode sync
        (0, $6MO8n.preloadJqlBuilderBasic)();
        return resolvedSearchMode;
    }, [
        searchModes,
        searchModeCandidate
    ]);
    (0, $eJOHy.useEffect)(()=>{
        searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED) && onLoad && onLoad((0, $56qWy.SEARCH_MODE_ADVANCED));
    }, [
        onLoad,
        searchMode
    ]);
    const BeforeJqlBuilderContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderContainer) : (0, $7ebli.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderListItemContainer) : (0, $7ebli.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.AdvancedEditorWrapper) : (0, $7ebli.AdvancedEditorWrapperOld);
    const jqlBuilderFallbackComponent = searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tpWk.JQLEditorReadOnly), {
        isCompact: true,
        isSearch: true,
        query: query
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.JQLBuilderBasicFallback), {
        query: query,
        excludedFields: excludedFields,
        onLoad: onJqlBuilderBasicLoad,
        shouldUseListMarkup: true,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker
    });
    const { SearchModeSwitcher: SearchModeSwitcher = (0, $9HnR3.SearchModeSwitcher) } = components ?? {};
    const BeforeJqlBuilderWrapper = searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $6zXPf.getWillShowNav4)();
    const searchModeSwitcherComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7bFFO.SearchModeSwitcherContainer), {
        testId: "jql-builder.ui.jql-builder-fallback.toggle-container",
        isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SearchModeSwitcher, {
        searchMode: searchMode,
        isBasicModeDisabled: false,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onUpdateSearchMode: ()=>{}
    }));
    const editorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, searchModeSwitcherComponent), jqlBuilderFallbackComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jn1oF.default), {
        searchMode: searchMode,
        renderExtraControls: renderExtraControls,
        shouldUseListMarkup: searchMode === (0, $56qWy.SEARCH_MODE_BASIC)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Container), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "jql-builder",
        "data-vc": `jql-builder-fallback${false ? '-ssr' : ''}`,
        ...false && {
            'data-ssr-placeholder': 'jql-builder-fallback-placeholder'
        },
        ...!false && {
            'data-ssr-placeholder-replace': 'jql-builder-fallback-placeholder'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOgRS.DefaultJqlBuilderContainer), {
        showAdvancedEditor: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED)
    }, searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.BasicEditorListContainer), {
        "data-testid": "jql-builder.ui.jql-builder-fallback.basic-editor-list-container"
    }, editorContent) : editorContent), isSearchModeToggleEnabled && !isSearchModeSwitcherOnLeft && searchModeSwitcherComponent);
};

});
parcelRegister("7tpWk", function(module, exports) {

$parcel$export(module.exports, "JQLEditorReadOnly", () => $5a95c3cf9c4bf51a$export$96157d0351f40cdc);
$parcel$export(module.exports, "default", () => $5a95c3cf9c4bf51a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8XtVW = parcelRequire("8XtVW");

var $dhRXV = parcelRequire("dhRXV");

var $aG17i = parcelRequire("aG17i");

var $4uGwj = parcelRequire("4uGwj");

var $9cvBI = parcelRequire("9cvBI");

var $hglfE = parcelRequire("hglfE");
const $5a95c3cf9c4bf51a$var$JQLEditorLayout = (props)=>{
    const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, $aG17i.useEditorThemeContext)();
    const { editorViewHasFocus: editorViewHasFocus, EditorControlsContent: EditorControlsContent, EditorFooterContent: EditorFooterContent, editorViewIsInvalid: editorViewIsInvalid, lineNumbersVisible: lineNumbersVisible, mainId: mainId, onEditorMainRef: onEditorMainRef, onEditorViewContainerRef: onEditorViewContainerRef, onEditorViewContainerScroll: onEditorViewContainerScroll, onEditorViewRef: onEditorViewRef, onEditorViewBlur: onEditorViewBlur, onEditorViewFocus: onEditorViewFocus, onEditorViewTransitionEnd: onEditorViewTransitionEnd } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hglfE.EditorMain), {
        id: mainId,
        ref: onEditorMainRef,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hglfE.EditorViewContainer), {
                editorViewHasFocus: editorViewHasFocus,
                editorViewIsInvalid: editorViewIsInvalid,
                ref: onEditorViewContainerRef,
                onScroll: onEditorViewContainerScroll,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hglfE.LineNumberToolbar), {
                        lineNumbersVisible: lineNumbersVisible
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hglfE.EditorView), {
                        defaultMaxRows: defaultMaxRows,
                        expandedRows: expandedRows,
                        isCompact: isCompact,
                        lineNumbersVisible: lineNumbersVisible,
                        ref: onEditorViewRef,
                        onBlur: onEditorViewBlur,
                        onFocus: onEditorViewFocus,
                        onTransitionEnd: onEditorViewTransitionEnd
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hglfE.EditorControls), {
                        isSearch: isSearch,
                        isCompact: isCompact,
                        isVisualRefresh: (0, $8XtVW.fg)('platform-component-visual-refresh'),
                        children: EditorControlsContent
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hglfE.EditorFooter), {
                children: EditorFooterContent
            })
        ]
    });
};
/**
 * A read only version of the JQL Editor which mimics the layout of the complete component, suitable as an intermediary
 * state when rendering the editor asynchronously.
 * In order to minimise bundle size impact on consumers, it is critical that this component (and any child component)
 * only imports the bare minimum dependencies required to replicate the editor layout.
 */ const $5a95c3cf9c4bf51a$var$JQLEditorReadOnlyWithoutTheme = ({ query: query })=>{
    const { defaultMaxRows: defaultMaxRows, expandedRows: expandedRows, isSearch: isSearch, isCompact: isCompact } = (0, $aG17i.useEditorThemeContext)();
    const blocks = (0, $4uGwj.splitTextByNewLine)(query);
    const lineNumbersVisible = blocks.length > 1;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hglfE.EditorMain), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $hglfE.ReadOnlyEditorViewContainer), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hglfE.LineNumberToolbar), {
                        lineNumbersVisible: lineNumbersVisible
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hglfE.ReadOnlyEditorView), {
                        "data-testid": "jql-editor-read-only",
                        role: "combobox",
                        "aria-readonly": true,
                        defaultMaxRows: defaultMaxRows,
                        expandedRows: expandedRows,
                        lineNumbersVisible: lineNumbersVisible,
                        isCompact: isCompact,
                        // aria-expanded and aria-controls here are placeholders only. This is to avoid a11y violations.
                        // This component JQLEditorReadOnlyWithoutTheme is only a loading state
                        // Therefore the autocomplete combobox is never shown to the users
                        "aria-expanded": false,
                        "aria-controls": "dummy-jql-editor-auto-complete-id",
                        "aria-label": "JQL query",
                        children: blocks.map((block, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                                as: "p",
                                children: block
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hglfE.EditorControls), {
                        isSearch: isSearch,
                        isCompact: isCompact,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9cvBI.ReadOnlyControlsContent), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hglfE.EditorFooter), {})
        ]
    });
};
const $5a95c3cf9c4bf51a$export$96157d0351f40cdc = ({ isSearch: isSearch, isCompact: isCompact, ...props })=>{
    const editorTheme = (0, $aG17i.useEditorTheme)({
        isSearch: isSearch,
        isCompact: isCompact
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG17i.EditorThemeContext).Provider, {
        value: editorTheme,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($5a95c3cf9c4bf51a$var$JQLEditorReadOnlyWithoutTheme, {
            ...props
        })
    });
};
var $5a95c3cf9c4bf51a$export$2e2bcd8739ae039 = $5a95c3cf9c4bf51a$var$JQLEditorLayout;

});
parcelRegister("aG17i", function(module, exports) {

$parcel$export(module.exports, "EditorThemeContext", () => $a759f8abca3c2c49$export$fc25b324c910bbf4);
$parcel$export(module.exports, "useEditorTheme", () => $a759f8abca3c2c49$export$c119185e316114b3);
$parcel$export(module.exports, "useEditorThemeContext", () => $a759f8abca3c2c49$export$cf804716df5ed454);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
const $a759f8abca3c2c49$var$defaultMaxRows = 3;
const $a759f8abca3c2c49$var$expandedRows = 15;
const $a759f8abca3c2c49$var$defaultEditorTheme = {
    defaultMaxRows: $a759f8abca3c2c49$var$defaultMaxRows,
    expanded: false,
    expandedRows: $a759f8abca3c2c49$var$expandedRows,
    toggleExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    isSearch: false,
    isCompact: false
};
const $a759f8abca3c2c49$export$fc25b324c910bbf4 = (0, $eJOHy.createContext)($a759f8abca3c2c49$var$defaultEditorTheme);
const $a759f8abca3c2c49$export$c119185e316114b3 = ({ isSearch: isSearch = false, isCompact: isCompact = false })=>{
    const [expanded, setExpanded] = (0, $eJOHy.useState)(false);
    const toggleExpanded = (0, $eJOHy.useCallback)(()=>setExpanded((prevState)=>!prevState), []);
    return (0, $eJOHy.useMemo)(()=>({
            defaultMaxRows: $a759f8abca3c2c49$var$defaultMaxRows,
            expanded: expanded,
            expandedRows: $a759f8abca3c2c49$var$expandedRows,
            toggleExpanded: toggleExpanded,
            isSearch: isSearch,
            isCompact: isCompact
        }), [
        expanded,
        toggleExpanded,
        isSearch,
        isCompact
    ]);
};
const $a759f8abca3c2c49$export$cf804716df5ed454 = ()=>(0, $eJOHy.useContext)($a759f8abca3c2c49$export$fc25b324c910bbf4);

});

parcelRegister("4uGwj", function(module, exports) {

$parcel$export(module.exports, "splitTextByNewLine", () => $a27172450cf7b948$export$ccd327fb940bd525);
/**
 * Splits the provided text by new line characters.
 */ const $a27172450cf7b948$export$ccd327fb940bd525 = (text)=>text.split(/(?:\r\n?|\n)/);

});

parcelRegister("9cvBI", function(module, exports) {

$parcel$export(module.exports, "ReadOnlyControlsContent", () => $0351bfa3e59ad523$export$26cf64f30d6cc7f3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $aG17i = parcelRequire("aG17i");

var $gd8zT = parcelRequire("gd8zT");

var $2i85u = parcelRequire("2i85u");

var $1RTev = parcelRequire("1RTev");
const $0351bfa3e59ad523$export$26cf64f30d6cc7f3 = ()=>{
    const { isSearch: isSearch } = (0, $aG17i.useEditorThemeContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gd8zT.BaseExpandToggle), {
                // The label here is for avoiding a11y violations only
                // This component ReadOnlyControlsContent is only used as a fallback for a loading state
                label: 'Editor',
                editorId: '',
                expanded: false,
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                isDisabled: true
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1RTev.BaseSyntaxHelp), {
                label: '',
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                isDisabled: true
            }),
            isSearch && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2i85u.BaseSearch), {
                // The label here is for avoiding a11y violations only
                // This component ReadOnlyControlsContent is only used as a fallback for a loading state
                label: 'Search',
                onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                isDisabled: true
            })
        ]
    });
};

});
parcelRegister("gd8zT", function(module, exports) {

$parcel$export(module.exports, "BaseExpandToggle", () => $bf688885e47be6b6$export$651ea466a727285d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $4BzUI = parcelRequire("4BzUI");

var $kZmGG = parcelRequire("kZmGG");

var $5Bhea = parcelRequire("5Bhea");

var $i6eQX = parcelRequire("i6eQX");

var $gV7Yu = parcelRequire("gV7Yu");

var $8XtVW = parcelRequire("8XtVW");


var $8JeHL = parcelRequire("8JeHL");
// Atlaskit doesn't provide a circle variation of the expand/collapse icons so we have to implement our own
const $bf688885e47be6b6$var$ExpandCircleIcon = ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kZmGG))), {
        label: '',
        LEGACY_size: 'small',
        color: isDisabled ? `var(--ds-icon-disabled, ${0, $135dba7912433cc2$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $135dba7912433cc2$export$c39c0fe0f26207ae})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($i6eQX)))
    });
const $bf688885e47be6b6$var$CollapseCircleIcon = ({ isDisabled: isDisabled })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Bhea))), {
        label: '',
        LEGACY_size: 'small',
        color: isDisabled ? `var(--ds-icon-disabled, ${0, $135dba7912433cc2$export$8754fc7e6d8b3000})` : `var(--ds-icon, ${0, $135dba7912433cc2$export$c39c0fe0f26207ae})`,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gV7Yu)))
    });
const $bf688885e47be6b6$export$651ea466a727285d = ({ expanded: expanded, editorId: editorId, isDisabled: isDisabled, label: label, onClick: onClick })=>{
    let Icon;
    if (expanded) Icon = $bf688885e47be6b6$var$CollapseCircleIcon;
    else Icon = $bf688885e47be6b6$var$ExpandCircleIcon;
    return (0, $8XtVW.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
        appearance: 'subtle',
        spacing: "compact",
        "aria-expanded": expanded,
        "aria-controls": editorId,
        label: label,
        isDisabled: isDisabled,
        onClick: onClick,
        icon: expanded ? (0, (/*@__PURE__*/$parcel$interopDefault($5Bhea))) : (0, (/*@__PURE__*/$parcel$interopDefault($kZmGG)))
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8JeHL.ExpandToggleContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKpTa.default), {
            appearance: 'subtle',
            "aria-expanded": expanded,
            "aria-controls": editorId,
            "aria-label": label,
            isDisabled: isDisabled,
            spacing: 'none',
            onClick: onClick,
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                isDisabled: isDisabled
            })
        })
    });
};

});
parcelRegister("kZmGG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f47b1a631f24d3d9$var$_react = $f47b1a631f24d3d9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f47b1a631f24d3d9$var$_baseNew = $f47b1a631f24d3d9$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $f47b1a631f24d3d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f47b1a631f24d3d9$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $f47b1a631f24d3d9$var$_react.default.createElement($f47b1a631f24d3d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$f47b1a631f24d3d9$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $f47b1a631f24d3d9$var$_default = module.exports.default = $f47b1a631f24d3d9$var$GrowDiagonalIcon;

});

parcelRegister("5Bhea", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $413dc579ed4890ee$var$_react = $413dc579ed4890ee$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $413dc579ed4890ee$var$_baseNew = $413dc579ed4890ee$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $413dc579ed4890ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $413dc579ed4890ee$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $413dc579ed4890ee$var$_react.default.createElement($413dc579ed4890ee$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$413dc579ed4890ee$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $413dc579ed4890ee$var$_default = module.exports.default = $413dc579ed4890ee$var$ShrinkDiagonalIcon;

});

parcelRegister("i6eQX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2d44f08d83e9658$var$_react = $d2d44f08d83e9658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $d2d44f08d83e9658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d2d44f08d83e9658$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $d2d44f08d83e9658$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props));
$d2d44f08d83e9658$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $d2d44f08d83e9658$var$_default = module.exports.default = $d2d44f08d83e9658$var$MediaServicesActualSizeIcon;

});

parcelRegister("gV7Yu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c51827d31ffdd698$var$_react = $c51827d31ffdd698$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $c51827d31ffdd698$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c51827d31ffdd698$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $c51827d31ffdd698$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
    }, props));
$c51827d31ffdd698$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $c51827d31ffdd698$var$_default = module.exports.default = $c51827d31ffdd698$var$MediaServicesFitToPageIcon;

});

var $135dba7912433cc2$exports = {};

$parcel$export($135dba7912433cc2$exports, "R50", () => $135dba7912433cc2$export$4b84fd0e2c617bd);
$parcel$export($135dba7912433cc2$exports, "R75", () => $135dba7912433cc2$export$b34b069eff244586);
$parcel$export($135dba7912433cc2$exports, "R100", () => $135dba7912433cc2$export$be802dd0d8b57f35);
$parcel$export($135dba7912433cc2$exports, "R200", () => $135dba7912433cc2$export$60847d42f9da92a6);
$parcel$export($135dba7912433cc2$exports, "R300", () => $135dba7912433cc2$export$4a7404f376229999);
$parcel$export($135dba7912433cc2$exports, "R400", () => $135dba7912433cc2$export$2010d0fb4295b346);
$parcel$export($135dba7912433cc2$exports, "R500", () => $135dba7912433cc2$export$2837b5a1a71d5c02);
$parcel$export($135dba7912433cc2$exports, "Y50", () => $135dba7912433cc2$export$8d9596b529bbb9cf);
$parcel$export($135dba7912433cc2$exports, "Y75", () => $135dba7912433cc2$export$41060a744ab0b7ae);
$parcel$export($135dba7912433cc2$exports, "Y100", () => $135dba7912433cc2$export$1cc05bbbf340e559);
$parcel$export($135dba7912433cc2$exports, "Y200", () => $135dba7912433cc2$export$5aae31392d72caaa);
$parcel$export($135dba7912433cc2$exports, "Y300", () => $135dba7912433cc2$export$c6930421db9fa514);
$parcel$export($135dba7912433cc2$exports, "Y400", () => $135dba7912433cc2$export$59619663aa6500fb);
$parcel$export($135dba7912433cc2$exports, "Y500", () => $135dba7912433cc2$export$874739ea9e379ab6);
$parcel$export($135dba7912433cc2$exports, "G50", () => $135dba7912433cc2$export$8a6341c32b6a3ee6);
$parcel$export($135dba7912433cc2$exports, "G75", () => $135dba7912433cc2$export$69a3bf21b9686c2b);
$parcel$export($135dba7912433cc2$exports, "G100", () => $135dba7912433cc2$export$afbce1382ec95f73);
$parcel$export($135dba7912433cc2$exports, "G200", () => $135dba7912433cc2$export$747d86715d4175de);
$parcel$export($135dba7912433cc2$exports, "G300", () => $135dba7912433cc2$export$940e1f69e873f202);
$parcel$export($135dba7912433cc2$exports, "G400", () => $135dba7912433cc2$export$a49394138f7b8e85);
$parcel$export($135dba7912433cc2$exports, "G500", () => $135dba7912433cc2$export$6fa04827ac68a4fb);
$parcel$export($135dba7912433cc2$exports, "B50", () => $135dba7912433cc2$export$226de0355ed012f8);
$parcel$export($135dba7912433cc2$exports, "B75", () => $135dba7912433cc2$export$8c13c2ee36917869);
$parcel$export($135dba7912433cc2$exports, "B100", () => $135dba7912433cc2$export$ecfc1dff386a3e7a);
$parcel$export($135dba7912433cc2$exports, "B200", () => $135dba7912433cc2$export$215b7063051591f1);
$parcel$export($135dba7912433cc2$exports, "B300", () => $135dba7912433cc2$export$e62e8919cca44969);
$parcel$export($135dba7912433cc2$exports, "B400", () => $135dba7912433cc2$export$b3de0ae08da2ce64);
$parcel$export($135dba7912433cc2$exports, "B500", () => $135dba7912433cc2$export$a6ee3d71bc067634);
$parcel$export($135dba7912433cc2$exports, "B600", () => $135dba7912433cc2$export$67f15409e87642a1);
$parcel$export($135dba7912433cc2$exports, "B700", () => $135dba7912433cc2$export$f0539dbc42dbb067);
$parcel$export($135dba7912433cc2$exports, "P50", () => $135dba7912433cc2$export$363e4475840015bb);
$parcel$export($135dba7912433cc2$exports, "P75", () => $135dba7912433cc2$export$4b0a4417ed59760f);
$parcel$export($135dba7912433cc2$exports, "P100", () => $135dba7912433cc2$export$6011520a64d9a187);
$parcel$export($135dba7912433cc2$exports, "P200", () => $135dba7912433cc2$export$a7175d4e9206bc80);
$parcel$export($135dba7912433cc2$exports, "P300", () => $135dba7912433cc2$export$b48405b95304b5a1);
$parcel$export($135dba7912433cc2$exports, "P400", () => $135dba7912433cc2$export$c71e4279dd54a18d);
$parcel$export($135dba7912433cc2$exports, "P500", () => $135dba7912433cc2$export$147899de772240ec);
$parcel$export($135dba7912433cc2$exports, "T50", () => $135dba7912433cc2$export$2cf711fe14c66f06);
$parcel$export($135dba7912433cc2$exports, "T75", () => $135dba7912433cc2$export$7a8f4d33f6f9772c);
$parcel$export($135dba7912433cc2$exports, "T100", () => $135dba7912433cc2$export$776c9c497ef08533);
$parcel$export($135dba7912433cc2$exports, "T200", () => $135dba7912433cc2$export$69cb3ca10c1e330e);
$parcel$export($135dba7912433cc2$exports, "T300", () => $135dba7912433cc2$export$9dc1ef0f3f48059b);
$parcel$export($135dba7912433cc2$exports, "T400", () => $135dba7912433cc2$export$7c835c78b6fcdef8);
$parcel$export($135dba7912433cc2$exports, "T500", () => $135dba7912433cc2$export$6036577f95c3877e);
$parcel$export($135dba7912433cc2$exports, "N0", () => $135dba7912433cc2$export$29a4f05edc054374);
$parcel$export($135dba7912433cc2$exports, "N10", () => $135dba7912433cc2$export$e655ef011c4aa1a2);
$parcel$export($135dba7912433cc2$exports, "N20", () => $135dba7912433cc2$export$9fdfb749e33cdf97);
$parcel$export($135dba7912433cc2$exports, "N30", () => $135dba7912433cc2$export$3e51e8f1440314ba);
$parcel$export($135dba7912433cc2$exports, "N40", () => $135dba7912433cc2$export$1ce2d1575d444ceb);
$parcel$export($135dba7912433cc2$exports, "N50", () => $135dba7912433cc2$export$8754fc7e6d8b3000);
$parcel$export($135dba7912433cc2$exports, "N60", () => $135dba7912433cc2$export$c2e91cbeada39b8b);
$parcel$export($135dba7912433cc2$exports, "N70", () => $135dba7912433cc2$export$5f71e19f3a7ad9de);
$parcel$export($135dba7912433cc2$exports, "N80", () => $135dba7912433cc2$export$eaa8c8a70ac22806);
$parcel$export($135dba7912433cc2$exports, "N90", () => $135dba7912433cc2$export$7c87d337fb91a97d);
$parcel$export($135dba7912433cc2$exports, "N100", () => $135dba7912433cc2$export$d6447c357493214f);
$parcel$export($135dba7912433cc2$exports, "N200", () => $135dba7912433cc2$export$f563ee71e9ee74cd);
$parcel$export($135dba7912433cc2$exports, "N300", () => $135dba7912433cc2$export$e2ef2124cf4024b1);
$parcel$export($135dba7912433cc2$exports, "N400", () => $135dba7912433cc2$export$eece5f492e429f08);
$parcel$export($135dba7912433cc2$exports, "N500", () => $135dba7912433cc2$export$c39c0fe0f26207ae);
$parcel$export($135dba7912433cc2$exports, "N600", () => $135dba7912433cc2$export$7090862dc3038a9f);
$parcel$export($135dba7912433cc2$exports, "N700", () => $135dba7912433cc2$export$ad0bacf983b7ddaa);
$parcel$export($135dba7912433cc2$exports, "N800", () => $135dba7912433cc2$export$7d61b15e0da132af);
$parcel$export($135dba7912433cc2$exports, "N900", () => $135dba7912433cc2$export$fbda843f0a27fe96);
$parcel$export($135dba7912433cc2$exports, "N10A", () => $135dba7912433cc2$export$791e57b27ca738ef);
$parcel$export($135dba7912433cc2$exports, "N20A", () => $135dba7912433cc2$export$8d43898f60b96a82);
$parcel$export($135dba7912433cc2$exports, "N30A", () => $135dba7912433cc2$export$920c0d5c49070351);
$parcel$export($135dba7912433cc2$exports, "N40A", () => $135dba7912433cc2$export$46987b49aab6d1a8);
$parcel$export($135dba7912433cc2$exports, "N50A", () => $135dba7912433cc2$export$7d3359664e8bb0e5);
$parcel$export($135dba7912433cc2$exports, "N60A", () => $135dba7912433cc2$export$d2d3bedfb276cac0);
$parcel$export($135dba7912433cc2$exports, "N70A", () => $135dba7912433cc2$export$6e5e7499ff054f6d);
$parcel$export($135dba7912433cc2$exports, "N80A", () => $135dba7912433cc2$export$59264b346c877fa7);
$parcel$export($135dba7912433cc2$exports, "N90A", () => $135dba7912433cc2$export$d092757d7c64925c);
$parcel$export($135dba7912433cc2$exports, "N100A", () => $135dba7912433cc2$export$486ab785e4bac3c6);
$parcel$export($135dba7912433cc2$exports, "N200A", () => $135dba7912433cc2$export$fba592bbc6419fea);
$parcel$export($135dba7912433cc2$exports, "N300A", () => $135dba7912433cc2$export$13609db0e6812ab8);
$parcel$export($135dba7912433cc2$exports, "N400A", () => $135dba7912433cc2$export$fbae4efaa892d883);
$parcel$export($135dba7912433cc2$exports, "N500A", () => $135dba7912433cc2$export$f13946d26f440ce6);
$parcel$export($135dba7912433cc2$exports, "N600A", () => $135dba7912433cc2$export$19f58225ac52a306);
$parcel$export($135dba7912433cc2$exports, "N700A", () => $135dba7912433cc2$export$6384f09da70e7b62);
$parcel$export($135dba7912433cc2$exports, "N800A", () => $135dba7912433cc2$export$d0dccc730683edc2);
$parcel$export($135dba7912433cc2$exports, "DN900", () => $135dba7912433cc2$export$2f6319cf7d736c2a);
$parcel$export($135dba7912433cc2$exports, "DN800", () => $135dba7912433cc2$export$95126bc8884d6634);
$parcel$export($135dba7912433cc2$exports, "DN700", () => $135dba7912433cc2$export$8338d8c35d44ff1);
$parcel$export($135dba7912433cc2$exports, "DN600", () => $135dba7912433cc2$export$5368d76ae4fbbda7);
$parcel$export($135dba7912433cc2$exports, "DN500", () => $135dba7912433cc2$export$9f0a771d16ec8d36);
$parcel$export($135dba7912433cc2$exports, "DN400", () => $135dba7912433cc2$export$abcf8c38338b4aa5);
$parcel$export($135dba7912433cc2$exports, "DN300", () => $135dba7912433cc2$export$97e81faa16a182c7);
$parcel$export($135dba7912433cc2$exports, "DN200", () => $135dba7912433cc2$export$bfe21c59123ecf33);
$parcel$export($135dba7912433cc2$exports, "DN100", () => $135dba7912433cc2$export$ee82aa2ea6a1558);
$parcel$export($135dba7912433cc2$exports, "DN90", () => $135dba7912433cc2$export$682927c6ed76be02);
$parcel$export($135dba7912433cc2$exports, "DN80", () => $135dba7912433cc2$export$91fd9994c5be9757);
$parcel$export($135dba7912433cc2$exports, "DN70", () => $135dba7912433cc2$export$d281fbfe3cff2df6);
$parcel$export($135dba7912433cc2$exports, "DN60", () => $135dba7912433cc2$export$3902c91d8b98a753);
$parcel$export($135dba7912433cc2$exports, "DN50", () => $135dba7912433cc2$export$8e8133c1ba5845b5);
$parcel$export($135dba7912433cc2$exports, "DN40", () => $135dba7912433cc2$export$33ff357f6620b39);
$parcel$export($135dba7912433cc2$exports, "DN30", () => $135dba7912433cc2$export$633847cf062b69e0);
$parcel$export($135dba7912433cc2$exports, "DN20", () => $135dba7912433cc2$export$9776a6e503bdbf76);
$parcel$export($135dba7912433cc2$exports, "DN10", () => $135dba7912433cc2$export$6c813d5160dff5db);
$parcel$export($135dba7912433cc2$exports, "DN0", () => $135dba7912433cc2$export$3d4f271a500072a);
$parcel$export($135dba7912433cc2$exports, "DN800A", () => $135dba7912433cc2$export$fe151285c22759ec);
$parcel$export($135dba7912433cc2$exports, "DN700A", () => $135dba7912433cc2$export$a101c6190d0da34);
$parcel$export($135dba7912433cc2$exports, "DN600A", () => $135dba7912433cc2$export$4b16f52932fda51);
$parcel$export($135dba7912433cc2$exports, "DN500A", () => $135dba7912433cc2$export$a74bcd7b9845b0d8);
$parcel$export($135dba7912433cc2$exports, "DN400A", () => $135dba7912433cc2$export$9209c179316d1751);
$parcel$export($135dba7912433cc2$exports, "DN300A", () => $135dba7912433cc2$export$88f55133f636c8dd);
$parcel$export($135dba7912433cc2$exports, "DN200A", () => $135dba7912433cc2$export$51126f85d1009512);
$parcel$export($135dba7912433cc2$exports, "DN100A", () => $135dba7912433cc2$export$a069b547bd23af78);
$parcel$export($135dba7912433cc2$exports, "DN90A", () => $135dba7912433cc2$export$40cce05af3b2600a);
$parcel$export($135dba7912433cc2$exports, "DN80A", () => $135dba7912433cc2$export$b78942185925a0d);
$parcel$export($135dba7912433cc2$exports, "DN70A", () => $135dba7912433cc2$export$e058fb44b8eaafca);
$parcel$export($135dba7912433cc2$exports, "DN60A", () => $135dba7912433cc2$export$92b0b8de26920c18);
$parcel$export($135dba7912433cc2$exports, "DN50A", () => $135dba7912433cc2$export$67564f7459d3fc9e);
$parcel$export($135dba7912433cc2$exports, "DN40A", () => $135dba7912433cc2$export$77868e1ca884ffa3);
$parcel$export($135dba7912433cc2$exports, "DN30A", () => $135dba7912433cc2$export$2afd71d7d3ea2cd5);
$parcel$export($135dba7912433cc2$exports, "DN20A", () => $135dba7912433cc2$export$f2a0acaab9972c70);
$parcel$export($135dba7912433cc2$exports, "DN10A", () => $135dba7912433cc2$export$9ab70e67d6475361);
$parcel$export($135dba7912433cc2$exports, "T30", () => $135dba7912433cc2$export$d2adc5dedf09fced);
$parcel$export($135dba7912433cc2$exports, "L50", () => $135dba7912433cc2$export$f51762073d2bb381);
$parcel$export($135dba7912433cc2$exports, "L75", () => $135dba7912433cc2$export$95e26d54def96891);
// Reds
const $135dba7912433cc2$export$4b84fd0e2c617bd = '#FFEBE6';
const $135dba7912433cc2$export$b34b069eff244586 = '#FFBDAD';
const $135dba7912433cc2$export$be802dd0d8b57f35 = '#FF8F73';
const $135dba7912433cc2$export$60847d42f9da92a6 = '#FF7452';
const $135dba7912433cc2$export$4a7404f376229999 = '#FF5630';
const $135dba7912433cc2$export$2010d0fb4295b346 = '#DE350B';
const $135dba7912433cc2$export$2837b5a1a71d5c02 = '#BF2600';
const $135dba7912433cc2$export$8d9596b529bbb9cf = '#FFFAE6';
const $135dba7912433cc2$export$41060a744ab0b7ae = '#FFF0B3';
const $135dba7912433cc2$export$1cc05bbbf340e559 = '#FFE380';
const $135dba7912433cc2$export$5aae31392d72caaa = '#FFC400';
const $135dba7912433cc2$export$c6930421db9fa514 = '#FFAB00';
const $135dba7912433cc2$export$59619663aa6500fb = '#FF991F';
const $135dba7912433cc2$export$874739ea9e379ab6 = '#FF8B00';
const $135dba7912433cc2$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $135dba7912433cc2$export$69a3bf21b9686c2b = '#ABF5D1';
const $135dba7912433cc2$export$afbce1382ec95f73 = '#79F2C0';
const $135dba7912433cc2$export$747d86715d4175de = '#57D9A3';
const $135dba7912433cc2$export$940e1f69e873f202 = '#36B37E';
const $135dba7912433cc2$export$a49394138f7b8e85 = '#00875A';
const $135dba7912433cc2$export$6fa04827ac68a4fb = '#006644';
const $135dba7912433cc2$export$226de0355ed012f8 = '#DEEBFF';
const $135dba7912433cc2$export$8c13c2ee36917869 = '#B3D4FF';
const $135dba7912433cc2$export$ecfc1dff386a3e7a = '#4C9AFF';
const $135dba7912433cc2$export$215b7063051591f1 = '#2684FF';
const $135dba7912433cc2$export$e62e8919cca44969 = '#0065FF';
const $135dba7912433cc2$export$b3de0ae08da2ce64 = '#0052CC';
const $135dba7912433cc2$export$a6ee3d71bc067634 = '#0747A6';
const $135dba7912433cc2$export$67f15409e87642a1 = '#669DF1';
const $135dba7912433cc2$export$f0539dbc42dbb067 = '#8FB8F6';
const $135dba7912433cc2$export$363e4475840015bb = '#EAE6FF';
const $135dba7912433cc2$export$4b0a4417ed59760f = '#C0B6F2';
const $135dba7912433cc2$export$6011520a64d9a187 = '#998DD9';
const $135dba7912433cc2$export$a7175d4e9206bc80 = '#8777D9';
const $135dba7912433cc2$export$b48405b95304b5a1 = '#6554C0';
const $135dba7912433cc2$export$c71e4279dd54a18d = '#5243AA';
const $135dba7912433cc2$export$147899de772240ec = '#403294';
const $135dba7912433cc2$export$2cf711fe14c66f06 = '#E6FCFF';
const $135dba7912433cc2$export$7a8f4d33f6f9772c = '#B3F5FF';
const $135dba7912433cc2$export$776c9c497ef08533 = '#79E2F2';
const $135dba7912433cc2$export$69cb3ca10c1e330e = '#00C7E6';
const $135dba7912433cc2$export$9dc1ef0f3f48059b = '#00B8D9';
const $135dba7912433cc2$export$7c835c78b6fcdef8 = '#00A3BF';
const $135dba7912433cc2$export$6036577f95c3877e = '#008DA6';
const $135dba7912433cc2$export$29a4f05edc054374 = '#FFFFFF';
const $135dba7912433cc2$export$e655ef011c4aa1a2 = '#FAFBFC';
const $135dba7912433cc2$export$9fdfb749e33cdf97 = '#F4F5F7';
const $135dba7912433cc2$export$3e51e8f1440314ba = '#EBECF0';
const $135dba7912433cc2$export$1ce2d1575d444ceb = '#DFE1E6';
const $135dba7912433cc2$export$8754fc7e6d8b3000 = '#C1C7D0';
const $135dba7912433cc2$export$c2e91cbeada39b8b = '#B3BAC5';
const $135dba7912433cc2$export$5f71e19f3a7ad9de = '#A5ADBA';
const $135dba7912433cc2$export$eaa8c8a70ac22806 = '#97A0AF';
const $135dba7912433cc2$export$7c87d337fb91a97d = '#8993A4';
const $135dba7912433cc2$export$d6447c357493214f = '#7A869A';
const $135dba7912433cc2$export$f563ee71e9ee74cd = '#6B778C';
const $135dba7912433cc2$export$e2ef2124cf4024b1 = '#5E6C84';
const $135dba7912433cc2$export$eece5f492e429f08 = '#505F79';
const $135dba7912433cc2$export$c39c0fe0f26207ae = '#42526E';
const $135dba7912433cc2$export$7090862dc3038a9f = '#344563';
const $135dba7912433cc2$export$ad0bacf983b7ddaa = '#253858';
const $135dba7912433cc2$export$7d61b15e0da132af = '#172B4D';
const $135dba7912433cc2$export$fbda843f0a27fe96 = '#091E42';
const $135dba7912433cc2$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $135dba7912433cc2$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $135dba7912433cc2$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $135dba7912433cc2$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $135dba7912433cc2$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $135dba7912433cc2$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $135dba7912433cc2$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $135dba7912433cc2$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $135dba7912433cc2$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $135dba7912433cc2$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $135dba7912433cc2$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $135dba7912433cc2$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $135dba7912433cc2$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $135dba7912433cc2$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $135dba7912433cc2$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $135dba7912433cc2$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $135dba7912433cc2$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $135dba7912433cc2$export$2f6319cf7d736c2a = '#E6EDFA';
const $135dba7912433cc2$export$95126bc8884d6634 = '#DCE5F5';
const $135dba7912433cc2$export$8338d8c35d44ff1 = '#CED9EB';
const $135dba7912433cc2$export$5368d76ae4fbbda7 = '#B8C7E0';
const $135dba7912433cc2$export$9f0a771d16ec8d36 = '#ABBBD6';
const $135dba7912433cc2$export$abcf8c38338b4aa5 = '#9FB0CC';
const $135dba7912433cc2$export$97e81faa16a182c7 = '#8C9CB8';
const $135dba7912433cc2$export$bfe21c59123ecf33 = '#7988A3';
const $135dba7912433cc2$export$ee82aa2ea6a1558 = '#67758F';
const $135dba7912433cc2$export$682927c6ed76be02 = '#56637A';
const $135dba7912433cc2$export$91fd9994c5be9757 = '#455166';
const $135dba7912433cc2$export$d281fbfe3cff2df6 = '#3B475C';
const $135dba7912433cc2$export$3902c91d8b98a753 = '#313D52';
const $135dba7912433cc2$export$8e8133c1ba5845b5 = '#283447';
const $135dba7912433cc2$export$33ff357f6620b39 = '#202B3D';
const $135dba7912433cc2$export$633847cf062b69e0 = '#1B2638';
const $135dba7912433cc2$export$9776a6e503bdbf76 = '#121A29';
const $135dba7912433cc2$export$6c813d5160dff5db = '#0E1624';
const $135dba7912433cc2$export$3d4f271a500072a = '#0D1424';
const $135dba7912433cc2$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $135dba7912433cc2$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $135dba7912433cc2$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $135dba7912433cc2$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $135dba7912433cc2$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $135dba7912433cc2$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $135dba7912433cc2$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $135dba7912433cc2$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $135dba7912433cc2$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $135dba7912433cc2$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $135dba7912433cc2$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $135dba7912433cc2$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $135dba7912433cc2$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $135dba7912433cc2$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $135dba7912433cc2$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $135dba7912433cc2$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $135dba7912433cc2$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $135dba7912433cc2$export$d2adc5dedf09fced = '#292A2E';
const $135dba7912433cc2$export$f51762073d2bb381 = '#94C748';
const $135dba7912433cc2$export$95e26d54def96891 = '#B3DF72';

parcelRegister("8JeHL", function(module, exports) {

$parcel$export(module.exports, "ExpandToggleContainer", () => $923cf13362705f91$export$e6d67f4f78864edc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $923cf13362705f91$export$e6d67f4f78864edc = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1cnrddf0"
})({
    /* Override background styles for our button to match designs */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> button': {
        borderRadius: '100%',
        /* Fill the remaining vertical space for a single line in our editor and space between buttons */ margin: `${"var(--ds-space-050, 4px)"} 0`,
        '&:hover': {
            background: `var(--ds-background-neutral-subtle-hovered, ${(0, $135dba7912433cc2$export$1ce2d1575d444ceb)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:active, &[data-firefox-is-active='true']": {
            background: `var(--ds-background-neutral-subtle-pressed, ${(0, $135dba7912433cc2$export$8754fc7e6d8b3000)})`
        }
    }
});

});


parcelRegister("2i85u", function(module, exports) {

$parcel$export(module.exports, "BaseSearch", () => $8dff2cb175036264$export$c3a2772f8bfd85f4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $OgPfS = parcelRequire("OgPfS");

var $4BzUI = parcelRequire("4BzUI");

var $hJ5hq = parcelRequire("hJ5hq");

var $8XtVW = parcelRequire("8XtVW");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");
const $8dff2cb175036264$var$style = {
    // Fixes an issue where loading button makes the editor flicker with a scrollbar
    overflow: 'hidden'
};
// Fixes icon margin issus after new icon migration
const $8dff2cb175036264$var$iconStyle = (0, $5Wv5g.xcss)({
    margin: 'space.050',
    display: 'flex'
});
// Fixes an issue where loading button makes the editor flicker with a scrollbar
const $8dff2cb175036264$var$buttonContainerStyle = (0, $5Wv5g.xcss)({
    overflow: 'hidden'
});
const $8dff2cb175036264$export$c3a2772f8bfd85f4 = ({ isDisabled: isDisabled, isSearching: isSearching, label: label, onSearch: onSearch })=>{
    // Prevent click events being repeatedly fired if the Enter key is held down.
    const preventRepeatClick = (0, $eJOHy.useCallback)((e)=>{
        if (e.key === 'Enter' && e.repeat) e.preventDefault();
    }, []);
    return (0, $8XtVW.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
            xcss: $8dff2cb175036264$var$buttonContainerStyle,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                label: label,
                isDisabled: isDisabled,
                testId: "jql-editor-search",
                appearance: "default",
                spacing: "compact",
                onClick: onSearch,
                onKeyDown: preventRepeatClick,
                isLoading: isSearching,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hJ5hq))),
                ...(0, $8XtVW.fg)('add_nin_press_interactions') && {
                    interactionName: 'jql-editor-base-search-button'
                }
            })
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $OgPfS.default), {
            "aria-label": label,
            isDisabled: isDisabled,
            testId: "jql-editor-search",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $8dff2cb175036264$var$style,
            appearance: 'primary',
            spacing: 'none',
            onClick: onSearch,
            onKeyDown: preventRepeatClick,
            isLoading: isSearching,
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                xcss: $8dff2cb175036264$var$iconStyle,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hJ5hq))), {
                    color: "currentColor",
                    label: '',
                    LEGACY_size: 'medium',
                    LEGACY_margin: "-4px"
                })
            }),
            ...(0, $8XtVW.fg)('add_nin_press_interactions') && {
                interactionName: 'jql-editor-base-search-button'
            }
        })
    });
};

});

parcelRegister("1RTev", function(module, exports) {

$parcel$export(module.exports, "BaseSyntaxHelp", () => $8d1d3dd98d299bad$export$7267128805e130a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $i0PfN = parcelRequire("i0PfN");

var $lKcSF = parcelRequire("lKcSF");

var $25iSs = parcelRequire("25iSs");

var $8XtVW = parcelRequire("8XtVW");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");


var $3u9wO = parcelRequire("3u9wO");
// Fixes icon margin issus after new icon migration
const $8d1d3dd98d299bad$var$iconStyle = (0, $5Wv5g.xcss)({
    margin: 'space.025',
    display: 'inline-flex'
});
const $8d1d3dd98d299bad$export$7267128805e130a = ({ describedby: describedby, isDisabled: isDisabled, label: label, onClick: onClick })=>{
    return (0, $8XtVW.fg)('platform-component-visual-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i0PfN.default), {
        "aria-describedby": describedby,
        label: label,
        isDisabled: isDisabled,
        appearance: "subtle",
        spacing: "compact",
        onClick: onClick,
        target: "blank",
        href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lKcSF))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)"
            })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u9wO.SyntaxHelpContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKpTa.default), {
            "aria-describedby": describedby,
            "aria-label": label,
            isDisabled: isDisabled,
            appearance: 'subtle',
            spacing: 'none',
            target: 'blank',
            href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                xcss: $8d1d3dd98d299bad$var$iconStyle,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lKcSF))), {
                    label: '',
                    color: isDisabled ? `var(--ds-icon-disabled, ${0, $135dba7912433cc2$export$29a4f05edc054374})` : `var(--ds-icon-inverse, ${0, $135dba7912433cc2$export$29a4f05edc054374})`,
                    LEGACY_size: 'small',
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($25iSs))),
                    LEGACY_margin: "-2px"
                })
            }),
            onClick: onClick
        })
    });
};

});
parcelRegister("25iSs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $184ab10867eca165$var$_react = $184ab10867eca165$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $184ab10867eca165$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $184ab10867eca165$var$QuestionIcon = (props)=>/*#__PURE__*/ $184ab10867eca165$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
    }, props));
$184ab10867eca165$var$QuestionIcon.displayName = 'QuestionIcon';
var $184ab10867eca165$var$_default = module.exports.default = $184ab10867eca165$var$QuestionIcon;

});

parcelRegister("3u9wO", function(module, exports) {

$parcel$export(module.exports, "SyntaxHelpContainer", () => $2eda78b18a24ae74$export$4e1b8f789d662a1c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $2eda78b18a24ae74$export$4e1b8f789d662a1c = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1rcevfp0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> a': {
        background: `var(--ds-background-neutral-bold, ${(0, $135dba7912433cc2$export$5f71e19f3a7ad9de)})`,
        borderRadius: '100%',
        margin: "var(--ds-space-050, 4px)",
        '&:hover': {
            background: `var(--ds-background-neutral-bold-hovered, ${(0, $135dba7912433cc2$export$c39c0fe0f26207ae)})`
        },
        '&:focus': {
            background: `var(--ds-background-neutral-bold, ${(0, $135dba7912433cc2$export$5f71e19f3a7ad9de)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&:active, &[data-firefox-is-active='true']": {
            background: `var(--ds-background-neutral-bold-pressed, ${(0, $135dba7912433cc2$export$7090862dc3038a9f)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[disabled]': {
            background: `var(--ds-background-disabled, ${(0, $135dba7912433cc2$export$8754fc7e6d8b3000)})`
        }
    }
});

});



parcelRegister("hglfE", function(module, exports) {

$parcel$export(module.exports, "EditorMain", () => $dc2ae63b4ed828f3$export$4a1fe064357e4803);
$parcel$export(module.exports, "EditorFooter", () => $dc2ae63b4ed828f3$export$6b199f86fb39c56e);
$parcel$export(module.exports, "EditorViewContainer", () => $dc2ae63b4ed828f3$export$e1a59ec983b6e626);
$parcel$export(module.exports, "ReadOnlyEditorViewContainer", () => $dc2ae63b4ed828f3$export$92dc95fac89d1410);
$parcel$export(module.exports, "LineNumberToolbar", () => $dc2ae63b4ed828f3$export$c7f458a6447d7077);
$parcel$export(module.exports, "EditorView", () => $dc2ae63b4ed828f3$export$eece2fccabbb77c5);
$parcel$export(module.exports, "ReadOnlyEditorView", () => $dc2ae63b4ed828f3$export$1eeaf339fa9196a5);
$parcel$export(module.exports, "EditorControls", () => $dc2ae63b4ed828f3$export$3ebfd5942f1290ac);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $408ts = parcelRequire("408ts");

var $1KLZ6 = parcelRequire("1KLZ6");

var $aWILV = parcelRequire("aWILV");
function $dc2ae63b4ed828f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dc2ae63b4ed828f3$var$fadeIn = (0, $1NIU8.keyframes)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $dc2ae63b4ed828f3$var$fadeOut = (0, $1NIU8.keyframes)({
    from: {
        visibility: 'visible',
        opacity: 1
    },
    to: {
        opacity: 0
    }
});
const $dc2ae63b4ed828f3$export$4a1fe064357e4803 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j67"
})("font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-size:14px;flex-grow:1;/* These styles and animations are derived from @atlaskit/tooltip */.", (0, $1KLZ6.TOOLTIP_CLASSNAME), "{background-color:", `var(--ds-background-neutral-bold, ${(0, $135dba7912433cc2$export$7d61b15e0da132af)})`, ";color:", `var(--ds-text-inverse, ${(0, $135dba7912433cc2$export$29a4f05edc054374)})`, ";border-radius:var(--ds-border-radius-100, 3px);box-sizing:border-box;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);line-height:1.3;max-width:240px;padding:var(--ds-space-025, 2px) var(--ds-space-075, 6px);word-wrap:break-word;overflow-wrap:break-word;z-index:", (0, $408ts.layers).tooltip(), ";pointer-events:none;position:absolute;visibility:hidden;transform:translate(-50%, calc(-100% - var(--ds-space-200, 16px)));&.", (0, $1KLZ6.TOOLTIP_ENTER_CLASSNAME), "{animation:", $dc2ae63b4ed828f3$var$fadeIn, " 350ms cubic-bezier(0.15, 1, 0.3, 1);visibility:visible;}&.", (0, $1KLZ6.TOOLTIP_EXIT_CLASSNAME), "{animation:", $dc2ae63b4ed828f3$var$fadeOut, " 350ms cubic-bezier(0.15, 1, 0.3, 1);}}");
const $dc2ae63b4ed828f3$export$6b199f86fb39c56e = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j66"
})({
    name: "y524xc",
    styles: "display:flex;justify-content:space-between;min-height:20px"
});
// Height (in px) for a single row in the editor
const $dc2ae63b4ed828f3$var$rowHeight = 22;
// Vertical padding for the editor input
const $dc2ae63b4ed828f3$var$getEditorInputVerticalPadding = (isCompact)=>isCompact ? 3 : 7;
const $dc2ae63b4ed828f3$var$editorInputHorizontalPadding = 6;
const $dc2ae63b4ed828f3$export$e1a59ec983b6e626 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j65"
})({
    backgroundColor: `var(--ds-background-input, ${(0, $135dba7912433cc2$export$e655ef011c4aa1a2)})`,
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    borderColor: `var(--ds-border-input, ${(0, $135dba7912433cc2$export$d6447c357493214f)})`,
    borderRadius: "var(--ds-border-radius-100, 3px)",
    padding: "var(--ds-border-width, 1px)",
    boxSizing: 'border-box',
    color: `var(--ds-text, ${(0, $135dba7912433cc2$export$fbda843f0a27fe96)})`,
    display: 'flex',
    overflow: 'auto',
    transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.editorViewIsInvalid && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)({
        borderColor: `var(--ds-border-danger, ${(0, $135dba7912433cc2$export$2010d0fb4295b346)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${(0, $135dba7912433cc2$export$2010d0fb4295b346)})`}`
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.editorViewHasFocus ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)({
        backgroundColor: `var(--ds-surface, ${(0, $135dba7912433cc2$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-border-focused, ${(0, $135dba7912433cc2$export$215b7063051591f1)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $135dba7912433cc2$export$215b7063051591f1)})`}`
    }) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $1NIU8.css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-input-hovered, ${(0, $135dba7912433cc2$export$3e51e8f1440314ba)})`
        }
    }));
const $dc2ae63b4ed828f3$export$92dc95fac89d1410 = /*#__PURE__*/ (0, $aWILV.default)($dc2ae63b4ed828f3$export$e1a59ec983b6e626, {
    target: "ezls2j64"
})({
    backgroundColor: `var(--ds-background-disabled, ${(0, $135dba7912433cc2$export$3e51e8f1440314ba)})`,
    color: `var(--ds-text-disabled, ${(0, $135dba7912433cc2$export$d6447c357493214f)})`,
    pointerEvents: 'none'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $dc2ae63b4ed828f3$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
const $dc2ae63b4ed828f3$export$c7f458a6447d7077 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j63"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $135dba7912433cc2$export$3e51e8f1440314ba)})`,
    flexShrink: 0,
    width: '30px',
    position: 'sticky',
    top: 0
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>!props.lineNumbersVisible && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $dc2ae63b4ed828f3$var$_ref2);
/**
 * The main div which the Prosemirror editor will be rendered into.
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $dc2ae63b4ed828f3$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
const $dc2ae63b4ed828f3$export$eece2fccabbb77c5 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j62"
})("counter-reset:lineNumber;flex-grow:1;transition:height 250ms cubic-bezier(0.15, 1, 0.3, 1),max-height 250ms cubic-bezier(0.15, 1, 0.3, 1);max-height:", (props)=>$dc2ae63b4ed828f3$var$rowHeight * props.defaultMaxRows + $dc2ae63b4ed828f3$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;line-height:", $dc2ae63b4ed828f3$var$rowHeight / 14, ";font-family:var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace);word-break:break-word;overflow-wrap:anywhere;white-space:pre-wrap;&[data-expanded]{height:", (props)=>$dc2ae63b4ed828f3$var$rowHeight * props.expandedRows + $dc2ae63b4ed828f3$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;max-height:", (props)=>$dc2ae63b4ed828f3$var$rowHeight * props.expandedRows + $dc2ae63b4ed828f3$var$getEditorInputVerticalPadding(props.isCompact) * 2, "px;}.ProseMirror{color:", `var(--ds-text, ${(0, $135dba7912433cc2$export$ad0bacf983b7ddaa)})`, ";padding:", (props)=>$dc2ae63b4ed828f3$var$getEditorInputVerticalPadding(props.isCompact), "px ", $dc2ae63b4ed828f3$var$editorInputHorizontalPadding, "px;&:focus{outline:none;}.mark-token-keyword{color:", `var(--ds-text-accent-purple, ${(0, $135dba7912433cc2$export$c71e4279dd54a18d)})`, ";}.mark-token-field{color:", `var(--ds-text-accent-blue, ${(0, $135dba7912433cc2$export$e62e8919cca44969)})`, ";}.mark-token-operator{color:", `var(--ds-text-accent-green, ${(0, $135dba7912433cc2$export$6fa04827ac68a4fb)})`, ";}.mark-token-error{color:", `var(--ds-text-danger, ${(0, $135dba7912433cc2$export$2010d0fb4295b346)})`, ";text-decoration:wavy underline;text-decoration-thickness:1px;text-decoration-skip-ink:none;}}p{margin:0;counter-increment:lineNumber;position:relative;&::before{content:counter(lineNumber);color:", `var(--ds-text-subtlest, ${(0, $135dba7912433cc2$export$d6447c357493214f)})`, ";font-size:10px;line-height:", $dc2ae63b4ed828f3$var$rowHeight / 10, ";padding:0 var(--ds-space-100, 8px) 0 var(--ds-space-025, 2px);position:absolute;box-sizing:border-box;transform:translateX(calc(-100% - var(--ds-space-100, 8px)));max-width:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;", (props)=>!props.lineNumbersVisible && // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    $dc2ae63b4ed828f3$var$_ref, ";}}");
const $dc2ae63b4ed828f3$export$1eeaf339fa9196a5 = /*#__PURE__*/ (0, $aWILV.default)($dc2ae63b4ed828f3$export$eece2fccabbb77c5, {
    target: "ezls2j61"
})("padding:", (props)=>$dc2ae63b4ed828f3$var$getEditorInputVerticalPadding(props.isCompact), "px ", $dc2ae63b4ed828f3$var$editorInputHorizontalPadding, "px;max-height:", (props)=>$dc2ae63b4ed828f3$var$rowHeight * props.defaultMaxRows, "px;>p{min-height:", $dc2ae63b4ed828f3$var$rowHeight, "px;}");
const $dc2ae63b4ed828f3$export$3ebfd5942f1290ac = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "ezls2j60"
})((props)=>({
        alignItems: 'center',
        display: 'flex',
        flexShrink: 0,
        marginLeft: 'auto',
        marginRight: `${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.isSearch ? $dc2ae63b4ed828f3$var$getEditorInputVerticalPadding(props.isCompact) - 1 // the search button needs the same vertical & horizontal spacing
         : $dc2ae63b4ed828f3$var$editorInputHorizontalPadding - 3}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'normal',
        position: 'sticky',
        top: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$dc2ae63b4ed828f3$var$rowHeight + 2 * $dc2ae63b4ed828f3$var$getEditorInputVerticalPadding(props.isCompact)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: props.isVisualRefresh ? "var(--ds-space-025, 2px)" : 'unset'
    }));

});
parcelRegister("1KLZ6", function(module, exports) {

$parcel$export(module.exports, "JQLValidationTooltipPluginKey", () => $d2229650cb6d7c76$export$9c08c6e09c037890);
$parcel$export(module.exports, "TOOLTIP_CLASSNAME", () => $d2229650cb6d7c76$export$a6e3ebd2348b0a1);
$parcel$export(module.exports, "TOOLTIP_ENTER_CLASSNAME", () => $d2229650cb6d7c76$export$c58b4cecb88a4d51);
$parcel$export(module.exports, "TOOLTIP_EXIT_CLASSNAME", () => $d2229650cb6d7c76$export$22dac80660f4fba2);

var $3lIcL = parcelRequire("3lIcL");
const $d2229650cb6d7c76$export$9c08c6e09c037890 = new (0, $3lIcL.PluginKey)('jql-validation-tooltip-plugin');
const $d2229650cb6d7c76$export$a6e3ebd2348b0a1 = 'jql-validation-tooltip';
const $d2229650cb6d7c76$export$c58b4cecb88a4d51 = 'jql-validation-tooltip-enter';
const $d2229650cb6d7c76$export$22dac80660f4fba2 = 'jql-validation-tooltip-exit';

});
parcelRegister("3lIcL", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $27059f7464a1d1f5$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $27059f7464a1d1f5$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $27059f7464a1d1f5$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $27059f7464a1d1f5$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $27059f7464a1d1f5$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $27059f7464a1d1f5$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $27059f7464a1d1f5$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $27059f7464a1d1f5$export$1692d8b0e89cecc3);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $27059f7464a1d1f5$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $27059f7464a1d1f5$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $3xw6l.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $3xw6l.Slice).empty : content);
            if (i == 0) $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $27059f7464a1d1f5$export$c2b25f346d19bcbb($pos) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, 0, 0, 1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $27059f7464a1d1f5$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $27059f7464a1d1f5$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $27059f7464a1d1f5$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $27059f7464a1d1f5$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $27059f7464a1d1f5$var$warnedAboutTextSelection = false;
function $27059f7464a1d1f5$var$checkTextSelection($pos) {
    if (!$27059f7464a1d1f5$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $27059f7464a1d1f5$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $27059f7464a1d1f5$export$c2b25f346d19bcbb extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $27059f7464a1d1f5$var$checkTextSelection($anchor);
        $27059f7464a1d1f5$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $27059f7464a1d1f5$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $3xw6l.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $27059f7464a1d1f5$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("text", $27059f7464a1d1f5$export$c2b25f346d19bcbb);
class $27059f7464a1d1f5$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $27059f7464a1d1f5$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $27059f7464a1d1f5$export$e2940151ac854c0b extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
        return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$27059f7464a1d1f5$export$e2940151ac854c0b.prototype.visible = false;
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("node", $27059f7464a1d1f5$export$e2940151ac854c0b);
class $27059f7464a1d1f5$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $27059f7464a1d1f5$var$TextBookmark(pos, pos) : new $27059f7464a1d1f5$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(node)) return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
        return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $27059f7464a1d1f5$export$c15d9ba76bdbcd95 extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        if (content == (0, $3xw6l.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $27059f7464a1d1f5$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $27059f7464a1d1f5$var$AllBookmark;
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("all", $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
const $27059f7464a1d1f5$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $27059f7464a1d1f5$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $27059f7464a1d1f5$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $27059f7464a1d1f5$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(child)) return $27059f7464a1d1f5$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $27059f7464a1d1f5$var$UPDATED_SEL = 1, $27059f7464a1d1f5$var$UPDATED_MARKS = 2, $27059f7464a1d1f5$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $27059f7464a1d1f5$export$febc5573c75cefb0 extends (0, $lzEKq.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $27059f7464a1d1f5$var$UPDATED_SEL) & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $27059f7464a1d1f5$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $3xw6l.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $3xw6l.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $27059f7464a1d1f5$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SCROLL) > 0;
    }
}
function $27059f7464a1d1f5$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $27059f7464a1d1f5$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $27059f7464a1d1f5$var$bind(desc.init, self);
        this.apply = $27059f7464a1d1f5$var$bind(desc.apply, self);
    }
}
const $27059f7464a1d1f5$var$baseFields = [
    new $27059f7464a1d1f5$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $27059f7464a1d1f5$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $27059f7464a1d1f5$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $27059f7464a1d1f5$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $27059f7464a1d1f5$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $27059f7464a1d1f5$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $27059f7464a1d1f5$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $27059f7464a1d1f5$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $27059f7464a1d1f5$var$Configuration(config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $3xw6l.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $27059f7464a1d1f5$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $27059f7464a1d1f5$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $27059f7464a1d1f5$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $27059f7464a1d1f5$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $27059f7464a1d1f5$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $27059f7464a1d1f5$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $27059f7464a1d1f5$var$keys = Object.create(null);
function $27059f7464a1d1f5$var$createKey(name) {
    if (name in $27059f7464a1d1f5$var$keys) return name + "$" + ++$27059f7464a1d1f5$var$keys[name];
    $27059f7464a1d1f5$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $27059f7464a1d1f5$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $27059f7464a1d1f5$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("3xw6l", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $293d5acde922b5fe$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $293d5acde922b5fe$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $293d5acde922b5fe$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $293d5acde922b5fe$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $293d5acde922b5fe$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $293d5acde922b5fe$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $293d5acde922b5fe$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $293d5acde922b5fe$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $293d5acde922b5fe$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $293d5acde922b5fe$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $293d5acde922b5fe$export$3476b78f8f5a8b72);

var $b22x6 = parcelRequire("b22x6");
function $293d5acde922b5fe$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $293d5acde922b5fe$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $293d5acde922b5fe$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $293d5acde922b5fe$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $293d5acde922b5fe$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $293d5acde922b5fe$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $293d5acde922b5fe$var$retIndex(0, pos);
        if (pos == this.size) return $293d5acde922b5fe$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $293d5acde922b5fe$var$retIndex(i + 1, end);
                return $293d5acde922b5fe$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $293d5acde922b5fe$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (nodes instanceof $293d5acde922b5fe$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $293d5acde922b5fe$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $293d5acde922b5fe$export$ffb0004e005737fa.empty = new $293d5acde922b5fe$export$ffb0004e005737fa([], 0);
const $293d5acde922b5fe$var$found = {
    index: 0,
    offset: 0
};
function $293d5acde922b5fe$var$retIndex(index, offset) {
    $293d5acde922b5fe$var$found.index = index;
    $293d5acde922b5fe$var$found.offset = offset;
    return $293d5acde922b5fe$var$found;
}
function $293d5acde922b5fe$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$293d5acde922b5fe$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$293d5acde922b5fe$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $293d5acde922b5fe$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $293d5acde922b5fe$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        if (marks instanceof $293d5acde922b5fe$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $293d5acde922b5fe$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $293d5acde922b5fe$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $293d5acde922b5fe$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $293d5acde922b5fe$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty = new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.empty, 0, 0);
function $293d5acde922b5fe$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($293d5acde922b5fe$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $293d5acde922b5fe$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $293d5acde922b5fe$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $293d5acde922b5fe$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inconsistent open depths");
    return $293d5acde922b5fe$var$replaceOuter($from, $to, slice, 0);
}
function $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $293d5acde922b5fe$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $293d5acde922b5fe$var$prepareSliceForReplace(slice, $from);
        return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $293d5acde922b5fe$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $293d5acde922b5fe$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $293d5acde922b5fe$var$checkJoin(node, $after.node(depth));
    return node;
}
function $293d5acde922b5fe$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $293d5acde922b5fe$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $293d5acde922b5fe$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$293d5acde922b5fe$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $293d5acde922b5fe$var$addNode($end.nodeBefore, target);
}
function $293d5acde922b5fe$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $293d5acde922b5fe$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $293d5acde922b5fe$var$joinable($end, $to, depth + 1);
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $293d5acde922b5fe$var$checkJoin(openStart, openEnd);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceTwoWay($from, $start, depth + 1)), content);
        $293d5acde922b5fe$var$addRange($start, $end, depth, content);
        if (openEnd) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openEnd, $293d5acde922b5fe$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $293d5acde922b5fe$var$joinable($from, $to, depth + 1);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(type, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $293d5acde922b5fe$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $293d5acde922b5fe$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $293d5acde922b5fe$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $293d5acde922b5fe$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $293d5acde922b5fe$var$resolveCache.set(doc, cache = new $293d5acde922b5fe$var$ResolveCache);
        let result = cache.elts[cache.i] = $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $293d5acde922b5fe$var$resolveCacheSize;
        return result;
    }
}
class $293d5acde922b5fe$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $293d5acde922b5fe$var$resolveCacheSize = 12, $293d5acde922b5fe$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $293d5acde922b5fe$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $293d5acde922b5fe$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $293d5acde922b5fe$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $293d5acde922b5fe$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $293d5acde922b5fe$var$emptyAttrs) && $293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $293d5acde922b5fe$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $293d5acde922b5fe$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $293d5acde922b5fe$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $293d5acde922b5fe$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$293d5acde922b5fe$export$85c928794f8d04d4.prototype.text = undefined;
class $293d5acde922b5fe$var$TextNode extends $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $293d5acde922b5fe$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $293d5acde922b5fe$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $293d5acde922b5fe$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $293d5acde922b5fe$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $293d5acde922b5fe$export$364ed450558d7ec4.empty;
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $293d5acde922b5fe$var$dfa($293d5acde922b5fe$var$nfa(expr));
        $293d5acde922b5fe$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $293d5acde922b5fe$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $293d5acde922b5fe$export$364ed450558d7ec4.empty = new $293d5acde922b5fe$export$364ed450558d7ec4(true);
class $293d5acde922b5fe$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $293d5acde922b5fe$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSubscript(stream) {
    let expr = $293d5acde922b5fe$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $293d5acde922b5fe$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $293d5acde922b5fe$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $293d5acde922b5fe$var$parseExprRange(stream, expr) {
    let min = $293d5acde922b5fe$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $293d5acde922b5fe$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $293d5acde922b5fe$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $293d5acde922b5fe$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $293d5acde922b5fe$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $293d5acde922b5fe$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $293d5acde922b5fe$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $293d5acde922b5fe$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($293d5acde922b5fe$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $293d5acde922b5fe$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($293d5acde922b5fe$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $293d5acde922b5fe$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $293d5acde922b5fe$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($293d5acde922b5fe$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $293d5acde922b5fe$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $293d5acde922b5fe$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $293d5acde922b5fe$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $293d5acde922b5fe$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $293d5acde922b5fe$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $293d5acde922b5fe$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $293d5acde922b5fe$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $293d5acde922b5fe$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $293d5acde922b5fe$export$ffb0004e005737fa.from(content), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, attrs, content.append(after), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $293d5acde922b5fe$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $293d5acde922b5fe$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $293d5acde922b5fe$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $293d5acde922b5fe$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $293d5acde922b5fe$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $b22x6.default).from(spec.nodes), instanceSpec.marks = (0, $b22x6.default).from(spec.marks || {}), this.nodes = $293d5acde922b5fe$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $293d5acde922b5fe$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $293d5acde922b5fe$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $293d5acde922b5fe$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $293d5acde922b5fe$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $293d5acde922b5fe$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $293d5acde922b5fe$var$TextNode(type, type.defaultAttrs, text, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $293d5acde922b5fe$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $293d5acde922b5fe$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $293d5acde922b5fe$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $293d5acde922b5fe$var$isTagRule(rule) {
    return rule.tag != null;
}
function $293d5acde922b5fe$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $293d5acde922b5fe$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($293d5acde922b5fe$var$isTagRule(rule)) this.tags.push(rule);
            else if ($293d5acde922b5fe$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, false);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, true);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($293d5acde922b5fe$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $293d5acde922b5fe$export$1059c6e7d2ce5669(schema, $293d5acde922b5fe$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $293d5acde922b5fe$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $293d5acde922b5fe$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $293d5acde922b5fe$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $293d5acde922b5fe$var$OPT_PRESERVE_WS = 1, $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL = 2, $293d5acde922b5fe$var$OPT_OPEN_LEFT = 4;
function $293d5acde922b5fe$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $293d5acde922b5fe$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS | $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : base & ~$293d5acde922b5fe$var$OPT_OPEN_LEFT;
}
class $293d5acde922b5fe$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $293d5acde922b5fe$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$293d5acde922b5fe$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $293d5acde922b5fe$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $293d5acde922b5fe$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $293d5acde922b5fe$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $293d5acde922b5fe$var$NodeContext(topNode.type, topNode.attrs, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $293d5acde922b5fe$var$NodeContext(null, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $293d5acde922b5fe$var$NodeContext(parser.schema.topNodeType, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($293d5acde922b5fe$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $293d5acde922b5fe$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $293d5acde922b5fe$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($293d5acde922b5fe$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $293d5acde922b5fe$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $293d5acde922b5fe$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $293d5acde922b5fe$var$OPT_OPEN_LEFT;
        let applyMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $293d5acde922b5fe$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $293d5acde922b5fe$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $293d5acde922b5fe$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $293d5acde922b5fe$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $293d5acde922b5fe$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $293d5acde922b5fe$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $293d5acde922b5fe$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $293d5acde922b5fe$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $293d5acde922b5fe$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $293d5acde922b5fe$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $293d5acde922b5fe$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $293d5acde922b5fe$var$gatherToDOM(schema.marks);
    }
}
function $293d5acde922b5fe$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $293d5acde922b5fe$var$doc(options) {
    return options.document || window.document;
}
const $293d5acde922b5fe$var$suspiciousAttributeCache = new WeakMap();
function $293d5acde922b5fe$var$suspiciousAttributes(attrs) {
    let value = $293d5acde922b5fe$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $293d5acde922b5fe$var$suspiciousAttributeCache.set(attrs, value = $293d5acde922b5fe$var$suspiciousAttributesInner(attrs));
    return value;
}
function $293d5acde922b5fe$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $293d5acde922b5fe$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $293d5acde922b5fe$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("b22x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8081d8961ff8b83a$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $8081d8961ff8b83a$var$OrderedMap(content) {
    this.content = content;
}
$8081d8961ff8b83a$var$OrderedMap.prototype = {
    constructor: $8081d8961ff8b83a$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $8081d8961ff8b83a$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$8081d8961ff8b83a$var$OrderedMap.from = function(value) {
    if (value instanceof $8081d8961ff8b83a$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $8081d8961ff8b83a$var$OrderedMap(content);
};
var $8081d8961ff8b83a$export$2e2bcd8739ae039 = $8081d8961ff8b83a$var$OrderedMap;

});


parcelRegister("lzEKq", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $040d9edd1880ca83$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $040d9edd1880ca83$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $040d9edd1880ca83$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $040d9edd1880ca83$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $040d9edd1880ca83$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $040d9edd1880ca83$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $040d9edd1880ca83$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $040d9edd1880ca83$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $040d9edd1880ca83$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $040d9edd1880ca83$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $040d9edd1880ca83$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $040d9edd1880ca83$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $040d9edd1880ca83$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $040d9edd1880ca83$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $040d9edd1880ca83$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $040d9edd1880ca83$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $040d9edd1880ca83$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $040d9edd1880ca83$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $040d9edd1880ca83$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $040d9edd1880ca83$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $040d9edd1880ca83$export$563a914cafbdc389);

var $3xw6l = parcelRequire("3xw6l");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $040d9edd1880ca83$var$lower16 = 0xffff;
const $040d9edd1880ca83$var$factor16 = Math.pow(2, 16);
function $040d9edd1880ca83$var$makeRecover(index, offset) {
    return index + offset * $040d9edd1880ca83$var$factor16;
}
function $040d9edd1880ca83$var$recoverIndex(value) {
    return value & $040d9edd1880ca83$var$lower16;
}
function $040d9edd1880ca83$var$recoverOffset(value) {
    return (value - (value & $040d9edd1880ca83$var$lower16)) / $040d9edd1880ca83$var$factor16;
}
const $040d9edd1880ca83$var$DEL_BEFORE = 1, $040d9edd1880ca83$var$DEL_AFTER = 2, $040d9edd1880ca83$var$DEL_ACROSS = 4, $040d9edd1880ca83$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $040d9edd1880ca83$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_BEFORE | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_AFTER | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $040d9edd1880ca83$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $040d9edd1880ca83$export$c53d01c3ab9721b3.empty) return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $040d9edd1880ca83$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $040d9edd1880ca83$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $040d9edd1880ca83$var$DEL_AFTER : pos == end ? $040d9edd1880ca83$var$DEL_BEFORE : $040d9edd1880ca83$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $040d9edd1880ca83$var$DEL_SIDE;
                return new $040d9edd1880ca83$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $040d9edd1880ca83$export$c53d01c3ab9721b3.empty : new $040d9edd1880ca83$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $040d9edd1880ca83$export$c53d01c3ab9721b3.empty = new $040d9edd1880ca83$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $040d9edd1880ca83$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $040d9edd1880ca83$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $040d9edd1880ca83$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $040d9edd1880ca83$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $040d9edd1880ca83$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $040d9edd1880ca83$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $040d9edd1880ca83$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $3xw6l.ReplaceError)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $040d9edd1880ca83$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($040d9edd1880ca83$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $3xw6l.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $040d9edd1880ca83$export$d24ba56b0e3464a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addMark", $040d9edd1880ca83$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $040d9edd1880ca83$export$94150db1311f67a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeMark", $040d9edd1880ca83$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $040d9edd1880ca83$export$adefd16c402fee4e extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addNodeMark", $040d9edd1880ca83$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $040d9edd1880ca83$export$fdf7d1dc10724da2 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeNodeMark", $040d9edd1880ca83$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $040d9edd1880ca83$export$5c860b2e74034756 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $040d9edd1880ca83$var$contentBetween(doc, this.from, this.to)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $040d9edd1880ca83$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $040d9edd1880ca83$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $040d9edd1880ca83$export$5c860b2e74034756(json.from, json.to, (0, $3xw6l.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replace", $040d9edd1880ca83$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $040d9edd1880ca83$export$444ba800d6024a98 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($040d9edd1880ca83$var$contentBetween(doc, this.from, this.gapFrom) || $040d9edd1880ca83$var$contentBetween(doc, this.gapTo, this.to))) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $040d9edd1880ca83$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $040d9edd1880ca83$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $040d9edd1880ca83$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $3xw6l.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replaceAround", $040d9edd1880ca83$export$444ba800d6024a98);
function $040d9edd1880ca83$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $040d9edd1880ca83$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $040d9edd1880ca83$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $040d9edd1880ca83$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $040d9edd1880ca83$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $3xw6l.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $040d9edd1880ca83$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur, end, (0, $3xw6l.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $3xw6l.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $3xw6l.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $040d9edd1880ca83$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $040d9edd1880ca83$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$040d9edd1880ca83$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $040d9edd1880ca83$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $3xw6l.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $3xw6l.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $3xw6l.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $3xw6l.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $3xw6l.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $040d9edd1880ca83$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $040d9edd1880ca83$var$findWrappingOutside(range, nodeType);
    let inner = around && $040d9edd1880ca83$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($040d9edd1880ca83$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($040d9edd1880ca83$var$withAttrs));
}
function $040d9edd1880ca83$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $040d9edd1880ca83$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $040d9edd1880ca83$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $040d9edd1880ca83$var$wrap(tr, range, wrappers) {
    let content = (0, $3xw6l.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $3xw6l.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, start, end, new (0, $3xw6l.Slice)(content, 0, 0), wrappers.length, true));
}
function $040d9edd1880ca83$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $040d9edd1880ca83$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $040d9edd1880ca83$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $040d9edd1880ca83$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $040d9edd1880ca83$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $040d9edd1880ca83$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $040d9edd1880ca83$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $3xw6l.Fragment).empty, after = (0, $3xw6l.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $3xw6l.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $3xw6l.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(pos, pos, new (0, $3xw6l.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $040d9edd1880ca83$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $040d9edd1880ca83$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $040d9edd1880ca83$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $040d9edd1880ca83$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $040d9edd1880ca83$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $040d9edd1880ca83$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $040d9edd1880ca83$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $040d9edd1880ca83$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $3xw6l.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $040d9edd1880ca83$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $040d9edd1880ca83$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $040d9edd1880ca83$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $040d9edd1880ca83$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $3xw6l.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice);
    return new $040d9edd1880ca83$var$Fitter($from, $to, slice).fit();
}
function $040d9edd1880ca83$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $040d9edd1880ca83$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $3xw6l.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $3xw6l.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $3xw6l.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $040d9edd1880ca83$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $040d9edd1880ca83$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $040d9edd1880ca83$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $3xw6l.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $3xw6l.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($040d9edd1880ca83$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, frontierDepth, (0, $3xw6l.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$040d9edd1880ca83$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $040d9edd1880ca83$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $040d9edd1880ca83$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.depth, (0, $3xw6l.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $3xw6l.Fragment).empty, true);
        if (add.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $040d9edd1880ca83$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($040d9edd1880ca83$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $040d9edd1880ca83$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($040d9edd1880ca83$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $040d9edd1880ca83$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $040d9edd1880ca83$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $040d9edd1880ca83$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $040d9edd1880ca83$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$040d9edd1880ca83$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $040d9edd1880ca83$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $040d9edd1880ca83$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $040d9edd1880ca83$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $040d9edd1880ca83$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $040d9edd1880ca83$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $3xw6l.Slice)($040d9edd1880ca83$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $040d9edd1880ca83$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($040d9edd1880ca83$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return fragment;
}
function $040d9edd1880ca83$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $040d9edd1880ca83$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(node), 0, 0));
}
function $040d9edd1880ca83$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $040d9edd1880ca83$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $040d9edd1880ca83$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $040d9edd1880ca83$export$626399c38172f669 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $040d9edd1880ca83$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("attr", $040d9edd1880ca83$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $040d9edd1880ca83$export$f50707b396300ac9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $040d9edd1880ca83$export$f50707b396300ac9(json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("docAttr", $040d9edd1880ca83$export$f50707b396300ac9);
/**
@internal
*/ let $040d9edd1880ca83$export$88cc3a1dfce48dd3 = class extends Error {
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.constructor = $040d9edd1880ca83$export$88cc3a1dfce48dd3;
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $040d9edd1880ca83$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $040d9edd1880ca83$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $040d9edd1880ca83$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $3xw6l.Slice).empty) {
        let step = $040d9edd1880ca83$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $3xw6l.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $040d9edd1880ca83$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $040d9edd1880ca83$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $040d9edd1880ca83$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $040d9edd1880ca83$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $040d9edd1880ca83$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $040d9edd1880ca83$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $040d9edd1880ca83$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $040d9edd1880ca83$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $040d9edd1880ca83$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $040d9edd1880ca83$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $040d9edd1880ca83$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $3xw6l.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $040d9edd1880ca83$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $040d9edd1880ca83$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $040d9edd1880ca83$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $040d9edd1880ca83$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});





parcelRegister("hDiPV", function(module, exports) {

$parcel$export(module.exports, "preloadJQLEditor", () => $88d74f553798b247$export$d5d5e8328005e2ec);
$parcel$export(module.exports, "JQLEditorAsync", () => $88d74f553798b247$export$ecdc147409ce705b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
parcelRequire("bn7wb");
var $aAuez = parcelRequire("aAuez");
var $7qz8r = parcelRequire("7qz8r");

var $iMJ9G = parcelRequire("iMJ9G");

var $dAARv = parcelRequire("dAARv");

var $7tpWk = parcelRequire("7tpWk");

const $88d74f553798b247$var$JQLEditor = (0, $aAuez.lazyForPaint)(()=>(parcelRequire("3epos")).then(({ default: JQLEditorUI })=>JQLEditorUI), {
    ssr: false
});
const $88d74f553798b247$export$d5d5e8328005e2ec = ()=>$88d74f553798b247$var$JQLEditor.preload();
const $88d74f553798b247$export$ecdc147409ce705b = (0, $dAARv.withIntlProvider)((0, $iMJ9G.withErrorBoundary)((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qz8r.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7tpWk.JQLEditorReadOnly), {
            query: props.query,
            isSearch: !!props.onSearch,
            isCompact: props.isCompact
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($88d74f553798b247$var$JQLEditor, {
            ...props
        })
    });
}));

});
parcelRegister("bn7wb", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("aAuez")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("aAuez")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("aAuez")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $MkKnc = parcelRequire("MkKnc");

var $aAuez = parcelRequire("aAuez");
parcelRequire("4XKbm");
var $7eb8v = parcelRequire("7eb8v");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $7qz8r = parcelRequire("7qz8r");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");

var $hrq5I = parcelRequire("hrq5I");

});
parcelRegister("7veda", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $576673b9f1b70022$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $576673b9f1b70022$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("8V4xR")).MODE);

var $8V4xR = parcelRequire("8V4xR");
const $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN = undefined;
const $576673b9f1b70022$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $576673b9f1b70022$var$DEFAULT_MODE = (0, $8V4xR.MODE).HYDRATE;
const $576673b9f1b70022$var$DEFAULT_RETRY = 2;
const $576673b9f1b70022$var$config = {
    crossOrigin: $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN,
    manifest: $576673b9f1b70022$var$DEFAULT_MANIFEST,
    mode: $576673b9f1b70022$var$DEFAULT_MODE,
    retry: $576673b9f1b70022$var$DEFAULT_RETRY
};
const $576673b9f1b70022$export$44487a86467333c3 = ()=>$576673b9f1b70022$var$config;
const $576673b9f1b70022$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $576673b9f1b70022$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN;
    $576673b9f1b70022$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $576673b9f1b70022$var$DEFAULT_MANIFEST;
    $576673b9f1b70022$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $576673b9f1b70022$var$DEFAULT_MODE;
    $576673b9f1b70022$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $576673b9f1b70022$var$DEFAULT_RETRY;
};

});
parcelRegister("8V4xR", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $67e72c25add85f29$export$e48589d9e4824227);
const $67e72c25add85f29$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("MkKnc", function(module, exports) {

var $8h7zW = parcelRequire("8h7zW");

var $7veda = parcelRequire("7veda");
parcelRequire("1llka");
var $eGDOl = parcelRequire("eGDOl");
var $l7ep7 = parcelRequire("l7ep7");

var $a1Dox = parcelRequire("a1Dox");
const $091493b8f27d5831$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $7veda.setConfig)(config);
        (0, $eGDOl.LISTENERS).length = 0;
        (0, $l7ep7.setCurrent)(0);
        if (!(0, $a1Dox.isNodeEnvironment)()) (0, $8h7zW.collect)();
    }
};

});
parcelRegister("8h7zW", function(module, exports) {

$parcel$export(module.exports, "collect", () => $6065ca3c1e226813$export$bb44f104e3c54dae);

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");

var $9WyUY = parcelRequire("9WyUY");

var $1NKbK = parcelRequire("1NKbK");
const $6065ca3c1e226813$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $7veda.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $8V4xR.MODE).RENDER ? (0, $9WyUY.cloneElements)(markers[i], lazyBegin) : (0, $1NKbK.refElements)(markers[i], lazyBegin);
        if ((0, $bzDJE.COLLECTED).has(lazyBegin)) (0, $bzDJE.COLLECTED).get(lazyBegin).push(value);
        else (0, $bzDJE.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("bzDJE", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $86d1c92cf7d83ac0$export$4831ef3968ea94ef);
const $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $86d1c92cf7d83ac0$export$4831ef3968ea94ef = new Map();

});

parcelRegister("9WyUY", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $73d49dd0c38c2a1c$export$c42217d53a7ebafb);
const $73d49dd0c38c2a1c$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("1NKbK", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $14fe3218cc4e45c4$export$c69443129766a7fc);
const $14fe3218cc4e45c4$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1llka", function(module, exports) {

$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("l7ep7")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("l7ep7")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("eGDOl")).LISTENERS);

var $l7ep7 = parcelRequire("l7ep7");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");

});
parcelRegister("l7ep7", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $f5f56cc3db1024b3$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $f5f56cc3db1024b3$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $f5f56cc3db1024b3$export$1dc361b277327f88);

var $eJOHy = parcelRequire("eJOHy");

var $bzDJE = parcelRequire("bzDJE");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");
let $f5f56cc3db1024b3$var$CURRENT_PHASE = (0, $bzDJE.PHASE).PAINT;
const $f5f56cc3db1024b3$export$5f80f094fd31fffd = (phase)=>{
    $f5f56cc3db1024b3$var$CURRENT_PHASE = phase;
    (0, $eGDOl.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $f5f56cc3db1024b3$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: (0, $7Peej.createSubscribe)((0, $eGDOl.LISTENERS)),
    currentValue: ()=>$f5f56cc3db1024b3$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).PAINT)
    }
});
const $f5f56cc3db1024b3$export$1dc361b277327f88 = ()=>{
    const v = (0, $eJOHy.useContext)($f5f56cc3db1024b3$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("eGDOl", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $ab13de8c68717d57$export$81b9c458a026d68f);
const $ab13de8c68717d57$export$81b9c458a026d68f = [];

});

parcelRegister("7Peej", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $5b2855963721e7ea$export$364097d812234b3f);
const $5b2855963721e7ea$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("a1Dox", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $74c88e574846d6bd$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $74c88e574846d6bd$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $74c88e574846d6bd$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $74c88e574846d6bd$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("ed3y6")).default);

var $ed3y6 = parcelRequire("ed3y6");
const $74c88e574846d6bd$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $74c88e574846d6bd$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $74c88e574846d6bd$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $74c88e574846d6bd$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("ed3y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5850857827bd3c9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a5850857827bd3c9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("aAuez", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $7b54b80385d7fc57$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $7b54b80385d7fc57$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $7b54b80385d7fc57$export$488013bae63b21da);

var $j5vcn = parcelRequire("j5vcn");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");

var $a1Dox = parcelRequire("a1Dox");
var $ed3y6 = parcelRequire("ed3y6");

var $b8XF0 = parcelRequire("b8XF0");

var $jA7rF = parcelRequire("jA7rF");

var $c7s3I = parcelRequire("c7s3I");

var $iFrYh = parcelRequire("iFrYh");

var $dcrQD = parcelRequire("dcrQD");

var $dcUz2 = parcelRequire("dcUz2");

var $2f83m = parcelRequire("2f83m");
function $7b54b80385d7fc57$var$_extends() {
    $7b54b80385d7fc57$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b54b80385d7fc57$var$_extends.apply(this, arguments);
}
function $7b54b80385d7fc57$var$lazyProxy(_loader, { defer: defer = (0, $bzDJE.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $a1Dox.isNodeEnvironment)();
    const dataLazyId = (0, $ed3y6.default)(moduleId);
    const LazyInternal = isServer ? (0, $c7s3I.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $jA7rF.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $iFrYh.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $7veda.getConfig)();
                return (0, $dcUz2.retry)(_loader, {
                    delay: (0, $b8XF0.RETRY_DELAY),
                    factor: (0, $b8XF0.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $a1Dox.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $7veda.getConfig)();
        return (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $bzDJE.PHASE).PAINT ? (0, $b8XF0.PRIORITY).HIGH : (0, $b8XF0.PRIORITY).LOW;
        return (0, $dcrQD.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $7b54b80385d7fc57$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $bzDJE.PHASE).LAZY
    }
};
function $7b54b80385d7fc57$export$c952e5f94576010e(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $7b54b80385d7fc57$export$291dd592399bdafa(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $7b54b80385d7fc57$export$488013bae63b21da(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("j5vcn", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $de56af5358c8f987$export$303f43e55cf1ef2f);
const $de56af5358c8f987$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("b8XF0", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $81ceb864b052c80d$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $81ceb864b052c80d$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $81ceb864b052c80d$export$ba64c908e55507fe);
const $81ceb864b052c80d$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $81ceb864b052c80d$export$a339266ad71b2447 = 300;
const $81ceb864b052c80d$export$ba64c908e55507fe = 1;

});

parcelRegister("jA7rF", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $e417279bde8da3e7$export$6898b5504b58699a);

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $2f83m = parcelRequire("2f83m");

var $bVeRl = parcelRequire("bVeRl");

var $7fZLe = parcelRequire("7fZLe");

var $hrq5I = parcelRequire("hrq5I");

var $9qVNk = parcelRequire("9qVNk");
function $e417279bde8da3e7$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $eJOHy.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $2f83m.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $9qVNk.useSubscription)({
            context: (0, $esFTx.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $bzDJE.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $9qVNk.useSubscription)({
            context: (0, $l7ep7.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        (0, $eJOHy.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $bzDJE.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $7veda.getConfig)().mode === (0, $8V4xR.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bVeRl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fZLe.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("4XKbm", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => (parcelRequire("esFTx")).WaitContext);

var $esFTx = parcelRequire("esFTx");

var $7eb8v = parcelRequire("7eb8v");

});
parcelRegister("esFTx", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $a8742da03f685732$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");

var $ddxDA = parcelRequire("ddxDA");
const $a8742da03f685732$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: ()=>(0, $ddxDA.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("ddxDA", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $99f694f5596397af$export$276c7dbda7675aec);
const $99f694f5596397af$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("7eb8v", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $esFTx = parcelRequire("esFTx");
const $54327a9f9e29fe04$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const value = (0, $eJOHy.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const api = (0, $eJOHy.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $eJOHy.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esFTx.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("jv91R", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("4XL9N")).LazySuspenseContext);

var $7qz8r = parcelRequire("7qz8r");

var $4XL9N = parcelRequire("4XL9N");

});
parcelRegister("7qz8r", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $56863736a86894e9$export$256c542058532d6f);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");

var $4XL9N = parcelRequire("4XL9N");
class $56863736a86894e9$export$256c542058532d6f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $a1Dox.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("4XL9N", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $39d1408803878497$export$c33990e84065970c);

var $eJOHy = parcelRequire("eJOHy");
const $39d1408803878497$export$c33990e84065970c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("2f83m", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $1a233ab151dd1ee2$export$c73a6a6f0bf7d425);
const $1a233ab151dd1ee2$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $1a233ab151dd1ee2$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$1a233ab151dd1ee2$export$6aa69c1258005366]: true
    });
    return error;
};
const $1a233ab151dd1ee2$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($1a233ab151dd1ee2$export$6aa69c1258005366);

});

parcelRegister("bVeRl", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $8ae08b5f412b712d$export$d55db778a3e1446b);

var $eJOHy = parcelRequire("eJOHy");

var $hrq5I = parcelRequire("hrq5I");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");
function $8ae08b5f412b712d$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $8ae08b5f412b712d$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $eJOHy.useRef)(null);
    const { current: ssrDomNodes } = (0, $eJOHy.useRef)(content || []);
    const profilerContext = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
    const waitContext = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const suspenseContext = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
    (0, $eJOHy.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($8ae08b5f412b712d$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $8ae08b5f412b712d$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $8ae08b5f412b712d$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("hrq5I", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $cb29326da0127013$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $cb29326da0127013$export$8146ab57a3f7a7cb);

var $eJOHy = parcelRequire("eJOHy");
const $cb29326da0127013$export$e2d53c0cbedd2710 = {
    current: null
};
const $cb29326da0127013$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $eJOHy.createContext)($cb29326da0127013$export$e2d53c0cbedd2710);

});


parcelRegister("7fZLe", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $5489d785fce022f5$export$ca5b8fbc835d95e4);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");
function $5489d785fce022f5$var$_extends() {
    $5489d785fce022f5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5489d785fce022f5$var$_extends.apply(this, arguments);
}
const $5489d785fce022f5$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $a1Dox.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), $5489d785fce022f5$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("9qVNk", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $6de35f980c3d94e0$export$368b4214baeb914c);

var $eJOHy = parcelRequire("eJOHy");
function $6de35f980c3d94e0$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $eJOHy.useContext)(context);
    (0, $eJOHy.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("c7s3I", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $8d2be766ecc6ab62$export$eb2e4b04351cdd9e);

var $j5vcn = parcelRequire("j5vcn");

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $a1Dox = parcelRequire("a1Dox");

var $2f83m = parcelRequire("2f83m");
function $8d2be766ecc6ab62$var$load(moduleId, loader) {
    try {
        return (0, $a1Dox.getExport)(loader());
    } catch (err) {
        throw (0, $2f83m.createLoaderError)(err);
    }
}
function $8d2be766ecc6ab62$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $8d2be766ecc6ab62$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $7veda.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $bzDJE.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("link", {
                key: url,
                rel: defer === (0, $bzDJE.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("iFrYh", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $0381d5b0cf615548$export$e673efccd97e4223);
const $0381d5b0cf615548$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("dcrQD", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $99c1ff5e48fc9639$export$25bad4aa00c45355);

var $j5vcn = parcelRequire("j5vcn");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");

var $a1Dox = parcelRequire("a1Dox");

var $b8XF0 = parcelRequire("b8XF0");

var $dfXT0 = parcelRequire("dfXT0");

var $hrq5I = parcelRequire("hrq5I");
function $99c1ff5e48fc9639$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $7veda.getConfig)();
    const assets = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $dfXT0.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $99c1ff5e48fc9639$var$fakePromise = {
    then: ()=>$99c1ff5e48fc9639$var$fakePromise,
    catch: ()=>$99c1ff5e48fc9639$var$fakePromise,
    finally: ()=>$99c1ff5e48fc9639$var$fakePromise
};
function $99c1ff5e48fc9639$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $dfXT0.insertLinkTag)(href, rel));
        return $99c1ff5e48fc9639$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $99c1ff5e48fc9639$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $ddxDA.noopCleanup;
}
function $99c1ff5e48fc9639$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $a1Dox.isNodeEnvironment)()) return 0, $ddxDA.noopCleanup;
    (_GlobalReactLooselyLa = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $b8XF0.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $99c1ff5e48fc9639$export$3af04dbcb01bad4d,
        $99c1ff5e48fc9639$export$1046fd6a49d5e7a,
        $99c1ff5e48fc9639$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $ddxDA.noopCleanup;
}

});
parcelRegister("dfXT0", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $9a6b213a2be2821b$export$6610512821c8a4ce);

var $hrq5I = parcelRequire("hrq5I");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");
function $9a6b213a2be2821b$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $ddxDA.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $7veda.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("dcUz2", function(module, exports) {

$parcel$export(module.exports, "retry", () => $99d845ced60c5b28$export$9369b12211e1fce4);
const $99d845ced60c5b28$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $99d845ced60c5b28$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $99d845ced60c5b28$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $99d845ced60c5b28$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $99d845ced60c5b28$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $99d845ced60c5b28$var$calculateDelay(context, policy);
        if (delay) await $99d845ced60c5b28$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("iMJ9G", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $e9b5d6e185d03e1c$export$f0c7a449e0cfaec7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7tpWk = parcelRequire("7tpWk");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e9b5d6e185d03e1c$var$ErrorBoundary extends (0, $eJOHy.Component) {
    componentDidCatch(error) {
        this.setState({
            error: error
        });
        this.props.onError && this.props.onError(error);
    }
    render() {
        const { children: children, render: renderFallback } = this.props;
        const { error: error } = this.state;
        if (error === null) return children;
        return renderFallback({
            error: error
        });
    }
    constructor(...args){
        super(...args), this.state = {
            error: null
        };
    }
}
const $e9b5d6e185d03e1c$export$f0c7a449e0cfaec7 = (WrappedComponent)=>{
    return (props)=>{
        const { query: query, onRenderError: onRenderError, onSearch: onSearch, isCompact: isCompact } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($e9b5d6e185d03e1c$var$ErrorBoundary, {
            onError: onRenderError,
            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7tpWk.JQLEditorReadOnly), {
                    query: query,
                    isSearch: !!onSearch,
                    isCompact: isCompact
                }),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
};

});

parcelRegister("dAARv", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $d56ca8112f9a88f6$export$a5d940130f33be3f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
const $d56ca8112f9a88f6$export$a5d940130f33be3f = (WrappedComponent)=>{
    return (props)=>{
        const { locale: locale, ...rest } = props;
        if (locale) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: locale,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                ...rest
            })
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
            ...rest
        });
    };
};

});

parcelRegister("3epos", function(module, exports) {

let $25a6608712d1b78f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $25a6608712d1b78f$var$load("1VRB2"),
    $25a6608712d1b78f$var$load("bABhq"),
    $25a6608712d1b78f$var$load("5RYqM")
]).then(()=>parcelRequire('luuP8'));

});


parcelRegister("6MO8n", function(module, exports) {

$parcel$export(module.exports, "preloadJqlBuilderBasic", () => $4d51ebe33ebf7e5d$export$680bac3b2d4b8db0);
$parcel$export(module.exports, "JQLBuilderBasicOldAsync", () => $4d51ebe33ebf7e5d$export$50e4159fe4baf68e);
$parcel$export(module.exports, "default", () => $4d51ebe33ebf7e5d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $gzcjr = parcelRequire("gzcjr");

var $4GZBG = parcelRequire("4GZBG");



var $4GZBG = parcelRequire("4GZBG");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4d51ebe33ebf7e5d$var$AsyncJQLEditorUIOld = (0, $gzcjr.lazyForPaint)(()=>Promise.resolve((parcelRequire("lHTxM"))).then((module)=>module.JQLEditorUIWithErrorBoundaryOld), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4d51ebe33ebf7e5d$var$AsyncJQLEditorUI = (0, $gzcjr.lazyForPaint)(()=>Promise.resolve((parcelRequire("lHTxM"))), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx"
});
const $4d51ebe33ebf7e5d$export$680bac3b2d4b8db0 = ()=>$4d51ebe33ebf7e5d$var$AsyncJQLEditorUI.preload();
const $4d51ebe33ebf7e5d$export$50e4159fe4baf68e = (props)=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.JQLBuilderBasicUIWithAnalyticsOld), {
        ...props,
        JQLEditor: $4d51ebe33ebf7e5d$var$AsyncJQLEditorUIOld
    });
};
const $4d51ebe33ebf7e5d$var$JQLBuilderBasicAsync = (props)=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.default), {
        ...props,
        JQLEditor: $4d51ebe33ebf7e5d$var$AsyncJQLEditorUI
    });
};
var $4d51ebe33ebf7e5d$export$2e2bcd8739ae039 = $4d51ebe33ebf7e5d$var$JQLBuilderBasicAsync;

});
parcelRegister("4GZBG", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderBasicFallback", () => $5e1d54f8db67d585$export$c5a574f152d930c7);
$parcel$export(module.exports, "JQLBuilderBasicUIWithAnalyticsOld", () => $5e1d54f8db67d585$export$64a4e59c434c7d2d);
$parcel$export(module.exports, "default", () => $5e1d54f8db67d585$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $4xbv3 = parcelRequire("4xbv3");

var $lyPdT = parcelRequire("lyPdT");

var $fvO8D = parcelRequire("fvO8D");

var $elRNa = parcelRequire("elRNa");
const $5e1d54f8db67d585$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((onSearch, newJql)=>onSearch(newJql), 1000, {
    leading: false,
    trailing: true
});
const $5e1d54f8db67d585$var$JQLBuilderBasicUIOld = (props)=>{
    const { query: query, JQLEditor: JQLEditor, onSearch: triggerSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields, onReady: onReady, onLoad: onLoad, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, projectOptions: projectOptions, singleSelectFields: singleSelectFields, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker, contextJql: contextJql, viewContext: viewContext = null, scope: scope = null, suggestedUsersCount: suggestedUsersCount } = props;
    const [jql, setJql] = (0, $eJOHy.useState)(query);
    const onSearch = (0, $eJOHy.useCallback)((newJql)=>{
        setJql(newJql);
        triggerSearch && $5e1d54f8db67d585$var$debouncedSearch(triggerSearch, newJql);
    }, [
        triggerSearch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setJql(query);
    }, [
        query,
        setJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lyPdT.ASTContainer), {
        jql: jql,
        onSwitchToJql: onSwitchToJql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvO8D.SearchStateContainer), {
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JQLEditor, {
        NoOptionComponent: NoOptionComponent,
        query: jql,
        onSearch: onSearch,
        onSwitchToJql: onSwitchToJql,
        excludedFields: excludedFields,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        hydrationQueryRef: hydrationQueryRef,
        isHydrating: isHydrating,
        projectOptions: projectOptions,
        singleSelectFields: singleSelectFields,
        shouldUseListMarkup: shouldUseListMarkup,
        hideOperatorDropdown: hideOperatorDropdown,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope,
        suggestedUsersCount: suggestedUsersCount
    })));
};
const $5e1d54f8db67d585$var$JQLBuilderBasicUI = (props)=>{
    const { query: query, JQLEditor: JQLEditor, onSearch: triggerSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields, onReady: onReady, onLoad: onLoad, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, AddFilterButtonComponent: AddFilterButtonComponent, projectOptions: projectOptions, singleSelectFields: singleSelectFields, hydrationData: hydrationData, isHydrating: isHydrating, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker, contextJql: contextJql, viewContext: viewContext = null, scope: scope = null, suggestedUsersCount: suggestedUsersCount } = props;
    const [jql, setJql] = (0, $eJOHy.useState)(query);
    const onSearch = (0, $eJOHy.useCallback)((newJql)=>{
        setJql(newJql);
        triggerSearch && $5e1d54f8db67d585$var$debouncedSearch(triggerSearch, newJql);
    }, [
        triggerSearch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setJql(query);
    }, [
        query,
        setJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lyPdT.ASTContainer), {
        jql: jql,
        onSwitchToJql: onSwitchToJql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvO8D.SearchStateContainer), {
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JQLEditor, {
        NoOptionComponent: NoOptionComponent,
        AddFilterButtonComponent: AddFilterButtonComponent,
        query: jql,
        onSearch: onSearch,
        onSwitchToJql: onSwitchToJql,
        excludedFields: excludedFields,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        hydrationData: hydrationData,
        isHydrating: isHydrating,
        projectOptions: projectOptions,
        singleSelectFields: singleSelectFields,
        shouldUseListMarkup: shouldUseListMarkup,
        hideOperatorDropdown: hideOperatorDropdown,
        irremovableFields: irremovableFields,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope,
        suggestedUsersCount: suggestedUsersCount
    })));
};
const $5e1d54f8db67d585$export$c5a574f152d930c7 = ({ query: jql, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lyPdT.ASTContainer), {
        jql: jql
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvO8D.SearchStateContainer), {
        excludedFields: props.excludedFields,
        irremovableFields: props.irremovableFields
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $elRNa.default), props)));
const $5e1d54f8db67d585$export$64a4e59c434c7d2d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilderBasic",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e1d54f8db67d585$var$JQLBuilderBasicUIOld, props));
const $5e1d54f8db67d585$var$JQLBuilderBasicUIWithAnalytics = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilderBasic",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e1d54f8db67d585$var$JQLBuilderBasicUI, props));
var $5e1d54f8db67d585$export$2e2bcd8739ae039 = $5e1d54f8db67d585$var$JQLBuilderBasicUIWithAnalytics;

});
parcelRegister("lyPdT", function(module, exports) {

$parcel$export(module.exports, "ASTContainer", () => $062c5160a50f826b$export$9046b5020ab1c824);
$parcel$export(module.exports, "useAST", () => $062c5160a50f826b$export$2d94ebd7e6bbb03c);
$parcel$export(module.exports, "useClauseMap", () => $062c5160a50f826b$export$32019dca04f1bace);
$parcel$export(module.exports, "useTextSearchInputClause", () => $062c5160a50f826b$export$53c45c55dec81810);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $f1Zdy = parcelRequire("f1Zdy");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $beYGy = parcelRequire("beYGy");
const $062c5160a50f826b$var$actions = Object.freeze({});
const $062c5160a50f826b$var$ASTContainerInternal = (0, $6E16M.createContainer)();
const $062c5160a50f826b$var$store = (0, $GtRbT.createStore)({
    containedBy: $062c5160a50f826b$var$ASTContainerInternal,
    initialState: {
        ast: {
            query: undefined,
            represents: '',
            errors: []
        },
        clauseMap: {},
        textSearchInputClause: undefined
    },
    actions: $062c5160a50f826b$var$actions,
    name: 'JQLBasic-ASTService',
    handlers: {
        onInit: ()=>({ setState: setState }, props)=>{
                setState((0, $beYGy.getASTAndClausesFromJQL)(props));
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextProps, prevProps)) setState((0, $beYGy.getASTAndClausesFromJQL)(nextProps));
            }
    }
});
const $062c5160a50f826b$export$9046b5020ab1c824 = ({ jql: jql, children: children, onSwitchToJql: onSwitchToJql })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($062c5160a50f826b$var$ASTContainerInternal, {
        jql: jql,
        createAnalyticsEvent: createAnalyticsEvent,
        onSwitchToJql: onSwitchToJql
    }, children);
};
const $062c5160a50f826b$export$2d94ebd7e6bbb03c = (0, $iJq0l.createHook)($062c5160a50f826b$var$store, {
    selector: ({ ast: ast })=>ast
});
const $062c5160a50f826b$export$32019dca04f1bace = (0, $iJq0l.createHook)($062c5160a50f826b$var$store, {
    selector: ({ clauseMap: clauseMap })=>clauseMap
});
const $062c5160a50f826b$export$53c45c55dec81810 = (0, $iJq0l.createHook)($062c5160a50f826b$var$store, {
    selector: ({ textSearchInputClause: textSearchInputClause })=>textSearchInputClause
});

});
parcelRegister("beYGy", function(module, exports) {

$parcel$export(module.exports, "getASTAndClausesFromJQL", () => $14a4bd95a48ded6f$export$1029f331f2d8b0fd);

var $eM3Eu = parcelRequire("eM3Eu");

var $gYnSx = parcelRequire("gYnSx");

var $dTJxm = parcelRequire("dTJxm");

var $dHNhH = parcelRequire("dHNhH");

var $bgVBN = parcelRequire("bgVBN");
const $14a4bd95a48ded6f$export$1029f331f2d8b0fd = ({ jql: jql, createAnalyticsEvent: createAnalyticsEvent, onSwitchToJql: onSwitchToJql })=>{
    const ast = new (0, $eM3Eu.JastBuilder)().build(jql);
    let clauseMap = {};
    let textSearchInputClause;
    if (ast.query) try {
        ({ clauseMap: clauseMap, textSearchInputClause: textSearchInputClause } = new (0, $dHNhH.JqlClauseCollectingVisitor)(false).visit(ast.query));
    } catch (error) {
        if (error instanceof (0, $bgVBN.UnsupportedRefinementError)) {
            (0, $gYnSx.default)({
                event: createAnalyticsEvent({}),
                error: error,
                meta: {
                    id: 'queryTooComplexInBasicMode',
                    packageName: (0, $dTJxm.PACKAGE_NAME),
                    teamName: (0, $dTJxm.TEAM_NAME)
                },
                attributes: {
                    anonymizedJql: ast.query ? ast.query.accept((0, $dTJxm.jqlAnonymizerVisitor)) : undefined
                }
            });
            onSwitchToJql && onSwitchToJql();
        } else throw error;
    }
    return {
        ast: ast,
        clauseMap: clauseMap,
        textSearchInputClause: textSearchInputClause
    };
};

});


parcelRegister("fvO8D", function(module, exports) {

$parcel$export(module.exports, "SearchStateContainer", () => $419ccffd8ef074b5$export$f57da8b87ed90917);
$parcel$export(module.exports, "useSearchState", () => $419ccffd8ef074b5$export$5fd14fa624074d55);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $lyPdT = parcelRequire("lyPdT");

var $7xNb8 = parcelRequire("7xNb8");
const $419ccffd8ef074b5$var$actions = Object.freeze({});
const $419ccffd8ef074b5$var$SearchStateContainerInternal = (0, $6E16M.createContainer)();
const $419ccffd8ef074b5$var$store = (0, $GtRbT.createStore)({
    containedBy: $419ccffd8ef074b5$var$SearchStateContainerInternal,
    initialState: {
        astClauseOrder: [],
        clausesByFieldId: {},
        secondaryClausesByFieldId: {}
    },
    actions: $419ccffd8ef074b5$var$actions,
    name: 'JQLBasic-SearchStateService',
    handlers: {
        onInit: ()=>({ setState: setState }, props)=>{
                setState((0, $7xNb8.getClausesData)(props));
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextProps, prevProps)) setState((0, $7xNb8.getClausesData)(nextProps));
            }
    }
});
const $419ccffd8ef074b5$var$DEFAULT_EXCLUDED_FIELDS = [];
const $419ccffd8ef074b5$export$f57da8b87ed90917 = ({ excludedFields: excludedFields = $419ccffd8ef074b5$var$DEFAULT_EXCLUDED_FIELDS, irremovableFields: irremovableFields, children: children })=>{
    const [clauseMap] = (0, $lyPdT.useClauseMap)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($419ccffd8ef074b5$var$SearchStateContainerInternal, {
        clauseMap: clauseMap,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    }, children);
};
const $419ccffd8ef074b5$export$5fd14fa624074d55 = (0, $iJq0l.createHook)($419ccffd8ef074b5$var$store);

});
parcelRegister("7xNb8", function(module, exports) {

$parcel$export(module.exports, "getClausesData", () => $61abbd26a97ab4cd$export$27e1563385d8bc4e);
const $61abbd26a97ab4cd$export$27e1563385d8bc4e = ({ clauseMap: clauseMap, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const clausesByFieldId = {};
    const secondaryClausesByFieldId = {};
    const astClauseOrder = [];
    Object.keys(clauseMap).forEach((fieldId)=>{
        const fieldIsNotIrremovable = !irremovableFields.has(fieldId);
        const fieldIsNotYetIncluded = !astClauseOrder.includes(fieldId);
        const isNotExcludedField = !excludedFields.includes(fieldId);
        if (fieldIsNotIrremovable && fieldIsNotYetIncluded && isNotExcludedField) astClauseOrder.push(fieldId);
        if (isNotExcludedField) {
            const clauses = clauseMap[fieldId];
            clausesByFieldId[fieldId] = clauses && clauses[0] ? clauses[0] : undefined;
            secondaryClausesByFieldId[fieldId] = clauses && clauses[1] ? clauses[1] : undefined;
        }
    });
    return {
        astClauseOrder: astClauseOrder,
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId
    };
};

});


parcelRegister("elRNa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b19f8a4834a8bb56$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $co0wp = parcelRequire("co0wp");

var $lyPdT = parcelRequire("lyPdT");

var $fvO8D = parcelRequire("fvO8D");

var $hoXMy = parcelRequire("hoXMy");

var $idYtD = parcelRequire("idYtD");
const $b19f8a4834a8bb56$export$407dcaf889e68e30 = ({ onLoad: onLoad, excludedFields: excludedFields, shouldUseListMarkup: shouldUseListMarkup, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker })=>{
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $fvO8D.useSearchState)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onLoad && onLoad();
    }, [
        onLoad
    ]);
    const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $eJOHy.useMemo)(()=>(0, $hoXMy.gatherIrremovableFields)({
            excludedFields: excludedFields,
            intl: intl,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        }), [
        astClauseOrder,
        clausesByFieldId,
        excludedFields,
        intl,
        irremovableFields,
        secondaryClausesByFieldId
    ]);
    const orderByFieldCount = (0, $eJOHy.useMemo)(()=>showOrderByPicker ? (0, $idYtD.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $co0wp.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    });
};
var $b19f8a4834a8bb56$export$2e2bcd8739ae039 = $b19f8a4834a8bb56$export$407dcaf889e68e30;

});
parcelRegister("co0wp", function(module, exports) {

$parcel$export(module.exports, "JQLEditorLoading", () => $d41dad628cb17fdf$export$30c56a653ec47247);

var $eJOHy = parcelRequire("eJOHy");

var $h1VbR = parcelRequire("h1VbR");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $bmSiK = parcelRequire("bmSiK");

var $bNtSK = parcelRequire("bNtSK");

var $jx3Cw = parcelRequire("jx3Cw");

var $1gVNb = parcelRequire("1gVNb");

var $97Pzw = parcelRequire("97Pzw");

var $ivFNg = parcelRequire("ivFNg");
const $d41dad628cb17fdf$export$30c56a653ec47247 = ({ fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount, orderByFieldsCount: orderByFieldsCount, shouldUseListMarkup: shouldUseListMarkup, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker })=>{
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $1gVNb.StyledChild);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('add_nin_press_interactions') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h1VbR.default), {
        name: "jql-builder-basic-loading"
    }), !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, {
        key: (0, $dTJxm.getTextSearchInputField)(),
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "jql-builder-basic-refinement-fallback"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivFNg.TextSearchInputLoading), {
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>{
        const { clause: clause, picker: picker, fieldId: fieldId, fieldLabel: fieldLabel, isIrremovable: isIrremovable } = fieldToRender;
        if (!isIrremovable) // Optional fields are not rendered in the loading state, instead the number of
        // optional fields is displayed as a badge on the More Dropdown button.
        // Only irremovable field picker trigger is rendered in the loading state.
        return null;
        switch(picker.pickerType){
            case (0, $eqSys.PickerTypes).Picker:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, {
                    key: fieldId,
                    // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                    "data-testid": "jql-builder-basic-refinement-fallback"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jx3Cw.default), {
                    clause: clause,
                    fieldId: fieldId,
                    fieldDisplayName: fieldLabel,
                    fieldDescription: null,
                    isIrremovable: isIrremovable
                }));
            default:
                return null;
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bmSiK.default), {
        optionalFieldsCount: optionalFieldsCount
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $97Pzw.default), {
        orderByFieldsCount: orderByFieldsCount ?? 0
    })));
};

});
parcelRegister("bmSiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e4d9e52c21fde51$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $FO5HY = parcelRequire("FO5HY");

var $eE9zS = parcelRequire("eE9zS");

var $dKpTa = parcelRequire("dKpTa");

var $7qVFB = parcelRequire("7qVFB");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $izTXQ = parcelRequire("izTXQ");

var $fpIOP = parcelRequire("fpIOP");

var $kkE8T = parcelRequire("kkE8T");
const $7e4d9e52c21fde51$var$AddFilterFallback = ({ optionalFieldsCount: optionalFieldsCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const moreLabel = (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage((0, $izTXQ.default).moreButton) : formatMessage((0, $izTXQ.default).moreButtonOld);
    /**
   * We only show `More` button with loading state when there's more than 1
   * optional field with selected values underneath.
   * Otherwise we display the default `More` button
   */ if (optionalFieldsCount > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpIOP.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "default",
        isSelected: true,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        label: "addButton",
        testId: "jql-builder-basic.common.ui.add-filter-fallback.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.StyledLabel), null, moreLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.StyledBadge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eE9zS.default), {
        appearance: "primary"
    }, `+${optionalFieldsCount}`)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "default",
        iconAfter: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($FO5HY))), {
            label: "",
            color: "currentColor",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7qVFB))), {
            label: "addIcon",
            LEGACY_size: "small"
        }),
        isSelected: false,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        label: "addButton",
        testId: "jql-builder-basic.common.ui.add-filter-fallback.loading"
    }, moreLabel);
};
var $7e4d9e52c21fde51$export$2e2bcd8739ae039 = $7e4d9e52c21fde51$var$AddFilterFallback;

});
parcelRegister("7qVFB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5697b22777d077a1$var$_react = $5697b22777d077a1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5697b22777d077a1$var$_add = $5697b22777d077a1$var$_interopRequireDefault((parcelRequire("i140O")));

var $5697b22777d077a1$var$_add2 = $5697b22777d077a1$var$_interopRequireDefault((parcelRequire("9Wm0R")));
function $5697b22777d077a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5697b22777d077a1$var$AddIcon = (props)=>/*#__PURE__*/ $5697b22777d077a1$var$_react.default.createElement($5697b22777d077a1$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $5697b22777d077a1$var$_add2.default
    }, props));
$5697b22777d077a1$var$AddIcon.Name = 'AddIconMigration';
var $5697b22777d077a1$var$_default = module.exports.default = $5697b22777d077a1$var$AddIcon;

});
parcelRegister("9Wm0R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $01de1b46abe0ed48$var$_react = $01de1b46abe0ed48$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $01de1b46abe0ed48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $01de1b46abe0ed48$var$AddIcon = (props)=>/*#__PURE__*/ $01de1b46abe0ed48$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props));
$01de1b46abe0ed48$var$AddIcon.displayName = 'AddIcon';
var $01de1b46abe0ed48$var$_default = module.exports.default = $01de1b46abe0ed48$var$AddIcon;

});


parcelRegister("izTXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bb191f32cb760a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1bb191f32cb760a0$var$messages = (0, $7qGN1.defineMessages)({
    moreButtonOld: {
        "id": "jql-builder-basic.common.more-button-old",
        "defaultMessage": "More"
    },
    moreButton: {
        "id": "jql-builder-basic.common.more-button",
        "defaultMessage": "More filters"
    },
    refinementSearch: {
        "id": "jql-builder-basic.jql-editor.refinement-search",
        "defaultMessage": "Search issues"
    },
    searchCurrentPage: {
        "id": "jql-builder-basic.common.search-current-page",
        "defaultMessage": "Search on current page"
    },
    refinementSearchIssueTermRefresh: {
        "id": "jql-builder-basic.common.refinement-search-issue-term-refresh",
        "defaultMessage": "Search work"
    },
    moreButtonLabel: {
        "id": "jql-builder-basic.common.more-button-label",
        "defaultMessage": "More filter options"
    },
    searchMoreFiltersPlaceholder: {
        "id": "jql-builder-basic-picker.common.search-more-filters-placeholder",
        "defaultMessage": "Search more filters"
    },
    accessibleDescription: {
        "id": "jql-builder-basic.common.accessible-description",
        "defaultMessage": "Typing letters in the search input updates the search results below."
    }
});
var $1bb191f32cb760a0$export$2e2bcd8739ae039 = $1bb191f32cb760a0$var$messages;

});

parcelRegister("fpIOP", function(module, exports) {

$parcel$export(module.exports, "LoadingStateAnimationWrapper", () => $798b0be264727846$export$c7a90a9f6120efb7);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $798b0be264727846$export$c7a90a9f6120efb7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y44vkmg5 _kqswh2mm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kkE8T", function(module, exports) {

$parcel$export(module.exports, "TriggerComponentNoOperator", () => $5d8410405ab62313$export$2d8feb52cd4e66ea);
$parcel$export(module.exports, "Container", () => $5d8410405ab62313$export$42a852a2b6b56249);
$parcel$export(module.exports, "LabelContainer", () => $5d8410405ab62313$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "StyledLabel", () => $5d8410405ab62313$export$eea83358d9434634);
$parcel$export(module.exports, "StyledBadge", () => $5d8410405ab62313$export$1eb8c4092e3d2863);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eE9zS = parcelRequire("eE9zS");

var $bxHeV = parcelRequire("bxHeV");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $dPMMf = parcelRequire("dPMMf");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

const $5d8410405ab62313$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : typeof value === 'object' && value !== null;
const $5d8410405ab62313$export$2d8feb52cd4e66ea = ({ isInvalid: isInvalid = false, label: label = '', value: value, isSelected: isSelected })=>{
    if (!value || !$5d8410405ab62313$export$96bdbc84526f3739(value)) return (0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $5d8410405ab62313$var$triggerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $5d8410405ab62313$var$triggerStyles,
        testId: (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        weight: "medium",
        color: !isSelected ? 'color.text.subtle' : 'inherit'
    }, label))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$f5ae33f1b01a6402, {
        "data-testid": (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, label));
    const valueMap = value.map((v)=>v.optionType !== 'error' && v.label !== undefined ? v.label : '');
    const valueLength = valueMap.length;
    const [firstValue, ...rest] = valueMap;
    const badgeAppearance = isInvalid ? 'important' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$f5ae33f1b01a6402, {
        "data-testid": (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$eea83358d9434634, null, label, ":"), firstValue), valueLength > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5d8410405ab62313$export$1eb8c4092e3d2863, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eE9zS.default), {
        testId: (0, $332899bfd23114ba$export$fca2db27fe6c1305),
        appearance: badgeAppearance
    }, `+${rest.length}`)) : null);
};
const $5d8410405ab62313$var$triggerContainerStyles = (0, $5Wv5g.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $5d8410405ab62313$var$triggerStyles = (0, $5Wv5g.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${36 * (0, $dPMMf.gridSize)}px`,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $5d8410405ab62313$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5d8410405ab62313$export$f5ae33f1b01a6402 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _p12fo812 _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $5d8410405ab62313$export$eea83358d9434634 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pmoej _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $5d8410405ab62313$export$1eb8c4092e3d2863 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o _18u01b66",
            __cmplp.className
        ])
    });
});

});
const $332899bfd23114ba$export$743be55d5cf4a20d = 'jql-builder-basic.common.ui.format-label.label-container';
const $332899bfd23114ba$export$fca2db27fe6c1305 = 'jql-builder-basic.common.ui.format-label.badge';



parcelRegister("bNtSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9a301a8e69517c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");
const $f9a301a8e69517c3$var$ListItemChild = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "li",
        xcss: $f9a301a8e69517c3$var$listItemStyles,
        "data-vc": "jql-builder-basic-list-item-child",
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "jql-builder-basic-refinement-fallback"
    }, children);
var $f9a301a8e69517c3$export$2e2bcd8739ae039 = $f9a301a8e69517c3$var$ListItemChild;
const $f9a301a8e69517c3$var$listItemStyles = (0, $5Wv5g.xcss)({
    margin: 'space.050',
    minWidth: 'space.0',
    listStyle: 'none'
});

});

parcelRegister("jx3Cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $147d97f5fead946e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $1xd19 = parcelRequire("1xd19");
const $147d97f5fead946e$export$15138d86eb9e97c3 = ({ label: label = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147d97f5fead946e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147d97f5fead946e$var$LabelContainer, null, label));
const $147d97f5fead946e$var$PickerFallback = ({ clause: clause, fieldId: fieldId, fieldDisplayName: fieldDisplayName, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
        isInvalid: false,
        isSelected: false,
        hasValues: !!clause,
        onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
        isLoading: !!clause,
        fieldDescription: fieldDescription,
        isIrremovable: isIrremovable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147d97f5fead946e$export$15138d86eb9e97c3, {
        label: fieldDisplayName
    }));
var $147d97f5fead946e$export$2e2bcd8739ae039 = $147d97f5fead946e$var$PickerFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $147d97f5fead946e$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $147d97f5fead946e$var$LabelContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c116y _4cvr1h6o _p12fo812 _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1xd19", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27ca3e76f0378a8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $adDYm = parcelRequire("adDYm");

var $dKpTa = parcelRequire("dKpTa");

var $kibFU = parcelRequire("kibFU");

var $h8epd = parcelRequire("h8epd");

var $9JB3T = parcelRequire("9JB3T");

var $7jTnu = parcelRequire("7jTnu");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $6XJko = parcelRequire("6XJko");

var $dTJxm = parcelRequire("dTJxm");

var $8kiQA = parcelRequire("8kiQA");

var $huMsw = parcelRequire("huMsw");

var $fpIOP = parcelRequire("fpIOP");

var $aIcwA = parcelRequire("aIcwA");
const $a27ca3e76f0378a8$var$Button = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $dKpTa.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _ju3gewfl _mt1tewfl",
            __cmplp.className
        ])
    });
});
const $a27ca3e76f0378a8$var$isKeyboardEvent = (event)=>event.key !== undefined;
const $a27ca3e76f0378a8$var$PickerTrigger = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId, searchTemplate: searchTemplate, fieldDescription: fieldDescription, isIrremovable: isIrremovable = false }, ref)=>{
    const intl = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleOnClear = (0, $eJOHy.useCallback)((e)=>{
        e.stopPropagation();
        const isKeyboard = $a27ca3e76f0378a8$var$isKeyboardEvent(e); // only clear on click, enter key or space key
        const shouldClear = isKeyboard && (e.key === 'Enter' || e.key === ' ') || !isKeyboard;
        onClear && shouldClear && onClear();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'removeFilter', {
            keyboard: isKeyboard
        });
    }, [
        createAnalyticsEvent,
        onClear
    ]);
    if (isLoading === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpIOP.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        isSelected: true,
        testId: `${testId}.loading`,
        ...(0, $7jTnu.fg)('add_nin_press_interactions') && {
            interactionName: 'jql-builder-basic-picker-trigger'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$ButtonContent, null, children)));
    const Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$ButtonContent, null, searchTemplate === (0, $dTJxm.EPIC_LINK).searchTemplate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $aIcwA.default).deprecatedEpicLinkMessage,
            values: {
                // @ts-expect-error - Type '(chunks: string) => JSX.Element' is not assignable to type 'ReactNode'.
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                        as: "strong",
                        color: "inherit",
                        size: "UNSAFE_small"
                    }, chunks)
            }
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$IconWrapperLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kibFU))), {
        label: "",
        color: "var(--ds-icon-warning, #E56910)",
        LEGACY_size: "small"
    }))), children);
    const IconAfterContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$IconWrapper, {
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, fieldDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $huMsw.FieldDescriptionPopup), {
        fieldDescription: fieldDescription,
        isParentPickerActive: hasValues || isSelected
    }), !isIrremovable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8kiQA.ClearButton), {
        onClick: handleOnClear,
        label: intl.formatMessage((0, $aIcwA.default).removeField)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($adDYm))), {
        label: "",
        color: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') && !(isSelected || hasValues) ? "var(--ds-icon-subtle, #626F86)" : 'currentColor',
        size: "small"
    }));
    return isInvalid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$export$332fba2134818c97, {
        isSelected: isSelected || hasValues,
        onClick: onClick,
        ref: ref,
        testId: testId,
        iconAfter: IconAfterContent
    }, Content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$Button, {
        isSelected: isSelected || hasValues,
        "aria-expanded": isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        iconAfter: IconAfterContent
    }, Content);
});
var $a27ca3e76f0378a8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a27ca3e76f0378a8$var$PickerTrigger;
const $a27ca3e76f0378a8$var$ButtonContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- To migrate as part of go/ui-styling-standard
const $a27ca3e76f0378a8$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_gg26t5": (0, $awdRS.default)(__cmplp.visualRefresh ? "var(--ds-space-0, 0px)" : "var(--ds-space-negative-075, -6px)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o _2hwxyz14",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a27ca3e76f0378a8$var$IconWrapperLeft = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwx1b66 _18u01i6y",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a27ca3e76f0378a8$export$332fba2134818c97 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a27ca3e76f0378a8$var$Button, {
        ...props,
        ref: ref,
        className: (0, $hcewu.default)([
            "_1w905u61 _16hgvb0f _zelm5u61 _1fh15u61 _18y1vb0f _u1mbvb0f"
        ])
    }));
const $a27ca3e76f0378a8$var$styles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a27ca3e76f0378a8$export$27305c69e65286e6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz14q2 _30l316c2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8kiQA", function(module, exports) {

$parcel$export(module.exports, "ClearButton", () => $12161862574e639b$export$13ec83e50bf04290);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $iRTqk = parcelRequire("iRTqk");
const $12161862574e639b$export$13ec83e50bf04290 = ({ label: label, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($12161862574e639b$var$StyledClearButton, {
        // @ts-expect-error ts(2322) Type 'string' is not assignable to type 'number'.
        tabIndex: "0",
        role: "button",
        onClick: onClick,
        onKeyPress: onClick,
        "data-testid": "jql-editor-basic.common.ui.clear-button" // eslint-disable-line jira/integration/test-id-by-folder-structure
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRTqk))), {
        color: "currentColor",
        label: label,
        size: "small"
    }));
var $12161862574e639b$export$2e2bcd8739ae039 = $12161862574e639b$export$13ec83e50bf04290;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12161862574e639b$var$StyledClearButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _syaz131l _nt751r31 _49pcglyw _1hvw1o36 _vn89sqtm _f8pj1fxt _7ehi1vm4 _30l31fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iRTqk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53b9d7f39d5a7786fd5c4592782d4f82>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbc82b3b1b3dc9d6$var$_react = $dbc82b3b1b3dc9d6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $dbc82b3b1b3dc9d6$var$_cross = $dbc82b3b1b3dc9d6$var$_interopRequireDefault((parcelRequire("2Eu5z")));

var $dbc82b3b1b3dc9d6$var$_close = $dbc82b3b1b3dc9d6$var$_interopRequireDefault((parcelRequire("gsUqg")));
function $dbc82b3b1b3dc9d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbc82b3b1b3dc9d6$var$CrossIcon = (props)=>/*#__PURE__*/ $dbc82b3b1b3dc9d6$var$_react.default.createElement($dbc82b3b1b3dc9d6$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $dbc82b3b1b3dc9d6$var$_close.default
    }, props));
$dbc82b3b1b3dc9d6$var$CrossIcon.Name = 'CrossIconMigration';
var $dbc82b3b1b3dc9d6$var$_default = module.exports.default = $dbc82b3b1b3dc9d6$var$CrossIcon;

});
parcelRegister("gsUqg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfcb07342ff07c6a$var$_react = $bfcb07342ff07c6a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $bfcb07342ff07c6a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfcb07342ff07c6a$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $bfcb07342ff07c6a$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props));
$bfcb07342ff07c6a$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $bfcb07342ff07c6a$var$_default = module.exports.default = $bfcb07342ff07c6a$var$EditorCloseIcon;

});



parcelRegister("huMsw", function(module, exports) {

$parcel$export(module.exports, "FieldDescriptionPopup", () => $8ae94e736131c065$export$8adaffb2a3e09bc3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3fTrH = parcelRequire("3fTrH");

var $9JB3T = parcelRequire("9JB3T");

var $2ZGUP = parcelRequire("2ZGUP");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $lRq8t = parcelRequire("lRq8t");

var $cNe2t = parcelRequire("cNe2t");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $dTJxm = parcelRequire("dTJxm");


var $2OYJH = parcelRequire("2OYJH");

var $9i5BR = parcelRequire("9i5BR");

var $bT9la = parcelRequire("bT9la");
const $8ae94e736131c065$var$entryPointParams = {}; /**
                              * Render a Jira custom field description as rich text, within a popup
                              */ 
const $8ae94e736131c065$export$8adaffb2a3e09bc3 = ({ fieldDescription: fieldDescription, shouldOpenOnFirstRender: shouldOpenOnFirstRender = false, isParentPickerActive: isParentPickerActive })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(shouldOpenOnFirstRender);
    const toggleOpenCloseState = (0, $eJOHy.useCallback)(()=>{
        setIsOpen((currentIsOpenValue)=>!currentIsOpenValue);
    }, []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $9i5BR.default), $8ae94e736131c065$var$entryPointParams);
    const buttonTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions); /**
                                                                        * lazily render the field description popup content (using entrypoints).
                                                                        * The content is a rich text description that is configured in the 'custom
                                                                        * fields' Jira settings.
                                                                        */ 
    const renderContent = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: (0, $78f96576dfb68c5f$export$723ee4d7411b97b4),
            packageName: (0, $dTJxm.PACKAGE_NAME),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2OYJH.ContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2OYJH.ContentError), null)),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2OYJH.ContentBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2OYJH.ContentLoading), null)),
            runtimeProps: {
                fieldDescription: fieldDescription
            }
        }), [
        entryPointReferenceSubject,
        fieldDescription
    ]);
    /**
   * renders the icon that, when clicked, toggles open/close state of the
   * field description popup
   */ const renderTrigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
            content: formatMessage((0, $bT9la.default).showDescription),
            position: "top"
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8ae94e736131c065$var$Trigger, {
                ...tooltipProps,
                ...triggerProps,
                ...(0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') && {
                    role: 'button',
                    tabIndex: 0,
                    'aria-label': formatMessage((0, $bT9la.default).fieldDescription),
                    onKeyDown: (e)=>{
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            e.stopPropagation();
                            toggleOpenCloseState();
                        }
                    }
                },
                ref: (element)=>{
                    /*
       * make sure the Trigger's ref is passed to all things
       * that need it, otherwise bugs will appear such as
       * tooltip/popup appearing in weird places
       */ buttonTrigger(element); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    tooltipProps.ref(element); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                isOpen: isOpen,
                isParentPickerActive: isParentPickerActive,
                onClick: (e)=>{
                    e.stopPropagation();
                    toggleOpenCloseState();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fTrH))), {
                spacing: "spacious",
                label: isOpen ? formatMessage((0, $bT9la.default).hideDescription) : formatMessage((0, $bT9la.default).showDescription)
            }))), [
        buttonTrigger,
        formatMessage,
        isOpen,
        isParentPickerActive,
        toggleOpenCloseState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        messageId: "jql-builder-basic.common.ui.field-description-popup.popup",
        messageType: "transactional",
        content: renderContent,
        trigger: renderTrigger
    }), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null));
};
/**
 * Clickable element that will toggle the open / close state of the popup
 * (Old implementation - button tag)
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8ae94e736131c065$var$TriggerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, isParentPickerActive: isParentPickerActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk18uv _80omtlke _nt751r31 _49pcglyw _1hvw1o36 _vn89sqtm _f8pj1fxt _7ehi1vm4 _30l31fxt",
            __cmplp.isOpen || __cmplp.isParentPickerActive ? "_syaz1qo3" : "_syaz131l",
            __cmplp.className
        ])
    });
}); /**
     * Clickable element that will toggle the open / close state of the popup
     * (New implementation - div with role="button" )
     * Note this does not resolve the a11y issue ENGHEALTH-28029,
     * but does ensure SSR returns valid HTML
     */ 
const $8ae94e736131c065$var$TriggerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, isParentPickerActive: isParentPickerActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk18uv _80omtlke _1e0c116y _4cvr1h6o _1bah1h6o _nt751r31 _49pcglyw _1hvw1o36 _vn89sqtm _f8pj1fxt _7ehi1vm4 _30l31fxt",
            __cmplp.isOpen || __cmplp.isParentPickerActive ? "_syaz1qo3" : "_syaz131l",
            __cmplp.className
        ])
    });
});
const $8ae94e736131c065$var$Trigger = (0, $bJscI.componentWithFG)('jql_builder_basic_ssr_stability_fixes', $8ae94e736131c065$var$TriggerNew, $8ae94e736131c065$var$TriggerOld);

});
parcelRegister("3fTrH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4c08fce34755bd27ddd6baac981b869>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25edc8340db30fbd$var$_react = $25edc8340db30fbd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $25edc8340db30fbd$var$_statusInformation = $25edc8340db30fbd$var$_interopRequireDefault((parcelRequire("if36D")));

var $25edc8340db30fbd$var$_panel = $25edc8340db30fbd$var$_interopRequireDefault((parcelRequire("gobQf")));
function $25edc8340db30fbd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25edc8340db30fbd$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $25edc8340db30fbd$var$_react.default.createElement($25edc8340db30fbd$var$_statusInformation.default, Object.assign({
        LEGACY_fallbackIcon: $25edc8340db30fbd$var$_panel.default
    }, props));
$25edc8340db30fbd$var$StatusInformationIcon.Name = 'StatusInformationIconMigration';
var $25edc8340db30fbd$var$_default = module.exports.default = $25edc8340db30fbd$var$StatusInformationIcon;

});
parcelRegister("gobQf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bee812bfabdd80d5$var$_react = $bee812bfabdd80d5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $bee812bfabdd80d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bee812bfabdd80d5$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $bee812bfabdd80d5$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props));
$bee812bfabdd80d5$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $bee812bfabdd80d5$var$_default = module.exports.default = $bee812bfabdd80d5$var$EditorPanelIcon;

});


const $78f96576dfb68c5f$export$723ee4d7411b97b4 = 'field-description-popup-content';

parcelRegister("2OYJH", function(module, exports) {

$parcel$export(module.exports, "ContentBox", () => $82839c47848ada0f$export$2966b8ec97c144ae);
$parcel$export(module.exports, "ContentError", () => $82839c47848ada0f$export$f2a1a543c1677898);
$parcel$export(module.exports, "ContentLoading", () => $82839c47848ada0f$export$199be3e6e7e83c08);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6CZxU = parcelRequire("6CZxU");

var $72c8M = parcelRequire("72c8M");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $dPlS8 = parcelRequire("dPlS8");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $bWrOQ = parcelRequire("bWrOQ");
const $82839c47848ada0f$export$2966b8ec97c144ae = ({ children: children })=>{
    /**
   * Because the field description button is nested within the picker button,
   * any click events in the field description popup would bubble up and trigger
   * the picker. This is an intrim solution to prevent that from happening. Wrap
   * the entire field description popup in a div that listens for clicks and traps
   * them so that they don't bubble further up to the picker button.
   *
   * TODO remove this when completing the followup ticket:
   * https://jplat.jira.atlassian.cloud/browse/EM-6510
   */ const propagationTrap = (e)=>e.stopPropagation();
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        padding: "space.150",
        xcss: $82839c47848ada0f$var$contentBoxStyles,
        onClick: propagationTrap,
        tabIndex: 0
    }, children));
};
const $82839c47848ada0f$export$f2a1a543c1677898 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center"
    }, !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82839c47848ada0f$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6CZxU))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($72c8M))),
        LEGACY_size: "xlarge",
        LEGACY_primaryColor: "color.text",
        color: "var(--ds-icon-warning, #E56910)",
        testId: "jql-builder-basic.common.ui.field-description-popup-common.editor-warning-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($82839c47848ada0f$var$FlexRow, null, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $82839c47848ada0f$var$warningIconStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6CZxU))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($72c8M))),
        LEGACY_size: "xlarge",
        LEGACY_primaryColor: "color.text",
        color: "var(--ds-icon-warning, #E56910)",
        testId: "jql-builder-basic.common.ui.field-description-popup-common.editor-warning-icon"
    })), formatMessage((0, $bWrOQ.default).error)));
};
const $82839c47848ada0f$export$199be3e6e7e83c08 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        testId: "jql-builder-basic.common.ui.field-description-popup-common.spinner",
        size: "small"
    });
const $82839c47848ada0f$var$contentBoxStyles = (0, $5Wv5g.xcss)({
    maxWidth: '300px',
    maxHeight: '300px',
    overflow: 'auto',
    outline: 'none'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82839c47848ada0f$var$FlexRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule _y3gn1h6o _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $82839c47848ada0f$var$warningIconStyle = (0, $5Wv5g.xcss)({
    marginRight: 'space.100',
    display: 'inline'
});

});
parcelRegister("72c8M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51f2232ed4c78e4e$var$_react = $51f2232ed4c78e4e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $51f2232ed4c78e4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $51f2232ed4c78e4e$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $51f2232ed4c78e4e$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props));
$51f2232ed4c78e4e$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $51f2232ed4c78e4e$var$_default = module.exports.default = $51f2232ed4c78e4e$var$EditorWarningIcon;

});

parcelRegister("bWrOQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $472c84f011b76fc1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $472c84f011b76fc1$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "jql-builder-basic.common.field-description-popup-common.error",
        "defaultMessage": "We cannot show the field description at this time. Please refresh to try again."
    }
});
var $472c84f011b76fc1$export$2e2bcd8739ae039 = $472c84f011b76fc1$var$messages;

});


parcelRegister("9i5BR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a28ccc0a64ec8f4$export$2e2bcd8739ae039);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $0a28ccc0a64ec8f4$var$FieldDescriptionContentEntryPoint = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("3at7t")), {
        moduleId: "91602efd",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});
var $0a28ccc0a64ec8f4$export$2e2bcd8739ae039 = $0a28ccc0a64ec8f4$var$FieldDescriptionContentEntryPoint;

});
parcelRegister("3at7t", function(module, exports) {

let $24e8e4d33d515ed5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $24e8e4d33d515ed5$var$load("1VRB2"),
    $24e8e4d33d515ed5$var$load("bABhq"),
    $24e8e4d33d515ed5$var$load("7vqGd"),
    $24e8e4d33d515ed5$var$load("1Y4bq"),
    $24e8e4d33d515ed5$var$load("7ofGa")
]).then(()=>parcelRequire('dKBR7'));

});


parcelRegister("bT9la", function(module, exports) {

$parcel$export(module.exports, "default", () => $41dbe3960c87233a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $41dbe3960c87233a$var$messages = (0, $7qGN1.defineMessages)({
    showDescription: {
        "id": "jql-builder-basic.common.field-description-popup.show-description",
        "defaultMessage": "Show the description for this field"
    },
    hideDescription: {
        "id": "jql-builder-basic.common.field-description-popup.hide-description",
        "defaultMessage": "Hide the description for this field"
    },
    fieldDescription: {
        "id": "jql-builder-basic.common.field-description-popup.field-description",
        "defaultMessage": "Field description"
    }
});
var $41dbe3960c87233a$export$2e2bcd8739ae039 = $41dbe3960c87233a$var$messages;

});


parcelRegister("aIcwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $292ccc03ae0fcd70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $292ccc03ae0fcd70$var$messages = (0, $7qGN1.defineMessages)({
    removeField: {
        "id": "jql-builder-basic.common.picker-trigger.remove-field",
        "defaultMessage": "Remove field"
    },
    deprecatedEpicLinkMessage: {
        "id": "jql-builder-basic.common.picker-trigger.deprecated-epic-link-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>."
    }
});
var $292ccc03ae0fcd70$export$2e2bcd8739ae039 = $292ccc03ae0fcd70$var$messages;

});



parcelRegister("1gVNb", function(module, exports) {

$parcel$export(module.exports, "StyledChild", () => $9becb14e4b35c771$export$8133811dea85f484);
$parcel$export(module.exports, "StyledListItemChild", () => $9becb14e4b35c771$export$b24abe39371fec57);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9becb14e4b35c771$export$8133811dea85f484 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _2hwx1b66 _otyrv77o _18u01b66 _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $9becb14e4b35c771$export$b24abe39371fec57 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_qtt8glyw _19pk1b66 _2hwxv77o _otyr1b66 _18u0v77o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $9becb14e4b35c771$export$999ca5bf223f627 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("97Pzw", function(module, exports) {

$parcel$export(module.exports, "default", () => $13faf4701670b6d8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fpIOP = parcelRequire("fpIOP");

var $iRlQc = parcelRequire("iRlQc");
const $13faf4701670b6d8$var$ORDER_BY_LOADING_BUTTON_ID = 'jql-builder-basic-order-by-trigger-loading';
const $13faf4701670b6d8$var$OrderByPickerLoading = ({ orderByFieldsCount: orderByFieldsCount })=>orderByFieldsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpIOP.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iRlQc.default), {
        numberOfFields: orderByFieldsCount,
        buttonId: $13faf4701670b6d8$var$ORDER_BY_LOADING_BUTTON_ID,
        isSelected: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iRlQc.default), {
        numberOfFields: orderByFieldsCount,
        buttonId: $13faf4701670b6d8$var$ORDER_BY_LOADING_BUTTON_ID,
        isSelected: false
    });
var $13faf4701670b6d8$export$2e2bcd8739ae039 = $13faf4701670b6d8$var$OrderByPickerLoading;

});
parcelRegister("iRlQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $200a3c692ee5506a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eE9zS = parcelRequire("eE9zS");

var $alkjW = parcelRequire("alkjW");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $elIWt = parcelRequire("elIWt");

var $7yWes = parcelRequire("7yWes");
/**
 * Renders the button that triggers open/close of the Order By Picker. Also rendered in the basic mode
 * loading screen when the Order By Picker is enabled.
 */ const $200a3c692ee5506a$var$OrderByButton = ({ onClick: onClick, numberOfFields: numberOfFields, triggerProps: triggerProps, buttonId: buttonId, isSelected: isSelected })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const label = numberOfFields ? formatMessage((0, $elIWt.default).labelNameWithBadge, {
        fieldCount: numberOfFields
    }) : formatMessage((0, $elIWt.default).name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
        ...triggerProps,
        id: buttonId,
        isSelected: Boolean(numberOfFields) || isSelected,
        onClick: onClick,
        iconAfter: (...iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                xcss: $200a3c692ee5506a$var$iconContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7yWes.default), {
                ...iconProps,
                size: "small",
                label: ""
            })),
        "aria-label": label,
        testId: "jql-builder-basic.common.ui.order-by-trigger-button.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), null, formatMessage((0, $elIWt.default).name)), Boolean(numberOfFields) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eE9zS.default), {
        appearance: "primary"
    }, numberOfFields))));
};
var $200a3c692ee5506a$export$2e2bcd8739ae039 = $200a3c692ee5506a$var$OrderByButton;
const $200a3c692ee5506a$var$iconContainerStyles = (0, $5Wv5g.xcss)({
    paddingRight: 'space.050',
    paddingTop: 'space.025'
});

});
parcelRegister("elIWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $75062d67003cd2cf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
'src/packages/jql-builder/basic/src/ui/jql-editor/order-by-picker/trigger-button/messages.tsx';
const $75062d67003cd2cf$var$messages = (0, $7qGN1.defineMessages)({
    name: {
        "id": "jql-builder-basic.common.order-by-trigger-button.name",
        "defaultMessage": "Order"
    },
    labelNameWithBadge: {
        "id": "jql-builder-basic.common.order-by-trigger-button.label-name-with-badge",
        "defaultMessage": "Order, currently {fieldCount, plural, other {# fields} one {# field}} selected"
    }
});
var $75062d67003cd2cf$export$2e2bcd8739ae039 = $75062d67003cd2cf$var$messages;

});

parcelRegister("7yWes", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aad666c06754cce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aCmsU = parcelRequire("aCmsU");
const $9aad666c06754cce$var$sortOrderGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "none",
        d: "M1.7749 3.25001L4.24978 0.775132L6.72465 3.25001M14.2251 10.75L11.7502 13.2249L9.27535 10.75M11.75 12.5V0.75M4.25 13.25L4.25 1.50001",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "square",
        strokeLinejoin: "round"
    }));
const $9aad666c06754cce$var$SortIcon = ({ label: label, size: size = 'medium' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        glyph: $9aad666c06754cce$var$sortOrderGlyph,
        label: label,
        size: size
    });
var $9aad666c06754cce$export$2e2bcd8739ae039 = $9aad666c06754cce$var$SortIcon;

});



parcelRegister("ivFNg", function(module, exports) {

$parcel$export(module.exports, "TextSearchInputLoading", () => $97c7077f91ae1c75$export$d8de07f8c0b1e278);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $lyPdT = parcelRequire("lyPdT");

var $b06aK = parcelRequire("b06aK");

var $92k5z = parcelRequire("92k5z");

var $izTXQ = parcelRequire("izTXQ");

var $5jGSj = parcelRequire("5jGSj");
const $97c7077f91ae1c75$export$d8de07f8c0b1e278 = ({ placeholder: placeholder })=>{
    const intl = (0, $lRq8t.default)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const value = (0, $eJOHy.useMemo)(()=>(0, $92k5z.removeSurroundingQuotes)((0, $b06aK.default).value(textSearchInputClause) || ''), [
        textSearchInputClause
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jGSj.default), {
        label: placeholder !== undefined && (0, $6XJko.isVisualRefreshEnabled)() ? placeholder : intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $izTXQ.default).refinementSearchIssueTermRefresh : (0, $izTXQ.default).refinementSearch),
        value: value,
        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        isDisabled: true
    });
};

});
parcelRegister("92k5z", function(module, exports) {

$parcel$export(module.exports, "removeSurroundingQuotes", () => $d05f5ddefe8149a6$export$8de447c869ac6d85);
const $d05f5ddefe8149a6$export$8de447c869ac6d85 = (maybeQuotedString)=>maybeQuotedString.replace(/^["']|["']$/g, '');

});

parcelRegister("5jGSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cbf21a7fc36e3e6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $1otFb = parcelRequire("1otFb");

var $dqc6Z = parcelRequire("dqc6Z");

var $6XJko = parcelRequire("6XJko");

var $lRq8t = parcelRequire("lRq8t");

var $izTXQ = parcelRequire("izTXQ");
const $5cbf21a7fc36e3e6$var$accessibleDescriptionId = 'text-field-accessible-description-id';
const $5cbf21a7fc36e3e6$var$debounceOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(({ onSendOptionAnalytics: onSendOptionAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onChange: onChange, targetValue: targetValue })=>{
    onChange(targetValue);
    onSendOptionAnalytics({
        searchStringLength: targetValue ? targetValue.length : 0
    });
}, 500, {
    leading: false,
    trailing: true
});
const $5cbf21a7fc36e3e6$var$TextField = ({ inputRef: inputRef, label: label, value: value, isDisabled: isDisabled = false, onChange: onChange, onFocus: onFocus, onSendOptionAnalytics: onSendOptionAnalytics })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleChange = (0, $eJOHy.useCallback)((targetValue)=>{
        $5cbf21a7fc36e3e6$var$debounceOnChange({
            onChange: onChange,
            targetValue: targetValue,
            onSendOptionAnalytics: onSendOptionAnalytics
        });
    }, [
        onChange,
        onSendOptionAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5cbf21a7fc36e3e6$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1otFb.default), {
        id: $5cbf21a7fc36e3e6$var$accessibleDescriptionId
    }, formatMessage((0, $izTXQ.default).accessibleDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
        onChange: handleChange,
        onFocus: onFocus,
        value: value,
        placeholder: label,
        placeholderAlwaysVisible: true,
        isCompact: true,
        isResponsive: true,
        inputRef: inputRef,
        testId: "jql-builder-basic.common.ui.text-field.search-field",
        isDisabled: isDisabled,
        showIconBeforeInput: (0, $6XJko.isVisualRefreshEnabled)(),
        describedById: $5cbf21a7fc36e3e6$var$accessibleDescriptionId
    }));
};
var $5cbf21a7fc36e3e6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5cbf21a7fc36e3e6$var$TextField;
const $5cbf21a7fc36e3e6$var$StyledContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dqc6Z", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $f1Zdy = parcelRequire("f1Zdy");

var $eKx5I = parcelRequire("eKx5I");

var $9JB3T = parcelRequire("9JB3T");

var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
function $84caf67c6542222b$export$41946885a418e1(object) {
    return 'ref' in object && 'data-test-id' in object;
}
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            reducedHeight: reducedHeight
        } : {}
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    if (!(0, $7jTnu.fg)('jif-jam-search-filter-edit')) {
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
        setValue(externalValue);
        previousValueRef.current = externalValue;
    } // If clear filters gets clicked
    (0, $eJOHy.useEffect)(()=>{
        if (externalValue === '' && (0, $7jTnu.fg)('jif-jam-search-filter-edit')) setValue('');
    }, [
        externalValue
    ]);
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $7jTnu.fg)('filter_refinement_search_field_tooltip') ? // condition is because of fg
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]) : {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $84caf67c6542222b$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    if ($84caf67c6542222b$export$41946885a418e1(textFieldProps) && (0, $7jTnu.fg)('filter_refinement_search_field_tooltip')) {
        const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps; // condition is just because of fg
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showTooltip = (0, $eJOHy.useMemo)(()=>{
            return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
        }, [
            renderTooltipContent,
            value
        ]); // condition is because of fg - remove disabled eslint rule once fg is removed
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
            showTooltip
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
            shouldFitContainerWidth: shouldFitContainerWidth,
            reducedHeight: reducedHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
            content: renderTooltipContent,
            canAppear: useShowTooltip,
            position: "bottom-start",
            hideTooltipOnClick: true,
            ignoreTooltipPointerEvents: true
        }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
                ...tooltipProps,
                ...restTextFieldProps,
                elemBeforeInput: searchIcon,
                elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
                ...id !== undefined ? {
                    id: id
                } : {},
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onFocus: (0, $eJOHy.useCallback)((event)=>{
                    onFocusTextField && onFocusTextField(event);
                    onFocusTooltip(event);
                }, [
                    onFocusTooltip
                ]),
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onBlur: (0, $eJOHy.useCallback)((event)=>{
                    onBlurTextField && onBlurTextField(event);
                    onBlurTooltip(event);
                }, [
                    onBlurTooltip
                ]),
                ref: (0, $jd93d.mergeRefs)(textFieldRef, tooltipRef),
                "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
            }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $5Wv5g.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $5Wv5g.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $5Wv5g.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-border-radius, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");

var $2Eu5z = parcelRequire("2Eu5z");

var $8JneG = parcelRequire("8JneG");

var $bxHeV = parcelRequire("bxHeV");
var $bf0Hg = parcelRequire("bf0Hg");
var $cPbpX = parcelRequire("cPbpX");
var $5Wv5g = parcelRequire("5Wv5g");

var $7jTnu = parcelRequire("7jTnu");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPbpX.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8JneG))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Eu5z)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $5Wv5g.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $bf0Hg.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $5Wv5g.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $bf0Hg.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $5Wv5g.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'border.radius.circle',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $g17XP = parcelRequire("g17XP");

var $gmAES = parcelRequire("gmAES");

var $8tSIA = parcelRequire("8tSIA");

var $bxHeV = parcelRequire("bxHeV");
var $bf0Hg = parcelRequire("bf0Hg");
var $cPbpX = parcelRequire("cPbpX");
var $5Wv5g = parcelRequire("5Wv5g");

var $8JneG = parcelRequire("8JneG");

var $7jTnu = parcelRequire("7jTnu");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gmAES))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPbpX.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8JneG))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g17XP))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSIA))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $5Wv5g.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $5Wv5g.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $5Wv5g.xcss)({
    marginRight: 'space.075',
    [(0, $bf0Hg.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $5Wv5g.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $bf0Hg.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $5Wv5g.xcss)({
    marginLeft: 'space.075',
    [(0, $bf0Hg.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $5Wv5g.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'border.radius.circle',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});





parcelRegister("hoXMy", function(module, exports) {

$parcel$export(module.exports, "gatherFields", () => $3f3cab4de8a849d2$export$af0604ea1b6b60ec);
$parcel$export(module.exports, "gatherIrremovableFields", () => $3f3cab4de8a849d2$export$2965c0f6ab2d5c39);

var $a6gy0 = parcelRequire("a6gy0");

var $80xRm = parcelRequire("80xRm");

var $7jTnu = parcelRequire("7jTnu");

var $4G98k = parcelRequire("4G98k");

var $22GDK = parcelRequire("22GDK");
/**
 * getDataFromHydratedData read the fieldsHydratedData to the data hashed by fieldId/jqlTerm
 */ const $3f3cab4de8a849d2$var$getDataFromHydratedData = ({ fieldsHydratedData: fieldsHydratedData })=>{
    const fieldsData = {};
    (fieldsHydratedData?.jira?.jqlBuilder?.hydrateJqlQuery ?? fieldsHydratedData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.forEach((hydratedField)=>{
        if (hydratedField.field && hydratedField.jqlTerm) {
            const { field: { displayName: displayName, searchTemplate: searchTemplate, type: type, description: description, operators: operators, fieldType: fieldType, shouldShowInContext: shouldShowInContext, shouldExcludeInScope: shouldExcludeInScope }, jqlTerm: jqlTerm } = hydratedField;
            // Searchable fields should always have a type & search template
            if (searchTemplate?.key == null || type == null) return;
            if (!fieldsData[jqlTerm.toLowerCase()]) fieldsData[jqlTerm.toLowerCase()] = {
                displayName: // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                displayName,
                searchTemplate: searchTemplate.key,
                fieldType: type,
                fieldDescription: description ?? null,
                fieldTypeDisplayName: fieldType?.displayName ?? null,
                operators: (0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? operators?.map((0, $22GDK.mapOperators)) ?? [] : operators.map((0, $22GDK.mapOperators)),
                isDuplicated: false,
                shouldShowInContext: shouldShowInContext ?? true,
                shouldExcludeInScope: shouldExcludeInScope ?? false
            };
            else fieldsData[jqlTerm.toLowerCase()].isDuplicated = true;
        }
    });
    return fieldsData;
};
/**
 * getOptionalFieldsToRender takes data from the AST, selectedFields and hydrated data and generates Optional fields to render array
 */ const $3f3cab4de8a849d2$var$getOptionalFieldsToRender = ({ astClauseOrder: astClauseOrder, selectedFields: selectedFields, fieldsData: fieldsData, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId, excludedFields: excludedFields })=>{
    // First get an array of unique fields we want to add
    const allFields = [
        ...new Set([
            ...astClauseOrder,
            ...selectedFields.map((sf)=>sf.value.toLowerCase())
        ])
    ];
    // Create hash map with data of selected fields
    const selectedFieldsData = selectedFields.reduce((map, selectedField)=>{
        // eslint-disable-next-line no-param-reassign
        map[selectedField.value.toLowerCase()] = {
            displayName: selectedField.label,
            searchTemplate: selectedField.searchTemplate,
            fieldType: selectedField.fieldType,
            fieldDescription: selectedField.fieldDescription,
            operators: selectedField.operators,
            fieldTypeDisplayName: selectedField.fieldTypeDisplayName,
            isDuplicated: false,
            shouldShowInContext: true,
            shouldExcludeInScope: false
        };
        return map;
    }, {});
    const [fieldsWithHydration, fieldsMissingHydration] = (0, (/*@__PURE__*/$parcel$interopDefault($a6gy0)))(allFields, (fieldId)=>fieldsData[fieldId] ?? selectedFieldsData[fieldId]);
    // FG outside so it's not being evaluated for each field
    if ((0, $7jTnu.fg)('simple-plans-m2-release-feature-toggle')) {
        // Generate fields to render
        const optionalFieldsToRender = fieldsWithHydration.filter((fieldId)=>!excludedFields.includes(fieldId)).filter((fieldId)=>{
            if (fieldsData[fieldId]) return fieldsData[fieldId]?.shouldExcludeInScope !== true;
            if (selectedFieldsData[fieldId]) return selectedFieldsData[fieldId]?.shouldExcludeInScope !== true;
            // return true by default, including when field not found
            return true;
        }).map((fieldId)=>{
            const fieldData = fieldsData[fieldId] ?? selectedFieldsData[fieldId];
            const { isDuplicated: isDuplicated, searchTemplate: searchTemplate, fieldType: fieldType, displayName: displayName, fieldDescription: fieldDescription, operators: operators, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext, shouldExcludeInScope: shouldExcludeInScope } = fieldData;
            const fieldToRender = {
                fieldId: fieldId,
                fieldLabel: displayName ?? undefined,
                fieldDescription: fieldDescription,
                fieldTypeDisplayName: fieldTypeDisplayName,
                shouldShowInContext: shouldShowInContext,
                shouldExcludeInScope: shouldExcludeInScope,
                // We want only to show non-duplicated fieldIds/jqlTerms
                ...isDuplicated ? {
                    picker: (0, $4G98k.getUnsupportedPickerType)({
                        searchTemplate: searchTemplate,
                        fieldType: fieldType
                    }),
                    clause: undefined,
                    secondaryClause: undefined
                } : {
                    picker: (0, $4G98k.getPickerType)({
                        searchTemplate: searchTemplate,
                        fieldType: fieldType,
                        operators: operators
                    }),
                    clause: clausesByFieldId[fieldId],
                    secondaryClause: secondaryClausesByFieldId[fieldId]
                }
            };
            return fieldToRender;
        });
        return {
            optionalFieldsToRender: optionalFieldsToRender,
            fieldsMissingHydration: fieldsMissingHydration
        };
    }
    // Generate fields to render
    const optionalFieldsToRender = fieldsWithHydration.filter((fieldId)=>!excludedFields.includes(fieldId)).map((fieldId)=>{
        const fieldData = fieldsData[fieldId] ?? selectedFieldsData[fieldId];
        const { isDuplicated: isDuplicated, searchTemplate: searchTemplate, fieldType: fieldType, displayName: displayName, fieldDescription: fieldDescription, operators: operators, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext, shouldExcludeInScope: shouldExcludeInScope } = fieldData;
        const fieldToRender = {
            fieldId: fieldId,
            fieldLabel: displayName ?? undefined,
            fieldDescription: fieldDescription,
            fieldTypeDisplayName: fieldTypeDisplayName,
            shouldShowInContext: shouldShowInContext,
            shouldExcludeInScope: shouldExcludeInScope,
            // We want only to show non-duplicated fieldIds/jqlTerms
            ...isDuplicated ? {
                picker: (0, $4G98k.getUnsupportedPickerType)({
                    searchTemplate: searchTemplate,
                    fieldType: fieldType
                }),
                clause: undefined,
                secondaryClause: undefined
            } : {
                picker: (0, $4G98k.getPickerType)({
                    searchTemplate: searchTemplate,
                    fieldType: fieldType,
                    operators: operators
                }),
                clause: clausesByFieldId[fieldId],
                secondaryClause: secondaryClausesByFieldId[fieldId]
            }
        };
        return fieldToRender;
    });
    return {
        optionalFieldsToRender: optionalFieldsToRender,
        fieldsMissingHydration: fieldsMissingHydration
    };
};
/**
 * getIrremovableFieldsToRender
 */ const $3f3cab4de8a849d2$var$getIrremovableFieldsToRender = ({ clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const irremovableFieldsToRender = [];
    irremovableFields.forEach((irremovableField)=>{
        const isIrremovableFieldConfiguredAsExcludedField = excludedFields.includes(irremovableField.jqlTerm);
        if (!isIrremovableFieldConfiguredAsExcludedField) irremovableFieldsToRender.push({
            isIrremovable: true,
            fieldId: irremovableField.jqlTerm,
            fieldLabel: irremovableField.displayName,
            picker: (0, $4G98k.getPickerType)({
                searchTemplate: irremovableField.searchTemplate,
                fieldType: irremovableField.fieldType,
                operators: irremovableField.operators
            }),
            fieldDescription: null,
            fieldTypeDisplayName: null,
            clause: clausesByFieldId[irremovableField.jqlTerm],
            secondaryClause: secondaryClausesByFieldId[irremovableField.jqlTerm]
        });
    });
    return irremovableFieldsToRender;
};
const $3f3cab4de8a849d2$export$af0604ea1b6b60ec = ({ selectedFields: selectedFields, excludedFields: excludedFields = [], intl: intl, fieldsHydratedData: fieldsHydratedData, previousFieldToRender: previousFieldToRender = [], irremovableFields: irremovableFields, astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId })=>{
    const { optionalFieldsToRender: optionalFieldsToRender, fieldsMissingHydration: fieldsMissingHydration } = $3f3cab4de8a849d2$var$getOptionalFieldsToRender({
        astClauseOrder: astClauseOrder,
        clausesByFieldId: clausesByFieldId,
        fieldsData: $3f3cab4de8a849d2$var$getDataFromHydratedData({
            fieldsHydratedData: fieldsHydratedData
        }),
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        selectedFields: selectedFields,
        excludedFields: excludedFields
    });
    const fieldsToRender = $3f3cab4de8a849d2$var$getIrremovableFieldsToRender({
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        excludedFields: excludedFields,
        intl: intl,
        irremovableFields: irremovableFields
    }).concat(optionalFieldsToRender);
    const missingHydration = fieldsMissingHydration.length > 0;
    /**
   * Keep order of fields in the more dropdown if order is provided
   * We use the order array to sort the fieldsToRender adding any new fields at the end
   * and then remove all the fields that doesn't exist anymore in the new fieldsToRender
   */ let sortedFieldsToRender = fieldsToRender;
    if (previousFieldToRender.length > 0) {
        const previousFieldToRendeFieldIds = previousFieldToRender.map((field)=>field.fieldId);
        sortedFieldsToRender = (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(fieldsToRender, (fieldToRender)=>{
            const index = previousFieldToRendeFieldIds.indexOf(fieldToRender.fieldId);
            return index === -1 ? previousFieldToRendeFieldIds.length : index;
        });
    }
    return {
        fieldsToRender: sortedFieldsToRender,
        optionalFieldsCount: astClauseOrder.length,
        missingHydration: missingHydration
    };
};
const $3f3cab4de8a849d2$export$2965c0f6ab2d5c39 = ({ excludedFields: excludedFields = [], intl: intl, irremovableFields: irremovableFields, astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId })=>{
    const fieldsToRender = $3f3cab4de8a849d2$var$getIrremovableFieldsToRender({
        clausesByFieldId: clausesByFieldId,
        secondaryClausesByFieldId: secondaryClausesByFieldId,
        excludedFields: excludedFields,
        intl: intl,
        irremovableFields: irremovableFields
    });
    return {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: astClauseOrder.length,
        missingHydration: true
    };
};

});
parcelRegister("80xRm", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $4ppQ2 = parcelRequire("4ppQ2");

var $l76qh = parcelRequire("l76qh");

var $eA1it = parcelRequire("eA1it");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5d48969fb93c8520$var$sortBy = $l76qh(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $eA1it(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $eA1it(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $4ppQ2(collection, $72Qfa(iteratees, 1), []);
});
module.exports = $5d48969fb93c8520$var$sortBy;

});
parcelRegister("4ppQ2", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $5BbSa = parcelRequire("5BbSa");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $1QISL = parcelRequire("1QISL");

var $cUaWv = parcelRequire("cUaWv");

var $6c1m2 = parcelRequire("6c1m2");

var $d7YnM = parcelRequire("d7YnM");

var $4sprp = parcelRequire("4sprp");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $335d8a321b94e157$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $lylkU(iteratees, function(iteratee) {
        if ($4sprp(iteratee)) return function(value) {
            return $5BbSa(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d7YnM
    ];
    var index = -1;
    iteratees = $lylkU(iteratees, $cUaWv($1lM9j));
    var result = $k0Eii(collection, function(value, key, collection) {
        var criteria = $lylkU(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $1QISL(result, function(object, other) {
        return $6c1m2(object, other, orders);
    });
}
module.exports = $335d8a321b94e157$var$baseOrderBy;

});
parcelRegister("k0Eii", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");

var $7H30b = parcelRequire("7H30b");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e9131047aaeaff47$var$baseMap(collection, iteratee) {
    var index = -1, result = $7H30b(collection) ? Array(collection.length) : [];
    $c3u3c(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e9131047aaeaff47$var$baseMap;

});

parcelRegister("1QISL", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $158d7678f0c45464$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $158d7678f0c45464$var$baseSortBy;

});

parcelRegister("6c1m2", function(module, exports) {

var $boN2o = parcelRequire("boN2o");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4824ea093db12906$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $boN2o(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $4824ea093db12906$var$compareMultiple;

});
parcelRegister("boN2o", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $84c7f970dc532949$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9D78T(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9D78T(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $84c7f970dc532949$var$compareAscending;

});





parcelRegister("idYtD", function(module, exports) {

$parcel$export(module.exports, "getAstSortFields", () => $d83676d08a0304e7$export$dcd0fae6e8b9823a);
const $d83676d08a0304e7$export$dcd0fae6e8b9823a = (ast)=>{
    if (ast && ast.query && ast.query.orderBy) return ast.query.orderBy.fields.map((orderByFieldFromAst)=>({
            jqlTerm: orderByFieldFromAst.field.value,
            direction: orderByFieldFromAst.direction ? orderByFieldFromAst.direction.value : undefined
        }));
    return [];
};

});



parcelRegister("lHTxM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JQLEditorUIWithErrorBoundaryOld", () => $6aa7b8e93f45f0d1$export$92f0ecbbb0018d8e);
$parcel$export(module.exports, "default", () => $6aa7b8e93f45f0d1$export$2e2bcd8739ae039);

var $dnufc = parcelRequire("dnufc");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1KdDN = parcelRequire("1KdDN");

var $g8Az8 = parcelRequire("g8Az8");

var $lRq8t = parcelRequire("lRq8t");

var $gVAWF = parcelRequire("gVAWF");

var $cWcbh = parcelRequire("cWcbh");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $4xbv3 = parcelRequire("4xbv3");
var $f1Zdy = parcelRequire("f1Zdy");

var $6XJko = parcelRequire("6XJko");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");

var $co0wp = parcelRequire("co0wp");

var $bNtSK = parcelRequire("bNtSK");

var $1gVNb = parcelRequire("1gVNb");

var $9dqYm = parcelRequire("9dqYm");

var $lyPdT = parcelRequire("lyPdT");

var $lzg2Z = parcelRequire("lzg2Z");

var $fvO8D = parcelRequire("fvO8D");

var $hoXMy = parcelRequire("hoXMy");

var $idYtD = parcelRequire("idYtD");

var $hxooo = parcelRequire("hxooo");

var $3XJDD = parcelRequire("3XJDD");

var $bYJeL = parcelRequire("bYJeL");

var $dlxet = parcelRequire("dlxet");

var $hC1P1 = parcelRequire("hC1P1");

var $8mM4q = parcelRequire("8mM4q");

var $4lOXU = parcelRequire("4lOXU");
/* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/graphql-naming  */ const $6aa7b8e93f45f0d1$var$JQL_EDITOR_HYDRATION_FRAGMENT = (0, $dnufc.default);
/* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/graphql-naming */ const $6aa7b8e93f45f0d1$var$JQLEditorUIOld = ({ query: query, onSearch: onSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields = [], onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, projectOptions: projectOptions, singleSelectFields: singleSelectFields, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown = false, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker = false, contextJql: contextJql, viewContext: viewContext, scope: scope = null, suggestedUsersCount: suggestedUsersCount })=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_END
        });
    }, [
        onPerformanceMark
    ]);
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const hydratedData = (0, $j4oe4.usePreloadedQuery)((0, $cWcbh.HYDRATION_QUERY), hydrationQueryRef);
    const fieldsHydrationData = (0, $j4oe4.useFragment)($6aa7b8e93f45f0d1$var$JQL_EDITOR_HYDRATION_FRAGMENT, hydratedData);
    const loading = isHydrating ?? false;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (loading === false) onReady && onReady();
    }, [
        loading,
        onReady
    ]);
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $fvO8D.useSearchState)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $lzg2Z.useIntegrateDotDialogContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { internalState: internalState, setInternalState: setInternalState } = (0, $4lOXU.useFieldsToRender)({
        query: query,
        loading: loading,
        fieldsHydrationData: fieldsHydrationData,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    });
    const onSearchWrapper = (0, $eJOHy.useCallback)((jql)=>{
        if (onSearch) {
            setInternalState({
                internalJql: jql
            });
            onSearch(jql);
        }
    }, [
        onSearch,
        setInternalState
    ]);
    const onFieldsUpdate = (0, $eJOHy.useCallback)(({ fieldsToRender: fieldsToRender, selectedFields: selectedFields })=>{
        if (fieldsToRender !== undefined || selectedFields !== undefined) setInternalState({
            ...fieldsToRender !== undefined ? {
                fieldsToRender: fieldsToRender
            } : {},
            ...selectedFields !== undefined ? {
                selectedFields: selectedFields
            } : {}
        });
    }, [
        setInternalState
    ]);
    // Required fields are those that are never modified by the More dropdown (AddFilter component).
    // The More dropdown only manages optional fields.
    // Required fields:
    // - Cannot be added from the More dropdown
    // - Cannot be cleared from the More dropdown, if they are in the query, they remain in the query
    const requiredFields = (0, $eJOHy.useMemo)(()=>new Set([
            ...irremovableFields.keys(),
            ...excludedFields ?? []
        ]), [
        excludedFields,
        irremovableFields
    ]);
    const onClearAddFilterValues = (0, $eJOHy.useCallback)(()=>{
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $hoXMy.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        setInternalState({
            selectedFields: [],
            fieldsToRender: fieldsToRender,
            optionalFieldsCount: optionalFieldsCount
        });
        onSearchWrapper((0, $hxooo.removeOptionalFieldsFromJql)(ast, requiredFields, textSearchInputClause));
    }, [
        ast,
        excludedFields,
        intl,
        fieldsHydrationData,
        irremovableFields,
        astClauseOrder,
        clausesByFieldId,
        secondaryClausesByFieldId,
        setInternalState,
        onSearchWrapper,
        requiredFields,
        textSearchInputClause
    ]);
    const { showLoadingState: showLoadingState, fieldsToRender: fieldsToRender, selectedFields: selectedFields, optionalFieldsCount: optionalFieldsCount } = internalState;
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $1gVNb.StyledChild);
    const orderByFieldCount = (0, $eJOHy.useMemo)(()=>showOrderByPicker ? (0, $idYtD.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showLoadingState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $co0wp.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9dqYm.ActivePopupKeyContainer), {
        createAnalyticsEvent: createAnalyticsEvent,
        onJourneyStart: onJourneyStart
    }, !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            fieldType: (0, $dTJxm.getTextSearchInputField)(),
            searchTemplate: (0, $dTJxm.getTextSearchInputField)(),
            refinementType: (0, $eqSys.PickerTypes).Text,
            propType: (0, $eqSys.GenericPropTypes).NoProp
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mM4q.TextSearchInput), {
        onSearchWrapper: onSearchWrapper,
        onJourneyStart: onJourneyStart,
        shouldUseListMarkup: shouldUseListMarkup,
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            key: fieldToRender.fieldId,
            attributes: {
                fieldType: fieldToRender.picker.fieldType,
                searchTemplate: fieldToRender.picker.searchTemplate,
                refinementType: fieldToRender.picker.pickerType,
                propType: fieldToRender.picker.propType
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYJeL.default), {
            key: fieldToRender.fieldId,
            fieldToRender: fieldToRender,
            onSearchWrapper: onSearchWrapper,
            onSwitchToJql: onSwitchToJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            onClearPicker: onFieldsUpdate,
            loading: loading,
            hydratedData: hydratedData,
            projectOptions: projectOptions,
            singleSelectFields: singleSelectFields,
            shouldUseListMarkup: shouldUseListMarkup,
            hideOperatorDropdown: hideOperatorDropdown,
            contextJql: contextJql,
            viewContext: viewContext,
            scope: scope,
            suggestedUsersCount: suggestedUsersCount
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3XJDD.AddFilter), {
        NoOptionComponent: NoOptionComponent,
        value: selectedFields,
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onSearchWrapper: onSearchWrapper,
        onClearValues: onClearAddFilterValues,
        onChange: onFieldsUpdate,
        excludeFields: requiredFields,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dlxet.default), {
        ast: ast,
        onChange: onSearchWrapper,
        contextJql: contextJql,
        hydrationData: fieldsHydrationData,
        viewContext: viewContext,
        scope: scope
    })), isShortcutsDialogIntegrationAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hC1P1.AsyncRegisterSearchCriteriaToShortcutsDialog), {
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onChange: onFieldsUpdate
    })));
};
const $6aa7b8e93f45f0d1$export$92f0ecbbb0018d8e = (props)=>{
    const [ast] = (0, $lyPdT.useAST)();
    const getErrorAttributes = (0, $eJOHy.useCallback)((error)=>({
            ...(0, $g8Az8.isLoaderErrorAttributes)(error),
            anonymizedJql: ast.query ? ast.query.accept((0, $dTJxm.jqlAnonymizerVisitor)) : undefined
        }), [
        ast.query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "ui.jql-builder-basic.jql-editor.error-boundary",
        packageName: (0, $dTJxm.PACKAGE_NAME),
        teamName: (0, $dTJxm.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: getErrorAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gVAWF.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6aa7b8e93f45f0d1$var$JQLEditorUIOld, props));
};
const $6aa7b8e93f45f0d1$var$JQLEditorUI = ({ query: query, onSearch: onSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields = [], onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, AddFilterButtonComponent: AddFilterButtonComponent, hydrationData: hydrationData, isHydrating: isHydrating, projectOptions: projectOptions, singleSelectFields: singleSelectFields, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown = false, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker = false, contextJql: contextJql, viewContext: viewContext, scope: scope = null, suggestedUsersCount: suggestedUsersCount })=>{
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_END
        });
    }, [
        onPerformanceMark
    ]);
    const fieldsHydrationData = (0, $j4oe4.useFragment)($6aa7b8e93f45f0d1$var$JQL_EDITOR_HYDRATION_FRAGMENT, hydrationData);
    const loading = isHydrating ?? false;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (loading === false) onReady && onReady();
    }, [
        loading,
        onReady
    ]);
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $fvO8D.useSearchState)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $lzg2Z.useIntegrateDotDialogContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { internalState: internalState, setInternalState: setInternalState } = (0, $4lOXU.useFieldsToRender)({
        query: query,
        loading: loading,
        fieldsHydrationData: fieldsHydrationData,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    });
    const onSearchWrapper = (0, $eJOHy.useCallback)((jql)=>{
        if (onSearch) {
            setInternalState({
                internalJql: jql
            });
            onSearch(jql);
        }
    }, [
        onSearch,
        setInternalState
    ]);
    const onFieldsUpdate = (0, $eJOHy.useCallback)(({ fieldsToRender: fieldsToRender, selectedFields: selectedFields })=>{
        if (fieldsToRender !== undefined || selectedFields !== undefined) setInternalState({
            ...fieldsToRender !== undefined ? {
                fieldsToRender: fieldsToRender
            } : {},
            ...selectedFields !== undefined ? {
                selectedFields: selectedFields
            } : {}
        });
    }, [
        setInternalState
    ]);
    // Required fields are those that are never modified by the More dropdown (AddFilter component).
    // The More dropdown only manages optional fields.
    // Required fields:
    // - Cannot be added from the More dropdown
    // - Cannot be cleared from the More dropdown, if they are in the query, they remain in the query
    const requiredFields = (0, $eJOHy.useMemo)(()=>new Set([
            ...irremovableFields.keys(),
            ...excludedFields ?? []
        ]), [
        excludedFields,
        irremovableFields
    ]);
    const onClearAddFilterValues = (0, $eJOHy.useCallback)(()=>{
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $hoXMy.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        setInternalState({
            selectedFields: [],
            fieldsToRender: fieldsToRender,
            optionalFieldsCount: optionalFieldsCount
        });
        onSearchWrapper((0, $hxooo.removeOptionalFieldsFromJql)(ast, requiredFields, textSearchInputClause));
    }, [
        ast,
        excludedFields,
        intl,
        fieldsHydrationData,
        irremovableFields,
        astClauseOrder,
        clausesByFieldId,
        secondaryClausesByFieldId,
        setInternalState,
        onSearchWrapper,
        requiredFields,
        textSearchInputClause
    ]);
    const { showLoadingState: showLoadingState, fieldsToRender: fieldsToRender, selectedFields: selectedFields, optionalFieldsCount: optionalFieldsCount } = internalState;
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $1gVNb.StyledChild);
    const orderByFieldCount = (0, $eJOHy.useMemo)(()=>showOrderByPicker ? (0, $idYtD.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showLoadingState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $co0wp.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9dqYm.ActivePopupKeyContainer), {
        createAnalyticsEvent: createAnalyticsEvent,
        onJourneyStart: onJourneyStart
    }, !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            fieldType: (0, $dTJxm.getTextSearchInputField)(),
            searchTemplate: (0, $dTJxm.getTextSearchInputField)(),
            refinementType: (0, $eqSys.PickerTypes).Text,
            propType: (0, $eqSys.GenericPropTypes).NoProp
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8mM4q.TextSearchInput), {
        onSearchWrapper: onSearchWrapper,
        onJourneyStart: onJourneyStart,
        shouldUseListMarkup: shouldUseListMarkup,
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            key: fieldToRender.fieldId,
            attributes: {
                fieldType: fieldToRender.picker.fieldType,
                searchTemplate: fieldToRender.picker.searchTemplate,
                refinementType: fieldToRender.picker.pickerType,
                propType: fieldToRender.picker.propType
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYJeL.default), {
            key: fieldToRender.fieldId,
            fieldToRender: fieldToRender,
            onSearchWrapper: onSearchWrapper,
            onSwitchToJql: onSwitchToJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            onClearPicker: onFieldsUpdate,
            loading: loading,
            hydratedData: hydrationData,
            projectOptions: projectOptions,
            singleSelectFields: singleSelectFields,
            shouldUseListMarkup: shouldUseListMarkup,
            hideOperatorDropdown: hideOperatorDropdown,
            contextJql: contextJql,
            viewContext: viewContext,
            scope: scope,
            suggestedUsersCount: suggestedUsersCount
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3XJDD.AddFilter), {
        NoOptionComponent: NoOptionComponent,
        ButtonComponent: AddFilterButtonComponent,
        value: selectedFields,
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onSearchWrapper: onSearchWrapper,
        onClearValues: onClearAddFilterValues,
        onChange: onFieldsUpdate,
        excludeFields: requiredFields,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dlxet.default), {
        ast: ast,
        onChange: onSearchWrapper,
        contextJql: contextJql,
        hydrationData: fieldsHydrationData,
        viewContext: viewContext,
        scope: scope
    })), isShortcutsDialogIntegrationAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hC1P1.AsyncRegisterSearchCriteriaToShortcutsDialog), {
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onChange: onFieldsUpdate
    })));
};
const $6aa7b8e93f45f0d1$var$JQLEditorUIWithErrorBoundary = (props)=>{
    const [ast] = (0, $lyPdT.useAST)();
    const getErrorAttributes = (0, $eJOHy.useCallback)((error)=>({
            ...(0, $g8Az8.isLoaderErrorAttributes)(error),
            anonymizedJql: ast.query ? ast.query.accept((0, $dTJxm.jqlAnonymizerVisitor)) : undefined
        }), [
        ast.query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "ui.jql-builder-basic.jql-editor.error-boundary",
        packageName: (0, $dTJxm.PACKAGE_NAME),
        teamName: (0, $dTJxm.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: getErrorAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gVAWF.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6aa7b8e93f45f0d1$var$JQLEditorUI, props));
};
var $6aa7b8e93f45f0d1$export$2e2bcd8739ae039 = $6aa7b8e93f45f0d1$var$JQLEditorUIWithErrorBoundary;

});
parcelRegister("dnufc", function(module, exports) {

$parcel$export(module.exports, "default", () => $51101ccdaf4275fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bd212cab142d3ad3dcabb80999462fd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $51101ccdaf4275fd$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlTerm"
                                },
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "condition": "isPlanReleaseFeatureToggleEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        v0 /*: any*/ 
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "shouldExcludeInScope"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "isPlanReleaseFeatureToggleEnabled"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v3 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v3 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$51101ccdaf4275fd$var$node.hash = "2e5853cb23c29f7d40742951bd6a87bb";
var $51101ccdaf4275fd$export$2e2bcd8739ae039 = $51101ccdaf4275fd$var$node;

});

parcelRegister("gVAWF", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $753680c12bef645e$export$4c766016a5659721);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $aIgra = parcelRequire("aIgra");

var $lRq8t = parcelRequire("lRq8t");

var $hN3Oc = parcelRequire("hN3Oc");
const $753680c12bef645e$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $753680c12bef645e$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIgra.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $hN3Oc.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
                appearance: "link",
                spacing: "none",
                onClick: $753680c12bef645e$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("aIgra", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ee40beb30eb4c49$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4BzUI = parcelRequire("4BzUI");

var $bvFRW = parcelRequire("bvFRW");

var $g17XP = parcelRequire("g17XP");

var $8XtVW = parcelRequire("8XtVW");

var $9M9zY = parcelRequire("9M9zY");
var $aRh7I = parcelRequire("aRh7I");

var $eygST = parcelRequire("eygST");
const $1ee40beb30eb4c49$var$sectionMessageStyles = {
    container: "_2rkoglpi _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
const $1ee40beb30eb4c49$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $1ee40beb30eb4c49$var$SectionMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, isDismissible: isDismissible, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $eJOHy.useState)(false);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        setDismissed(true);
    }, []);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $eygST.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $eJOHy.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $eJOHy.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ (0, $gt9Am.jsx)("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            $1ee40beb30eb4c49$var$sectionMessageStyles.container,
            $1ee40beb30eb4c49$var$appearanceStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1ee40beb30eb4c49$var$sectionMessageStyles.iconContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aRh7I.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    xcss: $1ee40beb30eb4c49$var$sectionMessageStyles.contentContainer,
                    children: [
                        !!title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $1ee40beb30eb4c49$var$sectionMessageStyles.content
                            ]),
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9M9zY.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $8XtVW.fg)('platform_ads_explicit_font_styles') && $1ee40beb30eb4c49$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9M9zY.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                }),
                isDismissible && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $1ee40beb30eb4c49$var$sectionMessageStyles.dismissButtonContainer
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                        testId: testId && `${testId}--dismiss-button`,
                        label: "Dismiss",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g17XP))),
                        appearance: "subtle",
                        onClick: handleDismiss,
                        spacing: "compact"
                    })
                })
            ]
        })
    });
});
$1ee40beb30eb4c49$var$SectionMessage.displayName = 'SectionMessage';
var $1ee40beb30eb4c49$export$2e2bcd8739ae039 = $1ee40beb30eb4c49$var$SectionMessage;

});
parcelRegister("eygST", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $6569b34ea74f05a3$export$e9b82d2e21ac0c1f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aVKq8 = parcelRequire("aVKq8");

var $cMyAt = parcelRequire("cMyAt");

var $Svlt9 = parcelRequire("Svlt9");

var $lU1m0 = parcelRequire("lU1m0");

var $gmIOk = parcelRequire("gmIOk");

var $kibFU = parcelRequire("kibFU");

var $8XtVW = parcelRequire("8XtVW");

const $6569b34ea74f05a3$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $135dba7912433cc2$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lU1m0))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $135dba7912433cc2$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $135dba7912433cc2$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kibFU))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $135dba7912433cc2$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $135dba7912433cc2$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $135dba7912433cc2$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $135dba7912433cc2$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gmIOk))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $135dba7912433cc2$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $135dba7912433cc2$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cMyAt))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $135dba7912433cc2$export$147899de772240ec)})`
    },
    discoveryUpdated: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $135dba7912433cc2$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aVKq8))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $135dba7912433cc2$export$147899de772240ec)})`
    }
};
function $6569b34ea74f05a3$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $6569b34ea74f05a3$var$appearanceIconSchema[appearance === 'discovery' && (0, $8XtVW.fg)('platform_dst_section_message_discovery_icon') ? 'discoveryUpdated' : appearance] || $6569b34ea74f05a3$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $gt9Am.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("aVKq8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79b7b06346630e2a8502fd6db80f47e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f533c6681701239$var$_react = $7f533c6681701239$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7f533c6681701239$var$_discovery = $7f533c6681701239$var$_interopRequireDefault((parcelRequire("2K8hI")));

var $7f533c6681701239$var$_note = $7f533c6681701239$var$_interopRequireDefault((parcelRequire("khuvd")));
function $7f533c6681701239$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f533c6681701239$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $7f533c6681701239$var$_react.default.createElement($7f533c6681701239$var$_discovery.default, Object.assign({
        LEGACY_fallbackIcon: $7f533c6681701239$var$_note.default
    }, props));
$7f533c6681701239$var$DiscoveryIcon.Name = 'DiscoveryIconMigration';
var $7f533c6681701239$var$_default = module.exports.default = $7f533c6681701239$var$DiscoveryIcon;

});
parcelRegister("2K8hI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffbdc778869407ee1ee67d41c1920845>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ff64dd38f5eb1a5$var$_react = $1ff64dd38f5eb1a5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1ff64dd38f5eb1a5$var$_baseNew = $1ff64dd38f5eb1a5$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $1ff64dd38f5eb1a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ff64dd38f5eb1a5$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $1ff64dd38f5eb1a5$var$_react.default.createElement($1ff64dd38f5eb1a5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$1ff64dd38f5eb1a5$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $1ff64dd38f5eb1a5$var$_default = module.exports.default = $1ff64dd38f5eb1a5$var$DiscoveryIcon;

});

parcelRegister("khuvd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec3d0e502b4f94da$var$_react = $ec3d0e502b4f94da$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $ec3d0e502b4f94da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ec3d0e502b4f94da$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $ec3d0e502b4f94da$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$ec3d0e502b4f94da$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $ec3d0e502b4f94da$var$_default = module.exports.default = $ec3d0e502b4f94da$var$EditorNoteIcon;

});




parcelRegister("hN3Oc", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ab64dd92055a31$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $26ab64dd92055a31$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});

});


parcelRegister("9dqYm", function(module, exports) {

$parcel$export(module.exports, "ActivePopupKeyContainer", () => $0498275d6a05dd5d$export$a23bda26408a297f);
$parcel$export(module.exports, "useActivePopupKey", () => $0498275d6a05dd5d$export$f374a0a655a12cf3);

var $gCeeo = parcelRequire("gCeeo");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $dTJxm = parcelRequire("dTJxm");
const $0498275d6a05dd5d$var$store = (0, $GtRbT.createStore)({
    initialState: {
        activeKey: ''
    },
    actions: {
        openPopup: (key)=>({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, onJourneyStart: onJourneyStart })=>{
                setState({
                    activeKey: key
                });
                if (onJourneyStart) {
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'opened',
                        actionSubject: 'dropdown'
                    });
                    const attributes = onJourneyStart();
                    // Only checking if it matches the "More +" dropdown.
                    // Not sending the key name directly as it would result in UGC for custom fields
                    attributes.isMoreFilters = String(key === (0, $dTJxm.ADD_FILTER_DROPDOWN));
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
                }
            },
        closePopup: (key)=>({ getState: getState, setState: setState })=>{
                const { activeKey: activeKey } = getState();
                if (key === activeKey) setState({
                    activeKey: ''
                });
            },
        closeAllPopups: ()=>({ setState: setState })=>{
                setState({
                    activeKey: ''
                });
            }
    },
    name: 'JQLBasic-ActivePopup'
});
const $0498275d6a05dd5d$export$a23bda26408a297f = (0, $6E16M.createContainer)($0498275d6a05dd5d$var$store, {});
const $0498275d6a05dd5d$export$f374a0a655a12cf3 = (0, $iJq0l.createHook)($0498275d6a05dd5d$var$store, {
    selector: ({ activeKey: activeKey })=>activeKey
});

});

parcelRegister("lzg2Z", function(module, exports) {

$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $cc4956edece29853$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $cc4956edece29853$export$97e3ca22c7078b46);

var $eJOHy = parcelRequire("eJOHy");
const $cc4956edece29853$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $cc4956edece29853$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $eJOHy.createContext)($cc4956edece29853$var$PRESET_VALUE.DEFAULT);
const $cc4956edece29853$export$705d46354f301b1c = ()=>(0, $eJOHy.useContext)($cc4956edece29853$var$IntegrateDotDialogContext);
const $cc4956edece29853$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc4956edece29853$var$IntegrateDotDialogContext.Provider, {
        value: $cc4956edece29853$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("hxooo", function(module, exports) {

$parcel$export(module.exports, "removeOptionalFieldsFromJql", () => $aef13f8f878a4e55$export$b5bca93ddaa14d75);

var $3c1PD = parcelRequire("3c1PD");
var $iTOA0 = parcelRequire("iTOA0");

var $jwox6 = parcelRequire("jwox6");
const $aef13f8f878a4e55$export$b5bca93ddaa14d75 = (ast, requiredFields, textSearchInputClause)=>{
    (0, $iTOA0.walkAST)({
        enterTerminalClause (terminalClause) {
            const isTextSearchInput = textSearchInputClause && new (0, $jwox6.IsInCompoundClauseVisitor)(terminalClause).visit(textSearchInputClause);
            if (!requiredFields.has(terminalClause.field.value.toLowerCase()) && !isTextSearchInput) terminalClause.remove();
        }
    }, ast);
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};

});
parcelRegister("iTOA0", function(module, exports) {

$parcel$export(module.exports, "walkAST", () => $c6ff2dcf3c5c4ee9$export$a8de6ce748deffac);
const $c6ff2dcf3c5c4ee9$export$a8de6ce748deffac = (listener, jast)=>{
    jast.query && $c6ff2dcf3c5c4ee9$var$walkNode(listener, jast.query);
};
const $c6ff2dcf3c5c4ee9$var$walkNode = (listener, node)=>{
    listener.enterEveryNode && listener.enterEveryNode(node);
    node.enterNode(listener);
    node.getChildren().forEach((child)=>$c6ff2dcf3c5c4ee9$var$walkNode(listener, child));
    node.exitNode(listener);
    listener.exitEveryNode && listener.exitEveryNode(node);
};

});

parcelRegister("jwox6", function(module, exports) {

$parcel$export(module.exports, "IsInCompoundClauseVisitor", () => $2eeee74e30a7e1d2$export$e2ad94bc9eac2e29);

var $7ivol = parcelRequire("7ivol");
class $2eeee74e30a7e1d2$export$e2ad94bc9eac2e29 extends (0, $7ivol.AbstractJastVisitor) {
    constructor(terminalClause){
        super(), this.visitCompoundClause = (compoundClause)=>compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), false), this.visitTerminalClause = (terminalClause)=>terminalClause === this.terminalClause, this.aggregateResult = (aggregate, nextResult)=>aggregate || nextResult;
        this.terminalClause = terminalClause;
    }
    defaultResult() {
        return false;
    }
}

});


parcelRegister("3XJDD", function(module, exports) {

$parcel$export(module.exports, "AddFilter", () => $e3217184ed46e165$export$b317d04196c5962b);

var $eJOHy = parcelRequire("eJOHy");

var $FO5HY = parcelRequire("FO5HY");

var $dKpTa = parcelRequire("dKpTa");

var $7qVFB = parcelRequire("7qVFB");

var $h8epd = parcelRequire("h8epd");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $d9b92 = parcelRequire("d9b92");

var $jd93d = parcelRequire("jd93d");

var $ch9En = parcelRequire("ch9En");

var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $gzcjr = parcelRequire("gzcjr");

var $ixh2S = parcelRequire("ixh2S");

var $izTXQ = parcelRequire("izTXQ");

var $9dqYm = parcelRequire("9dqYm");

var $lyPdT = parcelRequire("lyPdT");

var $4G98k = parcelRequire("4G98k");

var $2ftMY = parcelRequire("2ftMY");

var $3SxQz = parcelRequire("3SxQz");

var $ce3v0 = parcelRequire("ce3v0");

var $dTJxm = parcelRequire("dTJxm");

var $4kCrw = parcelRequire("4kCrw");

const $e3217184ed46e165$export$f5aa183e0b797cbf = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eurzt")), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic-picker/src/index.tsx"
});
const $e3217184ed46e165$var$TriggerButtonWithMergeRef = ({ triggerRef: triggerRef, popupRef: popupRef, ButtonComponent: ButtonComponent, ...props })=>{
    const ref = (0, $jd93d.default)(triggerRef, popupRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ButtonComponent, {
        ref: ref,
        ...props
    });
};
const $e3217184ed46e165$var$isKeyboardEvent = (event)=>Object.hasOwn(event, 'key');
const $e3217184ed46e165$export$b317d04196c5962b = ({ value: value, fieldsToRender: fieldsToRender, selectedFields: selectedFields, onSearchWrapper: onSearchWrapper, onClearValues: onClearValues, NoOptionComponent: NoOptionComponent, onChange: onChange, excludeFields: excludeFields, contextJql: contextJql, viewContext: viewContext, scope: scope, ButtonComponent: ButtonComponent = (0, $dKpTa.default) })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup }] = (0, $9dqYm.useActivePopupKey)();
    const onOpen = (0, $eJOHy.useCallback)(()=>openPopup((0, $dTJxm.ADD_FILTER_DROPDOWN)), [
        openPopup
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>closePopup((0, $dTJxm.ADD_FILTER_DROPDOWN)), [
        closePopup
    ]);
    const [ast] = (0, $lyPdT.useAST)();
    const [textSearchInputClause] = (0, $lyPdT.useTextSearchInputClause)();
    const excludedFields = (0, $eJOHy.useMemo)(()=>Array.from(excludeFields), [
        excludeFields
    ]);
    const onLoadOptions = (0, $2ftMY.useFields)({
        jql: contextJql,
        excludeFields: excludedFields,
        viewContext: viewContext,
        scope: scope
    });
    const isOpen = activePopupKey === (0, $dTJxm.ADD_FILTER_DROPDOWN);
    const sendAnalytics = (0, $ce3v0.useSendAnalytics)();
    const buttonRef = (0, $eJOHy.useRef)(null);
    const iconAfter = (0, $eJOHy.useMemo)(()=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($FO5HY))), {
            label: "",
            color: // eslint-disable-next-line no-nested-ternary
            (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? !isOpen ? "var(--ds-icon-subtle, #626F86)" : 'currentColor' : 'currentColor',
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7qVFB))), {
            label: "",
            LEGACY_size: "small"
        }), [
        isOpen
    ]);
    const buttonLabel = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line no-nested-ternary
        return (0, $6XJko.isVisualRefreshEnabled)() ? (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
            weight: "medium",
            color: !isOpen ? 'color.text.subtle' : 'inherit'
        }, formatMessage((0, $izTXQ.default).moreButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $izTXQ.default).moreButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $izTXQ.default).moreButtonOld));
    }, [
        isOpen,
        formatMessage
    ]);
    const loadingMessages = (0, $eJOHy.useMemo)(()=>{
        return (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') ? {
            paginationStart: formatMessage((0, $4kCrw.default).loadingMessageStart),
            paginationEnd: formatMessage((0, $4kCrw.default).loadingMessageEnd)
        } : undefined;
    }, [
        formatMessage
    ]);
    const handleClose = (0, $eJOHy.useCallback)((event)=>{
        onClose();
        if ($e3217184ed46e165$var$isKeyboardEvent(event) && event.key === 'Escape') buttonRef.current?.focus();
    }, [
        onClose
    ]);
    const CustomNoOptionsMessage = (0, $eJOHy.useCallback)(()=>NoOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NoOptionComponent, {
            onClickLink: onClose,
            sourceId: "moreFieldsPicker"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
            actionSubject: "unsupportedFieldsMessage",
            action: "viewed",
            actionSubjectId: "moreFieldsPicker"
        })) : undefined, [
        NoOptionComponent,
        onClose
    ]);
    const onTrigger = (0, $eJOHy.useCallback)(({ ref: ref })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3217184ed46e165$var$TriggerButtonWithMergeRef, {
            triggerRef: buttonRef,
            popupRef: ref,
            appearance: "default",
            iconAfter: iconAfter,
            isSelected: isOpen,
            "aria-expanded": isOpen,
            onClick: isOpen ? onClose : onOpen,
            label: formatMessage((0, $izTXQ.default).moreButtonLabel),
            "aria-label": formatMessage((0, $izTXQ.default).moreButtonLabel),
            testId: "jql-builder-basic.ui.jql-editor.add-filter.more-button",
            ButtonComponent: ButtonComponent
        }, buttonLabel);
    }, [
        iconAfter,
        isOpen,
        onClose,
        onOpen,
        formatMessage,
        ButtonComponent,
        buttonLabel
    ]);
    const handleChange = (0, $eJOHy.useCallback)((options, meta)=>{
        switch(meta.action){
            case (0, $d9b92.MetaActions).selectOption:
                if ('option' in meta && meta.option?.optionType === 'field') {
                    const newSelectedFields = [
                        ...selectedFields,
                        meta.option
                    ];
                    const picker = (0, $4G98k.getPickerType)({
                        fieldType: meta.option.fieldType,
                        searchTemplate: meta.option.searchTemplate,
                        operators: meta.option.operators
                    });
                    const newFieldsToRender = [
                        ...fieldsToRender,
                        {
                            fieldId: meta.option.value,
                            fieldLabel: meta.option.label,
                            picker: picker,
                            clause: undefined,
                            secondaryClause: undefined,
                            fieldDescription: meta.option.fieldDescription,
                            fieldTypeDisplayName: meta.option.fieldTypeDisplayName
                        }
                    ];
                    onChange({
                        selectedFields: newSelectedFields,
                        fieldsToRender: newFieldsToRender
                    });
                    openPopup(meta.option.value);
                    sendAnalytics({
                        actionSubjectId: 'addFilter',
                        attributes: {
                            fieldType: picker.fieldType,
                            searchTemplate: picker.searchTemplate,
                            refinementType: picker.pickerType,
                            propType: picker.propType
                        }
                    });
                }
                break;
            case (0, $d9b92.MetaActions).deselectOption:
                if ('option' in meta && meta.option?.optionType === 'field' && !meta.option.isDisabled) {
                    const newSelectedFields = selectedFields.filter((activeField)=>meta.option?.optionType === 'field' && meta.option.value !== activeField.value);
                    const newFieldsToRender = fieldsToRender.filter((fieldToRender)=>{
                        if (meta.option?.optionType === 'field' && meta.option?.value === fieldToRender.fieldId) {
                            onSearchWrapper && onSearchWrapper((0, $3SxQz.removeFieldsFromJql)(ast, new Set([
                                fieldToRender.fieldId
                            ]), textSearchInputClause));
                            return !!(fieldToRender.secondaryClause || fieldToRender.clause);
                        }
                        return true;
                    });
                    onChange({
                        selectedFields: newSelectedFields,
                        fieldsToRender: newFieldsToRender
                    });
                    const picker = (0, $4G98k.getPickerType)({
                        fieldType: meta.option.fieldType,
                        searchTemplate: meta.option.searchTemplate,
                        operators: meta.option.operators
                    });
                    sendAnalytics({
                        actionSubjectId: 'removeFilter',
                        attributes: {
                            fieldType: picker.fieldType,
                            searchTemplate: picker.searchTemplate,
                            refinementType: picker.pickerType,
                            propType: picker.propType,
                            isOnlyUnselectable: meta.option.isOnlyUnselectable ?? false
                        }
                    });
                }
                break;
            default:
        }
    }, [
        ast,
        fieldsToRender,
        onChange,
        onSearchWrapper,
        openPopup,
        textSearchInputClause,
        selectedFields,
        sendAnalytics
    ]);
    const TriggerButton = ButtonComponent ?? (0, $dKpTa.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('render_jql_builder_in_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: (0, $dTJxm.ADD_FILTER_DROPDOWN),
        onChange: handleChange,
        onLoadOptions: onLoadOptions,
        enableFullList: false,
        onTrigger: onTrigger,
        onClearValues: onClearValues,
        CustomNoOptionsMessage: CustomNoOptionsMessage,
        shouldRenderToParent: true,
        searchInputPlaceholder: formatMessage((0, $izTXQ.default).searchMoreFiltersPlaceholder),
        loadingMessages: loadingMessages
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "add-filter-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TriggerButton, {
            iconAfter: iconAfter
        }, buttonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e3217184ed46e165$export$f5aa183e0b797cbf, {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: (0, $dTJxm.ADD_FILTER_DROPDOWN),
        onChange: handleChange,
        onLoadOptions: onLoadOptions,
        enableFullList: false,
        onTrigger: onTrigger,
        onClearValues: onClearValues,
        CustomNoOptionsMessage: CustomNoOptionsMessage,
        shouldRenderToParent: true,
        searchInputPlaceholder: formatMessage((0, $izTXQ.default).searchMoreFiltersPlaceholder),
        loadingMessages: loadingMessages
    })));
};
var $e3217184ed46e165$export$2e2bcd8739ae039 = $e3217184ed46e165$export$b317d04196c5962b;

});
parcelRegister("d9b92", function(module, exports) {

$parcel$export(module.exports, "MetaActions", () => $5ca44d217725f710$export$50531cf3046c5956);
const $5ca44d217725f710$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("ixh2S", function(module, exports) {

$parcel$export(module.exports, "Picker", () => $e80b57c94adae16a$export$ba25329847403e11);

var $eJOHy = parcelRequire("eJOHy");

var $5UxOh = parcelRequire("5UxOh");

var $dhRXV = parcelRequire("dhRXV");

var $7jTnu = parcelRequire("7jTnu");

var $d0VAM = parcelRequire("d0VAM");

var $hEe9x = parcelRequire("hEe9x");

var $5LwVz = parcelRequire("5LwVz");
const $e80b57c94adae16a$export$ba25329847403e11 = ({ isOpen: isPickerOpen, value: value, onClose: onClose, onClearValues: onClearValues, onRestoreDefaults: onRestoreDefaults, id: id, invalidLabel: invalidLabel, onChange: onChange, onSortOptions: onSortOptions, formatOptionLabel: formatOptionLabel = (0, $hEe9x.default), onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, PopupComponent: PopupComponent, onTrigger: onTrigger, placement: placement = 'bottom-start', zIndex: zIndex, CustomNoOptionsMessage: CustomNoOptionsMessage, pickerComponents: pickerComponents, fallbackPlacements: fallbackPlacements, showOperatorSelect: showOperatorSelect = false, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchInputPlaceholder: searchInputPlaceholder, shouldRenderToParent: shouldRenderToParent = false, experienceAnalyticsAttributes: experienceAnalyticsAttributes, isLoading: isLoading = false, CustomFooter: CustomFooter, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false, loadingMessages: loadingMessages, renderFooter: renderFooter })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        role: "presentation",
        onKeyDown: (event)=>{
            if (event.key === 'Escape') {
                // avoid closing a modal on closing a picker with esc key
                isPickerOpen && event.stopPropagation();
                onClose && onClose(event);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5UxOh.default), {
        key: id,
        zIndex: zIndex,
        placement: placement,
        isOpen: isPickerOpen,
        onClose: onClose,
        popupComponent: PopupComponent ?? (0, $5LwVz.FixedWidthPopupComponent),
        trigger: onTrigger,
        autoFocus: false,
        fallbackPlacements: fallbackPlacements,
        testId: `jql-builder-basic-picker-${id}`,
        shouldRenderToParent: shouldRenderToParent,
        /* Our default popup component supports resizing to fit the viewport. */ shouldFitViewport: PopupComponent === undefined,
        // eslint-disable-next-line jira/import/no-direct-popup
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d0VAM.default), {
                id: id,
                invalidLabel: invalidLabel,
                enableFullList: enableFullList,
                operandDisplayValues: operandDisplayValues,
                showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
                loadOptions: onLoadOptions,
                onChange: onChange,
                onSortOptions: onSortOptions,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                onRestoreDefaults: onRestoreDefaults,
                NoOptionsMessage: CustomNoOptionsMessage,
                components: pickerComponents,
                showOperatorSelect: showOperatorSelect,
                onChangeOperator: onChangeOperator,
                allowedOperators: allowedOperators,
                selectedOperator: selectedOperator,
                isMulti: isMulti,
                placeholder: searchInputPlaceholder,
                setInitialFocusRef: setInitialFocusRef,
                experienceAnalyticsAttributes: experienceAnalyticsAttributes,
                isLoading: isLoading,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                CustomFooter: // eslint-disable-next-line jira/ff/no-preconditioning
                (0, $7jTnu.fg)('jira_inline_field_config_gate') && !(0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates') ? CustomFooter : undefined,
                loadingMessages: loadingMessages,
                renderFooter: // eslint-disable-next-line jira/ff/no-preconditioning
                (0, $7jTnu.fg)('jira_inline_field_config_gate') && (0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates') ? renderFooter : undefined
            })
    }));
$e80b57c94adae16a$export$ba25329847403e11.whyDidYouRender = {
    customName: 'Picker'
};

});
parcelRegister("d0VAM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc6c8c7998de8b9$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gyBpf = parcelRequire("gyBpf");

var $cSmYj = parcelRequire("cSmYj");

var $2ZGUP = parcelRequire("2ZGUP");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $9cbmy = parcelRequire("9cbmy");

var $gMbEk = parcelRequire("gMbEk");

var $j8m5Z = parcelRequire("j8m5Z");

var $f3ko0 = parcelRequire("f3ko0");

var $f1iCr = parcelRequire("f1iCr");

var $1fUys = parcelRequire("1fUys");

var $5lNLi = parcelRequire("5lNLi");

var $j7wtI = parcelRequire("j7wtI");

var $fSowc = parcelRequire("fSowc");

var $icknm = parcelRequire("icknm");

var $bWslp = parcelRequire("bWslp");

var $7XraK = parcelRequire("7XraK");
const $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $8bc6c8c7998de8b9$var$selectStyles = {
    container: (baseStyles)=>({
            ...baseStyles,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        })
};
const $8bc6c8c7998de8b9$var$getLoadingMessage = ({ isLoadingPaginationStart: isLoadingPaginationStart, isLoadingPaginationEnd: isLoadingPaginationEnd, loadingMessages: loadingMessages, formatMessage: formatMessage })=>{
    if (isLoadingPaginationStart) return loadingMessages?.paginationStart || formatMessage((0, $7XraK.default).loadingStart);
    if (isLoadingPaginationEnd) return loadingMessages?.paginationEnd || formatMessage((0, $7XraK.default).loadingEnd);
    return undefined;
};
const $8bc6c8c7998de8b9$export$f2aa4c50966ce803 = ()=>(0, $eJOHy.useState)(false);
const $8bc6c8c7998de8b9$var$PaginatedAsyncSelectView = ({ id: id, onMenuScrollToBottom: onMenuScrollToBottom, onMenuScrollToTop: onMenuScrollToTop, placeholder: placeholder, invalidLabel: invalidLabel, enableFullList: enableFullListProp, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, loadOptions: loadOptions, onInputChange: onInputChange, value: value, onChange: onChange, onChangeOperator: onChangeOperator, onSortOptions: onSortOptions, onClear: onClear, onRestoreDefaults: onRestoreDefaults, components: customComponents, showOperatorSelect: showOperatorSelect, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, isLoading: isLoadingExternal, CustomFooter: CustomFooter, onKeyDown: onKeyDown, loadingMessages: loadingMessages, renderFooter: renderFooter, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const paginatedComponents = (0, $eJOHy.useMemo)(()=>({
            ...(0, $j7wtI.selectComponents),
            MenuList: $f3ko0.MenuList
        }), []);
    const paginatedSingleSelectComponents = (0, $eJOHy.useMemo)(()=>({
            ...(0, $j7wtI.singleSelectComponents),
            Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fSowc.default), {
                    ...props,
                    isMulti: false
                }),
            MenuList: $f3ko0.MenuList
        }), []);
    const [isLoadingInternal, setIsLoading] = (0, $eJOHy.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix' // eslint-disable-next-line react-hooks/react-compiler
    ) // eslint-disable-next-line react-hooks/rules-of-hooks
     ? $8bc6c8c7998de8b9$export$f2aa4c50966ce803() : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useState)(false);
    const [inputValue, setInputValue] = (0, $eJOHy.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $eJOHy.useState)([]);
    const rollbackOptionsRef = (0, $eJOHy.useRef)(loadedOptions);
    const [enableFullList, setEnableFullList] = (0, $eJOHy.useState)(enableFullListProp || false);
    const [totalCount, setTotalCount] = (0, $eJOHy.useState)(null);
    const [endCursor, setEndCursor] = (0, $eJOHy.useState)(undefined);
    const loadingScreenMessage = (0, $eJOHy.useRef)(undefined);
    const [error, setError] = (0, $eJOHy.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const isLoading = isLoadingInternal || isLoadingExternal;
    if ((0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix')) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const prevIsPaginationLoading = (0, $6d9QY.usePreviousWithInitial)(isPaginationLoading);
        const hasFinishedPaginationLoading = prevIsPaginationLoading && !isPaginationLoading;
        loadingScreenMessage.current = $8bc6c8c7998de8b9$var$getLoadingMessage({
            isLoadingPaginationStart: Boolean(isPaginationLoading && !prevIsPaginationLoading),
            isLoadingPaginationEnd: hasFinishedPaginationLoading,
            loadingMessages: loadingMessages,
            formatMessage: formatMessage
        });
    }
    const searchRef = (0, $eJOHy.useRef)('');
    const isColumnChangeInProgress = (0, $eJOHy.useRef)(false);
    const itemCount = (0, $eJOHy.useMemo)(()=>loadedOptions.flatMap((option)=>option.optionType === 'group' ? option.options : option).length, [
        loadedOptions
    ]);
    const getTotalCountWithFunctions = (0, $eJOHy.useCallback)((newTotalCount)=>{
        if (newTotalCount === null || !operandDisplayValues?.length) return newTotalCount;
        let newTotalCountWithKeywords;
        if (showOperandDisplayValuesInFullList === true) newTotalCountWithKeywords = newTotalCount + operandDisplayValues.length;
        else newTotalCountWithKeywords = newTotalCount + value.filter((option)=>(0, $gMbEk.isSingleValueOption)(option) && operandDisplayValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $8bc6c8c7998de8b9$var$MAX_TOTAL_COUNT;
    }, [
        operandDisplayValues,
        showOperandDisplayValuesInFullList,
        value
    ]);
    const checkIfError = (0, $eJOHy.useCallback)((search, options, onRetry)=>{
        const errorOption = options.find((option)=>option.optionType === 'error' && option.error instanceof Error);
        if (errorOption && errorOption.optionType === 'error') {
            setError({
                isError: true,
                error: errorOption.error,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $eJOHy.useCallback)((search, overridenValue, renderInitialValues = enableFullList)=>{
        if (!loadOptions) return;
        searchRef.current = search;
        setIsLoading(true);
        loadOptions(search, renderInitialValues, undefined, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            // Handle error
            if (checkIfError(search, options, ()=>{
                handleLoadOptions(search);
            })) return; // This is to prevent outdated options/results from overriding if a race condition occurs
            if (searchRef.current !== search) return;
            if (search) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, options)) {
                    setLoadedOptions(options);
                    setTotalCount(newTotalCount);
                }
            } else {
                const newLoadedOptions = (0, $bWslp.generateOptions)([
                    ...overridenValue ?? value
                ], options);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(loadedOptions, newLoadedOptions)) {
                    setLoadedOptions(newLoadedOptions);
                    setTotalCount(getTotalCountWithFunctions(newTotalCount));
                }
            }
            setEndCursor(newEndCursor);
            setIsLoading(false);
        });
    }, [
        loadOptions,
        enableFullList,
        checkIfError,
        value,
        loadedOptions,
        getTotalCountWithFunctions
    ]);
    const handleShowMore = (0, $eJOHy.useCallback)((firstLoad = false, isRetry = false)=>{
        if (!loadOptions || !loadedOptions) return;
        let originalLoadedOptions;
        if (firstLoad) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, endCursor, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(firstLoad, true);
            })) return;
            const newLoadedOptions = inputValue ? originalLoadedOptions.concat(options) : (0, $bWslp.generateOptions)(value, options, originalLoadedOptions, firstLoad);
            setEnableFullList(false);
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setLoadedOptions(newLoadedOptions);
            setIsPaginationLoading(false);
            setIsLoading(false);
            setEndCursor(newEndCursor);
        });
    }, [
        loadOptions,
        loadedOptions,
        inputValue,
        endCursor,
        checkIfError,
        value,
        getTotalCountWithFunctions,
        setIsPaginationLoading
    ]);
    const handleShowFullList = (0, $eJOHy.useCallback)(()=>{
        handleShowMore(true);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $eJOHy.useCallback)((newInputValue)=>{
        // on empty search: reset to default state for pickers where enableFullListProp==true
        if (newInputValue.length === 0 && enableFullListProp) {
            setEnableFullList(true);
            handleLoadOptions(newInputValue, undefined, true);
        } else {
            setEnableFullList(false);
            handleLoadOptions(newInputValue);
        }
        setInputValue(newInputValue);
        onInputChange && onInputChange();
    }, [
        enableFullListProp,
        handleLoadOptions,
        onInputChange
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((options, meta)=>{
        if (!isColumnChangeInProgress.current && (0, $7jTnu.fg)('jira_inline_field_config_gate')) {
            isColumnChangeInProgress.current = true;
            rollbackOptionsRef.current = loadedOptions;
        }
        if ('option' in meta && meta.option) {
            const selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($gyBpf)))(loadedOptions, (option)=>(0, $gMbEk.isSingleValueOption)(option) && meta.option !== undefined && (0, $gMbEk.isSingleValueOption)(meta.option) && option.value === meta.option.value);
            onChange && onChange(options, meta, {
                selectedIndex: selectedIndex
            }, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? ()=>{
                isColumnChangeInProgress.current = false;
            } : undefined, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? ()=>{
                setLoadedOptions(rollbackOptionsRef.current);
                isColumnChangeInProgress.current = false;
            } : undefined);
        } else onChange && onChange(options, meta, undefined, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? ()=>{
            isColumnChangeInProgress.current = false;
        } : undefined, (0, $7jTnu.fg)('jira_inline_field_config_gate') ? ()=>{
            setLoadedOptions(rollbackOptionsRef.current);
            isColumnChangeInProgress.current = false;
        } : undefined);
    }, [
        onChange,
        loadedOptions
    ]);
    const handleOnRestoreDefaults = (0, $eJOHy.useCallback)(()=>{
        if (typeof onRestoreDefaults === 'function') {
            const defaultOptions = onRestoreDefaults(); // Reset picker input and force update of options to go back to an initial-like state where selected options are on top
            setInputValue('');
            handleLoadOptions('', defaultOptions);
        }
    }, [
        handleLoadOptions,
        onRestoreDefaults
    ]); // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>{
        handleLoadOptions(''); // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsWithFullList = (0, $eJOHy.useMemo)(()=>{
        let newLoadedOptions = loadedOptions;
        if (onSortOptions && !(0, $7jTnu.fg)('jira_inline_field_config_gate') && (0, $7jTnu.fg)('jira_list_merged_column_gate')) newLoadedOptions = onSortOptions(newLoadedOptions);
        return (0, $bWslp.addFullListToOptions)(newLoadedOptions, !enableFullList, onSortOptions);
    }, [
        loadedOptions,
        enableFullList,
        onSortOptions
    ]);
    const components = (0, $eJOHy.useMemo)(()=>isMulti ? {
            ...paginatedComponents,
            ...customComponents
        } : {
            ...paginatedSingleSelectComponents,
            ...customComponents
        }, [
        customComponents,
        isMulti,
        paginatedComponents,
        paginatedSingleSelectComponents
    ]);
    const selectedValue = (0, $eJOHy.useMemo)(/**
   * This method is to form the value from loadedOptionsWithFullList Array so that the 'Options' and 'Value' props of
   * select component will have same object references, This is a workaround to meet the below condition in the '@atlaskit/select'
   * component's ariaFocused method
   * var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));.
   * This condition must work to announce the state of selection.
   *
   * The below method can be removed if the above condition is improved to check just the value instead of reference.
   */ ()=>(0, $bWslp.getValueFromOptions)(loadedOptionsWithFullList, value), [
        loadedOptionsWithFullList,
        value
    ]);
    const showFooterType = (0, $eJOHy.useMemo)(()=>{
        const showFooter = !isLoading && loadedOptions && Boolean(loadedOptions.length) && !error.isError;
        if (showFooter) {
            if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) {
                if (CustomFooter != null || renderFooter != null && (0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates')) return 'custom';
            }
            return 'default';
        }
    }, [
        CustomFooter,
        error.isError,
        isLoading,
        loadedOptions,
        renderFooter
    ]);
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (isPaginationLoading && event.key === 'ArrowUp' || isPaginationLoading && event.key === 'ArrowDown' || isLoading && event.key === 'ArrowUp' || isLoading && event.key === 'ArrowDown') {
            // prevent focusing first option when loading of more options
            event.preventDefault();
            return;
        }
        onKeyDown?.(event);
    }, [
        isLoading,
        isPaginationLoading,
        onKeyDown
    ]);
    const footerComponent = (0, $eJOHy.useMemo)(()=>{
        if (renderFooter && (0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates')) return renderFooter(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1fUys.SimplePaginationDetails), {
            itemsCount: itemCount,
            totalCount: totalCount
        }));
        return CustomFooter;
    }, [
        renderFooter,
        CustomFooter,
        itemCount,
        totalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showOperatorSelect && onChangeOperator && allowedOperators && Boolean(allowedOperators.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f1iCr.OperatorsSelect), {
        onChange: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j7wtI.BaseSelect), {
        components: components,
        inputValue: inputValue,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: onMenuScrollToBottom,
        onMenuScrollToTop: onMenuScrollToTop,
        placeholder: placeholder,
        id: id,
        invalidLabel: invalidLabel,
        options: loadedOptionsWithFullList,
        setInitialFocusRef: setInitialFocusRef,
        menuListProps: {
            error: error,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            isShowMoreEnabled: totalCount !== null && itemCount < totalCount
        },
        onChange: handleOnChange,
        value: selectedValue,
        styles: $8bc6c8c7998de8b9$var$selectStyles,
        ...restProps,
        isMulti: isMulti,
        totalCount: totalCount,
        onKeyDown: handleOnKeyDown
    }), showFooterType === 'default' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bc6c8c7998de8b9$var$Footer, null, onRestoreDefaults !== undefined ? typeof onRestoreDefaults === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5lNLi.default), {
        onRestoreDefaults: handleOnRestoreDefaults
    }) : Boolean(value.length) && isMulti && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j8m5Z.default), {
        onClear: onClear
    }), (!value.length || !isMulti) && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $icknm.default), {
        onShowFullList: handleShowFullList
    }), !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1fUys.PaginationDetails), {
        itemsCount: itemCount,
        totalCount: totalCount
    })), showFooterType === 'custom' && footerComponent, loadingScreenMessage.current && (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, loadingScreenMessage.current), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null));
};
var $8bc6c8c7998de8b9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8bc6c8c7998de8b9$var$PaginatedAsyncSelectView;
const $8bc6c8c7998de8b9$var$Footer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dog0l8 _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3i1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gyBpf", function(module, exports) {

var $9gUEB = parcelRequire("9gUEB");

var $1lM9j = parcelRequire("1lM9j");

var $c9FP3 = parcelRequire("c9FP3");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c0dcd66d5aa7faa7$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c0dcd66d5aa7faa7$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $c9FP3(fromIndex);
    if (index < 0) index = $c0dcd66d5aa7faa7$var$nativeMax(length + index, 0);
    return $9gUEB(array, $1lM9j(predicate, 3), index);
}
module.exports = $c0dcd66d5aa7faa7$var$findIndex;

});

parcelRegister("gMbEk", function(module, exports) {

$parcel$export(module.exports, "isSingleValueOption", () => $282a6706fedd463a$export$35faed52a6bc243e);
const $282a6706fedd463a$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});

parcelRegister("j8m5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ce8dc8742c8663f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $aFyWG = parcelRequire("aFyWG");

var $6vNSg = parcelRequire("6vNSg");
const $4ce8dc8742c8663f$export$1d4b7cda9e589b53 = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClearSelectedItems = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'filterSearchClearSelectedItems', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onClear && onClear();
    }, [
        onClear
    ]);
    const message = formatMessage((0, $6vNSg.default).clearAllSelectedItemsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.clear-selection-button.clear-selected-items",
        hasTooltip: true
    });
};
var $4ce8dc8742c8663f$export$2e2bcd8739ae039 = $4ce8dc8742c8663f$export$1d4b7cda9e589b53;

});
parcelRegister("aFyWG", function(module, exports) {

$parcel$export(module.exports, "LeftFooterButton", () => $0affafe94b46ba2e$export$edc8e1365283b1f0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $9JB3T = parcelRequire("9JB3T");

var $6XJko = parcelRequire("6XJko");
const $0affafe94b46ba2e$export$edc8e1365283b1f0 = ({ message: message, onClick: onClick, testId: testId, appearance: appearance, hasTooltip: hasTooltip, label: label })=>{
    const shouldApplyVisualRefresh = (0, $6XJko.isVisualRefreshEnabled)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId
    }, message);
    if (!hasTooltip) {
        if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            padding: "space.050",
            xcss: $0affafe94b46ba2e$var$leftFooterButtonContainerStyles
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0affafe94b46ba2e$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
            appearance: appearance,
            onClick: onClick,
            testId: testId
        }, message));
    }
    if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        padding: "space.050",
        xcss: $0affafe94b46ba2e$var$leftFooterButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: message
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0affafe94b46ba2e$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId,
        ...label && {
            'aria-label': label
        }
    }, message)));
};
const $0affafe94b46ba2e$var$leftFooterButtonContainerStyles = (0, $5Wv5g.xcss)({
    overflow: 'hidden',
    marginInlineStart: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0affafe94b46ba2e$var$LeftFooterButtonContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _ahbqu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6vNSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $069e3a8465402294$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $069e3a8465402294$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    clearAllSelectedItemsButtonText: {
        "id": "jql-builder-basic-picker.async-select.clear-selection-button.clear-all-selected-items-button-text",
        "defaultMessage": "Clear selection"
    }
});

});


parcelRegister("f3ko0", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $810d101605fb454f$export$d4c4e98c5044dc8);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $j3gIc = parcelRequire("j3gIc");

var $gCeeo = parcelRequire("gCeeo");

var $4P0pd = parcelRequire("4P0pd");

var $9LD2u = parcelRequire("9LD2u");

var $lhCeH = parcelRequire("lhCeH");
const $810d101605fb454f$export$d4c4e98c5044dc8 = (props)=>{
    const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, isShowMoreEnabled: isShowMoreEnabled } } } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleOnShowMore = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'options',
            action: 'scrolled'
        }), 'filterSearchShowMore');
        handleShowMore();
    }, [
        handleShowMore,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).MenuList, props, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LD2u.default), null), !isLoading && isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4P0pd.default), {
        onRetry: onRetry
    }), !isLoading && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children, isShowMoreEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lhCeH.default), {
        onShowMore: handleOnShowMore,
        isPaginationLoading: isPaginationLoading
    }))));
};
var $810d101605fb454f$export$2e2bcd8739ae039 = $810d101605fb454f$export$d4c4e98c5044dc8;

});
parcelRegister("4P0pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $068e9aea02769269$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $Svlt9 = parcelRequire("Svlt9");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $cb8jR = parcelRequire("cb8jR");

var $ipK0z = parcelRequire("ipK0z");
const $068e9aea02769269$var$ErrorMessage = ({ onRetry: onRetry })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        onRetry?.();
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'refinementBarSelectRetry clicked');
    }, [
        onRetry,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 144,
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.error-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))), {
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, formatMessage((0, $ipK0z.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        onClick: onClick,
        appearance: "link",
        testId: "jql-builder-basic-picker.ui.async-select.menu-list.error-message.retry-button"
    }, formatMessage((0, $ipK0z.default).retryMessage)));
};
var $068e9aea02769269$export$2e2bcd8739ae039 = $068e9aea02769269$var$ErrorMessage;

});
parcelRegister("cb8jR", function(module, exports) {

$parcel$export(module.exports, "StyledBox", () => $965991b8073d69d7$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $965991b8073d69d7$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $965991b8073d69d7$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $965991b8073d69d7$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $965991b8073d69d7$export$6833d6d22987ee7f);
$parcel$export(module.exports, "CustomOptionStyles", () => $965991b8073d69d7$export$fa3694617a82202b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $bvFRW = parcelRequire("bvFRW");
const $965991b8073d69d7$export$d675f139b342d51a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $awdRS.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $awdRS.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1qr7",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$var$StyledTextComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($965991b8073d69d7$var$StyledTextComponent, props));
const $965991b8073d69d7$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl1pvm _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$94756becb802e330 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_80omtlke _30l31bsc",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { displayFlag: displayFlag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.displayFlag ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $965991b8073d69d7$export$fa3694617a82202b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasIconAfter: hasIconAfter, isSingleSelect: isSingleSelect, isFocused: isFocused, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kfm9xv": (0, $awdRS.default)(__cmplp.isFocused ? `inset 2px 0px 0px ${"var(--ds-border-focused, #388BFF)"}` : 'none'),
            "--_1p23kyf": (0, $awdRS.default)(__cmplp.isDisabled ? 'color.text.disabled' : 'color.text')
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _dzc2v2br _m3zku2gc",
            __cmplp.hasIconAfter ? "_sktr1ejb" : "_sktrze3t",
            __cmplp.isSingleSelect && "_bp7o1fcu _ngc03plq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ipK0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0214a23e274561c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c0214a23e274561c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.retry-message",
        "defaultMessage": "Click to retry"
    }
});

});


parcelRegister("9LD2u", function(module, exports) {

$parcel$export(module.exports, "default", () => $da95119f1df2e865$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $dPlS8 = parcelRequire("dPlS8");

var $kDaaB = parcelRequire("kDaaB");

var $cb8jR = parcelRequire("cb8jR");

var $dyWxb = parcelRequire("dyWxb");
const $da95119f1df2e865$export$e928a71d039d3102 = ()=>// eslint disabled because it is valid for options, see recommended https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/no-noninteractive-element-to-interactive-role.md
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "li",
        xcss: $da95119f1df2e865$var$listItemStyle,
        role: "option",
        "aria-selected": false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.loading-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $dyWxb.default).loadingMessage))));
var $da95119f1df2e865$export$2e2bcd8739ae039 = $da95119f1df2e865$export$e928a71d039d3102;
const $da95119f1df2e865$var$listItemStyle = (0, $5Wv5g.xcss)({
    listStyle: 'none'
});

});
parcelRegister("dyWxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9012dc4eef88d2fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9012dc4eef88d2fd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.loading-message.loading-message",
        "defaultMessage": "Loading..."
    }
});

});


parcelRegister("lhCeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $553b58ca6b88f3b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $dPlS8 = parcelRequire("dPlS8");

var $lRq8t = parcelRequire("lRq8t");

var $1R4YX = parcelRequire("1R4YX");

var $7jTnu = parcelRequire("7jTnu");

var $aJkOP = parcelRequire("aJkOP");
const $553b58ca6b88f3b1$var$LoadMoreTrigger = ({ onShowMore: onShowMore, isPaginationLoading: isPaginationLoading })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadingRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    const loadMoreRef = (0, $1R4YX.useIntersectionObserver)({
        margin: (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') ? 0 : 10,
        onIntersection: ()=>{
            if (!isPaginationLoading) {
                (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') && loadingRef?.current?.scrollIntoView();
                onShowMore();
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        role: "option",
        "aria-hidden": "true",
        "aria-selected": false,
        ref: loadingRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        xcss: $553b58ca6b88f3b1$var$loadingContainerStyles,
        justifyContent: "center",
        alignItems: "center",
        ref: loadMoreRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPlS8.default), {
        label: formatMessage((0, $aJkOP.default).loadingLabel)
    })));
};
const $553b58ca6b88f3b1$var$loadingContainerStyles = (0, $5Wv5g.xcss)({
    height: '56px'
});
var $553b58ca6b88f3b1$export$2e2bcd8739ae039 = $553b58ca6b88f3b1$var$LoadMoreTrigger;

});
parcelRegister("1R4YX", function(module, exports) {

$parcel$export(module.exports, "useIntersectionObserver", () => $01379305a4b54492$export$a7395f9832c00176);

var $eJOHy = parcelRequire("eJOHy");
const $01379305a4b54492$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                if (isIntersecting) onIntersection(time);
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: threshold
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin,
        threshold
    ]);
    return setObservedElement;
};

});

parcelRegister("aJkOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c10a5a4e92317e0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9c10a5a4e92317e0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingLabel: {
        "id": "jql-builder-basic-picker.async-select.menu-list.load-more-trigger.loading-label",
        "defaultMessage": "Loading"
    }
});

});



parcelRegister("f1iCr", function(module, exports) {

$parcel$export(module.exports, "OperatorsSelect", () => $45891c3f91875637$export$72ded8b112fe0b1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $bxHeV = parcelRequire("bxHeV");

var $8TCso = parcelRequire("8TCso");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $cO6Ov = parcelRequire("cO6Ov");
const $45891c3f91875637$var$selectStyles = {
    control: (baseStyles)=>({
            ...baseStyles,
            backgroundColor: "var(--ds-background-neutral, #091E420F)"
        })
};
const $45891c3f91875637$var$styles = {
    operatorsSelectOld: "_u5f3utpp _19bvutpp _ca0qu2gc",
    operatorsSelect: "_u5f3utpp _19bvutpp _ca0qze3t _n3tdu2gc"
};
const $45891c3f91875637$var$getOptionLabel = (option)=>option.ariaLabel;
const $45891c3f91875637$var$formatOptionLabel = (option)=>option.label;
const $45891c3f91875637$export$72ded8b112fe0b1 = ({ onChange: onChange, allowedOperators: allowedOperators, selectedOperator: selectedOperator })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeWithAnalytics = (0, $eJOHy.useCallback)((option)=>{
        onChange && onChange(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        option && (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            option: option.value,
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const onMenuOpenAnalytics = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: (0, $k0ahr.cx)((0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates') ? $45891c3f91875637$var$styles.operatorsSelect : $45891c3f91875637$var$styles.operatorsSelectOld)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCso.default), {
        "aria-label": formatMessage((0, $cO6Ov.default).operatorLabel),
        value: selectedOperator || allowedOperators[0],
        options: allowedOperators,
        onChange: onChangeWithAnalytics,
        spacing: "compact",
        appearance: "subtle",
        styles: $45891c3f91875637$var$selectStyles,
        onKeyDown: onKeyDown,
        onMenuOpen: onMenuOpenAnalytics,
        isSearchable: false,
        getOptionLabel: $45891c3f91875637$var$getOptionLabel,
        formatOptionLabel: $45891c3f91875637$var$formatOptionLabel
    }));
};

});
parcelRegister("cO6Ov", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c4c55cc3aef0b4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b1c4c55cc3aef0b4$var$messages = (0, $7qGN1.defineMessages)({
    operatorLabel: {
        "id": "jql-builder-basic-picker.async-select.operator-select.operator-label",
        "defaultMessage": "Operator dropdown"
    }
});
var $b1c4c55cc3aef0b4$export$2e2bcd8739ae039 = $b1c4c55cc3aef0b4$var$messages;

});


parcelRegister("1fUys", function(module, exports) {

$parcel$export(module.exports, "PaginationDetails", () => $60bd543addf3cb57$export$33eb0288c0936a84);
$parcel$export(module.exports, "SimplePaginationDetails", () => $60bd543addf3cb57$export$b7935720442eff68);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $kCiis = parcelRequire("kCiis");
const $60bd543addf3cb57$var$styles = {
    paginationDetails: "_11c82smr _y3gnusic _syaz131l _16jlkb7n _1o9zidpf _i0dl1wug _19pkze3t _2hwxutpp _otyrze3t _18u0utpp",
    fontMedium: "_k48p1wq8"
};
const $60bd543addf3cb57$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (totalCount == null) return null;
    return /*#__PURE__*/ $eJOHy.createElement("div" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    , {
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.pagination-details",
        className: (0, $hcewu.default)([
            $60bd543addf3cb57$var$styles.paginationDetails,
            (0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates') && $60bd543addf3cb57$var$styles.fontMedium
        ])
    }, formatMessage((0, $kCiis.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};
const $60bd543addf3cb57$export$b7935720442eff68 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ $eJOHy.createElement((0, $h8epd.default), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage((0, $kCiis.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};

});
parcelRegister("kCiis", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ca9967a4a24ae17$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6ca9967a4a24ae17$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    ofTotalCount: {
        "id": "jql-builder-basic-picker.async-select.pagination-details.of-total-count",
        "defaultMessage": "{itemsCount} of {totalCount}"
    }
});

});


parcelRegister("5lNLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6429fb8860ba26$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $aFyWG = parcelRequire("aFyWG");

var $5HR61 = parcelRequire("5HR61");
const $ce6429fb8860ba26$export$2543cc45221bf5bc = ({ onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleRestoreDefaults = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    const message = formatMessage((0, $5HR61.default).restoreDefaultsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: handleRestoreDefaults,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.restore-defaults-button",
        hasTooltip: true
    });
};
var $ce6429fb8860ba26$export$2e2bcd8739ae039 = $ce6429fb8860ba26$export$2543cc45221bf5bc;

});
parcelRegister("5HR61", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f7feca5c1b3e4c8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1f7feca5c1b3e4c8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    restoreDefaultsButtonText: {
        "id": "jql-builder-basic-picker.async-select.restore-defaults-button.restore-defaults-button-text",
        "defaultMessage": "Restore defaults"
    }
});

});


parcelRegister("j7wtI", function(module, exports) {

$parcel$export(module.exports, "selectComponents", () => $952582033f9b0a69$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "singleSelectComponents", () => $952582033f9b0a69$export$6161e15c6859b0c9);
$parcel$export(module.exports, "BaseSelect", () => $952582033f9b0a69$export$dcee1aa94a106d27);

var $eJOHy = parcelRequire("eJOHy");

var $8TCso = parcelRequire("8TCso");

var $mjinE = parcelRequire("mjinE");

var $8KUFq = parcelRequire("8KUFq");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $d9b92 = parcelRequire("d9b92");

var $gMbEk = parcelRequire("gMbEk");


var $gWVN2 = parcelRequire("gWVN2");

var $62EHB = parcelRequire("62EHB");

var $aeAJB = parcelRequire("aeAJB");

var $35vKc = parcelRequire("35vKc");

var $3UBK2 = parcelRequire("3UBK2");

var $fSowc = parcelRequire("fSowc");

var $j1sv5 = parcelRequire("j1sv5");
const $952582033f9b0a69$export$c34d65c0f5a1c617 = {
    Control: $gWVN2.default,
    DropdownIndicator: $62EHB.default,
    LoadingIndicator: ()=>null,
    Menu: $aeAJB.default,
    Option: $fSowc.default
};
const $952582033f9b0a69$export$6161e15c6859b0c9 = {
    Control: $gWVN2.default,
    DropdownIndicator: $62EHB.default,
    LoadingIndicator: undefined,
    Menu: $aeAJB.default
};
const $952582033f9b0a69$var$onIsOptionDisabled = (option, value)=>{
    if (option.optionType === 'error') return true;
    // if an option is only unselectable and currently selected, it should not be a disabled option
    if ('isOnlyUnselectable' in option && option.isOnlyUnselectable) {
        const isSelectedOption = (0, $gMbEk.isSingleValueOption)(option) && value.map((v)=>(0, $gMbEk.isSingleValueOption)(v) && v.value).includes(option.value);
        return !(isSelectedOption && option.isOnlyUnselectable);
    }
    if ('isDisabled' in option && option.isDisabled) return option.isDisabled;
    return false;
};
// Needed to disable filtering from react-select
const $952582033f9b0a69$var$noFilterOptions = ()=>true;
const $952582033f9b0a69$export$dcee1aa94a106d27 = ({ onReload: onReload, placeholder: placeholder, NoOptionsMessage: NoOptionsMessage = (0, $3UBK2.default), isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, totalCount: totalCount, components: componentsSelect, options: options, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, ...restProps })=>{
    const { onInputChange: onInputChangeProp, inputValue: inputValueProp, id: id, menuListProps: { isLoading: isLoading, error: { isError: isError, error: error } }, experienceAnalyticsAttributes: experienceAnalyticsAttributes, value: value } = restProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)(); // use any type for react-select ref
    const [inputValue, setInputValue] = (0, $eJOHy.useState)(inputValueProp ?? '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        // only set once when the component mounted
        if (selectRef.current && setInitialFocusRef) setInitialFocusRef(selectRef.current.select.inputRef);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (options && !(isLoading ?? false)) {
            let errorType = 'unknown';
            if (error != null && (0, $8KUFq.isClientFetchError)(error)) errorType = 'networkError';
            const errorAttributes = error ? {
                errorType: errorType,
                message: error.message
            } : null;
            (0, $mjinE.default)({
                analyticsSource: 'refinement-bar-select',
                wasExperienceSuccesful: error == null,
                experience: 'showOptions',
                application: null,
                edition: null,
                additionalAttributes: {
                    filter: id ?? 'unknown',
                    ...experienceAnalyticsAttributes,
                    ...errorAttributes
                }
            });
        }
    }, [
        isError,
        error,
        isLoading,
        options,
        id,
        experienceAnalyticsAttributes
    ]);
    const hasEnabledOption = (0, $eJOHy.useMemo)(()=>options?.some((option)=>!$952582033f9b0a69$var$onIsOptionDisabled(option, value)), [
        options,
        value
    ]);
    const onInputChange = (0, $eJOHy.useCallback)((newInputValue, meta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blured.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if (Array.from([
            (0, $d9b92.MetaActions).setValue,
            (0, $d9b92.MetaActions).inputBlur,
            (0, $d9b92.MetaActions).menuClose
        ]).includes(meta.action) && !newInputValue.length) return;
        // Reload defaultOptions in case of potential error by changing key on AsyncSelect
        if (meta.action === (0, $d9b92.MetaActions).inputChange && !newInputValue.length) onReload?.('');
        onInputChangeProp && onInputChangeProp(newInputValue, meta);
        setInputValue(newInputValue);
    }, [
        onInputChangeProp,
        onReload
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setInputValue(inputValueProp);
    }, [
        inputValueProp
    ]);
    const getOptionLabel = (0, $eJOHy.useCallback)((option)=>{
        if ((0, $gMbEk.isSingleValueOption)(option)) {
            if (typeof option.secondaryLabel === 'string') return `${option.label}, ${option.secondaryLabel}`;
            if (// remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
            typeof option.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(option.secondaryLabel)) return `${option.label}, ${option.secondaryLabel.label}`;
            return option.label;
        }
        return option.optionType === 'group' ? option?.label ?? '' : '';
    }, []);
    // placeholder type is reactNode and aria-label won't allow, for safe side checking the type and empty value
    const ariaLabel = typeof placeholder === 'string' && placeholder ? placeholder : formatMessage((0, $35vKc.default).searchPlaceholder);
    const OriginalOptionComponent = componentsSelect?.Option || undefined;
    // Note: this is a workaround to not visually focus any option, when there are only disabled options in the list
    // react-select autofocuses the first option, see more here: https://github.com/JedWatson/react-select/pull/4080
    // tracked bug ticket: https://product-fabric.atlassian.net/browse/DSP-17138
    const OptionComponentExtended = (0, $eJOHy.useCallback)((props)=>OriginalOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OriginalOptionComponent, {
            ...props,
            isFocused: hasEnabledOption ? props.isFocused : false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null), [
        OriginalOptionComponent,
        hasEnabledOption
    ]);
    const unselectedOptions = (0, $eJOHy.useMemo)(()=>{
        if (!isInBetweenColumnPickerEnabled) return [];
        if (!inputValue) return (0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates') ? options?.filter((option)=>option.optionType === 'group' && option.id !== (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01)) || [] : options?.filter((option)=>option.optionType === 'group') || [];
        const selectedOptions = new Set(value.map((v)=>(0, $gMbEk.isSingleValueOption)(v) ? v.value : ''));
        return options?.filter((option)=>(0, $gMbEk.isSingleValueOption)(option) && !selectedOptions.has(option.value)) || [];
    }, [
        isInBetweenColumnPickerEnabled,
        inputValue,
        options,
        value
    ]);
    const memoizedComponents = (0, $eJOHy.useMemo)(()=>{
        const totalCountOfUnselectedFields = totalCount ? totalCount - value.length : null;
        let groupComponents = {};
        if ((0, $7jTnu.fg)('jira_inline_field_config_gate')) groupComponents = {
            GroupHeading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.GroupHeading), {
                    ...props,
                    totalCount: totalCountOfUnselectedFields
                })
        };
        // this changes should override the IFC changes
        if ((0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates')) groupComponents = {
            GroupHeading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.GroupHeadingNew), props),
            Group: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j1sv5.Group), props)
        };
        return {
            ...componentsSelect,
            ...groupComponents,
            ...OriginalOptionComponent !== undefined ? {
                Option: OptionComponentExtended
            } : {}
        };
    }, [
        componentsSelect,
        OriginalOptionComponent,
        OptionComponentExtended,
        totalCount,
        value.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCso.default), {
        ...restProps,
        options: isInBetweenColumnPickerEnabled && (0, $7jTnu.fg)('jira_inline_field_config_gate') ? unselectedOptions : options,
        // Using classNamePrefix to identify the select component in cypress test, testId doesn't work (doc https://atlassian.design/components/select/testing)
        classNamePrefix: "jql-builder-basic-picker-atlaskit-select",
        components: memoizedComponents,
        cacheOptions: false,
        ref: selectRef,
        autoFocus: !setInitialFocusRef,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: isMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        onInputChange: onInputChange,
        isOptionDisabled: $952582033f9b0a69$var$onIsOptionDisabled,
        reload: onReload,
        filterOption: $952582033f9b0a69$var$noFilterOptions,
        placeholder: placeholder ?? formatMessage((0, $35vKc.default).searchPlaceholder),
        label: ariaLabel,
        noOptionsMessage: NoOptionsMessage,
        getOptionLabel: getOptionLabel
    });
};

});
const $398aa02f7b594968$export$eb85a4c9b5d9ce7b = 'all-columns';
const $398aa02f7b594968$export$bfd1c05c2e5a5a01 = 'selected-columns';

parcelRegister("gWVN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c50f99a84b41b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gmAES = parcelRequire("gmAES");

var $bxHeV = parcelRequire("bxHeV");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $cb8jR = parcelRequire("cb8jR");
const $0c50f99a84b41b08$var$styles = {
    control: "_2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d1elr _1e0c1txw _syaz131l _19pkze3t _2hwxutpp _otyrze3t _18u0utpp _jyzf1p6i _1u6lq049",
    wrapper: "_1e0c1txw _4cvr1h6o _19bvu2gc"
};
const $0c50f99a84b41b08$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
    if ((0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates')) return /*#__PURE__*/ $eJOHy.createElement("div", {
        ref: innerRef ?? undefined,
        ...innerProps,
        className: (0, $hcewu.default)([
            $0c50f99a84b41b08$var$styles.control
        ])
    }, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $bxHeV.default), {
        xcss: $0c50f99a84b41b08$var$styles.wrapper
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gmAES))), {
        LEGACY_size: "small",
        label: ""
    })), children);
    return /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.StyledControl), {
        ref: innerRef ?? undefined,
        ...innerProps
    }, (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $bxHeV.default), {
        xcss: $0c50f99a84b41b08$var$styles.wrapper
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gmAES))), {
        LEGACY_size: "small",
        label: ""
    })), children);
};
var $0c50f99a84b41b08$export$2e2bcd8739ae039 = $0c50f99a84b41b08$export$7a7fa4424cb20976;

});

parcelRegister("62EHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $54055c12a318bc3b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cWQKo = parcelRequire("cWQKo");

var $cPbpX = parcelRequire("cPbpX");

var $gmAES = parcelRequire("gmAES");

var $j3gIc = parcelRequire("j3gIc");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");
const $54055c12a318bc3b$var$styles = {
    dropdownIndicatorWrapper: "_2hwxv77o _y3gn1h6o",
    dropdownIndicatorWrapperOld: "_2hwxv77o _y3gn1h6o _1bsbzwfg",
    iconWrapper: "_2rko14q2 _1e0c1txw _80omtlke _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz131l _30l31dyx"
};
const $54055c12a318bc3b$export$ec98719d3db7f2e4 = (props)=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $j3gIc.components).DropdownIndicator, props, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            (0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates') ? $54055c12a318bc3b$var$styles.dropdownIndicatorWrapper : $54055c12a318bc3b$var$styles.dropdownIndicatorWrapperOld
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.DisplayWrapper), {
        displayFlag: props.selectProps.inputValue
    }, (0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates') ? /*#__PURE__*/ $eJOHy.createElement((0, $cPbpX.default), {
        xcss: $54055c12a318bc3b$var$styles.iconWrapper,
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange && props.selectProps.onInputChange('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        },
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cWQKo))), {
        LEGACY_size: "small",
        label: ""
    })) : /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.CloseIconWrapper), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.select.dropdown-indicator.dropdown-close-icon",
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange && props.selectProps.onInputChange('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cWQKo))), {
        LEGACY_size: "small",
        label: ""
    }))), !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ $eJOHy.createElement((0, $cb8jR.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gmAES))), {
        LEGACY_size: "small",
        label: ""
    }))));
};
var $54055c12a318bc3b$export$2e2bcd8739ae039 = $54055c12a318bc3b$export$ec98719d3db7f2e4;

});

parcelRegister("aeAJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b7f34fee106459a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4b7f34fee106459a$var$Menu = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4b7f34fee106459a$var$MenuBox, {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);
var $4b7f34fee106459a$export$2e2bcd8739ae039 = $4b7f34fee106459a$var$Menu;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4b7f34fee106459a$var$MenuBox = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("35vKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6409cd14587ac6e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b6409cd14587ac6e$var$messages = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "jql-builder-basic-picker.async-select.select.search-placeholder",
        "defaultMessage": "Search"
    }
});
var $b6409cd14587ac6e$export$2e2bcd8739ae039 = $b6409cd14587ac6e$var$messages;

});

parcelRegister("3UBK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba06491bbd0f20a1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2KjG5 = parcelRequire("2KjG5");

var $19Any = parcelRequire("19Any");

var $aRh7I = parcelRequire("aRh7I");
var $h8epd = parcelRequire("h8epd");

var $kDaaB = parcelRequire("kDaaB");

var $iqtgH = parcelRequire("iqtgH");

var $6XJko = parcelRequire("6XJko");

var $cb8jR = parcelRequire("cb8jR");

var $lWJ0U = parcelRequire("lWJ0U");
const $ba06491bbd0f20a1$var$NoOptionsMessageContainer = ({ children: children })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aRh7I.default), {
        space: "space.150",
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        height: 72
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lWJ0U.default).noOptionsMessage)));
};
const $ba06491bbd0f20a1$export$d58b72b7d3c4072c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.StyledBox), {
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.select.no-options-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ba06491bbd0f20a1$var$NoOptionsMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KjG5))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($19Any))),
        LEGACY_size: "xlarge"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "noMatches"
    }));
var $ba06491bbd0f20a1$export$2e2bcd8739ae039 = $ba06491bbd0f20a1$export$d58b72b7d3c4072c;

});
parcelRegister("lWJ0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e390d646017ea1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $43e390d646017ea1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noOptionsMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-message",
        "defaultMessage": "No matches found"
    },
    noOptionsPrimaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});


parcelRegister("fSowc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c802979ef0e97e4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2KjG5 = parcelRequire("2KjG5");

var $3fTrH = parcelRequire("3fTrH");

var $6fhEi = parcelRequire("6fhEi");

var $bL3dk = parcelRequire("bL3dk");
var $5Wv5g = parcelRequire("5Wv5g");

var $eUb2z = parcelRequire("eUb2z");
var $j3gIc = parcelRequire("j3gIc");

var $9JB3T = parcelRequire("9JB3T");

var $8cv11 = parcelRequire("8cv11");

var $cb8jR = parcelRequire("cb8jR");

var $1MOGE = parcelRequire("1MOGE");
const $9c802979ef0e97e4$var$tooltipStyles = null;
const $9c802979ef0e97e4$var$ConditionalTooltip = ({ condition: condition, content: content, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: content
    }, children) : children;
const $9c802979ef0e97e4$export$36d18380658d5d20 = ({ isMulti: isMulti = true, ...props })=>{
    const iconRef = (0, $eJOHy.useRef)(null);
    const { isOnlyUnselectable: isOnlyUnselectable, disabledMessage: disabledMessage, invalid: invalid } = props.data?.optionType === 'option' || props.data?.optionType === 'avatar' || props.data?.optionType === 'lozenge' || props.data?.optionType === 'field' ? props.data : {
        isOnlyUnselectable: undefined,
        disabledMessage: undefined,
        invalid: undefined
    };
    // Only disable checkbox for an only unselectable option when it is not a selected option
    const optionState = (0, $1MOGE.getOptionState)(props.isDisabled, Boolean(isOnlyUnselectable), props.isSelected, Boolean(invalid));
    const hasIconAfter = ()=>{
        switch(optionState){
            case 'only-unselectable-unselected':
            case 'only-unselectable-selected':
            case 'disabled':
                return Boolean(disabledMessage);
            case 'invalid':
                return true;
            default:
                return undefined;
        }
    };
    const OptionInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $9c802979ef0e97e4$export$d318e19053d98641[optionState].xcss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cb8jR.CustomOptionStyles), {
        hasIconAfter: hasIconAfter(),
        isFocused: props.isFocused,
        isDisabled: props.isDisabled,
        isSingleSelect: true
    }, isMulti ? /* @ts-expect-error - This component has stricter OptionType args which isn't compatible with ErrorOption in SelectOption. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eUb2z.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).Option, {
        ...props,
        isMulti: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$TooltipContainer, {
        ref: iconRef
    }, optionState !== 'invalid' && Boolean(disabledMessage) && // Show a tooltip for mouse users, since option.isFocused is not triggered for disabled options on mouse over
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$ConditionalTooltip, {
        content: disabledMessage,
        condition: props.isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fTrH))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.info-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    })), optionState === 'invalid' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KjG5))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.invalid-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6fhEi)))
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": $9c802979ef0e97e4$export$d318e19053d98641[optionState].testid
    }, optionState === 'only-unselectable-unselected' || optionState === 'disabled' || optionState === 'invalid' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9c802979ef0e97e4$var$UnsafeStyledCheckboxOption, null, OptionInner) : OptionInner), (disabledMessage || props.selectProps?.invalidLabel && optionState === 'invalid') && props.isFocused && iconRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8cv11.JiraPopper), {
        referenceElement: iconRef.current,
        placement: "bottom",
        messageType: "transactional",
        messageId: "jql-builder-basic-picker.ui.async-select.select.option.popper"
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            ref: ref,
            style: style,
            className: (0, $hcewu.default)([
                "_2rkoglpi _11c8dcr7 _vchhusvi _p12fp3fh _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
            ])
        }, optionState === 'invalid' ? props.selectProps?.invalidLabel : disabledMessage))));
};
var $9c802979ef0e97e4$export$2e2bcd8739ae039 = $9c802979ef0e97e4$export$36d18380658d5d20;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9c802979ef0e97e4$var$UnsafeStyledCheckboxOption = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_nrk9jdj5",
            __cmplp.className
        ])
    });
});
const $9c802979ef0e97e4$var$TooltipContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u0p1rm _u5f3utpp _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles = (0, $5Wv5g.xcss)({
    color: 'color.text.disabled'
});
const $9c802979ef0e97e4$var$InvalidCheckboxOptionStyles = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.background.danger'
});
const $9c802979ef0e97e4$export$d318e19053d98641 = {
    disabled: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.disabled-option',
        xcss: [
            $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles
        ]
    },
    invalid: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.invalid-option',
        xcss: [
            $9c802979ef0e97e4$var$InvalidCheckboxOptionStyles
        ]
    },
    selected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option',
        xcss: []
    },
    unselected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option',
        xcss: []
    },
    'only-unselectable-unselected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.only-unselectable',
        xcss: [
            $9c802979ef0e97e4$var$DisabledCheckboxOptionStyles
        ]
    },
    'only-unselectable-selected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option.only-unselectable',
        xcss: []
    }
};

});
parcelRegister("6fhEi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48c1d5862eb637c9$var$_react = $48c1d5862eb637c9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $48c1d5862eb637c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $48c1d5862eb637c9$var$JiraFailedBuildStatusIcon = (props)=>/*#__PURE__*/ $48c1d5862eb637c9$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$48c1d5862eb637c9$var$JiraFailedBuildStatusIcon.displayName = 'JiraFailedBuildStatusIcon';
var $48c1d5862eb637c9$var$_default = module.exports.default = $48c1d5862eb637c9$var$JiraFailedBuildStatusIcon;

});

parcelRegister("eUb2z", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $1b2b8824e98c54fc$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $1b2b8824e98c54fc$export$82ab7168879267a7);
/* input-options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $40c79 = parcelRequire("40c79");

var $1DXJJ = parcelRequire("1DXJJ");

var $lb1YQ = parcelRequire("lb1YQ");

var $8XtVW = parcelRequire("8XtVW");
const $1b2b8824e98c54fc$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk18uv _16qs1kw7 _syaz1kw7 _1di61dty",
    focused: "_bfhk166n _16qsn8hf _112ej1ic",
    disabled: "_syaz15gi"
};
// the primary color represents the outer or background element
const $1b2b8824e98c54fc$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #091E4208)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #09326C)";
    else if (isActive) return "var(--ds-background-selected-pressed, #85B8FF)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #0055CC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #0C66E4)";
    return "var(--ds-background-neutral, #091E420F)";
};
// the secondary color represents the radio dot or checkmark
const $1b2b8824e98c54fc$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #091E424F)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $1b2b8824e98c54fc$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1elr _1gqp1elr"
};
const $1b2b8824e98c54fc$var$baseIconStyles = null;
const $1b2b8824e98c54fc$var$baseOptionStyles = null;
const $1b2b8824e98c54fc$var$ControlOption = (props)=>{
    const [isActive, setIsActive] = (0, $eJOHy.useState)(false);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $eJOHy.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $eJOHy.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $1b2b8824e98c54fc$var$optionStyles.default,
            isFocused && $1b2b8824e98c54fc$var$optionStyles.focused,
            isDisabled && $1b2b8824e98c54fc$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
                    isSelected || isActive || isDisabled ? $1b2b8824e98c54fc$var$iconStyles.inherit : $1b2b8824e98c54fc$var$iconStyles.default
                ]),
                children: !!Icon ? /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    label: "",
                    primaryColor: $1b2b8824e98c54fc$var$getPrimaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        isFocused: isFocused,
                        isActive: isActive
                    }),
                    secondaryColor: $1b2b8824e98c54fc$var$getSecondaryColor({
                        isDisabled: isDisabled,
                        isSelected: isSelected
                    }),
                    isFacadeDisabled: true
                }) : null
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
const $1b2b8824e98c54fc$var$NewCheckboxIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lb1YQ.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
const $1b2b8824e98c54fc$var$NewRadioIcon = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lb1YQ.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "6.75",
                    fill: "currentColor",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "inherit"
                })
            ]
        })
    });
const $1b2b8824e98c54fc$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($1b2b8824e98c54fc$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $8XtVW.fg)('platform-visual-refresh-icons') ? $1b2b8824e98c54fc$var$NewCheckboxIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($40c79))),
        ...props
    });
const $1b2b8824e98c54fc$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    /*#__PURE__*/ (0, $gt9Am.jsx)($1b2b8824e98c54fc$var$ControlOption, {
        Icon: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $8XtVW.fg)('platform-visual-refresh-icons') ? $1b2b8824e98c54fc$var$NewRadioIcon : // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, (/*@__PURE__*/$parcel$interopDefault($1DXJJ))),
        ...props
    });

});
parcelRegister("40c79", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ea08f2b9404cb6f$var$_react = $2ea08f2b9404cb6f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $2ea08f2b9404cb6f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ea08f2b9404cb6f$var$CheckboxIcon = (props)=>/*#__PURE__*/ $2ea08f2b9404cb6f$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$2ea08f2b9404cb6f$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $2ea08f2b9404cb6f$var$_default = module.exports.default = $2ea08f2b9404cb6f$var$CheckboxIcon;

});

parcelRegister("1DXJJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1327c56dce7e7aee$var$_react = $1327c56dce7e7aee$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $1327c56dce7e7aee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1327c56dce7e7aee$var$RadioIcon = (props)=>/*#__PURE__*/ $1327c56dce7e7aee$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$1327c56dce7e7aee$var$RadioIcon.displayName = 'RadioIcon';
var $1327c56dce7e7aee$var$_default = module.exports.default = $1327c56dce7e7aee$var$RadioIcon;

});


parcelRegister("8cv11", function(module, exports) {

$parcel$export(module.exports, "JiraPopper", () => $7c774b4266762c6b$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $fcTrq = parcelRequire("fcTrq");

var $SyPNn = parcelRequire("SyPNn");

var $k3Xbr = parcelRequire("k3Xbr");
const $7c774b4266762c6b$export$23789575ac361b5d = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k3Xbr.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fcTrq.Popper), rest);
};

});
parcelRegister("k3Xbr", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopper", () => $035f7c874f3f3baa$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $fcTrq = parcelRequire("fcTrq");

var $1pkzT = parcelRequire("1pkzT");
const $035f7c874f3f3baa$export$6077de4a190b560c = (0, $1pkzT.withChoreographedRender)((0, $fcTrq.Popper));

});


parcelRegister("1MOGE", function(module, exports) {

$parcel$export(module.exports, "getOptionState", () => $af5121b5036d97d9$export$e651787bf17e8335);
const $af5121b5036d97d9$export$e651787bf17e8335 = (isDisabled, isOnlyUnselectable, isSelected, isInvalid)=>{
    if (isDisabled) return 'disabled';
    if (isOnlyUnselectable && !isSelected) return 'only-unselectable-unselected';
    if (isInvalid) return 'invalid';
    if (isOnlyUnselectable && isSelected) return 'only-unselectable-selected';
    if (isSelected) return 'selected';
    return 'unselected';
};

});


parcelRegister("j1sv5", function(module, exports) {

$parcel$export(module.exports, "GroupHeading", () => $f8d83750115807b5$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "GroupHeadingNew", () => $f8d83750115807b5$export$68d21e17c31e791a);
$parcel$export(module.exports, "Group", () => $f8d83750115807b5$export$eb2fcfdbd7ba97d4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $jvsV6 = parcelRequire("jvsV6");

var $j3gIc = parcelRequire("j3gIc");

const $f8d83750115807b5$var$styles = {
    groupHeading: "_1e0c1txw _4cvr1h6o _1bah1yb4",
    borderGroup: "_n7zl7r9e _ca0qze3t _otyru2gc",
    allColumnsGroup: "_ca0qze3t"
};
const $f8d83750115807b5$var$HeadingContent = ({ label: label, totalCount: totalCount })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $f8d83750115807b5$var$styles.groupHeading,
        paddingBlockEnd: "space.075",
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtle"
    }, label?.toLocaleUpperCase()), totalCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        size: "small",
        color: "color.text.subtle"
    }, totalCount));
};
const $f8d83750115807b5$export$85c8b41a3cd87edc = ({ data: data, totalCount: totalCount, ...restProps })=>{
    const { id: id, label: label } = data;
    switch(id){
        case 0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83750115807b5$var$HeadingContent, {
                label: label,
                totalCount: totalCount
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).GroupHeading, {
                ...restProps,
                data: data
            });
    }
};
const $f8d83750115807b5$export$68d21e17c31e791a = ({ data: data, ...props })=>{
    const { id: id } = data;
    switch(id){
        // no heading for these groups
        case 0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b:
        case 0, $398aa02f7b594968$export$bfd1c05c2e5a5a01:
            return null;
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).GroupHeading, {
                ...props,
                data: data
            });
    }
};
const $f8d83750115807b5$export$eb2fcfdbd7ba97d4 = ({ data: data, ...props })=>{
    const { id: id } = data;
    // selected columns group should have a border bottom divider
    if (id === (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).Group, {
        ...props,
        data: data,
        xcss: $f8d83750115807b5$var$styles.borderGroup
    });
    if (id === (0, $398aa02f7b594968$export$eb85a4c9b5d9ce7b)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).Group, {
        ...props,
        data: data,
        xcss: $f8d83750115807b5$var$styles.allColumnsGroup
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).Group, {
        ...props,
        data: data
    });
};

});


parcelRegister("icknm", function(module, exports) {

$parcel$export(module.exports, "default", () => $295f45065da2298c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $aFyWG = parcelRequire("aFyWG");

var $8quwH = parcelRequire("8quwH");
const $295f45065da2298c$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleShowFullList = (0, $eJOHy.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'expanded',
            actionSubject: 'filterSearch',
            actionSubjectId: 'refinementBarFilterSearch'
        });
        const attributes = {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: e.detail === 0
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        createAnalyticsEvent,
        onShowFullList
    ]);
    const message = formatMessage((0, $8quwH.default).showFullListButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFyWG.LeftFooterButton), {
        message: message,
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.show-full-list-button.show-full-list-button",
        hasTooltip: true
    });
};
var $295f45065da2298c$export$2e2bcd8739ae039 = $295f45065da2298c$export$bf0956d66cd7566b;

});
parcelRegister("8quwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa637fe2306205e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $aa637fe2306205e4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showFullListButtonText: {
        "id": "jql-builder-basic-picker.async-select.show-full-list-button.show-full-list-button-text",
        "defaultMessage": "Show full list"
    }
});

});


parcelRegister("bWslp", function(module, exports) {

$parcel$export(module.exports, "addFullListToOptions", () => $c7a0e88bf351185c$export$f3b09dca68236b3);
$parcel$export(module.exports, "generateOptions", () => $c7a0e88bf351185c$export$c21133b4499f5374);
$parcel$export(module.exports, "getValueFromOptions", () => $c7a0e88bf351185c$export$cc4ee748665ecf20);

var $7jTnu = parcelRequire("7jTnu");

var $gMbEk = parcelRequire("gMbEk");

const $c7a0e88bf351185c$export$17aec06b00a4043e = (keys, options, option)=>{
    if ((0, $gMbEk.isSingleValueOption)(option) && !keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
    // If the option is a group, we either append to an existing group or add a new group
    if (option.optionType === 'group') {
        const foundDuplicateGroup = options.some((o)=>'label' in o && o.label === option.label);
        if (foundDuplicateGroup) option.options.forEach((groupVal)=>{
            const existingGroup = options.find((o)=>'label' in o && o.label === option.label);
            if (existingGroup && existingGroup.optionType === 'group') {
                const newOptions = [
                    ...existingGroup?.options,
                    groupVal
                ];
                existingGroup.options = newOptions;
            }
        });
        else options.push(option);
    }
};
const $c7a0e88bf351185c$export$f3b09dca68236b3 = (options, fullList, onSortOptions)=>options.map((option)=>{
        switch(option.optionType){
            case 'group':
                {
                    const newOptions = $c7a0e88bf351185c$export$f3b09dca68236b3(option.options, fullList, onSortOptions);
                    return {
                        ...option,
                        options: onSortOptions && (0, $7jTnu.fg)('jira_list_merged_column_gate') ? onSortOptions(newOptions) : newOptions
                    };
                }
            case 'avatar':
            case 'lozenge':
            case 'option':
                {
                    // keep same object reference to keep focus on same option on pagination
                    const optionRef = option;
                    optionRef.fullList = fullList;
                    return optionRef;
                }
            default:
                return option;
        }
    });
const $c7a0e88bf351185c$export$c21133b4499f5374 = (selected, data, previousData, addSelectedFirst = true)=>{
    // Handle currently selected
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) {
        // add selected options as a group
        if ((0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates')) {
            const groupSelectedOptions = [];
            selected && selected.forEach((val)=>{
                $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, groupSelectedOptions, val);
            });
            if (groupSelectedOptions.length > 0) $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, {
                id: (0, $398aa02f7b594968$export$bfd1c05c2e5a5a01),
                optionType: 'group',
                options: groupSelectedOptions,
                label: 'Selected columns'
            });
        } else selected && selected.forEach((val)=>{
            $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
        });
    }
    if (previousData) // add previous loaded options
    previousData.forEach((val)=>{
        $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
    });
    data && data.forEach((val)=>{
        // Add group options
        if (val && val.optionType === 'group') {
            const groupOptions = [];
            val.options.forEach((groupVal)=>{
                // removing values from the group that are already in the options list (e.g. selected values, values from previousData)
                $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, groupOptions, groupVal);
            });
            if (groupOptions.length > 0) $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, {
                ...val,
                options: groupOptions,
                optionType: 'group'
            });
            return;
        }
        // add individual options
        $c7a0e88bf351185c$export$17aec06b00a4043e(optionKeys, options, val);
    });
    return options;
};
const $c7a0e88bf351185c$export$cc4ee748665ecf20 = (loadedOptionsWithFullList, value)=>{
    if (loadedOptionsWithFullList.length === 0) return value;
    const loadedOptionsWithFullListFlat = loadedOptionsWithFullList.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    return value.map((selectedValue)=>loadedOptionsWithFullListFlat.find((option)=>(0, $gMbEk.isSingleValueOption)(option) && (0, $gMbEk.isSingleValueOption)(selectedValue) && selectedValue.value === option.value) || selectedValue);
};

});

parcelRegister("7XraK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6bbce5e4b9b1a0a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e6bbce5e4b9b1a0a$var$messages = (0, $7qGN1.defineMessages)({
    loadingStart: {
        "id": "jql-builder-basic-picker.async-select.loading-start",
        "defaultMessage": "Loading more"
    },
    loadingEnd: {
        "id": "jql-builder-basic-picker.async-select.loading-end",
        "defaultMessage": "Finished loading"
    }
});
var $e6bbce5e4b9b1a0a$export$2e2bcd8739ae039 = $e6bbce5e4b9b1a0a$var$messages;

});


parcelRegister("hEe9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d51a2057bdff96c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g5nWu = parcelRequire("g5nWu");

var $7PBuN = parcelRequire("7PBuN");

var $5xIBb = parcelRequire("5xIBb");
const $9d51a2057bdff96c$var$formatOptionLabel = (data)=>{
    switch(data.optionType){
        case 'avatar':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5nWu.default), {
                data: data
            });
        case 'lozenge':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5xIBb.default), {
                data: data
            });
        case 'option':
        case 'field':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PBuN.default), {
                data: data
            });
        default:
            return null;
    }
};
var $9d51a2057bdff96c$export$2e2bcd8739ae039 = $9d51a2057bdff96c$var$formatOptionLabel;

});
parcelRegister("g5nWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $53de91e06cefcdc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6q0fu = parcelRequire("6q0fu");

var $7tPhm = parcelRequire("7tPhm");

var $lRq8t = parcelRequire("lRq8t");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");

var $lCwqw = parcelRequire("lCwqw");
const $53de91e06cefcdc0$export$fe00f602c942368a = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, data.hideAvatar !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelIcon), null, data.isGroup === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StylesGroupIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7tPhm))), {
        LEGACY_size: "small",
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.group-icon",
        label: formatMessage((0, $lCwqw.default).groupIcon)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6q0fu.default), {
        src: typeof data.avatar !== 'string' ? undefined : data.avatar,
        size: "xsmall",
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.avatar",
        appearance: typeof data.square === 'boolean' && data.square === true ? 'square' : 'circle'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage)));
};
var $53de91e06cefcdc0$export$2e2bcd8739ae039 = $53de91e06cefcdc0$export$fe00f602c942368a;

});
parcelRegister("7tPhm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $572304c327609f97$var$_react = $572304c327609f97$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $572304c327609f97$var$_peopleGroup = $572304c327609f97$var$_interopRequireDefault((parcelRequire("262zM")));

var $572304c327609f97$var$_peopleGroup2 = $572304c327609f97$var$_interopRequireDefault((parcelRequire("lze6D")));
function $572304c327609f97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $572304c327609f97$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $572304c327609f97$var$_react.default.createElement($572304c327609f97$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $572304c327609f97$var$_peopleGroup2.default
    }, props));
$572304c327609f97$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $572304c327609f97$var$_default = module.exports.default = $572304c327609f97$var$PeopleGroupIcon;

});
parcelRegister("lze6D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb37cefe77d9139b$var$_react = $fb37cefe77d9139b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $fb37cefe77d9139b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb37cefe77d9139b$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fb37cefe77d9139b$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props));
$fb37cefe77d9139b$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $fb37cefe77d9139b$var$_default = module.exports.default = $fb37cefe77d9139b$var$PeopleGroupIcon;

});


parcelRegister("buJG5", function(module, exports) {

$parcel$export(module.exports, "ConditionalTooltip", () => $f134232f4e230d4e$export$d8abb7a1cfbd4b6b);

var $eJOHy = parcelRequire("eJOHy");

var $9JB3T = parcelRequire("9JB3T");
const $f134232f4e230d4e$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>// @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
    condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});

parcelRegister("jMiTg", function(module, exports) {

$parcel$export(module.exports, "PICKER_DROPDOWN_WIDTH", () => $53e13f8b42d31da6$export$ca493ca2aa631e47);
$parcel$export(module.exports, "StyledOption", () => $53e13f8b42d31da6$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledLabel", () => $53e13f8b42d31da6$export$eea83358d9434634);
$parcel$export(module.exports, "StyledLabelIcon", () => $53e13f8b42d31da6$export$282e0b7f297acea7);
$parcel$export(module.exports, "StyledIcon", () => $53e13f8b42d31da6$export$7c8f159da0dc916);
$parcel$export(module.exports, "StyledLabelText", () => $53e13f8b42d31da6$export$601dc5d21f1e8182);
$parcel$export(module.exports, "StyledLozenge", () => $53e13f8b42d31da6$export$fb418b53e6535057);
$parcel$export(module.exports, "StyledLozengeLabel", () => $53e13f8b42d31da6$export$cd2803f359bf9865);
$parcel$export(module.exports, "StyledSecondaryLabel", () => $53e13f8b42d31da6$export$385a11497793b305);
$parcel$export(module.exports, "StylesGroupIconContainer", () => $53e13f8b42d31da6$export$56cfb14c006d4229);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $53e13f8b42d31da6$export$ca493ca2aa631e47 = 300;
const $53e13f8b42d31da6$export$844bee7de236d7ec = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$eea83358d9434634 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$282e0b7f297acea7 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$7c8f159da0dc916 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko14q2 _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$601dc5d21f1e8182 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _18u01b66",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$fb418b53e6535057 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _18u01b66 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$cd2803f359bf9865 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _1bsb1osq _1bto1l2s _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$385a11497793b305 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _11c81o8v _zulpv77o _1bto1l2s _syaz131l _19pk1i6y _18u01b66 _4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $53e13f8b42d31da6$export$56cfb14c006d4229 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lCwqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dbf9dc996adfbbc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8dbf9dc996adfbbc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    groupIcon: {
        "id": "jql-builder-basic-picker.format-option-label.avatar-option-label.group-icon",
        "defaultMessage": "Group Icon"
    }
});

});


parcelRegister("7PBuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c0e2fe81e1bf76c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");
const $9c0e2fe81e1bf76c$export$914fa095fc1e0a45 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const [secondaryLabelOverflows, setSecondaryLabelOverflows] = (0, $eJOHy.useState)(false);
    const showSecondaryLabel = (input)=>typeof input.secondaryLabel === 'string' && input.secondaryLabel.length > 0 || // remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
        typeof input.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(input.secondaryLabel) && /*#__PURE__*/ (0, $eJOHy.isValidElement)(input.secondaryLabel.element);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const onSecondaryLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setSecondaryLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const tooltipContent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, data.label), typeof data.secondaryLabel === 'string' && data.secondaryLabel.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, "(", data.secondaryLabel, ")")), [
        data
    ]);
    const getSecondaryLabelComponent = (option)=>{
        if (typeof option === 'object' && !/*#__PURE__*/ (0, $eJOHy.isValidElement)(option)) return option.element;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, option);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows || secondaryLabelOverflows,
        content: tooltipContent,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, data.icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledIcon), {
        src: data.icon,
        alt: data.label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), showSecondaryLabel(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledSecondaryLabel), {
        ref: onSecondaryLabelRef,
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.icon-option-label.secondary-label"
    }, data.secondaryLabel && getSecondaryLabelComponent(data.secondaryLabel))), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage));
};
var $9c0e2fe81e1bf76c$export$2e2bcd8739ae039 = $9c0e2fe81e1bf76c$export$914fa095fc1e0a45;

});

parcelRegister("5xIBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba51567c14d8e757$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6alcT = parcelRequire("6alcT");

var $dPMMf = parcelRequire("dPMMf");

var $buJG5 = parcelRequire("buJG5");

var $9cbmy = parcelRequire("9cbmy");

var $jMiTg = parcelRequire("jMiTg");
// Checkbox icon width = 3 * gridSize
// Margins and paddings around checkbox icon = 2 * gridSize
// Option right padding = (3 / 2) * gridSize
const $ba51567c14d8e757$var$DEFAULT_MAX_WIDTH = (0, $jMiTg.PICKER_DROPDOWN_WIDTH) - 3 * (0, $dPMMf.gridSize) - 2 * (0, $dPMMf.gridSize) - 1.5 * (0, $dPMMf.gridSize);
const $ba51567c14d8e757$export$5f70fe304106fcb1 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $eJOHy.useState)(false);
    const onLabelRef = (0, $eJOHy.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLozenge), {
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.lozenge-option-label.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: data.appearance,
        isBold: data.isBold,
        maxWidth: data.maxWidth ?? $ba51567c14d8e757$var$DEFAULT_MAX_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMiTg.StyledLozengeLabel), {
        ref: onLabelRef
    }, data.label))))), data.disabledMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9cbmy.ScreenReaderText), null, data.disabledMessage));
};
var $ba51567c14d8e757$export$2e2bcd8739ae039 = $ba51567c14d8e757$export$5f70fe304106fcb1;

});


parcelRegister("5LwVz", function(module, exports) {

$parcel$export(module.exports, "DefaultPopupComponent", () => $4e7f80d8c92d0b45$export$5038854ec49970e4);
$parcel$export(module.exports, "FixedWidthPopupComponent", () => $4e7f80d8c92d0b45$export$84690c88a5faffa0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $408ts = parcelRequire("408ts");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");

var $jMiTg = parcelRequire("jMiTg");
const $4e7f80d8c92d0b45$var$getPopupComponent = (width)=>/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4e7f80d8c92d0b45$var$PopupComponentContainer, {
            ...props,
            ref: ref,
            width: width
        }));
const $4e7f80d8c92d0b45$export$5038854ec49970e4 = $4e7f80d8c92d0b45$var$getPopupComponent();
const $4e7f80d8c92d0b45$export$84690c88a5faffa0 = $4e7f80d8c92d0b45$var$getPopupComponent((0, $jMiTg.PICKER_DROPDOWN_WIDTH));
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $4e7f80d8c92d0b45$var$layerValue = (0, $408ts.layers).layer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e7f80d8c92d0b45$var$PopupComponentContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkosqtm _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs1cd0 _vchhusvi _1e0c1txw _2lx21bp4 _1pby1nn1 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.width && "_1bsb1efm",
            __cmplp.className
        ])
    });
});
const $4e7f80d8c92d0b45$var$PopupComponentContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkosqtm _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs1cd0 _vchhusvi _1e0c1txw _2lx21bp4 _1pby1nn1 _ca0qutpp _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.width && "_1bsb1efm",
            __cmplp.className
        ])
    });
});
const $4e7f80d8c92d0b45$var$PopupComponentContainer = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('slv-117-nin-column-picker-style-updates'), $4e7f80d8c92d0b45$var$PopupComponentContainerNew, $4e7f80d8c92d0b45$var$PopupComponentContainerOld);

});


parcelRegister("2ftMY", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $4970e401839ffb92$export$6df0712d20d2cc08);
$parcel$export(module.exports, "useFields", () => $4970e401839ffb92$export$d25cd19bd4b6c629);

var $bzKDb = parcelRequire("bzKDb");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");


var $h8epd = parcelRequire("h8epd");

var $gYnSx = parcelRequire("gYnSx");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $3Zpjn = parcelRequire("3Zpjn");

var $cjRWP = parcelRequire("cjRWP");

var $fexQV = parcelRequire("fexQV");

var $kEUB1 = parcelRequire("kEUB1");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $22GDK = parcelRequire("22GDK");

var $gX8pG = parcelRequire("gX8pG");
const $4970e401839ffb92$var$WHERE_CLAUSE = 'WHERE';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $4970e401839ffb92$var$ORDER_BY_CLAUSE = 'ORDER_BY';
const $4970e401839ffb92$export$6df0712d20d2cc08 = (node, itemType, intl)=>{
    const notInContextFieldMessageIssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $gX8pG.default).notInContextFieldMessageIssueTermRefreshGalaxia : (0, $gX8pG.default).notInContextFieldMessageIssueTermRefresh;
    if (!node) return undefined;
    const { displayName: displayName, jqlTerm: jqlTerm, searchTemplate: searchTemplate, type: type, operators: operators, description: description, fieldType: fieldType, shouldShowInContext: shouldShowInContext } = node;
    // Search template & type are required; description can be null but not undefined
    if (searchTemplate == null || searchTemplate.key == null || type == null || description === undefined) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getOption',
                packageName: (0, $dTJxm.PACKAGE_NAME),
                teamName: (0, $dTJxm.TEAM_NAME)
            },
            error: new Error('Field node missing required data'),
            attributes: {
                searchTemplate: searchTemplate == null ? 'missing' : {
                    key: searchTemplate.key
                },
                fieldType: type == null ? 'missing' : type,
                description: description === undefined ? 'missing' : 'present'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
    const isDisabledEpicLinkField = searchTemplate?.key === (0, $dTJxm.EPIC_LINK).searchTemplate;
    const fieldTypeDisplayName = fieldType?.displayName ?? null;
    const icon = type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fexQV.FieldTypeIcon), {
        type: type,
        size: "small"
    }) : undefined;
    const fieldLabel = displayName != null ? displayName : jqlTerm;
    let isOnlyUnselectable = false;
    let disabledMessage = isDisabledEpicLinkField ? intl.formatMessage((0, $gX8pG.default).deprecatedEpicMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                as: "strong",
                color: "inherit",
                size: "UNSAFE_small"
            }, chunks)
    }) : undefined;
    if (shouldShowInContext === false) {
        isOnlyUnselectable = true;
        disabledMessage = intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? notInContextFieldMessageIssueTermRefreshGalaxia : (0, $gX8pG.default).notInContextFieldMessage);
    }
    if (isDisabledEpicLinkField) {
        isOnlyUnselectable = true;
        disabledMessage = intl.formatMessage((0, $gX8pG.default).deprecatedEpicMessage, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                    as: "strong",
                    color: "inherit",
                    size: "UNSAFE_small"
                }, chunks)
        });
    }
    return {
        optionType: 'field',
        label: fieldLabel,
        value: jqlTerm.toLowerCase(),
        searchTemplate: searchTemplate?.key,
        fieldType: type,
        fieldDescription: description,
        isOnlyUnselectable: isOnlyUnselectable,
        secondaryLabel: fieldTypeDisplayName && icon ? (0, $cjRWP.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
        fieldTypeDisplayName: fieldTypeDisplayName,
        itemType: itemType,
        disabledMessage: disabledMessage,
        operators: operators?.map((0, $22GDK.mapOperators))
    };
};
const $4970e401839ffb92$export$d25cd19bd4b6c629 = ({ jql: jql = '', excludeFields: excludeFields = [], forClause: forClause = $4970e401839ffb92$var$WHERE_CLAUSE, viewContext: viewContext = null, scope: scope = null })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const intl = (0, $lRq8t.default)();
    return (0, $eJOHy.useMemo)(()=>(0, $3Zpjn.createGenericDebouncableDataLoader)(async (search, renderInitialValues, endCursor)=>{
            try {
                const data = await (0, $j4oe4.fetchQuery)(environment, (0, $bzKDb.default), {
                    cloudId: cloudId,
                    first: 10,
                    searchString: search,
                    after: typeof endCursor === 'string' ? endCursor : undefined,
                    excludeFields: excludeFields,
                    forClause: forClause,
                    jqlContext: jql,
                    viewContext: viewContext,
                    scope: scope
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
                if (data?.jira?.jqlBuilder?.fields?.__typename === 'JiraJqlFieldConnection') {
                    if (!data?.jira?.jqlBuilder?.fields?.edges) return (0, $eiIzV.generateOptions)([]);
                    const { edges: fields, totalCount: totalCount, pageInfo: { endCursor: newEndCursor } } = data.jira.jqlBuilder.fields;
                    return (0, $eiIzV.generateOptions)(fields.reduce((options, edge)=>{
                        const option = $4970e401839ffb92$export$6df0712d20d2cc08(edge?.node, (0, $f38290926d0398e2$export$38accfc5a5d1c113), intl);
                        if (option) options.push(option);
                        return options;
                    }, []), totalCount, newEndCursor || undefined);
                }
                return {
                    options: [],
                    totalCount: 0
                };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'fetchMoreFieldsOptions',
                        packageName: (0, $dTJxm.PACKAGE_NAME),
                        teamName: (0, $dTJxm.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        cloudId,
        environment,
        excludeFields,
        forClause,
        intl,
        jql,
        viewContext,
        scope
    ]);
};

});
parcelRegister("bzKDb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed8902967b18900a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4bad42763fe9b96aaeb4b5637bc7191>>
 * @relayHash 9f3804059f817e66c9f5d118131a5d95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 278d1d02ca9988a436ecd2ed0f40ed9bd2d6714d11a8385dc7bb75edb65af03b
const $ed8902967b18900a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeFields"
    }, v3 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "forClause"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v10 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "excludeFields",
            "variableName": "excludeFields"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "forClause",
            "variableName": "forClause"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jqlContext"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v13 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "concreteType": "JiraJqlFieldEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraJqlField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    v14 /*: any*/ ,
                    {
                        "concreteType": "JiraJqlSearchTemplate",
                        "kind": "LinkedField",
                        "name": "searchTemplate",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "operators"
                    },
                    {
                        "concreteType": "JiraFieldType",
                        "kind": "LinkedField",
                        "name": "fieldType",
                        "plural": false,
                        "selections": [
                            v14 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "shouldShowInContext"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v9 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10 /*: any*/ ,
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v11 /*: any*/ ,
                                                    v12 /*: any*/ ,
                                                    v13 /*: any*/ ,
                                                    v15 /*: any*/ 
                                                ],
                                                "type": "JiraJqlFieldConnection"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v11 /*: any*/ 
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "type": "JiraJqlFieldConnection"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "278d1d02ca9988a436ecd2ed0f40ed9bd2d6714d11a8385dc7bb75edb65af03b",
            "metadata": {},
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ed8902967b18900a$var$node.hash = "744e35745d428b3b4fc4514e1a4087bc";
var $ed8902967b18900a$export$2e2bcd8739ae039 = $ed8902967b18900a$var$node;

});

parcelRegister("3Zpjn", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $515f3085be272897$export$ea63a11564958c9e);

var $3s8bj = parcelRequire("3s8bj");
const $515f3085be272897$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $515f3085be272897$export$2e2bcd8739ae039 = $515f3085be272897$export$ea63a11564958c9e;

});

parcelRegister("cjRWP", function(module, exports) {

$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $fe2515622481ebd0$export$de24d837eb50c435);

var $eJOHy = parcelRequire("eJOHy");
const $fe2515622481ebd0$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("fexQV", function(module, exports) {

$parcel$export(module.exports, "fieldTypesIcons", () => $a32db5a6d1618aac$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $a32db5a6d1618aac$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $a32db5a6d1618aac$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $a32db5a6d1618aac$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $a32db5a6d1618aac$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $a32db5a6d1618aac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aCmsU = parcelRequire("aCmsU");

var $4BXjD = parcelRequire("4BXjD");

var $9nmYq = parcelRequire("9nmYq");

var $bY9p9 = parcelRequire("bY9p9");

var $iovNB = parcelRequire("iovNB");

var $8G3gB = parcelRequire("8G3gB");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $814y1 = parcelRequire("814y1");

var $h7qTf = parcelRequire("h7qTf");

var $33mJg = parcelRequire("33mJg");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
const $a32db5a6d1618aac$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $a32db5a6d1618aac$var$TeamCfTypeIcon = (0, $bJscI.componentWithFG)('twcj-37_update_team_icons_and_avatars_in_jira', (0, (/*@__PURE__*/$parcel$interopDefault($8G3gB))), (0, (/*@__PURE__*/$parcel$interopDefault($bY9p9))));
const $a32db5a6d1618aac$var$checkedFieldTypesIcons = {
    [(0, $814y1.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    [(0, $814y1.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.radioGlyph)
    }),
    [(0, $814y1.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.doubleDropdownGlyph)
    }),
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $h7qTf.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $h7qTf.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $814y1.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$TeamCfTypeIcon, {
        spacing: "spacious",
        label: ""
    }),
    [(0, $814y1.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shipGlyph)
    }),
    [(0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGroupGlyph)
    }),
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.officeBuildingGlyph)
    }),
    [(0, $814y1.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.attachmentGlyph)
    }),
    [(0, $814y1.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    [(0, $814y1.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.priorityGlyph)
    }),
    [(0, $814y1.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    [(0, $814y1.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    [(0, $814y1.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeTrackingGlyph)
    }),
    [(0, $814y1.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.originalTimeEstimateGlyph)
    }),
    [(0, $814y1.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.screenGlyph)
    }),
    [(0, $814y1.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    [(0, $814y1.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.arrowRightGlyph)
    }),
    [(0, $814y1.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shortTextGlyph)
    }),
    [(0, $h7qTf.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.shortTextGlyph)
    }),
    [(0, $h7qTf.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.checkboxGlyph)
    }),
    [(0, $814y1.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $h7qTf.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.commentGlyph)
    }),
    [(0, $814y1.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.appAccessGlyph)
    }),
    [(0, $814y1.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.appAccessGlyph)
    }),
    [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.folderGlyph)
    }),
    [(0, $814y1.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    [(0, $814y1.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.jwmCategoryGlyph)
    }),
    [(0, $814y1.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    [(0, $814y1.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    }),
    [(0, $814y1.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BXjD))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }),
    [(0, $814y1.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$a32db5a6d1618aac$var$checkedFieldTypesIcons
});
const $a32db5a6d1618aac$export$67f993f3bbfb364d = $a32db5a6d1618aac$var$checkedFieldTypesIcons;
const $a32db5a6d1618aac$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nmYq))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nmYq))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iovNB))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $a32db5a6d1618aac$var$allIcons = {
    ...$a32db5a6d1618aac$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a32db5a6d1618aac$var$ResizedIcon, {
        glyph: (0, $33mJg.customFieldGlyph)
    })
};
const $a32db5a6d1618aac$var$checkedFieldTypesGlyphs = {
    [(0, $814y1.NUMBER_CF_TYPE)]: (0, $33mJg.numberGlyph),
    [(0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $33mJg.numberGlyph),
    [(0, $814y1.LABELS_CF_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.DATE_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.DATETIME_CF_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: (0, $33mJg.radioGlyph),
    [(0, $814y1.SELECT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.MULTI_SELECT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: (0, $33mJg.doubleDropdownGlyph),
    [(0, $814y1.MULTI_VERSION_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.VERSION_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.GROUP_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.MULTI_GROUP_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.USER_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $h7qTf.USERPICKER_FIELD_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.MULTI_USER_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $h7qTf.MULTIUSERPICKER_FIELD_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.PEOPLE_CF_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.FLAGGED_CF_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.URL_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.TEAM_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.PARENT_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.BASELINE_START_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.BASELINE_END_CF_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.SPRINT_TYPE)]: (0, $33mJg.shipGlyph),
    [(0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $33mJg.peopleGroupGlyph),
    [(0, $814y1.ORGANIZATIONS_CF_TYPE)]: (0, $33mJg.officeBuildingGlyph),
    [(0, $814y1.REPORTER_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.ATTACHMENT_TYPE)]: (0, $33mJg.attachmentGlyph),
    [(0, $814y1.ASSIGNEE_TYPE)]: (0, $33mJg.peopleGlyph),
    [(0, $814y1.LABELS_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.PRIORITY_TYPE)]: (0, $33mJg.priorityGlyph),
    [(0, $814y1.DUE_DATE_TYPE)]: (0, $33mJg.dateGlyph),
    [(0, $814y1.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $33mJg.timeStampGlyph),
    [(0, $814y1.TIME_TRACKING_TYPE)]: (0, $33mJg.timeTrackingGlyph),
    [(0, $814y1.TIME_ESTIMATE_TYPE)]: (0, $33mJg.originalTimeEstimateGlyph),
    [(0, $814y1.ASSETS_CF_TYPE)]: (0, $33mJg.screenGlyph),
    [(0, $814y1.SERVICE_ENTITY_CF_TYPE)]: (0, $33mJg.labelGlyph),
    [(0, $814y1.STATUS_TYPE)]: (0, $33mJg.arrowRightGlyph),
    [(0, $814y1.SUMMARY_TYPE)]: (0, $33mJg.shortTextGlyph),
    [(0, $h7qTf.DESCRIPTION_FIELD_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.TEXT_CF_TYPE)]: (0, $33mJg.shortTextGlyph),
    [(0, $h7qTf.TEXT_AREA_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: (0, $33mJg.checkboxGlyph),
    [(0, $814y1.ISSUE_LINKS_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $h7qTf.ENVIRONMENT_FIELD_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.FIX_VERSIONS_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.COMMENT_TYPE)]: (0, $33mJg.commentGlyph),
    [(0, $814y1.APPROVERS_LIST_CF_TYPE)]: (0, $33mJg.appAccessGlyph),
    [(0, $814y1.APPROVALS_CF_TYPE)]: (0, $33mJg.appAccessGlyph),
    [(0, $814y1.PROJECT_PICKER_CF_TYPE)]: (0, $33mJg.folderGlyph),
    [(0, $814y1.MESSAGE_EDIT_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.MESSAGE_VIEW_CF_TYPE)]: (0, $33mJg.paragraphGlyph),
    [(0, $814y1.CATEGORY_TYPE)]: (0, $33mJg.jwmCategoryGlyph),
    [(0, $814y1.ENTITLEMENT_CF_TYPE)]: (0, $33mJg.dropdownGlyph),
    [(0, $814y1.SENTIMENT_CF_TYPE)]: (0, $33mJg.customFieldGlyph),
    [(0, $814y1.ORGANIZATION_CF_TYPE)]: (0, $33mJg.customFieldGlyph)
};
const $a32db5a6d1618aac$export$14355977bfae6aaa = {
    ...$a32db5a6d1618aac$var$checkedFieldTypesGlyphs,
    text: (0, $33mJg.paragraphGlyph),
    number: (0, $33mJg.numberGlyph),
    date: (0, $33mJg.dateGlyph),
    datetime: (0, $33mJg.timeStampGlyph),
    dropdown: (0, $33mJg.dropdownGlyph),
    addon: (0, $33mJg.addonGlyph),
    checkbox: (0, $33mJg.checkboxGlyph),
    user: (0, $33mJg.peopleGlyph),
    radio: (0, $33mJg.radioGlyph),
    time: (0, $33mJg.timeStampGlyph),
    message: (0, $33mJg.commentGlyph),
    bulletList: (0, $33mJg.bulletListGlyph),
    label: (0, $33mJg.labelGlyph),
    labelpicker: (0, $33mJg.labelGlyph),
    close: (0, $33mJg.closeGlyph),
    assetspicker: (0, $33mJg.screenGlyph),
    select: (0, $33mJg.dropdownGlyph),
    multiselect: (0, $33mJg.dropdownGlyph),
    cascadingselect: (0, $33mJg.doubleDropdownGlyph),
    multigrouppicker: (0, $33mJg.dropdownGlyph),
    grouppicker: (0, $33mJg.dropdownGlyph),
    multiversion: (0, $33mJg.dropdownGlyph),
    version: (0, $33mJg.dropdownGlyph),
    projectpicker: (0, $33mJg.dropdownGlyph),
    customField: (0, $33mJg.customFieldGlyph)
};
const $a32db5a6d1618aac$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $814y1.TEAMS_PLATFORM_CF_TYPE)) return (0, $7jTnu.fg)('twcj-37_update_team_icons_and_avatars_in_jira') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8G3gB))), {
        label: "",
        size: size,
        spacing: "spacious",
        testId: testId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bY9p9))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $814y1.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BXjD))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        label: "",
        glyph: $a32db5a6d1618aac$var$checkedFieldTypesGlyphs[type] || $a32db5a6d1618aac$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    });
});
const $a32db5a6d1618aac$export$87c5289d8835f589 = /*#__PURE__*/ (0, $eJOHy.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $814y1.TEAMS_PLATFORM_CF_TYPE)) {
        const iconSpacing = size === 'small' ? 'compact' : 'spacious';
        return (0, $7jTnu.fg)('twcj-37_update_team_icons_and_avatars_in_jira') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8G3gB))), {
            label: "",
            size: size,
            spacing: iconSpacing,
            testId: testId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bY9p9))), {
            label: "",
            size: size,
            testId: testId
        });
    }
    if (type === (0, $814y1.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4BXjD))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aCmsU.default), {
        label: "",
        glyph: $a32db5a6d1618aac$export$14355977bfae6aaa[type] || $a32db5a6d1618aac$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    });
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $a32db5a6d1618aac$export$2e2bcd8739ae039 = $a32db5a6d1618aac$var$allIcons;

});
parcelRegister("9nmYq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d38151dcfc47747$var$_react = $6d38151dcfc47747$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6d38151dcfc47747$var$_branch = $6d38151dcfc47747$var$_interopRequireDefault((parcelRequire("fA73y")));

var $6d38151dcfc47747$var$_branches = $6d38151dcfc47747$var$_interopRequireDefault((parcelRequire("a0K0E")));
function $6d38151dcfc47747$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6d38151dcfc47747$var$BranchIcon = (props)=>/*#__PURE__*/ $6d38151dcfc47747$var$_react.default.createElement($6d38151dcfc47747$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $6d38151dcfc47747$var$_branches.default
    }, props));
$6d38151dcfc47747$var$BranchIcon.Name = 'BranchIconMigration';
var $6d38151dcfc47747$var$_default = module.exports.default = $6d38151dcfc47747$var$BranchIcon;

});
parcelRegister("fA73y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b57fb106ce6ba08e$var$_react = $b57fb106ce6ba08e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b57fb106ce6ba08e$var$_baseNew = $b57fb106ce6ba08e$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $b57fb106ce6ba08e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b57fb106ce6ba08e$var$BranchIcon = (props)=>/*#__PURE__*/ $b57fb106ce6ba08e$var$_react.default.createElement($b57fb106ce6ba08e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$b57fb106ce6ba08e$var$BranchIcon.displayName = 'BranchIcon';
var $b57fb106ce6ba08e$var$_default = module.exports.default = $b57fb106ce6ba08e$var$BranchIcon;

});

parcelRegister("a0K0E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $749d980244191d95$var$_react = $749d980244191d95$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $749d980244191d95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $749d980244191d95$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $749d980244191d95$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props));
$749d980244191d95$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $749d980244191d95$var$_default = module.exports.default = $749d980244191d95$var$BitbucketBranchesIcon;

});


parcelRegister("iovNB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8fa98d5af7aa71848cf5218e04fd5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d643228279e7ac69$var$_react = $d643228279e7ac69$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d643228279e7ac69$var$_stopwatch = $d643228279e7ac69$var$_interopRequireDefault((parcelRequire("j1DEd")));

var $d643228279e7ac69$var$_stopwatch2 = $d643228279e7ac69$var$_interopRequireDefault((parcelRequire("bibxr")));
function $d643228279e7ac69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StopwatchIcon.
 * This component is StopwatchIcon, with `UNSAFE_fallbackIcon` set to "StopwatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d643228279e7ac69$var$StopwatchIcon = (props)=>/*#__PURE__*/ $d643228279e7ac69$var$_react.default.createElement($d643228279e7ac69$var$_stopwatch.default, Object.assign({
        LEGACY_fallbackIcon: $d643228279e7ac69$var$_stopwatch2.default
    }, props));
$d643228279e7ac69$var$StopwatchIcon.Name = 'StopwatchIconMigration';
var $d643228279e7ac69$var$_default = module.exports.default = $d643228279e7ac69$var$StopwatchIcon;

});
parcelRegister("j1DEd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da0501648aefebd7252ab6523b352986>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd9cdd8594092cf7$var$_react = $dd9cdd8594092cf7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $dd9cdd8594092cf7$var$_baseNew = $dd9cdd8594092cf7$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $dd9cdd8594092cf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd9cdd8594092cf7$var$StopwatchIcon = (props)=>/*#__PURE__*/ $dd9cdd8594092cf7$var$_react.default.createElement($dd9cdd8594092cf7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$dd9cdd8594092cf7$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $dd9cdd8594092cf7$var$_default = module.exports.default = $dd9cdd8594092cf7$var$StopwatchIcon;

});

parcelRegister("bibxr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $838a536be70b7537$var$_react = $838a536be70b7537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $838a536be70b7537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $838a536be70b7537$var$StopwatchIcon = (props)=>/*#__PURE__*/ $838a536be70b7537$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props));
$838a536be70b7537$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $838a536be70b7537$var$_default = module.exports.default = $838a536be70b7537$var$StopwatchIcon;

});


parcelRegister("33mJg", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $845d6a4dfc3d7122$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $845d6a4dfc3d7122$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $845d6a4dfc3d7122$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $845d6a4dfc3d7122$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $845d6a4dfc3d7122$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $845d6a4dfc3d7122$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $845d6a4dfc3d7122$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $845d6a4dfc3d7122$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $845d6a4dfc3d7122$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $845d6a4dfc3d7122$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $845d6a4dfc3d7122$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $845d6a4dfc3d7122$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $845d6a4dfc3d7122$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $845d6a4dfc3d7122$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $845d6a4dfc3d7122$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $845d6a4dfc3d7122$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $845d6a4dfc3d7122$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $845d6a4dfc3d7122$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $845d6a4dfc3d7122$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $845d6a4dfc3d7122$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $845d6a4dfc3d7122$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $845d6a4dfc3d7122$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $845d6a4dfc3d7122$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $845d6a4dfc3d7122$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $845d6a4dfc3d7122$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $845d6a4dfc3d7122$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $845d6a4dfc3d7122$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $845d6a4dfc3d7122$export$88453606d7da6ff7);

var $eJOHy = parcelRequire("eJOHy");
const $845d6a4dfc3d7122$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $845d6a4dfc3d7122$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $845d6a4dfc3d7122$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $845d6a4dfc3d7122$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("gX8pG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4e37e5cc168504$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2b4e37e5cc168504$var$messages = (0, $7qGN1.defineMessages)({
    deprecatedEpicMessage: {
        "id": "jql-builder-basic.services.use-fields.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    notInContextFieldMessage: {
        "id": "jql-builder-basic.services.use-fields.not-in-context-field-message",
        "defaultMessage": "This field is unavailable for the selected project and/or issue type."
    },
    notInContextFieldMessageIssueTermRefresh: {
        "id": "jql-builder-basic.services.use-fields.not-in-context-field-message-issue-term-refresh",
        "defaultMessage": "This field is unavailable for the selected project and/or work type."
    },
    notInContextFieldMessageIssueTermRefreshGalaxia: {
        "id": "jql-builder-basic.services.use-fields.not-in-context-field-message-issue-term-refresh-galaxia",
        "defaultMessage": "This field is unavailable for the selected space and/or work type."
    }
});
var $2b4e37e5cc168504$export$2e2bcd8739ae039 = $2b4e37e5cc168504$var$messages;

});


parcelRegister("3SxQz", function(module, exports) {

$parcel$export(module.exports, "removeFieldsFromJql", () => $25996a2cd844b33d$export$cc86b3e973172951);

var $3c1PD = parcelRequire("3c1PD");
var $iTOA0 = parcelRequire("iTOA0");

var $jwox6 = parcelRequire("jwox6");
const $25996a2cd844b33d$export$cc86b3e973172951 = (ast, clausesToRemove, textSearchInputClause)=>{
    (0, $iTOA0.walkAST)({
        enterTerminalClause (terminalClause) {
            const isTextSearchInput = textSearchInputClause && new (0, $jwox6.IsInCompoundClauseVisitor)(terminalClause).visit(textSearchInputClause);
            if (clausesToRemove.has(terminalClause.field.value.toLowerCase()) && !isTextSearchInput) terminalClause.remove();
        }
    }, ast);
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("ce3v0", function(module, exports) {

$parcel$export(module.exports, "useSendAnalytics", () => $d1703ea48a3fd165$export$a8fd9767f372c6ec);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $d1703ea48a3fd165$export$a8fd9767f372c6ec = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const sendAnalytics = (0, $eJOHy.useCallback)(({ actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent
    ]);
    return sendAnalytics;
};

});

parcelRegister("4kCrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $edc966f003f68a2f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $edc966f003f68a2f$var$messages = (0, $7qGN1.defineMessages)({
    loadingMessageStart: {
        "id": "jql-builder-basic.jql-editor.add-filter.loading-message-start",
        "defaultMessage": "Loading more filters"
    },
    loadingMessageEnd: {
        "id": "jql-builder-basic.jql-editor.add-filter.loading-message-end",
        "defaultMessage": "Finished loading filters"
    }
});
var $edc966f003f68a2f$export$2e2bcd8739ae039 = $edc966f003f68a2f$var$messages;

});

parcelRegister("eurzt", function(module, exports) {

let $a8c941115f7b4d2c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a8c941115f7b4d2c$var$load("jRw8u").then(()=>parcelRequire('1CR3k'));

});


parcelRegister("bYJeL", function(module, exports) {

$parcel$export(module.exports, "default", () => $33afa19ea889a8e3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $6XJko = parcelRequire("6XJko");

var $eqSys = parcelRequire("eqSys");

var $bNtSK = parcelRequire("bNtSK");

var $1gVNb = parcelRequire("1gVNb");

var $9dqYm = parcelRequire("9dqYm");

var $h9gPh = parcelRequire("h9gPh");

var $lYhmm = parcelRequire("lYhmm");

var $aAvty = parcelRequire("aAvty");

var $8b3Zt = parcelRequire("8b3Zt");

var $5maGz = parcelRequire("5maGz");

var $6CLhR = parcelRequire("6CLhR");

var $8M9FQ = parcelRequire("8M9FQ");

var $01FiY = parcelRequire("01FiY");
const $33afa19ea889a8e3$var$analyticsAttributes = {
    pickerType: 'field'
};
const $33afa19ea889a8e3$var$FieldWrapperNew = ({ children: children, useListElement: useListElement, handleKeyDown: handleKeyDown })=>{
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    return useListElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StyledListItemChildComponent, {
        "data-vc": "jql-builder-basic-field-list-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        onKeyDown: handleKeyDown
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1gVNb.StyledChild), {
        onKeyDown: handleKeyDown
    }, children);
};
const $33afa19ea889a8e3$export$a455218a85c89869 = ({ fieldToRender: fieldToRender, onSearchWrapper: onSearchWrapper, onSwitchToJql: onSwitchToJql, fieldsToRender: fieldsToRender, loading: loading, hydratedData: hydratedData, selectedFields: selectedFields, onClearPicker: onClearPicker, projectOptions: projectOptions, singleSelectFields: singleSelectFields = [], shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, contextJql: contextJql, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const { clause: clause, secondaryClause: secondaryClause, fieldId: fieldId, fieldLabel: fieldLabel, picker: picker, fieldDescription: fieldDescription, isIrremovable: isIrremovable } = fieldToRender;
    const sendOptionAnalytics = (0, $h9gPh.useSendOptionAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { pickerType: pickerType, propType: propType, fieldType: fieldType } = picker;
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup, closeAllPopups: closeAllPopups }] = (0, $9dqYm.useActivePopupKey)();
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        const attributes = {
            actionType: 'open'
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
        return openPopup(fieldId);
    }, [
        createAnalyticsEvent,
        fieldId,
        openPopup
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        const attributes = {
            actionType: 'close'
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
        return closePopup(fieldId);
    }, [
        closePopup,
        fieldId,
        createAnalyticsEvent
    ]);
    const onClearCallback = (0, $eJOHy.useCallback)((onClearJqlClause)=>{
        const newSelectedFields = selectedFields.filter((selectedField)=>selectedField.value.toLowerCase() !== fieldId.toLowerCase());
        if (onClearJqlClause !== undefined) {
            onClearPicker({
                selectedFields: newSelectedFields
            });
            onSearchWrapper && onSearchWrapper(onClearJqlClause);
        } else onClearPicker({
            selectedFields: newSelectedFields,
            fieldsToRender: fieldsToRender.filter((field)=>fieldId.toLowerCase() !== field.fieldId)
        });
    }, [
        fieldId,
        fieldsToRender,
        onClearPicker,
        onSearchWrapper,
        selectedFields
    ]);
    const handleOnKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // avoid closing a modal on closing a picker with esc key
            const isOpen = activePopupKey === fieldId;
            isOpen && event.stopPropagation();
            onClose();
        }
    };
    const UnsupportedFieldPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
        useListElement: Boolean(shouldUseListMarkup),
        handleKeyDown: handleOnKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $01FiY.UnsupportedPickerWrapper), {
        activePopupKey: activePopupKey,
        clause: clause,
        fieldDescription: fieldDescription,
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        onClose: onClose,
        onOpen: onOpen,
        onClear: onClearCallback,
        onSwitchToJql: onSwitchToJql
    }));
    switch(pickerType){
        case (0, $eqSys.PickerTypes).Picker:
            if (clause && clause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                sourceName: "valueSearch",
                sourceType: (0, $466f60259c330878$export$cae2783c9279926),
                attributes: $33afa19ea889a8e3$var$analyticsAttributes
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6CLhR.PickerWrapper), {
                onSearchWrapper: onSearchWrapper,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                picker: picker,
                terminalClause: clause || undefined,
                activePopupKey: activePopupKey,
                onOpen: onOpen,
                onClose: onClose,
                onSendOptionAnalytics: sendOptionAnalytics,
                loading: loading,
                hydratedData: hydratedData,
                onClear: onClearCallback,
                projectOptions: projectOptions,
                isMulti: !singleSelectFields.includes(fieldId),
                fieldDescription: fieldDescription,
                onOpenOperatorPicker: closeAllPopups,
                hideOperatorDropdown: hideOperatorDropdown,
                isIrremovable: isIrremovable,
                contextJql: contextJql,
                viewContext: viewContext,
                scope: scope,
                suggestedUsersCount: suggestedUsersCount
            })));
        case (0, $eqSys.PickerTypes).TextArea:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8M9FQ.TextAreaPicker), {
                clause: clause,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                fieldType: fieldType,
                activePopupKey: activePopupKey,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                fieldDescription: fieldDescription,
                propType: propType,
                isIrremovable: isIrremovable
            }));
        case (0, $eqSys.PickerTypes).DateTime:
        case (0, $eqSys.PickerTypes).DueDate:
        case (0, $eqSys.PickerTypes).DateTimeRange:
            if (clause && clause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) || secondaryClause && secondaryClause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aAvty.DatePickerWrapper), {
                clause: clause,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                pickerType: pickerType,
                activePopupKey: activePopupKey,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                secondaryClause: secondaryClause,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }));
        case (0, $eqSys.PickerTypes).CascadeSelect:
            if (clause && clause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lYhmm.CascadeSelectPicker), {
                activePopupKey: activePopupKey,
                clause: clause,
                fieldDescription: fieldDescription,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                hydratedData: hydratedData,
                onClose: onClose,
                onOpen: onOpen,
                onSearchWrapper: onSearchWrapper,
                onSendOptionAnalytics: sendOptionAnalytics,
                onClear: onClearCallback,
                isIrremovable: isIrremovable,
                contextJql: contextJql
            }));
        case (0, $eqSys.PickerTypes).NumberRange:
            if (clause && clause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) || secondaryClause && secondaryClause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5maGz.NumberRangePicker), {
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                activePopupKey: activePopupKey,
                clause: clause,
                secondaryClause: secondaryClause,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                fieldDescription: fieldDescription,
                onSendOptionAnalytics: sendOptionAnalytics,
                isIrremovable: isIrremovable
            }));
        case (0, $eqSys.PickerTypes).BooleanType:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33afa19ea889a8e3$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8b3Zt.LastUserCommentedPickerWrapper), {
                activePopupKey: activePopupKey,
                clause: clause,
                fieldDescription: fieldDescription,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                onClose: onClose,
                onOpen: onOpen,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                isIrremovable: isIrremovable
            }));
        default:
            return UnsupportedFieldPicker;
    }
};
var $33afa19ea889a8e3$export$2e2bcd8739ae039 = $33afa19ea889a8e3$export$a455218a85c89869;

});
parcelRegister("h9gPh", function(module, exports) {

$parcel$export(module.exports, "useSendOptionAnalytics", () => $079b59d2717b0607$export$dd648d2c308aa842);

var $eJOHy = parcelRequire("eJOHy");

var $jFHCE = parcelRequire("jFHCE");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");
const $079b59d2717b0607$export$dd648d2c308aa842 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((attributes)=>{
        const actionSubjectId = 'refinementBarFilterSearch';
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'changed',
            actionSubject: 'filterSearch',
            actionSubjectId: actionSubjectId
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, actionSubjectId, (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(attributes, 'fieldId'));
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("lYhmm", function(module, exports) {

$parcel$export(module.exports, "CascadeSelectPicker", () => $f01cfe735bc99dd9$export$d469cbf777198f76);

var $eJOHy = parcelRequire("eJOHy");


var $boEdP = parcelRequire("boEdP");

var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $7PQ0T = parcelRequire("7PQ0T");

var $5gMlm = parcelRequire("5gMlm");

var $7hNmk = parcelRequire("7hNmk");

var $7Wv9B = parcelRequire("7Wv9B");

var $37ded = parcelRequire("37ded");
const $f01cfe735bc99dd9$export$d469cbf777198f76 = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, hydratedData: hydratedData, onClose: onClose, onOpen: onOpen, onClear: onClear, onSearchWrapper: onSearchWrapper, onSendOptionAnalytics: onSendOptionAnalytics, isIrremovable: isIrremovable, contextJql: contextJql })=>{
    if (clause !== undefined && clause.clauseType !== (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) throw new Error('cascadeSelectPicker attempted to hydrate using a query that should have been handled by query-too-complex');
    // match the hydrated value to the option from the clause & handle optimistic updates
    const selectedOptionsFromHydration = (0, $7Wv9B.useHydratedValues)({
        fieldId: fieldId,
        clause: clause,
        hydratedData: hydratedData
    });
    const [selectedOption, setSelectedOption] = (0, $37ded.useSelectedValues)(hydratedData, selectedOptionsFromHydration);
    const [ast] = (0, $lyPdT.useAST)();
    /**
	 * fieldLabel comes from field displayName from the hydration data.
	 * It is defined in the fragment `jqlEditor_jqlBuilderBasic_JQLEditorUI` in
	 * `src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx`
	 * we never expect it to be undefined but since we are not using the @required
	 * directive in the fragment, this check is required.
	 */ const safeFieldLabel = fieldLabel ?? '';
    const triggerTextContent = {
        fieldLabel: safeFieldLabel,
        parentOption: selectedOption?.parentOption?.label,
        childOption: selectedOption?.childOption?.label
    };
    const triggerHasValues = Boolean(triggerTextContent.parentOption || triggerTextContent.childOption);
    const triggerHasInvalidValues = Boolean(selectedOption?.parentOption?.isInvalid || selectedOption?.childOption?.isInvalid);
    const isOpen = activePopupKey === fieldId;
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const triggerRenderer = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
            ...triggerProps,
            fieldDescription: fieldDescription,
            isInvalid: triggerHasInvalidValues,
            isSelected: isOpen,
            isLoading: false,
            hasValues: triggerHasValues,
            onClear: ()=>onClear(clause ? (0, $boEdP.default)(ast, clause) : undefined),
            onClick: onTriggerClick,
            testId: "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.picker-trigger",
            isIrremovable: isIrremovable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5gMlm.TriggerLabelContainer), {
            fieldLabel: triggerTextContent.fieldLabel,
            parentValue: triggerTextContent.parentOption,
            childValue: triggerTextContent.childOption
        })), [
        fieldDescription,
        triggerHasInvalidValues,
        isOpen,
        triggerHasValues,
        onTriggerClick,
        isIrremovable,
        triggerTextContent.fieldLabel,
        triggerTextContent.parentOption,
        triggerTextContent.childOption,
        onClear,
        clause,
        ast
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PQ0T.CascadeSelectPickerPopup), {
        fieldId: fieldId,
        initialValue: selectedOption,
        isOpen: isOpen,
        onClose: onClose,
        onChange: (newValue)=>{
            setSelectedOption(newValue);
            onSendOptionAnalytics && onSendOptionAnalytics({
                hasParentOption: Boolean(newValue.parentOption),
                hasChildOption: Boolean(newValue.childOption)
            });
            onSearchWrapper && onSearchWrapper((0, $7hNmk.getUpdatedJql)(ast, clause, fieldId, newValue));
            onClose();
        },
        renderTrigger: triggerRenderer,
        contextJql: contextJql
    });
};

});
parcelRegister("boEdP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4952339e703518b2$export$2e2bcd8739ae039);


var $etRm8 = parcelRequire("etRm8");

var $9o0jj = parcelRequire("9o0jj");
const $4952339e703518b2$var$removeFieldClauseFromJql = (ast, clauseToRemove)=>{
    const jqlString = ast.represents;
    let previousClause;
    let nextClause;
    const where = ast.query?.where;
    if (where && where.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b)) for(let index = 0; index < where.clauses.length; index += 1){
        const clause = where.clauses[index];
        const clausePosition = clause.position;
        const clauseToRemovePosition = clauseToRemove.position;
        // Early exit if position data is unavailable for our clause
        if (!clausePosition || !clauseToRemovePosition) return jqlString;
        if (clausePosition[0] === clauseToRemovePosition[0] && clausePosition[1] === clauseToRemovePosition[1]) {
            previousClause = where.clauses[index - 1];
            nextClause = where.clauses[index + 1];
        }
    }
    const clauseToRemovePosition = (0, $9o0jj.getClausePosition)(jqlString, clauseToRemove);
    // Early exit if position data is unavailable for our clause
    if (!clauseToRemovePosition) return jqlString;
    const [clauseToRemoveStart, clauseToRemoveEnd] = clauseToRemovePosition;
    if (previousClause) {
        // preserve AND inbetween
        if (nextClause) {
            const nextClausePosition = (0, $9o0jj.getClausePosition)(jqlString, nextClause);
            // Early exit if position data is unavailable for our clause
            if (!nextClausePosition) return jqlString;
            return (0, $etRm8.substring)(jqlString, 0, clauseToRemoveStart) + (0, $etRm8.substring)(jqlString, nextClausePosition[0]);
        }
        const previousClausePosition = (0, $9o0jj.getClausePosition)(jqlString, previousClause);
        // Early exit if position data is unavailable for our clause
        if (!previousClausePosition) return jqlString;
        return (0, $etRm8.substring)(jqlString, 0, previousClausePosition[1]) + (0, $etRm8.substring)(jqlString, clauseToRemoveEnd);
    }
    if (!previousClause) {
        if (nextClause) {
            const nextClausePosition = (0, $9o0jj.getClausePosition)(jqlString, nextClause);
            // Early exit if position data is unavailable for our clause
            if (!nextClausePosition) return jqlString;
            return (0, $etRm8.substring)(jqlString, 0, clauseToRemoveStart) + (0, $etRm8.substring)(jqlString, nextClausePosition[0]);
        }
        return (0, $etRm8.substring)(jqlString, 0, clauseToRemoveStart) + (0, $etRm8.substring)(jqlString, clauseToRemoveEnd);
    }
    return jqlString;
};
var $4952339e703518b2$export$2e2bcd8739ae039 = $4952339e703518b2$var$removeFieldClauseFromJql;

});
parcelRegister("etRm8", function(module, exports) {

$parcel$export(module.exports, "substring", () => $a6ff7d96722f4e2e$export$662d3818631fba36);
/**
 * Returns the substring at the specified location within a String object while supporting Emojis.
 *
 * This method is to be used instead of String.substring. String.substring does not handle emojis correctly as they can be multi-char length.
 *
 * @param start — The zero-based index number indicating the beginning of the substring.
 * @param end Zero-based index number indicating the end of the substring. The substring includes the characters up to, but not including, the character indicated by end. If end is omitted, the characters from start through the end of the original string are returned.
 */ const $a6ff7d96722f4e2e$export$662d3818631fba36 = (str, start, end)=>[
        ...str
    ].slice(start, end).join('');

});

parcelRegister("9o0jj", function(module, exports) {

$parcel$export(module.exports, "getClausePosition", () => $5dfc7784089511a1$export$9a8cf65f444b696f);
const $5dfc7784089511a1$var$whiteSpaceRegex = /\s/;
const $5dfc7784089511a1$export$9a8cf65f444b696f = (jql, clause)=>{
    if (!clause.position) return null;
    let [start, end] = [
        undefined,
        undefined
    ];
    // Spreading the jql will account for multi-char unicode characters
    const jqlSymbols = [
        ...jql
    ];
    // Start
    for(let i = clause.position[0] - 1; i >= 0; i -= 1){
        const symbol = jqlSymbols[i];
        if (symbol === '(') {
            start = i;
            break;
        }
        // The use of continue here to check for
        if (!$5dfc7784089511a1$var$whiteSpaceRegex.test(symbol)) break;
    }
    // short circuit here if no '(' is found
    if (start === undefined) return clause.position;
    // End
    for(let i = clause.position[1]; i <= jqlSymbols.length; i += 1){
        const symbol = jqlSymbols[i];
        if (symbol === ')') {
            end = i + 1;
            break;
        }
        if (!$5dfc7784089511a1$var$whiteSpaceRegex.test(symbol)) break;
    }
    return start !== undefined && end !== undefined ? [
        start,
        end
    ] : clause.position;
};

});


parcelRegister("7PQ0T", function(module, exports) {

$parcel$export(module.exports, "CascadeSelectPickerPopup", () => $a8c12e4e24cc1d6b$export$f74bfb091b432a99);

var $eJOHy = parcelRequire("eJOHy");

var $iTysS = parcelRequire("iTysS");

var $5LwVz = parcelRequire("5LwVz");

var $cNe2t = parcelRequire("cNe2t");
const $a8c12e4e24cc1d6b$export$f74bfb091b432a99 = ({ fieldId: fieldId, initialValue: initialValue, isOpen: isOpen, onClose: onClose, onChange: onChange, renderTrigger: renderTrigger, contextJql: contextJql })=>{
    const renderContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iTysS.CascadingSelectView), {
            jqlTerm: fieldId,
            jqlContext: contextJql,
            initialValue: initialValue,
            onChange: onChange,
            setInitialFocusRef: setInitialFocusRef
        }), [
        fieldId,
        contextJql,
        initialValue,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: renderContent,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.popup",
        messageType: "transactional",
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        trigger: renderTrigger
    });
};

});
parcelRegister("iTysS", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectView", () => $cc3cbdcd717128e1$export$468e769561d652ac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $lx8oo = parcelRequire("lx8oo");

var $i9p2T = parcelRequire("i9p2T");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $aAdFp = parcelRequire("aAdFp");

var $lRq8t = parcelRequire("lRq8t");

var $h6ll6 = parcelRequire("h6ll6");

var $5oTNo = parcelRequire("5oTNo");

var $4HZBL = parcelRequire("4HZBL");
const $cc3cbdcd717128e1$var$PARENT_INPUT_ID = 'jql-builder-cascading-select-parent-options-select';
const $cc3cbdcd717128e1$var$CHILD_INPUT_ID = 'jql-builder-cascading-select-child-options-select';
const $cc3cbdcd717128e1$export$468e769561d652ac = ({ jqlTerm: jqlTerm, jqlContext: jqlContext, initialValue: initialValue, onChange: onChange, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Parent data
    const [selectedParentOption, setSelectedParentOption] = (0, $eJOHy.useState)(initialValue?.parentOption);
    const { loadOptions: loadParentOptions } = (0, $h6ll6.useCascadingSelectValuesLoader)({
        jqlTerm: jqlTerm,
        optionType: 'PARENT',
        jqlContext: jqlContext
    });
    // Child data
    const [selectedChildOption, setSelectedChildOption] = (0, $eJOHy.useState)(initialValue?.childOption);
    const { loadOptions: loadChildOptions } = (0, $h6ll6.useCascadingSelectValuesLoader)({
        jqlTerm: jqlTerm,
        optionType: 'CHILD',
        jqlContext: jqlContext,
        parentOptionId: selectedParentOption?.value.toString() ?? undefined
    });
    const onSelectRef = (0, $eJOHy.useCallback)((ref)=>{
        if (ref?.select?.inputRef && setInitialFocusRef) setInitialFocusRef(ref.select.inputRef);
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $cc3cbdcd717128e1$var$dropdownGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $cc3cbdcd717128e1$var$parentDropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lx8oo.Label), {
        htmlFor: $cc3cbdcd717128e1$var$PARENT_INPUT_ID
    }, formatMessage((0, $5oTNo.default).parentSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aAdFp.default), {
        ref: onSelectRef,
        inputId: $cc3cbdcd717128e1$var$PARENT_INPUT_ID,
        testId: "jql-builder-basic-cascading-select.ui.select-parent",
        formatOptionLabel: (0, $4HZBL.formatOptionLabel),
        placeholder: formatMessage((0, $5oTNo.default).parentSelectPlaceholder),
        noOptionsMessage: ()=>formatMessage((0, $5oTNo.default).noOptions),
        value: selectedParentOption,
        loadOptions: loadParentOptions,
        onChange: (newValue)=>{
            if (!newValue || newValue !== selectedParentOption) setSelectedChildOption(undefined);
            setSelectedParentOption(newValue ?? undefined);
        },
        defaultOptions: true,
        isClearable: true,
        isInvalid: selectedParentOption?.isInvalid
    }), selectedParentOption?.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, selectedParentOption?.invalidMessage ?? formatMessage((0, $5oTNo.default).invalidOptionMessage, {
        selectField: formatMessage((0, $5oTNo.default).parentSelectLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $cc3cbdcd717128e1$var$childDropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lx8oo.Label), {
        htmlFor: $cc3cbdcd717128e1$var$CHILD_INPUT_ID
    }, formatMessage((0, $5oTNo.default).childSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aAdFp.default), {
        key: selectedParentOption?.value,
        inputId: $cc3cbdcd717128e1$var$CHILD_INPUT_ID,
        testId: "jql-builder-basic-cascading-select.ui.select-child",
        formatOptionLabel: (0, $4HZBL.formatOptionLabel),
        placeholder: formatMessage((0, $5oTNo.default).childSelectPlaceholder),
        noOptionsMessage: ()=>formatMessage((0, $5oTNo.default).noOptions),
        value: selectedChildOption,
        loadOptions: selectedParentOption ? loadChildOptions : undefined,
        onChange: (newValue)=>setSelectedChildOption(newValue ?? undefined),
        isDisabled: !selectedParentOption,
        defaultOptions: true,
        isClearable: true,
        isInvalid: selectedChildOption?.isInvalid
    }), selectedChildOption?.isInvalid && !selectedParentOption?.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, selectedParentOption?.invalidMessage ?? formatMessage((0, $5oTNo.default).invalidOptionMessage, {
        selectField: formatMessage((0, $5oTNo.default).parentSelectLabel)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cc3cbdcd717128e1$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "primary",
        onClick: (e)=>{
            e.preventDefault();
            onChange({
                parentOption: selectedParentOption,
                childOption: selectedChildOption
            });
        },
        type: "submit",
        isDisabled: false,
        testId: "jql-builder-basic-cascading-select.ui.update-button"
    }, formatMessage((0, $5oTNo.default).updateButtonText))));
};
const $cc3cbdcd717128e1$var$dropdownGroupContainerStyles = (0, $5Wv5g.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $cc3cbdcd717128e1$var$parentDropdownContainerStyles = (0, $5Wv5g.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $cc3cbdcd717128e1$var$childDropdownContainerStyles = (0, $5Wv5g.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc3cbdcd717128e1$var$StyledButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h6ll6", function(module, exports) {

$parcel$export(module.exports, "useCascadingSelectValuesLoader", () => $297dd5293a8e5958$export$34980bb479d0f067);

var $lMsOr = parcelRequire("lMsOr");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $kEUB1 = parcelRequire("kEUB1");


var $2oJGZ = parcelRequire("2oJGZ");
const $297dd5293a8e5958$export$c52a35aaea869872 = async (environment, variables)=>{
    const result = await (0, $j4oe4.fetchQuery)(environment, (0, $lMsOr.default), variables, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!result) throw new Error('Unexpected empty result received from useCascadingSelectValuesLoaderQuery');
    const { pageInfo: pageInfo, edges: edges } = result.jira.jqlBuilder.cascadingSelectValues;
    const options = edges.map((edge)=>edge ? {
            label: edge.node.displayName,
            value: edge.node.optionId
        } : undefined).filter(Boolean);
    return pageInfo.hasNextPage && pageInfo.endCursor ? options.concat(await $297dd5293a8e5958$export$c52a35aaea869872(environment, {
        ...variables,
        after: pageInfo.endCursor
    })) : options;
};
const $297dd5293a8e5958$export$34980bb479d0f067 = ({ jqlTerm: jqlTerm, jqlContext: jqlContext, optionType: optionType, parentOptionId: parentOptionId })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useMemo)(()=>({
            loadOptions: (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(// Must return void/undefined. AK select ignores the callback if a promise/async is returned.
            (searchString, cb)=>{
                $297dd5293a8e5958$export$c52a35aaea869872(environment, {
                    searchString: searchString,
                    cloudId: cloudId,
                    jqlTerm: jqlTerm,
                    jqlContext: jqlContext,
                    optionType: optionType,
                    parentOptionId: parentOptionId
                }).catch((error)=>{
                    (0, $gYnSx.default)({
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        meta: {
                            id: 'useCascadingSelectValuesLoaderError',
                            packageName: (0, $7275f557eeceb717$export$355546c9851d0c23),
                            teamName: 'empanada'
                        }
                    });
                    return [
                        {
                            label: formatMessage((0, $2oJGZ.default).fetchError),
                            value: '',
                            isDisabled: true
                        }
                    ];
                }).then(cb);
            }, 500)
        }), [
        cloudId,
        environment,
        formatMessage,
        jqlContext,
        jqlTerm,
        optionType,
        parentOptionId
    ]);
};

});
parcelRegister("lMsOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f774d595c016734e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5a55b2db0d39bf05e1c7d776024275e>>
 * @relayHash c58b78e997cd2d1bf926e8e2e8d669a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e5ce2c8910f5a8665b5d15e181d1b534162ee1416e674e05e682caad7c9f62d
const $f774d595c016734e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "optionType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentOptionId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "optionType",
                    "variableName": "optionType"
                },
                {
                    "kind": "Variable",
                    "name": "parentOptionId",
                    "variableName": "parentOptionId"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jqlContext"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v9 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "kind": "ScalarField",
        "name": "optionId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCascadingSelectValuesLoaderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v8 /*: any*/ ,
                                                "concreteType": "JiraJqlCascadingOptionFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "cascadingSelectValues",
                                                "plural": false,
                                                "selections": [
                                                    v9 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraJqlCascadingOptionFieldValueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v10 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v11 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jqlBuilder.cascadingSelectValues.edges.node.optionId"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jqlBuilder.cascadingSelectValues.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jqlBuilder.cascadingSelectValues.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jqlBuilder.cascadingSelectValues"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jqlBuilder"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCascadingSelectValuesLoaderQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlCascadingOptionFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "cascadingSelectValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlCascadingOptionFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2e5ce2c8910f5a8665b5d15e181d1b534162ee1416e674e05e682caad7c9f62d",
            "metadata": {},
            "name": "useCascadingSelectValuesLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f774d595c016734e$var$node.hash = "deb7ed0e1bb076edffe453408ba24625";
var $f774d595c016734e$export$2e2bcd8739ae039 = $f774d595c016734e$var$node;

});

const $7275f557eeceb717$export$355546c9851d0c23 = 'jira-jql-builder-basic-cascading-select';

parcelRegister("2oJGZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $54d3f2f988883e9c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $54d3f2f988883e9c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fetchError: {
        "id": "jql-builder-basic-cascading-select.services.use-cascading-select-values-loader.fetch-error",
        "defaultMessage": "Something went wrong, please refresh and try again."
    }
});

});


parcelRegister("5oTNo", function(module, exports) {

$parcel$export(module.exports, "default", () => $536eecd9c3cdb700$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $536eecd9c3cdb700$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-cascading-select.update-button-text",
        "defaultMessage": "Update"
    },
    parentSelectLabel: {
        "id": "jql-builder-basic-cascading-select.parent-select-label",
        "defaultMessage": "Parent option"
    },
    parentSelectPlaceholder: {
        "id": "jql-builder-basic-cascading-select.parent-select-placeholder",
        "defaultMessage": "Select parent option"
    },
    childSelectLabel: {
        "id": "jql-builder-basic-cascading-select.child-select-label",
        "defaultMessage": "Child option"
    },
    childSelectPlaceholder: {
        "id": "jql-builder-basic-cascading-select.child-select-placeholder",
        "defaultMessage": "Select child option"
    },
    noOptions: {
        "id": "jql-builder-basic-cascading-select.no-options",
        "defaultMessage": "No options available"
    },
    invalidOptionMessage: {
        "id": "jql-builder-basic-cascading-select.invalid-option-message",
        "defaultMessage": "\"{selectField}\" selection is not valid for the current project."
    }
});

});

parcelRegister("4HZBL", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $997890c413cb529c$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2KjG5 = parcelRequire("2KjG5");

var $6fhEi = parcelRequire("6fhEi");
const $997890c413cb529c$export$322216d90ffb8d0e = ({ label: label, isInvalid: isInvalid, invalidMessage: invalidMessage })=>{
    if (isInvalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($997890c413cb529c$var$InvalidOption, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($997890c413cb529c$var$InvalidOptionText, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($997890c413cb529c$var$InvalidOptionIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KjG5))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: invalidMessage ?? '',
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6fhEi)))
    })));
    return label;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $997890c413cb529c$var$InvalidOption = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1tmw _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $997890c413cb529c$var$InvalidOptionText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1o9zkb7n _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $997890c413cb529c$var$InvalidOptionIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("5gMlm", function(module, exports) {

$parcel$export(module.exports, "TriggerLabelContainer", () => $98d99684c4964f5b$export$2c19d76757def6a5);

var $eJOHy = parcelRequire("eJOHy");

var $kkE8T = parcelRequire("kkE8T");
const $98d99684c4964f5b$export$2c19d76757def6a5 = ({ fieldLabel: fieldLabel, parentValue: parentValue, childValue: childValue })=>{
    const parentDisplay = parentValue ? `${parentValue}` : '';
    const childDisplay = parentValue && childValue ? ` - ${childValue}` : '';
    const displayValue = `${parentDisplay}${childDisplay}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.LabelContainer), {
        "data-testid": "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.trigger-label-container.label-container"
    }, !parentValue && !childValue ? fieldLabel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.StyledLabel), null, fieldLabel, ": "), displayValue));
};

});

parcelRegister("7hNmk", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $35247e2bed88ed9f$export$1625bb7ada97d007);

var $2poie = parcelRequire("2poie");
var $lNgEH = parcelRequire("lNgEH");
var $3c1PD = parcelRequire("3c1PD");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");
const $35247e2bed88ed9f$var$createTerminalClause = (fieldId, value)=>{
    const args = [];
    if (value.parentOption) // parent value first
    args.push(value.parentOption.value);
    if (value.childOption) // followed by child value
    args.push(value.childOption.value);
    return (0, $2poie.default).terminalClause((0, $2poie.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $2poie.default).operator((0, $lNgEH.OPERATOR_IN)), (0, $2poie.default).functionOperand((0, $2poie.default).functionString((0, $dTJxm.CASCADE_OPTION_FUNCTION_NAME)), args.map((argString)=>(0, $2poie.default).argument(argString.toString()))));
};
const $35247e2bed88ed9f$export$1625bb7ada97d007 = (ast, clause, fieldId, value)=>{
    const hasValue = Boolean(value.parentOption || value.childOption);
    if (!clause) {
        if (!ast.query || !hasValue) return ast.represents;
        ast.query.appendClause($35247e2bed88ed9f$var$createTerminalClause(fieldId, value), (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
    } else if (!hasValue) clause.remove();
    else clause.replace($35247e2bed88ed9f$var$createTerminalClause(fieldId, value));
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("7Wv9B", function(module, exports) {

$parcel$export(module.exports, "useHydratedValues", () => $6e530d75c47b26bd$export$dc23a21ad032e5fa);

var $3RIir = parcelRequire("3RIir");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dFEPL = parcelRequire("dFEPL");
const $6e530d75c47b26bd$export$dc23a21ad032e5fa = ({ fieldId: fieldId, clause: clause, hydratedData: hydratedData })=>{
    /* eslint-disable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ const data = (0, $j4oe4.useFragment)((0, $3RIir.default), hydratedData);
    /* eslint-enable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ return (0, $eJOHy.useMemo)(()=>{
        const hydratedValues = (data.jira?.jqlBuilder?.hydrateJqlQuery ?? data.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm?.toLowerCase() === fieldId)?.values;
        const unambiguousCascadeFieldValue = (0, $dFEPL.findUnambiguousCascadeFieldValue)({
            clause: clause,
            hydratedValues: hydratedValues
        });
        return unambiguousCascadeFieldValue;
    }, [
        clause,
        data.jira?.jqlBuilder?.hydrateJqlQuery,
        data.jira?.jqlBuilder?.hydrateJqlQueryForFilter,
        fieldId
    ]);
};

});
parcelRegister("3RIir", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e1c39e5e3c9f50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03ac623fc1b9a207f6465549a3bccf93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a5e1c39e5e3c9f50$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v6 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useHydratedValues_cascadeSelectPicker",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$a5e1c39e5e3c9f50$var$node.hash = "92d338efa13872bf45e89b5f9f1155af";
var $a5e1c39e5e3c9f50$export$2e2bcd8739ae039 = $a5e1c39e5e3c9f50$var$node;

});


parcelRegister("37ded", function(module, exports) {

$parcel$export(module.exports, "useSelectedValues", () => $f977cf65639d4968$export$e10928cdf9450649);

var $eJOHy = parcelRequire("eJOHy");
const $f977cf65639d4968$export$e10928cdf9450649 = (hydratedData, selectedOptionsFromHydration)=>{
    const prevHydrationData = (0, $eJOHy.useRef)(hydratedData);
    const [hydrated, setHydrated] = (0, $eJOHy.useState)(true);
    // Allow optimistic updates when a value is selected while hydration is taking place
    const [optimisticValues, setOptimisticValues] = (0, $eJOHy.useState)();
    // Only flag values as hydrated after a data change
    (0, $eJOHy.useEffect)(()=>{
        if (!hydrated && hydratedData !== prevHydrationData.current) setHydrated(true);
        prevHydrationData.current = hydratedData;
    }, [
        hydrated,
        hydratedData
    ]);
    const setSelectedValues = (0, $eJOHy.useCallback)((values)=>{
        setHydrated(false);
        setOptimisticValues(values);
    }, []);
    const selectedValues = !hydrated && optimisticValues ? optimisticValues : selectedOptionsFromHydration;
    return [
        selectedValues,
        setSelectedValues
    ];
};

});


parcelRegister("aAvty", function(module, exports) {

$parcel$export(module.exports, "DatePickerWrapper", () => $0363ad5eba43a3d3$export$a915f81916d25a71);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $e2kjR = parcelRequire("e2kjR");

var $4xwUT = parcelRequire("4xwUT");

var $5LwVz = parcelRequire("5LwVz");

var $buJG5 = parcelRequire("buJG5");

var $q3XlS = parcelRequire("q3XlS");

var $cNe2t = parcelRequire("cNe2t");

var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $h9gPh = parcelRequire("h9gPh");
const $0363ad5eba43a3d3$export$a915f81916d25a71 = ({ activePopupKey: activePopupKey, clause: clause, secondaryClause: secondaryClause, fieldId: fieldId, fieldLabel: fieldLabel, pickerType: pickerType, onOpen: onOpen, onClose: onClose, onClear: onClear, onSearchWrapper: onSearchWrapper, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const sendOptionAnalytics = (0, $h9gPh.useSendOptionAnalytics)();
    const variation = (0, $e2kjR.DateTimeVariations)[pickerType] || 'DateTime';
    const dateRefinementValueFromJql = (0, $4xwUT.getValueFromClauses)(variation, clause, secondaryClause);
    const tooltip = (0, $4xwUT.getTooltip)({
        intl: intl,
        label: fieldLabel || '',
        variation: variation,
        value: dateRefinementValueFromJql
    });
    const isOpen = activePopupKey === fieldId;
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        onClear && onClear(clause ? (0, $q3XlS.default)(fieldId, ast, undefined) : undefined);
    }, [
        onClear,
        clause,
        fieldId,
        ast
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.DefaultPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.date-picker-wrapper.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buJG5.ConditionalTooltip), {
                condition: tooltip !== undefined,
                content: tooltip ?? null,
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: Boolean(clause || secondaryClause),
                onClick: handleOnClick,
                onClear: !isIrremovable ? handleOnClear : undefined,
                ref: ref,
                testId: `refinement-bar.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, (0, $4xwUT.formatLabel)({
                intl: intl,
                label: fieldLabel || '',
                variation: variation,
                value: dateRefinementValueFromJql
            }))),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xwUT.default), {
                fieldLabel: fieldLabel,
                variation: variation,
                value: dateRefinementValueFromJql,
                onSendOptionAnalytics: sendOptionAnalytics,
                onClosePopup: onClose,
                onChange: (value)=>onSearchWrapper && onSearchWrapper((0, $q3XlS.default)(fieldId, ast, (0, $4xwUT.getJqlInfo)(value, variation)))
            })
    });
};

});
parcelRegister("e2kjR", function(module, exports) {

$parcel$export(module.exports, "TimeUnits", () => $452c14429b146642$export$5d7753c8ad881494);
$parcel$export(module.exports, "NowOverdue", () => $452c14429b146642$export$28c868305da91826);
$parcel$export(module.exports, "BetweenComponent", () => $452c14429b146642$export$709f90f7ba10389);
$parcel$export(module.exports, "BetweenDateTimeComponent", () => $452c14429b146642$export$abb0f24cc549194b);
$parcel$export(module.exports, "InRangeComponent", () => $452c14429b146642$export$68448428cc911d39);
$parcel$export(module.exports, "TimeInputComponent", () => $452c14429b146642$export$1bc14371a5279585);
$parcel$export(module.exports, "IsNotSetComponent", () => $452c14429b146642$export$112000efafa8ead5);
$parcel$export(module.exports, "DateTimeVariations", () => $452c14429b146642$export$efd605d50e9e79ce);
const $452c14429b146642$export$5d7753c8ad881494 = {
    m: 'minutes',
    h: 'hours',
    d: 'days',
    w: 'weeks'
};
const $452c14429b146642$export$75843c31a96775e0 = 'within_the_last';
const $452c14429b146642$export$7d35a296ea2a6822 = 'more_than';
const $452c14429b146642$export$7df927301bd2f537 = 'between';
const $452c14429b146642$export$5ec4ea40f310605c = 'in_range';
const $452c14429b146642$export$28c868305da91826 = 'now_overdue';
const $452c14429b146642$export$7441c1214e39d97f = 'due_in_next';
const $452c14429b146642$export$de656838e950fdb9 = 'between_date_time';
const $452c14429b146642$export$709f90f7ba10389 = 'between';
const $452c14429b146642$export$abb0f24cc549194b = 'between_date_time';
const $452c14429b146642$export$68448428cc911d39 = 'in_range';
const $452c14429b146642$export$1bc14371a5279585 = 'time_input';
const $452c14429b146642$export$112000efafa8ead5 = 'is_not_set';
const $452c14429b146642$export$efd605d50e9e79ce = {
    DueDate: 'DueDate',
    DateTime: 'DateTime',
    DateTimeRange: 'DateTimeRange'
};

});

parcelRegister("4xwUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $51379c83cbc8267c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatLabel", () => $51379c83cbc8267c$export$957d7daebd899f12);
$parcel$export(module.exports, "getTooltip", () => $51379c83cbc8267c$export$46455b4476d4b8e1);
$parcel$export(module.exports, "getJqlInfo", () => $51379c83cbc8267c$export$8299afa491becffd);
$parcel$export(module.exports, "getValueFromClauses", () => $51379c83cbc8267c$export$66bd7052943865c8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Xz6kS = parcelRequire("Xz6kS");

var $alkjW = parcelRequire("alkjW");

var $Svlt9 = parcelRequire("Svlt9");


var $bxHeV = parcelRequire("bxHeV");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $e2kjR = parcelRequire("e2kjR");

var $8wYmT = parcelRequire("8wYmT");

var $eUhKT = parcelRequire("eUhKT");

var $lRsB7 = parcelRequire("lRsB7");

var $cKrbS = parcelRequire("cKrbS");

var $kgmJM = parcelRequire("kgmJM");

var $fTjd1 = parcelRequire("fTjd1");

var $3QrSv = parcelRequire("3QrSv");

var $73DRj = parcelRequire("73DRj");
const $51379c83cbc8267c$var$hasValue = (dateTimePickerValue)=>{
    if (dateTimePickerValue) {
        const { type: type, value: value } = dateTimePickerValue;
        if (type === 'now_overdue') return {
            type: type,
            value: value
        };
        if (value === null) return false;
        switch(type){
            case 'more_than':
            case 'due_in_next':
            case 'within_the_last':
                return value !== undefined && Boolean(value.value1 && value.value2) ? {
                    value: value,
                    type: type
                } : false;
            case 'between':
            case 'between_date_time':
            case 'in_range':
                return value !== undefined && Boolean(value.value1 || value.value2) ? {
                    value: value,
                    type: type
                } : false;
            default:
                return false;
        }
    }
    return false;
};
const $51379c83cbc8267c$var$getFilterTypes = (name = '')=>{
    if (name === 'DueDate') return 0, $3QrSv.DueDateTypeConfig;
    if (name === 'DateTimeRange') return 0, $3QrSv.DateTimeTypeConfig;
    return 0, $3QrSv.DateTypeConfig;
};
const $51379c83cbc8267c$var$getDateInput = (componentType)=>{
    switch(componentType){
        case 0, $e2kjR.BetweenComponent:
            return 0, $lRsB7.default;
        case 0, $e2kjR.BetweenDateTimeComponent:
            return 0, $eUhKT.default;
        case 0, $e2kjR.InRangeComponent:
            return 0, $cKrbS.default;
        case 0, $e2kjR.TimeInputComponent:
            return 0, $fTjd1.default;
        default:
            return null;
    }
};
const $51379c83cbc8267c$var$DateTimeView = ({ fieldLabel: fieldLabel, value: valueProp, variation: variation, onChange: onChange, onClosePopup: onClosePopup, onSendOptionAnalytics: onSendOptionAnalytics })=>{
    const intl = (0, $lRq8t.default)();
    const [selectedTypeConfig, setSelectedTypeConfig] = (0, $eJOHy.useState)(valueProp !== undefined && valueProp.type ? $51379c83cbc8267c$var$getFilterTypes(variation).filter((filterType)=>valueProp && filterType.type === valueProp.type)[0] : undefined);
    const [value, setValue] = (0, $eJOHy.useState)({
        between: {
            value1: '',
            value2: ''
        },
        between_date_time: {
            value1: '',
            value2: ''
        },
        in_range: {
            value1: '',
            value2: ''
        },
        within_the_last: {
            value1: '',
            value2: ''
        },
        more_than: {
            value1: '',
            value2: ''
        },
        due_in_next: {
            value1: '',
            value2: '',
            excludeOverdue: true
        },
        ...valueProp && {
            [`${valueProp.type}`]: {
                ...valueProp.value
            }
        }
    });
    const onChangeCheckbox = (0, $eJOHy.useCallback)((event)=>{
        const type = event.currentTarget.value;
        const typeConfig = $51379c83cbc8267c$var$getFilterTypes(variation).find((t)=>t.type === type);
        setSelectedTypeConfig(typeConfig);
    }, [
        variation
    ]);
    const onChangeInput = (0, $eJOHy.useCallback)((val)=>{
        setValue((0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, value, selectedTypeConfig ? {
            [selectedTypeConfig.type]: val
        } : {}));
    }, [
        selectedTypeConfig,
        value
    ]);
    const errorMessage = (0, $eJOHy.useMemo)(()=>{
        let message;
        $51379c83cbc8267c$var$getFilterTypes(variation).forEach((m)=>{
            const isCurrent = selectedTypeConfig ? m.type === selectedTypeConfig.type : false;
            const currentValue = selectedTypeConfig && value[selectedTypeConfig.type];
            if (m.getErrorMessage && isCurrent) message = m.getErrorMessage(intl, currentValue);
        });
        return message;
    }, [
        intl,
        selectedTypeConfig,
        value,
        variation
    ]);
    const onUpdate = (0, $eJOHy.useCallback)(()=>{
        if (errorMessage !== undefined) return;
        const val = selectedTypeConfig && selectedTypeConfig.type !== (0, $e2kjR.NowOverdue) ? value[selectedTypeConfig.type] : undefined;
        const datePickerValue = selectedTypeConfig !== undefined ? {
            type: selectedTypeConfig.type,
            value: selectedTypeConfig.componentType !== (0, $e2kjR.IsNotSetComponent) ? val : undefined
        } : undefined;
        onChange(datePickerValue);
        if (typeof onClosePopup === 'function') onClosePopup();
        onSendOptionAnalytics && onSendOptionAnalytics({
            timeConstraints: datePickerValue?.type
        });
    }, [
        errorMessage,
        onChange,
        onClosePopup,
        onSendOptionAnalytics,
        selectedTypeConfig,
        value
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        onUpdate();
    }, [
        onUpdate
    ]);
    const handleOnKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
            onUpdate();
        }
    }, [
        onUpdate
    ]);
    const DateInputType = selectedTypeConfig ? $51379c83cbc8267c$var$getDateInput(selectedTypeConfig.componentType) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51379c83cbc8267c$var$StyledDialogInner, {
        onKeyDown: handleOnKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "fieldset",
        xcss: $51379c83cbc8267c$var$fieldsetStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "legend",
        xcss: $51379c83cbc8267c$var$legendStyles
    }, intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m4') ? (0, $73DRj.default).legendTextIssueTerminologyRefreshM4 : (0, $73DRj.default).legendText, {
        fieldLabel: fieldLabel
    })), $51379c83cbc8267c$var$getFilterTypes(variation).map((m)=>{
        const isCurrent = !!selectedTypeConfig && m.type === selectedTypeConfig.type;
        const currentValue = selectedTypeConfig && value[selectedTypeConfig.type];
        const messageDescriptor = (0, $73DRj.messageLookup)[m.label];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51379c83cbc8267c$var$StyledOptionContainer, {
            key: m.type
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kgmJM.Radio), {
            checked: isCurrent,
            name: "mode",
            onChange: onChangeCheckbox,
            value: m.type,
            testId: `jql-builder-basic-datetime.ui.radio.${m.type}`
        }, messageDescriptor ? intl.formatMessage(messageDescriptor) : null), isCurrent && m.hasInput && currentValue && DateInputType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DateInputType, {
            isInvalid: isCurrent && errorMessage !== undefined,
            typeConfig: m,
            onChange: onChangeInput,
            value: currentValue
        }), isCurrent && errorMessage !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($51379c83cbc8267c$var$ErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        }), errorMessage));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $51379c83cbc8267c$var$buttonWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
        appearance: "primary",
        testId: "jql-builder-basic-datetime.ui.update-button",
        spacing: "default",
        isDisabled: errorMessage !== undefined,
        onClick: handleOnClick
    }, intl.formatMessage((0, $73DRj.default).updateButtonText))));
};
$51379c83cbc8267c$var$DateTimeView.whyDidYouRender = true;
var $51379c83cbc8267c$export$2e2bcd8739ae039 = $51379c83cbc8267c$var$DateTimeView;
const $51379c83cbc8267c$export$957d7daebd899f12 = ({ intl: intl, variation: variation, label: label, value: field })=>{
    const typeConfig = field ? $51379c83cbc8267c$var$getFilterTypes(variation).find((f)=>f.type === field.type) : undefined;
    if (typeConfig === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        weight: "medium",
        color: "inherit"
    }, label);
    const value = typeConfig.getFormattedValue(intl, field && field.value);
    return value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        weight: "medium",
        color: "inherit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        as: "strong"
    }, label, ": "), typeConfig.getFormattedValue(intl, field && field.value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        weight: "medium",
        color: "inherit"
    }, label);
};
const $51379c83cbc8267c$export$46455b4476d4b8e1 = ({ intl: intl, variation: variation, value: field })=>{
    const typeConfig = field ? $51379c83cbc8267c$var$getFilterTypes(variation).find((f)=>f.type === field.type) : undefined;
    if (typeConfig === undefined || !typeConfig.getTooltip) return undefined;
    return typeConfig.getTooltip(intl, field && field.value);
};
const $51379c83cbc8267c$export$8299afa491becffd = (dateTimePickerValue, variation)=>{
    if (dateTimePickerValue) {
        const { type: type, value: value } = dateTimePickerValue;
        const typeConfig = $51379c83cbc8267c$var$getFilterTypes(variation).find((f)=>f.type === type);
        const hasValuePresent = $51379c83cbc8267c$var$hasValue({
            type: type,
            value: value
        });
        if (!hasValuePresent) return undefined;
        if (typeConfig) {
            if (typeConfig.type === (0, $e2kjR.NowOverdue)) return typeConfig.getJqlData();
            if (value) return typeConfig.getJqlData(value);
        }
    }
    return undefined;
};
const $51379c83cbc8267c$export$f82c5f277c92418 = (variation, jqlData)=>{
    const possibleValues = $51379c83cbc8267c$var$getFilterTypes(variation).map((typeConfig)=>{
        const value = typeConfig.getValueFromJqlData(jqlData);
        if (value) return {
            type: typeConfig.type,
            value: value
        };
        return undefined;
    }).filter(Boolean);
    if (possibleValues.length > 0) return possibleValues[0];
    return undefined;
};
const $51379c83cbc8267c$export$82f46aa4e6535a45 = (intl, dateTimePickerValue, variation)=>{
    if (dateTimePickerValue) {
        const typeConfig = $51379c83cbc8267c$var$getFilterTypes(variation).filter((filterType)=>filterType.type === dateTimePickerValue.type)[0];
        if (dateTimePickerValue && typeConfig && typeConfig.getErrorMessage) return typeConfig.getErrorMessage(intl, dateTimePickerValue.value);
    }
    return undefined;
};
const $51379c83cbc8267c$export$66bd7052943865c8 = (variation, primaryClause, secondaryClause)=>{
    const jqlData = primaryClause === undefined && secondaryClause === undefined ? undefined : {
        primaryClause: primaryClause !== undefined && primaryClause.operator && primaryClause.operand && primaryClause.operand.operandType === (0, $f38290926d0398e2$export$38accfc5a5d1c113) ? {
            operator: primaryClause.operator.value,
            operand: (0, $8wYmT.removeSurroundingQuotes)(primaryClause.operand.text)
        } : undefined,
        secondaryClause: secondaryClause !== undefined && secondaryClause.operator && secondaryClause.operand && secondaryClause.operand.operandType === (0, $f38290926d0398e2$export$38accfc5a5d1c113) ? {
            operator: secondaryClause.operator.value,
            operand: (0, $8wYmT.removeSurroundingQuotes)(secondaryClause.operand.text)
        } : undefined
    };
    return $51379c83cbc8267c$export$f82c5f277c92418(variation, jqlData);
};
const $51379c83cbc8267c$var$fieldsetStyles = (0, $5Wv5g.xcss)({
    border: 'none',
    margin: 'space.0',
    paddingBlockStart: 'space.200',
    paddingBlockEnd: 'space.100',
    paddingInlineStart: 'space.150',
    paddingInlineEnd: 'space.150'
});
const $51379c83cbc8267c$var$legendStyles = (0, $5Wv5g.xcss)({
    width: '1px',
    height: '1px',
    padding: 'space.0',
    position: 'absolute',
    border: 'none',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $51379c83cbc8267c$var$buttonWrapperStyle = (0, $5Wv5g.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingInlineStart: 'space.150',
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $51379c83cbc8267c$var$StyledOptionContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyrpxbi _1tke1ou6 _dmhjze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $51379c83cbc8267c$var$ErrorContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _18u01ejb _19pk1b66 _syaz1tmw _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $51379c83cbc8267c$var$StyledDialogInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbxilx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8wYmT", function(module, exports) {

$parcel$export(module.exports, "removeSurroundingQuotes", () => $eef539967c694e7e$export$8de447c869ac6d85);

var $eM3Eu = parcelRequire("eM3Eu");
const $eef539967c694e7e$export$5378ca09aae39be8 = (jql, fieldIdentifier)=>{
    const ast = new (0, $eM3Eu.JastBuilder)().build(jql);
    const fieldsToReturn = [];
    if (ast && ast.query && ast.query.where) {
        if (ast.query.where.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b)) ast.query.where.clauses.forEach((clause)=>{
            if (clause.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) {
                const fieldId = clause.field.value.toLowerCase();
                if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(clause);
            }
        });
        else if (ast.query.where.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) {
            const fieldId = ast.query.where.field.value.toLowerCase();
            if (fieldIdentifier.toLowerCase() === fieldId) {
                if (ast.query && ast.query.where) fieldsToReturn.push(ast.query.where);
            }
        }
    }
    return fieldsToReturn;
};
const $eef539967c694e7e$export$8de447c869ac6d85 = (maybeQuotedString)=>maybeQuotedString.replace(/^["']|["']$/g, '');

});

parcelRegister("eUhKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8e02413cd1ced53$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $gJffn = parcelRequire("gJffn");

var $bxHeV = parcelRequire("bxHeV");
var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $iw2hI = parcelRequire("iw2hI");

var $2cfd4 = parcelRequire("2cfd4");

var $cVHnY = parcelRequire("cVHnY");

var $fWxQr = parcelRequire("fWxQr");
const $c8e02413cd1ced53$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $c8e02413cd1ced53$var$isDateValueInvalid = (value)=>!(0, $dBLX0.default)((0, $kQ82p.default)(value)) && value !== '';
const $c8e02413cd1ced53$var$BetweenDateTime = ({ value: { value1: value1, value2: value2 }, onChange: onChange })=>{
    const locale = (0, $2cfd4.useLocale)();
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
    const [localizationProvider] = (0, $eJOHy.useState)((0, $gJffn.createLocalizationProvider)(standardizedLocale));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeValue1Date = (0, $eJOHy.useCallback)((value)=>{
        onChange({
            value1: value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $eJOHy.useCallback)((value)=>{
        onChange({
            value1: value1,
            value2: value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $c8e02413cd1ced53$var$wrapperStyles,
        paddingBlockStart: "space.075",
        paddingInlineStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVHnY.DateTimePicker), {
        locale: standardizedLocale,
        onChange: onChangeValue1Date,
        isInvalid: $c8e02413cd1ced53$var$isDateValueInvalid(value1),
        dateLabel: formatMessage((0, $fWxQr.default).startDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() - $c8e02413cd1ced53$var$ONE_DAY_IN_MILLISECONDS)),
        value: !$c8e02413cd1ced53$var$isDateValueInvalid(value1) ? value1 : '',
        testId: "jql-builder-basic-datetime.ui.between-date-time.value-1",
        timeLabel: formatMessage((0, $fWxQr.default).startTimeLabel),
        defaultTime: "00:00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), null, formatMessage((0, $fWxQr.default).and)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cVHnY.DateTimePicker), {
        locale: standardizedLocale,
        isInvalid: $c8e02413cd1ced53$var$isDateValueInvalid(value2),
        onChange: onChangeValue2Date,
        dateLabel: formatMessage((0, $fWxQr.default).endDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() + $c8e02413cd1ced53$var$ONE_DAY_IN_MILLISECONDS)),
        value: !$c8e02413cd1ced53$var$isDateValueInvalid(value2) ? value2 : '',
        testId: "jql-builder-basic-datetime.ui.between-date-time.value-2",
        timeLabel: formatMessage((0, $fWxQr.default).endTimeLabel),
        defaultTime: "23:59"
    })));
};
var $c8e02413cd1ced53$export$2e2bcd8739ae039 = $c8e02413cd1ced53$var$BetweenDateTime;
const $c8e02413cd1ced53$var$wrapperStyles = (0, $5Wv5g.xcss)({
    width: '350px'
});

});
parcelRegister("gJffn", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $36fae507b07e9649$export$ea56ca58f08ffa52);

var $aCClh = parcelRequire("aCClh");

var $8HHDi = parcelRequire("8HHDi");

var $kZc93 = parcelRequire("kZc93");
const $36fae507b07e9649$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $aCClh.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $8HHDi.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $kZc93.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $kZc93.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("aCClh", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $a1fdee6bfccb5dbf$export$dca0327c9b9c6498);
const $a1fdee6bfccb5dbf$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("8HHDi", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $229bf2718d96d772$export$cfa2ef2687faeda2);

var $aCClh = parcelRequire("aCClh");

var $0YsGb = parcelRequire("0YsGb");
const $229bf2718d96d772$var$INVALID_DATE = new Date(NaN);
const $229bf2718d96d772$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $229bf2718d96d772$var$INVARIANT_DATE = (0, $0YsGb.toDate)($229bf2718d96d772$var$INVARIANT);
const $229bf2718d96d772$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $229bf2718d96d772$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $229bf2718d96d772$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $229bf2718d96d772$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $229bf2718d96d772$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $aCClh.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($229bf2718d96d772$var$INVARIANT_DATE);
    const shortDate = $229bf2718d96d772$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($229bf2718d96d772$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $229bf2718d96d772$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($229bf2718d96d772$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($229bf2718d96d772$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($229bf2718d96d772$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $229bf2718d96d772$var$stripExtras(date).match($229bf2718d96d772$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $229bf2718d96d772$var$INVALID_DATE;
        const dateParts = $229bf2718d96d772$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $0YsGb.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $0YsGb.isValid)(normalizedDate)) return $229bf2718d96d772$var$INVALID_DATE;
        return (0, $0YsGb.toDate)(normalizedDate);
    };
};

});
parcelRegister("0YsGb", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $97d3eecfe9d9f551$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $97d3eecfe9d9f551$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $97d3eecfe9d9f551$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $97d3eecfe9d9f551$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $97d3eecfe9d9f551$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $97d3eecfe9d9f551$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $97d3eecfe9d9f551$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $97d3eecfe9d9f551$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $97d3eecfe9d9f551$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $97d3eecfe9d9f551$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $97d3eecfe9d9f551$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $97d3eecfe9d9f551$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("kZc93", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $abfeded41c91acba$export$9b7ca29af37c192);
const $abfeded41c91acba$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("iw2hI", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $07e147bc3d7cc59d$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $07e147bc3d7cc59d$export$93ff13646da25bd);

var $4qiFT = parcelRequire("4qiFT");

var $eSnSE = parcelRequire("eSnSE");
const $07e147bc3d7cc59d$export$95b7602913551865 = 'en-US';
const $07e147bc3d7cc59d$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$07e147bc3d7cc59d$export$95b7602913551865}.`);
        return $07e147bc3d7cc59d$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $4qiFT.default).includes(jiraLocale)) (0, $eSnSE.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $07e147bc3d7cc59d$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($07e147bc3d7cc59d$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("cVHnY", function(module, exports) {

$parcel$export(module.exports, "DateTimePicker", () => $ad34d83c53d353ed$export$ccdfd7928785632e);

var $eJOHy = parcelRequire("eJOHy");

var $euo01 = parcelRequire("euo01");
var $1m9Q9 = parcelRequire("1m9Q9");

var $bxHeV = parcelRequire("bxHeV");
var $bL3dk = parcelRequire("bL3dk");
var $5Wv5g = parcelRequire("5Wv5g");

var $igoRN = parcelRequire("igoRN");

var $9jzsQ = parcelRequire("9jzsQ");
const $ad34d83c53d353ed$export$ccdfd7928785632e = ({ locale: locale, isInvalid: isInvalid = false, onChange: onChange, value: value, placeholder: placeholder, dateLabel: dateLabel, timeLabel: timeLabel, testId: testId, defaultTime: defaultTime = '00:00' })=>{
    const [internalDateValue, setInternalDateValue] = (0, $eJOHy.useState)(()=>value ? (0, $9jzsQ.parseDateValue)(value) : '');
    const [internalTimeValue, setInternalTimeValue] = (0, $eJOHy.useState)(()=>value ? (0, $9jzsQ.parseTimeValue)(value) : '');
    const handleOnDateChange = (0, $eJOHy.useCallback)((dateValue)=>{
        setInternalDateValue(dateValue);
        const parsedDateTime = dateValue ? (0, $9jzsQ.parseDateTimeToISO)(dateValue, internalTimeValue || defaultTime) : '';
        onChange(parsedDateTime);
    }, [
        defaultTime,
        internalTimeValue,
        onChange
    ]);
    const handleOnTimeChange = (0, $eJOHy.useCallback)((timeValue)=>{
        setInternalTimeValue(timeValue);
        if (internalDateValue) {
            const parsedDateTime = (0, $9jzsQ.parseDateTimeToISO)(internalDateValue, timeValue || defaultTime);
            onChange(parsedDateTime);
        }
    }, [
        defaultTime,
        internalDateValue,
        onChange
    ]);
    const timePlaceholder = (0, $eJOHy.useMemo)(()=>{
        return (0, $9jzsQ.getTimePlaceholder)(defaultTime, locale);
    }, [
        defaultTime,
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        xcss: $ad34d83c53d353ed$var$baseContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $ad34d83c53d353ed$var$datePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euo01.default), {
        locale: locale,
        isInvalid: isInvalid,
        onChange: handleOnDateChange,
        placeholder: placeholder,
        label: dateLabel,
        value: internalDateValue,
        shouldShowCalendarButton: true,
        testId: `${testId}--datepicker`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $ad34d83c53d353ed$var$timePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1m9Q9.default), {
        locale: locale,
        isInvalid: isInvalid,
        onChange: handleOnTimeChange,
        label: timeLabel,
        value: internalTimeValue,
        timeIsEditable: true,
        times: (0, $igoRN.default),
        testId: `${testId}--timepicker`,
        placeholder: timePlaceholder
    })));
};
const $ad34d83c53d353ed$var$datePickerContainerStyles = (0, $5Wv5g.xcss)({
    flexBasis: '50%',
    flexGrow: 1,
    flexShrink: 0
});
const $ad34d83c53d353ed$var$timePickerContainerStyles = (0, $5Wv5g.xcss)({
    flexBasis: '50%',
    flexGrow: 1
});
const $ad34d83c53d353ed$var$baseContainerStyles = (0, $5Wv5g.xcss)({
    display: 'flex',
    gap: 'space.050'
});

});
parcelRegister("euo01", function(module, exports) {

$parcel$export(module.exports, "default", () => $afddfcf3a4013a12$export$2e2bcd8739ae039);

var $8XtVW = parcelRequire("8XtVW");

var $84IRl = parcelRequire("84IRl");

var $l2RSp = parcelRequire("l2RSp");

var $lgiyJ = parcelRequire("lgiyJ");
const $afddfcf3a4013a12$var$DatePicker = (0, $84IRl.componentWithCondition)(()=>(0, $8XtVW.fg)('dst-date-picker-use-functional-component'), (0, $lgiyJ.default), (0, $l2RSp.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$afddfcf3a4013a12$export$2e2bcd8739ae039 = $afddfcf3a4013a12$var$DatePicker;

});
parcelRegister("84IRl", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $90a752d40dd25a7a$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $90a752d40dd25a7a$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("l2RSp", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e5ef5090bf35a$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $63DI8 = parcelRequire("63DI8");
var $kUIKr = parcelRequire("kUIKr");
var $aN4Pk = parcelRequire("aN4Pk");

var $4BzUI = parcelRequire("4BzUI");

var $i7XOj = parcelRequire("i7XOj");

var $gdEz9 = parcelRequire("gdEz9");

var $b3NdY = parcelRequire("b3NdY");

var $gJffn = parcelRequire("gJffn");

var $8XtVW = parcelRequire("8XtVW");

var $dhRXV = parcelRequire("dhRXV");

var $8TCso = parcelRequire("8TCso");
var $1Cwn9 = parcelRequire("1Cwn9");

var $f4r1V = parcelRequire("f4r1V");

var $2bSC0 = parcelRequire("2bSC0");

var $67PbX = parcelRequire("67PbX");

var $4t2cq = parcelRequire("4t2cq");

var $kUmtr = parcelRequire("kUmtr");

var $kZ61w = parcelRequire("kZ61w");
const $373e5ef5090bf35a$var$packageName = "platform-pkg";
const $373e5ef5090bf35a$var$packageVersion = "0.0.0-use.local";
const $373e5ef5090bf35a$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $373e5ef5090bf35a$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $373e5ef5090bf35a$export$df43d21f5faca9f7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $373e5ef5090bf35a$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $2bSC0.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $2bSC0.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $kUmtr.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $2bSC0.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $kUmtr.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $kUmtr.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $kUmtr.getShortISOString)(new Date()),
            l10n: (0, $gJffn.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $gJffn.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($b3NdY))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $8XtVW.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                xcss: $373e5ef5090bf35a$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $kZ61w.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $f4r1V.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $67PbX.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $4t2cq.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $f4r1V.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $kUmtr.getShortISOString)((0, $kQ82p.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $1Cwn9.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $2bSC0.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $hcewu.default)([
                $373e5ef5090bf35a$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8TCso.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $2bSC0.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gdEz9.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                            xcss: (0, $i7XOj.cx)($373e5ef5090bf35a$var$styles.iconContainerStyles, value && !hideIcon ? $373e5ef5090bf35a$var$styles.iconSpacingWithClearButtonStyles : $373e5ef5090bf35a$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b3NdY))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $373e5ef5090bf35a$var$DatePicker = (0, $kUIKr.default)({
    componentName: 'datePicker',
    packageName: $373e5ef5090bf35a$var$packageName,
    packageVersion: $373e5ef5090bf35a$var$packageVersion
})((0, $aN4Pk.default)({
    onChange: (0, $63DI8.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $373e5ef5090bf35a$var$packageName,
            packageVersion: $373e5ef5090bf35a$var$packageVersion
        }
    })
})($373e5ef5090bf35a$export$df43d21f5faca9f7));
var $373e5ef5090bf35a$export$2e2bcd8739ae039 = $373e5ef5090bf35a$var$DatePicker;

});
parcelRegister("b3NdY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80d628705b3511f2$var$_react = $80d628705b3511f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $80d628705b3511f2$var$_calendar = $80d628705b3511f2$var$_interopRequireDefault((parcelRequire("dsP2y")));

var $80d628705b3511f2$var$_calendar2 = $80d628705b3511f2$var$_interopRequireDefault((parcelRequire("jd3YJ")));
function $80d628705b3511f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80d628705b3511f2$var$CalendarIcon = (props)=>/*#__PURE__*/ $80d628705b3511f2$var$_react.default.createElement($80d628705b3511f2$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $80d628705b3511f2$var$_calendar2.default
    }, props));
$80d628705b3511f2$var$CalendarIcon.Name = 'CalendarIconMigration';
var $80d628705b3511f2$var$_default = module.exports.default = $80d628705b3511f2$var$CalendarIcon;

});
parcelRegister("dsP2y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cd57b698cbabd99$var$_react = $9cd57b698cbabd99$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cd57b698cbabd99$var$_baseNew = $9cd57b698cbabd99$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $9cd57b698cbabd99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cd57b698cbabd99$var$CalendarIcon = (props)=>/*#__PURE__*/ $9cd57b698cbabd99$var$_react.default.createElement($9cd57b698cbabd99$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$9cd57b698cbabd99$var$CalendarIcon.displayName = 'CalendarIcon';
var $9cd57b698cbabd99$var$_default = module.exports.default = $9cd57b698cbabd99$var$CalendarIcon;

});

parcelRegister("jd3YJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfc2514506359716$var$_react = $dfc2514506359716$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $dfc2514506359716$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfc2514506359716$var$CalendarIcon = (props)=>/*#__PURE__*/ $dfc2514506359716$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props));
$dfc2514506359716$var$CalendarIcon.displayName = 'CalendarIcon';
var $dfc2514506359716$var$_default = module.exports.default = $dfc2514506359716$var$CalendarIcon;

});


parcelRegister("f4r1V", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $0bb33c78f3e4c9d5$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $0bb33c78f3e4c9d5$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $0bb33c78f3e4c9d5$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $0bb33c78f3e4c9d5$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $0bb33c78f3e4c9d5$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $0bb33c78f3e4c9d5$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $0bb33c78f3e4c9d5$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $0bb33c78f3e4c9d5$export$5e30e9a24d6c1203 = ()=>null;
const $0bb33c78f3e4c9d5$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $0bb33c78f3e4c9d5$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $0bb33c78f3e4c9d5$export$9e6d8fcf62256b85 = 'h:mma';
const $0bb33c78f3e4c9d5$export$75032c84f56650eb = 'YYYY/MM/DD';
function $0bb33c78f3e4c9d5$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $0bb33c78f3e4c9d5$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("2bSC0", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $db2307e6881e9b15$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $db2307e6881e9b15$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $db2307e6881e9b15$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $db2307e6881e9b15$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $db2307e6881e9b15$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $57raR = parcelRequire("57raR");
var $cBFyu = parcelRequire("cBFyu");
var $kQ82p = parcelRequire("kQ82p");

var $8KmA8 = parcelRequire("8KmA8");

var $f4r1V = parcelRequire("f4r1V");
const $db2307e6881e9b15$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $db2307e6881e9b15$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $cBFyu.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $f4r1V.padToTwo)(parsedMonth)}-${(0, $f4r1V.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $f4r1V.padToTwo)(parsedMonth)}-${(0, $f4r1V.padToTwo)(parsedDate)}`;
    return newIso;
};
const $db2307e6881e9b15$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $f4r1V.defaultDateFormat));
    return l10n.parseDate(date);
};
const $db2307e6881e9b15$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $f4r1V.defaultDateFormat));
    const date = (0, $kQ82p.default)(value);
    return dateFormat ? (0, $57raR.default)(date, (0, $8KmA8.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $db2307e6881e9b15$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $f4r1V.placeholderDatetime));
};

});
parcelRegister("8KmA8", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $cba5c640e69d6fd6$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $cba5c640e69d6fd6$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $cba5c640e69d6fd6$var$v1tokens = Object.keys($cba5c640e69d6fd6$var$tokensMap).sort().reverse();
const $cba5c640e69d6fd6$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$cba5c640e69d6fd6$var$v1tokens.join('|') + '|.)', 'g');
function $cba5c640e69d6fd6$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($cba5c640e69d6fd6$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $cba5c640e69d6fd6$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("67PbX", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $ade5757a357b6040$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j3gIc = parcelRequire("j3gIc");
const $ade5757a357b6040$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $ade5757a357b6040$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            showClearIndicator ? $ade5757a357b6040$var$styles.calendarButtonInclusionStyles : $ade5757a357b6040$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("4t2cq", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $7ed0d6fb3bc94326$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $9o8tE = parcelRequire("9o8tE");

var $ijDer = parcelRequire("ijDer");

var $dOX7c = parcelRequire("dOX7c");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $7ed0d6fb3bc94326$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $kQ82p.default)(iso);
        return (0, $dBLX0.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $7ed0d6fb3bc94326$var$menuStyles = null;
const $7ed0d6fb3bc94326$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $7ed0d6fb3bc94326$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ijDer.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dOX7c.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $hcewu.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9o8tE.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("9o8tE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c097a7b9cfef488$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $j2fEo = parcelRequire("j2fEo");

var $9pZRF = parcelRequire("9pZRF");

var $gdEz9 = parcelRequire("gdEz9");

var $dhRXV = parcelRequire("dhRXV");
var $aRh7I = parcelRequire("aRh7I");

var $iwfQ8 = parcelRequire("iwfQ8");

var $4BgVL = parcelRequire("4BgVL");

var $kcbnV = parcelRequire("kcbnV");

var $ij78R = parcelRequire("ij78R");

var $g6M7m = parcelRequire("g6M7m");

var $aqDzp = parcelRequire("aqDzp");

var $c5bSc = parcelRequire("c5bSc");

var $47SeE = parcelRequire("47SeE");

var $gaGKE = parcelRequire("gaGKE");

var $c9xVF = parcelRequire("c9xVF");
const $8c097a7b9cfef488$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $8c097a7b9cfef488$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8c097a7b9cfef488$var$InnerCalendar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $ij78R.blankStringArray), defaultSelected: defaultSelected = (0, $ij78R.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $9pZRF.default), onChange: onChange = (0, $9pZRF.default), onFocus: onFocus = (0, $9pZRF.default), onSelect: onSelect = (0, $9pZRF.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $g6M7m.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eJOHy.useState)(false);
    const onChangeWithAnalytics = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$8c097a7b9cfef488$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $47SeE.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$8c097a7b9cfef488$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $gaGKE.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $aqDzp.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $c9xVF.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $c5bSc.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $gdEz9.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
            xcss: $8c097a7b9cfef488$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $aRh7I.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iwfQ8.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dhRXV.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kcbnV.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BgVL.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $8c097a7b9cfef488$var$Calendar = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($8c097a7b9cfef488$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$8c097a7b9cfef488$var$Calendar.displayName = 'Calendar';
var $8c097a7b9cfef488$export$2e2bcd8739ae039 = $8c097a7b9cfef488$var$Calendar;

});
parcelRegister("iwfQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $57fe6b0bacbe358d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");

var $gdEz9 = parcelRequire("gdEz9");

var $bvFRW = parcelRequire("bvFRW");

var $bzNNq = parcelRequire("bzNNq");

var $dR9Pz = parcelRequire("dR9Pz");

var $3K50z = parcelRequire("3K50z");

var $abxMj = parcelRequire("abxMj");

var $dhRXV = parcelRequire("dhRXV");
var $9M9zY = parcelRequire("9M9zY");
const $57fe6b0bacbe358d$var$Header = /*#__PURE__*/ (0, $eJOHy.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $gdEz9.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $eJOHy.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bzNNq))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3K50z))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvFRW.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9M9zY.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($abxMj))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dR9Pz))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$57fe6b0bacbe358d$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$57fe6b0bacbe358d$export$2e2bcd8739ae039 = $57fe6b0bacbe358d$var$Header;

});
parcelRegister("bzNNq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89a5ee1ee34f6c51127fc5be19fb8c41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86d997143acd7423$var$_react = $86d997143acd7423$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86d997143acd7423$var$_baseNew = $86d997143acd7423$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $86d997143acd7423$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86d997143acd7423$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $86d997143acd7423$var$_react.default.createElement($86d997143acd7423$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$86d997143acd7423$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $86d997143acd7423$var$_default = module.exports.default = $86d997143acd7423$var$ChevronDoubleLeftIcon;

});

parcelRegister("dR9Pz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a70faad39a1700c3cb50a44f6bcc1a4e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a167d9cc874f3a59$var$_react = $a167d9cc874f3a59$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a167d9cc874f3a59$var$_baseNew = $a167d9cc874f3a59$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $a167d9cc874f3a59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a167d9cc874f3a59$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $a167d9cc874f3a59$var$_react.default.createElement($a167d9cc874f3a59$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$a167d9cc874f3a59$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $a167d9cc874f3a59$var$_default = module.exports.default = $a167d9cc874f3a59$var$ChevronDoubleRightIcon;

});

parcelRegister("3K50z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b998d7e87e1ac6b$var$_react = $2b998d7e87e1ac6b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2b998d7e87e1ac6b$var$_baseNew = $2b998d7e87e1ac6b$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $2b998d7e87e1ac6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b998d7e87e1ac6b$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2b998d7e87e1ac6b$var$_react.default.createElement($2b998d7e87e1ac6b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$2b998d7e87e1ac6b$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $2b998d7e87e1ac6b$var$_default = module.exports.default = $2b998d7e87e1ac6b$var$ChevronLeftIcon;

});


parcelRegister("4BgVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd7aa6c9ff3ea25c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");

var $dOdWl = parcelRequire("dOdWl");

var $jFZBF = parcelRequire("jFZBF");
const $fd7aa6c9ff3ea25c$var$WeekDays = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jFZBF.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dOdWl.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$fd7aa6c9ff3ea25c$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd7aa6c9ff3ea25c$export$2e2bcd8739ae039 = $fd7aa6c9ff3ea25c$var$WeekDays;

});
parcelRegister("dOdWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c0ee856278595c7$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9pZRF = parcelRequire("9pZRF");

var $6c0ec = parcelRequire("6c0ec");
const $1c0ee856278595c7$var$dateCellSiblingStyle = null;
const $1c0ee856278595c7$var$dateCellTodayStyle = null;
const $1c0ee856278595c7$var$dateCellPrevSelectedStyle = null;
const $1c0ee856278595c7$var$dateCellSelectedStyle = null;
const $1c0ee856278595c7$var$dateCellDisabledStyle = null;
const $1c0ee856278595c7$var$dateCellStyles = null;
const $1c0ee856278595c7$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $9pZRF.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eJOHy.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6c0ec.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $hcewu.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$1c0ee856278595c7$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1c0ee856278595c7$export$2e2bcd8739ae039 = $1c0ee856278595c7$var$Date;

});
parcelRegister("6c0ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $918a0ca1ea16eb69$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $918a0ca1ea16eb69$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $918a0ca1ea16eb69$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $918a0ca1ea16eb69$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $918a0ca1ea16eb69$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $918a0ca1ea16eb69$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $918a0ca1ea16eb69$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $918a0ca1ea16eb69$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $918a0ca1ea16eb69$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $918a0ca1ea16eb69$var$baseStyles.root,
            gap && $918a0ca1ea16eb69$var$columnGapMap[gap],
            columnGap && $918a0ca1ea16eb69$var$columnGapMap[columnGap],
            gap && $918a0ca1ea16eb69$var$rowGapMap[gap],
            rowGap && $918a0ca1ea16eb69$var$rowGapMap[rowGap],
            alignItems && $918a0ca1ea16eb69$var$alignItemsMap[alignItems],
            alignContent && $918a0ca1ea16eb69$var$alignContentMap[alignContent],
            justifyContent && $918a0ca1ea16eb69$var$justifyContentMap[justifyContent],
            autoFlow && $918a0ca1ea16eb69$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$918a0ca1ea16eb69$var$Grid.displayName = 'Grid';
var $918a0ca1ea16eb69$export$2e2bcd8739ae039 = $918a0ca1ea16eb69$var$Grid;

});


parcelRegister("jFZBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4a45c994e98379$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6c0ec = parcelRequire("6c0ec");
const $4f4a45c994e98379$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $4f4a45c994e98379$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6c0ec.default), {
        testId: testId,
        xcss: $4f4a45c994e98379$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $4f4a45c994e98379$export$2e2bcd8739ae039 = $4f4a45c994e98379$var$WeekDayGrid;

});


parcelRegister("kcbnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $180a39c7fd4fbc22$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");
var $h8epd = parcelRequire("h8epd");

var $jFZBF = parcelRequire("jFZBF");
const $180a39c7fd4fbc22$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $180a39c7fd4fbc22$var$WeekHeader = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jFZBF.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                padding: "space.100",
                xcss: $180a39c7fd4fbc22$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h8epd.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$180a39c7fd4fbc22$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$180a39c7fd4fbc22$export$2e2bcd8739ae039 = $180a39c7fd4fbc22$var$WeekHeader;

});

parcelRegister("ij78R", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $01dd9cfc84bdb43f$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $01dd9cfc84bdb43f$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $01dd9cfc84bdb43f$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $01dd9cfc84bdb43f$export$8fa20d70624f8b9d);
const $01dd9cfc84bdb43f$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $01dd9cfc84bdb43f$export$3ae905d9742bef55 = 7;
const $01dd9cfc84bdb43f$export$c9b7c010035d60c6 = 12;
const $01dd9cfc84bdb43f$export$8fa20d70624f8b9d = [];

});

parcelRegister("g6M7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e0666ed794738d1$export$2e2bcd8739ae039);

var $ieBWZ = parcelRequire("ieBWZ");

var $djARB = parcelRequire("djARB");

var $hNUF0 = parcelRequire("hNUF0");
function $9e0666ed794738d1$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $djARB.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $ieBWZ.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $ieBWZ.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $ieBWZ.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $ieBWZ.default)(today, ()=>today || `${thisYear}-${(0, $hNUF0.default)(thisMonth)}-${(0, $hNUF0.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $ieBWZ.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $ieBWZ.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("hNUF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $361148daa528aaba$export$2e2bcd8739ae039);
function $361148daa528aaba$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("aqDzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1136ea8c09683192$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $1136ea8c09683192$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eJOHy.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("c5bSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa56293c428f3227$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $ij78R = parcelRequire("ij78R");

var $bCNc6 = parcelRequire("bCNc6");

var $frkUB = parcelRequire("frkUB");
function $aa56293c428f3227$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eJOHy.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $ij78R.daysPerWeek) : 0;
            return (0, $frkUB.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $ij78R.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $aa56293c428f3227$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eJOHy.useMemo)(()=>(0, $frkUB.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $aa56293c428f3227$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $kQ82p.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $kQ82p.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eJOHy.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $bCNc6.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $kQ82p.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("bCNc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc89d3ce81f87b9d$export$2e2bcd8739ae039);

var $hNUF0 = parcelRequire("hNUF0");
function $bc89d3ce81f87b9d$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $hNUF0.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $hNUF0.default)(date.day)}`;
}

});

parcelRegister("frkUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee87d84f0510dac5$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $ij78R = parcelRequire("ij78R");

var $kEHBI = parcelRequire("kEHBI");
function $ee87d84f0510dac5$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $ij78R.daysPerWeek) - weekStartDay + firstDay) % (0, $ij78R.daysPerWeek));
    const lastDate = (0, $kEHBI.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $ij78R.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $kEHBI.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $ij78R.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $ij78R.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $ij78R.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $ij78R.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $ij78R.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("kEHBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0aaaa1f297186f3$export$2e2bcd8739ae039);
function $e0aaaa1f297186f3$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("47SeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c26e1404b4f10833$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ij78R = parcelRequire("ij78R");

var $bCNc6 = parcelRequire("bCNc6");

var $kEHBI = parcelRequire("kEHBI");
const $c26e1404b4f10833$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $ij78R.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $c26e1404b4f10833$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $ij78R.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $c26e1404b4f10833$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $bCNc6.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eJOHy.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $ij78R.daysPerWeek);
            const daysInMonth = (0, $kEHBI.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $c26e1404b4f10833$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $c26e1404b4f10833$var$getPrevMonth(month, year);
                const prevDay = (0, $kEHBI.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $kEHBI.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $c26e1404b4f10833$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $ij78R.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $c26e1404b4f10833$var$getPrevMonth(month, year);
                const prevDay = (0, $kEHBI.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$c26e1404b4f10833$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$c26e1404b4f10833$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("gaGKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd6b9d543baa4633$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ij78R = parcelRequire("ij78R");

var $bCNc6 = parcelRequire("bCNc6");
function $bd6b9d543baa4633$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $bCNc6.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eJOHy.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $ij78R.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("c9xVF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f89c37a152710359$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gJffn = parcelRequire("gJffn");
function $f89c37a152710359$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eJOHy.useMemo)(()=>(0, $gJffn.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eJOHy.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eJOHy.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eJOHy.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("dOX7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $20225fe24e543513$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $9pZRF = parcelRequire("9pZRF");

var $6w0CZ = parcelRequire("6w0CZ");

var $dCPMq = parcelRequire("dCPMq");
var $fcTrq = parcelRequire("fcTrq");
var $c89uy = parcelRequire("c89uy");
const $20225fe24e543513$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $20225fe24e543513$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $6w0CZ.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dCPMq.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c89uy.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $hcewu.default)([
                                $20225fe24e543513$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fcTrq.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $hcewu.default)([
                                $20225fe24e543513$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $9pZRF.default);
    }
}

});
parcelRegister("6w0CZ", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $945a7914dc03583e$export$c647cb0ee6e282fe);
const $945a7914dc03583e$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $945a7914dc03583e$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $945a7914dc03583e$export$62ad7b0c781000e9 = {
    small: {
        width: $945a7914dc03583e$export$c647cb0ee6e282fe.small,
        height: $945a7914dc03583e$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $945a7914dc03583e$export$c647cb0ee6e282fe.medium,
        height: $945a7914dc03583e$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $945a7914dc03583e$export$c647cb0ee6e282fe.large,
        height: $945a7914dc03583e$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $945a7914dc03583e$export$c647cb0ee6e282fe.xlarge,
        height: $945a7914dc03583e$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("kUmtr", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $38c69b5eac9a5948$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $38c69b5eac9a5948$export$ff525416014fb67d);

var $57raR = parcelRequire("57raR");

var $8KmA8 = parcelRequire("8KmA8");
function $38c69b5eac9a5948$export$77d5bc49fed7ef14(date) {
    return (0, $57raR.default)(date, (0, $8KmA8.convertTokens)('YYYY-MM-DD'));
}
function $38c69b5eac9a5948$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $38c69b5eac9a5948$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("kZ61w", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $c91efd2a46f2b5d3$export$6e30bf8cb1347b56);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $j3gIc = parcelRequire("j3gIc");
const $c91efd2a46f2b5d3$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("lgiyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbcf3e0f0338fa32$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $j2fEo = parcelRequire("j2fEo");

var $4BzUI = parcelRequire("4BzUI");

var $i7XOj = parcelRequire("i7XOj");

var $gdEz9 = parcelRequire("gdEz9");

var $b3NdY = parcelRequire("b3NdY");

var $gJffn = parcelRequire("gJffn");

var $8XtVW = parcelRequire("8XtVW");

var $dhRXV = parcelRequire("dhRXV");

var $8TCso = parcelRequire("8TCso");
var $1Cwn9 = parcelRequire("1Cwn9");

var $f4r1V = parcelRequire("f4r1V");

var $2bSC0 = parcelRequire("2bSC0");

var $67PbX = parcelRequire("67PbX");

var $4t2cq = parcelRequire("4t2cq");

var $kUmtr = parcelRequire("kUmtr");

var $kZ61w = parcelRequire("kZ61w");
const $bbcf3e0f0338fa32$var$packageName = "platform-pkg";
const $bbcf3e0f0338fa32$var$packageVersion = "0.0.0-use.local";
const $bbcf3e0f0338fa32$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $bbcf3e0f0338fa32$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $bbcf3e0f0338fa32$var$packageName,
    packageVersion: $bbcf3e0f0338fa32$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $bbcf3e0f0338fa32$var$DatePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const calendarRef = (0, $eJOHy.useRef)(null);
    const calendarButtonRef = (0, $eJOHy.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($b3NdY))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $eJOHy.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $eJOHy.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $eJOHy.useState)(propValue || defaultValue || (0, $kUmtr.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $eJOHy.useState)((0, $gJffn.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $eJOHy.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $eJOHy.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $eJOHy.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $eJOHy.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$bbcf3e0f0338fa32$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $gJffn.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $eJOHy.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $2bSC0.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $2bSC0.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $kUmtr.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $2bSC0.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $kUmtr.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                props.selectProps?.onMenuClose?.();
                return false;
            } else {
                props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $kUmtr.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $eJOHy.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $8XtVW.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
            xcss: $bbcf3e0f0338fa32$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $kZ61w.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $f4r1V.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $67PbX.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $4t2cq.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $f4r1V.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $kUmtr.getShortISOString)((0, $kQ82p.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $1Cwn9.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $2bSC0.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $gdEz9.useId)()}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hcewu.default)([
            $bbcf3e0f0338fa32$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8TCso.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $2bSC0.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
                xcss: (0, $i7XOj.cx)($bbcf3e0f0338fa32$var$styles.iconContainerStyles, value && !hideIcon ? $bbcf3e0f0338fa32$var$styles.iconSpacingWithClearButtonStyles : $bbcf3e0f0338fa32$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4BzUI.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b3NdY))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $bbcf3e0f0338fa32$export$2e2bcd8739ae039 = $bbcf3e0f0338fa32$var$DatePicker;

});


parcelRegister("1m9Q9", function(module, exports) {

$parcel$export(module.exports, "default", () => $27eb0eb610665314$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");

var $j2fEo = parcelRequire("j2fEo");

var $9pZRF = parcelRequire("9pZRF");

var $gJffn = parcelRequire("gJffn");

var $dPBl9 = parcelRequire("dPBl9");
var $8TCso = parcelRequire("8TCso");
var $1Cwn9 = parcelRequire("1Cwn9");

var $f4r1V = parcelRequire("f4r1V");

var $5Iw4N = parcelRequire("5Iw4N");

var $6wBog = parcelRequire("6wBog");

var $8KmA8 = parcelRequire("8KmA8");

var $kZ61w = parcelRequire("kZ61w");
const $27eb0eb610665314$var$packageName = "platform-pkg";
const $27eb0eb610665314$var$packageVersion = "0.0.0-use.local";
const $27eb0eb610665314$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $27eb0eb610665314$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $27eb0eb610665314$var$packageName,
    packageVersion: $27eb0eb610665314$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $27eb0eb610665314$var$TimePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $9pZRF.default), onChange: providedOnChange = (0, $9pZRF.default), onFocus: providedOnFocus = (0, $9pZRF.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $6wBog.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $f4r1V.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $eJOHy.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$27eb0eb610665314$var$analyticsAttributes
    });
    (0, $eJOHy.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $f4r1V.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $57raR.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $gJffn.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $dPBl9.default) : (0, $8TCso.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $f4r1V.defaultTimeFormat));
        const date = (0, $6wBog.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $dBLX0.default)(date)) return time;
        if (timeFormat) return (0, $57raR.default)(date, (0, $8KmA8.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $kZ61w.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $f4r1V.EmptyComponent),
        Menu: (0, $5Iw4N.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $f4r1V.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $1Cwn9.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$27eb0eb610665314$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $f4r1V.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $27eb0eb610665314$export$2e2bcd8739ae039 = $27eb0eb610665314$var$TimePicker;

});
parcelRegister("5Iw4N", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $ed09eaf8b5d55f29$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $j3gIc = parcelRequire("j3gIc");

var $dOX7c = parcelRequire("dOX7c");
const $ed09eaf8b5d55f29$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dOX7c.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j3gIc.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("6wBog", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cc8e92447f442c8$export$2e2bcd8739ae039);
const $6cc8e92447f442c8$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $6cc8e92447f442c8$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $6cc8e92447f442c8$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $6cc8e92447f442c8$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $6cc8e92447f442c8$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $6cc8e92447f442c8$var$map24[hour];
    return hour;
}
function $6cc8e92447f442c8$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $6cc8e92447f442c8$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $6cc8e92447f442c8$var$formatSemi24(timeArray[0].trim());
    const hour = $6cc8e92447f442c8$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $6cc8e92447f442c8$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $6cc8e92447f442c8$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $6cc8e92447f442c8$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $6cc8e92447f442c8$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$6cc8e92447f442c8$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $6cc8e92447f442c8$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $6cc8e92447f442c8$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $6cc8e92447f442c8$var$assignToDate(time2);
}

});


parcelRegister("igoRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfac6f159c013af7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $cfac6f159c013af7$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("9jzsQ", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeToISO", () => $580fa2fd07885202$export$c3b7bf9ddc221a4f);
$parcel$export(module.exports, "parseDateValue", () => $580fa2fd07885202$export$220ff045e4b830ec);
$parcel$export(module.exports, "parseTimeValue", () => $580fa2fd07885202$export$beddb17599b4a110);
$parcel$export(module.exports, "getTimePlaceholder", () => $580fa2fd07885202$export$c7659888e054d16a);

var $57raR = parcelRequire("57raR");

var $fTjQo = parcelRequire("fTjQo");

var $dBLX0 = parcelRequire("dBLX0");

var $cT05m = parcelRequire("cT05m");

var $kQ82p = parcelRequire("kQ82p");

var $gJffn = parcelRequire("gJffn");
/**
 * Format used by atlaskit datepicker
 */ const $580fa2fd07885202$var$DATE_FORMAT = 'yyyy-MM-dd';
const $580fa2fd07885202$export$c4e1e4e065ff5bd8 = 'HH:mm';
const $580fa2fd07885202$export$c3b7bf9ddc221a4f = (date, time)=>{
    const parsedDate = (0, $cT05m.default)(`${date} ${time}`, `${$580fa2fd07885202$var$DATE_FORMAT} ${$580fa2fd07885202$export$c4e1e4e065ff5bd8}`, new Date());
    if (!(0, $dBLX0.default)(parsedDate)) return '';
    return (0, $fTjQo.default)(parsedDate);
};
const $580fa2fd07885202$export$220ff045e4b830ec = (date)=>{
    if (!(0, $dBLX0.default)((0, $kQ82p.default)(date))) return '';
    return (0, $57raR.default)(new Date(date), $580fa2fd07885202$var$DATE_FORMAT);
};
const $580fa2fd07885202$export$beddb17599b4a110 = (date)=>{
    if (!(0, $dBLX0.default)((0, $kQ82p.default)(date))) return '';
    return (0, $57raR.default)(new Date(date), $580fa2fd07885202$export$c4e1e4e065ff5bd8);
};
const $580fa2fd07885202$export$c7659888e054d16a = (time, locale)=>{
    const { formatTime: formatTime } = (0, $gJffn.createLocalizationProvider)(locale);
    const parsedDate = (0, $cT05m.default)(time, `${$580fa2fd07885202$export$c4e1e4e065ff5bd8}`, new Date());
    if (!(0, $dBLX0.default)(parsedDate)) return time;
    return formatTime(parsedDate);
};

});


parcelRegister("fWxQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc63606e62f0b45$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9cc63606e62f0b45$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    and: {
        "id": "jql-builder-basic-datetime.between-date-time.and",
        "defaultMessage": "and"
    },
    startDateLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.start-date-label",
        "defaultMessage": "Choose a start date"
    },
    endDateLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.end-date-label",
        "defaultMessage": "Choose an end date"
    },
    startTimeLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.start-time-label",
        "defaultMessage": "Choose a start time"
    },
    endTimeLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.end-time-label",
        "defaultMessage": "Choose an end time"
    }
});

});


parcelRegister("lRsB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2518732b1b92a456$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $euo01 = parcelRequire("euo01");

var $gJffn = parcelRequire("gJffn");

var $lRq8t = parcelRequire("lRq8t");

var $iw2hI = parcelRequire("iw2hI");

var $2cfd4 = parcelRequire("2cfd4");

var $bXrXb = parcelRequire("bXrXb");

var $daQnM = parcelRequire("daQnM");
const $2518732b1b92a456$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $2518732b1b92a456$var$isDateValueInvalid = (value)=>!(0, $dBLX0.default)((0, $kQ82p.default)(value)) && value !== '';
const $2518732b1b92a456$var$BetweenDates = ({ value: { value1: value1, value2: value2 }, onChange: onChange })=>{
    const locale = (0, $2cfd4.useLocale)();
    const standardizedLocale = (0, $iw2hI.standardizeLocale)(locale);
    const [localizationProvider] = (0, $eJOHy.useState)((0, $gJffn.createLocalizationProvider)(standardizedLocale));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeValue1Date = (0, $eJOHy.useCallback)((value)=>{
        onChange({
            value1: value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $eJOHy.useCallback)((value)=>{
        onChange({
            value1: value1,
            value2: value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euo01.default), {
        id: "value1",
        locale: standardizedLocale,
        onChange: onChangeValue1Date,
        isInvalid: $2518732b1b92a456$var$isDateValueInvalid(value1),
        value: !$2518732b1b92a456$var$isDateValueInvalid(value1) ? value1 : '',
        spacing: "compact",
        testId: "jql-builder-basic-datetime.ui.between-dates.value-1",
        label: formatMessage((0, $daQnM.default).startDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() - $2518732b1b92a456$var$ONE_DAY_IN_MILLISECONDS)),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $daQnM.default).startDateLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.FixedChildWrapper), null, formatMessage((0, $daQnM.default).and)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euo01.default), {
        id: "value2",
        locale: standardizedLocale,
        isInvalid: $2518732b1b92a456$var$isDateValueInvalid(value2),
        onChange: onChangeValue2Date,
        value: !$2518732b1b92a456$var$isDateValueInvalid(value2) ? value2 : '',
        spacing: "compact",
        testId: "jql-builder-basic-datetime.ui.between-dates.value-2",
        label: formatMessage((0, $daQnM.default).endDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() + $2518732b1b92a456$var$ONE_DAY_IN_MILLISECONDS)),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $daQnM.default).endDateLabel)
    })));
};
var $2518732b1b92a456$export$2e2bcd8739ae039 = $2518732b1b92a456$var$BetweenDates;

});
parcelRegister("bXrXb", function(module, exports) {

$parcel$export(module.exports, "StyledRow", () => $96f2d0560712ebd9$export$81761b52b04ea573);
$parcel$export(module.exports, "ChildWrapper", () => $96f2d0560712ebd9$export$87c2de9f2249ec47);
$parcel$export(module.exports, "FixedChildWrapper", () => $96f2d0560712ebd9$export$c11f358d1515ce8d);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $96f2d0560712ebd9$export$81761b52b04ea573 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _18u01ejb _19pk12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $96f2d0560712ebd9$export$87c2de9f2249ec47 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $96f2d0560712ebd9$export$c11f358d1515ce8d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("daQnM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e42384888a6a453$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1e42384888a6a453$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    and: {
        "id": "jql-builder-basic-datetime.between-dates.and",
        "defaultMessage": "and"
    },
    startDateLabel: {
        "id": "jql-builder-basic-datetime.between-dates.start-date-label",
        "defaultMessage": "Choose a start date"
    },
    endDateLabel: {
        "id": "jql-builder-basic-datetime.between-dates.end-date-label",
        "defaultMessage": "Choose an end date"
    }
});

});


parcelRegister("cKrbS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6725246d07ad04a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eKx5I = parcelRequire("eKx5I");

var $lRq8t = parcelRequire("lRq8t");

var $bXrXb = parcelRequire("bXrXb");

var $8keuW = parcelRequire("8keuW");
const $a6725246d07ad04a$var$InRangeOf = ({ value: { value1: value1 = '', value2: value2 = '' }, onChange: onChange, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeValue1Date = (0, $eJOHy.useCallback)((event)=>{
        onChange({
            value1: event.currentTarget.value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $eJOHy.useCallback)((event)=>{
        onChange({
            value1: value1,
            value2: event.currentTarget.value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
        isInvalid: isInvalid,
        name: "value1",
        onChange: onChangeValue1Date,
        value: value1,
        placeholder: "-3w 4d 12h 30m",
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.in-range-of-time.input-1",
        "aria-label": formatMessage((0, $8keuW.default).startTimeRangeLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.FixedChildWrapper), null, formatMessage((0, $8keuW.default).to)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
        isInvalid: isInvalid,
        name: "value2",
        onChange: onChangeValue2Date,
        value: value2,
        placeholder: "3w 4d 12h 30m",
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.in-range-of-time.input-2",
        "aria-label": formatMessage((0, $8keuW.default).endTimeRangeLabel)
    })));
};
var $a6725246d07ad04a$export$2e2bcd8739ae039 = $a6725246d07ad04a$var$InRangeOf;

});
parcelRegister("8keuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb47076830e1c3d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $efb47076830e1c3d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    to: {
        "id": "jql-builder-basic-datetime.in-range-of-time.to",
        "defaultMessage": "to"
    },
    startTimeRangeLabel: {
        "id": "jql-builder-basic-datetime.in-range-of-time.start-time-range-label",
        "defaultMessage": "Enter start of the time range e.g weeks, days, hours and/or minutes"
    },
    endTimeRangeLabel: {
        "id": "jql-builder-basic-datetime.in-range-of-time.end-time-range-label",
        "defaultMessage": "Enter end of the time range"
    }
});

});


parcelRegister("kgmJM", function(module, exports) {

$parcel$export(module.exports, "Radio", () => $73c2433e8d2410fc$export$d7b12c4107be0d61);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $73c2433e8d2410fc$var$Label = ({ htmlFor: htmlFor, children: children, testId: testId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73c2433e8d2410fc$export$eea83358d9434634, {
        htmlFor: htmlFor,
        "data-testid": testId,
        ...props
    }, children);
let $73c2433e8d2410fc$var$controlId = 0;
const $73c2433e8d2410fc$export$d7b12c4107be0d61 = ({ children: children, testId: testId, ...props })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    $73c2433e8d2410fc$var$controlId += 1;
    const id = `jql-builder-basic-datetime-dialog-radio-${$73c2433e8d2410fc$var$controlId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73c2433e8d2410fc$var$Label, {
        htmlFor: id,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73c2433e8d2410fc$export$a195049fd73b3fe2, {
        type: "radio",
        id: id,
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, children));
};
const $73c2433e8d2410fc$export$eea83358d9434634 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _24rc1b66",
            __cmplp.className
        ])
    });
});
const $73c2433e8d2410fc$export$a195049fd73b3fe2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkze3t _2hwx1b66 _otyrze3t _18u01b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fTjd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6600bfb42c2d20b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8TCso = parcelRequire("8TCso");

var $eKx5I = parcelRequire("eKx5I");

var $lRq8t = parcelRequire("lRq8t");

var $e2kjR = parcelRequire("e2kjR");

var $34QWT = parcelRequire("34QWT");

var $bXrXb = parcelRequire("bXrXb");

var $9oqiU = parcelRequire("9oqiU");
const $6600bfb42c2d20b7$var$TimeInput = ({ value: { value1: value1, value2: value2, excludeOverdue: excludeOverdue }, onChange: onChange, typeConfig: { endLabel: endLabel, overduePicker: overduePicker }, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [overdueOptions] = (0, $eJOHy.useState)([
        {
            label: formatMessage((0, $9oqiU.default).labelOrIs),
            value: 'or-is'
        },
        {
            label: formatMessage((0, $9oqiU.default).labelAndNot),
            value: 'and-not'
        }
    ]);
    const [options] = (0, $eJOHy.useState)(Object.entries((0, $e2kjR.TimeUnits)).map(([value, timeUnit])=>{
        const messageDescriptor = (0, $9oqiU.messageLookup)[`${timeUnit}${endLabel || ''}`];
        return {
            label: messageDescriptor ? formatMessage(messageDescriptor) : '',
            value: value
        };
    }));
    (0, $eJOHy.useEffect)(()=>{
        if (value2 === '') {
            const value = {
                value1: value1,
                value2: Object.keys((0, $e2kjR.TimeUnits))[0]
            };
            if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
            onChange(value);
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onChangeValue1 = (0, $eJOHy.useCallback)((event)=>{
        const value = {
            value1: event.currentTarget.value,
            value2: value2
        };
        if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
        onChange(value);
    }, [
        value2,
        overduePicker,
        onChange,
        excludeOverdue
    ]);
    const onChangeValue2 = (0, $eJOHy.useCallback)((optionValue)=>{
        if (!optionValue) return;
        const value = {
            value1: value1,
            value2: optionValue.value
        };
        if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
        onChange(value);
    }, [
        excludeOverdue,
        onChange,
        overduePicker,
        value1
    ]);
    const onChangeExcludeOverdue = (0, $eJOHy.useCallback)((value)=>{
        if (!value) return;
        onChange({
            value1: value1,
            value2: value2,
            excludeOverdue: value.value === overdueOptions[1].value
        });
    }, [
        onChange,
        overdueOptions,
        value1,
        value2
    ]);
    const optionValue2 = options.find((o)=>o.value === value2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bXrXb.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6600bfb42c2d20b7$var$InputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
        isInvalid: isInvalid,
        name: "value1",
        onChange: onChangeValue1,
        value: value1,
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.time-input.input",
        "aria-label": formatMessage((0, $9oqiU.default).timeInputLabel, {
            timeUnit: optionValue2?.label
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6600bfb42c2d20b7$var$ChildWrapper, {
        overduePicker: overduePicker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCso.default), {
        value: optionValue2,
        "aria-label": formatMessage((0, $9oqiU.default).labelTimeUnit),
        onChange: onChangeValue2,
        name: "value2",
        options: options,
        spacing: "compact",
        components: (0, $34QWT.default),
        styles: {
            singleValue: (base)=>({
                    ...base,
                    minWidth: 'fit-content'
                })
        },
        testId: "jql-builder-basic-datetime.ui.time-input.time-units-select"
    })), overduePicker !== undefined && overduePicker === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6600bfb42c2d20b7$var$ChildWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCso.default), {
        value: excludeOverdue === true ? overdueOptions[1] : overdueOptions[0],
        onChange: onChangeExcludeOverdue,
        name: "excludeOverdue",
        options: overdueOptions,
        spacing: "compact",
        components: (0, $34QWT.default),
        styles: {
            singleValue: (base)=>({
                    ...base,
                    minWidth: 'fit-content'
                })
        },
        testId: "jql-builder-basic-datetime.ui.time-input.overdue-select",
        "aria-label": formatMessage((0, $9oqiU.default).labelTimeStatus)
    })));
};
var $6600bfb42c2d20b7$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = $6600bfb42c2d20b7$var$TimeInput;
const $6600bfb42c2d20b7$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug _1ul9t9kd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6600bfb42c2d20b7$var$ChildWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { overduePicker: overduePicker, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug",
            __cmplp.overduePicker ? "_1ul916xz" : "_1ul91llu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("34QWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7cb0b06df59e80$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j3gIc = parcelRequire("j3gIc");
const $7b7cb0b06df59e80$var$Control = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": `${rest.selectProps.testId}--control`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).Control, rest, children));
const $7b7cb0b06df59e80$var$Option = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": `${rest.selectProps.testId}--option`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).Option, rest, children));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b7cb0b06df59e80$export$2e2bcd8739ae039 = {
    Control: $7b7cb0b06df59e80$var$Control,
    Option: $7b7cb0b06df59e80$var$Option
};

});

parcelRegister("9oqiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1daf1c57a51bef8b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $1daf1c57a51bef8b$export$3a16bd55b6aaaf91);

var $7qGN1 = parcelRequire("7qGN1");
const $1daf1c57a51bef8b$var$messages = (0, $7qGN1.defineMessages)({
    minutes: {
        "id": "jql-builder-basic-datetime.time-input.minutes",
        "defaultMessage": "minutes"
    },
    hours: {
        "id": "jql-builder-basic-datetime.time-input.hours",
        "defaultMessage": "hours"
    },
    days: {
        "id": "jql-builder-basic-datetime.time-input.days",
        "defaultMessage": "days"
    },
    weeks: {
        "id": "jql-builder-basic-datetime.time-input.weeks",
        "defaultMessage": "weeks"
    },
    months: {
        "id": "jql-builder-basic-datetime.time-input.months",
        "defaultMessage": "months"
    },
    years: {
        "id": "jql-builder-basic-datetime.time-input.years",
        "defaultMessage": "years"
    },
    minutesAgo: {
        "id": "jql-builder-basic-datetime.time-input.minutes-ago",
        "defaultMessage": "minutes ago"
    },
    hoursAgo: {
        "id": "jql-builder-basic-datetime.time-input.hours-ago",
        "defaultMessage": "hours ago"
    },
    daysAgo: {
        "id": "jql-builder-basic-datetime.time-input.days-ago",
        "defaultMessage": "days ago"
    },
    weeksAgo: {
        "id": "jql-builder-basic-datetime.time-input.weeks-ago",
        "defaultMessage": "weeks ago"
    },
    monthsAgo: {
        "id": "jql-builder-basic-datetime.time-input.months-ago",
        "defaultMessage": "months ago"
    },
    yearsAgo: {
        "id": "jql-builder-basic-datetime.time-input.years-ago",
        "defaultMessage": "years ago"
    },
    minutesOverdue: {
        "id": "jql-builder-basic-datetime.time-input.minutes-overdue",
        "defaultMessage": "minutes overdue"
    },
    hoursOverdue: {
        "id": "jql-builder-basic-datetime.time-input.hours-overdue",
        "defaultMessage": "hours overdue"
    },
    daysOverdue: {
        "id": "jql-builder-basic-datetime.time-input.days-overdue",
        "defaultMessage": "days overdue"
    },
    weeksOverdue: {
        "id": "jql-builder-basic-datetime.time-input.weeks-overdue",
        "defaultMessage": "weeks overdue"
    },
    monthsOverdue: {
        "id": "jql-builder-basic-datetime.time-input.months-overdue",
        "defaultMessage": "months overdue"
    },
    yearsOverdue: {
        "id": "jql-builder-basic-datetime.time-input.years-overdue",
        "defaultMessage": "years overdue"
    },
    labelOrIs: {
        "id": "jql-builder-basic-datetime.time-input.label-or-is",
        "defaultMessage": "or is overdue"
    },
    labelAndNot: {
        "id": "jql-builder-basic-datetime.time-input.label-and-not",
        "defaultMessage": "and not overdue"
    },
    labelTimeUnit: {
        "id": "jql-builder-basic-datetime.time-input.label-time-unit",
        "defaultMessage": "Select unit of time"
    },
    labelTimeStatus: {
        "id": "jql-builder-basic-datetime.time-input.label-time-status",
        "defaultMessage": "Select status"
    },
    timeInputLabel: {
        "id": "jql-builder-basic-datetime.time-input.time-input-label",
        "defaultMessage": "Enter a number of {timeUnit}"
    }
});
var $1daf1c57a51bef8b$export$2e2bcd8739ae039 = $1daf1c57a51bef8b$var$messages;
const $1daf1c57a51bef8b$export$3a16bd55b6aaaf91 = $1daf1c57a51bef8b$var$messages;

});


parcelRegister("3QrSv", function(module, exports) {

$parcel$export(module.exports, "DueDateTypeConfig", () => $566d9bbc72d35ccb$export$e089c311056e8386);
$parcel$export(module.exports, "DateTypeConfig", () => $566d9bbc72d35ccb$export$6643317b16cfbee9);
$parcel$export(module.exports, "DateTimeTypeConfig", () => $566d9bbc72d35ccb$export$5ff2b2d5b16ed369);

var $5YOs6 = parcelRequire("5YOs6");

var $4iNk4 = parcelRequire("4iNk4");

var $TNurX = parcelRequire("TNurX");

var $jp05X = parcelRequire("jp05X");

var $hLFTi = parcelRequire("hLFTi");

var $bgS1B = parcelRequire("bgS1B");

var $fxONR = parcelRequire("fxONR");
const $566d9bbc72d35ccb$export$e089c311056e8386 = [
    (0, $bgS1B.NOW_OVERDUE_CONFIG),
    (0, $hLFTi.MORE_THAN_CONFIG),
    (0, $TNurX.DUE_IN_NEXT_CONFIG),
    (0, $5YOs6.BETWEEN_CONFIG),
    (0, $jp05X.IN_RANGE_CONFIG)
];
const $566d9bbc72d35ccb$export$6643317b16cfbee9 = [
    (0, $fxONR.WITHIN_THE_LAST_CONFIG),
    (0, $hLFTi.CONFIG_DATE_MORE_THAN),
    (0, $5YOs6.BETWEEN_CONFIG),
    (0, $jp05X.IN_RANGE_CONFIG)
];
const $566d9bbc72d35ccb$export$5ff2b2d5b16ed369 = [
    (0, $fxONR.WITHIN_THE_LAST_CONFIG),
    (0, $hLFTi.CONFIG_DATE_MORE_THAN),
    (0, $4iNk4.BETWEEN_DATE_TIME_CONFIG),
    (0, $jp05X.IN_RANGE_CONFIG)
];

});
parcelRegister("5YOs6", function(module, exports) {

$parcel$export(module.exports, "BETWEEN_CONFIG", () => $f10da1fb7b2d5710$export$76f00c4fd9a48d7b);

var $dBLX0 = parcelRequire("dBLX0");

var $lNgEH = parcelRequire("lNgEH");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $f10da1fb7b2d5710$export$76f00c4fd9a48d7b = {
    type: 'between',
    componentType: 'between',
    label: 'labelBetween',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value?.value2 && new Date(value?.value1) > new Date(value?.value2)) return intl.formatMessage((0, $73DRj.default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.value1 !== '' && !(0, $dBLX0.default)(new Date(value?.value1)) || value?.value2 !== '' && !(0, $dBLX0.default)(new Date(value?.value2)))) return intl.formatMessage((0, $73DRj.default).validationMessageInvalidDateFormat);
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        // Format Date based on 'UTC' because `new Date()` uses UTC when no timezone present, and JQL dates never have a timezone
        // JRACLOUD-79698: Without this, users west of UTC will see the dates off-by-one in the UI
        const formatOptions = {
            timeZone: 'UTC'
        };
        if (value) {
            if (value.value1 && value.value2) {
                if ((0, $dBLX0.default)(new Date(value.value1)) && (0, $dBLX0.default)(new Date(value.value2))) return `${intl.formatDate(new Date(value.value1), formatOptions)} - ${intl.formatDate(new Date(value.value2), formatOptions)}`;
            } else if (value.value1 && (0, $dBLX0.default)(new Date(value.value1)) || value.value2 && (0, $dBLX0.default)(new Date(value.value2))) {
                const valueToformat = value.value1 || value.value2;
                return intl.formatDate(new Date(valueToformat), formatOptions);
            }
        }
        return '';
    },
    getJqlData: ({ value1: value1, value2: value2 } = {})=>({
            primaryClause: value1 ? {
                operator: (0, $lNgEH.OPERATOR_GT_EQUALS),
                operand: `${value1}`
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $lNgEH.OPERATOR_LT_EQUALS),
                operand: `${value2}`
            } : undefined
        }),
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    if (clause) {
                        const operatorValue = clause.operator ? clause.operator : '';
                        const value = clause.operand !== undefined ? clause.operand : '';
                        switch(operatorValue){
                            case 0, $lNgEH.OPERATOR_GT_EQUALS:
                                if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX))) returnValue.value1 = value;
                                break;
                            case 0, $lNgEH.OPERATOR_LT_EQUALS:
                                if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX))) returnValue.value2 = value;
                                break;
                            default:
                                break;
                        }
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});
parcelRegister("73DRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $effee99c41ec7377$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $effee99c41ec7377$export$3a16bd55b6aaaf91);

var $7qGN1 = parcelRequire("7qGN1");
const $effee99c41ec7377$var$messages = (0, $7qGN1.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-datetime.utils.update-button-text",
        "defaultMessage": "Update"
    },
    legendText: {
        "id": "jql-builder-basic-datetime.utils.legend-text",
        "defaultMessage": "{fieldLabel} issues by date and time"
    },
    labelNowOverdue: {
        "id": "jql-builder-basic-datetime.utils.label-now-overdue",
        "defaultMessage": "Now overdue"
    },
    valueNowOverdue: {
        "id": "jql-builder-basic-datetime.utils.value-now-overdue",
        "defaultMessage": "Now overdue"
    },
    labelMoreThan: {
        "id": "jql-builder-basic-datetime.utils.label-more-than",
        "defaultMessage": "More than"
    },
    valueMoreThanMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-minutes",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# minute ago} other {# minutes ago}}"
    },
    valueMoreThanHours: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-hours",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# hour ago} other {# hours ago}}"
    },
    valueMoreThanDays: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-days",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# day ago} other {# days ago}}"
    },
    valueMoreThanWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-weeks",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# week ago} other {# weeks ago}}"
    },
    labelDueInNext: {
        "id": "jql-builder-basic-datetime.utils.label-due-in-next",
        "defaultMessage": "Due in next"
    },
    valueDueInNextExcludeOverdueMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-minutes",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    valueDueInNextExcludeOverdueHours: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-hours",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueDueInNextExcludeOverdueDays: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-days",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueDueInNextExcludeOverdueWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-weeks",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueDueInNextMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-minutes",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}} or is overdue"
    },
    valueDueInNextHours: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-hours",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}} or is overdue"
    },
    valueDueInNextDays: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-days",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 days} one {# day} other {# days}} or is overdue"
    },
    valueDueInNextWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-weeks",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}} or is overdue"
    },
    labelBetween: {
        "id": "jql-builder-basic-datetime.utils.label-between",
        "defaultMessage": "Between"
    },
    labelInRange: {
        "id": "jql-builder-basic-datetime.utils.label-in-range",
        "defaultMessage": "In the range"
    },
    valueInRange: {
        "id": "jql-builder-basic-datetime.utils.value-in-range",
        "defaultMessage": "From {start} to {end}"
    },
    valueInRangeBeforeNowToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-after-now",
        "defaultMessage": "From {beforeTime} ago to {afterTime} from now"
    },
    valueInRangeBeforeNowToBeforeNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-before-now",
        "defaultMessage": "From {beforeTime} ago to {afterTime} ago"
    },
    valueInRangeAfterNowToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-after-now-to-after-now",
        "defaultMessage": "From {beforeTime} from now to {afterTime} from now"
    },
    valueInRangeBeforeNowToBlank: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-blank",
        "defaultMessage": "From {beforeTime} ago"
    },
    valueInRangeAfterNowToBlank: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-after-now-to-blank",
        "defaultMessage": "From {beforeTime} from now"
    },
    valueInRangeBlankToBeforeNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-blank-to-before-now",
        "defaultMessage": "Up to {afterTime} ago"
    },
    valueInRangeBlankToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-blank-to-after-now",
        "defaultMessage": "Up to {afterTime} from now"
    },
    labelIsNotSet: {
        "id": "jql-builder-basic-datetime.utils.label-is-not-set",
        "defaultMessage": "is empty"
    },
    labelWithinTheLast: {
        "id": "jql-builder-basic-datetime.utils.label-within-the-last",
        "defaultMessage": "Within the last"
    },
    valueWithinTheLastMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-minutes",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    valueWithinTheLastHours: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-hours",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueWithinTheLastDays: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-days",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueWithinTheLastWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-weeks",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueTimeInWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-weeks",
        "defaultMessage": "{timeNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueTimeInDays: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-days",
        "defaultMessage": "{timeNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueTimeInHours: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-hours",
        "defaultMessage": "{timeNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueTimeInMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-minutes",
        "defaultMessage": "{timeNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    validationMessageInvalidPeriodFormat: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-period-format",
        "defaultMessage": "Enter a valid number"
    },
    validationMessageBeforeGreaterThanAfter: {
        "id": "jql-builder-basic-datetime.utils.validation-message-before-greater-than-after",
        "defaultMessage": "'Before' field cannot be later than 'After' field."
    },
    validationMessageFromGreaterThanTo: {
        "id": "jql-builder-basic-datetime.utils.validation-message-from-greater-than-to",
        "defaultMessage": "'From' field cannot be later than 'To' field."
    },
    validationMessageInvalidDateFormat: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-date-format",
        "defaultMessage": "Invalid date format."
    },
    validationMessageInvalidPeriodFormatValue: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-period-format-value",
        "defaultMessage": "Invalid period format. Please enter the period in the format \"3w 4d 5h 6m\"."
    },
    legendTextIssueTerminologyRefreshM4: {
        "id": "jql-builder-basic-datetime.utils.legend-text-issue-terminology-refresh-m4",
        "defaultMessage": "{fieldLabel} work items by date and time"
    }
});
var $effee99c41ec7377$export$2e2bcd8739ae039 = $effee99c41ec7377$var$messages;
const $effee99c41ec7377$export$3a16bd55b6aaaf91 = $effee99c41ec7377$var$messages;

});

parcelRegister("iE7P0", function(module, exports) {

$parcel$export(module.exports, "IS_YYYY_MM_DD_REGEX", () => $daa50c52dd369c58$export$f1b1463eb20d9130);
$parcel$export(module.exports, "getTimeInfo", () => $daa50c52dd369c58$export$5c5047d260d2b2e4);
$parcel$export(module.exports, "getTimeString", () => $daa50c52dd369c58$export$da876ebe5870f49a);
$parcel$export(module.exports, "getTimeInMinutes", () => $daa50c52dd369c58$export$99ba9a356555dbdf);
$parcel$export(module.exports, "isValidTimePeriodFormat", () => $daa50c52dd369c58$export$2214112898027187);

var $73DRj = parcelRequire("73DRj");
const $daa50c52dd369c58$var$periodRegexp = /^(?!$)(?<sign>(^-))?((?<weeks>\d+)w)? ?((?<days>\d+)d)? ?((?<hours>\d+)h)? ?((?<minutes>\d+)m)*$/;
const $daa50c52dd369c58$export$f1b1463eb20d9130 = /[1-9][0-9]{3}([-][0-9]{2}){2}/;
const $daa50c52dd369c58$export$412dc06c06fbf003 = (timeString)=>{
    const weeksIndex = timeString.indexOf('w');
    const daysIndex = timeString.indexOf('d');
    const hoursIndex = timeString.indexOf('h');
    const minutesIndex = timeString.indexOf('m');
    if (weeksIndex > -1 && weeksIndex < timeString.length - 1 && timeString[weeksIndex + 1] !== ' ') return false;
    if (daysIndex > -1 && daysIndex < timeString.length - 1 && timeString[daysIndex + 1] !== ' ') return false;
    if (hoursIndex > -1 && hoursIndex < timeString.length - 1 && timeString[hoursIndex + 1] !== ' ') return false;
    if (minutesIndex > -1 && minutesIndex < timeString.length - 1 && timeString[minutesIndex + 1] !== ' ') return false;
    return true;
};
const $daa50c52dd369c58$export$5c5047d260d2b2e4 = (timeData)=>{
    if (timeData !== undefined) {
        const matches = timeData.match($daa50c52dd369c58$var$periodRegexp);
        if ($daa50c52dd369c58$var$periodRegexp.test(timeData) && $daa50c52dd369c58$export$412dc06c06fbf003(timeData) && matches && matches.groups) {
            const { sign: sign = '', weeks: weeks = '', days: days = '', hours: hours = '', minutes: minutes = '' } = matches.groups;
            const parsedWeeks = parseInt(weeks, 10);
            const parsedDays = parseInt(days, 10);
            const parsedHours = parseInt(hours, 10);
            const parsedMinute = parseInt(minutes, 10);
            return {
                isBeforeNow: sign === '-',
                minutes: Number.isNaN(parsedMinute) ? undefined : +parsedMinute,
                hours: Number.isNaN(parsedHours) ? undefined : +parsedHours,
                days: Number.isNaN(parsedDays) ? undefined : +parsedDays,
                weeks: Number.isNaN(parsedWeeks) ? undefined : +parsedWeeks,
                isValid: true
            };
        }
    }
    return {
        isBeforeNow: false,
        minutes: undefined,
        hours: undefined,
        days: undefined,
        weeks: undefined,
        isValid: false
    };
};
const $daa50c52dd369c58$export$da876ebe5870f49a = (intl, timeInfo)=>[
        timeInfo.weeks !== undefined ? intl.formatMessage((0, $73DRj.default).valueTimeInWeeks, {
            timeNumber: timeInfo.weeks
        }) : false,
        timeInfo.days !== undefined ? intl.formatMessage((0, $73DRj.default).valueTimeInDays, {
            timeNumber: timeInfo.days
        }) : false,
        timeInfo.hours !== undefined ? intl.formatMessage((0, $73DRj.default).valueTimeInHours, {
            timeNumber: timeInfo.hours
        }) : false,
        timeInfo.minutes !== undefined ? intl.formatMessage((0, $73DRj.default).valueTimeInMinutes, {
            timeNumber: timeInfo.minutes
        }) : false
    ].filter(Boolean).join(', ');
const $daa50c52dd369c58$export$99ba9a356555dbdf = (timeInfo)=>{
    if (timeInfo.isValid) return (timeInfo.isBeforeNow ? -1 : 1) * ((timeInfo.minutes !== undefined ? timeInfo.minutes : 0) + (timeInfo.hours !== undefined ? timeInfo.hours * 60 : 0) + (timeInfo.days !== undefined ? timeInfo.days * 1440 : 0) + (timeInfo.weeks !== undefined ? timeInfo.weeks * 10080 : 0));
    return 0;
};
const $daa50c52dd369c58$var$isNumeric = (value)=>/^\d+$/.test(value);
const $daa50c52dd369c58$export$2214112898027187 = (timeDigits, timeUnit)=>timeDigits === '' || timeDigits !== undefined && $daa50c52dd369c58$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && [
        'm',
        'h',
        'd',
        'w'
    ].includes(timeUnit ?? '');

});


parcelRegister("4iNk4", function(module, exports) {

$parcel$export(module.exports, "BETWEEN_DATE_TIME_CONFIG", () => $ea598d0e89b0c8ee$export$a553aad7ea821394);

var $57raR = parcelRequire("57raR");

var $dBLX0 = parcelRequire("dBLX0");

var $kQ82p = parcelRequire("kQ82p");

var $lNgEH = parcelRequire("lNgEH");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $ea598d0e89b0c8ee$export$a553aad7ea821394 = {
    type: 'between_date_time',
    componentType: 'between_date_time',
    label: 'labelBetween',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value?.value2 && (0, $kQ82p.default)(value?.value1) > (0, $kQ82p.default)(value?.value2)) return intl.formatMessage((0, $73DRj.default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.value1 !== '' && !(0, $dBLX0.default)((0, $kQ82p.default)(value?.value1)) || value?.value2 !== '' && !(0, $dBLX0.default)((0, $kQ82p.default)(value?.value2)))) return intl.formatMessage((0, $73DRj.default).validationMessageInvalidDateFormat);
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        if (value) {
            if (value.value1 && value.value2) {
                const parsedValue1 = (0, $kQ82p.default)(value.value1);
                const parsedValue2 = (0, $kQ82p.default)(value.value2);
                if ((0, $dBLX0.default)(parsedValue1) && (0, $dBLX0.default)(parsedValue2)) return `${intl.formatDate(parsedValue1, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                })} - ${intl.formatDate(parsedValue2, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                })}`;
            } else if (value.value1 && (0, $dBLX0.default)((0, $kQ82p.default)(value.value1)) || value.value2 && (0, $dBLX0.default)((0, $kQ82p.default)(value.value2))) {
                const valueToformat = value.value1 || value.value2;
                return intl.formatDate((0, $kQ82p.default)(valueToformat), {
                    dateStyle: 'short',
                    timeStyle: 'short'
                });
            }
        }
        return '';
    },
    getJqlData: ({ value1: value1, value2: value2 } = {})=>{
        const formatValue = (value)=>{
            const parsedValue = (0, $kQ82p.default)(value);
            return (0, $dBLX0.default)(parsedValue) ? (0, $57raR.default)(parsedValue, 'yyyy-MM-dd HH:mm') : value;
        };
        return {
            primaryClause: value1 ? {
                operator: (0, $lNgEH.OPERATOR_GT_EQUALS),
                operand: formatValue(value1)
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $lNgEH.OPERATOR_LT_EQUALS),
                operand: formatValue(value2)
            } : undefined
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    if (clause) {
                        const operatorValue = clause.operator ? clause.operator : '';
                        const value = clause.operand !== undefined ? clause.operand : '';
                        switch(operatorValue){
                            case 0, $lNgEH.OPERATOR_GT_EQUALS:
                                if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX))) returnValue.value1 = value;
                                break;
                            case 0, $lNgEH.OPERATOR_LT_EQUALS:
                                if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX))) returnValue.value2 = value;
                                break;
                            default:
                                break;
                        }
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});

parcelRegister("TNurX", function(module, exports) {

$parcel$export(module.exports, "DUE_IN_NEXT_CONFIG", () => $59a3b15ec01e416d$export$f0be3f9139a88bf5);

var $lNgEH = parcelRequire("lNgEH");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $59a3b15ec01e416d$export$f0be3f9139a88bf5 = {
    type: 'due_in_next',
    componentType: 'time_input',
    label: 'labelDueInNext',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $iE7P0.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $73DRj.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) {
            const { excludeOverdue: excludeOverdue = false } = value;
            switch(value.value2.toLowerCase()){
                case 'm':
                    return excludeOverdue ? intl.formatMessage((0, $73DRj.default).valueDueInNextExcludeOverdueMinutes, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $73DRj.default).valueDueInNextMinutes, {
                        dateNumber: value.value1
                    });
                case 'h':
                    return excludeOverdue ? intl.formatMessage((0, $73DRj.default).valueDueInNextExcludeOverdueHours, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $73DRj.default).valueDueInNextHours, {
                        dateNumber: value.value1
                    });
                case 'd':
                    return excludeOverdue ? intl.formatMessage((0, $73DRj.default).valueDueInNextExcludeOverdueDays, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $73DRj.default).valueDueInNextDays, {
                        dateNumber: value.value1
                    });
                case 'w':
                    return excludeOverdue ? intl.formatMessage((0, $73DRj.default).valueDueInNextExcludeOverdueWeeks, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $73DRj.default).valueDueInNextWeeks, {
                        dateNumber: value.value1
                    });
                default:
                    return value.value2;
            }
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2, excludeOverdue: excludeOverdue } = dateTimeValue;
        return excludeOverdue === true ? {
            primaryClause: {
                operator: (0, $lNgEH.OPERATOR_GT_EQUALS),
                operand: '0'
            },
            secondaryClause: {
                operator: (0, $lNgEH.OPERATOR_LT_EQUALS),
                operand: `${value1}${value2}`
            }
        } : {
            primaryClause: {
                operator: (0, $lNgEH.OPERATOR_LT_EQUALS),
                operand: `${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            // if both clauses are present check value of operand if it's '0'
            if (primaryClause === undefined && secondaryClause === undefined) // Does not match type if more than one clause is present
            return undefined;
            if (primaryClause !== undefined && secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: '',
                    excludeOverdue: false
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    const operatorValue = clause.operator ? clause.operator : '';
                    const value = clause.operand !== undefined ? clause.operand : '';
                    switch(operatorValue){
                        case 0, $lNgEH.OPERATOR_GT_EQUALS:
                            if (value === '0' || value === '"0"') returnValue.excludeOverdue = true;
                            break;
                        case 0, $lNgEH.OPERATOR_LT_EQUALS:
                            if (value) {
                                const matches = value.match(/^([0-9]*)([mhdw])$/);
                                if (matches?.length === 3) {
                                    const [, value1, value2] = matches;
                                    returnValue.value1 = value1;
                                    returnValue.value2 = value2;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                });
                if (returnValue.value1 && returnValue.value2 && returnValue.excludeOverdue) return returnValue;
            }
            if (primaryClause === undefined && secondaryClause !== undefined || primaryClause !== undefined && secondaryClause === undefined) {
                const clause = primaryClause || secondaryClause;
                if (clause && clause.operator === (0, $lNgEH.OPERATOR_LT_EQUALS)) {
                    const value = clause.operand !== undefined ? clause.operand : '';
                    if (value !== undefined) {
                        const matches = value.match(/^([0-9]*)([mhdw])$/);
                        if (matches?.length === 3) return {
                            value1: matches[1],
                            value2: matches[2]
                        };
                    }
                }
            }
            return undefined;
        }
        return undefined;
    },
    overduePicker: true
};

});

parcelRegister("jp05X", function(module, exports) {

$parcel$export(module.exports, "IN_RANGE_CONFIG", () => $4b0a8471b77494aa$export$824796e3ed16a4e0);

var $lNgEH = parcelRequire("lNgEH");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $4b0a8471b77494aa$export$824796e3ed16a4e0 = {
    type: 'in_range',
    componentType: 'in_range',
    label: 'labelInRange',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value.value2 && (0, $iE7P0.getTimeInMinutes)((0, $iE7P0.getTimeInfo)(value.value1)) > (0, $iE7P0.getTimeInMinutes)((0, $iE7P0.getTimeInfo)(value.value2))) return intl.formatMessage((0, $73DRj.default).validationMessageFromGreaterThanTo);
        if (value && (value.value1 !== '' && !(0, $iE7P0.getTimeInfo)(value.value1).isValid || value.value2 !== '' && !(0, $iE7P0.getTimeInfo)(value.value2).isValid)) return intl.formatMessage((0, $73DRj.default).validationMessageInvalidPeriodFormatValue);
        return undefined;
    },
    getTooltip: (intl, value)=>{
        const fromTimeInfo = (0, $iE7P0.getTimeInfo)(value?.value1);
        const toTimeInfo = (0, $iE7P0.getTimeInfo)(value?.value2);
        if (fromTimeInfo.isValid && toTimeInfo.isValid) {
            if (fromTimeInfo.isBeforeNow && toTimeInfo.isBeforeNow) return intl.formatMessage((0, $73DRj.default).valueInRangeBeforeNowToBeforeNow, {
                beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
            });
            if (fromTimeInfo.isBeforeNow && !toTimeInfo.isBeforeNow) return intl.formatMessage((0, $73DRj.default).valueInRangeBeforeNowToAfterNow, {
                beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
            });
            if (!fromTimeInfo.isBeforeNow && !toTimeInfo.isBeforeNow) return intl.formatMessage((0, $73DRj.default).valueInRangeAfterNowToAfterNow, {
                beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
            });
        }
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        const fromTimeInfo = (0, $iE7P0.getTimeInfo)(value?.value1);
        const toTimeInfo = (0, $iE7P0.getTimeInfo)(value?.value2);
        if (fromTimeInfo.isValid && toTimeInfo.isValid) return intl.formatMessage((0, $73DRj.default).valueInRange, {
            start: value?.value1,
            end: value?.value2
        });
        if (fromTimeInfo.isValid && value && value.value2 === '') return fromTimeInfo.isBeforeNow ? intl.formatMessage((0, $73DRj.default).valueInRangeBeforeNowToBlank, {
            beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo)
        }) : intl.formatMessage((0, $73DRj.default).valueInRangeAfterNowToBlank, {
            beforeTime: (0, $iE7P0.getTimeString)(intl, fromTimeInfo)
        });
        if (toTimeInfo.isValid && value && value.value1 === '') return toTimeInfo.isBeforeNow ? intl.formatMessage((0, $73DRj.default).valueInRangeBlankToBeforeNow, {
            afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
        }) : intl.formatMessage((0, $73DRj.default).valueInRangeBlankToAfterNow, {
            afterTime: (0, $iE7P0.getTimeString)(intl, toTimeInfo)
        });
        // TODO : This scenario shouldn't happen, retain this till invalid scenarios are handled
        return value ? intl.formatMessage((0, $73DRj.default).valueInRangeBeforeNowToAfterNow, {
            beforeTime: value.value1,
            afterTime: value.value2
        }) : '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: value1 ? {
                operator: (0, $lNgEH.OPERATOR_GT_EQUALS),
                operand: `${value1}`
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $lNgEH.OPERATOR_LT_EQUALS),
                operand: `${value2}`
            } : undefined
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    const operatorValue = clause && clause.operator ? clause.operator : '';
                    const value = clause && clause.operand !== undefined ? clause.operand : '';
                    switch(operatorValue){
                        case 0, $lNgEH.OPERATOR_GT_EQUALS:
                            if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX)) == null) returnValue.value1 = value;
                            break;
                        case 0, $lNgEH.OPERATOR_LT_EQUALS:
                            if (value.match((0, $iE7P0.IS_YYYY_MM_DD_REGEX)) == null) returnValue.value2 = value;
                            break;
                        default:
                            break;
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});

parcelRegister("hLFTi", function(module, exports) {

$parcel$export(module.exports, "MORE_THAN_CONFIG", () => $5b94708a8484f41d$export$d840a05dccc1ad98);
$parcel$export(module.exports, "CONFIG_DATE_MORE_THAN", () => $5b94708a8484f41d$export$3381ab6a0f70cfec);

var $lNgEH = parcelRequire("lNgEH");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $5b94708a8484f41d$export$d840a05dccc1ad98 = {
    type: 'more_than',
    componentType: 'time_input',
    label: 'labelMoreThan',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $iE7P0.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $73DRj.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) switch(value.value2.toLowerCase()){
            case 'm':
                return intl.formatMessage((0, $73DRj.default).valueMoreThanMinutes, {
                    dateNumber: value.value1
                });
            case 'h':
                return intl.formatMessage((0, $73DRj.default).valueMoreThanHours, {
                    dateNumber: value.value1
                });
            case 'd':
                return intl.formatMessage((0, $73DRj.default).valueMoreThanDays, {
                    dateNumber: value.value1
                });
            case 'w':
                return intl.formatMessage((0, $73DRj.default).valueMoreThanWeeks, {
                    dateNumber: value.value1
                });
            default:
                return value.value2;
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: {
                operator: (0, $lNgEH.OPERATOR_LT_EQUALS),
                operand: `-${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $lNgEH.OPERATOR_LT_EQUALS)) {
                const value = clause.operand !== undefined ? clause.operand : '';
                if (value) {
                    const matches = value.match(/^[-]([0-9]*)([mhdw])$/);
                    if (matches?.length === 3) return {
                        value1: matches[1],
                        value2: matches[2]
                    };
                }
            }
            return undefined;
        }
        return undefined;
    },
    endLabel: 'Overdue'
};
const $5b94708a8484f41d$export$3381ab6a0f70cfec = {
    ...$5b94708a8484f41d$export$d840a05dccc1ad98,
    endLabel: 'Ago'
};

});

parcelRegister("bgS1B", function(module, exports) {

$parcel$export(module.exports, "NOW_OVERDUE_CONFIG", () => $b5905e01b49267d0$export$10b9f2fe105831bd);

var $lNgEH = parcelRequire("lNgEH");

var $73DRj = parcelRequire("73DRj");
const $b5905e01b49267d0$export$10b9f2fe105831bd = {
    type: 'now_overdue',
    componentType: 'is_not_set',
    label: 'labelNowOverdue',
    hasInput: false,
    getFormattedValue: (intl, value)=>value ? intl.formatMessage((0, $73DRj.default).valueNowOverdue) : '',
    getJqlData: ()=>({
            primaryClause: {
                operator: (0, $lNgEH.OPERATOR_LT_EQUALS),
                operand: '0'
            }
        }),
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $lNgEH.OPERATOR_LT_EQUALS)) {
                const value = clause.operand;
                if (value && (value === '0' || value === '"0"')) return {
                    value1: '',
                    value2: ''
                };
            }
        }
        return undefined;
    }
};

});

parcelRegister("fxONR", function(module, exports) {

$parcel$export(module.exports, "WITHIN_THE_LAST_CONFIG", () => $1e697b480fd46006$export$8095f803ac0c0718);

var $lNgEH = parcelRequire("lNgEH");

var $73DRj = parcelRequire("73DRj");

var $iE7P0 = parcelRequire("iE7P0");
const $1e697b480fd46006$export$8095f803ac0c0718 = {
    type: 'within_the_last',
    componentType: 'time_input',
    label: 'labelWithinTheLast',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $iE7P0.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $73DRj.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) switch(value.value2.toLowerCase()){
            case 'm':
                return intl.formatMessage((0, $73DRj.default).valueWithinTheLastMinutes, {
                    dateNumber: value.value1
                });
            case 'h':
                return intl.formatMessage((0, $73DRj.default).valueWithinTheLastHours, {
                    dateNumber: value.value1
                });
            case 'd':
                return intl.formatMessage((0, $73DRj.default).valueWithinTheLastDays, {
                    dateNumber: value.value1
                });
            case 'w':
                return intl.formatMessage((0, $73DRj.default).valueWithinTheLastWeeks, {
                    dateNumber: value.value1
                });
            default:
                return value.value2;
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: {
                operator: (0, $lNgEH.OPERATOR_GT_EQUALS),
                operand: `-${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $lNgEH.OPERATOR_GT_EQUALS)) {
                const value = clause.operand !== undefined ? clause.operand : '';
                if (value) {
                    const matches = value.match(/^[-]([0-9]*)([mhdw])$/);
                    if (matches?.length === 3) return {
                        value1: matches[1],
                        value2: matches[2]
                    };
                }
            }
            return undefined;
        }
        return undefined;
    }
};

});



parcelRegister("q3XlS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc71c3438f9a300$export$2e2bcd8739ae039);

var $2poie = parcelRequire("2poie");
var $3c1PD = parcelRequire("3c1PD");
const $ccc71c3438f9a300$var$singleDatePattern = /^(-)?[0-9]+(m|minute|minutes|h|hour|hours|d|day|days|w|week|weeks){1}$/;
const $ccc71c3438f9a300$var$isSingleDateValue = (str)=>$ccc71c3438f9a300$var$singleDatePattern.test(str.toLowerCase());
const $ccc71c3438f9a300$var$wrapWithQuotesIfNeeded = (text)=>$ccc71c3438f9a300$var$isSingleDateValue(text) ? text : `"${text.replace(/"/g, '\\"')}"`;
const $ccc71c3438f9a300$var$getClauses = (ast, fieldIdentifier)=>{
    const fieldsToReturn = [];
    const where = ast.query?.where;
    if (where) {
        if (where.clauseType === (0, $27a6760b07fae18c$export$7a58b23488ea076b) && where.clauses) where.clauses.forEach((clause)=>{
            if (clause.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) {
                const fieldId = clause.field.value.toLowerCase();
                if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(clause);
            }
        });
        else if (where.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a)) {
            const fieldId = where.field.value.toLowerCase();
            if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(where);
        }
    }
    return fieldsToReturn;
};
const $ccc71c3438f9a300$var$createTerminalClause = ({ fieldId: fieldId, operator: operator, value: value })=>(0, $2poie.default).terminalClause((0, $2poie.default).field(fieldId), (0, $2poie.default).operator(operator), (0, $2poie.default).byText.valueOperand($ccc71c3438f9a300$var$wrapWithQuotesIfNeeded(value)));
const $ccc71c3438f9a300$var$appendOrReplaceClause = ({ fieldId: fieldId, newClauseData: newClauseData, clauseToReplace: clauseToReplace, query: query })=>{
    const { operator: operator, operand: value } = newClauseData;
    if (clauseToReplace) clauseToReplace.replace($ccc71c3438f9a300$var$createTerminalClause({
        fieldId: fieldId,
        operator: operator,
        value: value
    }));
    else query.appendClause($ccc71c3438f9a300$var$createTerminalClause({
        fieldId: fieldId,
        operator: operator,
        value: value
    }), (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
};
const $ccc71c3438f9a300$var$appendOrReplaceClauses = ({ fieldId: fieldId, jqlData: jqlData, fieldToRenderClause: fieldToRenderClause, fieldToRenderSecondaryClause: fieldToRenderSecondaryClause, query: query })=>{
    const { primaryClause: primaryClauseData, secondaryClause: secondaryClauseData } = jqlData;
    if (primaryClauseData) $ccc71c3438f9a300$var$appendOrReplaceClause({
        fieldId: fieldId,
        newClauseData: primaryClauseData,
        clauseToReplace: fieldToRenderClause || fieldToRenderSecondaryClause,
        query: query
    });
    if (secondaryClauseData) $ccc71c3438f9a300$var$appendOrReplaceClause({
        fieldId: fieldId,
        newClauseData: secondaryClauseData,
        clauseToReplace: primaryClauseData ? fieldToRenderSecondaryClause : fieldToRenderClause || fieldToRenderSecondaryClause,
        query: query
    });
};
const $ccc71c3438f9a300$var$deleteUnnecessaryClauses = ({ jqlData: jqlData, fieldToRenderClause: fieldToRenderClause, fieldToRenderSecondaryClause: fieldToRenderSecondaryClause })=>{
    if (!jqlData || !jqlData.primaryClause && !jqlData.secondaryClause) {
        fieldToRenderClause && fieldToRenderClause.remove();
        fieldToRenderSecondaryClause && fieldToRenderSecondaryClause.remove();
    }
    if (jqlData && (!jqlData.primaryClause || !jqlData.secondaryClause)) fieldToRenderSecondaryClause && fieldToRenderSecondaryClause.remove();
};
const $ccc71c3438f9a300$var$getNewJqlFromDoubleClausePickerJqlData = (fieldId, ast, jqlData)=>{
    if (!ast.query) return ast.represents;
    const [fieldToRenderClause, fieldToRenderSecondaryClause] = $ccc71c3438f9a300$var$getClauses(ast, fieldId);
    if (jqlData !== undefined) $ccc71c3438f9a300$var$appendOrReplaceClauses({
        fieldId: fieldId,
        jqlData: jqlData,
        fieldToRenderClause: fieldToRenderClause,
        fieldToRenderSecondaryClause: fieldToRenderSecondaryClause,
        query: ast.query
    });
    $ccc71c3438f9a300$var$deleteUnnecessaryClauses({
        jqlData: jqlData,
        fieldToRenderClause: fieldToRenderClause,
        fieldToRenderSecondaryClause: fieldToRenderSecondaryClause
    });
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};
var $ccc71c3438f9a300$export$2e2bcd8739ae039 = $ccc71c3438f9a300$var$getNewJqlFromDoubleClausePickerJqlData;

});


parcelRegister("8b3Zt", function(module, exports) {

$parcel$export(module.exports, "LastUserCommentedPickerWrapper", () => $9ac07a7acbf1a93d$export$d03064b9074933a8);

var $eJOHy = parcelRequire("eJOHy");

var $fkBUX = parcelRequire("fkBUX");

var $lx8oo = parcelRequire("lx8oo");

var $bxHeV = parcelRequire("bxHeV");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $boEdP = parcelRequire("boEdP");

var $cNe2t = parcelRequire("cNe2t");


var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $dIHx6 = parcelRequire("dIHx6");

var $gZnpM = parcelRequire("gZnpM");
const $9ac07a7acbf1a93d$export$d03064b9074933a8 = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, onClear: onClear, onClose: onClose, onOpen: onOpen, onSearchWrapper: onSearchWrapper, isIrremovable: isIrremovable })=>{
    const [isChecked, setIsChecked] = (0, $eJOHy.useState)((0, $gZnpM.getInitialState)(clause));
    const isOpen = activePopupKey === fieldId;
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const [ast] = (0, $lyPdT.useAST)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.last-user-commented-picker-wrapper.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!clause,
                onClick: handleOnTriggerClick,
                onClear: ()=>onClear(clause ? (0, $boEdP.default)(ast, clause) : undefined),
                testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
                color: "inherit",
                weight: "medium",
                testId: (0, $332899bfd23114ba$export$743be55d5cf4a20d)
            }, clause ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
                as: "strong"
            }, `${fieldLabel}: `), isChecked ? formatMessage((0, $dIHx6.default).trueMessage) : formatMessage((0, $dIHx6.default).all)) : fieldLabel)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                xcss: $9ac07a7acbf1a93d$var$boxStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkBUX.default), {
                id: "last-user-commented-checkbox",
                onChange: (e)=>{
                    setIsChecked(e.target.checked);
                    onSearchWrapper && onSearchWrapper((0, $gZnpM.getUpdatedJql)(ast, clause, fieldId, e.target.checked));
                    onClose();
                },
                isChecked: isChecked,
                testId: "jql-builder-basic.ui.jql-editor.field.last-user-commented-picker-wrapper.checkbox"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lx8oo.Label), {
                htmlFor: "last-user-commented-checkbox"
            }, formatMessage((0, $dIHx6.default).checkBoxLabel)))
    });
};
var $9ac07a7acbf1a93d$export$2e2bcd8739ae039 = $9ac07a7acbf1a93d$export$d03064b9074933a8;
const $9ac07a7acbf1a93d$var$boxStyles = (0, $5Wv5g.xcss)({
    padding: 'space.150'
});

});
parcelRegister("fkBUX", function(module, exports) {

$parcel$export(module.exports, "default", () => $726f6df391a2f24d$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j2fEo = parcelRequire("j2fEo");

var $i15ln = parcelRequire("i15ln");

var $9kJQq = parcelRequire("9kJQq");
var $dpUii = parcelRequire("dpUii");
var $lPOzx = parcelRequire("lPOzx");
var $BS6V6 = parcelRequire("BS6V6");
const $726f6df391a2f24d$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $726f6df391a2f24d$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $i15ln.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dpUii.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $726f6df391a2f24d$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9kJQq.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lPOzx.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $BS6V6.default), {})
                ]
            })
        ]
    });
}));
$726f6df391a2f24d$var$Checkbox.displayName = 'Checkbox';
var $726f6df391a2f24d$export$2e2bcd8739ae039 = $726f6df391a2f24d$var$Checkbox;

});
parcelRegister("9kJQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9af74bab0be798aa$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lb1YQ = parcelRequire("lb1YQ");

var $8XtVW = parcelRequire("8XtVW");
function $9af74bab0be798aa$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $8XtVW.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $8XtVW.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $9af74bab0be798aa$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$9af74bab0be798aa$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lb1YQ.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $8XtVW.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $9af74bab0be798aa$export$2e2bcd8739ae039 = $9af74bab0be798aa$var$CheckboxIcon;

});

parcelRegister("dpUii", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab99cb6f1b9c8ee4$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ab99cb6f1b9c8ee4$var$baseStyles = null;
const $ab99cb6f1b9c8ee4$var$textLabelLayoutStyles = null;
const $ab99cb6f1b9c8ee4$var$disabledStyles = null;
const $ab99cb6f1b9c8ee4$var$labelStyles = null;
function $ab99cb6f1b9c8ee4$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("lPOzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb1d03d747e55e3$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ffb1d03d747e55e3$var$labelTextStyles = null;
function $ffb1d03d747e55e3$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("BS6V6", function(module, exports) {

$parcel$export(module.exports, "default", () => $901caf535bc521f4$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $901caf535bc521f4$var$requiredIndicatorStyles = null;
function $901caf535bc521f4$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("dIHx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b628b450a5564035$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b628b450a5564035$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    checkBoxLabel: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.check-box-label",
        "defaultMessage": "Restrict to last commented by non-developers"
    },
    all: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.all",
        "defaultMessage": "All"
    },
    trueMessage: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.true-message",
        "defaultMessage": "true"
    }
});

});

parcelRegister("gZnpM", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $f759b4c47f66e682$export$1625bb7ada97d007);
$parcel$export(module.exports, "getInitialState", () => $f759b4c47f66e682$export$53ac33307b5acee9);

var $2poie = parcelRequire("2poie");
var $lNgEH = parcelRequire("lNgEH");
var $3c1PD = parcelRequire("3c1PD");

var $boEdP = parcelRequire("boEdP");

var $eiIzV = parcelRequire("eiIzV");
const $f759b4c47f66e682$var$createTerminalClause = (fieldId, value)=>(0, $2poie.default).terminalClause((0, $2poie.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS)), (0, $2poie.default).byText.valueOperand(value ? '"true"' : '""'));
const $f759b4c47f66e682$export$1625bb7ada97d007 = (ast, clause, fieldId, value)=>{
    const hasValue = Boolean(value);
    if (!clause) {
        if (!ast.query || !hasValue) return ast.represents;
        if (value) ast.query.appendClause($f759b4c47f66e682$var$createTerminalClause(fieldId, value), (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
    } else if (value) clause.replace($f759b4c47f66e682$var$createTerminalClause(fieldId, value));
    else return (0, $boEdP.default)(ast, clause);
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};
const $f759b4c47f66e682$export$53ac33307b5acee9 = (clause)=>(clause && clause.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) && clause.operand && clause.operand.operandType === (0, $f38290926d0398e2$export$38accfc5a5d1c113) && clause.operand.value) === 'true';

});


parcelRegister("5maGz", function(module, exports) {

$parcel$export(module.exports, "NumberRangePicker", () => $d17dc1ea6d66e4bc$export$1ad8a36b54765fad);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $q3XlS = parcelRequire("q3XlS");

var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $jhLWN = parcelRequire("jhLWN");

var $aM67A = parcelRequire("aM67A");
const $d17dc1ea6d66e4bc$export$1ad8a36b54765fad = ({ fieldId: fieldId, fieldLabel: fieldLabel, activePopupKey: activePopupKey, clause: clause, secondaryClause: secondaryClause, onSearchWrapper: onSearchWrapper, onSendOptionAnalytics: onSendOptionAnalytics, onClear: onClear, onOpen: onOpen, onClose: onClose, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    /**
   * fieldLabel comes from field displayName from the hydration data.
   * It is defined in the fragment `jqlEditor_jqlBuilderBasic_JQLEditorUI` in
   * `src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx`
   * we never expect it to be undefined but since we are not using the @required
   * directive in the fragment, this check is required.
   */ const safeFieldLabel = fieldLabel ?? '';
    const numberRangeValue = (0, $eJOHy.useMemo)(()=>(0, $aM67A.mapJqlDataToNumberRangeValue)((0, $aM67A.getJqlDataFromClauses)(clause, secondaryClause)), [
        clause,
        secondaryClause
    ]);
    const triggerValueMessageDescriptor = (0, $eJOHy.useMemo)(()=>(0, $aM67A.getTriggerValueMessageDescriptor)(numberRangeValue), [
        numberRangeValue
    ]);
    const isOpen = activePopupKey === fieldId;
    const handleOnChange = (0, $eJOHy.useCallback)((newValue)=>{
        onSearchWrapper && onSearchWrapper((0, $q3XlS.default)(fieldId, ast, (0, $aM67A.mapNumberRangeValueToJqlData)(newValue)));
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            hasMinValue: newValue.min.length > 0,
            hasMaxValue: newValue.max.length > 0
        });
    }, [
        ast,
        fieldId,
        onClose,
        onSearchWrapper,
        onSendOptionAnalytics
    ]);
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const onTriggerClear = (0, $eJOHy.useCallback)(()=>onClear(clause ? (0, $q3XlS.default)(fieldId, ast, undefined) : undefined), [
        ast,
        clause,
        fieldId,
        onClear
    ]);
    const triggerRenderer = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
            ...triggerProps,
            isInvalid: false,
            isSelected: isOpen,
            isLoading: false,
            hasValues: !(0, $aM67A.isNumberRangeValueEmpty)(numberRangeValue),
            onClear: onTriggerClear,
            onClick: onTriggerClick,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.picker-trigger",
            fieldDescription: fieldDescription,
            isIrremovable: isIrremovable
        }, triggerValueMessageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
            as: "span",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
            as: "strong",
            color: "inherit"
        }, safeFieldLabel, ":\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $d17dc1ea6d66e4bc$var$valueContainerStyles,
            as: "span"
        }, formatMessage(triggerValueMessageDescriptor, numberRangeValue))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
            as: "span"
        }, safeFieldLabel)), [
        isOpen,
        numberRangeValue,
        onTriggerClear,
        onTriggerClick,
        fieldDescription,
        isIrremovable,
        triggerValueMessageDescriptor,
        safeFieldLabel,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jhLWN.NumberRangePickerPopup), {
        isOpen: isOpen,
        onClose: onClose,
        onChange: handleOnChange,
        value: numberRangeValue,
        renderTrigger: triggerRenderer
    });
};
const $d17dc1ea6d66e4bc$var$valueContainerStyles = (0, $5Wv5g.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
});

});
parcelRegister("jhLWN", function(module, exports) {

$parcel$export(module.exports, "NumberRangePickerPopup", () => $6343d6e76713afc8$export$7e88ff560d51764b);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $lx8oo = parcelRequire("lx8oo");

var $i9p2T = parcelRequire("i9p2T");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $eKx5I = parcelRequire("eKx5I");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $cNe2t = parcelRequire("cNe2t");


var $gB01j = parcelRequire("gB01j");

var $aM67A = parcelRequire("aM67A");
const $6343d6e76713afc8$export$7e88ff560d51764b = ({ isOpen: isOpen, onClose: onClose, renderTrigger: renderTrigger, value: value, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [unsubmittedValue, setUnsubmittedValue] = (0, $eJOHy.useState)(value);
    const [errorStateMessages, setErrorStateMessages] = (0, $eJOHy.useState)(()=>(0, $aM67A.getNumberRangePickerErrorMessages)(value));
    const hasError = (0, $eJOHy.useMemo)(()=>(0, $aM67A.hasNumberRangeValueError)(errorStateMessages), [
        errorStateMessages
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((index)=>({ currentTarget: { value: targetValue } })=>{
            const newUnsubmittedValue = {
                ...unsubmittedValue,
                [index]: targetValue
            };
            setUnsubmittedValue(newUnsubmittedValue);
            setErrorStateMessages((0, $aM67A.getNumberRangePickerErrorMessages)(newUnsubmittedValue, index));
        }, [
        unsubmittedValue
    ]);
    const handleOnSubmit = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        onChange(unsubmittedValue);
    }, [
        onChange,
        unsubmittedValue
    ]);
    const showErrorMessage = (0, $eJOHy.useCallback)((messageDescriptor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $6343d6e76713afc8$var$errorMessageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, messageDescriptor === (0, $gB01j.default).numberSizeLimitErrorMessage ? formatMessage(messageDescriptor, {
            maxSize: (0, $c6374ddcf66d0147$export$3aefefab9ae0beef).toLocaleString()
        }) : formatMessage(messageDescriptor))), [
        formatMessage
    ]);
    const renderContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $6343d6e76713afc8$var$textFieldGroupContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $6343d6e76713afc8$var$clauseDropdownContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lx8oo.Label), {
            htmlFor: "lower-clause-number-range-field"
        }, formatMessage((0, $gB01j.default).minimumClauseLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            ref: setInitialFocusRef,
            id: "lower-clause-number-range-field",
            onChange: handleOnChange('min'),
            value: unsubmittedValue.min,
            placeholder: formatMessage((0, $gB01j.default).numberRangePlaceholderMessage),
            isInvalid: hasError && errorStateMessages.min !== undefined,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.lower-clause-text-field"
        }), hasError && errorStateMessages.min !== undefined && showErrorMessage(errorStateMessages.min)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $6343d6e76713afc8$var$clauseDropdownContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lx8oo.Label), {
            htmlFor: "upper-clause-number-range-field"
        }, formatMessage((0, $gB01j.default).maximumClauseLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
            id: "upper-clause-number-range-field",
            onChange: handleOnChange('max'),
            value: unsubmittedValue.max,
            placeholder: formatMessage((0, $gB01j.default).numberRangePlaceholderMessage),
            isInvalid: hasError && errorStateMessages.max !== undefined,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.upper-clause-text-field"
        }), hasError && errorStateMessages.max !== undefined && showErrorMessage(errorStateMessages.max))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $6343d6e76713afc8$var$buttonContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
            appearance: "primary",
            onClick: handleOnSubmit,
            type: "submit",
            isDisabled: hasError,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.update-button"
        }, formatMessage((0, $gB01j.default).updateButtonText)))), [
        errorStateMessages,
        formatMessage,
        handleOnChange,
        handleOnSubmit,
        hasError,
        showErrorMessage,
        unsubmittedValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: renderContent,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.popup",
        messageType: "transactional",
        trigger: renderTrigger
    });
};
const $6343d6e76713afc8$var$textFieldGroupContainerStyles = (0, $5Wv5g.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $6343d6e76713afc8$var$clauseDropdownContainerStyles = (0, $5Wv5g.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $6343d6e76713afc8$var$buttonContainerStyles = (0, $5Wv5g.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width.0',
    borderTopWidth: 'border.width',
    paddingInline: 'space.150',
    paddingBlock: 'space.075'
});
const $6343d6e76713afc8$var$errorMessageContainerStyles = (0, $5Wv5g.xcss)({
    margin: 'space.050'
});

});
const $c6374ddcf66d0147$export$3aefefab9ae0beef = 100000000000000;

parcelRegister("gB01j", function(module, exports) {

$parcel$export(module.exports, "default", () => $8286dc3ca17b5e18$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8286dc3ca17b5e18$var$messages = (0, $7qGN1.defineMessages)({
    numberRangePlaceholderMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-placeholder-message",
        "defaultMessage": "Enter a number"
    },
    minimumClauseLabel: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.minimum-clause-label",
        "defaultMessage": "Minimum"
    },
    maximumClauseLabel: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.maximum-clause-label",
        "defaultMessage": "Maximum"
    },
    triggerValueBothClauses: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-both-clauses",
        "defaultMessage": "From {min} to {max}"
    },
    triggerValueMinimumClause: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-minimum-clause",
        "defaultMessage": "From {min}"
    },
    triggerValueMaximumClause: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-maximum-clause",
        "defaultMessage": "Up to {max}"
    },
    validNumberErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.valid-number-error-message",
        "defaultMessage": "Please enter a valid number"
    },
    numberSizeLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-size-limit-error-message",
        "defaultMessage": "Specify a number for the custom field (below {maxSize})"
    },
    numberRangeErrorMinimumClauseMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-error-minimum-clause-message",
        "defaultMessage": "The minimum must be less than the maximum"
    },
    numberRangeErrorMaximumClauseMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-error-maximum-clause-message",
        "defaultMessage": "The maximum must be greater than the minimum"
    },
    updateButtonText: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.update-button-text",
        "defaultMessage": "Update"
    }
});
var $8286dc3ca17b5e18$export$2e2bcd8739ae039 = $8286dc3ca17b5e18$var$messages;

});

parcelRegister("aM67A", function(module, exports) {

$parcel$export(module.exports, "isNumberRangeValueEmpty", () => $fb9b4692cb347d63$export$edfac072ec483f79);
$parcel$export(module.exports, "hasNumberRangeValueError", () => $fb9b4692cb347d63$export$dacc285ab5e4c500);
$parcel$export(module.exports, "getJqlDataFromClauses", () => $fb9b4692cb347d63$export$6e2488cf7796259d);
$parcel$export(module.exports, "mapJqlDataToNumberRangeValue", () => $fb9b4692cb347d63$export$37604c455ea22dda);
$parcel$export(module.exports, "mapNumberRangeValueToJqlData", () => $fb9b4692cb347d63$export$d2843f73b1f2a602);
$parcel$export(module.exports, "getTriggerValueMessageDescriptor", () => $fb9b4692cb347d63$export$9454d66b829ec1fe);
$parcel$export(module.exports, "getNumberRangePickerErrorMessages", () => $fb9b4692cb347d63$export$d22fc14cae6c7a09);

var $fQnJZ = parcelRequire("fQnJZ");

var $lNgEH = parcelRequire("lNgEH");

var $19xe7 = parcelRequire("19xe7");

var $92k5z = parcelRequire("92k5z");

var $gB01j = parcelRequire("gB01j");
const $fb9b4692cb347d63$export$edfac072ec483f79 = (numberRangeValue)=>numberRangeValue.min === '' && numberRangeValue.max === '';
const $fb9b4692cb347d63$export$dacc285ab5e4c500 = (errorStateMessages)=>errorStateMessages.min !== undefined || errorStateMessages.max !== undefined;
const $fb9b4692cb347d63$export$6e2488cf7796259d = (primaryClause, secondaryClause)=>({
        ...primaryClause !== undefined && primaryClause.operator && primaryClause.operand && primaryClause.operand.operandType === (0, $f38290926d0398e2$export$38accfc5a5d1c113) && {
            primaryClause: {
                operator: primaryClause.operator.value,
                operand: (0, $92k5z.removeSurroundingQuotes)(primaryClause.operand.text)
            }
        },
        ...secondaryClause !== undefined && secondaryClause.operator && secondaryClause.operand && secondaryClause.operand.operandType === (0, $f38290926d0398e2$export$38accfc5a5d1c113) && {
            secondaryClause: {
                operator: secondaryClause.operator.value,
                operand: (0, $92k5z.removeSurroundingQuotes)(secondaryClause.operand.text)
            }
        }
    });
const $fb9b4692cb347d63$export$37604c455ea22dda = (jqlData)=>{
    const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
    const numberRangeValue = {
        min: '',
        max: ''
    };
    [
        primaryClause,
        secondaryClause
    ].forEach((clause)=>{
        switch(clause?.operator){
            case 0, $lNgEH.OPERATOR_GT_EQUALS:
                numberRangeValue.min = clause.operand;
                break;
            case 0, $lNgEH.OPERATOR_LT_EQUALS:
                numberRangeValue.max = clause.operand;
                break;
            default:
                break;
        }
    });
    return numberRangeValue;
};
const $fb9b4692cb347d63$export$d2843f73b1f2a602 = (numberRangeValue)=>({
        ...numberRangeValue.min !== '' && {
            primaryClause: {
                operator: (0, $lNgEH.OPERATOR_GT_EQUALS),
                operand: numberRangeValue.min
            }
        },
        ...numberRangeValue.max !== '' && {
            secondaryClause: {
                operator: (0, $lNgEH.OPERATOR_LT_EQUALS),
                operand: numberRangeValue.max
            }
        }
    });
const $fb9b4692cb347d63$export$9454d66b829ec1fe = (numberRangeValue)=>{
    const { min: min, max: max } = numberRangeValue;
    if (min !== '' && max !== '') return (0, $gB01j.default).triggerValueBothClauses;
    if (min !== '') return (0, $gB01j.default).triggerValueMinimumClause;
    if (max !== '') return (0, $gB01j.default).triggerValueMaximumClause;
};
const $fb9b4692cb347d63$export$e51ed4980accfbd3 = (inputValue, focusedIndex)=>{
    if (inputValue.min !== '' && inputValue.max !== '') {
        if (focusedIndex === 'min' && (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue.min) > (inputValue.max !== '' ? (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue.max) : Number.POSITIVE_INFINITY)) return true;
        if (focusedIndex === 'max' && (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue.max) < (inputValue.min !== '' ? (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue.min) : Number.NEGATIVE_INFINITY)) return true;
    }
    return false;
};
const $fb9b4692cb347d63$export$d22fc14cae6c7a09 = (inputValue, // default is used here to account for initial state, where focusedIndex is not provided
focusedIndex = 'max')=>{
    const errorMessages = {};
    if ($fb9b4692cb347d63$export$edfac072ec483f79(inputValue)) return errorMessages;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const index of [
        'min',
        'max'
    ]){
        if (focusedIndex === index && $fb9b4692cb347d63$export$e51ed4980accfbd3(inputValue, index)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = focusedIndex === 'min' ? (0, $gB01j.default).numberRangeErrorMinimumClauseMessage : (0, $gB01j.default).numberRangeErrorMaximumClauseMessage;
        if ((0, $19xe7.isUnsubmittedValueNotANumber)(inputValue[index])) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = (0, $gB01j.default).validNumberErrorMessage;
        // this assumes that value is a valid number
        if ((0, $19xe7.isUnsubmittedNumberTooLarge)((0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue[index]))) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = (0, $gB01j.default).numberSizeLimitErrorMessage;
    }
    return errorMessages;
};

});
parcelRegister("19xe7", function(module, exports) {

$parcel$export(module.exports, "isUnsubmittedValueNotANumber", () => $fa9ed8cbfdb15b73$export$dc9f326e882569dd);
$parcel$export(module.exports, "isUnsubmittedNumberTooLarge", () => $fa9ed8cbfdb15b73$export$8716b9bb318bd57c);

var $fQnJZ = parcelRequire("fQnJZ");

const $fa9ed8cbfdb15b73$export$4e785eb5f6d441 = (value)=>/^-?(\d+(\.\d*)?|\.\d+)$|^$/.test(`${value}`);
const $fa9ed8cbfdb15b73$export$dc9f326e882569dd = (unsubmittedValue)=>!$fa9ed8cbfdb15b73$export$4e785eb5f6d441(unsubmittedValue);
const $fa9ed8cbfdb15b73$export$8716b9bb318bd57c = (unsubmittedValue)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(unsubmittedValue) > (0, $c6374ddcf66d0147$export$3aefefab9ae0beef);

});




parcelRegister("6CLhR", function(module, exports) {

$parcel$export(module.exports, "PickerWrapper", () => $328d245f9692afd1$export$9d776b739e5a282a);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $3Zpjn = parcelRequire("3Zpjn");

var $gMbEk = parcelRequire("gMbEk");

var $boEdP = parcelRequire("boEdP");

var $lvKO5 = parcelRequire("lvKO5");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $eqSys = parcelRequire("eqSys");

var $lyPdT = parcelRequire("lyPdT");

var $bPVeA = parcelRequire("bPVeA");

var $cPX6Y = parcelRequire("cPX6Y");

var $8i1DT = parcelRequire("8i1DT");

var $2lSRS = parcelRequire("2lSRS");

var $5atdb = parcelRequire("5atdb");

var $l2et3 = parcelRequire("l2et3");

var $8Hwfj = parcelRequire("8Hwfj");
const $328d245f9692afd1$export$9d776b739e5a282a = ({ fieldId: fieldId, fieldLabel: fieldDisplayName, terminalClause: terminalClause, activePopupKey: activePopupKey, onOpen: onOpen, onClose: onClose, onSearchWrapper: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSearchWrapper = ()=>{}, onSendOptionAnalytics: onSendOptionAnalytics, hydratedData: hydratedData, loading: isLoading, onClear: onClear, picker: picker, projectOptions: projectOptions, isMulti: isMulti, fieldDescription: fieldDescription, onOpenOperatorPicker: onOpenOperatorPicker, hideOperatorDropdown: hideOperatorDropdown, isIrremovable: isIrremovable, contextJql: contextJql, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const refinementInvalidProjectOptionMessageGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8i1DT.default).refinementInvalidProjectOptionMessageGalaxia : (0, $8i1DT.default).refinementInvalidProjectOptionMessage;
    const refinementInvalidOptionMessageGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8i1DT.default).refinementInvalidOptionMessageGalaxia : (0, $8i1DT.default).refinementInvalidOptionMessage;
    const isOpen = activePopupKey === fieldId;
    const isEmpty = !terminalClause;
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const { searchTemplate: searchTemplate } = picker;
    // FIXME: getPickerProps creates "unstable" results so we've wrapped it in a memo;
    // a better solution might be to make it a hook so we can be more granular on each individual callback etc
    const { loadOptions: loadOptionsCallback, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList } = (0, $fAZgY.useMemoWithCondition)(()=>(0, $5atdb.getPickerProps)({
            fieldId: fieldId,
            propType: picker.propType || (0, $eqSys.GenericPropTypes).NoProp,
            searchTemplate: searchTemplate,
            jql: contextJql,
            formatMessage: intl.formatMessage,
            environment: environment,
            cloudId: cloudId,
            projectOptions: projectOptions,
            viewContext: viewContext,
            scope: scope,
            suggestedUsersCount: suggestedUsersCount
        }), [
        cloudId,
        contextJql,
        environment,
        fieldId,
        intl.formatMessage,
        picker.propType,
        projectOptions,
        scope,
        searchTemplate,
        suggestedUsersCount,
        viewContext
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const loadOptions = (0, $eJOHy.useCallback)((0, $3Zpjn.createGenericDebouncableDataLoader)(loadOptionsCallback), [
        loadOptionsCallback
    ]);
    const [selectedValues, setSelectedValues] = (0, $8Hwfj.useSelectedValues)(terminalClause, hydratedData, fieldId, operandDisplayValues, searchTemplate);
    const { selectedOperator: selectedOperator, setSelectedOperator: setSelectedOperator, allowedOperators: allowedOperators, setDefaultOperator: setDefaultOperator } = (0, $l2et3.useSelectedOperator)({
        fieldDisplayName: fieldDisplayName ?? fieldId,
        terminalClause: terminalClause,
        allowedOperators: picker.allowedOperators
    });
    const onChangeOperator = (0, $eJOHy.useCallback)((operator)=>{
        if (!hideOperatorDropdown && operator !== null && operator.value !== selectedOperator?.value) {
            setSelectedOperator && setSelectedOperator(operator);
            if (terminalClause) onSearchWrapper((0, $bPVeA.changeOperator)(ast, terminalClause, operator.value));
        }
    }, [
        hideOperatorDropdown,
        selectedOperator?.value,
        setSelectedOperator,
        terminalClause,
        onSearchWrapper,
        ast
    ]);
    const isInvalid = (0, $eJOHy.useMemo)(()=>!isEmpty && selectedValues.length > 0 && selectedValues.some((selectedValue)=>selectedValue.optionType === 'error' || selectedValue.optionType !== 'group' && selectedValue.invalid), [
        selectedValues,
        isEmpty
    ]);
    const onChangeCallback = (0, $eJOHy.useCallback)((optionOrOptions, meta, selectData)=>{
        const options = Array.isArray(optionOrOptions) ? optionOrOptions : [
            optionOrOptions
        ];
        // Optimistically make the UI change, so we don't have to wait for hydration
        setSelectedValues(options);
        onSearchWrapper?.((0, $cPX6Y.updateSelectedValue)({
            ast: ast,
            fieldId: fieldId,
            options: options,
            terminalClause: terminalClause,
            operator: !hideOperatorDropdown ? selectedOperator : undefined
        }));
        if (!Array.isArray(optionOrOptions)) onClose?.();
        if (meta.option && (0, $gMbEk.isSingleValueOption)(meta.option)) onSendOptionAnalytics?.({
            selectedItemsCount: options.length,
            selectedItemIndex: selectData?.selectedIndex,
            selectedItemType: 'option' in meta ? meta.option?.itemType : undefined,
            isFullList: 'option' in meta ? meta.option?.fullList : undefined
        });
    }, [
        setSelectedValues,
        onSearchWrapper,
        ast,
        fieldId,
        terminalClause,
        hideOperatorDropdown,
        selectedOperator,
        onClose,
        onSendOptionAnalytics
    ]);
    const onClearValues = (0, $eJOHy.useCallback)(()=>{
        // Optimistically make the UI change so we don't have to wait for hydration
        setSelectedValues([]);
        terminalClause && onSearchWrapper && onSearchWrapper((0, $boEdP.default)(ast, terminalClause));
        if (!hideOperatorDropdown) setDefaultOperator();
    }, [
        setSelectedValues,
        terminalClause,
        onSearchWrapper,
        ast,
        hideOperatorDropdown,
        setDefaultOperator
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        onClear && onClear(terminalClause ? (0, $boEdP.default)(ast, terminalClause) : undefined);
    }, [
        ast,
        onClear,
        terminalClause
    ]);
    const refinement = fieldDisplayName?.toLowerCase() || fieldId;
    const invalidMessage = refinement === 'project' ? intl.formatMessage(refinementInvalidProjectOptionMessageGalaxia) : intl.formatMessage(refinementInvalidOptionMessageGalaxia, {
        refinement: refinement
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2lSRS.PickerLoader), {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        value: selectedValues,
        isLoading: isLoading,
        fieldId: fieldId,
        searchTemplate: searchTemplate,
        fieldInvalidLabel: isInvalid ? invalidMessage : undefined,
        onChange: onChangeCallback,
        onClearValues: terminalClause ? onClearValues : undefined,
        onLoadOptions: loadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        clause: terminalClause,
        fieldDisplayName: fieldDisplayName,
        isInvalid: isInvalid,
        isEmpty: isEmpty,
        onClearPicker: handleOnClear,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        hideOperatorDropdown: hideOperatorDropdown,
        isMulti: isMulti,
        fieldDescription: fieldDescription,
        onOpenOperatorPicker: onOpenOperatorPicker,
        isIrremovable: isIrremovable
    });
};

});
parcelRegister("bPVeA", function(module, exports) {

$parcel$export(module.exports, "changeOperator", () => $d252c396e97fb247$export$108a5188e4c8d65);

var $2poie = parcelRequire("2poie");
var $3c1PD = parcelRequire("3c1PD");

var $5c1zW = parcelRequire("5c1zW");

var $9dwrV = parcelRequire("9dwrV");
const $d252c396e97fb247$export$108a5188e4c8d65 = (ast, clause, operatorValue)=>{
    let correctOperator = operatorValue;
    if (clause.operand) {
        correctOperator = (0, $9dwrV.resolveOperator)({
            operatorValue: operatorValue,
            isList: (0, $5c1zW.isListOperand)(clause.operand)
        });
        if (clause.operand.operandType === (0, $f38290926d0398e2$export$fabec4aebba3f4df) && clause.operand.values.length === 1) clause.setOperand(clause.operand.values[0]);
    }
    clause.setOperator((0, $2poie.default).operator(correctOperator));
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};

});
parcelRegister("5c1zW", function(module, exports) {

$parcel$export(module.exports, "isListOperand", () => $c835bd750ad04bac$export$1ad46a26ef4c01b7);


var $dTJxm = parcelRequire("dTJxm");
const $c835bd750ad04bac$export$1ad46a26ef4c01b7 = (operand)=>{
    if (operand.operandType === (0, $f38290926d0398e2$export$fabec4aebba3f4df)) {
        if (operand.values.length === 1) {
            if (operand.values[0].operandType === (0, $f38290926d0398e2$export$19c7c729db381f9d)) return Boolean((0, $dTJxm.OperandValues)[operand.values[0].function.value]?.isList);
            return false;
        }
        return true;
    }
    if (operand.operandType === (0, $f38290926d0398e2$export$19c7c729db381f9d)) return Boolean((0, $dTJxm.OperandValues)[operand.function.value]?.isList);
    return false;
};

});

parcelRegister("9dwrV", function(module, exports) {

$parcel$export(module.exports, "resolveOperator", () => $30705e25d12db1c7$export$1ba71b2d6ac9610b);

var $lNgEH = parcelRequire("lNgEH");
const $30705e25d12db1c7$export$1ba71b2d6ac9610b = ({ operatorValue: operatorValue, isList: isList })=>{
    switch(operatorValue){
        case 0, $lNgEH.OPERATOR_EQUALS:
        case 0, $lNgEH.OPERATOR_IN:
        case 0, $lNgEH.OPERATOR_IS:
            return isList ? (0, $lNgEH.OPERATOR_IN) : (0, $lNgEH.OPERATOR_EQUALS);
        case 0, $lNgEH.OPERATOR_NOT_EQUALS:
        case 0, $lNgEH.OPERATOR_NOT_IN:
        case 0, $lNgEH.OPERATOR_IS_NOT:
            return isList ? (0, $lNgEH.OPERATOR_NOT_IN) : (0, $lNgEH.OPERATOR_NOT_EQUALS);
        case 0, $lNgEH.OPERATOR_WAS_NOT_IN:
        case 0, $lNgEH.OPERATOR_WAS_NOT:
            return isList ? (0, $lNgEH.OPERATOR_WAS_NOT_IN) : (0, $lNgEH.OPERATOR_WAS_NOT);
        case 0, $lNgEH.OPERATOR_WAS:
        case 0, $lNgEH.OPERATOR_WAS_IN:
            return isList ? (0, $lNgEH.OPERATOR_WAS_IN) : (0, $lNgEH.OPERATOR_WAS);
        default:
            return operatorValue;
    }
};

});


parcelRegister("cPX6Y", function(module, exports) {

$parcel$export(module.exports, "updateSelectedValue", () => $c87c020709ebcbec$export$e4207420b53e5463);

var $2poie = parcelRequire("2poie");
var $lNgEH = parcelRequire("lNgEH");
var $3c1PD = parcelRequire("3c1PD");

var $7jTnu = parcelRequire("7jTnu");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $9dwrV = parcelRequire("9dwrV");
const $c87c020709ebcbec$var$parseFunction = (func)=>{
    const [, functionName, args] = func.match(/(\w+)\((.*)\)/) ?? [];
    return functionName ? {
        functionName: functionName,
        arguments: args.split(',').map((arg)=>(0, $2poie.default).byText.argument(arg.trim()))
    } : {
        functionName: func,
        arguments: []
    };
};
const $c87c020709ebcbec$var$getOperandValue = (option)=>{
    switch(option.itemType){
        case 0, $f38290926d0398e2$export$19c7c729db381f9d:
            {
                const parsedFunctionText = $c87c020709ebcbec$var$parseFunction(option.value);
                return (0, $2poie.default).functionOperand((0, $2poie.default).functionString(parsedFunctionText.functionName), parsedFunctionText.arguments);
            }
        case 0, $f38290926d0398e2$export$f6049126fd97001f:
            return (0, $2poie.default).keywordOperand();
        default:
            return (0, $2poie.default).byText.valueOperand(option.value);
    }
};
const $c87c020709ebcbec$var$getOperandValues = (options)=>{
    const operandValues = options.map((option)=>$c87c020709ebcbec$var$getOperandValue(option));
    return operandValues;
};
const $c87c020709ebcbec$var$isListOperator = (options)=>{
    if (options.length === 1) {
        const [option] = options;
        const keyword = Object.values((0, $dTJxm.OperandValues)).find((kw)=>kw.value === option.value || kw.hasArgs && option.value.startsWith(kw.value));
        return Boolean(keyword?.isList);
    }
    return true;
};
const $c87c020709ebcbec$var$createTerminalClause = ({ fieldId: fieldId, options: options, terminalClause: terminalClause, operator: operator = terminalClause?.operator || (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS)) })=>(0, $2poie.default).terminalClause((0, $2poie.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $2poie.default).operator((0, $9dwrV.resolveOperator)({
        operatorValue: operator.value,
        isList: $c87c020709ebcbec$var$isListOperator(options)
    })), options.length > 1 ? (0, $2poie.default).listOperand($c87c020709ebcbec$var$getOperandValues(options)) : $c87c020709ebcbec$var$getOperandValue(options[0]));
const $c87c020709ebcbec$var$isNumericWithLeadingZero = (jqlTerm)=>!Number.isNaN(Number(jqlTerm)) && jqlTerm.startsWith('0');
const $c87c020709ebcbec$export$4f30f4cb9fdd9675 = (option)=>{
    const jqlTerm = option.value;
    if ($c87c020709ebcbec$var$isNumericWithLeadingZero(jqlTerm)) return {
        ...option,
        value: `"${jqlTerm}"`
    };
    return option;
};
const $c87c020709ebcbec$export$e4207420b53e5463 = ({ ast: ast, fieldId: fieldId, options: options, terminalClause: terminalClause, operator: operator })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const filteredOptionsWithValue = options.filter((option)=>'value' in option);
    const filteredOptions = (0, $7jTnu.fg)('jql_basic_picker_fix_numeric_field_values') ? filteredOptionsWithValue.map((option)=>$c87c020709ebcbec$export$4f30f4cb9fdd9675(option)) : filteredOptionsWithValue;
    if (!terminalClause && filteredOptions.length) {
        const newClause = $c87c020709ebcbec$var$createTerminalClause({
            fieldId: fieldId,
            options: filteredOptions,
            terminalClause: terminalClause,
            operator: operator
        });
        ast.query?.appendClause(newClause, (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
    }
    if (terminalClause && !filteredOptions.length) terminalClause.remove();
    else terminalClause?.replace($c87c020709ebcbec$var$createTerminalClause({
        fieldId: fieldId,
        options: filteredOptions,
        terminalClause: terminalClause,
        operator: operator
    }));
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("8i1DT", function(module, exports) {

$parcel$export(module.exports, "default", () => $17ee9a952bde9a16$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $17ee9a952bde9a16$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementInvalidOptionMessage: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-option-message",
        "defaultMessage": "Your project and {refinement} selection is invalid."
    },
    refinementInvalidProjectOptionMessage: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-project-option-message",
        "defaultMessage": "Your project selection is invalid."
    },
    refinementInvalidOptionMessageGalaxia: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-option-message-galaxia",
        "defaultMessage": "Your space and {refinement} selection is invalid."
    },
    refinementInvalidProjectOptionMessageGalaxia: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-project-option-message-galaxia",
        "defaultMessage": "Your space selection is invalid."
    }
});

});

parcelRegister("2lSRS", function(module, exports) {

$parcel$export(module.exports, "PickerLoader", () => $93f4c0f3074b28dc$export$4b415d703a601d69);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $jd93d = parcelRequire("jd93d");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $ixh2S = parcelRequire("ixh2S");

var $jx3Cw = parcelRequire("jx3Cw");

var $1xd19 = parcelRequire("1xd19");

var $kkE8T = parcelRequire("kkE8T");

var $6yIId = parcelRequire("6yIId");

var $4qpfH = parcelRequire("4qpfH");

const $93f4c0f3074b28dc$export$f5aa183e0b797cbf = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("eurzt")), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic-picker/src/index.tsx"
});
const $93f4c0f3074b28dc$var$isKeyboardEvent = (event)=>Object.hasOwn(event, 'key');
const $93f4c0f3074b28dc$var$TriggerButtonWrapper = ({ children: children, popupRef: popupRef, triggerRef: triggerRef, ...props })=>{
    const ref = (0, $jd93d.default)(popupRef, triggerRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
        ref: ref,
        ...props
    }, children);
};
const $93f4c0f3074b28dc$export$4b415d703a601d69 = ({ clause: clause, fieldId: fieldId, fieldDisplayName: fieldDisplayName, isLoading: isLoading, isOpen: isOpen, onOpen: onOpen, onClose: onClose, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, onClearValues: onClearValues, onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, isInvalid: isInvalid, isEmpty: isEmpty, onClearPicker: onClearPicker, value: value, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchTemplate: searchTemplate, fieldDescription: fieldDescription, onOpenOperatorPicker: onOpenOperatorPicker, hideOperatorDropdown: hideOperatorDropdown, isIrremovable: isIrremovable })=>{
    const buttonRef = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onTrigger = (0, $eJOHy.useCallback)(({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($93f4c0f3074b28dc$var$TriggerButtonWrapper, {
            isInvalid: isInvalid,
            isSelected: isOpen,
            hasValues: !isEmpty,
            onClick: (event)=>{
                isOpen ? onClose(event) : onOpen();
            },
            onClear: onClearPicker,
            popupRef: ref,
            triggerRef: buttonRef,
            testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
            fieldDescription: fieldDescription,
            /**
   * We need to show loading state when:
   * 1) clause is defined (values are selected) and
   * 2) we are waiting for hydrtation to finish (isLoading === true)
   * 3) Picker is closed
   * 4) There are no hydrated values (new or old) for current clause
   */ isLoading: clause && isLoading && !isOpen && value.length === 0,
            searchTemplate: searchTemplate,
            isIrremovable: isIrremovable
        }, !hideOperatorDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6yIId.default), {
            label: fieldDisplayName,
            value: value,
            isInvalid: isInvalid,
            onChangeOperator: onChangeOperator,
            selectedOperator: selectedOperator,
            allowedOperators: allowedOperators,
            isParentPickerOpen: isOpen,
            onOpenOperatorPicker: onOpenOperatorPicker,
            ...(0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') && {
                isSelected: isOpen
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkE8T.TriggerComponentNoOperator), {
            label: fieldDisplayName,
            value: value,
            isInvalid: isInvalid,
            ...(0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') && {
                isSelected: isOpen
            }
        })), [
        isInvalid,
        isOpen,
        isEmpty,
        fieldId,
        onClearPicker,
        fieldDescription,
        clause,
        isLoading,
        value,
        searchTemplate,
        isIrremovable,
        hideOperatorDropdown,
        allowedOperators,
        onOpenOperatorPicker,
        fieldDisplayName,
        onChangeOperator,
        selectedOperator,
        onClose,
        onOpen
    ]);
    const experienceAnalyticsAttributes = (0, $eJOHy.useMemo)(()=>searchTemplate ? {
            searchTemplate: searchTemplate
        } : {}, [
        searchTemplate
    ]);
    const loadingMessage = (0, $eJOHy.useMemo)(()=>{
        return fieldDisplayName && (0, $7jTnu.fg)('jql_basic_picker_infinite_scroll_loading_fix') ? {
            paginationStart: formatMessage((0, $4qpfH.default).loadingMessageStart, {
                fieldName: fieldDisplayName
            }),
            paginationEnd: formatMessage((0, $4qpfH.default).loadingMessageEnd, {
                fieldName: fieldDisplayName
            })
        } : undefined;
    }, [
        formatMessage,
        fieldDisplayName
    ]);
    const handleClose = (0, $eJOHy.useCallback)((event)=>{
        onClose(event);
        if ($93f4c0f3074b28dc$var$isKeyboardEvent(event) && event.key === 'Escape') buttonRef.current?.focus();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $7jTnu.fg)('render_jql_builder_in_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: fieldId,
        searchInputPlaceholder: formatMessage((0, $4qpfH.default).searchPlaceholder, {
            fieldName: fieldDisplayName
        }),
        invalidLabel: fieldInvalidLabel,
        onChange: onChange,
        onClearValues: onClearValues,
        onLoadOptions: onLoadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        onTrigger: onTrigger,
        shouldRenderToParent: true,
        showOperatorSelect: !hideOperatorDropdown,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        isMulti: isMulti,
        experienceAnalyticsAttributes: experienceAnalyticsAttributes,
        loadingMessages: loadingMessage
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "picker-loader-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jx3Cw.default), {
            clause: clause,
            fieldId: fieldId,
            fieldDisplayName: fieldDisplayName,
            fieldDescription: fieldDescription,
            isIrremovable: isIrremovable
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($93f4c0f3074b28dc$export$f5aa183e0b797cbf, {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: fieldId,
        searchInputPlaceholder: formatMessage((0, $4qpfH.default).searchPlaceholder, {
            fieldName: fieldDisplayName
        }),
        invalidLabel: fieldInvalidLabel,
        onChange: onChange,
        onClearValues: onClearValues,
        onLoadOptions: onLoadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        onTrigger: onTrigger,
        shouldRenderToParent: true,
        showOperatorSelect: !hideOperatorDropdown,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        isMulti: isMulti,
        experienceAnalyticsAttributes: experienceAnalyticsAttributes,
        loadingMessages: loadingMessage
    })));
};
var $93f4c0f3074b28dc$export$2e2bcd8739ae039 = $93f4c0f3074b28dc$export$4b415d703a601d69;

});
parcelRegister("6yIId", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf2b299f58666df$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eE9zS = parcelRequire("eE9zS");

var $bxHeV = parcelRequire("bxHeV");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $dPMMf = parcelRequire("dPMMf");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");


var $a7CU0 = parcelRequire("a7CU0");
const $bcf2b299f58666df$var$hasValue = (value)=>Array.isArray(value) ? value.length > 0 : typeof value === 'object' && value !== null;
const $bcf2b299f58666df$var$TriggerComponent = ({ isInvalid: isInvalid = false, label: label = '', value: value, allowedOperators: allowedOperators, onChangeOperator: onChangeOperator, selectedOperator: selectedOperator, isParentPickerOpen: isParentPickerOpen, onOpenOperatorPicker: onOpenOperatorPicker, isSelected: isSelected })=>{
    if (!value || !$bcf2b299f58666df$var$hasValue(value)) return (0, $6XJko.isVisualRefreshEnabled)() && (0, $7jTnu.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $bcf2b299f58666df$var$triggerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $bcf2b299f58666df$var$triggerStyles,
        testId: (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        weight: "medium",
        color: !isSelected ? 'color.text.subtle' : 'inherit'
    }, label))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$LabelContainer, {
        "data-testid": (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, label));
    const valueMap = value.map((v)=>v.optionType !== 'error' && v.label !== undefined ? v.label : '');
    const valueLength = valueMap.length;
    const [firstValue, ...rest] = valueMap;
    const badgeAppearance = isInvalid ? 'important' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$Container, {
        "aria-label": `${selectedOperator?.ariaLabel} ${firstValue}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$LabelContainer, {
        "data-testid": (0, $332899bfd23114ba$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$StyledLabel, null, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a7CU0.default), {
        isInvalid: isInvalid,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        onChangeOperator: onChangeOperator,
        isParentPickerOpen: isParentPickerOpen,
        onOpenOperatorPicker: onOpenOperatorPicker
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$ValueContainer, null, firstValue), valueLength > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bcf2b299f58666df$var$StyledBadge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eE9zS.default), {
        testId: (0, $332899bfd23114ba$export$fca2db27fe6c1305),
        appearance: badgeAppearance
    }, `+${rest.length}`)) : null);
};
const $bcf2b299f58666df$var$triggerContainerStyles = (0, $5Wv5g.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $bcf2b299f58666df$var$triggerStyles = (0, $5Wv5g.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${24 * (0, $dPMMf.gridSize)}px`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bcf2b299f58666df$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $bcf2b299f58666df$var$LabelContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _p12fd36x _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $bcf2b299f58666df$var$ValueContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _p12fd36x _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $bcf2b299f58666df$var$StyledLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pmoej _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $bcf2b299f58666df$var$StyledBadge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o _18u01b66",
            __cmplp.className
        ])
    });
});
var $bcf2b299f58666df$export$2e2bcd8739ae039 = $bcf2b299f58666df$var$TriggerComponent;

});
parcelRegister("a7CU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd94239f4d8ef829$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $eJOHy = parcelRequire("eJOHy");

var $adDYm = parcelRequire("adDYm");

var $dhRXV = parcelRequire("dhRXV");

var $j3gIc = parcelRequire("j3gIc");
var $8TCso = parcelRequire("8TCso");

var $dPMMf = parcelRequire("dPMMf");

var $f2JN3 = parcelRequire("f2JN3");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $6XJko = parcelRequire("6XJko");

var $4onsb = parcelRequire("4onsb");
const $bd94239f4d8ef829$var$baseStyle = {
    alignSelf: 'center',
    margin: 0,
    padding: 0
};
const $bd94239f4d8ef829$var$indicatorsContainerStyle = {
    root: "_3lltze3t _1onpze3t _k4bfze3t _1vxpze3t"
};
const $bd94239f4d8ef829$var$getAdditionalStyles = (isInvalid)=>({
        control: (css, props)=>({
                ...css,
                height: `${"var(--ds-space-300, 24px)"}`,
                textAlign: 'left',
                // need to overwrite existing minHeight
                minHeight: 0,
                // substracting 5 so it's never on top of main dropdown
                zIndex: (0, $dPMMf.layers).navigation - 5,
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                ...props.isDisabled ? {
                    backgroundColor: 'none',
                    borderColor: "var(--ds-text-inverse, #FFFFFF)"
                } : {}
            }),
        input: (css)=>({
                ...css,
                ...$bd94239f4d8ef829$var$baseStyle,
                height: 'inherit'
            }),
        singleValue: (css)=>({
                ...css,
                ...$bd94239f4d8ef829$var$baseStyle,
                color: "var(--ds-text-selected, #0C66E4)",
                textAlign: 'left',
                ...isInvalid ? {
                    color: "var(--ds-text-danger, #AE2E24)"
                } : {}
            }),
        valueContainer: (css)=>({
                ...css,
                ...$bd94239f4d8ef829$var$baseStyle,
                // to align horizontally
                height: '100%',
                paddingLeft: `${"var(--ds-space-050, 4px)"}`,
                paddingRight: 0
            }),
        indicatorsContainer: (css)=>({
                ...css,
                ...$bd94239f4d8ef829$var$baseStyle,
                '> div': {
                    padding: '0'
                },
                // to align horizontally
                height: '100%'
            }),
        container: (css)=>({
                ...css,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '20px',
                textAlign: 'left'
            }),
        menu: (css)=>({
                ...css,
                // no space between dropdown and trigger button
                marginTop: 0,
                width: 'fit-content',
                // substracting 4 so it's never on top of main dropdown but if on top of the picker trigger of other operator dropdowns
                zIndex: (0, $dPMMf.layers).navigation - 4
            })
    });
const $bd94239f4d8ef829$var$TEST_ID_DROPDOWN = 'jql-builder-basic.common.ui.picker-trigger.dropdown-operator.dropdown-operator';
const $bd94239f4d8ef829$var$getOptionLabel = (option)=>option.ariaLabel;
const $bd94239f4d8ef829$var$formatOptionLabel = (option)=>option.shortLabel;
const $bd94239f4d8ef829$var$DropdownOperator = ({ allowedOperators: allowedOperators, selectedOperator: selectedOperator = allowedOperators[0], onChangeOperator: onChangeOperator, isParentPickerOpen: isParentPickerOpen, onOpenOperatorPicker: onOpenOperatorPicker, isInvalid: isInvalid })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeOperatorWithAnalytics = (0, $eJOHy.useCallback)((option)=>{
        onChangeOperator && onChangeOperator(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        option && (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            option: option.value,
            selectType: 'inline'
        });
    }, [
        createAnalyticsEvent,
        onChangeOperator
    ]);
    const SingleValue = (0, $eJOHy.useCallback)(({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).SingleValue, props, selectedOperator?.valueLabel), [
        selectedOperator?.valueLabel
    ]);
    const DropdownIndicator = (0, $eJOHy.useCallback)((props)=>{
        let primaryColor = "var(--ds-text-selected, #0C66E4)";
        if (props.isDisabled) primaryColor = "var(--ds-text-inverse, #FFFFFF)";
        else if (isInvalid) primaryColor = "var(--ds-text-danger, #AE2E24)";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd94239f4d8ef829$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($adDYm))), {
            testId: "jql-builder-basic.common.ui.picker-trigger.dropdown-operator.chevron-down-icon",
            label: "",
            color: primaryColor,
            LEGACY_primaryColor: primaryColor,
            size: "small"
        })));
    }, [
        isInvalid
    ]);
    const onMenuOpenAnalytics = (0, $eJOHy.useCallback)(()=>{
        onOpenOperatorPicker();
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            selectType: 'inline'
        });
    }, [
        createAnalyticsEvent,
        onOpenOperatorPicker
    ]);
    const dropdownOperatorComponents = (0, $eJOHy.useMemo)(()=>({
            DropdownIndicator: DropdownIndicator,
            SingleValue: SingleValue,
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3gIc.components).IndicatorsContainer, {
                    ...props,
                    xcss: $bd94239f4d8ef829$var$indicatorsContainerStyle.root
                })
        }), [
        DropdownIndicator,
        SingleValue
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        paddingInlineStart: "space.025",
        paddingInlineEnd: "space.050",
        onClick: (event)=>{
            !isParentPickerOpen && event.stopPropagation();
        },
        role: "presentation",
        onKeyDown: (event)=>{
            // Prevent issue list from capturing arrow up and down keys, prevent closing a modal on escape key
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Escape') event.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCso.default), {
        "aria-label": formatMessage((0, $4onsb.default).operatorLabel),
        testId: $bd94239f4d8ef829$var$TEST_ID_DROPDOWN,
        components: dropdownOperatorComponents,
        spacing: "compact",
        appearance: "subtle",
        styles: $bd94239f4d8ef829$var$getAdditionalStyles(isInvalid),
        value: selectedOperator,
        options: allowedOperators,
        onChange: onChangeOperatorWithAnalytics,
        getOptionLabel: $bd94239f4d8ef829$var$getOptionLabel,
        formatOptionLabel: $bd94239f4d8ef829$var$formatOptionLabel,
        isDisabled: isParentPickerOpen,
        isInvalid: isInvalid,
        isSearchable: false,
        onMenuOpen: onMenuOpenAnalytics
    })));
};
var $bd94239f4d8ef829$export$2e2bcd8739ae039 = $bd94239f4d8ef829$var$DropdownOperator;
const $bd94239f4d8ef829$var$IconContainer = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        paddingInline: "space.075"
    }, children), (0, $eJOHy.Fragment));

});
parcelRegister("4onsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e1e72d7652d30e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f1e1e72d7652d30e$var$messages = (0, $7qGN1.defineMessages)({
    operatorLabel: {
        "id": "jql-builder-basic.common.picker-trigger.dropdown-operator.operator-label",
        "defaultMessage": "Operator dropdown"
    }
});
var $f1e1e72d7652d30e$export$2e2bcd8739ae039 = $f1e1e72d7652d30e$var$messages;

});



parcelRegister("4qpfH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e3ee1393a7b533$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f0e3ee1393a7b533$var$messages = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "jql-builder-basic.picker-loader.search-placeholder",
        "defaultMessage": "Search {fieldName}"
    },
    loadingMessageStart: {
        "id": "jql-builder-basic.picker-loader.loading-message-start",
        "defaultMessage": "{fieldName}: Loading more"
    },
    loadingMessageEnd: {
        "id": "jql-builder-basic.picker-loader.loading-message-end",
        "defaultMessage": "{fieldName}: Finished loading"
    }
});
var $f0e3ee1393a7b533$export$2e2bcd8739ae039 = $f0e3ee1393a7b533$var$messages;

});


parcelRegister("5atdb", function(module, exports) {

$parcel$export(module.exports, "getPickerProps", () => $0a786da442a7a73a$export$3dc4888d75a40889);

var $eqSys = parcelRequire("eqSys");

var $eiIzV = parcelRequire("eiIzV");

var $jZgio = parcelRequire("jZgio");

var $7porm = parcelRequire("7porm");

var $kPoTo = parcelRequire("kPoTo");

var $3q8Sy = parcelRequire("3q8Sy");

var $lVLIX = parcelRequire("lVLIX");

var $3bnsV = parcelRequire("3bnsV");

var $3Tke1 = parcelRequire("3Tke1");
const $0a786da442a7a73a$export$3dc4888d75a40889 = ({ fieldId: fieldId, propType: propType, searchTemplate: searchTemplate, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, projectOptions: projectOptions, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const commonProps = {
        fieldId: fieldId,
        searchTemplate: searchTemplate,
        propType: propType,
        formatMessage: formatMessage,
        jql: jql,
        environment: environment,
        cloudId: cloudId,
        operandDisplayValues: (0, $jZgio.getValidOperandDisplayValues)(propType),
        viewContext: viewContext,
        scope: scope,
        suggestedUsersCount: suggestedUsersCount
    };
    if (!(0, $eiIzV.isPickerPropType)(propType)) throw new Error(`Unsupported PickerPropType: ${propType}`);
    switch(propType){
        case (0, $eqSys.PickerPropTypes).IssueType:
            return (0, $3q8Sy.getIssueTypeProps)(commonProps);
        case (0, $eqSys.PickerPropTypes).User:
            return (0, $lVLIX.getPeopleProps)(commonProps);
        case (0, $eqSys.PickerPropTypes).Sprint:
            return (0, $3Tke1.getSprintProps)(commonProps);
        case (0, $eqSys.PickerPropTypes).Common:
            return (0, $7porm.getCommonProps)(commonProps);
        case (0, $eqSys.PickerPropTypes).CommonWithEmpty:
        case (0, $eqSys.PickerPropTypes).Version:
            return (0, $7porm.getCommonProps)({
                ...commonProps,
                showOperandDisplayValuesInFullList: true
            });
        case (0, $eqSys.PickerPropTypes).Project:
            return (0, $3bnsV.getProjectProps)({
                ...commonProps,
                projectOptions: projectOptions
            });
        case (0, $eqSys.PickerPropTypes).Group:
            return (0, $kPoTo.getGroupProps)(commonProps);
        default:
            throw new Error(`Unsupported PickerPropType: ${propType}`);
    }
};

});
parcelRegister("jZgio", function(module, exports) {

$parcel$export(module.exports, "getValidOperandNames", () => $8327937554fcf4bb$export$1917025b3a772e5);
$parcel$export(module.exports, "getValidOperandDisplayValues", () => $8327937554fcf4bb$export$7b0867b4bdc21cd8);

var $5PQOA = parcelRequire("5PQOA");

var $dTJxm = parcelRequire("dTJxm");

var $eqSys = parcelRequire("eqSys");
const $8327937554fcf4bb$export$1917025b3a772e5 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((propType)=>{
    switch(propType){
        case (0, $eqSys.PickerPropTypes).IssueType:
            return [
                (0, $dTJxm.FunctionName).standardIssueTypes,
                (0, $dTJxm.FunctionName).subTaskIssueTypes
            ];
        case (0, $eqSys.PickerPropTypes).User:
            return [
                (0, $dTJxm.FunctionName).currentUser,
                (0, $dTJxm.KeywordName).empty,
                (0, $dTJxm.FunctionName).membersOf
            ];
        case (0, $eqSys.PickerPropTypes).CommonWithEmpty:
        case (0, $eqSys.PickerPropTypes).Sprint:
            return [
                (0, $dTJxm.KeywordName).empty
            ];
        case (0, $eqSys.PickerPropTypes).Version:
            return [
                (0, $dTJxm.KeywordName).empty,
                (0, $dTJxm.FunctionName).releasedVersions,
                (0, $dTJxm.FunctionName).unreleasedVersions
            ];
        default:
    }
    return undefined;
});
const $8327937554fcf4bb$export$7b0867b4bdc21cd8 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((propType)=>$8327937554fcf4bb$export$1917025b3a772e5(propType)?.map((name)=>(0, $dTJxm.OperandValues)[name].value));

});

parcelRegister("7porm", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $03dac207aa852f1a$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getCommonProps", () => $03dac207aa852f1a$export$fa723cfebd5684f9);

var $iiYNp = parcelRequire("iiYNp");

var $j4oe4 = parcelRequire("j4oe4");


var $7jTnu = parcelRequire("7jTnu");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $cb5xP = parcelRequire("cb5xP");

var $65vFU = parcelRequire("65vFU");

var $jZgio = parcelRequire("jZgio");

var $9fWxr = parcelRequire("9fWxr");
const $03dac207aa852f1a$export$6df0712d20d2cc08 = (node, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm, __typename: __typename } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (__typename === 'JiraJqlPriorityFieldValue' && node.priority && node.priority.iconUrl) return {
        ...option,
        icon: node.priority.iconUrl
    };
    if ((__typename === 'JiraJqlStatusFieldValue' || __typename === 'JiraJqlStatusCategoryFieldValue') && node.statusCategory) {
        const { colorName: colorName } = node.statusCategory;
        return {
            ...option,
            optionType: 'lozenge',
            appearance: (0, $9fWxr.getLozengeAppearance)(colorName),
            isBold: (0, $7jTnu.fg)('jira_jql_builder_bold_status') ? true : undefined
        };
    }
    if (__typename === 'JiraJqlIssueFieldValue' && node.issue && node.issue.fields && node.issue.fields.edges && node.issue.fields.edges[0] && node.issue.fields.edges[0].node && node.issue.fields.edges[0].node.text !== undefined && node.issue.fields.edges[0].node.text !== null) return {
        ...option,
        label: node.issue.fields.edges[0].node.text,
        secondaryLabel: option.label
    };
    return option;
};
const $03dac207aa852f1a$export$fa723cfebd5684f9 = ({ fieldId: fieldId, propType: propType, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: false,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList || undefined,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            const after = endCursor;
            try {
                const data = await (0, $j4oe4.fetchQuery)(environment, (0, $iiYNp.default), {
                    cloudId: cloudId,
                    first: 10,
                    jqlTerm: fieldId.toLowerCase(),
                    jql: jql || '',
                    searchString: search,
                    after: after,
                    viewContext: viewContext
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
                const operandOptions = showOperandDisplayValuesInFullList ? ((0, $jZgio.getValidOperandNames)(propType) ?? []).map((name)=>({
                        label: (0, $dTJxm.OperandValues)[name].type === (0, $f38290926d0398e2$export$f6049126fd97001f) ? (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, formatMessage) : (0, $65vFU.getFunctionLabel)(name, formatMessage),
                        value: (0, $dTJxm.OperandValues)[name].value,
                        optionType: 'option',
                        itemType: (0, $dTJxm.OperandValues)[name].type
                    })) : [];
                if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([
                    ...operandOptions
                ]);
                const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
                return (0, $eiIzV.generateOptions)([
                    ...search.length === 0 && !endCursor ? operandOptions : [],
                    ...fieldValues.reduce((options, edges)=>{
                        if (!edges || !edges.node) return options;
                        const { node: node } = edges;
                        options.push($03dac207aa852f1a$export$6df0712d20d2cc08(node, (0, $f38290926d0398e2$export$38accfc5a5d1c113)));
                        return options;
                    }, [])
                ], totalCount, pageInfo?.endCursor || undefined);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('commonJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("iiYNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5135e7cff34ffb7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95602755025a1134fb7a37aa1d85e952>>
 * @relayHash 8640e63348e5d925f93816e53f6c5b01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e831c84bdd8946040c19eb688135440ba952ad04b564b51cc4edbcd136cd7b02
const $a5135e7cff34ffb7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "colorName"
    }, v15 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v14 /*: any*/ ,
                v18 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "JiraJqlStatusFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v16 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlPriorityFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "JiraJqlStatusCategoryFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fields",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v17 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v19 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v19 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e831c84bdd8946040c19eb688135440ba952ad04b564b51cc4edbcd136cd7b02",
            "metadata": {},
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a5135e7cff34ffb7$var$node.hash = "287a2bf3ddbdda31cd84a0d1afbcfa31";
var $a5135e7cff34ffb7$export$2e2bcd8739ae039 = $a5135e7cff34ffb7$var$node;

});

parcelRegister("cb5xP", function(module, exports) {

$parcel$export(module.exports, "getEmptyLabel", () => $8b37b510820a2509$export$b77f75d3ab7bfc24);

var $dbAgy = parcelRequire("dbAgy");
const $8b37b510820a2509$export$b77f75d3ab7bfc24 = (searchTemplate, formatMessage)=>{
    const message = (0, $dbAgy.messageLookup)[searchTemplate];
    if (message) return formatMessage(message);
    return formatMessage((0, $dbAgy.messages).genericEmpty);
};

});
parcelRegister("dbAgy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $35ea1f857982d6fd$export$defe85febe8b728c);
$parcel$export(module.exports, "messageLookup", () => $35ea1f857982d6fd$export$3a16bd55b6aaaf91);

var $7qGN1 = parcelRequire("7qGN1");

var $dTJxm = parcelRequire("dTJxm");
const $35ea1f857982d6fd$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.ASSIGNEE).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.assignee",
        "defaultMessage": "Unassigned"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.REPORTER).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.reporter-new",
        "defaultMessage": "Anonymous"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.CREATOR).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.creator",
        "defaultMessage": "Anonymous"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.COMPONENT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.components",
        "defaultMessage": "No component"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.PARENT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.parent",
        "defaultMessage": "No parent"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.FIX_VERSION).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.fix-versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.AFFECTED_VERSION).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher': {
        "id": "jql-builder-basic.utils.get-empty-label.custom-versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.EPIC_LINK).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.epic-link-new",
        "defaultMessage": "No epic link"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $dTJxm.SPRINT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.sprint-new",
        "defaultMessage": "No sprint"
    },
    genericEmpty: {
        "id": "jql-builder-basic.utils.get-empty-label.generic-empty",
        "defaultMessage": "Empty"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    'epic link': {
        "id": "jql-builder-basic.utils.get-empty-label.epic-link",
        "defaultMessage": "No epic link"
    },
    sprint: {
        "id": "jql-builder-basic.utils.get-empty-label.sprint",
        "defaultMessage": "No sprint"
    }
});
const $35ea1f857982d6fd$export$3a16bd55b6aaaf91 = $35ea1f857982d6fd$export$defe85febe8b728c;

});


parcelRegister("65vFU", function(module, exports) {

$parcel$export(module.exports, "getFunctionLabel", () => $cd851674220e71c5$export$2d3d5a019b7ffccf);

var $epTsa = parcelRequire("epTsa");

var $jUYSN = parcelRequire("jUYSN");
const $cd851674220e71c5$export$2d3d5a019b7ffccf = (name, formatMessage)=>{
    let messageKey = name.toLowerCase();
    if ((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
        const refreshedMessageKey = `${messageKey}IssueTermRefresh`;
        if (refreshedMessageKey in (0, $jUYSN.default)) messageKey = refreshedMessageKey;
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ subtaskissuetypes: MessageDescriptorV2; standardissuetypes: MessageDescriptorV2; currentuser: MessageDescriptorV2; }'.
    const message = (0, $jUYSN.default)[messageKey];
    if (message) return formatMessage(message);
    return name;
};

});
parcelRegister("jUYSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8432e062247db1af$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8432e062247db1af$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    currentuser: {
        "id": "jql-builder-basic.utils.get-function-label.currentuser",
        "defaultMessage": "Current User"
    },
    standardissuetypes: {
        "id": "jql-builder-basic.utils.get-function-label.standardissuetypes",
        "defaultMessage": "All standard issue types"
    },
    subtaskissuetypes: {
        "id": "jql-builder-basic.utils.get-function-label.subtaskissuetypes",
        "defaultMessage": "All sub-task issue types"
    },
    releasedversions: {
        "id": "jql-builder-basic.utils.get-function-label.releasedversions",
        "defaultMessage": "All Released Versions"
    },
    unreleasedversions: {
        "id": "jql-builder-basic.utils.get-function-label.unreleasedversions",
        "defaultMessage": "All Unreleased Versions"
    },
    standardissuetypesIssueTermRefresh: {
        "id": "jql-builder-basic.utils.get-function-label.standardissuetypes-issue-term-refresh",
        "defaultMessage": "All standard work types"
    },
    subtaskissuetypesIssueTermRefresh: {
        "id": "jql-builder-basic.utils.get-function-label.subtaskissuetypes-issue-term-refresh",
        "defaultMessage": "All sub-tasks"
    }
});

});


parcelRegister("9fWxr", function(module, exports) {

$parcel$export(module.exports, "getLozengeAppearance", () => $172686d3950f7f7a$export$4d9e331cafeacb9d);

var $dTJxm = parcelRequire("dTJxm");
const $172686d3950f7f7a$export$4d9e331cafeacb9d = (colorName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (colorName && Object.keys((0, $dTJxm.appearanceMap)).includes(colorName)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $dTJxm.appearanceMap)[colorName];
    return undefined;
};

});


parcelRegister("kPoTo", function(module, exports) {

$parcel$export(module.exports, "getGroupProps", () => $0aad662277c3e921$export$acaa9db88ea2a755);

var $04t3y = parcelRequire("04t3y");

var $kVjFI = parcelRequire("kVjFI");

var $j4oe4 = parcelRequire("j4oe4");


var $eiIzV = parcelRequire("eiIzV");

var $kldev = parcelRequire("kldev");
const $0aad662277c3e921$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, formatMessage: formatMessage })=>{
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $kVjFI.default), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.suggestedGroups?.edges) return (0, $eiIzV.generateOptions)([]);
    const groups = data?.jira?.jqlBuilder?.suggestedGroups?.edges?.reduce((options, edge)=>{
        if (!edge || !edge.node) return options;
        const { node: node } = edge;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $f38290926d0398e2$export$38accfc5a5d1c113)
        });
        return options;
    }, []) || [];
    const options = [
        {
            label: formatMessage((0, $kldev.default).refinementOptionSuggestedGroups),
            optionType: 'group',
            options: groups
        }
    ];
    return (0, $eiIzV.generateOptions)(options);
};
const $0aad662277c3e921$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $04t3y.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $eiIzV.generateOptions)(fieldValues.reduce((options, edge)=>{
        if (!edge || !edge.node) return options;
        const { node: node } = edge;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $f38290926d0398e2$export$38accfc5a5d1c113)
        });
        return options;
    }, []), totalCount, pageInfo?.endCursor || undefined);
};
const $0aad662277c3e921$export$acaa9db88ea2a755 = ({ fieldId: fieldId, operandDisplayValues: operandDisplayValues, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $0aad662277c3e921$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    formatMessage: formatMessage
                });
                return await $0aad662277c3e921$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('groupJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("04t3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e401f50532df595$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<147dc64cb2bca6b7a230336a320aef2e>>
 * @relayHash 06c4d66e23835ebc572846a0efd865a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4982c6eb0de3a1f0d61be5e83b4457823ceed6631a0abe4509a993a35a9c371
const $1e401f50532df595$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d4982c6eb0de3a1f0d61be5e83b4457823ceed6631a0abe4509a993a35a9c371",
            "metadata": {},
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1e401f50532df595$var$node.hash = "3750697c009021fb29b02b6b38567062";
var $1e401f50532df595$export$2e2bcd8739ae039 = $1e401f50532df595$var$node;

});

parcelRegister("kVjFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $007f48cf194fefb3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2cf28df69801d2e8d4ca1f516b897779>>
 * @relayHash 4242efb1e1867c214b21bde3f239c032
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d6bf7b889b129263d1bfecb23143f0126ab23fbd7882e0ce40044a8c0c3293d
const $007f48cf194fefb3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "context",
                                "value": "GROUP"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                            }
                        ],
                        "concreteType": "JiraJqlGroupFieldValueConnection",
                        "kind": "LinkedField",
                        "name": "suggestedGroups",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraJqlGroupFieldValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraJqlGroupFieldValue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "jqlTerm"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "suggestedGroups(context:\"GROUP\",first:10)"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "groupJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "groupJqlBuilderBasicInitQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "5d6bf7b889b129263d1bfecb23143f0126ab23fbd7882e0ce40044a8c0c3293d",
            "metadata": {},
            "name": "groupJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$007f48cf194fefb3$var$node.hash = "89effe1db6e447cbb0e66d80074d1b0b";
var $007f48cf194fefb3$export$2e2bcd8739ae039 = $007f48cf194fefb3$var$node;

});

parcelRegister("kldev", function(module, exports) {

$parcel$export(module.exports, "default", () => $b677e4b43da380ad$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b677e4b43da380ad$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementOptionSuggestedGroups: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.group.refinement-option-suggested-groups",
        "defaultMessage": "Suggested Groups"
    }
});

});


parcelRegister("3q8Sy", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $582df2399a38b329$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getIssueTypeProps", () => $582df2399a38b329$export$912584a67029924);

var $2Es8K = parcelRequire("2Es8K");

var $eszwa = parcelRequire("eszwa");

var $j4oe4 = parcelRequire("j4oe4");


var $epTsa = parcelRequire("epTsa");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $65vFU = parcelRequire("65vFU");

var $iDtDh = parcelRequire("iDtDh");
const $582df2399a38b329$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>typeof issueType.avatar?.xsmall === 'string' && issueType.avatar.xsmall.length > 0)?.avatar?.xsmall;
const $582df2399a38b329$export$6df0712d20d2cc08 = (node, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (node.issueTypes) return {
        ...option,
        optionType: 'avatar',
        avatar: $582df2399a38b329$var$getFirstIssueTypeAvatar(node),
        square: true,
        itemType: itemType
    };
    return option;
};
const $582df2399a38b329$var$getInitialOptions = async ({ environment: environment, cloudId: cloudId, jql: jql, formatMessage: formatMessage })=>{
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $eszwa.default), {
        cloudId: cloudId,
        jql: jql || ''
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const issueTypes = data?.jira?.jqlBuilder?.issueTypes;
    if (!issueTypes) return (0, $eiIzV.generateOptions)([]);
    const aboveBaseLevelTypes = issueTypes?.aboveBaseLevel?.edges || [];
    const baseLevelTypes = issueTypes?.baseLevel?.edges || [];
    const belowBaseLevelTypes = issueTypes?.belowBaseLevel?.edges || [];
    const standardTypes = aboveBaseLevelTypes.concat(baseLevelTypes).reduce((options, edges)=>{
        if (edges?.node === undefined || edges?.node === null) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($582df2399a38b329$export$6df0712d20d2cc08(node, (0, $f38290926d0398e2$export$38accfc5a5d1c113)));
        return options;
    }, []);
    const subtaskTypes = belowBaseLevelTypes.reduce((options, edges)=>{
        if (edges?.node === undefined || edges?.node === null) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($582df2399a38b329$export$6df0712d20d2cc08(node, (0, $f38290926d0398e2$export$38accfc5a5d1c113)));
        return options;
    }, []);
    const standardGroupOption = [
        {
            label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iDtDh.default).refinementSubtitleStandardIssueTypesIssueTermRefresh : (0, $iDtDh.default).refinementSubtitleStandardIssueTypes),
            optionType: 'group',
            options: standardTypes
        }
    ];
    const subtaskGroupOption = [
        {
            label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iDtDh.default).refinementSubtitleSubTaskIssueTypesIssueTermRefresh : (0, $iDtDh.default).refinementSubtitleSubTaskIssueTypes),
            optionType: 'group',
            options: subtaskTypes
        }
    ];
    return (0, $eiIzV.generateOptions)([
        {
            label: (0, $65vFU.getFunctionLabel)('standardIssueTypes', formatMessage),
            value: (0, $dTJxm.OperandValues).standardIssueTypes.value,
            optionType: 'avatar',
            hideAvatar: true,
            itemType: (0, $f38290926d0398e2$export$19c7c729db381f9d)
        },
        {
            label: (0, $65vFU.getFunctionLabel)('subTaskIssueTypes', formatMessage),
            value: (0, $dTJxm.OperandValues).subTaskIssueTypes.value,
            optionType: 'avatar',
            hideAvatar: true,
            itemType: (0, $f38290926d0398e2$export$19c7c729db381f9d)
        },
        ...Array.isArray(standardTypes) && standardTypes.length > 0 ? standardGroupOption : [],
        ...Array.isArray(subtaskTypes) && subtaskTypes.length > 0 ? subtaskGroupOption : []
    ]);
};
const $582df2399a38b329$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext, scope: scope = null })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $2Es8K.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext,
        scope: scope
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $eiIzV.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($582df2399a38b329$export$6df0712d20d2cc08(node, (0, $f38290926d0398e2$export$38accfc5a5d1c113)));
        return options;
    }, []), totalCount, pageInfo.endCursor || undefined);
};
const $582df2399a38b329$export$912584a67029924 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $582df2399a38b329$var$getInitialOptions({
                    environment: environment,
                    cloudId: cloudId,
                    jql: jql,
                    formatMessage: formatMessage
                });
                return await $582df2399a38b329$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('issueTypeJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("2Es8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ac93a6a393332bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1606061b2f060cdafb07c4ef37cd6363>>
 * @relayHash 30538de95cec3c3cdff68eadc99f2abd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 656a65d09fbea171572af0068266d364b84a8e0e6face2f36475662ed790295c
const $0ac93a6a393332bf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v8 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            v11 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "656a65d09fbea171572af0068266d364b84a8e0e6face2f36475662ed790295c",
            "metadata": {},
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0ac93a6a393332bf$var$node.hash = "8a0afa1c6c431e628b55f9e4f56ffde8";
var $0ac93a6a393332bf$export$2e2bcd8739ae039 = $0ac93a6a393332bf$var$node;

});

parcelRegister("eszwa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf7ecd8b0dad74a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6074d0f3e024b0012bb1972fe1478635>>
 * @relayHash acb29e4100939579dcd3416df9471194
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a787d89ed618a815e9879150e4bc32d1810382544bfced47ff3503e5a3ee9d3
const $ccf7ecd8b0dad74a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = [
        {
            "concreteType": "JiraJqlIssueTypeFieldValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraJqlIssueTypeFieldValue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v9 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        }
    ], v10 = [
        {
            "concreteType": "JiraJqlIssueTypeFieldValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraJqlIssueTypeFieldValue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlIssueTypes",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v3 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "aboveBaseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "aboveBaseLevel(first:2)"
                                            },
                                            {
                                                "args": v8 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "baseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "baseLevel(first:3)"
                                            },
                                            {
                                                "args": v9 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "belowBaseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "belowBaseLevel(first:5)"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlIssueTypes",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "aboveBaseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "aboveBaseLevel(first:2)"
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "baseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "baseLevel(first:3)"
                                        },
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "belowBaseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "belowBaseLevel(first:5)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7a787d89ed618a815e9879150e4bc32d1810382544bfced47ff3503e5a3ee9d3",
            "metadata": {},
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ccf7ecd8b0dad74a$var$node.hash = "b67b86d33998fb54b3dd5cfc1247f7e1";
var $ccf7ecd8b0dad74a$export$2e2bcd8739ae039 = $ccf7ecd8b0dad74a$var$node;

});

parcelRegister("iDtDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e43ded24d27d85bd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e43ded24d27d85bd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementOptionAllStandardIssues: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-standard-issues",
        "defaultMessage": "All standard issue types"
    },
    refinementOptionAllSubTaskIssues: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-sub-task-issues",
        "defaultMessage": "All sub-task issue types"
    },
    refinementSubtitleStandardIssueTypes: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-standard-issue-types",
        "defaultMessage": "Standard issue types"
    },
    refinementSubtitleSubTaskIssueTypes: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-sub-task-issue-types",
        "defaultMessage": "Sub-task issue types"
    },
    refinementOptionAllStandardIssuesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-standard-issues-issue-term-refresh",
        "defaultMessage": "All standard work types"
    },
    refinementOptionAllSubTaskIssuesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-sub-task-issues-issue-term-refresh",
        "defaultMessage": "All sub-tasks"
    },
    refinementSubtitleStandardIssueTypesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-standard-issue-types-issue-term-refresh",
        "defaultMessage": "Standard work types"
    },
    refinementSubtitleSubTaskIssueTypesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-sub-task-issue-types-issue-term-refresh",
        "defaultMessage": "Subtasks"
    }
});

});


parcelRegister("lVLIX", function(module, exports) {

$parcel$export(module.exports, "getPeopleProps", () => $5cf45e06c061731f$export$c4faa1f798289cbf);

var $jI42G = parcelRequire("jI42G");

var $h5ChR = parcelRequire("h5ChR");

var $j4oe4 = parcelRequire("j4oe4");


var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $cb5xP = parcelRequire("cb5xP");

var $65vFU = parcelRequire("65vFU");

var $ilCyB = parcelRequire("ilCyB");
const $5cf45e06c061731f$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, formatMessage: formatMessage, suggestedUsersCount: suggestedUsersCount = 5 })=>{
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $h5ChR.default), {
        cloudId: cloudId,
        suggestedUsersCount: suggestedUsersCount
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.recentlyUsedUsers?.edges) return (0, $eiIzV.generateOptions)([]);
    const users = data?.jira?.jqlBuilder?.recentlyUsedUsers?.edges.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            avatar: node.user?.picture,
            itemType: (0, $f38290926d0398e2$export$38accfc5a5d1c113)
        });
        return options;
    }, []);
    const groups = data?.jira?.jqlBuilder?.suggestedGroups?.edges?.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $f38290926d0398e2$export$19c7c729db381f9d)
        });
        return options;
    }, []) || [];
    const emptyLabel = (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, formatMessage);
    const options = [
        {
            label: (0, $65vFU.getFunctionLabel)('currentUser', formatMessage),
            value: (0, $dTJxm.OperandValues).currentUser.value,
            optionType: 'avatar',
            avatar: data?.me?.user?.picture,
            itemType: (0, $f38290926d0398e2$export$19c7c729db381f9d)
        },
        {
            label: emptyLabel,
            optionType: 'avatar',
            value: (0, $dTJxm.OperandValues).empty.value,
            itemType: (0, $f38290926d0398e2$export$f6049126fd97001f)
        },
        {
            label: formatMessage((0, $ilCyB.default).refinementOptionSuggestedUsers),
            optionType: 'group',
            options: users
        }
    ];
    options.push({
        label: formatMessage((0, $ilCyB.default).refinementOptionSuggestedGroups),
        optionType: 'group',
        options: groups
    });
    return (0, $eiIzV.generateOptions)(options);
};
const $5cf45e06c061731f$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $jI42G.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $eiIzV.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            avatar: node.user?.picture,
            ...node.__typename === 'JiraJqlGroupFieldValue' ? {
                isGroup: true,
                itemType: (0, $f38290926d0398e2$export$19c7c729db381f9d)
            } : {
                itemType: (0, $f38290926d0398e2$export$38accfc5a5d1c113)
            }
        });
        return options;
    }, []), totalCount, pageInfo?.endCursor || undefined);
};
const $5cf45e06c061731f$export$c4faa1f798289cbf = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext, suggestedUsersCount: suggestedUsersCount })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $5cf45e06c061731f$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    formatMessage: formatMessage,
                    suggestedUsersCount: suggestedUsersCount
                });
                return await $5cf45e06c061731f$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('peopleJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("jI42G", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7c303b3c9ecf207$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6967d117ea6f27382f145acf7656350d>>
 * @relayHash 12d33ba0d4f7005558a90b51b7f8972a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9a16b4ab65b19abc2908fd11e6e008e1ae9a5d76096455dab5aea9cc79f7f3fe
const $f7c303b3c9ecf207$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlUserFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9a16b4ab65b19abc2908fd11e6e008e1ae9a5d76096455dab5aea9cc79f7f3fe",
            "metadata": {},
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f7c303b3c9ecf207$var$node.hash = "58da705b88c7cc909a92b46593be279d";
var $f7c303b3c9ecf207$export$2e2bcd8739ae039 = $f7c303b3c9ecf207$var$node;

});

parcelRegister("h5ChR", function(module, exports) {

$parcel$export(module.exports, "default", () => $790ca30b1c43e45b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5b2b2d7f16455667801cc7af16014d7>>
 * @relayHash 60854f32bffe29af2901e4add654f964
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f3dcddb111bd3a875a7fe72854ff370624a9ff146bf6085aa9856c22d9b59710
const $790ca30b1c43e45b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "suggestedUsersCount"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v2 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v1 /*: any*/ 
        ]
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "suggestedUsersCount"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 5
            }
        ],
        "concreteType": "JiraJqlGroupFieldValueConnection",
        "kind": "LinkedField",
        "name": "suggestedGroups",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraJqlGroupFieldValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraJqlGroupFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "suggestedGroups(first:5)"
    }, v8 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "peopleJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v4 /*: any*/ ,
                                        "concreteType": "JiraJqlUserFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedUsers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlUserFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlUserFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            v6 /*: any*/ ,
                                                            v2 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v7 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "peopleJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraJqlUserFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedUsers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlUserFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlUserFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f3dcddb111bd3a875a7fe72854ff370624a9ff146bf6085aa9856c22d9b59710",
            "metadata": {},
            "name": "peopleJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$790ca30b1c43e45b$var$node.hash = "05b44957144740bb12a1e2842916fbf5";
var $790ca30b1c43e45b$export$2e2bcd8739ae039 = $790ca30b1c43e45b$var$node;

});

parcelRegister("ilCyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c5e782f889db04$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e2c5e782f889db04$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementOptionCurrentUser: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-current-user",
        "defaultMessage": "Current User"
    },
    refinementOptionUnassigned: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-unassigned",
        "defaultMessage": "Unassigned"
    },
    refinementOptionSuggestedUsers: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-suggested-users",
        "defaultMessage": "Suggested Users"
    },
    refinementOptionSuggestedGroups: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-suggested-groups",
        "defaultMessage": "Suggested Groups"
    }
});

});


parcelRegister("3bnsV", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $7e64d26d8875364d$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getProjectProps", () => $7e64d26d8875364d$export$2ba60b1cee4e2df8);

var $9zust = parcelRequire("9zust");

var $lTzVR = parcelRequire("lTzVR");

var $j4oe4 = parcelRequire("j4oe4");


var $epTsa = parcelRequire("epTsa");

var $eiIzV = parcelRequire("eiIzV");

var $b1bEi = parcelRequire("b1bEi");
const $7e64d26d8875364d$export$6df0712d20d2cc08 = (node, itemType)=>({
        label: node.displayName,
        value: node.jqlTerm,
        optionType: 'avatar',
        avatar: node.project?.avatar?.small,
        square: true,
        itemType: itemType
    });
const $7e64d26d8875364d$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, formatMessage: formatMessage, projectOptions: projectOptions })=>{
    const refinementOptionRecentProjectsGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $b1bEi.default).refinementOptionRecentProjectsGalaxia : (0, $b1bEi.default).refinementOptionRecentProjects;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $lTzVR.default), {
        cloudId: cloudId,
        ...projectOptions && {
            projectOptions: projectOptions
        }
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira.jqlBuilder?.recentlyUsedProjects || !data?.jira.jqlBuilder?.recentlyUsedProjects.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: projectEdges } = data?.jira.jqlBuilder?.recentlyUsedProjects;
    return (0, $eiIzV.generateOptions)([
        {
            label: formatMessage(refinementOptionRecentProjectsGalaxia),
            optionType: 'group',
            options: projectEdges.reduce((options, edges)=>{
                if (!edges || !edges.node) return options;
                const { node: node } = edges;
                options.push($7e64d26d8875364d$export$6df0712d20d2cc08(node, (0, $f38290926d0398e2$export$38accfc5a5d1c113)));
                return options;
            }, [])
        }
    ]);
};
const $7e64d26d8875364d$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, projectOptions: projectOptions, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $9zust.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        ...projectOptions && {
            projectOptions: projectOptions
        },
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $eiIzV.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($7e64d26d8875364d$export$6df0712d20d2cc08(node, (0, $f38290926d0398e2$export$38accfc5a5d1c113)));
        return options;
    }, []), totalCount, pageInfo.endCursor || undefined);
};
const $7e64d26d8875364d$export$2ba60b1cee4e2df8 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, projectOptions: projectOptions, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $7e64d26d8875364d$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    formatMessage: formatMessage,
                    projectOptions: projectOptions
                });
                return await $7e64d26d8875364d$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    projectOptions: projectOptions,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('projectJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("9zust", function(module, exports) {

$parcel$export(module.exports, "default", () => $248da6610d0f1a50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95caf096268fefcfb77bddd415bb8857>>
 * @relayHash 3192fa5b6aa6a6075a38be5eb5f2aecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08d5f8ea6bbd314a0327191f720e0d7feda67a0f80b02f2c0149ab63f075c6ca
const $248da6610d0f1a50$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectOptions"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "projectOptions",
            "variableName": "projectOptions"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v8 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            v11 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlProjectFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "08d5f8ea6bbd314a0327191f720e0d7feda67a0f80b02f2c0149ab63f075c6ca",
            "metadata": {},
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$248da6610d0f1a50$var$node.hash = "7ae3b3a2998a3aacd96d184e4fa73d96";
var $248da6610d0f1a50$export$2e2bcd8739ae039 = $248da6610d0f1a50$var$node;

});

parcelRegister("lTzVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2209bb35edc632$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd0ea0833b7ca298c76608f11bb00cb1>>
 * @relayHash 18fa54e2ca28ad2622498bf24b076364
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ece22d797eb7f498f6481931bc3a47afb02775056d1512d271738b91c214c2ad
const $2e2209bb35edc632$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectOptions"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectOptions",
            "variableName": "projectOptions"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlProjectFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedProjects",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlProjectFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlProjectFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            v4 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlProjectFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlProjectFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlProjectFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ece22d797eb7f498f6481931bc3a47afb02775056d1512d271738b91c214c2ad",
            "metadata": {},
            "name": "projectJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2e2209bb35edc632$var$node.hash = "fe20d750eadef8bafda1d590956fca21";
var $2e2209bb35edc632$export$2e2bcd8739ae039 = $2e2209bb35edc632$var$node;

});

parcelRegister("b1bEi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8dfb71dc22a922$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0e8dfb71dc22a922$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refinementOptionRecentProjects: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.project.refinement-option-recent-projects",
        "defaultMessage": "Recent projects"
    },
    refinementOptionRecentProjectsGalaxia: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.project.refinement-option-recent-projects-galaxia",
        "defaultMessage": "Recent spaces"
    }
});

});


parcelRegister("3Tke1", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $1cc4c48b4ccddd45$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getSprintProps", () => $1cc4c48b4ccddd45$export$85662d0553c985b4);

var $aSINI = parcelRequire("aSINI");

var $co0xU = parcelRequire("co0xU");

var $j4oe4 = parcelRequire("j4oe4");


var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");

var $cb5xP = parcelRequire("cb5xP");

var $j2vE2 = parcelRequire("j2vE2");

var $7nojJ = parcelRequire("7nojJ");
const $1cc4c48b4ccddd45$export$6df0712d20d2cc08 = (node, formatMessage, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (node.sprint) {
        const { state: state, boardName: boardName } = node.sprint;
        const i18nState = state ? (0, $7nojJ.getSprintState)(state, formatMessage) : undefined;
        const secondaryLabel = [
            i18nState,
            boardName
        ].filter((0, $7nojJ.hasValue)).join(" \u22C5 ");
        if (secondaryLabel !== '') return {
            ...option,
            secondaryLabel: secondaryLabel
        };
    }
    return option;
};
const $1cc4c48b4ccddd45$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, endCursor: endCursor, formatMessage: formatMessage })=>{
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $co0xU.default), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const emptyOption = [
        {
            label: (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, formatMessage),
            value: (0, $dTJxm.OperandValues).empty.value,
            optionType: 'option',
            itemType: (0, $f38290926d0398e2$export$f6049126fd97001f)
        }
    ];
    if (!data?.jira?.jqlBuilder?.recentlyUsedSprints?.edges) return (0, $eiIzV.generateOptions)(emptyOption);
    const { edges: fieldValues } = data.jira.jqlBuilder.recentlyUsedSprints;
    const sprints = fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($1cc4c48b4ccddd45$export$6df0712d20d2cc08(node, formatMessage, (0, $f38290926d0398e2$export$38accfc5a5d1c113)));
        return options;
    }, []);
    return (0, $eiIzV.generateOptions)([
        ...!endCursor ? emptyOption : [],
        {
            label: formatMessage((0, $j2vE2.default).refinementOptionSuggestedSprints),
            optionType: 'group',
            options: sprints
        }
    ]);
};
const $1cc4c48b4ccddd45$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, fieldId: fieldId, searchTemplate: searchTemplate, jql: jql, search: search, endCursor: endCursor, formatMessage: formatMessage, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $j4oe4.fetchQuery)(environment, (0, $aSINI.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: fieldId.toLowerCase(),
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const emptyOption = {
        label: (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, formatMessage),
        value: (0, $dTJxm.OperandValues).empty.value,
        optionType: 'option',
        itemType: (0, $f38290926d0398e2$export$f6049126fd97001f)
    };
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $eiIzV.generateOptions)([
        emptyOption
    ]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    const sprints = fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($1cc4c48b4ccddd45$export$6df0712d20d2cc08(node, formatMessage, (0, $f38290926d0398e2$export$38accfc5a5d1c113)));
        return options;
    }, []);
    return (0, $eiIzV.generateOptions)([
        ...search.length === 0 && !endCursor ? [
            emptyOption
        ] : [],
        ...sprints
    ], totalCount, pageInfo?.endCursor || undefined);
};
const $1cc4c48b4ccddd45$export$85662d0553c985b4 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: true,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $1cc4c48b4ccddd45$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    endCursor: endCursor,
                    formatMessage: formatMessage
                });
                return await $1cc4c48b4ccddd45$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    formatMessage: formatMessage,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eiIzV.fireJqlBuilderBasicErrorAnalytics)('sprintJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $eiIzV.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("aSINI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8724a13f10f859$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<241c95051fbcdaa37867d9588c9652fc>>
 * @relayHash a753d2378b8a0e85d368b587cef149cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f49a61064524e802bb475f20e360b1e395edcd2bd05d487b7817a174f90c52df
const $ab8724a13f10f859$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "state"
    }, v14 = {
        "kind": "ScalarField",
        "name": "boardName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "sprint",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v13 /*: any*/ ,
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlSprintFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f49a61064524e802bb475f20e360b1e395edcd2bd05d487b7817a174f90c52df",
            "metadata": {},
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ab8724a13f10f859$var$node.hash = "2fca268b01a9949b7d6a9c7abb665ff1";
var $ab8724a13f10f859$export$2e2bcd8739ae039 = $ab8724a13f10f859$var$node;

});

parcelRegister("co0xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d52de5785a57a3c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b82b9b38c96bf6b763bd8f21ed441feb>>
 * @relayHash 0f4f3c0dc3fbfd461b30b2edce7ff480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd147d7ddd3fe153f2faac37da072abad63284dd1e60a1ad50037b7db7059d8d
const $5d52de5785a57a3c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "state"
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardName"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sprintJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlSprintFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedSprints",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlSprintFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlSprintFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            v4 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraSprint",
                                                                "kind": "LinkedField",
                                                                "name": "sprint",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5 /*: any*/ ,
                                                                    v6 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "recentlyUsedSprints(first:5)"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sprintJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlSprintFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedSprints",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlSprintFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlSprintFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "sprint",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "recentlyUsedSprints(first:5)"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bd147d7ddd3fe153f2faac37da072abad63284dd1e60a1ad50037b7db7059d8d",
            "metadata": {},
            "name": "sprintJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5d52de5785a57a3c$var$node.hash = "ea6849d517e657548891da01c0336d4f";
var $5d52de5785a57a3c$export$2e2bcd8739ae039 = $5d52de5785a57a3c$var$node;

});

parcelRegister("j2vE2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d12ef39052694cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7d12ef39052694cc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    active: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.active",
        "defaultMessage": "Active"
    },
    future: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.future",
        "defaultMessage": "Future"
    },
    closed: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.closed",
        "defaultMessage": "Closed"
    },
    refinementOptionSuggestedSprints: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.refinement-option-suggested-sprints",
        "defaultMessage": "Suggested Sprints"
    }
});

});

parcelRegister("7nojJ", function(module, exports) {

$parcel$export(module.exports, "hasValue", () => $1728709a38bdfd7a$export$96bdbc84526f3739);
$parcel$export(module.exports, "getSprintState", () => $1728709a38bdfd7a$export$9cbf48c04feaac07);

var $j2vE2 = parcelRequire("j2vE2");
const $1728709a38bdfd7a$export$96bdbc84526f3739 = (text)=>typeof text === 'string' && text.length > 0;
const $1728709a38bdfd7a$export$9cbf48c04feaac07 = (state, formatMessage)=>{
    switch(state){
        case 'ACTIVE':
            return formatMessage((0, $j2vE2.default).active);
        case 'FUTURE':
            return formatMessage((0, $j2vE2.default).future);
        case 'CLOSED':
            return formatMessage((0, $j2vE2.default).closed);
        default:
            return undefined;
    }
};

});



parcelRegister("l2et3", function(module, exports) {

$parcel$export(module.exports, "useSelectedOperator", () => $d4ee52aa46843976$export$7efa7e0a027633a3);

var $eJOHy = parcelRequire("eJOHy");

var $2poie = parcelRequire("2poie");
var $lpN3x = parcelRequire("lpN3x");
var $lNgEH = parcelRequire("lNgEH");

var $lRq8t = parcelRequire("lRq8t");

var $5c1zW = parcelRequire("5c1zW");

var $hV50T = parcelRequire("hV50T");

var $9dwrV = parcelRequire("9dwrV");
const $d4ee52aa46843976$var$DEFAULT_OPERATOR = (0, $2poie.default).operator((0, $lNgEH.OPERATOR_EQUALS));
const $d4ee52aa46843976$export$7efa7e0a027633a3 = ({ fieldDisplayName: fieldDisplayName, terminalClause: terminalClause, allowedOperators: allowedOperators = [] })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    /**
   * List of operators allowed for the field
   * We need to keep the object references to allow react select to know which is selected for screen readers
   * It uses the reference for this, not the value (https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/components/LiveRegion.tsx#L118)
   */ const allowedOperatorsOptions = (0, $eJOHy.useMemo)(()=>({
            singleOperators: [
                ...new Set(allowedOperators.map((operator)=>(0, $9dwrV.resolveOperator)({
                        operatorValue: operator.value,
                        isList: false
                    })))
            ].map((operatorValue)=>(0, $hV50T.createOperatorOption)({
                    fieldDisplayName: fieldDisplayName,
                    operator: (0, $2poie.default).operator(operatorValue),
                    formatMessage: formatMessage
                })),
            listOperators: [
                ...new Set(allowedOperators.map((o)=>(0, $9dwrV.resolveOperator)({
                        operatorValue: o.value,
                        isList: true
                    })))
            ].map((operatorValue)=>(0, $hV50T.createOperatorOption)({
                    fieldDisplayName: fieldDisplayName,
                    operator: (0, $2poie.default).operator(operatorValue),
                    formatMessage: formatMessage
                }))
        }), // Operator don't change after bootup
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Select if we need to show list or single operators
    const allowedOperatorsOptionsFiltered = (0, $eJOHy.useMemo)(()=>allowedOperatorsOptions[terminalClause?.operand && (0, $5c1zW.isListOperand)(terminalClause.operand) ? 'listOperators' : 'singleOperators'], [
        allowedOperatorsOptions,
        terminalClause?.operand
    ]);
    // Selected operator for the field
    const [selectedOperator, setSelectedOperator] = (0, $eJOHy.useState)(()=>{
        let resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>terminalClause?.operator?.value && operator.value === terminalClause.operator.value);
        if (!resolvedOperator) resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === $d4ee52aa46843976$var$DEFAULT_OPERATOR.value);
        return resolvedOperator !== undefined ? resolvedOperator : (0, $hV50T.createOperatorOption)({
            fieldDisplayName: fieldDisplayName,
            operator: $d4ee52aa46843976$var$DEFAULT_OPERATOR,
            formatMessage: formatMessage
        });
    });
    const setDefaultOperator = (0, $eJOHy.useCallback)(()=>{
        setSelectedOperator(()=>{
            const resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === $d4ee52aa46843976$var$DEFAULT_OPERATOR.value);
            return resolvedOperator !== undefined ? resolvedOperator : (0, $hV50T.createOperatorOption)({
                fieldDisplayName: fieldDisplayName,
                operator: $d4ee52aa46843976$var$DEFAULT_OPERATOR,
                formatMessage: formatMessage
            });
        });
    }, [
        allowedOperatorsOptionsFiltered,
        fieldDisplayName,
        formatMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (terminalClause && terminalClause.operator?.value && (0, $lpN3x.isOperator)(terminalClause.operator.value) && terminalClause.operator.value !== selectedOperator?.value) {
            const terminalOperator = terminalClause.operator;
            const resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === terminalOperator.value);
            setSelectedOperator(resolvedOperator !== undefined ? resolvedOperator : (0, $hV50T.createOperatorOption)({
                fieldDisplayName: fieldDisplayName,
                operator: terminalOperator,
                formatMessage: formatMessage
            }));
        }
    // Only update when change come from outside of the hook (terminalClause)
    // We already manage selectedOperator changes internally
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formatMessage,
        terminalClause
    ]);
    return {
        allowedOperators: allowedOperatorsOptionsFiltered,
        selectedOperator: selectedOperator,
        setSelectedOperator: setSelectedOperator,
        setDefaultOperator: setDefaultOperator
    };
};

});
parcelRegister("hV50T", function(module, exports) {

$parcel$export(module.exports, "createOperatorOption", () => $6a1887d158b16397$export$ed5b7e9422ae3ae4);

var $lNgEH = parcelRequire("lNgEH");

var $8v8cy = parcelRequire("8v8cy");
const $6a1887d158b16397$var$getOperatorLabels = ({ operatorValue: operatorValue, fieldDisplayName: fieldDisplayName, formatMessage: formatMessage })=>{
    let messageKey;
    let resolvedOperatorValue;
    switch(operatorValue){
        case 0, $lNgEH.OPERATOR_EQUALS:
        case 0, $lNgEH.OPERATOR_IS:
        case 0, $lNgEH.OPERATOR_IN:
            messageKey = 'operatorEquals';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_EQUALS);
            break;
        case 0, $lNgEH.OPERATOR_NOT_EQUALS:
        case 0, $lNgEH.OPERATOR_IS_NOT:
        case 0, $lNgEH.OPERATOR_NOT_IN:
            messageKey = 'operatorNotEquals';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_NOT_EQUALS);
            break;
        case 0, $lNgEH.OPERATOR_WAS:
        case 0, $lNgEH.OPERATOR_WAS_IN:
            messageKey = 'operatorWas';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_WAS);
            break;
        case 0, $lNgEH.OPERATOR_WAS_NOT:
        case 0, $lNgEH.OPERATOR_WAS_NOT_IN:
            messageKey = 'operatorWasNot';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_WAS_NOT);
            break;
        case 0, $lNgEH.OPERATOR_CHANGED:
            messageKey = 'operatorChanged';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_CHANGED);
            break;
        case 0, $lNgEH.OPERATOR_LIKE:
            messageKey = 'operatorLike';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_LIKE);
            break;
        case 0, $lNgEH.OPERATOR_NOT_LIKE:
            messageKey = 'operatorNotLike';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_NOT_LIKE);
            break;
        case 0, $lNgEH.OPERATOR_GT:
            messageKey = 'operatorGt';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_GT);
            break;
        case 0, $lNgEH.OPERATOR_GT_EQUALS:
            messageKey = 'operatorGtEquals';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_GT_EQUALS);
            break;
        case 0, $lNgEH.OPERATOR_LT:
            messageKey = 'operatorLt';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_LT);
            break;
        case 0, $lNgEH.OPERATOR_LT_EQUALS:
            messageKey = 'operatorLtEquals';
            resolvedOperatorValue = (0, $lNgEH.OPERATOR_LT_EQUALS);
            break;
        default:
            throw new Error(`Operator value: ${operatorValue} not supported`);
    }
    return {
        label: formatMessage((0, $8v8cy.default)[messageKey], {
            fieldDisplayName: fieldDisplayName,
            operator: resolvedOperatorValue
        }),
        shortLabel: formatMessage((0, $8v8cy.default)[`${messageKey}Short`], {
            operator: resolvedOperatorValue
        }),
        ariaLabel: formatMessage((0, $8v8cy.default)[`${messageKey}AriaLabel`], {
            fieldDisplayName: fieldDisplayName
        }),
        valueLabel: resolvedOperatorValue
    };
};
const $6a1887d158b16397$export$ed5b7e9422ae3ae4 = ({ fieldDisplayName: fieldDisplayName, operator: operator, formatMessage: formatMessage })=>({
        ...operator,
        ...$6a1887d158b16397$var$getOperatorLabels({
            operatorValue: operator.value,
            fieldDisplayName: fieldDisplayName,
            formatMessage: formatMessage
        })
    });

});
parcelRegister("8v8cy", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4b6f5023c858d7$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $df4b6f5023c858d7$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    operatorEquals: {
        "id": "jql-builder-basic.utils.operators.operator-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (equals)"
    },
    operatorNotEquals: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (not equals)"
    },
    operatorWas: {
        "id": "jql-builder-basic.utils.operators.operator-was",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorWasNot: {
        "id": "jql-builder-basic.utils.operators.operator-was-not",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorChanged: {
        "id": "jql-builder-basic.utils.operators.operator-changed",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorLike: {
        "id": "jql-builder-basic.utils.operators.operator-like",
        "defaultMessage": "{fieldDisplayName} {operator} (like)"
    },
    operatorNotLike: {
        "id": "jql-builder-basic.utils.operators.operator-not-like",
        "defaultMessage": "{fieldDisplayName} {operator} (not like)"
    },
    operatorGt: {
        "id": "jql-builder-basic.utils.operators.operator-gt",
        "defaultMessage": "{fieldDisplayName} {operator} (greater than)"
    },
    operatorGtEquals: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (greater than or equals)"
    },
    operatorLt: {
        "id": "jql-builder-basic.utils.operators.operator-lt",
        "defaultMessage": "{fieldDisplayName} {operator} (less than)"
    },
    operatorLtEquals: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (less than or equals)"
    },
    operatorEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-equals-short",
        "defaultMessage": "{operator} (equals)"
    },
    operatorNotEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals-short",
        "defaultMessage": "{operator} (not equals)"
    },
    operatorWasShort: {
        "id": "jql-builder-basic.utils.operators.operator-was-short",
        "defaultMessage": "{operator}"
    },
    operatorWasNotShort: {
        "id": "jql-builder-basic.utils.operators.operator-was-not-short",
        "defaultMessage": "{operator}"
    },
    operatorChangedShort: {
        "id": "jql-builder-basic.utils.operators.operator-changed-short",
        "defaultMessage": "{operator}"
    },
    operatorLikeShort: {
        "id": "jql-builder-basic.utils.operators.operator-like-short",
        "defaultMessage": "{operator} (like)"
    },
    operatorNotLikeShort: {
        "id": "jql-builder-basic.utils.operators.operator-not-like-short",
        "defaultMessage": "{operator} (not like)"
    },
    operatorGtShort: {
        "id": "jql-builder-basic.utils.operators.operator-gt-short",
        "defaultMessage": "{operator} (greater than)"
    },
    operatorGtEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals-short",
        "defaultMessage": "{operator} (greater than or equals)"
    },
    operatorLtShort: {
        "id": "jql-builder-basic.utils.operators.operator-lt-short",
        "defaultMessage": "{operator} (less than)"
    },
    operatorLtEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals-short",
        "defaultMessage": "{operator} (less than or equals)"
    },
    operatorEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} equals"
    },
    operatorNotEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} not equals"
    },
    operatorWasAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-was-aria-label",
        "defaultMessage": "{fieldDisplayName} was"
    },
    operatorWasNotAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-was-not-aria-label",
        "defaultMessage": "{fieldDisplayName} was not"
    },
    operatorChangedAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-changed-aria-label",
        "defaultMessage": "{fieldDisplayName} changed"
    },
    operatorLikeAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-like-aria-label",
        "defaultMessage": "{fieldDisplayName} like"
    },
    operatorNotLikeAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-not-like-aria-label",
        "defaultMessage": "{fieldDisplayName} not like"
    },
    operatorGtAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-gt-aria-label",
        "defaultMessage": "{fieldDisplayName} greater than"
    },
    operatorGtEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} greater than or equals"
    },
    operatorLtAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-lt-aria-label",
        "defaultMessage": "{fieldDisplayName} less than"
    },
    operatorLtEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} less than or equals"
    }
});
var $df4b6f5023c858d7$export$2e2bcd8739ae039 = $df4b6f5023c858d7$export$defe85febe8b728c;

});



parcelRegister("8Hwfj", function(module, exports) {

$parcel$export(module.exports, "useSelectedValues", () => $528f55de3c1dfdb1$export$e10928cdf9450649);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $dTJxm = parcelRequire("dTJxm");

var $7KNt5 = parcelRequire("7KNt5");
const $528f55de3c1dfdb1$var$isEmptyOption = (option)=>option.optionType === 'option' && option.value === (0, $dTJxm.OperandValues).empty.value;
const $528f55de3c1dfdb1$export$e10928cdf9450649 = (terminalClause, hydratedData, fieldId, operandDisplayValues, searchTemplate)=>{
    // Allow optimistic updates when a value is selected while hydration is taking place
    const [optimisticValues, setOptimisticValues] = (0, $eJOHy.useState)([]);
    const [hydrated, setHydrated] = (0, $eJOHy.useState)((0, $7jTnu.fg)('render_jql_builder_in_ssr') ? !!hydratedData : false);
    const prevHydratedData = (0, $eJOHy.useRef)((0, $7jTnu.fg)('render_jql_builder_in_ssr') ? hydratedData : undefined);
    const hydratedValues = (0, $7KNt5.useHydratedValues)(fieldId, hydratedData, searchTemplate, terminalClause, operandDisplayValues);
    // Only flag values as hydrated after a data change
    (0, $eJOHy.useEffect)(()=>{
        if (!hydrated && hydratedData !== prevHydratedData.current) setHydrated(true);
        prevHydratedData.current = hydratedData;
    }, [
        hydrated,
        hydratedData
    ]);
    const selectedValues = (0, $eJOHy.useMemo)(()=>{
        const values = hydrated ? hydratedValues : optimisticValues;
        const emptyIndex = values.findIndex($528f55de3c1dfdb1$var$isEmptyOption);
        if (emptyIndex !== -1) {
            const orderedValues = [
                ...values
            ];
            // Rearrange selected values to keep EMPTY at the end
            orderedValues.push(orderedValues.splice(emptyIndex, 1)[0]);
            return orderedValues;
        }
        return values;
    }, [
        hydrated,
        hydratedValues,
        optimisticValues
    ]);
    const setSelectedValues = (0, $eJOHy.useCallback)((values)=>{
        setHydrated(false);
        setOptimisticValues(values);
    }, []);
    return [
        selectedValues,
        setSelectedValues
    ];
};

});
parcelRegister("7KNt5", function(module, exports) {

$parcel$export(module.exports, "useHydratedValues", () => $4c8c764adfc4d727$export$dc23a21ad032e5fa);

var $7Inhe = parcelRequire("7Inhe");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $8eqAB = parcelRequire("8eqAB");
const $4c8c764adfc4d727$export$dc23a21ad032e5fa = (fieldId, hydratedData, searchTemplate, terminalClause, operandDisplayValues)=>{
    const intl = (0, $lRq8t.default)();
    /* eslint-disable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ const data = (0, $j4oe4.useFragment)((0, $7Inhe.default), hydratedData);
    /* eslint-enable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ return (0, $eJOHy.useMemo)(()=>{
        if (terminalClause && data) {
            const hydratedValuesFromClause = (0, $8eqAB.getValuesFromClause)(terminalClause, data, fieldId, operandDisplayValues, intl, searchTemplate);
            if (hydratedValuesFromClause !== undefined) return Array.isArray(hydratedValuesFromClause) ? hydratedValuesFromClause : [
                hydratedValuesFromClause
            ];
        }
        return [];
    }, [
        terminalClause,
        data,
        fieldId,
        intl,
        operandDisplayValues,
        searchTemplate
    ]);
};

});
parcelRegister("7Inhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ddb9b3b5922ab9a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5aa1f9f496fb483e2dd16633d7de899e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1ddb9b3b5922ab9a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "picture"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v2 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                }
            ]
        }
    ], v8 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v7 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v7 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v0 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "accountId"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "includeUser"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useHydratedValues",
        "selections": [
            {
                "condition": "includeUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "accountId",
                                "variableName": "accountId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            },
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v8 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v8 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$1ddb9b3b5922ab9a$var$node.hash = "ca3de7c8645b6f4d9524497f325707e2";
var $1ddb9b3b5922ab9a$export$2e2bcd8739ae039 = $1ddb9b3b5922ab9a$var$node;

});

parcelRegister("8eqAB", function(module, exports) {

$parcel$export(module.exports, "getValuesFromClause", () => $6b0f40cc3b2b71af$export$703572bd21b6316);


var $eSnSE = parcelRequire("eSnSE");

var $al3nN = parcelRequire("al3nN");

var $39sKD = parcelRequire("39sKD");

var $idQ0v = parcelRequire("idQ0v");

var $8S3SG = parcelRequire("8S3SG");
const $6b0f40cc3b2b71af$export$703572bd21b6316 = (terminalClause, data, fieldJqlTerm, validOperandDisplayValues, intl, searchTemplate)=>{
    if (terminalClause.operand) switch(terminalClause.operand.operandType){
        case 0, $f38290926d0398e2$export$f6049126fd97001f:
            return (0, $39sKD.getKeywordValue)(terminalClause.operand.value, validOperandDisplayValues, intl, searchTemplate);
        case 0, $f38290926d0398e2$export$38accfc5a5d1c113:
            return (0, $8S3SG.getValue)(data, fieldJqlTerm, terminalClause.operand.value, intl);
        case 0, $f38290926d0398e2$export$19c7c729db381f9d:
            return (0, $al3nN.getFunctionValue)(data, terminalClause.operand.function.value, validOperandDisplayValues, intl, terminalClause.operand.arguments, fieldJqlTerm);
        case 0, $f38290926d0398e2$export$fabec4aebba3f4df:
            return (0, $idQ0v.getListValue)({
                listOperand: terminalClause.operand,
                data: data,
                fieldJqlTerm: fieldJqlTerm,
                validOperandDisplayValues: validOperandDisplayValues,
                intl: intl,
                searchTemplate: searchTemplate
            });
        default:
            throw new Error('Operand Type is not valid');
    }
    (0, $eSnSE.default).unsafeErrorWithCustomerData('jiraJqlBuilderBasic.getValuesFromClause', 'Terminal clause operand is undefined', {
        jql: (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.jql,
        fieldJqlTerm: fieldJqlTerm,
        operator: terminalClause.operator?.value,
        searchTemplate: searchTemplate
    });
    throw new Error('Terminal clause operand is undefined');
};

});
parcelRegister("al3nN", function(module, exports) {

$parcel$export(module.exports, "getFunctionValue", () => $2bf1256e481171d9$export$f1c78020f9d2362b);


var $dTJxm = parcelRequire("dTJxm");

var $65vFU = parcelRequire("65vFU");
const $2bf1256e481171d9$export$f1c78020f9d2362b = (data, value, validOperandDisplayValues, intl, args, fieldJqlTerm)=>{
    const invalid = Boolean(!validOperandDisplayValues || !validOperandDisplayValues.includes((0, $dTJxm.OperandValues)[value]?.value || value));
    if (value === 'membersOf') {
        const matchingField = (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm && field.jqlTerm.toLowerCase() === fieldJqlTerm.toLowerCase());
        const fieldData = matchingField?.values?.find((v)=>v?.jqlTerm && v.jqlTerm === args[0].value);
        if (fieldData?.values?.length) {
            const [hydratedFieldValue] = fieldData.values;
            if (hydratedFieldValue) return {
                label: hydratedFieldValue.displayName,
                value: hydratedFieldValue.jqlTerm,
                itemType: (0, $f38290926d0398e2$export$19c7c729db381f9d),
                optionType: 'avatar',
                isGroup: true,
                invalid: invalid
            };
        }
        return undefined;
    }
    const fieldValue = {
        label: (0, $65vFU.getFunctionLabel)(value, intl.formatMessage),
        value: (0, $dTJxm.OperandValues)[value]?.value || value,
        itemType: (0, $f38290926d0398e2$export$19c7c729db381f9d)
    };
    if (fieldValue.value === (0, $dTJxm.OperandValues).currentUser.value && !invalid) return {
        ...fieldValue,
        optionType: 'avatar',
        avatar: data?.user?.picture ?? '',
        invalid: invalid
    };
    return {
        ...fieldValue,
        optionType: 'avatar',
        hideAvatar: true,
        invalid: invalid
    };
};

});

parcelRegister("39sKD", function(module, exports) {

$parcel$export(module.exports, "getKeywordValue", () => $4bfa627004eedef8$export$2b5362d270091b71);


var $dTJxm = parcelRequire("dTJxm");

var $cb5xP = parcelRequire("cb5xP");
const $4bfa627004eedef8$export$2b5362d270091b71 = (value, validOperandDisplayValues, intl, searchTemplate)=>{
    // EMPTY is the only supported RHS keyword in JQL (AST returns EMPTY for both EMPTY and NULL)
    const label = (0, $cb5xP.getEmptyLabel)(searchTemplate ?? null, intl.formatMessage);
    const selectOptionValue = (0, $dTJxm.OperandValues).empty.value;
    const invalid = !validOperandDisplayValues || !validOperandDisplayValues.some((keyword)=>keyword.toLowerCase() === value.toLowerCase());
    if (searchTemplate && (0, $dTJxm.userFieldSearchTemplates).has(searchTemplate.toLowerCase())) return {
        label: label,
        optionType: 'avatar',
        value: selectOptionValue,
        invalid: invalid,
        itemType: (0, $f38290926d0398e2$export$f6049126fd97001f)
    };
    return {
        label: label,
        optionType: 'option',
        value: selectOptionValue,
        invalid: invalid,
        itemType: (0, $f38290926d0398e2$export$f6049126fd97001f)
    };
};

});

parcelRegister("idQ0v", function(module, exports) {

$parcel$export(module.exports, "getListValue", () => $0c1cb7ff80f05047$export$9cc74515108c9544);


var $al3nN = parcelRequire("al3nN");

var $39sKD = parcelRequire("39sKD");

var $8S3SG = parcelRequire("8S3SG");
// Returns a minimal `SelectOption` which contains only the value. This is used
// during creation of `rawSelectedValues` in `./main.js`, and is necessary so
// that we can perform comparisons on the selected values before updated data
// is returned from the server.
const $0c1cb7ff80f05047$var$getRawValue = (value)=>({
        optionType: 'option',
        label: '',
        value: value
    });
const $0c1cb7ff80f05047$export$9cc74515108c9544 = ({ listOperand: listOperand, data: data, fieldJqlTerm: fieldJqlTerm, validOperandDisplayValues: validOperandDisplayValues, intl: intl, searchTemplate: searchTemplate })=>listOperand.values.reduce((acum, value)=>{
        if (value.operandType === (0, $f38290926d0398e2$export$38accfc5a5d1c113)) {
            if (!data) {
                const rawValue = $0c1cb7ff80f05047$var$getRawValue(value.value);
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                return rawValue ? [
                    ...acum,
                    rawValue
                ] : acum;
            }
            const hydratedValue = (0, $8S3SG.getValue)(data, fieldJqlTerm, value.value, intl);
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return hydratedValue ? [
                ...acum,
                hydratedValue
            ] : acum;
        }
        if (value.operandType === (0, $f38290926d0398e2$export$19c7c729db381f9d)) {
            const hydratedValue = (0, $al3nN.getFunctionValue)(data, value.function.value, validOperandDisplayValues, intl, value.arguments, fieldJqlTerm);
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return hydratedValue ? [
                ...acum,
                hydratedValue
            ] : acum;
        }
        if (value.operandType === (0, $f38290926d0398e2$export$f6049126fd97001f)) return [
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acum,
            (0, $39sKD.getKeywordValue)(value.value, validOperandDisplayValues, intl, searchTemplate)
        ];
        if (value.operandType === (0, $f38290926d0398e2$export$fabec4aebba3f4df)) return [
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acum,
            ...$0c1cb7ff80f05047$export$9cc74515108c9544({
                listOperand: value,
                data: data,
                fieldJqlTerm: fieldJqlTerm,
                validOperandDisplayValues: validOperandDisplayValues,
                intl: intl,
                searchTemplate: searchTemplate
            })
        ];
        throw new Error('This is unexpected! Check if isQueryTooComplex is missing a check');
    }, []);

});
parcelRegister("8S3SG", function(module, exports) {

$parcel$export(module.exports, "getValue", () => $e191da333fbbf5dd$export$bf7199a9ebcb84a9);


var $92k5z = parcelRequire("92k5z");

var $7porm = parcelRequire("7porm");

var $3q8Sy = parcelRequire("3q8Sy");

var $3bnsV = parcelRequire("3bnsV");

var $3Tke1 = parcelRequire("3Tke1");
const $e191da333fbbf5dd$export$bf7199a9ebcb84a9 = (data, fieldJqlTerm, valueJqlTerm, intl)=>{
    const matchingField = (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm && field.jqlTerm.toLowerCase() === fieldJqlTerm.toLowerCase());
    const fieldData = matchingField?.values?.find((value)=>value?.jqlTerm && (value.jqlTerm === valueJqlTerm || value.jqlTerm.toLowerCase() === (0, $92k5z.removeSurroundingQuotes)(valueJqlTerm).toLowerCase()));
    if (fieldData?.error) return {
        label: (0, $92k5z.removeSurroundingQuotes)(valueJqlTerm),
        optionType: 'option',
        value: valueJqlTerm,
        invalid: true,
        itemType: (0, $f38290926d0398e2$export$38accfc5a5d1c113)
    };
    if (fieldData?.values?.length) {
        const [hydratedFieldValue] = fieldData.values;
        if (hydratedFieldValue) switch(hydratedFieldValue.__typename){
            case 'JiraJqlUserFieldValue':
                return {
                    label: hydratedFieldValue.displayName,
                    value: hydratedFieldValue.jqlTerm,
                    optionType: 'avatar',
                    avatar: hydratedFieldValue.user?.picture,
                    itemType: (0, $f38290926d0398e2$export$38accfc5a5d1c113)
                };
            case 'JiraJqlGroupFieldValue':
                return {
                    label: hydratedFieldValue.displayName,
                    value: hydratedFieldValue.jqlTerm,
                    optionType: 'avatar',
                    itemType: (0, $f38290926d0398e2$export$38accfc5a5d1c113),
                    isGroup: true
                };
            case 'JiraJqlIssueTypeFieldValue':
                return (0, $3q8Sy.getOption)(hydratedFieldValue, (0, $f38290926d0398e2$export$38accfc5a5d1c113));
            case 'JiraJqlProjectFieldValue':
                return (0, $3bnsV.getOption)(hydratedFieldValue, (0, $f38290926d0398e2$export$38accfc5a5d1c113));
            case 'JiraJqlSprintFieldValue':
                return (0, $3Tke1.getOption)(hydratedFieldValue, intl.formatMessage, (0, $f38290926d0398e2$export$38accfc5a5d1c113));
            default:
                return (0, $7porm.getOption)(hydratedFieldValue, (0, $f38290926d0398e2$export$38accfc5a5d1c113));
        }
    }
    return undefined;
};

});






parcelRegister("8M9FQ", function(module, exports) {

$parcel$export(module.exports, "TextAreaPicker", () => $69e876a674f23fb1$export$2d0fad1d142f2f68);

var $eJOHy = parcelRequire("eJOHy");

var $lNgEH = parcelRequire("lNgEH");

var $boEdP = parcelRequire("boEdP");

var $eqSys = parcelRequire("eqSys");

var $eiIzV = parcelRequire("eiIzV");

var $lyPdT = parcelRequire("lyPdT");

var $h9gPh = parcelRequire("h9gPh");

var $ediQO = parcelRequire("ediQO");

var $aEcQh = parcelRequire("aEcQh");

var $gWc6I = parcelRequire("gWc6I");

var $7moyo = parcelRequire("7moyo");
const $69e876a674f23fb1$var$isSingleValueOperand = (operand)=>operand.operandType === (0, $f38290926d0398e2$export$38accfc5a5d1c113) || operand.operandType === (0, $f38290926d0398e2$export$f6049126fd97001f);
const $69e876a674f23fb1$export$2d0fad1d142f2f68 = ({ clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldType: fieldType, activePopupKey: activePopupKey, onSearchWrapper: onSearchWrapper, onClear: onClear, onOpen: onOpen, onClose: onClose, fieldDescription: fieldDescription, propType: propType, isIrremovable: isIrremovable })=>{
    const [ast] = (0, $lyPdT.useAST)();
    const sendOptionAnalytics = (0, $h9gPh.useSendOptionAnalytics)();
    if (!(0, $eiIzV.isTextAreaPropType)(propType)) throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        onClear && onClear(clause ? (0, $boEdP.default)(ast, clause) : undefined);
    }, [
        onClear,
        clause,
        ast
    ]);
    const commonProps = {
        fieldId: fieldId,
        fieldDisplayName: fieldLabel || '',
        fieldType: fieldType,
        propType: propType,
        isOpen: activePopupKey === fieldId,
        onOpen: onOpen,
        onClose: onClose,
        onClear: handleOnClear,
        value: clause && clause.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) && clause.operand && $69e876a674f23fb1$var$isSingleValueOperand(clause.operand) && clause.operand.value || '',
        onSendOptionAnalytics: sendOptionAnalytics,
        fieldDescription: fieldDescription,
        isIrremovable: isIrremovable
    };
    switch(propType){
        case (0, $eqSys.TextAreaPropTypes).Number:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aEcQh.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $7moyo.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $lNgEH.OPERATOR_EQUALS)));
                }
            });
        case (0, $eqSys.TextAreaPropTypes).Aql:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ediQO.default), {
                ...commonProps,
                value: (0, $7moyo.getAqlFromClause)(clause),
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $7moyo.getUpdatedJqlWithAql)(ast, clause, fieldId, newValue, (0, $lNgEH.OPERATOR_IN)));
                }
            });
        case (0, $eqSys.TextAreaPropTypes).Text:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWc6I.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $7moyo.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $lNgEH.OPERATOR_LIKE)));
                }
            });
        case (0, $eqSys.TextAreaPropTypes).ExactText:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWc6I.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $7moyo.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $lNgEH.OPERATOR_EQUALS)));
                }
            });
        default:
            throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    }
};

});
parcelRegister("ediQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $31cee9ad984fd584$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $i0PfN = parcelRequire("i0PfN");

var $cMyAt = parcelRequire("cMyAt");

var $iFzFz = parcelRequire("iFzFz");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $bL3dk = parcelRequire("bL3dk");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $9JB3T = parcelRequire("9JB3T");

var $gYnSx = parcelRequire("gYnSx");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $bQ4fi = parcelRequire("bQ4fi");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7cSYk = parcelRequire("7cSYk");

var $8XHsn = parcelRequire("8XHsn");

var $jopyG = parcelRequire("jopyG");

var $6cdzW = parcelRequire("6cdzW");

var $lvKO5 = parcelRequire("lvKO5");

var $dTJxm = parcelRequire("dTJxm");

var $1xd19 = parcelRequire("1xd19");

var $i10HP = parcelRequire("i10HP");
const $31cee9ad984fd584$var$formatLabel = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        color: "inherit",
        as: "strong"
    }, label), ":\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31cee9ad984fd584$var$ValueWrapper, null, value));
};
const $31cee9ad984fd584$var$shouldValidateAQL = (tenantContext)=>(0, $jopyG.isLicensedPremiumUser)(tenantContext) && (0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP);
const $31cee9ad984fd584$export$3ff8b265431bef98 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId } = (0, $8XHsn.useWorkspaceContext)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [{ unvalidatedIql: unvalidatedIql, validationResult: validationResult }, { onChange: onIqlChange }] = (0, $6cdzW.useIqlValidation)({
        workspaceId: workspaceId,
        initialIql: value ?? ''
    });
    let aqlValidationError;
    if (validationResult.type === 'invalid') aqlValidationError = validationResult.error;
    (0, $eJOHy.useEffect)(()=>{
        if (!workspaceId) fetchWorkspaceId();
    }, [
        fetchWorkspaceId,
        workspaceId
    ]);
    const handleOnValueChange = (0, $eJOHy.useCallback)((inputValue = '')=>{
        // Only check AQL if it is a premium user
        if ($31cee9ad984fd584$var$shouldValidateAQL(tenantContext)) onIqlChange(inputValue);
    }, [
        onIqlChange,
        tenantContext
    ]);
    const handleOnUpdate = (0, $eJOHy.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            isAqlValidationEnabled: $31cee9ad984fd584$var$shouldValidateAQL(tenantContext),
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics,
        tenantContext
    ]);
    const handleOnHelpClick = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const attributes = {
            actionType: 'close'
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'aqlHelpLink', attributes);
    }, [
        createAnalyticsEvent
    ]);
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) onClose();
        else {
            onOpen();
            if ($31cee9ad984fd584$var$shouldValidateAQL(tenantContext)) onIqlChange(value || '');
        }
    }, [
        isOpen,
        onClose,
        onIqlChange,
        onOpen,
        tenantContext,
        value
    ]);
    const handleOnAQLValidationRetry = (0, $eJOHy.useCallback)((inputValue)=>()=>onIqlChange(inputValue), [
        onIqlChange
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ($31cee9ad984fd584$var$shouldValidateAQL(tenantContext) && aqlValidationError) {
            // We skip syntax errors from sentry and sent them to privacy unsafe splunk
            const isInvalidSyntaxError = aqlValidationError.includes('invalid syntax');
            (0, $gYnSx.default)({
                error: new Error(isInvalidSyntaxError ? 'invalid syntax' : 'unable to validate AQL query'),
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: isInvalidSyntaxError,
                meta: {
                    id: 'aql-validation-error',
                    packageName: (0, $dTJxm.PACKAGE_NAME),
                    teamName: (0, $dTJxm.TEAM_NAME)
                }
            });
        }
    }, [
        aqlValidationError,
        tenantContext
    ]);
    const getAqlPickerErrorMessage = (0, $eJOHy.useCallback)((inputValue)=>{
        if (!$31cee9ad984fd584$var$shouldValidateAQL(tenantContext)) return undefined;
        switch(validationResult.type){
            case 'valid':
                return unvalidatedIql !== inputValue ? formatMessage((0, $i10HP.default).aqlValidationInProgressMessage) : undefined;
            case 'invalid':
                return aqlValidationError !== 'Failed to fetch' ? formatMessage((0, $i10HP.default).inValidAqlErrorMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
                    alignInline: "center",
                    xcss: $31cee9ad984fd584$var$retryStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), null, formatMessage((0, $i10HP.default).unableToValidateAqlErrorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                    xcss: $31cee9ad984fd584$var$retryIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
                    content: formatMessage((0, $i10HP.default).retry),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: handleOnAQLValidationRetry(inputValue),
                    testId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.aql-picker-popup.retry-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFzFz))), {
                    LEGACY_size: "small",
                    label: formatMessage((0, $i10HP.default).retry)
                })))));
            case 'loading':
                return formatMessage((0, $i10HP.default).aqlValidationInProgressMessage);
            default:
                return undefined;
        }
    }, [
        tenantContext,
        validationResult.type,
        unvalidatedIql,
        formatMessage,
        aqlValidationError,
        handleOnAQLValidationRetry
    ]);
    const InfoIconComponent = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMyAt))), {
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)",
            label: ""
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.aql-picker-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                testId: `jql-builder-basic.ui.jql-editor.aql.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $31cee9ad984fd584$var$formatLabel(fieldDisplayName, value ? formatMessage((0, $i10HP.default).formatLabelMessage) : '')),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQ4fi.default), {
                value: value ?? '',
                getErrorMessage: getAqlPickerErrorMessage,
                onChange: handleOnUpdate,
                onValueChange: handleOnValueChange,
                placeholderText: formatMessage((0, $i10HP.default).textAreaPlaceholder),
                setInitialFocusRef: setInitialFocusRef,
                footerIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                    xcss: $31cee9ad984fd584$var$helpStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
                    content: formatMessage((0, $i10HP.default).aqlSyntaxHelpLinkLabel),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0PfN.default), {
                    href: "https://support.atlassian.com/jira-service-management-cloud/docs/use-assets-query-language-aql/",
                    shape: "circle",
                    onClick: handleOnHelpClick,
                    icon: InfoIconComponent,
                    appearance: "subtle",
                    spacing: "compact",
                    label: formatMessage((0, $i10HP.default).aqlSyntaxHelpLinkLabel)
                })))
            })
    });
};
var $31cee9ad984fd584$export$2e2bcd8739ae039 = $31cee9ad984fd584$export$3ff8b265431bef98;
const $31cee9ad984fd584$var$retryStyles = (0, $5Wv5g.xcss)({
    height: "var(--ds-space-200, 16px)"
});
const $31cee9ad984fd584$var$helpStyles = (0, $5Wv5g.xcss)({
    height: "var(--ds-space-300, 24px)"
});
const $31cee9ad984fd584$var$retryIconStyles = (0, $5Wv5g.xcss)({
    marginLeft: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31cee9ad984fd584$var$ValueWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iFzFz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6523555332355b1d4aa6bddc8955e159>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d977b98f0e6d4d53$var$_react = $d977b98f0e6d4d53$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d977b98f0e6d4d53$var$_retry = $d977b98f0e6d4d53$var$_interopRequireDefault((parcelRequire("29ZDx")));

var $d977b98f0e6d4d53$var$_retry2 = $d977b98f0e6d4d53$var$_interopRequireDefault((parcelRequire("lwzfw")));
function $d977b98f0e6d4d53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RetryIcon.
 * This component is RetryIcon, with `UNSAFE_fallbackIcon` set to "RetryIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d977b98f0e6d4d53$var$RetryIcon = (props)=>/*#__PURE__*/ $d977b98f0e6d4d53$var$_react.default.createElement($d977b98f0e6d4d53$var$_retry.default, Object.assign({
        LEGACY_fallbackIcon: $d977b98f0e6d4d53$var$_retry2.default
    }, props));
$d977b98f0e6d4d53$var$RetryIcon.Name = 'RetryIconMigration';
var $d977b98f0e6d4d53$var$_default = module.exports.default = $d977b98f0e6d4d53$var$RetryIcon;

});
parcelRegister("29ZDx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b87cc7d74b53f2f9074ecfc04ea4b65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $192c3bca631c8529$var$_react = $192c3bca631c8529$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $192c3bca631c8529$var$_baseNew = $192c3bca631c8529$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $192c3bca631c8529$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $192c3bca631c8529$var$RetryIcon = (props)=>/*#__PURE__*/ $192c3bca631c8529$var$_react.default.createElement($192c3bca631c8529$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$192c3bca631c8529$var$RetryIcon.displayName = 'RetryIcon';
var $192c3bca631c8529$var$_default = module.exports.default = $192c3bca631c8529$var$RetryIcon;

});

parcelRegister("lwzfw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab7edea7dbaa1a8$var$_react = $fab7edea7dbaa1a8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $fab7edea7dbaa1a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fab7edea7dbaa1a8$var$RetryIcon = (props)=>/*#__PURE__*/ $fab7edea7dbaa1a8$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 10h2.954a1 1 0 0 1 0 2H5.099A1.1 1.1 0 0 1 4 10.9V7a1 1 0 1 1 2 0z"/><path fill-rule="nonzero" d="M7.39 10.09H5.3a8 8 0 1 1 .818 6H7.84v-1.02a6 6 0 1 0-.45-4.98"/><circle cx="7" cy="15.61" r="1"/></g></svg>`
    }, props));
$fab7edea7dbaa1a8$var$RetryIcon.displayName = 'RetryIcon';
var $fab7edea7dbaa1a8$var$_default = module.exports.default = $fab7edea7dbaa1a8$var$RetryIcon;

});


parcelRegister("bQ4fi", function(module, exports) {

$parcel$export(module.exports, "default", () => $62773f6dae5fb220$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $i9p2T = parcelRequire("i9p2T");

var $bL3dk = parcelRequire("bL3dk");
var $5Wv5g = parcelRequire("5Wv5g");

var $isKH0 = parcelRequire("isKH0");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");


var $4GEuJ = parcelRequire("4GEuJ");
const $62773f6dae5fb220$export$60ae88ee9ba520c0 = ({ value: value, getErrorMessage: getErrorMessage, onChange: onChange, onValueChange: onValueChange, placeholderText: placeholderText, setInitialFocusRef: setInitialFocusRef, multiline: multiline = true, footerIcon: footerIcon })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [unsubmittedValue, setUnsubmittedValue] = (0, $eJOHy.useState)(value ?? '');
    const textAreaRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (setInitialFocusRef) setInitialFocusRef(textAreaRef.current);
    }, [
        setInitialFocusRef
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ target: { value: targetValue } })=>{
        if (onValueChange) onValueChange(targetValue);
        setUnsubmittedValue(targetValue);
    }, [
        setUnsubmittedValue,
        onValueChange
    ]);
    const handleOnSubmit = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        onChange(unsubmittedValue);
    }, [
        unsubmittedValue,
        onChange
    ]);
    const hasError = (0, $eJOHy.useMemo)(()=>!!getErrorMessage?.(unsubmittedValue), [
        getErrorMessage,
        unsubmittedValue
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (!multiline && event.key === 'Enter') event.preventDefault();
    }, [
        multiline
    ]);
    const handleOnPaste = (0, $eJOHy.useCallback)((event)=>{
        if (!multiline) {
            const data = event.clipboardData.getData('text/plain');
            if (textAreaRef.current && data.includes('\n')) {
                // Replace newlines with spaces
                const paste = data.replace(/\n/g, ' ');
                setUnsubmittedValue(unsubmittedValue.slice(0, textAreaRef.current.selectionStart) + paste + unsubmittedValue.slice(textAreaRef.current.selectionEnd));
                event.preventDefault();
            }
        }
    }, [
        multiline,
        unsubmittedValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62773f6dae5fb220$var$DialogInner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62773f6dae5fb220$var$TextAreaWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $isKH0.default), {
        ref: textAreaRef,
        onChange: handleOnChange,
        value: unsubmittedValue,
        onKeyDown: handleKeyDown,
        "aria-multiline": multiline,
        maxHeight: (0, $e382814c341184bc$export$5cdf10537498e072),
        onPaste: handleOnPaste,
        appearance: "none",
        minimumRows: 4,
        placeholder: placeholderText ?? formatMessage((0, $4GEuJ.default).textAreaPlaceholder),
        testId: "jql-builder-basic-textarea.ui.text-area"
    })), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62773f6dae5fb220$var$ErrorMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9p2T.ErrorMessage), null, getErrorMessage?.(unsubmittedValue))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        spread: "space-between",
        alignBlock: "center",
        grow: "fill",
        xcss: $62773f6dae5fb220$var$footerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($62773f6dae5fb220$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "primary",
        onClick: handleOnSubmit,
        type: "submit",
        isDisabled: hasError,
        testId: "jql-builder-basic-textarea.ui.update-button"
    }, formatMessage((0, $4GEuJ.default).updateButtonText))), footerIcon));
};
var $62773f6dae5fb220$export$2e2bcd8739ae039 = $62773f6dae5fb220$export$60ae88ee9ba520c0;
const $62773f6dae5fb220$var$footerStyles = (0, $5Wv5g.xcss)({
    paddingRight: 'space.150',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderTop: `${"var(--ds-border, #091E4224)"} solid ${(0, $dPMMf.gridSize) / 4}px`,
    paddingTop: 'space.075',
    paddingBottom: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62773f6dae5fb220$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkze3t _2hwxutpp _otyrze3t _18u0utpp _p12f1vmz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62773f6dae5fb220$var$TextAreaWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv77o _otyr12x7 _18u012x7 _2hwx12x7 _c71l4d55",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62773f6dae5fb220$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1b66 _2hwxutpp _otyr1b66 _18u0utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62773f6dae5fb220$var$DialogInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("isKH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd1ec11728b3e01f$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $j2fEo = parcelRequire("j2fEo");

var $8XtVW = parcelRequire("8XtVW");
const $bd1ec11728b3e01f$var$packageName = "platform-pkg";
const $bd1ec11728b3e01f$var$packageVersion = "0.0.0-use.local";
const $bd1ec11728b3e01f$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $bd1ec11728b3e01f$var$packageName,
    packageVersion: $bd1ec11728b3e01f$var$packageVersion
};
const $bd1ec11728b3e01f$var$lineHeightBase = 20;
const $bd1ec11728b3e01f$var$lineHeightCompact = 16;
const $bd1ec11728b3e01f$var$compactVerticalPadding = 2;
const $bd1ec11728b3e01f$var$verticalPadding = 6;
const $bd1ec11728b3e01f$var$transitionDuration = '0.2s';
const $bd1ec11728b3e01f$var$borderWidth = 2;
const $bd1ec11728b3e01f$var$baseStyles = null;
const $bd1ec11728b3e01f$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $bd1ec11728b3e01f$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $bd1ec11728b3e01f$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $bd1ec11728b3e01f$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $bd1ec11728b3e01f$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $bd1ec11728b3e01f$var$InnerTextArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const ourRef = (0, $eJOHy.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $eJOHy.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $bd1ec11728b3e01f$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$bd1ec11728b3e01f$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $j2fEo.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$bd1ec11728b3e01f$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eJOHy.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $bd1ec11728b3e01f$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $bd1ec11728b3e01f$var$appearanceStyles[appearance],
            (0, $8XtVW.fg)('platform_design_system_team_safari_input_fix') && $bd1ec11728b3e01f$var$fontStyles['large'],
            $bd1ec11728b3e01f$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $bd1ec11728b3e01f$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $awdRS.default)($bd1ec11728b3e01f$var$lineHeightCompact * minimumRows + $bd1ec11728b3e01f$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $awdRS.default)($bd1ec11728b3e01f$var$lineHeightBase * minimumRows + $bd1ec11728b3e01f$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $bd1ec11728b3e01f$var$TextArea = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($bd1ec11728b3e01f$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$bd1ec11728b3e01f$var$TextArea.displayName = 'TextArea';
var $bd1ec11728b3e01f$export$2e2bcd8739ae039 = $bd1ec11728b3e01f$var$TextArea;

});

const $e382814c341184bc$export$5cdf10537498e072 = '232px';

parcelRegister("4GEuJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54d2e08763e74ff$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a54d2e08763e74ff$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-textarea.update-button-text",
        "defaultMessage": "Update"
    },
    textAreaPlaceholder: {
        "id": "jql-builder-basic-textarea.text-area-placeholder",
        "defaultMessage": "Begin typing..."
    }
});

});


parcelRegister("6cdzW", function(module, exports) {

$parcel$export(module.exports, "useIqlValidation", () => $3855fabe06311dda$export$e39e6ad91e20e4a0);

var $eJOHy = parcelRequire("eJOHy");

var $1kTCl = parcelRequire("1kTCl");

var $51aj0 = parcelRequire("51aj0");

var $7GNC3 = parcelRequire("7GNC3");

var $2dx7O = parcelRequire("2dx7O");
const $3855fabe06311dda$var$IQL_VALIDATE_DELAY = 300;
const $3855fabe06311dda$var$getInitialStateForIql = (newUnvalidatedIql)=>({
        unvalidatedIql: newUnvalidatedIql,
        validationResult: newUnvalidatedIql === (0, $7GNC3.EMPTY_VALIDATED_IQL) ? {
            type: 'valid',
            validatedIql: (0, $7GNC3.EMPTY_VALIDATED_IQL)
        } : {
            type: 'loading'
        }
    });
const $3855fabe06311dda$export$e39e6ad91e20e4a0 = ({ workspaceId: workspaceId, initialIql: initialIql })=>{
    const [state, setState] = (0, $eJOHy.useState)({
        unvalidatedIql: String(initialIql),
        validationResult: {
            type: 'valid',
            validatedIql: initialIql
        }
    });
    // Debounce calls to prevent validation being requested on every key press
    const [debouncedValidate] = (0, $1kTCl.default)(async (newUnvalidatedIql)=>{
        let newValidationResult;
        try {
            if (!workspaceId) return;
            newValidationResult = await (0, $2dx7O.validateQlQuery)({
                workspaceId: workspaceId,
                unvalidatedIql: newUnvalidatedIql
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'validateIql',
                    packageName: 'jiraServicedeskInsightIqlValidation',
                    teamName: 'aurum'
                }
            });
            newValidationResult = {
                type: 'invalid',
                error: error.message
            };
        }
        setState((prevState)=>{
            // If unvalidatedIql in the state has changed since this was called, this means the user has changed the IQL
            // making this current request invalid.
            if (prevState.unvalidatedIql !== newUnvalidatedIql) return prevState;
            return {
                unvalidatedIql: newUnvalidatedIql,
                validationResult: newValidationResult
            };
        });
    }, $3855fabe06311dda$var$IQL_VALIDATE_DELAY);
    const onChange = (0, $eJOHy.useCallback)((newUnvalidatedIql)=>{
        const newState = $3855fabe06311dda$var$getInitialStateForIql(newUnvalidatedIql);
        setState(newState);
        if (newState.validationResult.type === 'valid') return;
        debouncedValidate(newUnvalidatedIql);
    }, [
        debouncedValidate,
        setState
    ]);
    return [
        state,
        {
            onChange: onChange
        }
    ];
};

});
parcelRegister("7GNC3", function(module, exports) {

$parcel$export(module.exports, "EMPTY_VALIDATED_IQL", () => $2b8911246c28aaf6$export$f3e6582beacb59ad);

var $3VjNa = parcelRequire("3VjNa");
const $2b8911246c28aaf6$export$f3e6582beacb59ad = (0, $3VjNa.toValidatedIql)('');

});
parcelRegister("3VjNa", function(module, exports) {

$parcel$export(module.exports, "toValidatedIql", () => $f119345919c992e3$export$d2a6b8af2abc27c3);
const $f119345919c992e3$export$d2a6b8af2abc27c3 = (value)=>value;

});


parcelRegister("2dx7O", function(module, exports) {

$parcel$export(module.exports, "validateQlQuery", () => $c696c8cdc5303cfd$export$24689a54c49a777b);

var $u4YbY = parcelRequire("u4YbY");

var $aXuRT = parcelRequire("aXuRT");

var $3VjNa = parcelRequire("3VjNa");
const $c696c8cdc5303cfd$export$24689a54c49a777b = async ({ workspaceId: workspaceId, unvalidatedIql: unvalidatedIql })=>{
    const queryLanguageKey = 'qlQuery';
    const { isValid: isValid, errorMessages: errorMessages } = await (0, $u4YbY.performCmdbPostRequest)((0, $aXuRT.getCmdbQueryLanguageValidateUrl)(workspaceId), {
        body: JSON.stringify({
            context: 'ADVANCED_SEARCH',
            [queryLanguageKey]: unvalidatedIql
        })
    });
    if (isValid) return {
        type: 'valid',
        validatedIql: (0, $3VjNa.toValidatedIql)(unvalidatedIql)
    };
    return {
        type: 'invalid',
        error: errorMessages.join('')
    };
};

});
parcelRegister("aXuRT", function(module, exports) {

$parcel$export(module.exports, "getCmdbQueryLanguageValidateUrl", () => $d117fa7e71eb3fad$export$d8f39b0cf0b8673e);

var $1qZG3 = parcelRequire("1qZG3");
const $d117fa7e71eb3fad$var$getCmdbQueryLanguageUrl = (workspaceId)=>`${(0, $1qZG3.getCmdbRestBaseUrl)(workspaceId)}/aql`;
const $d117fa7e71eb3fad$export$d8f39b0cf0b8673e = (workspaceId)=>`${$d117fa7e71eb3fad$var$getCmdbQueryLanguageUrl(workspaceId)}/validate`;

});



parcelRegister("i10HP", function(module, exports) {

$parcel$export(module.exports, "default", () => $31525b398377bd13$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $31525b398377bd13$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    formatLabelMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.format-label-message",
        "defaultMessage": "AQL Query"
    },
    textAreaPlaceholder: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.text-area-placeholder",
        "defaultMessage": "Enter AQL Search"
    },
    aqlValidationInProgressMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.aql-validation-in-progress-message",
        "defaultMessage": "Validating AQL..."
    },
    inValidAqlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.in-valid-aql-error-message",
        "defaultMessage": "Please enter a valid AQL query"
    },
    aqlSyntaxHelpLinkLabel: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.aql-syntax-help-link-label",
        "defaultMessage": "Assets Query Language syntax help"
    },
    unableToValidateAqlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.unable-to-validate-aql-error-message",
        "defaultMessage": "Unable to validate AQL query"
    },
    retry: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.retry",
        "defaultMessage": "Retry"
    }
});

});


parcelRegister("aEcQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8048fff7250ffb6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fQnJZ = parcelRequire("fQnJZ");

var $gPqEA = parcelRequire("gPqEA");
var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $bQ4fi = parcelRequire("bQ4fi");

var $cNe2t = parcelRequire("cNe2t");


var $1xd19 = parcelRequire("1xd19");

var $19xe7 = parcelRequire("19xe7");

var $leDB3 = parcelRequire("leDB3");
const $d8048fff7250ffb6$export$957d7daebd899f12 = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: "inherit",
        as: "strong"
    }, label), ":\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d8048fff7250ffb6$var$ValueWrapper, null, value));
};
const $d8048fff7250ffb6$export$8ca1a6c3a31e7665 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); /**
                  * Note - despite the name, this actually handles the onClick
                  * of the 'Update' button that appears in the footer of the picker content,
                  * it does not get called on a change event
                  */ 
    const handleOnChange = (0, $eJOHy.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics
    ]);
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const getNumberPickerErrorMessage = (0, $eJOHy.useCallback)((inputValue)=>{
        if ((0, $19xe7.isUnsubmittedValueNotANumber)(inputValue)) return formatMessage((0, $leDB3.default).validNumberErrorMessage);
         // this assumes that value is a valid number
        if ((0, $19xe7.isUnsubmittedNumberTooLarge)((0, (/*@__PURE__*/$parcel$interopDefault($fQnJZ)))(inputValue))) return formatMessage((0, $leDB3.default).numberSizeLimitErrorMessage, {
            maxSize: (0, $c6374ddcf66d0147$export$3aefefab9ae0beef).toLocaleString()
        });
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.number-picker-popup.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                ref: ref,
                testId: `jql-builder-basic.ui.jql-editor.number.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $d8048fff7250ffb6$export$957d7daebd899f12(fieldDisplayName, value)),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQ4fi.default), {
                value: value || '',
                getErrorMessage: getNumberPickerErrorMessage,
                setInitialFocusRef: setInitialFocusRef,
                multiline: false,
                onChange: handleOnChange,
                placeholderText: formatMessage((0, $leDB3.default).numberPlaceholderMessage)
            })
    });
};
var $d8048fff7250ffb6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d8048fff7250ffb6$export$8ca1a6c3a31e7665;
const $d8048fff7250ffb6$var$ValueWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("leDB3", function(module, exports) {

$parcel$export(module.exports, "default", () => $eacf2101eadb05ce$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eacf2101eadb05ce$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    numberPlaceholderMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.number-placeholder-message",
        "defaultMessage": "Enter a number"
    },
    validNumberErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.valid-number-error-message",
        "defaultMessage": "Please enter a valid number"
    },
    numberSizeLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.number-size-limit-error-message",
        "defaultMessage": "Specify a number for the custom field (below {maxSize})"
    }
});

});


parcelRegister("gWc6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c9fabcea5d2ce2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gPqEA = parcelRequire("gPqEA");
var $h8epd = parcelRequire("h8epd");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $bQ4fi = parcelRequire("bQ4fi");

var $814y1 = parcelRequire("814y1");

var $cNe2t = parcelRequire("cNe2t");

var $eqSys = parcelRequire("eqSys");

var $1xd19 = parcelRequire("1xd19");


var $hsb9B = parcelRequire("hsb9B");

var $5d1TC = parcelRequire("5d1TC");
const $14c9fabcea5d2ce2$export$957d7daebd899f12 = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: "inherit",
        as: "strong"
    }, label), ': "', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($14c9fabcea5d2ce2$var$ValueWrapper, null, value), '"');
};
const $14c9fabcea5d2ce2$export$3f65fe93ad5d48a1 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, propType: propType, fieldType: fieldType, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); /**
                  * Note - despite the name, this actually handles the onClick
                  * of the 'Update' button that appears in the footer of the picker content,
                  * it does not get called on a change event
                  */ 
    const handleOnChange = (0, $eJOHy.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics
    ]);
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const getTextAreaPickerErrorMessage = (0, $eJOHy.useCallback)((inputValue)=>{
        if ((fieldType === (0, $814y1.TEXT_READONLY_CF_TYPE) || fieldType === (0, $814y1.TEXT_CF_TYPE) || propType === (0, $eqSys.TextAreaPropTypes).ExactText) && (0, $5d1TC.isUnsubmittedValueTooLong)(inputValue)) return formatMessage((0, $hsb9B.default).characterLimitErrorMessage, {
            maxChars: (0, $dac7ffb69b790f6c$export$bfd6231f3a02692b)
        });
        if (fieldType === (0, $814y1.URL_CF_TYPE) && !(0, $5d1TC.isValidUrl)(inputValue)) return formatMessage((0, $hsb9B.default).invalidUrlErrorMessage);
        return undefined;
    }, [
        fieldType,
        formatMessage,
        propType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.text-area-picker-popup.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                ref: ref,
                testId: `jql-builder-basic.ui.jql-editor.text-area.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $14c9fabcea5d2ce2$export$957d7daebd899f12(fieldDisplayName, value)),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQ4fi.default), {
                setInitialFocusRef: setInitialFocusRef,
                value: value || '',
                getErrorMessage: getTextAreaPickerErrorMessage,
                onChange: handleOnChange,
                multiline: fieldType !== (0, $814y1.URL_CF_TYPE)
            })
    });
};
var $14c9fabcea5d2ce2$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $14c9fabcea5d2ce2$export$3f65fe93ad5d48a1;
const $14c9fabcea5d2ce2$var$ValueWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
const $dac7ffb69b790f6c$export$bfd6231f3a02692b = 255;

parcelRegister("hsb9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $daacf239d67a430a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $daacf239d67a430a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    characterLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.text-area-picker-popup.character-limit-error-message",
        "defaultMessage": "You've reached the character limit ({maxChars})"
    },
    invalidUrlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.text-area-picker-popup.invalid-url-error-message",
        "defaultMessage": "Please enter a valid URL."
    }
});

});

parcelRegister("5d1TC", function(module, exports) {

$parcel$export(module.exports, "isUnsubmittedValueTooLong", () => $a52a5cfa90a1389c$export$6db449563fc820c1);
$parcel$export(module.exports, "isValidUrl", () => $a52a5cfa90a1389c$export$bef94a5618bf18bf);

const $a52a5cfa90a1389c$export$6db449563fc820c1 = (unsubmittedValue)=>unsubmittedValue.length > (0, $dac7ffb69b790f6c$export$bfd6231f3a02692b);
const $a52a5cfa90a1389c$export$bef94a5618bf18bf = (url)=>{
    // empty string is valid
    if (url === '') return true;
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
};

});


parcelRegister("7moyo", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $09603702ff96638f$export$1625bb7ada97d007);
$parcel$export(module.exports, "getUpdatedJqlWithAql", () => $09603702ff96638f$export$bfbecae194e14c6f);
$parcel$export(module.exports, "getAqlFromClause", () => $09603702ff96638f$export$dfeec2a4cb0aae8b);

var $2poie = parcelRequire("2poie");
var $3c1PD = parcelRequire("3c1PD");

var $dTJxm = parcelRequire("dTJxm");

var $eiIzV = parcelRequire("eiIzV");
const $09603702ff96638f$var$createTerminalClause = (fieldId, value, operator)=>// TODO: escapeBackslashes serves as a temporary patch to convert jqlTerm into a format suitable for creator API.
    // EM-6563 should resolve this by updating creator API to accept the semantic JQL value for jqlTerm currently returned by hydrateJqlQuery.
    (0, $2poie.default).terminalClause((0, $2poie.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $2poie.default).operator(operator), (0, $2poie.default).byText.valueOperand((0, $eiIzV.wrapWithQuotes)((0, $eiIzV.escapeBackslashes)(value))));
const $09603702ff96638f$export$1625bb7ada97d007 = (ast, clause, fieldId, value, operator)=>{
    if (!clause) {
        if (!value || !ast.query) return ast.represents;
        ast.query.appendClause($09603702ff96638f$var$createTerminalClause(fieldId, value, operator), (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
    } else if (!value) clause.remove();
    else {
        if (clause.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) && clause.operand?.operandType === (0, $f38290926d0398e2$export$38accfc5a5d1c113) && clause.operand.value === value && clause.operator?.value === operator) // If the clause already exists and the value is the same, return the original JQL
        // without modifying the AST. This is to prevent the introduction of stale clause objects.
        return ast.represents;
        clause.replace($09603702ff96638f$var$createTerminalClause(fieldId, value, operator));
    }
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};
const $09603702ff96638f$var$createAqlTerminalClause = (fieldId, value, operator)=>// TODO: escapeBackslashes serves as a temporary patch to convert jqlTerm into a format suitable for creator API.
    // EM-6563 should resolve this by updating creator API to accept the semantic JQL value for jqlTerm currently returned by hydrateJqlQuery.
    (0, $2poie.default).terminalClause((0, $2poie.default).field((0, $eiIzV.escapeBackslashes)(fieldId)), (0, $2poie.default).operator(operator), // Confirmed with the team that they prefer to use aqlFunction instead of iqlFunction
    (0, $2poie.default).byText.valueOperand(`${(0, $dTJxm.AQL_FUNCTION_NAME)}(${(0, $eiIzV.wrapWithQuotes)((0, $eiIzV.escapeBackslashes)(value))})`));
const $09603702ff96638f$export$bfbecae194e14c6f = (ast, clause, fieldId, value, operator)=>{
    if (!clause) {
        if (!value || !ast.query) return ast.represents;
        ast.query.appendClause($09603702ff96638f$var$createAqlTerminalClause(fieldId, value, operator), (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97));
    } else if (!value) clause.remove();
    else {
        if ($09603702ff96638f$export$dfeec2a4cb0aae8b(clause) === value && clause.operator?.value === operator) // If the clause already exists and the value is the same, return the original JQL
        // without modifying the AST. This is to prevent the introduction of stale clause objects.
        return ast.represents;
        clause.replace($09603702ff96638f$var$createAqlTerminalClause(fieldId, value, operator));
    }
    return (0, $3c1PD.print)(ast, {
        operatorCase: 'upper'
    });
};
const $09603702ff96638f$export$dfeec2a4cb0aae8b = (clause)=>clause && clause.clauseType === (0, $27a6760b07fae18c$export$ae56b4ef248a2b6a) && clause.operand && clause.operand.operandType === (0, $f38290926d0398e2$export$19c7c729db381f9d) && (clause.operand.function.value.toLowerCase() === (0, $dTJxm.AQL_FUNCTION_NAME).toLowerCase() || clause.operand.function.value.toLowerCase() === (0, $dTJxm.IQL_FUNCTION_NAME).toLowerCase()) && clause.operand.arguments[0].value || '';

});


parcelRegister("01FiY", function(module, exports) {

$parcel$export(module.exports, "UnsupportedPickerWrapper", () => $057edf7a7af93f5f$export$7b689f7721b0be1f);

var $eJOHy = parcelRequire("eJOHy");

var $h8epd = parcelRequire("h8epd");

var $aIgra = parcelRequire("aIgra");
var $dWTqn = parcelRequire("dWTqn");

var $lRq8t = parcelRequire("lRq8t");

var $5LwVz = parcelRequire("5LwVz");

var $boEdP = parcelRequire("boEdP");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $1xd19 = parcelRequire("1xd19");

var $lyPdT = parcelRequire("lyPdT");

var $kDsTX = parcelRequire("kDsTX");
const $057edf7a7af93f5f$export$7b689f7721b0be1f = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, onClose: onClose, onOpen: onOpen, onClear: onClear, onSwitchToJql: onSwitchToJql })=>{
    const isOpen = activePopupKey === fieldId;
    const handleOnTriggerClick = (0, $eJOHy.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const [ast] = (0, $lyPdT.useAST)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const onSwitchToJqlWrapper = (0, $eJOHy.useCallback)(()=>{
        if (onSwitchToJql) {
            onSwitchToJql();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jqlBuilderBasicUnsupportedField', {});
        }
    }, [
        createAnalyticsEvent,
        onSwitchToJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $5LwVz.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.unsupported-picker-wrapper.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1xd19.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!clause,
                onClick: handleOnTriggerClick,
                onClear: ()=>onClear(clause ? (0, $boEdP.default)(ast, clause) : undefined),
                testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
                fieldDescription: fieldDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                color: "inherit",
                weight: "medium"
            }, clause ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                as: "strong"
            }, fieldLabel) : fieldLabel)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aIgra.default), {
                actions: onSwitchToJql ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dWTqn.default), {
                    onClick: onSwitchToJqlWrapper
                }, formatMessage((0, $kDsTX.default).switchToJql)) : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                as: "p"
            }, formatMessage((0, $kDsTX.default).messageToCustomer, {
                fieldLabel: fieldLabel,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, chunks)
            })))
    });
};
var $057edf7a7af93f5f$export$2e2bcd8739ae039 = $057edf7a7af93f5f$export$7b689f7721b0be1f;

});
parcelRegister("dWTqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba47b39d2a11fc8$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $i7XOj = parcelRequire("i7XOj");

var $51Gwp = parcelRequire("51Gwp");

var $8XtVW = parcelRequire("8XtVW");

var $dPUtJ = parcelRequire("dPUtJ");
var $dhRXV = parcelRequire("dhRXV");
var $hBR2B = parcelRequire("hBR2B");
const $bba47b39d2a11fc8$var$stylesOld = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
const $bba47b39d2a11fc8$var$styles = {
    common: "_11c82smr",
    anchor: "_k48pi7a9",
    pressable: "_syaz14q2 _k48p1wq8 _bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $bba47b39d2a11fc8$var$SectionMessageAction = /*#__PURE__*/ (0, $eJOHy.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent && (0, $8XtVW.fg)('platform_section_message_action_migration')) {
        if (href) {
            if ((0, $8XtVW.fg)('platform_dst_section_message_actions_as_link')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    $bba47b39d2a11fc8$var$styles.common,
                    $bba47b39d2a11fc8$var$styles.anchor
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $51Gwp.default), {
                    testId: testId,
                    onClick: onClick,
                    href: href,
                    target: target,
                    children: children
                })
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dPUtJ.default), {
                testId: testId,
                onClick: onClick,
                href: href,
                xcss: (0, $i7XOj.cx)($bba47b39d2a11fc8$var$stylesOld.common, $bba47b39d2a11fc8$var$stylesOld.anchor),
                children: children
            });
        }
        if (onClick) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hBR2B.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $i7XOj.cx)((0, $8XtVW.fg)('platform_dst_section_message_actions_as_link') ? $bba47b39d2a11fc8$var$styles.common : $bba47b39d2a11fc8$var$stylesOld.common, (0, $8XtVW.fg)('platform_dst_section_message_actions_as_link') ? $bba47b39d2a11fc8$var$styles.pressable : $bba47b39d2a11fc8$var$stylesOld.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dhRXV.default), {
            as: "span",
            testId: testId,
            xcss: (0, $8XtVW.fg)('platform_dst_section_message_actions_as_link') && $bba47b39d2a11fc8$var$styles.common,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKpTa.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children
    });
});
var $bba47b39d2a11fc8$export$2e2bcd8739ae039 = $bba47b39d2a11fc8$var$SectionMessageAction;

});

parcelRegister("kDsTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b0a479a4e571bf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c6b0a479a4e571bf$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    all: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.all",
        "defaultMessage": "All"
    },
    switchToJql: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.switch-to-jql",
        "defaultMessage": "Switch to JQL"
    },
    messageToCustomer: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.message-to-customer",
        "defaultMessage": "To search by <b>{fieldLabel}</b>."
    }
});

});



parcelRegister("dlxet", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef4c50b29ad2a050$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $o0Fzr = parcelRequire("o0Fzr");

var $2poie = parcelRequire("2poie");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $8WkNi = parcelRequire("8WkNi");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $iRlQc = parcelRequire("iRlQc");

var $9dqYm = parcelRequire("9dqYm");

var $2ftMY = parcelRequire("2ftMY");

var $idYtD = parcelRequire("idYtD");

var $ixIfb = parcelRequire("ixIfb");

var $aBVhI = parcelRequire("aBVhI");
const $ef4c50b29ad2a050$export$d9f1e39ff1ffb511 = 'ORDER_BY_DROPDOWN';
/**
 * Replaces the default container element that wraps the picker content
 * so we can control its css properties
 */ const $ef4c50b29ad2a050$var$CustomPopupComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, 'data-testid': testId, xcss: _xcss, ...props }, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $ef4c50b29ad2a050$var$containerStyle,
        testId: testId,
        ...props,
        ref: ref
    }, children));
const $ef4c50b29ad2a050$var$OrderByPicker = ({ ast: ast, onChange: onChange, contextJql: contextJql, hydrationData: hydrationData, viewContext: viewContext, scope: scope })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [internalSelectedFields, setInternalSelectedFields] = (0, $eJOHy.useState)(()=>(0, $aBVhI.getNextSelectedOrderByFields)({
            ast: ast,
            hydrationData: hydrationData,
            selectedOrderByFields: []
        }));
    const firePickerAnalytics = (0, $eJOHy.useCallback)((isOpen, orderByFieldCount)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownMenu',
            actionSubjectId: 'orderByPicker',
            attributes: {
                isOpen: isOpen,
                orderByFieldCount: // So we can determine if the add field button needs to be
                // repositioned as long lists of fields mean it is needing to be
                // scrolled to
                orderByFieldCount
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup }] = (0, $9dqYm.useActivePopupKey)();
    const onOpen = (0, $eJOHy.useCallback)(()=>{
        openPopup($ef4c50b29ad2a050$export$d9f1e39ff1ffb511);
        firePickerAnalytics(true, internalSelectedFields.length);
    }, [
        firePickerAnalytics,
        internalSelectedFields.length,
        openPopup
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        firePickerAnalytics(false, internalSelectedFields.length);
        closePopup($ef4c50b29ad2a050$export$d9f1e39ff1ffb511);
    }, [
        closePopup,
        firePickerAnalytics,
        internalSelectedFields.length
    ]);
    const isOpen = activePopupKey === $ef4c50b29ad2a050$export$d9f1e39ff1ffb511;
    const buttonId = (0, $o0Fzr.useUID)();
    /**
	 * Popup does not want to close when users click browser back / forward buttons so manually
	 * compare the AST fields to the fields in the internal state, if they differ, the JQL was changed
	 * by an external action, so close the picker.
	 */ (0, $eJOHy.useEffect)(()=>{
        const astSortFields = (0, $idYtD.getAstSortFields)(ast);
        const isInternalChange = (0, $aBVhI.compareSortFields)(astSortFields, internalSelectedFields);
        if (!isInternalChange) onClose();
    }, [
        ast,
        internalSelectedFields,
        onClose
    ]);
    /**
	 * Changes to sort fields can come from internal (user interacting with the picker) or external
	 * (jql is changed by other means such as clicking a filter or browser back button). This means
	 * the picker needs to handle both scenarios and update the UI accordingly. This is achieved by
	 * comparing the ast, hydration data and what is currently internally tracked and deciding which
	 * sort fields to set in the next state
	 */ (0, $eJOHy.useEffect)(()=>{
        setInternalSelectedFields((currentInternalSelectedFields)=>(0, $aBVhI.getNextSelectedOrderByFields)({
                ast: ast,
                hydrationData: hydrationData,
                selectedOrderByFields: currentInternalSelectedFields
            }));
    }, [
        ast,
        hydrationData
    ]);
    /**
	 * any currently selected field becomes an excluded field so that duplicates cannot be selected
	 * in the picker(s)
	 */ const excludedFields = internalSelectedFields.map((selctedOrderByField)=>selctedOrderByField.jqlTerm);
    /**
	 * each rendered basic-picker within OrderBySelect uses this to fetch the picker options
	 */ const onLoadOptions = (0, $2ftMY.useFields)({
        jql: contextJql,
        excludeFields: excludedFields,
        forClause: 'ORDER_BY',
        viewContext: viewContext,
        scope: scope
    });
    /**
	 * attaches to a container element that wraps the picker and will prevent Esc key presses
	 * bubbling outside of the picker.
	 * This is needed for times when the picker might be rendered in a modal and we want
	 * users to be able to press Esc to close the picker, without also closing the modal.
	 */ const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Escape') {
            isOpen && event.stopPropagation();
            onClose();
        }
    }, [
        isOpen,
        onClose
    ]);
    /**
	 * Called each time the OrderBySelect fields change, are added or removed.
	 * This handler will take the new fields object, use it to update the ast which is printed to a
	 * string and passed to the onChange callback to trigger a new search
	 */ const handleOnChange = (0, $eJOHy.useCallback)((fields)=>{
        // If users have clicked the same option from a picker, no need to trigger a whole new
        // search
        const shouldUpdate = !(0, $aBVhI.compareSortFields)(internalSelectedFields, fields);
        if (shouldUpdate) {
            // Set the internal state so changes a immediately visible (optimistic update)
            setInternalSelectedFields(fields);
            // Trigger a new search as a side effect this will then be handled in the useEffects
            if (ast.query) {
                ast.query.replaceOrderBy((0, $2poie.default).orderBy(fields.map((f)=>(0, $2poie.default).orderByField((0, $2poie.default).field(f.jqlTerm), f.direction ? (0, $2poie.default).orderByDirection(f.direction) : undefined))));
                onChange((0, $aBVhI.printJast)(ast));
            }
        }
    }, [
        ast,
        internalSelectedFields,
        onChange
    ]);
    const handleOnClearAllFields = (0, $eJOHy.useCallback)(()=>{
        setInternalSelectedFields([]);
        if (ast.query) {
            ast.query.removeOrderBy();
            onChange((0, $aBVhI.printJast)(ast));
        }
    }, [
        ast,
        onChange
    ]);
    const renderContent = (0, $eJOHy.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            xcss: $ef4c50b29ad2a050$var$menuStyle,
            role: "presentation",
            ref: setInitialFocusRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8WkNi.default), {
            fields: internalSelectedFields,
            onLoadPickerOptions: onLoadOptions,
            onChange: handleOnChange
        })), Boolean(internalSelectedFields.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixIfb.default), {
            onClear: handleOnClearAllFields
        })), [
        internalSelectedFields,
        onLoadOptions,
        handleOnChange,
        handleOnClearAllFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        role: "dialog",
        titleId: buttonId,
        isOpen: isOpen,
        onClose: onClose,
        autoFocus: false,
        shouldRenderToParent: true,
        placement: "bottom-start",
        messageId: "jql-builder-basic.ui.jql-editor.order-by-picker.popup",
        messageType: "transactional",
        popupComponent: $ef4c50b29ad2a050$var$CustomPopupComponent,
        content: renderContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iRlQc.default), {
                isSelected: isOpen,
                buttonId: buttonId,
                triggerProps: triggerProps,
                numberOfFields: internalSelectedFields.length,
                onClick: isOpen ? onClose : onOpen
            })
    }));
};
var $ef4c50b29ad2a050$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($ef4c50b29ad2a050$var$OrderByPicker);
const $ef4c50b29ad2a050$var$containerStyle = (0, $5Wv5g.xcss)({
    zIndex: 'layer',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    width: '300px',
    borderRadius: 'border.radius'
});
const $ef4c50b29ad2a050$var$menuStyle = (0, $5Wv5g.xcss)({
    maxHeight: '284px',
    padding: 'space.150',
    paddingLeft: 'space.150',
    overflow: 'auto'
});

});
parcelRegister("8WkNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c9d92c9bfbd312c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gPqEA = parcelRequire("gPqEA");

var $kKLn8 = parcelRequire("kKLn8");

var $9y4v7 = parcelRequire("9y4v7");
const $5c9d92c9bfbd312c$var$BasicOrderBySelect = ({ fields: fields, onLoadPickerOptions: onLoadPickerOptions, onChange: onChange })=>{
    const onChangeField = (0, $eJOHy.useCallback)((index, field)=>{
        const nextFields = fields.map((currentField, currentIndex)=>index === currentIndex ? {
                ...field
            } : currentField);
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    const onRemoveField = (0, $eJOHy.useCallback)((index)=>{
        const nextFields = fields.filter((currentField, currentIndex)=>index !== currentIndex);
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    const onAddnewField = (0, $eJOHy.useCallback)((field)=>{
        const nextFields = [
            ...fields,
            field
        ];
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        gap: "space.100",
        direction: "column"
    }, fields.map((field, fieldIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9y4v7.default), {
            key: fieldIndex,
            field: field,
            fieldIndex: fieldIndex,
            onChange: onChangeField,
            onLoadOptions: onLoadPickerOptions,
            onRemove: onRemoveField
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKLn8.default), {
        onLoadOptions: onLoadPickerOptions,
        onSelectField: onAddnewField
    }));
};
var $5c9d92c9bfbd312c$export$2e2bcd8739ae039 = $5c9d92c9bfbd312c$var$BasicOrderBySelect;

});
parcelRegister("kKLn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cece478dfcf1a02e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


var $gPqEA = parcelRequire("gPqEA");

var $lRq8t = parcelRequire("lRq8t");

var $ixh2S = parcelRequire("ixh2S");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $cfy7S = parcelRequire("cfy7S");

var $7VqEq = parcelRequire("7VqEq");
const $cece478dfcf1a02e$var$FIELD_ID = 'add-order-by-field';
const $cece478dfcf1a02e$var$VALUE = [];
const $cece478dfcf1a02e$var$AddFieldPicker = ({ onLoadOptions: onLoadOptions, onSelectField: onSelectField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const handleTriggerClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen((currentisOpen)=>{
            const newOpenState = !currentisOpen;
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownMenu',
                actionSubjectId: 'addOrderByFieldPicker',
                attributes: {
                    isOpen: newOpenState
                }
            });
            return newOpenState;
        });
    }, [
        createAnalyticsEvent
    ]);
    const handlePickerCloseClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen(false);
    }, []);
    const handleFieldChanged = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        // @ts-expect-error TS inference not working with the SelectedValue type
        // despite explicit checks it always still thinks it might be an array or null
        // not sure of the root cause whether type defs in
        // jira/src/packages/jql-builder/basic-picker/src/common/types.tsx or TS issue at
        // the platform level
        if (newValue === null || Array.isArray(newValue) || !newValue.value || !newValue.label) return null;
        if (actionMeta.action === 'select-option') {
            const updatedField = {
                // @ts-expect-error see above
                displayText: newValue.label,
                // @ts-expect-error see above
                jqlTerm: newValue.value,
                direction: (0, $8ff9fbbb483161a6$export$6d60017b9e092e73)
            };
            onSelectField(updatedField);
            setIsOpen(false);
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'selectOption'
            }), 'addOrderByFieldPicker');
        }
    }, [
        createAnalyticsEvent,
        onSelectField
    ]);
    const onPickerTrigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cfy7S.default), {
            ariaLabel: formatMessage((0, $7VqEq.default).addFieldDisplayText),
            triggerProps: triggerProps,
            displayText: formatMessage((0, $7VqEq.default).addFieldDisplayText),
            onClick: handleTriggerClick,
            isOpen: isOpen
        }), [
        formatMessage,
        handleTriggerClick,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        isMulti: false,
        isOpen: isOpen,
        id: $cece478dfcf1a02e$var$FIELD_ID,
        value: $cece478dfcf1a02e$var$VALUE,
        onTrigger: onPickerTrigger,
        onClose: handlePickerCloseClick,
        onChange: handleFieldChanged,
        onLoadOptions: onLoadOptions,
        shouldRenderToParent: true
    }));
};
var $cece478dfcf1a02e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($cece478dfcf1a02e$var$AddFieldPicker);

});
parcelRegister("cfy7S", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c228f8d7f144dd9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $adDYm = parcelRequire("adDYm");

var $dKpTa = parcelRequire("dKpTa");
const $4c228f8d7f144dd9$var$PickerTrigger = ({ triggerProps: triggerProps, displayText: displayText, onClick: onClick, isOpen: isOpen, shouldFitContainer: shouldFitContainer = false, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4c228f8d7f144dd9$var$StyledTriggerButton, {
        ...triggerProps,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($adDYm))), {
            spacing: "spacious",
            label: "",
            size: "small"
        }),
        onClick: onClick,
        shouldFitContainer: shouldFitContainer,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        "aria-haspopup": "listbox"
    }, displayText);
var $4c228f8d7f144dd9$export$2e2bcd8739ae039 = $4c228f8d7f144dd9$var$PickerTrigger;
/*
 * Use of jira-jql-builder-basic-picker requires a trigger to be provided as a prop. In jql-builder,
 * atlaskit/button is used as a trigger. However our design spec is based on an atlaskit/select which
 * left aligns text on the trigger. This workaround is left aligning the text so that it looks more
 * like an atlaskit/select trigger.
 * This also restricts us to using legacy button as button/new does not work with `styled()`
 * TODO - https://jplat.jira.atlassian.cloud/browse/EM-7822
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides
const $4c228f8d7f144dd9$var$StyledTriggerButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $dKpTa.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1qpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7VqEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f04ee46c66a4b22$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4f04ee46c66a4b22$var$messages = (0, $7qGN1.defineMessages)({
    addFieldDisplayText: {
        "id": "jql-builder-basic-order-by-select.add-field-picker.add-field-display-text",
        "defaultMessage": "Select field"
    }
});
var $4f04ee46c66a4b22$export$2e2bcd8739ae039 = $4f04ee46c66a4b22$var$messages;

});


parcelRegister("9y4v7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66657688c3812d3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $24gpd = parcelRequire("24gpd");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $ixh2S = parcelRequire("ixh2S");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $cfy7S = parcelRequire("cfy7S");

var $euVK2 = parcelRequire("euVK2");

var $8YP3j = parcelRequire("8YP3j");

var $8XUsM = parcelRequire("8XUsM");

var $lFjNR = parcelRequire("lFjNR");
const $f66657688c3812d3$var$OrderByPicker = ({ field: field, fieldIndex: fieldIndex, onChange: onChange, onRemove: onRemove, onLoadOptions: onLoadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const pickerValue = (0, $eJOHy.useMemo)(()=>[
            {
                optionType: 'option',
                value: field.jqlTerm,
                label: field.displayText
            }
        ], [
        field.displayText,
        field.jqlTerm
    ]);
    const handleRemoveFieldButtonClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        e.preventDefault();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'orderBySelectRemoveFieldClick');
        onRemove(fieldIndex);
    }, [
        fieldIndex,
        onRemove
    ]);
    const handleTriggerClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen((currentisOpen)=>{
            const newOpenState = !currentisOpen;
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownMenu',
                actionSubjectId: 'orderBySelectFieldPicker',
                attributes: {
                    isOpen: newOpenState
                }
            });
            return newOpenState;
        });
    }, [
        createAnalyticsEvent
    ]);
    const handlePickerCloseClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen(false);
    }, []);
    const handleSortDirectionClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        e.preventDefault();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'orderBySelectSortDirectionClick');
        /**
     * It is expected that some order by fields in JQL dont have an explicit direction,
     * E.g. `ORDER BY project` instead of `ORDER BY project ASC`
     * In these cases if the direction is toggled, we add an explicit direction
     */ const updatedField = {
            ...field,
            direction: field.direction ? (0, $8XUsM.toggleDirection)(field.direction) : (0, $8YP3j.FALLBACK_SORT_DIRECTION)
        };
        onChange(fieldIndex, updatedField);
    }, [
        field,
        fieldIndex,
        onChange
    ]);
    const handleFieldChanged = (0, $eJOHy.useCallback)((newValue, actionMeta)=>{
        // @ts-expect-error TS inference not working with the SelectedValue type
        // despite explicit checks it always still thinks it might be an array or null
        // not sure of the root cause whether type defs in
        // jira/src/packages/jql-builder/basic-picker/src/common/types.tsx or TS issue at
        // the platform level
        if (newValue === null || Array.isArray(newValue) || !newValue.value || !newValue.label) return null;
        if (actionMeta.action === 'select-option') {
            const updatedField = {
                // @ts-expect-error see above
                displayText: newValue.label,
                // @ts-expect-error see above
                jqlTerm: newValue.value,
                direction: field.direction
            };
            onChange(fieldIndex, updatedField);
            setIsOpen(false);
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'selectOption'
            }), 'orderByFieldPicker');
        }
    }, [
        createAnalyticsEvent,
        field.direction,
        fieldIndex,
        onChange
    ]);
    const onPickerTrigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cfy7S.default), {
            triggerProps: triggerProps,
            displayText: field.displayText,
            onClick: handleTriggerClick,
            isOpen: isOpen,
            ariaLabel: formatMessage((0, $lFjNR.default).pickerLabel, {
                field: field.displayText
            }),
            shouldFitContainer: true
        }), [
        field.displayText,
        formatMessage,
        handleTriggerClick,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $f66657688c3812d3$var$pickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixh2S.Picker), {
        isMulti: false,
        isOpen: isOpen,
        id: `order-by-select-field-${fieldIndex}`,
        value: pickerValue,
        onTrigger: onPickerTrigger,
        onClose: handlePickerCloseClick,
        onChange: handleFieldChanged,
        onLoadOptions: onLoadOptions,
        shouldRenderToParent: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $f66657688c3812d3$var$sortButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        position: "bottom",
        content: formatMessage((0, $lFjNR.default).sortButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
            ...tooltipProps,
            onClick: handleSortDirectionClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euVK2.SortDirectionIcon), {
                fieldDisplayText: field.displayText,
                fieldSortDirection: field.direction
            })
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $f66657688c3812d3$var$clearButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        position: "bottom",
        content: formatMessage((0, $lFjNR.default).clearButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
            ...tooltipProps,
            appearance: "subtle",
            onClick: handleRemoveFieldButtonClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                as: "span",
                xcss: [
                    $f66657688c3812d3$var$iconButtonStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24gpd))), {
                LEGACY_size: "small",
                label: formatMessage((0, $lFjNR.default).clearButtonLabel, {
                    field: field.displayText
                })
            }))
        }))));
};
var $f66657688c3812d3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($f66657688c3812d3$var$OrderByPicker);
const $f66657688c3812d3$var$sortButtonContainerStyles = (0, $5Wv5g.xcss)({
    flex: 'none',
    marginLeft: 'space.075'
});
const $f66657688c3812d3$var$clearButtonContainerStyles = (0, $5Wv5g.xcss)({
    flex: 'none',
    marginLeft: 'space.150'
});
/**
 * There is a bug with the new Atlaskit IconButton where occasionally the onClick handler is not
 * triggered, when wrapped by a tooltip - https://atlassian.slack.com/archives/CFJ9DU39U/p1718597982581429
 * Instead, using a legacy button but making it appear 32px wide so that it looks like the new icon
 * button. Any narrower and it becomes an a11y issue having such a small click target
 */ const $f66657688c3812d3$var$iconButtonStyles = (0, $5Wv5g.xcss)({
    display: 'inline-block',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
const $f66657688c3812d3$var$pickerContainerStyles = (0, $5Wv5g.xcss)({
    flexGrow: '1',
    minWidth: '0'
});

});
parcelRegister("euVK2", function(module, exports) {

$parcel$export(module.exports, "SortDirectionIcon", () => $32511b2a80d3d997$export$a6df6c2e349e4183);

var $eJOHy = parcelRequire("eJOHy");

var $kUPGM = parcelRequire("kUPGM");

var $5DTbu = parcelRequire("5DTbu");


var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $duK9d = parcelRequire("duK9d");
const $32511b2a80d3d997$export$a6df6c2e349e4183 = ({ fieldDisplayText: fieldDisplayText, fieldSortDirection: fieldSortDirection })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "span",
        xcss: [
            fieldSortDirection === (0, $8ff9fbbb483161a6$export$6d60017b9e092e73) ? $32511b2a80d3d997$var$iconButtonStyles : $32511b2a80d3d997$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5DTbu))), {
        LEGACY_size: "small",
        label: formatMessage((0, $duK9d.default).sortButtonLabelAsc, {
            field: fieldDisplayText
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "span",
        xcss: [
            fieldSortDirection === (0, $8ff9fbbb483161a6$export$2ea27ea5f2121899) ? $32511b2a80d3d997$var$iconButtonStyles : $32511b2a80d3d997$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUPGM))), {
        LEGACY_size: "small",
        label: formatMessage((0, $duK9d.default).sortButtonLabelDesc, {
            field: fieldDisplayText
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "span",
        xcss: [
            fieldSortDirection === undefined ? $32511b2a80d3d997$var$iconButtonStyles : $32511b2a80d3d997$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUPGM))), {
        LEGACY_size: "small",
        label: formatMessage((0, $duK9d.default).sortButtonWithDefaultAscDirectionLabel, {
            field: fieldDisplayText
        })
    })));
};
/**
 * There is a bug with the new Atlaskit IconButton where occasionally the onClick handler is not
 * triggered, when wrapped by a tooltip - https://atlassian.slack.com/archives/CFJ9DU39U/p1718597982581429
 * Instead, using a legacy button but making it appear 32px wide so that it looks like the new icon
 * button. Any narrower and it becomes an a11y issue having such a small click target
 */ const $32511b2a80d3d997$var$iconButtonStyles = (0, $5Wv5g.xcss)({
    display: 'inline-block',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
/**
 * Used to hide the icon that is not currently mapped to the fieldSortDirection using CSS instead of
 * React.
 *
 * For example:
 * If the fieldSortDirection is ASC, the <ArrowDown> will receive this style and be hidden.
 *
 * using CSS to show the correct icon keeps both icons in the DOM whereas conditionally rendering
 * based on `fieldSortDirection` will remove the unrelated icon from the DOM completely, on click.

 * This removal from the DOM interferes with onClick management in popper:
 * jira/platform/packages/design-system/popup/src/use-close-manager.tsx
 *
 * In the above file, if an element has gone missing from the DOM, the onClose functionality will
 * return early and leave any open pickers still open. Instead I want any open pickers to close if the
 * user clicks on a button elsewhere on the page (such as clicking on this icon when it is in a button)
 */ const $32511b2a80d3d997$var$displayNoneStyle = (0, $5Wv5g.xcss)({
    display: 'none'
});

});
parcelRegister("kUPGM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c41b8a7a2a0e885f53178dceb7a8d3e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3a121f97f3293d4$var$_react = $f3a121f97f3293d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f3a121f97f3293d4$var$_arrowDown = $f3a121f97f3293d4$var$_interopRequireDefault((parcelRequire("2aes5")));

var $f3a121f97f3293d4$var$_arrowDown2 = $f3a121f97f3293d4$var$_interopRequireDefault((parcelRequire("jdKJu")));
function $f3a121f97f3293d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowDownIcon.
 * This component is ArrowDownIcon, with `UNSAFE_fallbackIcon` set to "ArrowDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f3a121f97f3293d4$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f3a121f97f3293d4$var$_react.default.createElement($f3a121f97f3293d4$var$_arrowDown.default, Object.assign({
        LEGACY_fallbackIcon: $f3a121f97f3293d4$var$_arrowDown2.default
    }, props));
$f3a121f97f3293d4$var$ArrowDownIcon.Name = 'ArrowDownIconMigration';
var $f3a121f97f3293d4$var$_default = module.exports.default = $f3a121f97f3293d4$var$ArrowDownIcon;

});
parcelRegister("2aes5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1937b9cd77cd6898$var$_react = $1937b9cd77cd6898$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1937b9cd77cd6898$var$_baseNew = $1937b9cd77cd6898$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $1937b9cd77cd6898$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1937b9cd77cd6898$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $1937b9cd77cd6898$var$_react.default.createElement($1937b9cd77cd6898$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$1937b9cd77cd6898$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $1937b9cd77cd6898$var$_default = module.exports.default = $1937b9cd77cd6898$var$ArrowDownIcon;

});

parcelRegister("jdKJu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dfe37b56c758e677$var$_react = $dfe37b56c758e677$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $dfe37b56c758e677$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfe37b56c758e677$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $dfe37b56c758e677$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props));
$dfe37b56c758e677$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $dfe37b56c758e677$var$_default = module.exports.default = $dfe37b56c758e677$var$ArrowDownIcon;

});


parcelRegister("5DTbu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ae9adc1e99d7e27810a205cdfaded7b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $010f68e1e306e671$var$_react = $010f68e1e306e671$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $010f68e1e306e671$var$_arrowUp = $010f68e1e306e671$var$_interopRequireDefault((parcelRequire("d627D")));

var $010f68e1e306e671$var$_arrowUp2 = $010f68e1e306e671$var$_interopRequireDefault((parcelRequire("k0Omy")));
function $010f68e1e306e671$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpIcon.
 * This component is ArrowUpIcon, with `UNSAFE_fallbackIcon` set to "ArrowUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $010f68e1e306e671$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $010f68e1e306e671$var$_react.default.createElement($010f68e1e306e671$var$_arrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $010f68e1e306e671$var$_arrowUp2.default
    }, props));
$010f68e1e306e671$var$ArrowUpIcon.Name = 'ArrowUpIconMigration';
var $010f68e1e306e671$var$_default = module.exports.default = $010f68e1e306e671$var$ArrowUpIcon;

});
parcelRegister("d627D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $988d7b502a1c0b9b$var$_react = $988d7b502a1c0b9b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $988d7b502a1c0b9b$var$_baseNew = $988d7b502a1c0b9b$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $988d7b502a1c0b9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $988d7b502a1c0b9b$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $988d7b502a1c0b9b$var$_react.default.createElement($988d7b502a1c0b9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$988d7b502a1c0b9b$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $988d7b502a1c0b9b$var$_default = module.exports.default = $988d7b502a1c0b9b$var$ArrowUpIcon;

});

parcelRegister("k0Omy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e91adfbb9201f57f$var$_react = $e91adfbb9201f57f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $e91adfbb9201f57f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e91adfbb9201f57f$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $e91adfbb9201f57f$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props));
$e91adfbb9201f57f$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $e91adfbb9201f57f$var$_default = module.exports.default = $e91adfbb9201f57f$var$ArrowUpIcon;

});


parcelRegister("duK9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a9935928166541$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f8a9935928166541$var$messages = (0, $7qGN1.defineMessages)({
    sortButtonLabelAsc: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-label-asc",
        "defaultMessage": "{field} ordered by ascending. Reverse order"
    },
    sortButtonLabelDesc: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-label-desc",
        "defaultMessage": "{field} ordered by descending. Reverse order"
    },
    sortButtonWithDefaultAscDirectionLabel: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-with-default-asc-direction-label",
        "defaultMessage": "{field} does not have a sort direction. Set the direction to ascending"
    }
});
var $f8a9935928166541$export$2e2bcd8739ae039 = $f8a9935928166541$var$messages;

});


parcelRegister("8YP3j", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SORT_DIRECTION", () => $05b45ef94ee30373$export$252fa5d135c32113);

const $05b45ef94ee30373$export$252fa5d135c32113 = (0, $8ff9fbbb483161a6$export$6d60017b9e092e73);

});

parcelRegister("8XUsM", function(module, exports) {

$parcel$export(module.exports, "toggleDirection", () => $ae48da4b32a67b00$export$1af131c8fc2061e9);

const $ae48da4b32a67b00$export$1af131c8fc2061e9 = (previousDirection)=>previousDirection === (0, $8ff9fbbb483161a6$export$6d60017b9e092e73) ? (0, $8ff9fbbb483161a6$export$2ea27ea5f2121899) : (0, $8ff9fbbb483161a6$export$6d60017b9e092e73);

});

parcelRegister("lFjNR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b969e901663be05$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8b969e901663be05$var$messages = (0, $7qGN1.defineMessages)({
    sortButtonTooltip: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.sort-button-tooltip",
        "defaultMessage": "Reverse order direction"
    },
    clearButtonTooltip: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.clear-button-tooltip",
        "defaultMessage": "Remove field"
    },
    clearButtonLabel: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.clear-button-label",
        "defaultMessage": "Remove {field}"
    },
    pickerLabel: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.picker-label",
        "defaultMessage": "{field} selected"
    }
});
var $8b969e901663be05$export$2e2bcd8739ae039 = $8b969e901663be05$var$messages;

});



parcelRegister("ixIfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2721563b9887dcd7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $fAfwV = parcelRequire("fAfwV");
const $2721563b9887dcd7$var$FooterButton = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'orderByClearSelectedItems', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        xcss: $2721563b9887dcd7$var$footerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $2721563b9887dcd7$var$buttonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "subtle-link",
        onClick: handleClick
    }, formatMessage((0, $fAfwV.default).buttonText))));
};
var $2721563b9887dcd7$export$2e2bcd8739ae039 = $2721563b9887dcd7$var$FooterButton;
const $2721563b9887dcd7$var$footerStyle = (0, $5Wv5g.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    justifyContent: 'start',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $2721563b9887dcd7$var$buttonStyle = (0, $5Wv5g.xcss)({
    padding: 'space.050',
    alignSelf: 'center',
    // left padding + left margin should total to 12px to match other picker types.
    marginInlineStart: 'space.100'
});

});
parcelRegister("fAfwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3233e82309e890a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3233e82309e890a0$var$messages = (0, $7qGN1.defineMessages)({
    buttonText: {
        "id": "jql-builder-basic.jql-editor.order-by-picker.footer.button-text",
        "defaultMessage": "Clear selection"
    }
});
var $3233e82309e890a0$export$2e2bcd8739ae039 = $3233e82309e890a0$var$messages;

});


parcelRegister("aBVhI", function(module, exports) {

$parcel$export(module.exports, "compareSortFields", () => $20a7cee1b2f4a4d0$export$d1fbc8ef95bdef46);
$parcel$export(module.exports, "getNextSelectedOrderByFields", () => $20a7cee1b2f4a4d0$export$d06db05a248b8bec);
$parcel$export(module.exports, "printJast", () => $20a7cee1b2f4a4d0$export$bfda6e07879dd093);

var $3c1PD = parcelRequire("3c1PD");

var $idYtD = parcelRequire("idYtD");
const $20a7cee1b2f4a4d0$export$d1fbc8ef95bdef46 = (sortFields1, sortFields2)=>{
    if (sortFields1.length !== sortFields2.length) return false;
    return sortFields1.every((sortField, index)=>sortField.jqlTerm === sortFields2[index].jqlTerm && sortField.direction === sortFields2[index].direction);
};
const $20a7cee1b2f4a4d0$var$getHydrationDisplayNameMap = (hydrationData)=>{
    const hydrationMap = new Map();
    (hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery ?? hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.map((field)=>field.field && field.jqlTerm && hydrationMap.set(field.jqlTerm.toLowerCase(), field.field.displayName ?? ''));
    return hydrationMap;
};
const $20a7cee1b2f4a4d0$export$d06db05a248b8bec = ({ ast: ast, hydrationData: hydrationData, selectedOrderByFields: selectedOrderByFields })=>{
    const astSortFields = (0, $idYtD.getAstSortFields)(ast);
    const hydrationDisplayNameMap = $20a7cee1b2f4a4d0$var$getHydrationDisplayNameMap(hydrationData);
    const nextSelectedOrderByFields = astSortFields.map((astSortField)=>{
        let displayText;
        const hydratedDisplayName = hydrationDisplayNameMap.get(astSortField.jqlTerm.toLowerCase());
        const existingField = selectedOrderByFields.find((selectedOrderByField)=>selectedOrderByField.jqlTerm === astSortField.jqlTerm);
        if (hydratedDisplayName !== undefined) displayText = hydratedDisplayName;
        else displayText = existingField?.displayText ?? '';
        const selectedOrderByField = {
            displayText: displayText,
            jqlTerm: astSortField.jqlTerm,
            direction: astSortField.direction
        };
        return selectedOrderByField;
    });
    return nextSelectedOrderByFields;
};
const $20a7cee1b2f4a4d0$export$bfda6e07879dd093 = (jast)=>(0, $3c1PD.print)(jast, {
        operatorCase: 'upper'
    });

});


parcelRegister("hC1P1", function(module, exports) {

$parcel$export(module.exports, "AsyncRegisterSearchCriteriaToShortcutsDialog", () => $639f0e4e8d1708f4$export$f2345c1eb3a17e65);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bHRpp = parcelRequire("bHRpp");

var $gzcjr = parcelRequire("gzcjr");
var $fgHyA = parcelRequire("fgHyA");

var $lzg2Z = parcelRequire("lzg2Z");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $639f0e4e8d1708f4$var$RegisterSearchCriteriaToShortcutsDialog = (0, $gzcjr.lazy)(()=>(parcelRequire("g1K28")), {
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/register-search-criteria-to-shortcuts-dialog/index.tsx"
});
const $639f0e4e8d1708f4$export$f2345c1eb3a17e65 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $bHRpp.useShortcuts)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $lzg2Z.useIntegrateDotDialogContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue-navigatior-search-criteria-shortcuts-dialog",
        packageName: "jql-builder-basic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgHyA.LazyWait), {
        until: isShortcutsDialogIntegrationAvailable && isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($639f0e4e8d1708f4$var$RegisterSearchCriteriaToShortcutsDialog, props))));
};

});
parcelRegister("bHRpp", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $5ec870659f2b42dd$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $5ec870659f2b42dd$export$b331ee6e87b9104c);

var $fgHZ8 = parcelRequire("fgHZ8");
const $5ec870659f2b42dd$export$a1ca853c6e4bb6fb = ()=>(0, $fgHZ8.useShortcutsStore)();
const $5ec870659f2b42dd$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fgHZ8.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fgHZ8", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $1037d55a513c4cd3$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $1037d55a513c4cd3$export$1a29bfef7fa09838);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9rMca = parcelRequire("9rMca");
const $1037d55a513c4cd3$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $1037d55a513c4cd3$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $1037d55a513c4cd3$export$d4c72bab9d6cc13a,
    actions: $9rMca
});
const $1037d55a513c4cd3$export$a14646bfc7ba8d81 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9);
const $1037d55a513c4cd3$export$1a29bfef7fa09838 = (0, $iJq0l.createHook)($1037d55a513c4cd3$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("9rMca", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $bd65986ef711b2b7$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $bd65986ef711b2b7$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $bd65986ef711b2b7$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $bd65986ef711b2b7$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $bd65986ef711b2b7$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $bd65986ef711b2b7$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $bd65986ef711b2b7$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $bd65986ef711b2b7$export$9cf39adf0dec984);

var $2zs80 = parcelRequire("2zs80");

var $9FV9P = parcelRequire("9FV9P");

var $2TCxE = parcelRequire("2TCxE");
const $bd65986ef711b2b7$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $bd65986ef711b2b7$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $bd65986ef711b2b7$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $bd65986ef711b2b7$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $bd65986ef711b2b7$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $bd65986ef711b2b7$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $9FV9P.default)();
        const shortcuts = result ? (0, $2TCxE.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $bd65986ef711b2b7$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $bd65986ef711b2b7$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($2zs80)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("9FV9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9cd1634918b3cd3$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e9cd1634918b3cd3$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $1Ozm9.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("2TCxE", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $8b2ef73b57082485$export$5f8c94ecd4c9eb76);
const $8b2ef73b57082485$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$8b2ef73b57082485$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("g1K28", function(module, exports) {

let $0302d88edf4ca300$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0302d88edf4ca300$var$load("2Whsu").then(()=>parcelRequire('aAqp7'));

});


parcelRegister("8mM4q", function(module, exports) {

$parcel$export(module.exports, "TextSearchInput", () => $7f77d35c0ab62119$export$451fab4acd1fe94e);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $gRw8I = parcelRequire("gRw8I");

var $46Ypp = parcelRequire("46Ypp");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $1Zcfy = parcelRequire("1Zcfy");

var $ii7Oz = parcelRequire("ii7Oz");

var $itdlt = parcelRequire("itdlt");

var $ezGpi = parcelRequire("ezGpi");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $6XJko = parcelRequire("6XJko");

var $hsWsW = parcelRequire("hsWsW");

var $izTXQ = parcelRequire("izTXQ");

var $bNtSK = parcelRequire("bNtSK");

var $1gVNb = parcelRequire("1gVNb");

var $5jGSj = parcelRequire("5jGSj");

var $lyPdT = parcelRequire("lyPdT");

var $b06aK = parcelRequire("b06aK");

var $h9gPh = parcelRequire("h9gPh");

var $dTJxm = parcelRequire("dTJxm");
const $7f77d35c0ab62119$export$451fab4acd1fe94e = ({ onSearchWrapper: onSearchWrapper, onJourneyStart: onJourneyStart, shouldUseListMarkup: shouldUseListMarkup, placeholder: placeholder })=>{
    (0, $gRw8I.di)(requestAnimationFrame);
    const intl = (0, $lRq8t.default)();
    const [ast] = (0, $lyPdT.useAST)();
    const [textSearchInputClauseOld] = (0, $lyPdT.useTextSearchInputClause)();
    const textSearchInputClauseNew = (0, $hsWsW.useTextSearchInputClause)(ast, (0, $dTJxm.getTextSearchInputField)());
    const textSearchInputClause = (0, $7jTnu.fg)('shplxi_628_text_search_input_concurrent_fix') ? textSearchInputClauseNew : textSearchInputClauseOld;
    const sendOptionAnalytics = (0, $h9gPh.useSendOptionAnalytics)();
    const textSearchInputRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const value = (0, $eJOHy.useMemo)(()=>(0, $b06aK.default).value(textSearchInputClause) || '', [
        textSearchInputClause
    ]);
    const focusTextSearchInput = (0, $eJOHy.useCallback)(()=>{
        // This prevents the shortcut from being fed into the input
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(textSearchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(textSearchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                textSearchInputRef.current?.focus();
            });
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'pressed',
                actionSubject: 'keyboardShortcut'
            }), 'jqlEditorBasicSearchInputKeyboardShortcut', {
                keyPressed: 'f',
                keyboardShortcut: true
            });
        }
    }, [
        createAnalyticsEvent
    ]);
    const onTextFocus = (0, $eJOHy.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'refinementBarSearchInput', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const StyledListItemChildComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $bNtSK.default) : (0, $1gVNb.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $1gVNb.StyledChild);
    const commandShortcuts = (0, $fAZgY.useMemoWithCondition)(()=>({
            f: {
                callback: focusTextSearchInput,
                registerInCommandPalette: {
                    id: 'jql-builder-basic-jql-editor-text-picker-wrapper-focus-search-input',
                    name: intl.formatMessage((0, $izTXQ.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($46Ypp))), {
                                label: intl.formatMessage((0, $izTXQ.default).searchCurrentPage),
                                color: "var(--ds-icon, #44546F)"
                            })
                    },
                    priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        }), [
        focusTextSearchInput,
        getKeywords,
        intl
    ], ()=>(0, $7jTnu.fg)('jfp_magma_jsm-perf-improvement-batch-1'));
    const onChange = (0, $fAZgY.useCallbackWithCondition)((keyword)=>{
        onSearchWrapper && onSearchWrapper((0, $b06aK.default).update(ast, textSearchInputClause, keyword));
    }, [
        ast,
        onSearchWrapper,
        textSearchInputClause
    ], ()=>(0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezGpi.CommandShortcuts), {
        keyMap: commandShortcuts
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5jGSj.default), {
        label: placeholder !== undefined && (0, $6XJko.isVisualRefreshEnabled)() ? placeholder : intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $izTXQ.default).refinementSearchIssueTermRefresh : (0, $izTXQ.default).refinementSearch),
        value: value,
        onChange: onChange,
        onFocus: onJourneyStart ? onTextFocus : undefined,
        onSendOptionAnalytics: sendOptionAnalytics,
        inputRef: textSearchInputRef
    }));
};

});
parcelRegister("ezGpi", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $1e305c509eaf0223$export$7ff7e4fe85a5960a);

var $eJOHy = parcelRequire("eJOHy");

var $fWwfy = parcelRequire("fWwfy");

var $73jrx = parcelRequire("73jrx");

var $hf4h9 = parcelRequire("hf4h9");

var $3IF6p = parcelRequire("3IF6p");
const $1e305c509eaf0223$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eJOHy.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $hf4h9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eJOHy.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3IF6p.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $73jrx.RegisterCommands), {
        registrationId: (0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("73jrx", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $54ccbd2a3c61da6a$export$cd555833c78729f1);

var $eJOHy = parcelRequire("eJOHy");

var $3DnU9 = parcelRequire("3DnU9");
const $54ccbd2a3c61da6a$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3DnU9.RegisterCommandsWithRegistry), props);

});
parcelRegister("3DnU9", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $c82e68fcec934ed3$export$b8955a01360d2876);

var $cQKVu = parcelRequire("cQKVu");
function $c82e68fcec934ed3$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $cQKVu.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});


parcelRegister("3IF6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4ee5f40705d91a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");

var $7jTnu = parcelRequire("7jTnu");

var $hrKgE = parcelRequire("hrKgE");

var $kvNWh = parcelRequire("kvNWh");

var $676Hn = parcelRequire("676Hn");

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");

var $2ZGUP = parcelRequire("2ZGUP");

var $iUli2 = parcelRequire("iUli2");
let $ac4ee5f40705d91a$var$shortcutsCount = 0;
let $ac4ee5f40705d91a$var$subscription = null;
const $ac4ee5f40705d91a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $2ZGUP.ShortcutRegistryContext)) || (0, $dM9A7.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $iUli2.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $ac4ee5f40705d91a$var$shortcutsCount -= 1;
            if ($ac4ee5f40705d91a$var$subscription && $ac4ee5f40705d91a$var$shortcutsCount === 0) {
                $ac4ee5f40705d91a$var$subscription.unsubscribe();
                $ac4ee5f40705d91a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $ac4ee5f40705d91a$var$subscription = $ac4ee5f40705d91a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $b2ThO.default)().subscribe((0, $676Hn.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac4ee5f40705d91a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $kvNWh.useKeyboardShortcutsToggle), ...unstableProps })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, (0, $7jTnu.fg)('jfp-magma-concurrent-keyboard-shortcuts-fix-2'));
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac4ee5f40705d91a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("kvNWh", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $28efcafdf90afd66$export$a33a81f1fc5458ad);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $hWeHP = parcelRequire("hWeHP");

var $gCeeo = parcelRequire("gCeeo");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $28efcafdf90afd66$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $28efcafdf90afd66$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$28efcafdf90afd66$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $jGzN3.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $gYnSx.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $28efcafdf90afd66$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $28efcafdf90afd66$export$b62f67be35e65859
    }
});
const $28efcafdf90afd66$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($28efcafdf90afd66$var$Store);

});

parcelRegister("676Hn", function(module, exports) {

$parcel$export(module.exports, "default", () => $29a82f2f140805e4$export$2e2bcd8739ae039);

var $b2ThO = parcelRequire("b2ThO");

var $dM9A7 = parcelRequire("dM9A7");
const $29a82f2f140805e4$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$29a82f2f140805e4$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $dM9A7.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $b2ThO.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($29a82f2f140805e4$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $b2ThO.flush)();
    }
};

});
parcelRegister("b2ThO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb63e776564d4094$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $bb63e776564d4094$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $aBrUN = parcelRequire("aBrUN");
const $bb63e776564d4094$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $bb63e776564d4094$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$bb63e776564d4094$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bb63e776564d4094$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$bb63e776564d4094$var$isEditable(e.target) && !$bb63e776564d4094$var$ignoredKeys[e.key]);
const $bb63e776564d4094$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $bb63e776564d4094$var$key$;
const $bb63e776564d4094$var$flush$ = new (0, $6WhQS.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bb63e776564d4094$export$2e2bcd8739ae039 = ()=>{
    if (!$bb63e776564d4094$var$key$) {
        $bb63e776564d4094$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($bb63e776564d4094$var$isRelevantKeyEvent).filter($bb63e776564d4094$export$25d1b8252b4c49b7).map((0, $aBrUN.toKeyWithModifiers));
        const sequence$ = $bb63e776564d4094$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $bb63e776564d4094$var$key$ = $bb63e776564d4094$var$key$.debounceTime(1000).startWith(null).merge($bb63e776564d4094$var$flush$).switchMapTo(sequence$);
    }
    return $bb63e776564d4094$var$key$;
};
const $bb63e776564d4094$export$4909b86c8034bf73 = ()=>{
    $bb63e776564d4094$var$flush$.next();
};

});


parcelRegister("iUli2", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $0344ad6591542af9$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");
const $0344ad6591542af9$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $7jTnu.fg)('log-hotkey-analytics')) (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $0344ad6591542af9$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $0344ad6591542af9$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});



parcelRegister("hsWsW", function(module, exports) {

$parcel$export(module.exports, "useTextSearchInputClause", () => $0c17b9a1285fc13c$export$53c45c55dec81810);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $6I82R = parcelRequire("6I82R");
const $0c17b9a1285fc13c$export$53c45c55dec81810 = (ast, textSearchInputJqlTerm)=>{
    return (0, $eJOHy.useMemo)(()=>{
        if (!textSearchInputJqlTerm || !(0, $7jTnu.fg)('shplxi_628_text_search_input_concurrent_fix')) return;
        const visitor = new (0, $6I82R.TextSearchInputClauseCollectingVisitor)(textSearchInputJqlTerm);
        return ast.query ? visitor.visit(ast.query) : undefined;
    }, [
        ast.query,
        textSearchInputJqlTerm
    ]);
};

});
parcelRegister("6I82R", function(module, exports) {

$parcel$export(module.exports, "TextSearchInputClauseCollectingVisitor", () => $b32decb6e5878568$export$c1b34301831f6e1a);

var $7ivol = parcelRequire("7ivol");
var $2nXMg = parcelRequire("2nXMg");
class $b32decb6e5878568$export$c1b34301831f6e1a extends (0, $7ivol.AbstractJastVisitor) {
    constructor(textSearchInputJqlTerm){
        super(), this.visitCompoundClause = (compoundClause)=>{
            const operator = compoundClause.operator.value;
            if (operator === (0, $f6a7331f12a1b6ec$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), undefined);
            if (operator === (0, $f6a7331f12a1b6ec$export$7b8f0a728d79a753)) {
                if (compoundClause.clauses.length !== 2) return;
                for (const clause of compoundClause.clauses){
                    // Check if contains the text search input clause
                    if (clause.accept(this)) return compoundClause;
                }
            }
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            if (fieldName === this.textSearchInputJqlTerm) return terminalClause;
        };
        this.textSearchInputJqlTerm = textSearchInputJqlTerm;
    }
    shouldVisitNextChild(node) {
        // Skip visiting operand subtrees, which aren't needed for clause collection and can make a big impact on performance
        return !(0, $2nXMg.isOperandNode)(node);
    }
    aggregateResult(aggregate, nextResult) {
        return aggregate ?? nextResult;
    }
    defaultResult() {
        return undefined;
    }
}

});



parcelRegister("4lOXU", function(module, exports) {

$parcel$export(module.exports, "useFieldsToRender", () => $066f028a7c522302$export$4b20ffbea08469cb);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $fvO8D = parcelRequire("fvO8D");

var $hoXMy = parcelRequire("hoXMy");

var $6vt5P = parcelRequire("6vt5P");

var $byNye = parcelRequire("byNye");
const $066f028a7c522302$export$4b20ffbea08469cb = ({ query: query, loading: loading, fieldsHydrationData: fieldsHydrationData, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const intl = (0, $lRq8t.default)();
    const comparator = (0, $byNye.useLocaleCompare)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $fvO8D.useSearchState)();
    const [internalState, setInternalState] = (0, $eJOHy.useReducer)((oldState, newState)=>({
            ...oldState,
            ...newState
        }), {
        internalJql: query,
        fieldsToRender: [],
        selectedFields: [],
        optionalFieldsCount: 0,
        showLoadingState: loading
    }, (initialState)=>{
        const { internalJql: internalJql, showLoadingState: showLoadingState } = initialState;
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $hoXMy.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        const selectedFields = (0, $6vt5P.getSelectedFields)({
            fieldsToRender: fieldsToRender,
            intl: intl,
            comparator: comparator,
            irremovableFields: irremovableFields
        });
        return {
            internalJql: internalJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            optionalFieldsCount: optionalFieldsCount,
            showLoadingState: showLoadingState
        };
    });
    (0, $eJOHy.useEffect)(()=>{
        const { fieldsToRender: fieldsToRender, selectedFields: selectedFields, internalJql: internalJql } = internalState;
        const isExternalChange = internalJql !== query;
        const { fieldsToRender: newFieldsToRender, optionalFieldsCount: optionalFieldsCount, missingHydration: missingHydration } = (0, $hoXMy.gatherFields)({
            selectedFields: isExternalChange ? [] : selectedFields,
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            previousFieldToRender: !isExternalChange ? fieldsToRender : [],
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        const newSelectedFields = (0, $6vt5P.getSelectedFields)({
            fieldsToRender: newFieldsToRender,
            intl: intl,
            comparator: comparator,
            irremovableFields: irremovableFields
        });
        setInternalState({
            showLoadingState: missingHydration,
            fieldsToRender: newFieldsToRender,
            selectedFields: newSelectedFields,
            optionalFieldsCount: optionalFieldsCount,
            ...isExternalChange ? {
                internalJql: query
            } : {}
        });
    }, // When the query changes, we want to ensure fieldsToRender and selectedFields display as desired.
    // To prevent extraneous calls to useEffect, we leave out all dependencies besides query and fieldsHydrationData.
    // Where required, selectedFields state will be updated before query is.
    // We also assume that ast only changes when query also does.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        query,
        fieldsHydrationData
    ]);
    return {
        internalState: internalState,
        setInternalState: setInternalState
    };
};

});
parcelRegister("6vt5P", function(module, exports) {

$parcel$export(module.exports, "getSelectedFields", () => $cb1289546e9da883$export$3edef1dcbe28a0c6);

var $eJOHy = parcelRequire("eJOHy");

var $h8epd = parcelRequire("h8epd");

var $epTsa = parcelRequire("epTsa");

var $cjRWP = parcelRequire("cjRWP");

var $fexQV = parcelRequire("fexQV");

var $dTJxm = parcelRequire("dTJxm");

var $kWaBc = parcelRequire("kWaBc");
const $cb1289546e9da883$export$3edef1dcbe28a0c6 = ({ fieldsToRender: fieldsToRender, comparator: comparator, intl: intl, irremovableFields: irremovableFields })=>fieldsToRender.filter(({ fieldId: fieldId })=>// should not be an irremovable field
        !irremovableFields.has(fieldId)).sort((a, b)=>comparator(a.fieldLabel || '', b.fieldLabel || '')).map(({ fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, picker: picker, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext })=>{
        const notInContextFieldMessageIssueTermRefreshGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $kWaBc.default).notInContextFieldMessageIssueTermRefreshGalaxia : (0, $kWaBc.default).notInContextFieldMessageIssueTermRefresh;
        const isDisabled = picker.searchTemplate === (0, $dTJxm.EPIC_LINK).searchTemplate;
        let isOnlyUnselectable = false;
        let disabledMessage = isDisabled ? intl.formatMessage((0, $kWaBc.default).deprecatedEpicMessage, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                    as: "strong",
                    color: "inherit",
                    size: "UNSAFE_small"
                }, chunks)
        }) : undefined;
        if (shouldShowInContext === false) {
            isOnlyUnselectable = true;
            disabledMessage = intl.formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? notInContextFieldMessageIssueTermRefreshGalaxia : (0, $kWaBc.default).notInContextFieldMessage);
        }
        if (isDisabled) {
            isOnlyUnselectable = true;
            disabledMessage = intl.formatMessage((0, $kWaBc.default).deprecatedEpicMessage, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
                        as: "strong",
                        color: "inherit",
                        size: "UNSAFE_small"
                    }, chunks)
            });
        }
        const icon = picker.fieldType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fexQV.FieldTypeIcon), {
            type: picker.fieldType,
            size: "small"
        }) : undefined;
        const fieldOption = {
            optionType: 'field',
            label: fieldLabel || '',
            value: fieldId,
            isOnlyUnselectable: isOnlyUnselectable,
            disabledMessage: disabledMessage,
            searchTemplate: picker.searchTemplate,
            fieldType: picker.fieldType,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $cjRWP.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            fieldTypeDisplayName: fieldTypeDisplayName,
            fieldDescription: fieldDescription,
            operators: picker.allowedOperators?.map((operator)=>operator.value)
        };
        return fieldOption;
    });

});
parcelRegister("kWaBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e25bd07c78b362c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4e25bd07c78b362c$var$messages = (0, $7qGN1.defineMessages)({
    deprecatedEpicMessage: {
        "id": "jql-builder-basic.utils.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    notInContextFieldMessage: {
        "id": "jql-builder-basic.utils.not-in-context-field-message",
        "defaultMessage": "This field is unavailable for the selected project and/or issue type."
    },
    notInContextFieldMessageIssueTermRefresh: {
        "id": "jql-builder-basic.utils.not-in-context-field-message-issue-term-refresh",
        "defaultMessage": "This field is unavailable for the selected project and/or work type."
    },
    notInContextFieldMessageIssueTermRefreshGalaxia: {
        "id": "jql-builder-basic.utils.not-in-context-field-message-issue-term-refresh-galaxia",
        "defaultMessage": "This field is unavailable for the selected space and/or work type."
    }
});
var $4e25bd07c78b362c$export$2e2bcd8739ae039 = $4e25bd07c78b362c$var$messages;

});


parcelRegister("byNye", function(module, exports) {

$parcel$export(module.exports, "useLocaleCompare", () => $2fa6f9970e06d7dd$export$b0592aef48e26713);

var $eJOHy = parcelRequire("eJOHy");

var $4qiFT = parcelRequire("4qiFT");

var $lvKO5 = parcelRequire("lvKO5");

var $7jTnu = parcelRequire("7jTnu");
const $2fa6f9970e06d7dd$export$b0592aef48e26713 = ()=>{
    const { locale: locale } = (0, $lvKO5.useTenantContext)();
    const collatorNew = (0, $eJOHy.useMemo)(()=>new Intl.Collator((0, $4qiFT.standardizeLocale)(locale), {
            sensitivity: 'base'
        }), [
        locale
    ]);
    const callbackComparator = (0, $eJOHy.useCallback)((x, y)=>collatorNew.compare(x, y), [
        collatorNew
    ]);
    // remove when cleaning up jql_builder_basic_ssr_stability_fixes
    const memoComparator = (0, $eJOHy.useMemo)(()=>{
        const collator = new Intl.Collator((0, $4qiFT.standardizeLocale)(locale), {
            sensitivity: 'base'
        });
        return collator.compare;
    }, [
        locale
    ]);
    return (0, $7jTnu.fg)('jql_builder_basic_ssr_stability_fixes') ? callbackComparator : memoComparator;
};

});




parcelRegister("6bDCV", function(module, exports) {

$parcel$export(module.exports, "AdvancedEditorWrapper", () => $df780609925fddc7$export$500c96524dd0cfc7);
$parcel$export(module.exports, "BeforeJqlBuilderContainer", () => $df780609925fddc7$export$c139d55dec6a3c8a);
$parcel$export(module.exports, "BeforeJqlBuilderListItemContainer", () => $df780609925fddc7$export$4245b33623eb8df4);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $i8x5n = parcelRequire("i8x5n");
var $5Wv5g = parcelRequire("5Wv5g");

var $6XJko = parcelRequire("6XJko");
const $df780609925fddc7$export$500c96524dd0cfc7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i8x5n.default), {
        xcss: [
            $df780609925fddc7$var$negativeMarginOffsetStyles,
            $df780609925fddc7$var$advancedEditorWrapperStyles
        ]
    }, children);
const $df780609925fddc7$export$c139d55dec6a3c8a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $df780609925fddc7$var$negativeMarginOffsetStyles
    }, children);
const $df780609925fddc7$export$4245b33623eb8df4 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "li",
        xcss: [
            $df780609925fddc7$var$negativeMarginOffsetStyles,
            (0, $6XJko.isVisualRefreshEnabled)() ? $df780609925fddc7$var$beforeJqlBuilderListItemContainer : $df780609925fddc7$var$beforeJqlBuilderListItemContainerOld
        ]
    }, children);
const $df780609925fddc7$var$negativeMarginOffsetStyles = (0, $5Wv5g.xcss)({
    marginBlock: 'space.050',
    marginLeft: 'space.0',
    marginRight: 'space.100'
});
const $df780609925fddc7$var$advancedEditorWrapperStyles = (0, $5Wv5g.xcss)({
    flexGrow: 1
});
const $df780609925fddc7$var$beforeJqlBuilderListItemContainerOld = (0, $5Wv5g.xcss)({
    listStyle: 'none',
    marginRight: 'space.050'
});
const $df780609925fddc7$var$beforeJqlBuilderListItemContainer = (0, $5Wv5g.xcss)({
    listStyle: 'none',
    marginRight: 'space.050',
    marginLeft: 'space.050'
});

});

parcelRegister("9HnR3", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcher", () => $a5ba1ce0559205da$export$639730063e548c7);
$parcel$export(module.exports, "SearchModeSwitcherWithTarget", () => $a5ba1ce0559205da$export$ed9a97307608e2d9);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $lHHP1 = parcelRequire("lHHP1");

var $dQ4Ik = parcelRequire("dQ4Ik");

var $6XJko = parcelRequire("6XJko");

var $56qWy = parcelRequire("56qWy");

var $2G5xc = parcelRequire("2G5xc");
const $a5ba1ce0559205da$export$639730063e548c7 = ({ isBasicModeDisabled: isBasicModeDisabled, onUpdateSearchMode: onUpdateSearchMode, searchMode: searchMode })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.search-mode-switcher.toggle-button.';
    const basicModeLabel = (0, $eJOHy.useMemo)(()=>{
        if ((0, $6XJko.isVisualRefreshEnabled)()) return isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
            content: formatMessage((0, $2G5xc.messages).basicModeDisabledTooltip),
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            as: "span",
            xcss: $a5ba1ce0559205da$var$labelStyles,
            color: "inherit"
        }, formatMessage((0, $2G5xc.messages).basicMode))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            as: "span",
            xcss: $a5ba1ce0559205da$var$labelStyles,
            color: "inherit"
        }, formatMessage((0, $2G5xc.messages).basicMode));
        return isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
            content: formatMessage((0, $2G5xc.messages).basicModeDisabledTooltip),
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
            size: "UNSAFE_small",
            weight: "semibold",
            color: "inherit"
        }, formatMessage((0, $2G5xc.messages).basicMode))) : formatMessage((0, $2G5xc.messages).basicMode);
    }, [
        formatMessage,
        isBasicModeDisabled
    ]);
    const options = [
        {
            id: (0, $56qWy.SEARCH_MODE_BASIC),
            label: basicModeLabel,
            isDisabled: isBasicModeDisabled,
            testId: `${testIdPrefix}${(0, $56qWy.SEARCH_MODE_BASIC)}`
        },
        {
            id: (0, $56qWy.SEARCH_MODE_ADVANCED),
            label: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                as: "span",
                xcss: $a5ba1ce0559205da$var$labelStyles,
                color: "inherit"
            }, formatMessage((0, $2G5xc.messages).advancedMode)) : formatMessage((0, $2G5xc.messages).advancedMode),
            testId: `${testIdPrefix}${(0, $56qWy.SEARCH_MODE_ADVANCED)}`
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQ4Ik.default), {
        label: formatMessage((0, $2G5xc.messages).label),
        options: options,
        selectedOption: searchMode,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange: (value)=>onUpdateSearchMode(value)
    });
};
const $a5ba1ce0559205da$export$ed9a97307608e2d9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
        engagementId: "nin.jql-builder.searchmode-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a5ba1ce0559205da$export$639730063e548c7, props));
const $a5ba1ce0559205da$var$labelStyles = (0, $5Wv5g.xcss)({
    font: 'font.body'
});

});
parcelRegister("lHHP1", function(module, exports) {

$parcel$export(module.exports, "NinChangeboardingContext", () => $c026bf20b22e170d$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $c026bf20b22e170d$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $c026bf20b22e170d$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $c026bf20b22e170d$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $c026bf20b22e170d$export$9e9f507adee88e58);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $bILK0 = parcelRequire("bILK0");

var $ecCxV = parcelRequire("ecCxV");

var $4elgJ = parcelRequire("4elgJ");

var $7jTnu = parcelRequire("7jTnu");

var $9ncIL = parcelRequire("9ncIL");

var $5Rrlj = parcelRequire("5Rrlj");

var $hqX3Z = parcelRequire("hqX3Z");

var $5gIAR = parcelRequire("5gIAR");
const $c026bf20b22e170d$var$sessionStorageProvider = (0, $4elgJ.createSessionStorageProvider)('', false);
const $c026bf20b22e170d$export$b349f970aff316d8 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $c026bf20b22e170d$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c026bf20b22e170d$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $c026bf20b22e170d$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hqX3Z.default), {
        engagementId: engagementId
    }, children);
};
const $c026bf20b22e170d$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    if (!isTourEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Rrlj.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $c026bf20b22e170d$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $eJOHy.useContext)($c026bf20b22e170d$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $ecCxV.useHelpPanelLink)();
    const onLearnMore = (0, $eJOHy.useCallback)(()=>{
        onOpenInProductHelpArticle((0, $9ncIL.LEARN_MORE_IPH_ARTICLE_ID));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldShowOptInFlag = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.get('showNinOptInFlag') : sessionStorage.getItem('showNinOptInFlag');
        if (isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInTitleIssueTermRefresh : (0, $5gIAR.default).successOptInTitle,
                description: (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5gIAR.default).successOptInDescIssueTermRefresh : (0, $5gIAR.default).successOptInDesc,
                messageId: 'issue-navigator-changeboarding.controllers.enable-nin-changeboarding.show-flag.success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $5gIAR.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $c026bf20b22e170d$var$sessionStorageProvider.remove('showNinOptInFlag') : sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("ecCxV", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $ceecb2ae691c2ef9$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $ceecb2ae691c2ef9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $51Gwp = parcelRequire("51Gwp");

var $7jTnu = parcelRequire("7jTnu");

var $hLzUY = parcelRequire("hLzUY");

var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $epTsa = parcelRequire("epTsa");
const $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $hLzUY.HELP_PANEL_ID), (0, $hLzUY.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $ceecb2ae691c2ef9$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $7jTnu.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $7jTnu.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $ceecb2ae691c2ef9$export$2e2bcd8739ae039 = $ceecb2ae691c2ef9$export$5a09250ffddd7fd1;
const $ceecb2ae691c2ef9$var$buttonWrapperStyles = null;
const $ceecb2ae691c2ef9$var$buttonWrapperSubtleStyles = null;

});

parcelRegister("9ncIL", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $1b1bba2c09c1943d$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $1b1bba2c09c1943d$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $1b1bba2c09c1943d$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $1b1bba2c09c1943d$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $1b1bba2c09c1943d$export$d0079916fe6800ac);
const $1b1bba2c09c1943d$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $1b1bba2c09c1943d$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $1b1bba2c09c1943d$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $1b1bba2c09c1943d$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $1b1bba2c09c1943d$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $1b1bba2c09c1943d$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("5Rrlj", function(module, exports) {

$parcel$export(module.exports, "AsyncSpotlightCard", () => $09a720f6524e2b48$export$40e85aa59c198f98);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $09a720f6524e2b48$var$SpotlightCard = (0, $gzcjr.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("3K64w")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $09a720f6524e2b48$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09a720f6524e2b48$var$SpotlightCard, props)));

});
parcelRegister("3K64w", function(module, exports) {

let $2b9a60ba1731ace1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2b9a60ba1731ace1$var$load("gEEPr").then(()=>parcelRequire('knqHM'));

});


parcelRegister("hqX3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a165742ed253731e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gbiVe = parcelRequire("gbiVe");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a165742ed253731e$var$EngagementSpotlightAsync = (0, $gzcjr.lazy)(()=>(parcelRequire("clLIq")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $a165742ed253731e$var$SpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a165742ed253731e$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
var $a165742ed253731e$export$2e2bcd8739ae039 = $a165742ed253731e$var$SpotlightTourTarget;

});
parcelRegister("clLIq", function(module, exports) {

let $8fdc75842e1a1e8f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8fdc75842e1a1e8f$var$load("1VRB2"),
    $8fdc75842e1a1e8f$var$load("bABhq"),
    $8fdc75842e1a1e8f$var$load("7vqGd"),
    $8fdc75842e1a1e8f$var$load("1Y4bq"),
    $8fdc75842e1a1e8f$var$load("h98h3")
]).then(()=>parcelRequire('6j7Nq'));

});


parcelRegister("5gIAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b48b63ba324164d9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b48b63ba324164d9$var$messages = (0, $7qGN1.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
    }
});
var $b48b63ba324164d9$export$2e2bcd8739ae039 = $b48b63ba324164d9$var$messages;

});


parcelRegister("dQ4Ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e786e53309ddc04$export$2e2bcd8739ae039);

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $jbvD9 = parcelRequire("jbvD9");

var $aCCNU = parcelRequire("aCCNU");
var $9e786e53309ddc04$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), (0, $jbvD9.ToggleButtons), (0, $aCCNU.default));

});
parcelRegister("jbvD9", function(module, exports) {

$parcel$export(module.exports, "ToggleButtons", () => $9a70f8414c11195b$export$34301fadafd0cd9d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $cPbpX = parcelRequire("cPbpX");
var $5Wv5g = parcelRequire("5Wv5g");
const $9a70f8414c11195b$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact, expDesignRefresh: expDesignRefresh })=>{
    const getButtonWithContext = (0, $eJOHy.useCallback)(({ option: option, isSelected: isSelected })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $cPbpX.default), {
            role: "radio",
            "aria-checked": isSelected,
            xcss: [
                expDesignRefresh ? $9a70f8414c11195b$var$baseStylesDesignRefresh : $9a70f8414c11195b$var$baseStyles,
                !isCompact && (expDesignRefresh ? $9a70f8414c11195b$var$wideStylesDesignRefresh : $9a70f8414c11195b$var$wideStyles),
                isSelected && (expDesignRefresh ? $9a70f8414c11195b$var$selectedStylesDesignRefresh : $9a70f8414c11195b$var$selectedStyles)
            ],
            onClick: (event, analyticsEvent)=>!isSelected && onChange(option.id, event, analyticsEvent),
            isDisabled: option.isDisabled,
            testId: option.testId,
            interactionName: option.interactionName,
            children: option.label
        }, option.id), [
        onChange,
        isCompact,
        expDesignRefresh
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role: "radiogroup",
        xcss: expDesignRefresh ? $9a70f8414c11195b$var$containerStylesDesignRefresh : $9a70f8414c11195b$var$containerStyles,
        "aria-label": label,
        as: "fieldset",
        children: options.map((option)=>getButtonWithContext({
                option: option,
                isSelected: option.id === selectedOption
            }))
    });
};
const $9a70f8414c11195b$var$containerStyles = (0, $5Wv5g.xcss)({
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.025',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $9a70f8414c11195b$var$containerStylesDesignRefresh = (0, $5Wv5g.xcss)({
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 6px)",
    padding: 'space.050',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $9a70f8414c11195b$var$baseStyles = (0, $5Wv5g.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    color: 'color.text.subtle',
    height: '26px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $9a70f8414c11195b$var$baseStylesDesignRefresh = (0, $5Wv5g.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 3px)",
    color: 'color.text.subtle',
    height: '24px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $9a70f8414c11195b$var$selectedStyles = (0, $5Wv5g.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $9a70f8414c11195b$var$selectedStylesDesignRefresh = (0, $5Wv5g.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $9a70f8414c11195b$var$wideStyles = (0, $5Wv5g.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $9a70f8414c11195b$var$wideStylesDesignRefresh = (0, $5Wv5g.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.100'
});

});

parcelRegister("aCCNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5f0ece3abdd2b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $dPMMf = parcelRequire("dPMMf");

var $ucEZR = parcelRequire("ucEZR");

var $g60Pz = parcelRequire("g60Pz");
let $df5f0ece3abdd2b7$var$uniqueId = 0;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df5f0ece3abdd2b7$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: options.length > 0,
            message: `ToggleButtons requires at least one option, but received ${options.length}`
        }));
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: (0, $g60Pz.findDuplicateIds)(options) === null,
            message: `ToggleButtons requires that every option has a unique ID, but received "${(0, $g60Pz.findDuplicateIds)(options)}" multiple times`
        }));
    (0, $g60Pz.assertPrecondition)(()=>({
            precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
            message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
        }));
    const [id] = (0, $eJOHy.useState)(()=>`toggle-buttons-${$df5f0ece3abdd2b7$var$uniqueId++}`);
    const fieldsetRef = (0, $eJOHy.useRef)(null);
    const selectedOptionRef = (0, $eJOHy.useRef)();
    const [selectedOptionPosition, setSelectedOptionPosition] = (0, $eJOHy.useState)();
    (0, $eJOHy.useEffect)(()=>{
        const fieldset = fieldsetRef.current;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function, jira/jira-ssr/no-unchecked-globals-usage
        if (!fieldset || !window.ResizeObserver) return ()=>{};
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resizeObserver = new window.ResizeObserver(()=>{
            const element = selectedOptionRef.current;
            if (element) setSelectedOptionPosition({
                left: element.offsetLeft,
                top: element.offsetTop,
                width: element.offsetWidth,
                height: element.offsetHeight
            });
        });
        resizeObserver.observe(fieldset);
        return ()=>{
            resizeObserver.unobserve(fieldset);
        };
    }, [
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df5f0ece3abdd2b7$var$Fieldset, {
        ref: fieldsetRef,
        selectedOptionPosition: selectedOptionPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("legend", null, label), options.map((option)=>{
        const isChecked = selectedOption === option.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ucEZR.default), {
            key: option.id,
            name: id,
            value: option.id,
            isChecked: isChecked,
            isDisabled: !!option.isDisabled,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | undefined' is not assignable to type 'Ref<OptionProps> | undefined'.
            ref: isChecked ? selectedOptionRef : undefined,
            testId: option.testId
        }, option.label);
    }));
};
// The !important rules are required so that we can use this mixin on selectors
// with arbitrary specificity
const $df5f0ece3abdd2b7$var$selectedOptionIndicator = {
    backgroundColor: `${"var(--ds-background-accent-gray-subtler, #DCDFE4)"} !important`,
    borderRadius: `${(0, $dPMMf.borderRadius)}px !important`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df5f0ece3abdd2b7$var$Fieldset = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ozn9do": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.left, "px"),
            "--_1ibdxcf": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.top, "px"),
            "--_1ggrzjo": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.width, "px"),
            "--_1797z6d": (0, $awdRS.default)(__cmplp.selectedOptionPosition?.height, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhkm7j4 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48p1pd9 _1p1dangw _syaz1fxt _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1e1midpf _p8t715vq _b4u715vq _1se6t94y _soiet94y _1jhnstnw _1r9t7mnp _kj6f1q9c _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _rfx31wa3 _1rusksj1 _qs2z1l1k _1cg61yx9 _mlfedkwg",
            __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
            __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
            __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
            __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
            __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
            !__cmplp.selectedOptionPosition && "_1ph31wa3 _15e9ksj1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ucEZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1a484822ee0f4ba$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
var $f1a484822ee0f4ba$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1a484822ee0f4ba$var$Container, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: isChecked,
        disabled: isDisabled,
        "data-testid": testId,
        onChange: (event)=>onChange(value, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: id
    }, children));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1a484822ee0f4ba$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _scffidpf _1yzy15vq _bgrh15vq _5hv9t94y _pytkt94y _khufstnw _11127mnp _1ru31q9c _1ioh1l7b _15pj1ule _d7ff1b66 _1j8612x7 _1qrc1b66 _4yng12x7 _1vzltlke _1hhy73ad _1emz73ad _1efl1lh4 _7el91vm4 _15pqglyw _vrjh166n _c2fy18uv _ynfu18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g60Pz", function(module, exports) {

$parcel$export(module.exports, "findDuplicateIds", () => $d27f41633e9b3601$export$e5f5e25214715ca1);
$parcel$export(module.exports, "assertPrecondition", () => $d27f41633e9b3601$export$5565eefbe4b468a0);
const $d27f41633e9b3601$export$e5f5e25214715ca1 = (options)=>{
    for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
        if (options[i].id === options[j].id) return options[i].id;
    }
    return null;
};
const $d27f41633e9b3601$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};

});



parcelRegister("2G5xc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $18b42aaff9bd3333$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $18b42aaff9bd3333$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        "id": "jql-builder.search-mode-switcher.label",
        "defaultMessage": "Select search mode"
    },
    basicModeDisabledTooltip: {
        "id": "jql-builder.search-mode-switcher.basic-mode-disabled-tooltip",
        "defaultMessage": "You can't switch to basic as the query is too complex or is invalid"
    },
    basicMode: {
        "id": "jql-builder.search-mode-switcher.basic-mode",
        "defaultMessage": "Basic"
    },
    advancedMode: {
        "id": "jql-builder.search-mode-switcher.advanced-mode",
        "defaultMessage": "JQL"
    }
});

});


parcelRegister("cOgRS", function(module, exports) {

$parcel$export(module.exports, "DefaultJqlBuilderContainer", () => $9c511170863b1d92$export$ef9307b2d2a6d612);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $6XJko = parcelRequire("6XJko");
const $9c511170863b1d92$export$ef9307b2d2a6d612 = ({ showAdvancedEditor: showAdvancedEditor, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: [
            $9c511170863b1d92$var$jqlBuilderContainerStyles,
            // eslint-disable-next-line no-nested-ternary
            showAdvancedEditor ? $9c511170863b1d92$var$jqlBuilderContainerAdvancedStyles : (0, $6XJko.isVisualRefreshEnabled)() ? $9c511170863b1d92$var$jqlBuilderContainerBasicStyles : $9c511170863b1d92$var$jqlBuilderContainerBasicStyleOld
        ]
    }, children);
const $9c511170863b1d92$var$jqlBuilderContainerStyles = (0, $5Wv5g.xcss)({
    display: 'flex',
    flexGrow: 1
});
const $9c511170863b1d92$var$jqlBuilderContainerBasicStyleOld = (0, $5Wv5g.xcss)({
    /* ExtraControls should wrap with refinements when we are NOT in advanced mode */ flexWrap: 'wrap',
    /* Advanced mode has a footer element with a min-height of 20px. When in basic mode, we need to
	  replicate this spacing (20px - negative margin from above) to ensure there is no layout jumping
	  when switching between search modes. */ marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.200',
    marginLeft: 'space.negative.025'
});
const $9c511170863b1d92$var$jqlBuilderContainerBasicStyles = (0, $5Wv5g.xcss)({
    /* ExtraControls should wrap with refinements when we are NOT in advanced mode */ flexWrap: 'wrap',
    /* Advanced mode has a footer element with a min-height of 20px. When in basic mode, we need to
      replicate this spacing (20px - negative margin from above) to ensure there is no layout jumping
      when switching between search modes. */ marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.200',
    marginLeft: 'space.negative.050'
});
const $9c511170863b1d92$var$jqlBuilderContainerAdvancedStyles = (0, $5Wv5g.xcss)({
    marginTop: 'space.negative.025',
    marginRight: 'space.negative.050',
    marginBottom: 'space.negative.050',
    marginLeft: 'space.negative.025'
});

});

parcelRegister("7bFFO", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcherContainer", () => $287e29c0bdf24804$export$c9785cf59aeeda5f);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $6zXPf = parcelRequire("6zXPf");
const $287e29c0bdf24804$export$c9785cf59aeeda5f = ({ testId: testId, children: children, isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $287e29c0bdf24804$var$getContainerXcss(isSearchModeSwitcherOnLeft),
        testId: testId
    }, children);
const $287e29c0bdf24804$var$getContainerXcss = (isSearchModeSwitcherOnLeft)=>{
    if ((0, $6zXPf.getWillShowNav4)()) {
        if (isSearchModeSwitcherOnLeft) return [
            $287e29c0bdf24804$var$searchModeSwitcherBaseContainerStyle
        ];
        return [
            $287e29c0bdf24804$var$searchModeSwitcherBaseContainerStyle,
            $287e29c0bdf24804$var$searchModeSwitcherRightAlignedContainerStyle
        ];
    }
    return [
        $287e29c0bdf24804$var$searchModeSwitcherContainerStyle
    ];
};
const $287e29c0bdf24804$var$searchModeSwitcherBaseContainerStyle = (0, $5Wv5g.xcss)({
    alignSelf: 'start',
    // The toggle container is inline aligned with the JQL editor, and needs to match the height to avoid any misalignment along the horizontal axis
    // However, prior to this change, it only matched the height because some of the content coincidentally matched the height of the left side elements
    // The following two styles will fix that height to match the JQL editor, and align the items to the vertical center
    minHeight: "var(--ds-space-400, 32px)",
    display: 'flex'
});
const $287e29c0bdf24804$var$searchModeSwitcherRightAlignedContainerStyle = (0, $5Wv5g.xcss)({
    marginTop: 'space.025',
    marginLeft: 'space.100'
});
const $287e29c0bdf24804$var$searchModeSwitcherContainerStyle = (0, $5Wv5g.xcss)({
    marginLeft: 'space.100',
    alignSelf: 'start',
    marginTop: 'space.025',
    // The toggle container is inline aligned with the JQL editor, and needs to match the height to avoid any misalignment along the horizontal axis
    // However, prior to this change, it only matched the height because some of the content coincidentally matched the height of the left side elements
    // The following two styles will fix that height to match the JQL editor, and align the items to the vertical center
    minHeight: "var(--ds-space-400, 32px)",
    display: 'flex'
});

});

parcelRegister("7ebli", function(module, exports) {

$parcel$export(module.exports, "Container", () => $cc291d339cbcb639$export$42a852a2b6b56249);
$parcel$export(module.exports, "BasicEditorListContainer", () => $cc291d339cbcb639$export$5937a18186f4570f);
$parcel$export(module.exports, "AdvancedEditorWrapperOld", () => $cc291d339cbcb639$export$806411edd2f9cae);
$parcel$export(module.exports, "Divider", () => $cc291d339cbcb639$export$2e0a83ec2e27ecbb);
$parcel$export(module.exports, "BeforeJqlBuilderContainerOld", () => $cc291d339cbcb639$export$73fdb9b5d8c2be74);
$parcel$export(module.exports, "BeforeJqlBuilderListItemContainerOld", () => $cc291d339cbcb639$export$8f3efeb4a3e584ee);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $cc291d339cbcb639$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$export$5937a18186f4570f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _16jlkb7n _1n261g80 _rcujidpf _o81cidpf _1l6uidpf _149midpf",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$var$negativeMarginOffsetStyles = {
    /* Parent EditorContainer has a negative margin to offset the margin of refinement bar controls. So now we need to
     offset the parent container negative margin to ensure UI controls are aligned properly. */ margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
};
const $cc291d339cbcb639$export$806411edd2f9cae = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s89ng6 _1e0c1txw _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1kl7zgxb _1e0c1txw _4cvr1h6o _4t3izwfg _19pk1b66 _18u01b66 _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _vchhusvi",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$export$73fdb9b5d8c2be74 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s89ng6",
            __cmplp.className
        ])
    });
});
const $cc291d339cbcb639$export$8f3efeb4a3e584ee = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18s89ng6 _qtt8glyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jn1oF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7e5efbb2c8bb629$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XJko = parcelRequire("6XJko");

var $7ebli = parcelRequire("7ebli");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c7e5efbb2c8bb629$var$StyledChild = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $c7e5efbb2c8bb629$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlidpf _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $c7e5efbb2c8bb629$var$ExtraControls = ({ searchMode: searchMode, renderExtraControls: renderExtraControls, shouldUseListMarkup: shouldUseListMarkup })=>{
    const extraControls = (0, $eJOHy.useMemo)(()=>renderExtraControls(), [
        renderExtraControls
    ]);
    const shouldApplyVisualRefreshChanges = (0, $6XJko.isVisualRefreshEnabled)();
    const content = shouldUseListMarkup ? extraControls.map((Component, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7e5efbb2c8bb629$var$StyledChild, {
            key: index
        }, index === 0 && !shouldApplyVisualRefreshChanges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            searchMode: searchMode
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7e5efbb2c8bb629$var$Container, null, !shouldApplyVisualRefreshChanges && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Divider), null), extraControls.map((Component, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
            key: index,
            searchMode: searchMode
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, extraControls.length > 0 && content);
};
var $c7e5efbb2c8bb629$export$2e2bcd8739ae039 = $c7e5efbb2c8bb629$var$ExtraControls;

});


parcelRegister("8ShlV", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderUIImplOld", () => $ac45ac8f498fde35$export$8d394b0b8f88059a);
$parcel$export(module.exports, "JQLBuilderUIImpl", () => $ac45ac8f498fde35$export$d33754885f040153);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $eM3Eu = parcelRequire("eM3Eu");
var $fRacX = parcelRequire("fRacX");

var $gYnSx = parcelRequire("gYnSx");

var $lHHP1 = parcelRequire("lHHP1");

var $8t32G = parcelRequire("8t32G");

var $hrKgE = parcelRequire("hrKgE");

var $6MO8n = parcelRequire("6MO8n");
var $4GZBG = parcelRequire("4GZBG");

var $e1BYb = parcelRequire("e1BYb");

var $hHzDA = parcelRequire("hHzDA");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $l5UaK = parcelRequire("l5UaK");

var $gr39h = parcelRequire("gr39h");

var $bUnif = parcelRequire("bUnif");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $f1Zdy = parcelRequire("f1Zdy");

var $4Oene = parcelRequire("4Oene");

var $6XJko = parcelRequire("6XJko");

var $epTsa = parcelRequire("epTsa");

var $8FAu5 = parcelRequire("8FAu5");

var $bJscI = parcelRequire("bJscI");

var $ch9En = parcelRequire("ch9En");

var $7jTnu = parcelRequire("7jTnu");

var $56qWy = parcelRequire("56qWy");

var $6bDCV = parcelRequire("6bDCV");

var $cOgRS = parcelRequire("cOgRS");

var $cX22j = parcelRequire("cX22j");

var $7ebli = parcelRequire("7ebli");

var $jn1oF = parcelRequire("jn1oF");

var $34Sgq = parcelRequire("34Sgq");
const $ac45ac8f498fde35$export$8d394b0b8f88059a = ({ analyticsSource: analyticsSource, query: query, onSearch: onSearchProp, onUpdate: onUpdate, beforeControls: beforeControls, renderExtraControls: renderExtraControls, isSearching: isSearching, onLoad: onLoad, onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, jqlMessages: jqlMessages, excludedFields: excludedFields, searchModes: searchModes, selectedSearchMode: selectedSearchMode, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, components: components, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, showOrderByPicker: showOrderByPicker, contextJql: contextJql, loadingModeRef: loadingModeRef, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const jqlDebuggerStoreActions = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bUnif.useJqlDebuggerStoreActions)() : undefined;
    const irremovableFieldsAnalyticsAttributes = (0, $hHzDA.useIrremovableFieldsAnalyticsAttributes)(irremovableFields);
    const { searchMode: searchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $cX22j.useSelectedSearchMode)();
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    const onSwitchToJql = (0, $eJOHy.useCallback)(()=>{
        setSelectedSearchMode((0, $56qWy.SEARCH_MODE_ADVANCED), true);
    }, [
        setSelectedSearchMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const jqlErrors = (jqlMessages || []).filter((e)=>e.type === 'error');
        let jqlSanitized;
        if (jqlErrors?.length) {
            const errorAnalyticsEvent = createAnalyticsEvent({});
            if ((0, $7jTnu.fg)('nin_jqlbuilderjqlinvalid_analytics')) try {
                jqlSanitized = query && new (0, $eM3Eu.JastBuilder)().build(query).query?.accept(new (0, $fRacX.JqlAnonymizerVisitor)());
            } catch (error) {
                jqlSanitized = 'error sanitizing jql';
            }
            (0, $gYnSx.default)({
                event: errorAnalyticsEvent,
                meta: {
                    id: 'jqlBuilderJqlInvalid',
                    packageName: 'jiraJqlBuilder',
                    teamName: 'empanada'
                },
                attributes: {
                    jqlSanitized: jqlSanitized,
                    queryMode: searchMode
                }
            });
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onJqlBuilderAdvancedReady = (0, $eJOHy.useCallback)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_END
        });
        onReady && onReady((0, $56qWy.SEARCH_MODE_ADVANCED));
    }, [
        onPerformanceMark,
        onReady
    ]);
    const onJqlBuilderBasicReady = (0, $eJOHy.useCallback)(()=>{
        onReady && onReady((0, $56qWy.SEARCH_MODE_BASIC));
    }, [
        onReady
    ]);
    let onSearch = onSearchProp;
    // Keep onSearch undefined if onSearchProp is not provided, as a defined onSearch
    // will alter the behavior of the advanced JQL editor (e.g. rendering search button)
    if (onSearchProp) onSearch = (jql)=>{
        if ((0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) {
            if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH', jql);
            else jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH');
        }
        onSearchProp(jql);
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'search'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'jqlBuilder', {
            searchMode: searchMode
        });
    };
    const { SearchModeSwitcher: SearchModeSwitcher, EditorContainer: CustomEditorContainer } = components ?? {};
    const isSearchModeToggleEnabled = searchModes ? searchModes.length > 1 : true;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $6zXPf.getWillShowNav4)();
    const SearchModeSwitcherComponent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $34Sgq.SearchModeSwitcherRenderer), {
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            SearchModeSwitcher: SearchModeSwitcher,
            isHydrating: isHydrating,
            isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
        }), [
        SearchModeSwitcher,
        isHydrating,
        isSearchModeSwitcherOnLeft,
        isSearchModeToggleEnabled
    ]);
    const BeforeJqlBuilderContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderContainer) : (0, $7ebli.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderListItemContainer) : (0, $7ebli.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.AdvancedEditorWrapper) : (0, $7ebli.AdvancedEditorWrapperOld);
    // We need to memoize props before passing it into useMemo because an object splat is a new reference on every render
    const editorForwardedProps = (0, $hrKgE.useShallowStableReference)(props, (0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const Editor = (0, $eJOHy.useMemo)(()=>{
        let jqlBuilderComponent;
        switch(searchMode){
            case 0, $56qWy.SEARCH_MODE_BASIC:
                jqlBuilderComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-basic"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MO8n.JQLBuilderBasicOldAsync), {
                    query: query,
                    // consumers can hide search feature from advanced jql editor by not passing onSearch Handler
                    // if no onSearch handler is passed, Basic JQL editor would fallback to onUpdate handler
                    onSearch: onSearch || onUpdate || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                    onSwitchToJql: onSwitchToJql,
                    excludedFields: excludedFields,
                    onReady: onJqlBuilderBasicReady,
                    onJourneyStart: onJourneyStart,
                    NoOptionComponent: NoOptionComponent,
                    hydrationQueryRef: hydrationQueryRef,
                    isHydrating: isHydrating,
                    shouldUseListMarkup: true,
                    hideOperatorDropdown: hideOperatorDropdownBasicMode,
                    irremovableFields: irremovableFields,
                    hideTextSearchInput: hideTextSearchInput,
                    searchPlaceholder: searchPlaceholder,
                    showOrderByPicker: showOrderByPicker,
                    contextJql: contextJql,
                    ...editorForwardedProps
                }));
                break;
            default:
                jqlBuilderComponent = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gr39h.JqlDebuggerJqlBuilderContextProvider), {
                    jqlMessages: jqlMessages,
                    query: query,
                    onSearch: onSearch
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8t32G.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    customComponents: {
                        ErrorMessage: (0, $l5UaK.JQLDebuggerTriggerButton)
                    },
                    ...editorForwardedProps
                }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8t32G.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    ...editorForwardedProps
                }))));
        }
        const BeforeJqlBuilderWrapper = searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
        const showSearchModeSwitcher = (0, $6XJko.isVisualRefreshEnabled)() ? isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft : isSearchModeSwitcherOnLeft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), showSearchModeSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, SearchModeSwitcherComponent), jqlBuilderComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jn1oF.default), {
            searchMode: searchMode,
            renderExtraControls: renderExtraControls,
            shouldUseListMarkup: searchMode === (0, $56qWy.SEARCH_MODE_BASIC)
        }));
    }, [
        searchMode,
        BeforeJqlBuilderListItemContainerComponent,
        BeforeJqlBuilderContainerComponent,
        beforeControls,
        isSearchModeToggleEnabled,
        isSearchModeSwitcherOnLeft,
        SearchModeSwitcherComponent,
        renderExtraControls,
        query,
        onSearch,
        onUpdate,
        onSwitchToJql,
        excludedFields,
        onJqlBuilderBasicReady,
        onJourneyStart,
        NoOptionComponent,
        hydrationQueryRef,
        isHydrating,
        hideOperatorDropdownBasicMode,
        irremovableFields,
        hideTextSearchInput,
        searchPlaceholder,
        showOrderByPicker,
        contextJql,
        editorForwardedProps,
        AdvancedEditorWrapperComponent,
        analyticsSource,
        jqlMessages,
        isSearching,
        onJqlBuilderAdvancedReady
    ]);
    const EffectiveJqlBuilderContainer = CustomEditorContainer ?? (0, $cOgRS.DefaultJqlBuilderContainer);
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Container), {
        "data-testid": "jql-builder",
        "data-vc": "jql-builder-ui-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EffectiveJqlBuilderContainer, {
        showAdvancedEditor: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED),
        "data-testid": "jql-builder.ui.effective-jql-builder-container"
    }, searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.BasicEditorListContainer), {
        "data-vc": "jql-builder-basic-editor-container"
    }, Editor) : Editor), !isSearchModeSwitcherOnLeft && SearchModeSwitcherComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "jqlBuilder",
        attributes: {
            selectedSearchMode: selectedSearchMode,
            queryMode: (0, $56qWy.mapSearchModeToAnalyticAtribute)[searchMode],
            ...irremovableFieldsAnalyticsAttributes,
            loadingMode: loadingModeRef.current
        }
    })));
};
const $ac45ac8f498fde35$export$4eaa27e39ff4ae8c = (0, $bJscI.componentWithFG)('render_jql_builder_in_ssr', (0, $e1BYb.default), (0, $6MO8n.default));
const $ac45ac8f498fde35$export$d33754885f040153 = ({ analyticsSource: analyticsSource, query: query, onSearch: onSearchProp, onUpdate: onUpdate, beforeControls: beforeControls, renderExtraControls: renderExtraControls, isSearching: isSearching, onLoad: onLoad, onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, jqlMessages: jqlMessages, excludedFields: excludedFields, searchModes: searchModes, selectedSearchMode: selectedSearchMode, hydrationData: hydrationData, components: components, hideOperatorDropdownBasicMode: hideOperatorDropdownBasicMode, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput, searchPlaceholder: searchPlaceholder, searchModeSwitcherLocation: searchModeSwitcherLocation, showOrderByPicker: showOrderByPicker, contextJql: contextJql, loadingModeRef: loadingModeRef, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const jqlDebuggerStoreActions = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $bUnif.useJqlDebuggerStoreActions)() : undefined;
    const irremovableFieldsAnalyticsAttributes = (0, $hHzDA.useIrremovableFieldsAnalyticsAttributes)(irremovableFields);
    const { searchMode: searchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $cX22j.useSelectedSearchMode)();
    const { hydrationQueryIsFetching: hydrationQueryIsFetching } = (0, $8FAu5.useHydrationQuery)();
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    const onSwitchToJql = (0, $eJOHy.useCallback)(()=>{
        setSelectedSearchMode((0, $56qWy.SEARCH_MODE_ADVANCED), true);
    }, [
        setSelectedSearchMode
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const jqlErrors = (jqlMessages || []).filter((e)=>e.type === 'error');
        let jqlSanitized;
        if (jqlErrors?.length) {
            if ((0, $7jTnu.fg)('nin_jqlbuilderjqlinvalid_analytics')) try {
                jqlSanitized = query && new (0, $eM3Eu.JastBuilder)().build(query).query?.accept(new (0, $fRacX.JqlAnonymizerVisitor)());
            } catch (error) {
                jqlSanitized = 'error sanitizing jql';
            }
            const errorAnalyticsEvent = createAnalyticsEvent({});
            (0, $gYnSx.default)({
                event: errorAnalyticsEvent,
                meta: {
                    id: 'jqlBuilderJqlInvalid',
                    packageName: 'jiraJqlBuilder',
                    teamName: 'empanada'
                },
                attributes: {
                    jqlSanitized: jqlSanitized,
                    queryMode: searchMode
                }
            });
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onJqlBuilderAdvancedReady = (0, $eJOHy.useCallback)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_END
        });
        onReady && onReady((0, $56qWy.SEARCH_MODE_ADVANCED));
    }, [
        onPerformanceMark,
        onReady
    ]);
    const onJqlBuilderBasicLoad = (0, $eJOHy.useCallback)(()=>{
        onLoad && onLoad((0, $56qWy.SEARCH_MODE_BASIC));
    }, [
        onLoad
    ]);
    const onJqlBuilderBasicReady = (0, $eJOHy.useCallback)(()=>{
        onReady && onReady((0, $56qWy.SEARCH_MODE_BASIC));
    }, [
        onReady
    ]);
    let onSearch = onSearchProp;
    // Keep onSearch undefined if onSearchProp is not provided, as a defined onSearch
    // will alter the behavior of the advanced JQL editor (e.g. rendering search button)
    if (onSearchProp) onSearch = (jql)=>{
        if ((0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) {
            if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH', jql);
            else jqlDebuggerStoreActions?.resetStatus('ON_NEW_JQL_SEARCH');
        }
        onSearchProp(jql);
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'search'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'jqlBuilder', {
            searchMode: searchMode
        });
    };
    const { SearchModeSwitcher: SearchModeSwitcher, EditorContainer: CustomEditorContainer } = components ?? {};
    const isSearchModeToggleEnabled = searchModes ? searchModes.length > 1 : true;
    const isSearchModeSwitcherOnLeft = searchModeSwitcherLocation === (0, $56qWy.SEARCH_MODE_SWITCHER_LEFT_LOCATION) && (0, $6zXPf.getWillShowNav4)();
    const BeforeJqlBuilderContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderContainer) : (0, $7ebli.BeforeJqlBuilderContainerOld);
    const BeforeJqlBuilderListItemContainerComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.BeforeJqlBuilderListItemContainer) : (0, $7ebli.BeforeJqlBuilderListItemContainerOld);
    const AdvancedEditorWrapperComponent = (0, $6XJko.isVisualRefreshEnabled)() ? (0, $6bDCV.AdvancedEditorWrapper) : (0, $7ebli.AdvancedEditorWrapperOld);
    const SearchModeSwitcherComponent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $34Sgq.SearchModeSwitcherRenderer), {
            isSearchModeToggleEnabled: isSearchModeToggleEnabled,
            SearchModeSwitcher: SearchModeSwitcher,
            isHydrating: hydrationQueryIsFetching,
            isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
        }), [
        SearchModeSwitcher,
        hydrationQueryIsFetching,
        isSearchModeSwitcherOnLeft,
        isSearchModeToggleEnabled
    ]);
    // We need to memoize props before passing it into useMemo because an object splat is a new reference on every render
    const editorForwardedProps = (0, $hrKgE.useShallowStableReference)(props, (0, $7jTnu.fg)('jfp-magma-stability-2025-07-16'));
    const Editor = (0, $eJOHy.useMemo)(()=>{
        let jqlBuilderComponent;
        switch(searchMode){
            case 0, $56qWy.SEARCH_MODE_BASIC:
                jqlBuilderComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-basic"
                }, false && (0, $7jTnu.fg)('render_jql_builder_in_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
                    name: "jql-builder-basic-fallback",
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.JQLBuilderBasicFallback), {
                        query: query,
                        excludedFields: excludedFields,
                        onLoad: onJqlBuilderBasicLoad,
                        shouldUseListMarkup: true,
                        irremovableFields: irremovableFields,
                        hideTextSearchInput: hideTextSearchInput,
                        searchPlaceholder: searchPlaceholder,
                        showOrderByPicker: showOrderByPicker
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac45ac8f498fde35$export$4eaa27e39ff4ae8c, {
                    query: query,
                    // consumers can hide search feature from advanced jql editor by not passing onSearch Handler
                    // if no onSearch handler is passed, Basic JQL editor would fallback to onUpdate handler
                    onSearch: onSearch || onUpdate || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                    onSwitchToJql: onSwitchToJql,
                    excludedFields: excludedFields,
                    onReady: onJqlBuilderBasicReady,
                    onJourneyStart: onJourneyStart,
                    NoOptionComponent: NoOptionComponent,
                    AddFilterButtonComponent: components?.AddFilterButtonComponent,
                    hydrationData: hydrationData,
                    isHydrating: hydrationQueryIsFetching,
                    shouldUseListMarkup: true,
                    hideOperatorDropdown: hideOperatorDropdownBasicMode,
                    irremovableFields: irremovableFields,
                    hideTextSearchInput: hideTextSearchInput,
                    searchPlaceholder: searchPlaceholder,
                    showOrderByPicker: showOrderByPicker,
                    contextJql: contextJql,
                    ...editorForwardedProps
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ac45ac8f498fde35$export$4eaa27e39ff4ae8c, {
                    query: query,
                    // consumers can hide search feature from advanced jql editor by not passing onSearch Handler
                    // if no onSearch handler is passed, Basic JQL editor would fallback to onUpdate handler
                    onSearch: onSearch || onUpdate || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                    onSwitchToJql: onSwitchToJql,
                    excludedFields: excludedFields,
                    onReady: onJqlBuilderBasicReady,
                    onJourneyStart: onJourneyStart,
                    NoOptionComponent: NoOptionComponent,
                    AddFilterButtonComponent: components?.AddFilterButtonComponent,
                    hydrationData: hydrationData,
                    isHydrating: hydrationQueryIsFetching,
                    shouldUseListMarkup: true,
                    hideOperatorDropdown: hideOperatorDropdownBasicMode,
                    irremovableFields: irremovableFields,
                    hideTextSearchInput: hideTextSearchInput,
                    searchPlaceholder: searchPlaceholder,
                    showOrderByPicker: showOrderByPicker,
                    contextJql: contextJql,
                    ...editorForwardedProps
                }));
                break;
            default:
                jqlBuilderComponent = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gr39h.JqlDebuggerJqlBuilderContextProvider), {
                    jqlMessages: jqlMessages,
                    query: query,
                    onSearch: onSearch
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8t32G.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    customComponents: {
                        ErrorMessage: (0, $l5UaK.JQLDebuggerTriggerButton)
                    },
                    ...editorForwardedProps
                }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4Oene.default), {
                    name: "jql-builder-advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lHHP1.NinChangeboardingTourTarget), {
                    engagementId: "nin.jql-builder.advanced"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AdvancedEditorWrapperComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8t32G.default), {
                    analyticsSource: analyticsSource,
                    onSearch: onSearch,
                    onUpdate: onUpdate,
                    query: query,
                    jqlMessages: jqlMessages,
                    isSearching: isSearching,
                    isCompact: true,
                    excludedAutocompleteFields: excludedFields,
                    onReady: onJqlBuilderAdvancedReady,
                    onJourneyStart: onJourneyStart,
                    ...editorForwardedProps
                }))));
        }
        const BeforeJqlBuilderWrapper = searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? BeforeJqlBuilderListItemContainerComponent : BeforeJqlBuilderContainerComponent;
        const showSearchModeSwitcher = (0, $6XJko.isVisualRefreshEnabled)() ? isSearchModeToggleEnabled && isSearchModeSwitcherOnLeft : isSearchModeSwitcherOnLeft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, beforeControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, beforeControls), showSearchModeSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BeforeJqlBuilderWrapper, null, SearchModeSwitcherComponent), jqlBuilderComponent, renderExtraControls && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jn1oF.default), {
            searchMode: searchMode,
            renderExtraControls: renderExtraControls,
            shouldUseListMarkup: searchMode === (0, $56qWy.SEARCH_MODE_BASIC)
        }));
    }, [
        searchMode,
        BeforeJqlBuilderListItemContainerComponent,
        BeforeJqlBuilderContainerComponent,
        isSearchModeToggleEnabled,
        isSearchModeSwitcherOnLeft,
        beforeControls,
        SearchModeSwitcherComponent,
        renderExtraControls,
        query,
        onSearch,
        onUpdate,
        onSwitchToJql,
        excludedFields,
        onJqlBuilderBasicLoad,
        onJqlBuilderBasicReady,
        onJourneyStart,
        NoOptionComponent,
        components?.AddFilterButtonComponent,
        hydrationData,
        hydrationQueryIsFetching,
        hideOperatorDropdownBasicMode,
        irremovableFields,
        hideTextSearchInput,
        searchPlaceholder,
        showOrderByPicker,
        contextJql,
        editorForwardedProps,
        AdvancedEditorWrapperComponent,
        jqlMessages,
        analyticsSource,
        isSearching,
        onJqlBuilderAdvancedReady
    ]);
    const EffectiveJqlBuilderContainer = CustomEditorContainer ?? (0, $cOgRS.DefaultJqlBuilderContainer);
    return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.Container), {
        "data-testid": "jql-builder",
        "data-vc": "jql-builder-ui-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EffectiveJqlBuilderContainer, {
        showAdvancedEditor: searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED),
        "data-testid": "jql-builder.ui.effective-jql-builder-container"
    }, searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ebli.BasicEditorListContainer), {
        "data-vc": "jql-builder-basic-editor-container"
    }, Editor) : Editor), !isSearchModeSwitcherOnLeft && SearchModeSwitcherComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "jqlBuilder",
        attributes: {
            selectedSearchMode: selectedSearchMode,
            queryMode: (0, $56qWy.mapSearchModeToAnalyticAtribute)[searchMode],
            ...irremovableFieldsAnalyticsAttributes,
            loadingMode: loadingModeRef.current
        }
    })));
};

});
parcelRegister("8t32G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e3a3c86068ea6cb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hDiPV = parcelRequire("hDiPV");

var $j6JBf = parcelRequire("j6JBf");
const $3e3a3c86068ea6cb$var$JQLBuilderAdvancedAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j6JBf.default), {
        ...props,
        JQLEditor: (0, $hDiPV.JQLEditorAsync)
    });
var $3e3a3c86068ea6cb$export$2e2bcd8739ae039 = $3e3a3c86068ea6cb$var$JQLBuilderAdvancedAsync;

});
parcelRegister("j6JBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b05a2bfbaf0fa4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $mEt3r = parcelRequire("mEt3r");

var $heaM3 = parcelRequire("heaM3");

var $luVGg = parcelRequire("luVGg");

var $1Zcfy = parcelRequire("1Zcfy");

var $ii7Oz = parcelRequire("ii7Oz");

var $itdlt = parcelRequire("itdlt");

var $ezGpi = parcelRequire("ezGpi");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $bILK0 = parcelRequire("bILK0");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $bUnif = parcelRequire("bUnif");

var $5fhUb = parcelRequire("5fhUb");

var $8KuTC = parcelRequire("8KuTC");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $5G60L = parcelRequire("5G60L");


var $0aNCs = parcelRequire("0aNCs");

var $kLjta = parcelRequire("kLjta");

var $3LacB = parcelRequire("3LacB");

var $bOvYj = parcelRequire("bOvYj");
const $70b05a2bfbaf0fa4$var$JQLBuilderAdvancedUI = (props)=>{
    (0, $gRw8I.di)(requestAnimationFrame);
    const { analyticsSource: analyticsSource, JQLEditor: JQLEditor, query: query, jqlMessages: jqlMessages, isCompact: isCompact, isSearching: isSearching, onUpdate: onUpdate, onReady: onReady, onSearch: onSearch, excludedAutocompleteFields: excludedAutocompleteFields, onJourneyStart: onJourneyStart, autoFocus: autoFocus, viewContext: viewContext = null, scope: scope = null, customComponents: customComponents, isFieldIncludedInAutocomplete: isFieldIncludedInAutocomplete } = props;
    const onPerformanceMark = (0, $8KuTC.usePerformanceContext)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $5fhUb.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_ADVANCED_JS_START
        });
    }, [
        onPerformanceMark
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onHydrate = (0, $bOvYj.useOnHydrate)(viewContext, scope);
    const getInitialData = (0, $kLjta.useAutocompleteInitialData)(excludedAutocompleteFields, isFieldIncludedInAutocomplete);
    const getSuggestions = (0, $3LacB.useAutocompleteSuggestions)();
    const autocompleteProvider = (0, $luVGg.useAutocompleteProvider)(analyticsSource, getInitialData, getSuggestions);
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const onExperienceStart = (0, $8Uqf3.useExperienceStart)({
        experienceId: undefined,
        experience: (0, $7b5dd06670889591$export$abc61f74b6bec12c),
        analyticsSource: analyticsSource
    });
    const onExperienceFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $7b5dd06670889591$export$abc61f74b6bec12c)
    });
    const onExperienceSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: (0, $7b5dd06670889591$export$abc61f74b6bec12c)
    });
    const { setIsReadyForProactive: setIsReadyForProactive } = (0, $bUnif.useJqlDebuggerStoreActions)();
    const onError = (0, $eJOHy.useCallback)((error)=>{
        showFlag({
            type: 'error',
            title: (0, $0aNCs.default).errorFlagTitle,
            description: (0, $0aNCs.default).errorFlagDescription,
            messageId: 'jql-builder-advanced.ui.show-flag.error.error-flag',
            messageType: 'transactional'
        });
        // A success event may have already been fired on initial render. We need to start a new experience so we
        // can mark it as failed.
        onExperienceStart();
        onExperienceFail(analyticsSource, error);
        (0, $gYnSx.default)({
            meta: {
                id: (0, $7b5dd06670889591$export$abc61f74b6bec12c),
                packageName: (0, $7b5dd06670889591$export$b8b9d90f9e5bd72b),
                teamName: (0, $7b5dd06670889591$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        showFlag,
        onExperienceStart,
        onExperienceFail,
        analyticsSource
    ]);
    // Additional logging to debug unexpected (non-fatal) behaviour in the editor.
    const onDebugUnsafeMessage = (0, $eJOHy.useCallback)((message, event)=>{
        (0, $eSnSE.default).unsafeErrorWithCustomerData('jiraJqlBuilderAdvanced.onDebugUnsafeMessage', message, event);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Start the view experience on mount. This experience will be marked as successful by the JQLBuilderAdvancedUI
        // component upon render.
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const searchInputRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const focusSearchInput = (0, $eJOHy.useCallback)(()=>{
        // This is the same way the global search input prevents
        // the shortcut from being fed into the input
        // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
        requestAnimationFrame(()=>{
            searchInputRef?.current?.focus();
        });
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'jqlEditorAdvancedSearchInputKeyboardShortcut', {
            keyPressed: 'f',
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const onEditorMounted = (0, $eJOHy.useCallback)(()=>{
        onExperienceSuccess();
        if (autoFocus) focusSearchInput();
        onReady && onReady();
    }, [
        onExperienceSuccess,
        onReady,
        autoFocus,
        focusSearchInput
    ]);
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jqlEditorAdvancedSearchInput', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    const onEditorFocus = (0, $eJOHy.useCallback)(()=>{
        if (onJourneyStart) onFocus();
        setIsReadyForProactive(true);
    }, [
        onFocus,
        onJourneyStart,
        setIsReadyForProactive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ezGpi.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'jql-builder-advanced-focus-search-input',
                    name: formatMessage((0, $0aNCs.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mEt3r))), {
                                spacing: "spacious",
                                label: formatMessage((0, $0aNCs.default).searchCurrentPage)
                            })
                    },
                    priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JQLEditor, {
        inputRef: searchInputRef,
        analyticsSource: analyticsSource,
        query: query,
        messages: jqlMessages,
        isCompact: isCompact,
        isSearching: isSearching,
        onEditorMounted: onEditorMounted,
        onUpdate: onUpdate,
        onSearch: onSearch,
        onHydrate: onHydrate,
        onFocus: // eslint-disable-next-line no-nested-ternary
        (0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? onEditorFocus : onJourneyStart ? onFocus : undefined,
        autocompleteProvider: autocompleteProvider,
        onRenderError: onError,
        onDebugUnsafeMessage: onDebugUnsafeMessage,
        enableRichInlineNodes: true,
        customComponents: (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? customComponents : undefined
    }));
};
const $70b05a2bfbaf0fa4$var$JQLBuilderAdvancedUIWithAnalytics = (props)=>{
    const clientWrapper = (0, $eJOHy.useRef)((0, $5G60L.getAnalyticsWebClient)());
    return /* @ts-expect-error - Property 'analyticsClient' does not exist on type 'AnalyticsWebClient'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $heaM3.default), {
        client: clientWrapper.current?.analyticsClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "jqlBuilderAdvanced",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($70b05a2bfbaf0fa4$var$JQLBuilderAdvancedUI, props)));
};
var $70b05a2bfbaf0fa4$export$2e2bcd8739ae039 = $70b05a2bfbaf0fa4$var$JQLBuilderAdvancedUIWithAnalytics;

});
parcelRegister("heaM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $48e7fe078739b275$export$2e2bcd8739ae039);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/FabricEditorListener.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dbq8g = parcelRequire("dbq8g");

var $gbF4j = parcelRequire("gbF4j");

var $5ZKYQ = parcelRequire("5ZKYQ");

var $ktzPh = parcelRequire("ktzPh");
class $48e7fe078739b275$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props), this.handleEventWrapper = (event)=>{
            (0, $5ZKYQ.handleEvent)(event, this.logger, this.props.client);
        };
        this.logger = new (0, $ktzPh.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dbq8g.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $gbF4j.ANALYTICS_CHANNEL),
            children: this.props.children
        });
    }
}

});
parcelRegister("gbF4j", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $f2a826c223b239aa$export$85183a312807388d);
$parcel$export(module.exports, "EventType", () => $f2a826c223b239aa$export$3d7865934588d77e);
const $f2a826c223b239aa$export$85183a312807388d = 'jql-editor';
var $f2a826c223b239aa$export$3d7865934588d77e = /*#__PURE__*/ function(EventType) {
    EventType["OPERATIONAL"] = "operational";
    EventType["SCREEN"] = "screen";
    EventType["TRACK"] = "track";
    EventType["UI"] = "ui";
    return EventType;
}({});

});

parcelRegister("5ZKYQ", function(module, exports) {

$parcel$export(module.exports, "handleEvent", () => $e204721f38c10510$export$d6e5ca10785815df);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/handle-event.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $fT0tz = parcelRequire("fT0tz");

var $7j1TU = parcelRequire("7j1TU");
const $e204721f38c10510$export$d6e5ca10785815df = (event, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $7j1TU.processEventPayload)(event);
    (0, $fT0tz.sendEvent)(logger, client)(payload);
};

});
parcelRegister("fT0tz", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $e55973de1297e87d$export$7329bcdc3edcd90e);
/**
 * Copied from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/analytics-web-client-wrapper.ts
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ const $e55973de1297e87d$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $e55973de1297e87d$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const gasEvent = {
                ...event
            };
            /*
      Merging this ts-ignore is not going to affect the type definitions of the package
      there's a whole lot more wrong going on here than just this delete.
      All the send methods on the client take a GasPurePayload object which requires actionSubject
      actionSubject is missing on GasPayload | GasScreenEventPayload
    */ // @ts-ignore mergeable @fixme TypeScript 4.2.4 upgrade
            delete gasEvent.eventType;
            const withClient = (cb)=>{
                if ($e55973de1297e87d$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("7j1TU", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", () => $3b1c35dada892fe2$export$c37d638b7f2ca192);
/**
 * Adapted from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/fabric/process-event-payload.tsx
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ 
var $1O6Yz = parcelRequire("1O6Yz");

const $3b1c35dada892fe2$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, item), {});
const $3b1c35dada892fe2$var$fieldExtractor = ()=>$3b1c35dada892fe2$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId'
    ]);
const $3b1c35dada892fe2$var$updatePayloadWithContext = (event)=>{
    if (event.context.length === 0) return {
        source: (0, $27c7fc6638bd7614$export$b055de0e665cb20c),
        ...event.payload
    };
    const fields = $3b1c35dada892fe2$var$fieldExtractor()(event.context);
    return {
        source: (0, $27c7fc6638bd7614$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $3b1c35dada892fe2$export$c37d638b7f2ca192 = (event)=>{
    return $3b1c35dada892fe2$var$updatePayloadWithContext(event);
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $27c7fc6638bd7614$export$a1562d08625f5d7e = 'ui';
const $27c7fc6638bd7614$export$947dac6c72b26f81 = 'track';
const $27c7fc6638bd7614$export$f1d537d508d2945a = 'screen';
const $27c7fc6638bd7614$export$12346a674644c156 = 'operational';
const $27c7fc6638bd7614$export$b055de0e665cb20c = 'unknown';



parcelRegister("ktzPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e11dd22e63bc2c2$export$2e2bcd8739ae039);
/**
 * Copied from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/analytics/analytics-listeners/src/helpers/logger.ts
 * In future if this package is migrated into the Atlassian Frontend repo, then this code and related logic should be
 * moved into @atlaskit/analytics-listeners.
 */ const $3e11dd22e63bc2c2$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $3e11dd22e63bc2c2$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $3e11dd22e63bc2c2$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $3e11dd22e63bc2c2$export$ffe0c436e29512cf.DEBUG && logLevel <= $3e11dd22e63bc2c2$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $3e11dd22e63bc2c2$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) // eslint-disable-next-line no-console
        console[type](...args);
    }
    debug(...args) {
        this.logMessage($3e11dd22e63bc2c2$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($3e11dd22e63bc2c2$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($3e11dd22e63bc2c2$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($3e11dd22e63bc2c2$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});


parcelRegister("luVGg", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteProvider", () => $dfdf30fd49351d5c$export$2ae605545144a62d);

var $eJOHy = parcelRequire("eJOHy");

var $gKcSi = parcelRequire("gKcSi");

var $f3Bxu = parcelRequire("f3Bxu");

var $hrxfe = parcelRequire("hrxfe");

var $aho02 = parcelRequire("aho02");

var $lWTHF = parcelRequire("lWTHF");

var $7zhCa = parcelRequire("7zhCa");
const $dfdf30fd49351d5c$export$2ae605545144a62d = (/**
	 * Page/experience where the hook is being rendered. Used to correlate JQL analytics events to a given consumer.
	 */ analyticsSource, /**
	 * Fetch initial autocomplete data for fields and functions using the [Get field reference data API](https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-jql/#api-rest-api-3-jql-autocompletedata-post).
	 * Consumers can implement this method to configure which JS API will be used to make the request, e.g. Connect apps may
	 * wish to use the [AP.request API](https://developer.atlassian.com/cloud/jira/software/jsapi/request/).
	 */ getInitialData, /**
	 * Fetch autocomplete suggestions for field values using the [Get field autocomplete suggestions API](https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-jql/#api-rest-api-3-jql-autocompletedata-suggestions-get).
	 * Consumers can implement this method to configure which JS API will be used to make the request, e.g. Connect apps may
	 * wish to use the [AP.request API](https://developer.atlassian.com/cloud/jira/software/jsapi/request/).
	 */ getSuggestions)=>{
    const { createAndFireAnalyticsEvent: createAndFireAnalyticsEvent } = (0, $gKcSi.useJqlEditorAutocompleteAnalytics)(analyticsSource);
    const [, { load: load }] = (0, $f3Bxu.useJqlAutocompleteActions)();
    const [jqlSearchableFields$] = (0, $f3Bxu.useJqlSearchableFieldsObservable)();
    const [jqlOrderableFields$] = (0, $f3Bxu.useJqlOrderableFieldsObservable)();
    const [jqlFunctions$] = (0, $f3Bxu.useJqlFunctionsObservable)();
    const onFields = (0, $hrxfe.default)(jqlSearchableFields$, jqlOrderableFields$);
    const onOperators = (0, $lWTHF.default)(jqlSearchableFields$);
    const onFunctions = (0, $aho02.default)(jqlSearchableFields$, jqlFunctions$);
    const onValues = (0, $7zhCa.default)(jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent);
    (0, $eJOHy.useEffect)(()=>{
        // Load autocomplete data on mount
        load(getInitialData, createAndFireAnalyticsEvent);
    }, [
        createAndFireAnalyticsEvent,
        getInitialData,
        load
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            onFields: onFields,
            onOperators: onOperators,
            onFunctions: onFunctions,
            onValues: onValues
        }), [
        onFields,
        onOperators,
        onFunctions,
        onValues
    ]);
};

});
parcelRegister("gKcSi", function(module, exports) {

$parcel$export(module.exports, "useJqlEditorAutocompleteAnalytics", () => $b665b05233afce00$export$67ceee19d6563eac);

var $gbF4j = parcelRequire("gbF4j");
var $kXrPt = parcelRequire("kXrPt");

var $lqyzp = parcelRequire("lqyzp");
const $b665b05233afce00$export$67ceee19d6563eac = (analyticsSource)=>{
    return (0, $kXrPt.useJqlPackageAnalytics)(analyticsSource, "platform-pkg", "0.0.0-use.local", (0, $gbF4j.ANALYTICS_CHANNEL));
};

});
parcelRegister("kXrPt", function(module, exports) {

$parcel$export(module.exports, "useJqlPackageAnalytics", () => $4a4b702f1008b036$export$62edc016e6670a97);

var $eJOHy = parcelRequire("eJOHy");

var $f1Zdy = parcelRequire("f1Zdy");
const $4a4b702f1008b036$export$62edc016e6670a97 = (analyticsSource, packageName, packageVersion, analyticsChannel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const createAndFireAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
        const event = createAnalyticsEvent({
            ...payload,
            attributes: {
                ...payload.attributes,
                analyticsSource: analyticsSource,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        event.fire(analyticsChannel);
    }, [
        createAnalyticsEvent,
        analyticsSource,
        packageName,
        packageVersion,
        analyticsChannel
    ]);
    return {
        createAndFireAnalyticsEvent: createAndFireAnalyticsEvent
    };
};

});

parcelRegister("lqyzp", function(module, exports) {

$parcel$export(module.exports, "Action", () => $5f4b0fda11386972$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $5f4b0fda11386972$export$7f97440769de1377);
var $5f4b0fda11386972$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["FAILED"] = "failed";
    Action["SUCCESS"] = "success";
    return Action;
}({});
var $5f4b0fda11386972$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    ActionSubject["AUTOCOMPLETE_INITIAL_DATA"] = "autocompleteInitialData";
    ActionSubject["AUTOCOMPLETE_SUGGESTIONS"] = "autocompleteSuggestions";
    return ActionSubject;
}({});
var $5f4b0fda11386972$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    return ActionSubjectId;
}({});

});


parcelRegister("f3Bxu", function(module, exports) {

$parcel$export(module.exports, "useJqlAutocompleteActions", () => $95bb7e12e752280f$export$dfe74b189a0a3dd);
$parcel$export(module.exports, "useJqlSearchableFieldsObservable", () => $95bb7e12e752280f$export$e00ad85496518b08);
$parcel$export(module.exports, "useJqlOrderableFieldsObservable", () => $95bb7e12e752280f$export$ddac70d4fccb6121);
$parcel$export(module.exports, "useJqlFunctionsObservable", () => $95bb7e12e752280f$export$20ce426c77c6c794);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $2opa2 = parcelRequire("2opa2");

var $4pIMA = parcelRequire("4pIMA");

var $gbF4j = parcelRequire("gbF4j");

var $lqyzp = parcelRequire("lqyzp");
const $95bb7e12e752280f$var$initialData = {
    jqlSearchableFields: [],
    jqlOrderableFields: [],
    jqlFunctions: []
};
const $95bb7e12e752280f$var$initialState = {
    initialDataFetched: false,
    jqlSearchableFields$: (0, $2opa2.from)($95bb7e12e752280f$var$initialData.jqlSearchableFields),
    jqlOrderableFields$: (0, $2opa2.from)($95bb7e12e752280f$var$initialData.jqlOrderableFields),
    jqlFunctions$: (0, $2opa2.from)($95bb7e12e752280f$var$initialData.jqlFunctions)
};
const $95bb7e12e752280f$export$e324594224ef24da = {
    load: (getInitialData, createAndFireAnalyticsEvent)=>({ getState: getState, setState: setState })=>{
            const { initialDataFetched: initialDataFetched } = getState();
            if (initialDataFetched) return;
            const promise = getInitialData(`/rest/api/latest/jql/autocompletedata`).then((res)=>{
                const initialValue = {
                    jqlSearchableFields: [],
                    jqlOrderableFields: [],
                    jqlFunctions: res.jqlFunctions
                };
                const data = res.jqlFields.reduce((result, field)=>{
                    if (field.searchable === 'true') result.jqlSearchableFields.push(field);
                    if (field.orderable === 'true') result.jqlOrderableFields.push(field);
                    return result;
                }, initialValue);
                // Minor optimisation so consumers don't have to wait for the promise `then` function to be called
                // whenever we subscribe to the observable. (`then` runs async in the current thread loop)
                setState({
                    jqlSearchableFields$: (0, $2opa2.from)(data.jqlSearchableFields),
                    jqlOrderableFields$: (0, $2opa2.from)(data.jqlOrderableFields),
                    jqlFunctions$: (0, $2opa2.from)(data.jqlFunctions)
                });
                createAndFireAnalyticsEvent({
                    action: (0, $lqyzp.Action).SUCCESS,
                    actionSubject: (0, $lqyzp.ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                    eventType: (0, $gbF4j.EventType).OPERATIONAL
                });
                return data;
            }).catch(()=>{
                setState({
                    jqlSearchableFields$: $95bb7e12e752280f$var$initialState.jqlSearchableFields$,
                    jqlOrderableFields$: $95bb7e12e752280f$var$initialState.jqlOrderableFields$,
                    jqlFunctions$: $95bb7e12e752280f$var$initialState.jqlFunctions$
                });
                createAndFireAnalyticsEvent({
                    action: (0, $lqyzp.Action).FAILED,
                    actionSubject: (0, $lqyzp.ActionSubject).AUTOCOMPLETE_INITIAL_DATA,
                    eventType: (0, $gbF4j.EventType).OPERATIONAL
                });
                return $95bb7e12e752280f$var$initialData;
            });
            // Set the in-flight promise in state as an observable. This allows consumers to subscribe to our initial data
            // without worrying about race conditions with the API call.
            setState({
                initialDataFetched: true,
                jqlSearchableFields$: (0, $2opa2.from)(promise).pipe((0, $4pIMA.concatMap)(({ jqlSearchableFields: jqlSearchableFields })=>jqlSearchableFields)),
                jqlOrderableFields$: (0, $2opa2.from)(promise).pipe((0, $4pIMA.concatMap)(({ jqlOrderableFields: jqlOrderableFields })=>jqlOrderableFields)),
                jqlFunctions$: (0, $2opa2.from)(promise).pipe((0, $4pIMA.concatMap)(({ jqlFunctions: jqlFunctions })=>jqlFunctions))
            });
        }
};
const $95bb7e12e752280f$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    initialState: $95bb7e12e752280f$var$initialState,
    actions: $95bb7e12e752280f$export$e324594224ef24da
});
const $95bb7e12e752280f$export$96c8f4ecc88d96a5 = (0, $6E16M.createContainer)($95bb7e12e752280f$export$6f57813fe9f31bf9);
const $95bb7e12e752280f$export$dfe74b189a0a3dd = (0, $iJq0l.createHook)($95bb7e12e752280f$export$6f57813fe9f31bf9, {
    selector: null
});
const $95bb7e12e752280f$export$e00ad85496518b08 = (0, $iJq0l.createHook)($95bb7e12e752280f$export$6f57813fe9f31bf9, {
    selector: ({ jqlSearchableFields$: jqlSearchableFields$ })=>jqlSearchableFields$
});
const $95bb7e12e752280f$export$ddac70d4fccb6121 = (0, $iJq0l.createHook)($95bb7e12e752280f$export$6f57813fe9f31bf9, {
    selector: ({ jqlOrderableFields$: jqlOrderableFields$ })=>jqlOrderableFields$
});
const $95bb7e12e752280f$export$20ce426c77c6c794 = (0, $iJq0l.createHook)($95bb7e12e752280f$export$6f57813fe9f31bf9, {
    selector: ({ jqlFunctions$: jqlFunctions$ })=>jqlFunctions$
});

});

parcelRegister("hrxfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0515fe92ecd74275$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $17H3E = parcelRequire("17H3E");

var $lB9jX = parcelRequire("lB9jX");

var $8RTYQ = parcelRequire("8RTYQ");

var $3PmNk = parcelRequire("3PmNk");

var $ez3K4 = parcelRequire("ez3K4");

var $dfP4l = parcelRequire("dfP4l");

var $cfhE9 = parcelRequire("cfhE9");

var $0BRzV = parcelRequire("0BRzV");
const $0515fe92ecd74275$export$df27029b4333540b = 20;
const $0515fe92ecd74275$var$CF_ID_PATTERN = /^"?cf\[\d+]"?$/;
const $0515fe92ecd74275$var$COLLAPSED_FIELD_PATTERN = /^"?.+\[(.+)]"?$/;
const $0515fe92ecd74275$var$isCollapsedField = ({ value: value })=>$0515fe92ecd74275$var$COLLAPSED_FIELD_PATTERN.test(value) && !$0515fe92ecd74275$var$CF_ID_PATTERN.test(value);
const $0515fe92ecd74275$export$b9089a6e41ed43aa = (field)=>{
    if (!$0515fe92ecd74275$var$isCollapsedField(field)) return null;
    const matches = $0515fe92ecd74275$var$COLLAPSED_FIELD_PATTERN.exec(field.value);
    if (!matches || matches.length < 2) return null;
    return matches[1];
};
const $0515fe92ecd74275$var$useOnFields = (jqlSearchableFields$, jqlOrderableFields$)=>{
    // Returns an Observable of the fields to render for the provided query string
    return (0, $eJOHy.useCallback)((query, clause)=>{
        if (clause === undefined) return (0, $lB9jX.empty)();
        const jqlFields$ = clause === 'orderBy' ? jqlOrderableFields$ : jqlSearchableFields$;
        return jqlFields$.pipe((0, $8RTYQ.filter)((field)=>(0, $cfhE9.filterJqlValue)(field, query)), // Limit the result to MAX_VISIBLE_OPTIONS
        (0, $ez3K4.take)($0515fe92ecd74275$export$df27029b4333540b), (0, $3PmNk.map)((field)=>{
            const fieldType = $0515fe92ecd74275$export$b9089a6e41ed43aa(field);
            if (fieldType !== null) {
                const name = (0, (/*@__PURE__*/$parcel$interopDefault($17H3E)))(field.displayName).replace(` - ${(0, $0BRzV.normalize)(field.value)}`, '');
                return {
                    name: name,
                    value: field.value,
                    fieldType: fieldType,
                    isDeprecated: field.deprecated === 'true',
                    deprecatedSearcherKey: field.deprecatedSearcherKey
                };
            }
            return {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($17H3E)))(field.displayName),
                value: field.value,
                isDeprecated: field.deprecated === 'true',
                deprecatedSearcherKey: field.deprecatedSearcherKey
            };
        }), (0, $dfP4l.toArray)(), // We can filter out empty arrays as there is nothing to consume
        (0, $8RTYQ.filter)((fields)=>fields.length > 0));
    }, [
        jqlSearchableFields$,
        jqlOrderableFields$
    ]);
};
var $0515fe92ecd74275$export$2e2bcd8739ae039 = $0515fe92ecd74275$var$useOnFields;

});
parcelRegister("17H3E", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");

var $gdVrJ = parcelRequire("gdVrJ");
/** Used to match HTML entities and HTML characters. */ var $0d17d84d14702012$var$reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, $0d17d84d14702012$var$reHasEscapedHtml = RegExp($0d17d84d14702012$var$reEscapedHtml.source);
/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */ function $0d17d84d14702012$var$unescape(string) {
    string = $cz1WF(string);
    return string && $0d17d84d14702012$var$reHasEscapedHtml.test(string) ? string.replace($0d17d84d14702012$var$reEscapedHtml, $gdVrJ) : string;
}
module.exports = $0d17d84d14702012$var$unescape;

});
parcelRegister("gdVrJ", function(module, exports) {

var $loEwo = parcelRequire("loEwo");
/** Used to map HTML entities to characters. */ var $bcfa6be5b1ea43a2$var$htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
};
/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */ var $bcfa6be5b1ea43a2$var$unescapeHtmlChar = $loEwo($bcfa6be5b1ea43a2$var$htmlUnescapes);
module.exports = $bcfa6be5b1ea43a2$var$unescapeHtmlChar;

});


parcelRegister("cfhE9", function(module, exports) {

$parcel$export(module.exports, "filterJqlValue", () => $dcd532953356e6fe$export$7a9ba8200d77b3fe);

var $0BRzV = parcelRequire("0BRzV");
const $dcd532953356e6fe$export$7a9ba8200d77b3fe = ({ displayName: displayName, value: value }, query)=>{
    if (typeof query !== 'string' || query === '') return true;
    const normalizedQuery = (0, $0BRzV.normalize)(query);
    const normalizedDisplayName = (0, $0BRzV.normalize)(displayName);
    const normalizedValue = (0, $0BRzV.normalize)(value);
    // If query is quoted, then we only return exact matches with the JQL value
    if ((0, $0BRzV.isQuoted)(query)) return (0, $0BRzV.areStringsEquivalent)(normalizedQuery, normalizedValue);
    return (0, $0BRzV.areStringsEquivalent)(normalizedQuery, normalizedDisplayName.substring(0, normalizedQuery.length)) || (0, $0BRzV.areStringsEquivalent)(normalizedQuery, normalizedValue.substring(0, normalizedQuery.length));
};

});
parcelRegister("0BRzV", function(module, exports) {

$parcel$export(module.exports, "isQuoted", () => $69a5ef8dd0d1eae1$export$b86601123607fee5);
$parcel$export(module.exports, "normalize", () => $69a5ef8dd0d1eae1$export$a3295358bff77e);
$parcel$export(module.exports, "areStringsEquivalent", () => $69a5ef8dd0d1eae1$export$cef6d95c2df8ec7f);
const $69a5ef8dd0d1eae1$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $69a5ef8dd0d1eae1$export$d5efd6512db694fd = (maybeQuotedString)=>{
    if (maybeQuotedString.length < 2) return false;
    return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
};
const $69a5ef8dd0d1eae1$export$b86601123607fee5 = (maybeQuotedString)=>$69a5ef8dd0d1eae1$export$7a0b99b892e0dda8(maybeQuotedString) || $69a5ef8dd0d1eae1$export$d5efd6512db694fd(maybeQuotedString);
const $69a5ef8dd0d1eae1$export$a3295358bff77e = (maybeQuotedString)=>{
    if ($69a5ef8dd0d1eae1$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
    if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
    return maybeQuotedString;
};
const $69a5ef8dd0d1eae1$var$collator = new Intl.Collator(undefined, {
    sensitivity: 'base'
});
const $69a5ef8dd0d1eae1$export$cef6d95c2df8ec7f = (a, b)=>$69a5ef8dd0d1eae1$var$collator.compare(a, b) === 0;

});



parcelRegister("aho02", function(module, exports) {

$parcel$export(module.exports, "default", () => $4893e5dec7db842f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6PCNA = parcelRequire("6PCNA");

var $lB9jX = parcelRequire("lB9jX");

var $4pIMA = parcelRequire("4pIMA");

var $8RTYQ = parcelRequire("8RTYQ");

var $3PmNk = parcelRequire("3PmNk");

var $dfP4l = parcelRequire("dfP4l");

var $1IKJ8 = parcelRequire("1IKJ8");
const $4893e5dec7db842f$var$useOnFunctions = (jqlSearchableFields$, jqlFunctions$)=>{
    return (0, $eJOHy.useCallback)((query, field, isListOperator)=>{
        if (typeof field !== 'string' || field === '') return (0, $lB9jX.empty)();
        const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(query)}[^$]`, 'i') : undefined;
        const field$ = (0, $1IKJ8.default)(jqlSearchableFields$, field);
        // Find all functions that match our query with a type that intersects our field types
        return field$.pipe((0, $4pIMA.concatMap)((matchingField)=>jqlFunctions$.pipe((0, $8RTYQ.filter)((func)=>!filterRegex || func.displayName.match(filterRegex) !== null), (0, $8RTYQ.filter)((func)=>// Do not include functions that return a list unless we are using a list operator
                !!isListOperator || func.isList !== 'true'), (0, $8RTYQ.filter)((func)=>// Include functions with a type that intersects our field types
                func.types.filter((type)=>matchingField.types.includes(type)).length > 0), (0, $3PmNk.map)((func)=>({
                    name: func.displayName,
                    value: func.value,
                    isListFunction: func.isList === 'true' || func.supportsListAndSingleValueOperators === 'true'
                })), (0, $dfP4l.toArray)())), // We can filter out empty arrays as there is nothing to consume
        (0, $8RTYQ.filter)((operands)=>operands.length > 0));
    }, [
        jqlSearchableFields$,
        jqlFunctions$
    ]);
};
var $4893e5dec7db842f$export$2e2bcd8739ae039 = $4893e5dec7db842f$var$useOnFunctions;

});
parcelRegister("1IKJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e98d5286e5bf4df1$export$2e2bcd8739ae039);

var $8RTYQ = parcelRequire("8RTYQ");

var $ez3K4 = parcelRequire("ez3K4");

var $0BRzV = parcelRequire("0BRzV");
/**
 * Returns an Observable of the first field matching the provided string, or an empty Observable if no matching field
 * could be found.
 */ const $e98d5286e5bf4df1$var$findField$ = (jqlFields$, field)=>{
    return jqlFields$.pipe((0, $8RTYQ.filter)(({ value: value })=>{
        const normalizedField = (0, $0BRzV.normalize)(field);
        const normalizedValue = (0, $0BRzV.normalize)(value);
        return (0, $0BRzV.areStringsEquivalent)(normalizedField, normalizedValue);
    }), (0, $ez3K4.take)(1));
};
var $e98d5286e5bf4df1$export$2e2bcd8739ae039 = $e98d5286e5bf4df1$var$findField$;

});


parcelRegister("lWTHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c79e42e425b7d492$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6PCNA = parcelRequire("6PCNA");

var $lB9jX = parcelRequire("lB9jX");

var $4pIMA = parcelRequire("4pIMA");

var $8RTYQ = parcelRequire("8RTYQ");

var $3PmNk = parcelRequire("3PmNk");

var $dfP4l = parcelRequire("dfP4l");

var $1IKJ8 = parcelRequire("1IKJ8");
const $c79e42e425b7d492$var$useOnOperators = (jqlSearchableFields$)=>{
    return (0, $eJOHy.useCallback)((query, field)=>{
        if (typeof field !== 'string' || field === '') return (0, $lB9jX.empty)();
        const filterRegex = typeof query === 'string' && query !== '' ? new RegExp(`^${(0, (/*@__PURE__*/$parcel$interopDefault($6PCNA)))(query)}[^$]`, 'i') : undefined;
        // Find operators for matching field
        return (0, $1IKJ8.default)(jqlSearchableFields$, field).pipe((0, $4pIMA.concatMap)(({ operators: operators })=>operators), // Filter operators that match query
        (0, $8RTYQ.filter)((operator)=>!filterRegex || operator.match(filterRegex) !== null), (0, $3PmNk.map)((operator)=>{
            const value = operator.toUpperCase();
            return {
                name: value,
                value: value
            };
        }), (0, $dfP4l.toArray)(), // We can filter out empty arrays as there is nothing to consume
        (0, $8RTYQ.filter)((operators)=>operators.length > 0));
    }, [
        jqlSearchableFields$
    ]);
};
var $c79e42e425b7d492$export$2e2bcd8739ae039 = $c79e42e425b7d492$var$useOnOperators;

});

parcelRegister("7zhCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $b70b85413787c6a9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $lB9jX = parcelRequire("lB9jX");

var $jjQ5U = parcelRequire("jjQ5U");

var $4pIMA = parcelRequire("4pIMA");

var $dHUXL = parcelRequire("dHUXL");

var $8RTYQ = parcelRequire("8RTYQ");

var $1IKJ8 = parcelRequire("1IKJ8");

var $0BRzV = parcelRequire("0BRzV");


var $bP8nP = parcelRequire("bP8nP");
const $b70b85413787c6a9$var$getValueType = (field)=>{
    if (field.types.includes((0, $ba83a66a02b3859c$export$7cba791a20c35c0c))) return 'user';
    return undefined;
};
const $b70b85413787c6a9$var$fieldValuesReducer = (state, action)=>{
    const { cacheKey: cacheKey, values: values } = action.payload;
    return {
        ...state,
        [cacheKey]: values
    };
};
const $b70b85413787c6a9$var$initialState = {};
// Hard coded delay before making a fetch call for operands.
const $b70b85413787c6a9$var$OPERANDS_DELAY_MS = 650;
// Used to remove emails from user display names in autocomplete values, which come in format: "Name - email".
// Pattern below is specific enough for this purpose and we should avoid writing a more complex email matcher.
const $b70b85413787c6a9$var$BASIC_REMOVE_EMAIL_REGEX = /\s-\s\S+@\S+\.\S+$/;
const $b70b85413787c6a9$var$useOnValues = (jqlSearchableFields$, getSuggestions, createAndFireAnalyticsEvent)=>{
    (0, $gRw8I.di)((0, $eJOHy.useReducer));
    const fetchFieldValues = (0, $bP8nP.useFetchFieldValues)(getSuggestions, createAndFireAnalyticsEvent);
    const [fieldValuesCache, dispatch] = (0, $eJOHy.useReducer)($b70b85413787c6a9$var$fieldValuesReducer, $b70b85413787c6a9$var$initialState);
    return (0, $eJOHy.useCallback)((query, field)=>{
        if (typeof field !== 'string' || field === '') return (0, $lB9jX.empty)();
        const field$ = (0, $1IKJ8.default)(jqlSearchableFields$, field);
        // API expects unquoted and unescaped values
        const normalizedField = (0, $0BRzV.normalize)(field);
        const normalizedQuery = query !== undefined ? (0, $0BRzV.normalize)(query) : '';
        // Cache values by field + query
        const cacheKey = `${normalizedField}:${normalizedQuery}`;
        const isCacheHit = Object.prototype.hasOwnProperty.call(fieldValuesCache, cacheKey);
        return field$.pipe((0, $8RTYQ.filter)((matchingField)=>matchingField.auto === 'true'), (0, $4pIMA.concatMap)((matchingField)=>{
            if (isCacheHit) return (0, $jjQ5U.of)(fieldValuesCache[cacheKey]);
            // If we have a cfid then use it to fetch autocomplete suggestions as results will always be unique.
            // Otherwise it's possible `normalizedField` will match against multiple fields in the API and thus
            // return no data.
            const fieldNameForFetch = matchingField.cfid ?? normalizedField;
            // We emit a single value using Observable.of(null) and delay that event before fetching field values so we
            // can mimic debounce behaviour.
            return (0, $jjQ5U.of)(null).pipe((0, $dHUXL.delay)($b70b85413787c6a9$var$OPERANDS_DELAY_MS), (0, $4pIMA.concatMap)(()=>fetchFieldValues(fieldNameForFetch, normalizedQuery).then((values)=>{
                    const valueType = $b70b85413787c6a9$var$getValueType(matchingField);
                    if (valueType === 'user') values.forEach((value)=>{
                        value.valueType = valueType;
                        // REST autocomplete API returns user display names with this format: "Name - email". To be
                        // consistent with hydration API, we want to remove email from this name for rich inline nodes.
                        value.nameOnRichInlineNode = value.name.replace($b70b85413787c6a9$var$BASIC_REMOVE_EMAIL_REGEX, '');
                    });
                    // Save response to in-memory cache
                    dispatch({
                        type: 'update-cache',
                        payload: {
                            cacheKey: cacheKey,
                            values: values
                        }
                    });
                    return values;
                }).catch(()=>[])));
        }), // We can filter out empty arrays as there is nothing to consume
        (0, $8RTYQ.filter)((operands)=>operands.length > 0));
    }, [
        jqlSearchableFields$,
        fieldValuesCache,
        fetchFieldValues
    ]);
};
var $b70b85413787c6a9$export$2e2bcd8739ae039 = $b70b85413787c6a9$var$useOnValues;

});
const $ba83a66a02b3859c$export$7cba791a20c35c0c = 'com.atlassian.jira.user.ApplicationUser';

parcelRegister("bP8nP", function(module, exports) {

$parcel$export(module.exports, "useFetchFieldValues", () => $8503af4a55f09aea$export$6cb851ed13e3949e);

var $eJOHy = parcelRequire("eJOHy");

var $gbF4j = parcelRequire("gbF4j");

var $lqyzp = parcelRequire("lqyzp");
const $8503af4a55f09aea$export$7bf3f44bca0a7a65 = (field, query)=>`/rest/api/latest/jql/autocompletedata/suggestions?fieldName=${field}&fieldValue=${query ?? ''}`;
const $8503af4a55f09aea$export$6cb851ed13e3949e = (getSuggestions, createAndFireAnalyticsEvent)=>{
    return (0, $eJOHy.useCallback)(async (field, query)=>{
        try {
            const data = await getSuggestions($8503af4a55f09aea$export$7bf3f44bca0a7a65(field, query));
            const div = document.createElement('div');
            const results = data.results.map((operand)=>{
                // The displayName from the API includes HTML tags to bold matching text e.g. `<b>o</b>pen`
                // We set this as innerHTML so we can get the raw textContent
                div.innerHTML = operand.displayName;
                return {
                    name: div.textContent ?? '',
                    value: operand.value
                };
            });
            createAndFireAnalyticsEvent({
                action: (0, $lqyzp.Action).SUCCESS,
                actionSubject: (0, $lqyzp.ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                eventType: (0, $gbF4j.EventType).OPERATIONAL
            });
            return results;
        } catch (error) {
            createAndFireAnalyticsEvent({
                action: (0, $lqyzp.Action).FAILED,
                actionSubject: (0, $lqyzp.ActionSubject).AUTOCOMPLETE_SUGGESTIONS,
                eventType: (0, $gbF4j.EventType).OPERATIONAL
            });
            throw error;
        }
    }, [
        createAndFireAnalyticsEvent,
        getSuggestions
    ]);
};

});



parcelRegister("bUnif", function(module, exports) {

$parcel$export(module.exports, "useJqlDebuggerStoreActions", () => $225b1cd3961a99bb$export$661ee98a2d30a450);
$parcel$export(module.exports, "useStoreData", () => $225b1cd3961a99bb$export$544efe5ac05fc17);
$parcel$export(module.exports, "useDebuggerStatus", () => $225b1cd3961a99bb$export$e4c2322c66a3dea5);
$parcel$export(module.exports, "useJqlErrors", () => $225b1cd3961a99bb$export$d959fd60596bfa67);
$parcel$export(module.exports, "useJqlEditorOnSearch", () => $225b1cd3961a99bb$export$ba3a4678e5df092c);
$parcel$export(module.exports, "useJqlQuery", () => $225b1cd3961a99bb$export$ec027c329b94fe67);
$parcel$export(module.exports, "useIsAiEnabled", () => $225b1cd3961a99bb$export$742ce7b41314d513);
$parcel$export(module.exports, "useErrorComponentTestId", () => $225b1cd3961a99bb$export$afd1b99522ddeae9);
$parcel$export(module.exports, "useErrorComponentValidationId", () => $225b1cd3961a99bb$export$9c84149290836e7);
$parcel$export(module.exports, "useIsReadyForProactive", () => $225b1cd3961a99bb$export$1da2ac60b06e42d1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");
const $225b1cd3961a99bb$var$initialState = {
    jqlQuery: '',
    userQueryError: [],
    onSearch: ()=>undefined,
    status: 'INIT',
    jqlDiffTokens: [],
    isAiEnabled: false,
    syntaxCorrectionAttemptErrors: [],
    singleInstrumentationID: '',
    errorSectionTestId: '',
    onAiInteractionDismissed () {
    // do nothing
    },
    exitNaturalLanguageMode () {
    // do nothing
    },
    onJsError () {
    // do nothing
    },
    jqlErrors: [],
    errorComponentValidationId: '',
    errorComponentTestId: '',
    isReadyForProactive: false
};
const $225b1cd3961a99bb$var$Store = (0, $GtRbT.createStore)({
    initialState: $225b1cd3961a99bb$var$initialState,
    // actions that trigger store mutation
    actions: {
        setJqlQuery: (jqlQuery)=>({ setState: setState })=>{
                setState({
                    jqlQuery: jqlQuery
                });
            },
        setOnSearch: (onSearch)=>({ setState: setState })=>{
                setState({
                    onSearch: onSearch
                });
            },
        setStatus: (status)=>({ setState: setState, getState: getState })=>{
                if (status === 'JS_ERROR') getState().onJsError();
                setState({
                    status: status
                });
            },
        setIssueNavigatorSearchMode: (issueNavigatorSearchMode)=>({ setState: setState })=>{
                setState({
                    issueNavigatorSearchMode: issueNavigatorSearchMode
                });
            },
        resetStatus: (source, newJqlQuery)=>({ setState: setState, getState: getState })=>{
                if (source === 'ON_ENTER_NL_MODE') setState({
                    issueNavigatorSearchMode: 'NL2JQL'
                });
                if (getState().status !== 'INIT') {
                    if ((0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button')) // AI modal gets dismissed when we accept a suggestion
                    // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                    // We pass the status in as if we are viewing a result and close the panel, it should be a discarded event, not a dismissed event
                    {
                        if (source !== 'ACCEPT_FIX') {
                            if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                            {
                                if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source, getState().status);
                            } else getState().onAiInteractionDismissed(source, getState().status);
                        }
                    } else if (source !== 'ACCEPT_FIX') {
                        // AI modal gets dismissed when we accept a suggestion
                        // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                        {
                            if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source);
                        } else getState().onAiInteractionDismissed(source);
                    }
                    // Reset the status and aiInteractionDismissed handler so that duplicate events won't be fired
                    setState({
                        status: 'INIT',
                        onAiInteractionDismissed: $225b1cd3961a99bb$var$initialState.onAiInteractionDismissed
                    });
                }
            },
        setStateOnFeatureInvoke: (initialDataOnInvoke)=>({ setState: setState })=>{
                setState({
                    ...initialDataOnInvoke,
                    status: 'LOADING_RESULT'
                });
            },
        setJqlErorCorrectionData: (data)=>({ setState: setState })=>{
                setState({
                    ...data,
                    status: 'VIEW_RESULT'
                });
            },
        setIsAiEnabled: (isAiEnabled)=>({ setState: setState })=>{
                setState({
                    isAiEnabled: isAiEnabled
                });
            },
        setOnAiInteractionDismissed: (onAiInteractionDismissed)=>({ setState: setState })=>{
                setState({
                    onAiInteractionDismissed: onAiInteractionDismissed
                });
            },
        setOnJsError: (onJsError)=>({ setState: setState })=>{
                setState({
                    onJsError: onJsError
                });
            },
        exitNaturalLanguageMode: ()=>({ getState: getState })=>{
                getState().exitNaturalLanguageMode?.();
            },
        setExitNaturalLanguageMode: (exitNaturalLanguageMode)=>({ setState: setState })=>{
                setState({
                    exitNaturalLanguageMode: exitNaturalLanguageMode
                });
            },
        setJqlErrors: (jqlErrors)=>({ setState: setState })=>setState({
                    jqlErrors: jqlErrors
                }),
        setErrorComponentValidationId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setErrorComponentTestId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setIsReadyForProactive: (isReadyForProactive)=>({ setState: setState })=>{
                setState({
                    isReadyForProactive: isReadyForProactive
                });
            }
    }
});
const $225b1cd3961a99bb$export$661ee98a2d30a450 = (0, $iJq0l.createActionsHook)($225b1cd3961a99bb$var$Store);
const $225b1cd3961a99bb$export$544efe5ac05fc17 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store);
const $225b1cd3961a99bb$export$e4c2322c66a3dea5 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.status
});
const $225b1cd3961a99bb$export$d959fd60596bfa67 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.jqlErrors
});
const $225b1cd3961a99bb$export$ba3a4678e5df092c = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.onSearch
});
const $225b1cd3961a99bb$export$ec027c329b94fe67 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.jqlQuery
});
const $225b1cd3961a99bb$export$742ce7b41314d513 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.isAiEnabled
});
const $225b1cd3961a99bb$export$afd1b99522ddeae9 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.errorComponentTestId
});
const $225b1cd3961a99bb$export$9c84149290836e7 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.errorComponentValidationId
});
const $225b1cd3961a99bb$export$1da2ac60b06e42d1 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.isReadyForProactive && state.issueNavigatorSearchMode !== 'NL2JQL'
});
const $225b1cd3961a99bb$export$a416100e9df4f9b1 = (0, $iJq0l.createHook)($225b1cd3961a99bb$var$Store, {
    selector: (state)=>state.syntaxCorrectionAttemptErrors
});

});

const $7b5dd06670889591$export$abc61f74b6bec12c = 'viewJqlBuilderAdvanced';
const $7b5dd06670889591$export$b8b9d90f9e5bd72b = 'jiraJqlBuilderAdvanced';
const $7b5dd06670889591$export$d57b6b390e78d90f = 'empanada';

parcelRegister("0aNCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7411d81cc67d251$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e7411d81cc67d251$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorFlagTitle: {
        "id": "jql-builder-advanced.error-flag-title",
        "defaultMessage": "We couldn't edit the query"
    },
    errorFlagDescription: {
        "id": "jql-builder-advanced.error-flag-description",
        "defaultMessage": "The JQL builder is unresponsive. Refresh the page to try again."
    },
    searchCurrentPage: {
        "id": "jql-builder-advanced.search-current-page",
        "defaultMessage": "Search on current page"
    }
});

});

parcelRegister("kLjta", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteInitialData", () => $3d3f5d3a050a2eed$export$21e39afbf909ee71);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");


var $fastT = parcelRequire("fastT");
const $3d3f5d3a050a2eed$export$21e39afbf909ee71 = (excludedAutocompleteFields = [], fieldsFilter)=>(0, $eJOHy.useCallback)((url)=>{
        const options = {
            method: 'POST',
            body: JSON.stringify({
                includeCollapsedFields: true
            })
        };
        return (0, $fastT.fetchWithRetry)(()=>(0, $1Ozm9.default)(url, options), 1).then((res)=>({
                jqlFields: excludedAutocompleteFields.length === 0 && !fieldsFilter ? res.visibleFieldNames : res.visibleFieldNames.filter((field)=>fieldsFilter?.(field.cfid || field.value) !== false && !excludedAutocompleteFields.includes(field.value)),
                jqlFunctions: res.visibleFunctionNames
            })).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'getAutocompleteInitialData',
                    packageName: (0, $7b5dd06670889591$export$b8b9d90f9e5bd72b),
                    teamName: (0, $7b5dd06670889591$export$d57b6b390e78d90f)
                }
            });
            throw error;
        });
    }, [
        excludedAutocompleteFields,
        fieldsFilter
    ]);

});
parcelRegister("fastT", function(module, exports) {

$parcel$export(module.exports, "fetchWithRetry", () => $a4be334d36a5e60b$export$cffaac380b94df26);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a4be334d36a5e60b$export$cffaac380b94df26 = async (fetchCall, retryAttempts)=>{
    try {
        return await fetchCall();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (retryAttempts > 0) return $a4be334d36a5e60b$export$cffaac380b94df26(fetchCall, retryAttempts - 1);
        throw error;
    }
};

});


parcelRegister("3LacB", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteSuggestions", () => $5c28b34cfba0b2fb$export$b39a9f86c7843060);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

const $5c28b34cfba0b2fb$export$b39a9f86c7843060 = ()=>{
    return (0, $eJOHy.useCallback)((url)=>(0, $1Ozm9.default)(url).catch((error)=>{
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'getAutocompleteSuggestions',
                    packageName: (0, $7b5dd06670889591$export$b8b9d90f9e5bd72b),
                    teamName: (0, $7b5dd06670889591$export$d57b6b390e78d90f)
                }
            });
            throw error;
        }), []);
};

});

parcelRegister("bOvYj", function(module, exports) {

$parcel$export(module.exports, "useOnHydrate", () => $fc289583ab3a26a9$export$6d016355519acd77);

var $5X5p4 = parcelRequire("5X5p4");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $lvKO5 = parcelRequire("lvKO5");


const $fc289583ab3a26a9$export$f2e498f301ac7cdf = (response)=>{
    if (!response?.jira?.jqlBuilder?.hydrateJqlQuery?.fields) return {};
    const hydratedValues = {};
    response.jira.jqlBuilder.hydrateJqlQuery.fields.forEach((field)=>{
        if (field.values) {
            const fieldValues = [];
            field.values.forEach((valueResult)=>{
                if (valueResult?.values) valueResult.values.forEach((value)=>{
                    if (value?.__typename === 'JiraJqlUserFieldValue') fieldValues.push({
                        type: 'user',
                        id: value.jqlTerm,
                        name: value.displayName,
                        avatarUrl: value.user?.picture ?? ''
                    });
                });
            });
            if (field.field && field.field.searchTemplate) {
                const fieldName = field.field.jqlTerm;
                if ((0, $622e67768f78f9c9$export$3df7f6b39477220a) === field.field.searchTemplate.key) fieldValues.push({
                    type: 'deprecated-field',
                    id: fieldName,
                    deprecatedSearcherKey: field.field.searchTemplate.key
                });
            }
            if (field.field && field.field.searchTemplate) {
                const fieldName = field.field.jqlTerm;
                if ((0, $622e67768f78f9c9$export$f8cba5bda41a61a0) === field.field.searchTemplate.key) fieldValues.push({
                    type: 'deprecated-field',
                    id: fieldName,
                    deprecatedSearcherKey: field.field.searchTemplate.key
                });
            }
            if (fieldValues.length > 0 && field.field) {
                const fieldName = field.field.jqlTerm;
                hydratedValues[fieldName] = fieldValues;
            }
        }
    });
    return hydratedValues;
};
const $fc289583ab3a26a9$export$6d016355519acd77 = (viewContext, scope)=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    return (0, $eJOHy.useCallback)(async (jql)=>{
        try {
            const data = await (0, $j4oe4.fetchQuery)(environment, (0, $5X5p4.default), {
                jql: jql,
                cloudId: cloudId,
                viewContext: viewContext,
                scope: scope
            }, {
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).toPromise();
            return $fc289583ab3a26a9$export$f2e498f301ac7cdf(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'useOnHydrateRelay',
                    packageName: (0, $7b5dd06670889591$export$b8b9d90f9e5bd72b),
                    teamName: (0, $7b5dd06670889591$export$d57b6b390e78d90f)
                }
            });
            throw error;
        }
    }, [
        cloudId,
        environment,
        viewContext,
        scope
    ]);
};

});
parcelRegister("5X5p4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc978805eb79c70$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c97b62b0b4fb7cd6095e9b9c6e4c26e0>>
 * @relayHash 0b456e44a9397ce7756e643321eb4681
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d442b64928804cd27a695f19c4594036a888f67dbe22d5764db67e3820c7402
const $ecc978805eb79c70$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v7 = {
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "JiraJqlSearchTemplate",
                "kind": "LinkedField",
                "name": "searchTemplate",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v6 /*: any*/ ,
                                                                                        v8 /*: any*/ ,
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "user",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v10 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "id"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlUserFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5d442b64928804cd27a695f19c4594036a888f67dbe22d5764db67e3820c7402",
            "metadata": {},
            "name": "hydrationRelayJqlBuilderAdvancedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ecc978805eb79c70$var$node.hash = "73acc033ad6fdea5f965fc59c156d626";
var $ecc978805eb79c70$export$2e2bcd8739ae039 = $ecc978805eb79c70$var$node;

});

const $622e67768f78f9c9$export$3df7f6b39477220a = 'com.pyxis.greenhopper.jira:gh-epic-link-searcher';
const $622e67768f78f9c9$export$f8cba5bda41a61a0 = 'com.atlassian.jpo:jpo-custom-field-parent-searcher';




parcelRegister("e1BYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f392cf099dd7d8fb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4GZBG = parcelRequire("4GZBG");

var $lHTxM = parcelRequire("lHTxM");
const $f392cf099dd7d8fb$export$791565817c56ef87 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.JQLBuilderBasicUIWithAnalyticsOld), {
        ...props,
        JQLEditor: (0, $lHTxM.JQLEditorUIWithErrorBoundaryOld)
    });
const $f392cf099dd7d8fb$var$JQLBuilderBasic = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4GZBG.default), {
        ...props,
        JQLEditor: (0, $lHTxM.default)
    });
var $f392cf099dd7d8fb$export$2e2bcd8739ae039 = $f392cf099dd7d8fb$var$JQLBuilderBasic;

});

parcelRegister("l5UaK", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerTriggerButton", () => $68a041f25ac59326$export$a74ff97760ab288d);

var $eJOHy = parcelRequire("eJOHy");

var $alkjW = parcelRequire("alkjW");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $Svlt9 = parcelRequire("Svlt9");

var $kZSpL = parcelRequire("kZSpL");

var $gzcjr = parcelRequire("gzcjr");
var $kCMQD = parcelRequire("kCMQD");

var $lRq8t = parcelRequire("lRq8t");

var $1KdDN = parcelRequire("1KdDN");

var $bJscI = parcelRequire("bJscI");

var $bUnif = parcelRequire("bUnif");

var $13f5n = parcelRequire("13f5n");

var $hMoNE = parcelRequire("hMoNE");

var $kbhn6 = parcelRequire("kbhn6");

var $6Vq1r = parcelRequire("6Vq1r");

var $gr39h = parcelRequire("gr39h");

const $68a041f25ac59326$var$TriggerButtonWithLogic = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("8zsTV")), {
    moduleId: "./src/packages/jql-builder/jql-debugger/src/ui/trigger-button/trigger-button-content.tsx"
});
function $68a041f25ac59326$export$9504934576e2ed55(props) {
    const { children: children, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { jqlMessages: jqlMessages, onSearch: onSearch } = (0, $gr39h.useJqlDebuggerAdditionalContext)();
    const [debuggerState] = (0, $bUnif.useDebuggerStatus)();
    const [isAiEnabled] = (0, $bUnif.useIsAiEnabled)();
    // A jqlMessage can be error, warning or info
    // We only case about the error scenario
    // Here we map the jqlMessages object list to a list of plain strings
    const errors = (0, $eJOHy.useMemo)(()=>{
        return (0, $hMoNE.jqlMessagesToErrors)(jqlMessages);
    }, [
        jqlMessages
    ]);
    // Do not render the trigger button when:
    // 1. AI is not enabled
    // 2. onSearch callback is not available - i.e. we cannot apply the corrected jql to the editor
    // 3. No validation errors coming from the jql-editor - duuh
    //
    // Special note: Default render is `children` (and not `null`) coz we wanto keep showing the errors
    // For example when AI is not available, we still want to show the errors
    if (!isAiEnabled || !onSearch || !errors?.length) return children;
    if (debuggerState === 'JS_ERROR') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $68a041f25ac59326$var$errorBannerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kZSpL.JiraBanner), {
        messageId: "jql-debugger.ui.trigger-button.banner.error",
        messageType: "transactional",
        appearance: "error",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))), {
            spacing: "spacious",
            label: formatMessage((0, $6Vq1r.default).errorIconLabelNonFinal),
            LEGACY_secondaryColor: "inherit"
        })
    }, formatMessage((0, $6Vq1r.default).jsErrorNonFinal))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $68a041f25ac59326$var$errorComponentStyles
    }, debuggerState === 'INIT' && children, debuggerState === 'INIT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kCMQD.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), null, formatMessage((0, $6Vq1r.default).fixErrorWithAiNonFinal))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($68a041f25ac59326$var$TriggerButtonWithLogic, {
        testId: testId
    })));
}
const $68a041f25ac59326$var$JQLDebuggerTriggerButtonOld = (props)=>{
    const ChildrenFallback = (0, $eJOHy.useCallback)(()=>props.children, [
        props.children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).TRIGGER_BUTTON,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($68a041f25ac59326$export$9504934576e2ed55, props));
};
const $68a041f25ac59326$export$a74ff97760ab288d = (0, $bJscI.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $kbhn6.JQLPanelRenderSlotForJQLEditor), $68a041f25ac59326$var$JQLDebuggerTriggerButtonOld);
const $68a041f25ac59326$var$errorComponentStyles = (0, $5Wv5g.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    rowGap: 'space.025',
    marginBottom: 'space.050'
});
const $68a041f25ac59326$var$errorBannerStyle = (0, $5Wv5g.xcss)({
    marginTop: 'space.025',
    marginBottom: 'space.050'
});

});
parcelRegister("kZSpL", function(module, exports) {

$parcel$export(module.exports, "JiraBanner", () => $735e5a31d4bea264$export$23eaf79dd14ebe6e);

var $eJOHy = parcelRequire("eJOHy");

var $2Afze = parcelRequire("2Afze");

var $SyPNn = parcelRequire("SyPNn");

var $j2tD5 = parcelRequire("j2tD5");
const $735e5a31d4bea264$export$23eaf79dd14ebe6e = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j2tD5.ChoreographerBanner), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Afze.default), rest);
};

});
parcelRegister("j2tD5", function(module, exports) {

$parcel$export(module.exports, "ChoreographerBanner", () => $bc0a43425df5d870$export$d77caaec2153a90b);

var $2Afze = parcelRequire("2Afze");

var $1pkzT = parcelRequire("1pkzT");
const $bc0a43425df5d870$export$d77caaec2153a90b = (0, $1pkzT.withChoreographedRender)((0, $2Afze.default));

});


parcelRegister("13f5n", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_JQL_DEBUGGER", () => $4d08bf51bcedf53e$export$efcb4634ee5c0cb9);
$parcel$export(module.exports, "TEAM_NAME", () => $4d08bf51bcedf53e$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ERROR_BOUNDARY_IDS", () => $4d08bf51bcedf53e$export$2d2d5df8a192a41a);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_MESSAGE", () => $4d08bf51bcedf53e$export$8714ae84b437fe97);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_NAME", () => $4d08bf51bcedf53e$export$1e71032fcb7b8730);
$parcel$export(module.exports, "JS_ERROR_ABORT_REASON_NAME", () => $4d08bf51bcedf53e$export$64c672172b01336);
$parcel$export(module.exports, "AI_RESULT_ERROR_CATEGORIES", () => $4d08bf51bcedf53e$export$ad3b2223714b1ed9);
const $4d08bf51bcedf53e$export$efcb4634ee5c0cb9 = 'jira-jql-debugger';
const $4d08bf51bcedf53e$export$d57b6b390e78d90f = 'jira-ai-gravity';
const $4d08bf51bcedf53e$export$2d2d5df8a192a41a = {
    TRIGGER_BUTTON: 'jira-jql-debugger-trigger-button',
    FIX_WITH_AI_MODAL: 'jira-jql-debugger-fix-with-ai-modal',
    COMMON_ENTRY_JQL_BUILDER: 'jira-jql-debugger-common-entry-jql-builder',
    COMMON_ENTRY_ISSUE_VIEW: 'jira-jql-debugger-common-entry-issue-view'
};
const $4d08bf51bcedf53e$export$8714ae84b437fe97 = 'AI Modal was closed before the fetch completed';
const $4d08bf51bcedf53e$export$1e71032fcb7b8730 = 'AI_MODAL_CLOSED';
const $4d08bf51bcedf53e$export$64c672172b01336 = 'JS_ERROR';
const $4d08bf51bcedf53e$export$ad3b2223714b1ed9 = {
    FIXED_JQL_HAS_ERRORS: 'fixed-jql-has-errors',
    SERVER_ERROR: 'server-error'
};

});

parcelRegister("hMoNE", function(module, exports) {

$parcel$export(module.exports, "jqlMessagesToErrors", () => $7a67109f6acf81f3$export$c96be9b8b5cbea61);
function $7a67109f6acf81f3$export$c96be9b8b5cbea61(jqlMessages) {
    return jqlMessages?.filter((message)=>message.type === 'error').map((message)=>message.message?.toString()).filter(Boolean);
}

});

parcelRegister("kbhn6", function(module, exports) {

$parcel$export(module.exports, "JQLPanelRenderSlotForJQLEditor", () => $30ee3d17c3a559f0$export$79179285687e80ca);
$parcel$export(module.exports, "JQLPanelRenderSlotForIssueView", () => $30ee3d17c3a559f0$export$1efeb13e93a829bf);

var $eJOHy = parcelRequire("eJOHy");

var $5Wv5g = parcelRequire("5Wv5g");

var $26Ewk = parcelRequire("26Ewk");

var $2z985 = parcelRequire("2z985");

var $1KdDN = parcelRequire("1KdDN");

var $bUnif = parcelRequire("bUnif");

var $lfAG2 = parcelRequire("lfAG2");

var $k0Jpn = parcelRequire("k0Jpn");

var $13f5n = parcelRequire("13f5n");

var $lg8UF = parcelRequire("lg8UF");
function $30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher(props) {
    const layoutQuery = props.fullWidthLayout ? 'below.lg' : 'above.lg';
    const showProp = (0, $eJOHy.useMemo)(()=>props.fullWidthLayout ? {
            below: 'lg'
        } : {
            above: 'lg'
        }, [
        props.fullWidthLayout
    ]);
    const [matches, setMatches] = (0, $eJOHy.useState)(null);
    const mq = (0, $2z985.UNSAFE_useMediaQuery)(layoutQuery, (e)=>{
        setMatches(e.matches);
    });
    return matches ?? mq?.matches ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $26Ewk.Show), {
        ...showProp,
        xcss: props.xcss ? [
            $30ee3d17c3a559f0$var$showContainerStyles,
            props.xcss
        ] : $30ee3d17c3a559f0$var$showContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k0Jpn.JQLDebuggerCommonEntry), null)) : null;
}
const $30ee3d17c3a559f0$export$793a24421ebe4e74 = (props)=>{
    const { errorMessages: errorMessages, testId: testId, validationId: validationId } = props;
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const renderSyncActions = (0, $lfAG2.useRenderSynchronizerStoreActions)();
    const [isAiEnabled] = (0, $bUnif.useIsAiEnabled)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    /**
	 * When the JQL Editor unmounts for whatever reason, we want to mark jql editor as not ready
	 * So that JQLPanelRenderSlotForIssueView doesn't try to accidentally render any error messages
	 *
	 * For example, this happens when we enter NL-to-JQL AI mode while the regular JQL editor has an error
	 */ (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            renderSyncActions.setJqlEditorReady(false);
        };
    }, [
        renderSyncActions
    ]);
    if (!errorMessages?.length || !isReady || !isAiEnabled || status === 'UNRECOVERABLE_ERROR') {
        renderSyncActions.setJqlEditorReady(false);
        return props.children;
    }
    jqlDebuggerStoreActions.setJqlErrors(errorMessages.map((0, $lg8UF.extractTextFromReactElement)));
    jqlDebuggerStoreActions.setErrorComponentTestId(testId);
    jqlDebuggerStoreActions.setErrorComponentValidationId(validationId);
    renderSyncActions.setJqlEditorReady(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: false,
        xcss: $30ee3d17c3a559f0$var$jqlBuilderContainerStyles
    });
};
const $30ee3d17c3a559f0$export$79179285687e80ca = (props)=>{
    const { children: children } = props;
    const ChildrenFallback = (0, $eJOHy.useCallback)(()=>children, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).COMMON_ENTRY_JQL_BUILDER,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$export$793a24421ebe4e74, props));
};
const $30ee3d17c3a559f0$export$1efeb13e93a829bf = ()=>{
    const [isReady] = (0, $lfAG2.useIsContextReady)();
    const [isJqlEditorReady] = (0, $lfAG2.useIsJqlEditorReady)();
    const storeActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    if (!isReady || !isJqlEditorReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).COMMON_ENTRY_ISSUE_VIEW,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: ()=>null,
        onError: ()=>{
            storeActions.setStatus('UNRECOVERABLE_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($30ee3d17c3a559f0$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: true,
        xcss: $30ee3d17c3a559f0$var$issueViewContainerStyles
    }));
};
const $30ee3d17c3a559f0$var$jqlBuilderContainerStyles = (0, $5Wv5g.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.100'
});
const $30ee3d17c3a559f0$var$issueViewContainerStyles = (0, $5Wv5g.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.negative.100'
});
const $30ee3d17c3a559f0$var$showContainerStyles = (0, $5Wv5g.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});
parcelRegister("26Ewk", function(module, exports) {

$parcel$export(module.exports, "Show", () => $cb9efc8be57c14b9$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");

var $5Wv5g = parcelRequire("5Wv5g");

var $jJrxb = parcelRequire("jJrxb");
function $cb9efc8be57c14b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cb9efc8be57c14b9$var$showAboveQueries = (0, $jJrxb.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $cb9efc8be57c14b9$var$showBelowQueries = (0, $jJrxb.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $cb9efc8be57c14b9$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $cb9efc8be57c14b9$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $5Wv5g.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $cb9efc8be57c14b9$var$defaultHiddenStyles,
            above && $cb9efc8be57c14b9$var$showAboveQueries[above],
            below && $cb9efc8be57c14b9$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("jJrxb", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $b5f785561a893a67$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $b5f785561a893a67$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $hjWWB = parcelRequire("hjWWB");

var $bf0Hg = parcelRequire("bf0Hg");
const $b5f785561a893a67$export$918f8818cfbbeb2c = (input)=>{
    return (0, $hjWWB.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bf0Hg.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $b5f785561a893a67$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $hjWWB.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bf0Hg.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("hjWWB", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $f4f7cb185f8865fb$export$2d293d9871c38e91);
const $f4f7cb185f8865fb$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $f4f7cb185f8865fb$export$2d293d9871c38e91 = Object.keys($f4f7cb185f8865fb$export$e5ee4fe8b989fd09);
const $f4f7cb185f8865fb$export$b7ed752a57b4177b = $f4f7cb185f8865fb$export$2d293d9871c38e91[0];

});



parcelRegister("lfAG2", function(module, exports) {

$parcel$export(module.exports, "useRenderSynchronizerStoreActions", () => $7b22efe6dcaae164$export$60f8cec0dff6824c);
$parcel$export(module.exports, "useIsContextReady", () => $7b22efe6dcaae164$export$7668b8e8d8c22896);
$parcel$export(module.exports, "useIsJqlEditorReady", () => $7b22efe6dcaae164$export$7f34a2b12380537d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $7b22efe6dcaae164$var$initialState = {
    isContextReady: false,
    isJqlEditorReady: false
};
const $7b22efe6dcaae164$var$Store = (0, $GtRbT.createStore)({
    initialState: $7b22efe6dcaae164$var$initialState,
    actions: {
        setIsContextReady: (isContextReady)=>({ setState: setState })=>{
                setState({
                    isContextReady: isContextReady
                });
            },
        setJqlEditorReady: (isJqlEditorReady)=>({ setState: setState })=>{
                setState({
                    isJqlEditorReady: isJqlEditorReady
                });
            }
    }
});
const $7b22efe6dcaae164$export$60f8cec0dff6824c = (0, $iJq0l.createActionsHook)($7b22efe6dcaae164$var$Store);
const $7b22efe6dcaae164$export$7668b8e8d8c22896 = (0, $iJq0l.createHook)($7b22efe6dcaae164$var$Store, {
    selector: (state)=>state.isContextReady
});
const $7b22efe6dcaae164$export$7f34a2b12380537d = (0, $iJq0l.createHook)($7b22efe6dcaae164$var$Store, {
    selector: (state)=>state.isJqlEditorReady
});

});

parcelRegister("k0Jpn", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerCommonEntry", () => $182505dbe4321118$export$61b6653f41aa971b);

var $eJOHy = parcelRequire("eJOHy");

var $dhRXV = parcelRequire("dhRXV");

var $9skjA = parcelRequire("9skjA");

var $bbdV2 = parcelRequire("bbdV2");

var $cBavF = parcelRequire("cBavF");

var $f1Zdy = parcelRequire("f1Zdy");

var $epTsa = parcelRequire("epTsa");

var $bUnif = parcelRequire("bUnif");

var $bqGal = parcelRequire("bqGal");

var $iNmbB = parcelRequire("iNmbB");

var $13f5n = parcelRequire("13f5n");

var $awW5u = parcelRequire("awW5u");
function $182505dbe4321118$var$OnError() {
    const debuggerActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    (0, $eJOHy.useEffect)(()=>{
        // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
        // interfering with the feature initial state nor with the AI event instrumentation
        debuggerActions.setStatus('JS_ERROR');
    }, [
        debuggerActions
    ]);
    return null;
}
const $182505dbe4321118$export$61b6653f41aa971b = ()=>{
    const [status] = (0, $bUnif.useDebuggerStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [query] = (0, $bUnif.useJqlQuery)();
    const [jqlErrors] = (0, $bUnif.useJqlErrors)();
    const [onSearch] = (0, $bUnif.useJqlEditorOnSearch)();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $bbdV2.useEntryPoint)((0, $iNmbB.SuggestedFixContentEntrypoint), {});
    // For the proactive experience, we call the API through a useEffect for each applicable render
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) {
            if (status === 'INIT') {
                if (!isReadyForProactive) (0, $awW5u.preloadApiCall)(query, jqlErrors);
                else (0, $awW5u.onClick)({
                    testId: 'jql-debugger-common-entry',
                    createAnalyticsEvent: createAnalyticsEvent,
                    debuggerStoreActions: debuggerStoreActions,
                    query: query,
                    jqlErrors: jqlErrors,
                    onSearch: onSearch,
                    isReadyForProactive: isReadyForProactive
                });
            }
        }
    }, [
        isReadyForProactive,
        status,
        createAnalyticsEvent,
        debuggerStoreActions,
        jqlErrors,
        onSearch,
        query
    ]);
    /*
		We load the entrypoint conditionally here as the JQL debugger panel is rendered underneath the JQL builder for large screen sizes,
		and across the issue view for smaller screen sizes - their visibilty is controlled by a <Show>, but they are two separately
		rendered components. As a result, if we are switching from one screen size or issue view to another, the newly rendered version of the
		JQL debugger will not have a loaded entry point, so we load it here to ensure the content is still visible across different views.

		Example of behaviour without this conditional:
		https://www.loom.com/share/725438e2ea16481591bbe510815e9ca3?sid=b3dc286e-9c37-4cf9-a2c9-f55d3561a166
	*/ if (status !== 'INIT') entryPointActions?.load();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        spacing: "none",
        hasNewBorderExperience: true,
        shouldFitContainer: true,
        isLoading: status === 'LOADING_RESULT'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bqGal.ErrorSection), {
        entryPointActions: entryPointActions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        packageName: (0, $13f5n.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $13f5n.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $13f5n.TEAM_NAME),
        fallback: null,
        errorFallback: $182505dbe4321118$var$OnError
    }));
};

});
parcelRegister("9skjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c22c6f11d6c3191$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $5M7r5 = parcelRequire("5M7r5");

var $dPMMf = parcelRequire("dPMMf");

var $7jTnu = parcelRequire("7jTnu");
let $7c22c6f11d6c3191$var$namespaceUUID = 0;
const $7c22c6f11d6c3191$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION = 3000;
const $7c22c6f11d6c3191$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience, components: { SvgComponent: SvgComponent = $7c22c6f11d6c3191$var$SvgContainer } = {} })=>{
    const { colorMode: colorMode } = (0, $5M7r5.default)();
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    const [showRainbowBorder, setShowRainbowBorder] = (0, $eJOHy.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? $7c22c6f11d6c3191$var$newPalette.dark : $7c22c6f11d6c3191$var$newPalette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $7c22c6f11d6c3191$var$namespaceUUID;
        // eslint-disable-next-line react-hooks/react-compiler
        $7c22c6f11d6c3191$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            hasNewBorderExperience && setShowRainbowBorder(true); // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SvgComponent, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke",
        fill: (0, $7jTnu.fg)('jira_jif_jam_ai_container_ui_fix') ? 'none' : undefined
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $7c22c6f11d6c3191$var$AIContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $7c22c6f11d6c3191$var$Container, ContentComponent: ContentComponent = $7c22c6f11d6c3191$var$Content, SvgComponent: SvgComponent = $7c22c6f11d6c3191$var$SvgContainer } = {}, hasNewBorderExperience: hasNewBorderExperience = false, borderless: borderless = false, zIndex: zIndex = (0, $dPMMf.layers).card }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContainerComponent, {
        "data-testid": testId,
        testId: testId,
        shouldFitContainer: shouldFitContainer,
        zIndex: zIndex
    }, (!(0, $7jTnu.fg)('similar_items_in_gic_ui_fixes') || !borderless) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience,
        components: {
            SvgComponent: SvgComponent
        }
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContentComponent, {
        ref: ref,
        spacing: spacing
    }, children));
});
var $7c22c6f11d6c3191$export$2e2bcd8739ae039 = $7c22c6f11d6c3191$var$AIContainer;
$7c22c6f11d6c3191$var$AIContainer.displayName = 'AIContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $dPMMf.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1pbypt6a",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $dPMMf.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoi2wt _bfhkvuon _16jlkb7n _1pbypt6a _1bsb1osq",
            __cmplp.spacing === 'default' && "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$SvgContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoftgi _kqswstnw",
            __cmplp.isShadow ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7c22c6f11d6c3191$export$71abc632aa29e6fe = {
    ContainerComponent: $7c22c6f11d6c3191$var$Container,
    ContentComponent: $7c22c6f11d6c3191$var$Content,
    SvgComponent: $7c22c6f11d6c3191$var$SvgContainer
};

});

parcelRegister("bqGal", function(module, exports) {

$parcel$export(module.exports, "ErrorSection", () => $a9f0cd966e577c81$export$b0bceea2ea86179a);

var $eJOHy = parcelRequire("eJOHy");

var $2Eu5z = parcelRequire("2Eu5z");

var $bxHeV = parcelRequire("bxHeV");
var $bL3dk = parcelRequire("bL3dk");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $2KjG5 = parcelRequire("2KjG5");

var $6alcT = parcelRequire("6alcT");

var $4BzUI = parcelRequire("4BzUI");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $9n5mq = parcelRequire("9n5mq");

var $f6eza = parcelRequire("f6eza");

var $bUnif = parcelRequire("bUnif");

var $kCNym = parcelRequire("kCNym");

var $fHqkT = parcelRequire("fHqkT");
function $a9f0cd966e577c81$export$b0bceea2ea86179a(props) {
    const { entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [query] = (0, $bUnif.useJqlQuery)();
    const [status] = (0, $bUnif.useDebuggerStatus)();
    const [jqlErrors] = (0, $bUnif.useJqlErrors)();
    const [onSearch] = (0, $bUnif.useJqlEditorOnSearch)();
    const [errorComponentTestId] = (0, $bUnif.useErrorComponentTestId)();
    const [errorComponentValidationId] = (0, $bUnif.useErrorComponentValidationId)();
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const [{ syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors, singleInstrumentationID: singleInstrumentationID }] = (0, $bUnif.useStoreData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    const showDiscardButton = status === 'VIEW_RESULT' || status === 'RESULT_ERROR';
    // The Fix error button should be shown when:
    // The user has not invoked any action to make the experience ready for proactive, or
    // the user returns from dismissing a proactive AI result
    const showFixErrorButton = status === 'RESULT_DISCARDED' || status === 'INIT' && !isReadyForProactive;
    const onDiscardClick = ()=>{
        // The close button can be clicked from either a succesful result view, or an error view (server error or JQL couldn't be corrected)
        const closedFromSource = status === 'RESULT_ERROR' || status === 'VIEW_RESULT' && syntaxCorrectionAttemptErrors.length > 0 ? 'error_view' : 'result_view';
        // Fire `aiResult discarded` event when the close button is clicked in a successful result view
        // https://atlassian.slack.com/archives/C07B7SJR0CT/p1744736278862629?thread_ts=1744328109.644489&cid=C07B7SJR0CT
        if (status === 'VIEW_RESULT' && syntaxCorrectionAttemptErrors.length === 0) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult discarded', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            })
        });
        // Fire an event for the close button being clicked in all cases
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'closeButton clicked', 'jqlDebugger', {
            closedFromSource: closedFromSource
        });
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions.setStatus('RESULT_DISCARDED');
        else jqlDebuggerStoreActions.setStatus('INIT');
    };
    if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $a9f0cd966e577c81$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "h5",
        xcss: $a9f0cd966e577c81$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KjG5))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $fHqkT.default).jqlDebuggerHeadingPluralNonFinal : (0, $fHqkT.default).jqlDebuggerHeadingNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "ul",
        xcss: $a9f0cd966e577c81$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            as: "li",
            key: error,
            xcss: $a9f0cd966e577c81$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? $a9f0cd966e577c81$var$headerEndStylesWithCross : $a9f0cd966e577c81$var$headerEndStyles
    }, status === 'VIEW_RESULT' && !(0, $7jTnu.fg)('gravityai-3165-jql-fixer-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "new"
    }, formatMessage((0, $fHqkT.default).betaLozenge)) : null, showFixErrorButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6eza.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        testId: "jql-debugger.ui.error-section.close-button",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Eu5z))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $fHqkT.default).discardSuggestionNonFinal),
        onClick: onDiscardClick,
        isTooltipDisabled: false
    }) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $a9f0cd966e577c81$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "h5",
        xcss: $a9f0cd966e577c81$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2KjG5))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $fHqkT.default).jqlDebuggerHeadingPluralNonFinal : (0, $fHqkT.default).jqlDebuggerHeadingNonFinal))), status === 'LOADING_RESULT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kCNym.GeneratingAnimation), {
        alt: formatMessage((0, $fHqkT.default).jqlDebuggerLoadingNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), null, formatMessage((0, $fHqkT.default).jqlDebuggerLoadingNonFinal))) : // The wrappers around the ul element try to closely resemble the same structure as the default error message in the platform package
    // See: platform/packages/jql/jql-editor/src/ui/jql-editor-footer-content/jql-messages/errors/index.tsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "ul",
        xcss: $a9f0cd966e577c81$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
            as: "li",
            key: error,
            xcss: $a9f0cd966e577c81$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? $a9f0cd966e577c81$var$headerEndStylesWithCross : $a9f0cd966e577c81$var$headerEndStyles
    }, status === 'VIEW_RESULT' && !(0, $7jTnu.fg)('gravityai-3165-jql-fixer-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: "new"
    }, formatMessage((0, $fHqkT.default).betaLozenge)) : null, status === 'INIT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f6eza.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), (0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button') ? showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        testId: "jql-debugger.ui.error-section.close-button",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Eu5z))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $fHqkT.default).discardSuggestionNonFinal),
        onClick: onDiscardClick,
        isTooltipDisabled: false
    }) : null));
}
const $a9f0cd966e577c81$var$containerStyles = (0, $5Wv5g.xcss)({
    minHeight: "var(--ds-space-400, 32px)"
});
const $a9f0cd966e577c81$var$errorBoxStyles = (0, $5Wv5g.xcss)({
    flex: 1,
    marginBlockStart: '0',
    paddingInlineStart: 'space.025'
});
const $a9f0cd966e577c81$var$headerEndStyles = (0, $5Wv5g.xcss)({
    alignSelf: 'flex-start'
});
const $a9f0cd966e577c81$var$headerEndStylesWithCross = (0, $5Wv5g.xcss)({
    alignSelf: 'flex-start',
    display: 'flex',
    gap: 'space.075',
    alignItems: 'center'
});
const $a9f0cd966e577c81$var$listItemStyle = (0, $5Wv5g.xcss)({
    listStyle: 'none'
});
const $a9f0cd966e577c81$var$jqlErrorHeadingStyles = (0, $5Wv5g.xcss)({
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    gap: 'space.075'
});

});
parcelRegister("9n5mq", function(module, exports) {

$parcel$export(module.exports, "getAiAttributes", () => $93c2edddc4531c15$export$1dc69577c8d8f632);
function $93c2edddc4531c15$export$1dc69577c8d8f632({ singleInstrumentationID: singleInstrumentationID, isReadyForProactive: isReadyForProactive = false }) {
    const userGeneratedAI = isReadyForProactive ? 0 : 1;
    const proactiveAIGenerated = isReadyForProactive ? 1 : 0;
    return {
        aiFeatureName: 'JQL_Debugger',
        userGeneratedAI: userGeneratedAI,
        proactiveAIGenerated: proactiveAIGenerated,
        isAIFeature: 1,
        singleInstrumentationID: singleInstrumentationID
    };
}

});

parcelRegister("f6eza", function(module, exports) {

$parcel$export(module.exports, "FixErrorButton", () => $048c101372748c1a$export$94f98890cd333316);

var $eJOHy = parcelRequire("eJOHy");

var $alkjW = parcelRequire("alkjW");

var $a8kHz = parcelRequire("a8kHz");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $bUnif = parcelRequire("bUnif");

var $29xoF = parcelRequire("29xoF");

function $048c101372748c1a$var$useImportOnClickHandler() {
    const importer = (0, $eJOHy.useCallback)(()=>{
        return Promise.resolve((parcelRequire("awW5u")));
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        importer();
    }, [
        importer
    ]);
    return importer;
}
function $048c101372748c1a$export$94f98890cd333316(props) {
    const { testId: testId, jqlErrors: jqlErrors, onSearch: onSearch, query: query, entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const importer = $048c101372748c1a$var$useImportOnClickHandler();
    const [isReadyForProactive] = (0, $bUnif.useIsReadyForProactive)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fixWithAiButton viewed', {
            debuggerPanel: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($a8kHz))),
        onMouseOver: ()=>{
            entryPointActions?.preload();
        },
        testId: "jql-debugger.ui.fix-error-button.button",
        onClick: async ()=>{
            entryPointActions?.load();
            const { onClick: onClick } = await importer();
            onClick({
                testId: testId,
                query: query || '',
                jqlErrors: jqlErrors,
                onSearch: onSearch,
                createAnalyticsEvent: createAnalyticsEvent,
                debuggerStoreActions: debuggerStoreActions,
                isReadyForProactive: isReadyForProactive
            });
        }
    }, formatMessage((0, $29xoF.default).fixErrorWithAiNonFinal));
}

});
parcelRegister("29xoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fbc607cb38fb1a6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4fbc607cb38fb1a6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix error"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});

});

parcelRegister("awW5u", function(module, exports) {

$parcel$export(module.exports, "endpoint", () => $bfd85cc389cc53db$export$125e2b775860041f);
$parcel$export(module.exports, "apiCache", () => $bfd85cc389cc53db$export$fd9779c86130d7b0);
$parcel$export(module.exports, "preloadApiCall", () => $bfd85cc389cc53db$export$2797ffd2e0fc155);
$parcel$export(module.exports, "onClick", () => $bfd85cc389cc53db$export$1d5a917feb871989);

var $aXKmr = parcelRequire("aXKmr");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $9n5mq = parcelRequire("9n5mq");

var $13f5n = parcelRequire("13f5n");

var $gPSc4 = parcelRequire("gPSc4");

var $gJUBb = parcelRequire("gJUBb");
const $bfd85cc389cc53db$export$125e2b775860041f = (0, $gPSc4.createConvoAiEndpoint)({
    url: '/gateway/api/assist/api/v1/plugin/execute',
    method: 'POST',
    experienceId: 'jira-nl-to-jql-errors',
    product: 'jira'
});
const $bfd85cc389cc53db$export$fd9779c86130d7b0 = (0, $gJUBb.LruCache)();
const $bfd85cc389cc53db$export$2797ffd2e0fc155 = (query, jqlErrors, abortController = new AbortController())=>{
    const promise = $bfd85cc389cc53db$export$fd9779c86130d7b0.get(query)?.value || $bfd85cc389cc53db$export$125e2b775860041f({
        name: 'jirajqldebug',
        schema: {
            type: 'jirajqldebug',
            userQuery: query,
            userQueryError: jqlErrors?.join('. \n') || ''
        }
    }, {
        abortControllerSignal: abortController.signal
    });
    $bfd85cc389cc53db$export$fd9779c86130d7b0.set(query, promise);
    return promise;
};
async function $bfd85cc389cc53db$export$1d5a917feb871989({ testId: testId, createAnalyticsEvent: createAnalyticsEvent, query: query, debuggerStoreActions: debuggerStoreActions, jqlErrors: jqlErrors, onSearch: onSearch, isReadyForProactive: isReadyForProactive = false }) {
    const singleInstrumentationID = (0, $aXKmr.v4)();
    try {
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', (0, $9n5mq.getAiAttributes)({
            singleInstrumentationID: singleInstrumentationID,
            ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                isReadyForProactive: isReadyForProactive
            } : {}
        }));
        const abortController = new AbortController();
        // When we trigger the JQL Debugger within NL-to-JQL, we want to exit the natural language mode
        // This is because two AI features cannot be nested within each other
        // Attempting to show two AI features at once also interferes with non functional aspects such as loading states, analytics and feedback collector
        debuggerStoreActions.exitNaturalLanguageMode();
        debuggerStoreActions.setStateOnFeatureInvoke({
            jqlQuery: query,
            singleInstrumentationID: singleInstrumentationID,
            errorSectionTestId: testId
        });
        // Register callback to be called when there is a javascript error
        // Currently all it does is aborting any pending API calls
        debuggerStoreActions.setOnJsError(()=>{
            abortController?.abort(new DOMException((0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $13f5n.JS_ERROR_ABORT_REASON_NAME)));
        });
        // Register callback to be used when the AI modal is dismissed
        debuggerStoreActions.setOnAiInteractionDismissed((dismissReason, status)=>{
            // Abort any pending API calls
            abortController?.abort(new DOMException((0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)));
            if ((0, $7jTnu.fg)('gravityai-2571-jql-debugger-close-button')) {
                // When a successful result is shown, the AI result is discarded, not dismissed by definition on
                // single instrumentation docs: https://hello.atlassian.net/wiki/x/gqTA4
                if (status === 'VIEW_RESULT') (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult discarded', {
                    ...(0, $9n5mq.getAiAttributes)({
                        singleInstrumentationID: singleInstrumentationID,
                        ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                            isReadyForProactive: isReadyForProactive
                        } : {}
                    })
                });
                else // Fire the singleInstrumentation event
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                    ...(0, $9n5mq.getAiAttributes)({
                        singleInstrumentationID: singleInstrumentationID,
                        ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                            isReadyForProactive: isReadyForProactive
                        } : {}
                    }),
                    dismissReason: dismissReason
                });
            } else // Fire the singleInstrumentation event
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                ...(0, $9n5mq.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                        isReadyForProactive: isReadyForProactive
                    } : {}
                }),
                dismissReason: dismissReason
            });
        });
        let response = null;
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) {
            const promise = $bfd85cc389cc53db$export$2797ffd2e0fc155(query, jqlErrors, abortController);
            response = await promise;
        } else response = await $bfd85cc389cc53db$export$125e2b775860041f({
            name: 'jirajqldebug',
            schema: {
                type: 'jirajqldebug',
                userQuery: query,
                userQueryError: jqlErrors?.join('. \n') || ''
            }
        }, {
            abortControllerSignal: abortController?.signal
        });
        /**
		 * Set the API response data on the store, so that the data can be consumed by the JQLDebuggerRenderSlot
		 *
		 * This is because the trigger and the render slot are used in two different packages
		 *  - Trigger is rendered inside the JQL Builder
		 *  - Render slot is in Issue Navigator
		 *
		 * By keeping these two components loosely coupled, we can style them independent of each other
		 * Yet they are highly cohesive, so that one can be controlled by the other by updating data on the store
		 *
		 * This approach also allows us to minimise the javascript bundles loaded for each component in their specific circumstances
		 * For example, the render-slot chunk is not loaded until the users hover over the trigger button
		 * Similarly the trigger-button chunk is not loaded unless there are errors in the jql-editor
		 */ const syntaxCorrectionAttemptErrors = response?.metadata?.value?.errors || [];
        if (syntaxCorrectionAttemptErrors.length) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            }),
            aiResultErrorCategory: (0, $13f5n.AI_RESULT_ERROR_CATEGORIES).FIXED_JQL_HAS_ERRORS
        });
        debuggerStoreActions.setJqlErorCorrectionData({
            userQueryError: jqlErrors || [],
            onSearch: onSearch || (()=>undefined),
            jqlDiffTokens: response?.metadata?.value?.diff || [],
            syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors
        });
    } catch (e) {
        if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) $bfd85cc389cc53db$export$fd9779c86130d7b0.delete(query);
        const isNetworkCallAbort = e instanceof DOMException;
        (0, $gYnSx.default)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'JQL_Debugger',
                packageName: '@atlassian/jira-jql-debugger',
                teamName: 'gravity-ai'
            },
            attributes: {
                ...(0, $9n5mq.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                        isReadyForProactive: isReadyForProactive
                    } : {}
                }),
                isNetworkCallAbort: isNetworkCallAbort
            },
            error: e instanceof Error ? e : undefined,
            // When the network call is aborted due to dismissing the modal, then we don't want to send the error to Sentry as
            // it is not necessarily an error (e.g, a user could simply be searching for a different query)
            skipSentry: isNetworkCallAbort && e.name === (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)
        });
        if (isNetworkCallAbort) {
            // When network call is aborted due to a javascript error, then don't change the feature state
            if (e.name === (0, $13f5n.JS_ERROR_ABORT_REASON_NAME)) return;
            // When network call is aborted due to dismissing the modal, then we reset the feature state to initial state
            if (e.name === (0, $13f5n.CLOSED_AI_MODAL_ABORT_REASON_NAME)) {
                debuggerStoreActions.resetStatus('NETWORK_CALL_ABORT');
                return;
            }
        }
        // Do not fire the unified ai anlytics event for aiResult error when the API call is aborted
        // i.e. the interaction was dismissed, but not necessarily resulted in an error
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $9n5mq.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            }),
            aiResultErrorCategory: (0, $13f5n.AI_RESULT_ERROR_CATEGORIES).SERVER_ERROR
        });
        // Explicitly update the status to be RESULT_ERROR in the fallthrough case
        debuggerStoreActions.setStatus('RESULT_ERROR');
    }
}

});
parcelRegister("gPSc4", function(module, exports) {

$parcel$export(module.exports, "createConvoAiEndpoint", () => $78102f89db9e576c$export$f8ba6757167c2aba);
const $78102f89db9e576c$export$f8ba6757167c2aba = (initArgs)=>async (body, options)=>{
        const response = await fetch(initArgs.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': initArgs.product,
                'X-Experience-Id': initArgs.experienceId
            },
            body: JSON.stringify(body),
            signal: options.abortControllerSignal
        });
        if (!response.ok) throw new Error(`API call failed: ${response.status}`);
        const result = await response.json();
        return result;
    };

});

parcelRegister("gJUBb", function(module, exports) {

$parcel$export(module.exports, "LruCache", () => $3a4833cdaf1c1f06$export$ec63a4108685a0aa);
function $3a4833cdaf1c1f06$export$ec63a4108685a0aa(limit = 5) {
    const cache = new Map();
    return {
        get: (key)=>cache.get(key),
        set: (key, value)=>{
            cache.set(key, {
                lastAccessed: Date.now(),
                value: value
            });
            if (cache.size <= limit) return;
            // limit the cache size based on the oldest entry based on lastAccessed time
            let oldestKey = null;
            let oldestLastAccessed = null;
            for (const [key_, value_] of cache.entries())if (oldestLastAccessed === null || value_.lastAccessed < oldestLastAccessed) {
                oldestKey = key_;
                oldestLastAccessed = value_.lastAccessed;
            }
            if (oldestKey) cache.delete(oldestKey);
        },
        delete: (key)=>{
            cache.delete(key);
        },
        clear: ()=>{
            cache.clear();
        }
    };
}

});



parcelRegister("kCNym", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $dc78dc961c2fbf63$export$483f53d5a0354a30);

var $eJOHy = parcelRequire("eJOHy");
const $dc78dc961c2fbf63$export$483f53d5a0354a30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "20",
        viewBox: "0 2 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("fHqkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfe1ae393dfab8a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0dfe1ae393dfab8a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jqlDebuggerHeadingNonFinal: {
        "id": "jql-debugger-panel.header.text-non-final",
        "defaultMessage": "JQL error"
    },
    jqlDebuggerHeadingPluralNonFinal: {
        "id": "jql-debugger-panel.header.plural-text-non-final",
        "defaultMessage": "JQL errors"
    },
    jqlDebuggerLoadingNonFinal: {
        "id": "jql-debugger-panel.header.loading-non-final",
        "defaultMessage": "Generating query fixes"
    },
    betaLozenge: {
        "id": "jql-debugger-panel.header.beta-lozenge",
        "defaultMessage": "Beta"
    },
    discardSuggestionNonFinal: {
        "id": "jql-debugger-panel.error-section.discard-suggestion-non-final",
        "defaultMessage": "Discard and close"
    }
});

});


parcelRegister("iNmbB", function(module, exports) {

$parcel$export(module.exports, "SuggestedFixContentEntrypoint", () => $5a5654ca917f495c$export$9b2c3d0b37e41ae9);

var $2aGAf = parcelRequire("2aGAf");

var $4BK1O = parcelRequire("4BK1O");

const $5a5654ca917f495c$export$9b2c3d0b37e41ae9 = (0, $4BK1O.createEntryPoint)({
    root: (0, $2aGAf.JSResourceForInteraction)(()=>(parcelRequire("4sS95")), {
        moduleId: "2d263a55",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("4sS95", function(module, exports) {

let $3403c72571a3ef25$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3403c72571a3ef25$var$load("l5TeW").then(()=>parcelRequire('d16oc'));

});



parcelRegister("lg8UF", function(module, exports) {

$parcel$export(module.exports, "extractTextFromReactElement", () => $91bb6ebc41ba1a5e$export$98ee087174ba8894);

var $eJOHy = parcelRequire("eJOHy");
function $91bb6ebc41ba1a5e$export$98ee087174ba8894(element) {
    let result = '';
    function traverse(node) {
        if (typeof node === 'string' || typeof node === 'number') result += node.toString();
        else if (/*#__PURE__*/ (0, $eJOHy.isValidElement)(node)) (0, $eJOHy.Children).forEach(node.props.children, (child)=>{
            traverse(child);
        });
    }
    traverse(element);
    return result;
}

});


parcelRegister("6Vq1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $f69b94536cc1a621$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f69b94536cc1a621$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix with AI"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});

});

parcelRegister("gr39h", function(module, exports) {

$parcel$export(module.exports, "JqlDebuggerJqlBuilderContextProvider", () => $f1561459319f3132$export$c2426bb4c28cc626);
$parcel$export(module.exports, "useJqlDebuggerAdditionalContext", () => $f1561459319f3132$export$3b2021865598576e);

var $eJOHy = parcelRequire("eJOHy");

var $bJscI = parcelRequire("bJscI");

var $fZD08 = parcelRequire("fZD08");
const $f1561459319f3132$var$jqlDebuggerContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    onSearch: ()=>undefined,
    query: '',
    jqlMessages: []
});
/**
 * Provide additional context about the JQL Builder context to the JQL Debugger
 *
 * This additional context exists primarily because we need to pass some props from JQL builder to the customComponent override of ErrorMessage
 * Since ErrorMessage component (jql-debugger trigger-button) is passed as a component, we cannot pass the additional props as regular props
 * Hence we wrap the parent with this provider and pass the props as context
 */ const $f1561459319f3132$var$JqlDebuggerJqlBuilderContextProviderOld = (props)=>{
    const { jqlMessages: jqlMessages, query: query, onSearch: onSearch } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1561459319f3132$var$jqlDebuggerContext.Provider, {
        value: {
            query: query,
            jqlMessages: jqlMessages,
            onSearch: onSearch
        }
    }, props.children);
};
const $f1561459319f3132$export$c2426bb4c28cc626 = (0, $bJscI.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $fZD08.JqlDebuggerJqlBuilderContextProvider), $f1561459319f3132$var$JqlDebuggerJqlBuilderContextProviderOld);
const $f1561459319f3132$export$3b2021865598576e = ()=>(0, $eJOHy.useContext)($f1561459319f3132$var$jqlDebuggerContext);

});
parcelRegister("fZD08", function(module, exports) {

$parcel$export(module.exports, "JqlDebuggerJqlBuilderContextProvider", () => $6a81d5ddf104d319$export$c2426bb4c28cc626);

var $bUnif = parcelRequire("bUnif");

var $lfAG2 = parcelRequire("lfAG2");
const $6a81d5ddf104d319$export$c2426bb4c28cc626 = (props)=>{
    const { query: query, onSearch: onSearch, children: children } = props;
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)();
    const renderSyncActions = (0, $lfAG2.useRenderSynchronizerStoreActions)();
    // JQL Debugger is not ready when:
    // 1. AI is not enabled
    // 2. onSearch callback is not available - i.e. we cannot apply the corrected jql to the editor
    //
    // In such cases, we want to keep the default error layout
    if (onSearch && query) {
        jqlDebuggerStoreActions.setOnSearch(onSearch);
        jqlDebuggerStoreActions.setJqlQuery(query);
        renderSyncActions.setIsContextReady(true);
    } else renderSyncActions.setIsContextReady(false);
    return children;
};

});


parcelRegister("8zsTV", function(module, exports) {

let $63d802bddf445fe4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $63d802bddf445fe4$var$load("cwg8x").then(()=>parcelRequire('alMOc'));

});


parcelRegister("34Sgq", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcherRenderer", () => $c32c98d36df1a3c5$export$f054999725e0d47f);

var $eJOHy = parcelRequire("eJOHy");

var $56qWy = parcelRequire("56qWy");

var $9HnR3 = parcelRequire("9HnR3");

var $7bFFO = parcelRequire("7bFFO");

var $cX22j = parcelRequire("cX22j");

var $70el7 = parcelRequire("70el7");
const $c32c98d36df1a3c5$export$f054999725e0d47f = ({ isSearchModeToggleEnabled: isSearchModeToggleEnabled, SearchModeSwitcher: SearchModeSwitcher = (0, $9HnR3.SearchModeSwitcherWithTarget), isHydrating: isHydrating, isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft })=>{
    const { searchMode: selectedSearchMode, setSelectedSearchMode: setSelectedSearchMode } = (0, $cX22j.useSelectedSearchMode)();
    const { querySupported: querySupported } = (0, $70el7.useIsQuerySupported)();
    const onUpdateSearchMode = (0, $eJOHy.useCallback)((searchMode)=>{
        setSelectedSearchMode(searchMode, true);
    }, [
        setSelectedSearchMode
    ]);
    const isBasicModeDisabled = (0, $eJOHy.useMemo)(()=>// We disable basic mode if:
        // If query is not supported
        !querySupported || // Or if is supported but is also hydrating and we are not in basic mode
        isHydrating && selectedSearchMode !== (0, $56qWy.SEARCH_MODE_BASIC), [
        isHydrating,
        querySupported,
        selectedSearchMode
    ]);
    return isSearchModeToggleEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7bFFO.SearchModeSwitcherContainer), {
        testId: "jql-builder.ui.search-mode-switcher-renderer.toggle-container",
        isSearchModeSwitcherOnLeft: isSearchModeSwitcherOnLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SearchModeSwitcher, {
        searchMode: selectedSearchMode,
        isBasicModeDisabled: isBasicModeDisabled,
        onUpdateSearchMode: onUpdateSearchMode
    })) : null;
};

});




parcelRegister("iUwEA", function(module, exports) {

$parcel$export(module.exports, "useNaturalLanguageMode", () => $6703b84e2e411836$export$617c50bbd595c5ac);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $6703b84e2e411836$var$initialState = {
    isNaturalLanguageMode: false
};
const $6703b84e2e411836$export$e324594224ef24da = {
    toggleNaturalLanguageMode: ()=>({ setState: setState, getState: getState })=>{
            setState({
                isNaturalLanguageMode: !getState().isNaturalLanguageMode
            });
        },
    exitNaturalLanguageMode: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
};
const $6703b84e2e411836$var$Store = (0, $GtRbT.createStore)({
    initialState: $6703b84e2e411836$var$initialState,
    actions: $6703b84e2e411836$export$e324594224ef24da
});
const $6703b84e2e411836$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($6703b84e2e411836$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
});
const $6703b84e2e411836$var$getNaturalLanguageMode = (state)=>state.isNaturalLanguageMode;
const $6703b84e2e411836$export$617c50bbd595c5ac = (0, $iJq0l.createHook)($6703b84e2e411836$var$Store, {
    selector: $6703b84e2e411836$var$getNaturalLanguageMode
});
const $6703b84e2e411836$export$d99c2d47e59edc60 = (0, $iJq0l.createActionsHook)($6703b84e2e411836$var$Store);

});

parcelRegister("1tqww", function(module, exports) {

$parcel$export(module.exports, "AIPremiumUpsellButtonPopup", () => $88857a0604fa82b4$export$8a1c240781b9aa13);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $iTElX = parcelRequire("iTElX");
var $dKpTa = parcelRequire("dKpTa");

var $bvFRW = parcelRequire("bvFRW");

var $g17XP = parcelRequire("g17XP");

var $aymPs = parcelRequire("aymPs");

var $51Gwp = parcelRequire("51Gwp");

var $bxHeV = parcelRequire("bxHeV");
var $bL3dk = parcelRequire("bL3dk");
var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $7jTnu = parcelRequire("7jTnu");

var $cNe2t = parcelRequire("cNe2t");


var $9paWu = parcelRequire("9paWu");

var $ln6Iy = parcelRequire("ln6Iy");

var $ciFJV = parcelRequire("ciFJV");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $ivXYk = parcelRequire("ivXYk");

var $lRq8t = parcelRequire("lRq8t");

var $jM5Jy = parcelRequire("jM5Jy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lldWQ = parcelRequire("lldWQ");

var $8vyDv = parcelRequire("8vyDv");

var $lUto7 = parcelRequire("lUto7");

var $k65ux = parcelRequire("k65ux");
const $88857a0604fa82b4$var$DialogContents = ({ onClose: onClose, buttonTrigger: buttonTrigger })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $88857a0604fa82b4$var$backgroundBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        xcss: $88857a0604fa82b4$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        xcss: $88857a0604fa82b4$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $88857a0604fa82b4$var$imageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivXYk.default), {
        alt: formatMessage((0, $k65ux.default).bannerAltText)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $88857a0604fa82b4$var$closeButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g17XP))), {
        LEGACY_size: "small",
        label: formatMessage((0, $k65ux.default).closeModal),
        color: "var(--ds-icon, #44546F)"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        alignBlock: "start",
        space: "space.100",
        xcss: $88857a0604fa82b4$var$contentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "small"
    }, formatMessage((0, $k65ux.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $k65ux.default).descriptionSporkIssueTerminologyRefreshM4 : (0, $k65ux.default).descriptionSpork, {
        link: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
                target: "_blank",
                href: (0, $8e9abaad3d9cfcae$export$af6d68522cb370b8),
                onClick: ()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'atlassianIntelligenceLearnMore')
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignInline: "end",
        xcss: $88857a0604fa82b4$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iTElX.default), {
        ref: buttonTrigger,
        onClick: onClose,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aymPs))), {
            LEGACY_size: "small",
            label: formatMessage((0, $k65ux.default).premiumIconLabel),
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        size: "medium",
        weight: "medium",
        color: "color.text.inverse"
    }, formatMessage((0, $k65ux.default).tryItFreeButton)))))));
};
const $88857a0604fa82b4$var$entryPointParams = {};
const $88857a0604fa82b4$export$8a1c240781b9aa13 = ()=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const isSoftwareAppStandardEdition = (0, $lldWQ.isStandardEdition)((0, $ln6Iy.SOFTWARE_PROJECT), appEditions);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $jM5Jy.entryPointPremiumUpgradeModal), $88857a0604fa82b4$var$entryPointParams);
    const tryItFreeButtonTrigger = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const onAIButtonClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        if (!isOpen) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'jqlBuilderAiTogglePremiumUpsell');
        setIsOpen((open)=>!open);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onTryItFreeButtonClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', 'upgradeToPremiumFromJqlAiUpsell');
        setIsOpen(false);
    }, [
        setIsOpen
    ]); // We only want to show the AI Premium Upsell button to Standard Edition Site Admins
    if (!isSiteAdmin || !isSoftwareAppStandardEdition) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($88857a0604fa82b4$var$DialogContents, {
                onClose: onTryItFreeButtonClick,
                buttonTrigger: tryItFreeButtonTrigger
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9paWu.AIButton), {
                ...triggerProps,
                onClick: onAIButtonClick
            }),
        placement: "bottom-start",
        messageId: "jql-builder-with-ai.ui.ai-premium-upsell-button-popup.popup.ai-premium-upsell-button",
        messageType: "marketing"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jira-premium-upgrade-modal",
        packageName: "jiraPremiumUpgradeModal",
        errorFallback: "flag",
        runtimeProps: {
            onClose: entryPointActions.unload
        },
        entryPointActions: entryPointActions
    }));
};
const $88857a0604fa82b4$var$backgroundBorderStyles = (0, $5Wv5g.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius.100',
    width: '450px',
    padding: 'space.025',
    position: 'relative',
    background: `linear-gradient(135deg, ${"var(--ds-background-accent-blue-subtle, #579DFF)"}, ${"var(--ds-background-accent-purple-subtle, #9F8FEF)"})`
});
const $88857a0604fa82b4$var$containerStyles = (0, $5Wv5g.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay'
});
const $88857a0604fa82b4$var$imageWrapperStyles = (0, $5Wv5g.xcss)({
    borderTopLeftRadius: 'border.radius',
    borderTopRightRadius: 'border.radius'
});
const $88857a0604fa82b4$var$imageStyles = (0, $5Wv5g.xcss)({
    objectFit: 'cover',
    width: '100%',
    borderTopLeftRadius: 'border.radius.100',
    borderTopRightRadius: 'border.radius.100',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0'
});
const $88857a0604fa82b4$var$closeButtonWrapperStyles = (0, $5Wv5g.xcss)({
    position: 'absolute',
    top: '0',
    right: '0',
    padding: 'space.200'
});
const $88857a0604fa82b4$var$contentContainerStyles = (0, $5Wv5g.xcss)({
    padding: 'space.300',
    alignSelf: 'stretch'
});
const $88857a0604fa82b4$var$buttonContainerStyles = (0, $5Wv5g.xcss)({
    width: '100%',
    marginTop: 'space.100'
});

});
const $8e9abaad3d9cfcae$export$1a33ff8e70228fd6 = 'Atlassian Intelligence';
const $8e9abaad3d9cfcae$export$9c7ce577b80c2668 = 8;
const $8e9abaad3d9cfcae$export$d0d4ed81e1ed42ec = 6;
const $8e9abaad3d9cfcae$export$b6e7a25078ed1a5f = 7;
const $8e9abaad3d9cfcae$export$d0f488901b85b750 = 'LIKE';
const $8e9abaad3d9cfcae$export$7ca6708a8b83d828 = 'DISLIKE';
const $8e9abaad3d9cfcae$export$af6d68522cb370b8 = 'https://support.atlassian.com/organization-administration/docs/get-started-with-atlassian-intelligence/';

parcelRegister("9paWu", function(module, exports) {

$parcel$export(module.exports, "AIButton", () => $c9dbb125b0a6a333$export$a51986b9c6d9ac89);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $alkjW = parcelRequire("alkjW");

var $dhRXV = parcelRequire("dhRXV");
var $gPqEA = parcelRequire("gPqEA");
var $h8epd = parcelRequire("h8epd");

var $26Ewk = parcelRequire("26Ewk");

var $01Fzu = parcelRequire("01Fzu");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $9skjA = parcelRequire("9skjA");

var $4R2jN = parcelRequire("4R2jN");

var $iURn3 = parcelRequire("iURn3");
const $c9dbb125b0a6a333$var$AIButtonOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ autoFocus: autoFocus, onClick: onClick }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        spacing: "none",
        isShadow: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        ref: ref,
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        appearance: "subtle",
        onClick: onClick,
        spacing: "none",
        "aria-label": "AI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dhRXV.default), {
        paddingBlock: "space.050",
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPqEA.default), {
        gap: "space.050",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4R2jN.AiIcon), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h8epd.default), {
        color: "color.text.selected",
        weight: "medium"
    }, "AI"))))));
// Rendering the AI button as part of the NL2JQL CTA change
const $c9dbb125b0a6a333$var$renderAIButtonCta = ()=>{
    if ((0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'FIND_WORK', 'CONTROL')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $iURn3.default).findWorkNonFinal);
    if ((0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'QUICK_SEARCH', 'CONTROL')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $iURn3.default).quickSearchNonFinal);
    // This case is the ASK_AI variant
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $iURn3.default).askAiNonFinal);
};
const $c9dbb125b0a6a333$var$AIButtonNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ autoFocus: autoFocus, onClick: onClick, onToggleBlur: onToggleBlur }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $alkjW.default), {
        ref: ref,
        autoFocus: autoFocus,
        onClick: onClick,
        appearance: "default",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($01Fzu))),
        onBlur: onToggleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $26Ewk.Show), {
        above: "md"
    }, $c9dbb125b0a6a333$var$renderAIButtonCta()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $26Ewk.Show), {
        below: "md"
    }, formatMessage((0, $iURn3.default).aiSearchShortNonFinal)));
});
const $c9dbb125b0a6a333$export$a51986b9c6d9ac89 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ autoFocus: autoFocus, onClick: onClick, onToggleBlur: onToggleBlur }, ref)=>{
    if (!(0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'FIND_WORK', 'CONTROL') && !(0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'QUICK_SEARCH', 'CONTROL') && !(0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'ASK_AI', 'CONTROL')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9dbb125b0a6a333$var$AIButtonOld, {
        autoFocus: autoFocus,
        onClick: onClick,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9dbb125b0a6a333$var$AIButtonNew, {
        autoFocus: autoFocus,
        onClick: onClick,
        ref: ref,
        onToggleBlur: onToggleBlur
    });
});

});
parcelRegister("01Fzu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $005057528cfcac92$var$_react = $005057528cfcac92$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $005057528cfcac92$var$_baseNew = $005057528cfcac92$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $005057528cfcac92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $005057528cfcac92$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $005057528cfcac92$var$_react.default.createElement($005057528cfcac92$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$005057528cfcac92$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $005057528cfcac92$var$_default = module.exports.default = $005057528cfcac92$var$AtlassianIntelligenceIcon;

});

parcelRegister("4R2jN", function(module, exports) {

$parcel$export(module.exports, "AiIcon", () => $d2ec776599e18090$export$762da6f7f5ace732);

var $eJOHy = parcelRequire("eJOHy");

var $lb1YQ = parcelRequire("lb1YQ");
const $d2ec776599e18090$export$762da6f7f5ace732 = (props)=>{
    let iconAccentBlueB200;
    let textAccentBlueB400;
    if (props.isDisabled) {
        iconAccentBlueB200 = "var(--ds-text-subtlest, #626F86)";
        textAccentBlueB400 = "var(--ds-text-subtlest, #626F86)";
    } else if (props.isDisabled) {
        iconAccentBlueB200 = "var(--ds-icon-accent-gray, #758195)";
        textAccentBlueB400 = "var(--ds-text-accent-gray, #44546F)";
    } else {
        iconAccentBlueB200 = "var(--ds-icon-accent-blue, #1D7AFC)";
        textAccentBlueB400 = "var(--ds-text-accent-blue, #0055CC)";
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lb1YQ.default), {
        ...props,
        testId: "atlassian-intelligence.common.ui.ai-icon.svg-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg0)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg1)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg2)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: props.isDisabled ? "var(--ds-text-subtlest, #626F86)" : 'url(#ai_icon_lg3)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconAccentBlueB200
    })));
};

});

parcelRegister("iURn3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9148581a5aebe955$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9148581a5aebe955$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    quickSearchNonFinal: {
        "id": "atlassian-intelligence.common.ui.ai-button.quick-search-non-final",
        "defaultMessage": "Quick search"
    },
    findWorkNonFinal: {
        "id": "atlassian-intelligence.common.ui.ai-button.find-work-non-final",
        "defaultMessage": "Find work"
    },
    askAiNonFinal: {
        "id": "atlassian-intelligence.common.ui.ai-button.ask-ai-non-final",
        "defaultMessage": "Ask AI"
    },
    aiSearchShortNonFinal: {
        "id": "atlassian-intelligence.common.ui.ai-button.ai-search-short-non-final",
        "defaultMessage": "AI"
    }
});

});


parcelRegister("ivXYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a23eb71b54d1af2e$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $bgAjU = parcelRequire("bgAjU");

var $9evIv = parcelRequire("9evIv");
const $a23eb71b54d1af2e$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($9evIv)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($bgAjU))
});
var $a23eb71b54d1af2e$export$2e2bcd8739ae039 = $a23eb71b54d1af2e$var$Illustration;
// for advanced use only
const $a23eb71b54d1af2e$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    110
];

});
parcelRegister("bgAjU", function(module, exports) {
module.exports = new URL("ai-premium-upsell-darkmode.090d0954.svg", import.meta.url).toString();

});

parcelRegister("9evIv", function(module, exports) {
module.exports = new URL("ai-premium-upsell.b942d6b5.svg", import.meta.url).toString();

});


parcelRegister("lldWQ", function(module, exports) {

$parcel$export(module.exports, "hasPermissionGate", () => $aad1b3258d475d56$export$2d7869ada39bf0b);
$parcel$export(module.exports, "isStandardEdition", () => $aad1b3258d475d56$export$4b1af5399a63f452);
$parcel$export(module.exports, "isFreeEdition", () => $aad1b3258d475d56$export$a8e9f6df1deeb7d);
$parcel$export(module.exports, "hasPermissionToArchive", () => $aad1b3258d475d56$export$70eef98d89c5d158);

var $ln6Iy = parcelRequire("ln6Iy");

var $a9ldn = parcelRequire("a9ldn");
const $aad1b3258d475d56$export$2d7869ada39bf0b = (projectType, appEditions)=>(0, $a9ldn.getEditionForProject)(projectType, appEditions) === (0, $a9ldn.PREMIUM_EDITION);
const $aad1b3258d475d56$export$4b1af5399a63f452 = (projectType, appEditions)=>(0, $a9ldn.getEditionForProject)(projectType, appEditions) === (0, $a9ldn.STANDARD_EDITION);
const $aad1b3258d475d56$export$a8e9f6df1deeb7d = (projectType, appEditions)=>(0, $a9ldn.getEditionForProject)(projectType, appEditions) === (0, $a9ldn.FREE_EDITION);
const $aad1b3258d475d56$var$hasPermissionToArchiveProject = (isSimplified, isAdmin, canAdministerProject)=>{
    if (isSimplified) return isAdmin || canAdministerProject; // Either Jira admins or Project admins can archive the simplified/next-gen project
    return isAdmin; // Only Jira admins can archive the classic software project
};
const $aad1b3258d475d56$export$70eef98d89c5d158 = ({ projectType: projectType, isSimplified: isSimplified, isAdmin: isAdmin, canAdministerProject: canAdministerProject })=>{
    switch(projectType){
        case 0, $ln6Iy.SOFTWARE_PROJECT:
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
        case 0, $ln6Iy.CORE_PROJECT:
            return $aad1b3258d475d56$var$hasPermissionToArchiveProject(isSimplified, isAdmin, canAdministerProject);
        default:
            return false;
    }
};

});

parcelRegister("k65ux", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b0fb6ad2a0dd0a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $48b0fb6ad2a0dd0a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    closeModal: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.close-modal",
        "defaultMessage": "Close modal"
    },
    bannerAltText: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.banner-alt-text",
        "defaultMessage": "Decorative banner"
    },
    premiumIconLabel: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.premium-icon-label",
        "defaultMessage": "Upgrade to Jira Premium"
    },
    heading: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.heading",
        "defaultMessage": "No more complex queries"
    },
    descriptionSpork: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.description-spork",
        "defaultMessage": "Search for issues in your own words with <link>Atlassian Intelligence (AI)</link>. Try AI with Jira Premium."
    },
    tryItFreeButton: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.try-it-free-button",
        "defaultMessage": "Try it free"
    },
    descriptionSporkIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.ai-premium-upsell-button-popup.description-spork-issue-terminology-refresh-m4",
        "defaultMessage": "Search for work items in your own words with <link>Atlassian Intelligence (AI)</link>. Try AI with Jira Premium."
    }
});

});


parcelRegister("2QWuu", function(module, exports) {

$parcel$export(module.exports, "NaturalLanguageToJQLWrapper", () => $585b092fcba8b276$export$b04216da143ef4b0);

var $fiZ73 = parcelRequire("fiZ73");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $lRq8t = parcelRequire("lRq8t");

var $6sTi7 = parcelRequire("6sTi7");

var $gokBr = parcelRequire("gokBr");

var $fNOMn = parcelRequire("fNOMn");

var $437hw = parcelRequire("437hw");

var $56qWy = parcelRequire("56qWy");


var $6mUAz = parcelRequire("6mUAz");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $7jTnu = parcelRequire("7jTnu");

var $bUnif = parcelRequire("bUnif");

var $epTsa = parcelRequire("epTsa");

var $83x9v = parcelRequire("83x9v");

var $hf0iW = parcelRequire("hf0iW");

var $bZ6RS = parcelRequire("bZ6RS");

var $3SZaW = parcelRequire("3SZaW");

var $2JKeq = parcelRequire("2JKeq");
const $585b092fcba8b276$var$createUseDebouncedEventForAIResult = ()=>{
    const lastEventPublishedState = {};
    let previousTimeoutId = setTimeout(()=>({}), 0); // Current debounce timeout is 2 seconds. This value was chosen by observation only. Feel free to update as necessary
    const DEBOUNCE_TIMEOUT = 2000; // To avoid any memory leaks, we clear the lastPublished entry after 10seconds
    // The idea here is that events can duplicated if multiple events for same promptId arrive 10seconds apart
    // In practice however, all events finish arriving within 500ms-1500ms
    const DUPLICATE_CHECK_CLEAR_TIMEOUT = 10000;
    return function useDebouncedReadyEvent() {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
        const fireEventForAIResult = (0, $eJOHy.useCallback)(({ isSuccess: isSuccess, is5xxError: is5xxError, promptId: promptId = '', errorOrigin: errorOrigin = '' })=>{
            // Clear any pending timeouts so that the latest event data is used
            // If the promptId is different, then we don't need to clear the timeout, and just let the event go through
            if (lastEventPublishedState[promptId] === 'PENDING') clearTimeout(previousTimeoutId);
            if (lastEventPublishedState[promptId] === 'PUBLISHED') // Event already published. Ignore the latest data and stick with the previously published event
            return;
             // Mark that an event is pending for the particular promptId
            lastEventPublishedState[promptId] = 'PENDING'; // Update the timeoutId, so that it can be cleared when the data becomes stale (with a newer event)
            previousTimeoutId = setTimeout(()=>{
                if (isSuccess) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
                    aiFeatureName: (0, $8985fbecf34f047a$export$819aee5dd7b4244d),
                    singleInstrumentationID: promptId,
                    userGeneratedAI: 1,
                    proactiveAIGenerated: 0,
                    isAIFeature: 1
                });
                else (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
                    aiFeatureName: (0, $8985fbecf34f047a$export$819aee5dd7b4244d),
                    singleInstrumentationID: promptId,
                    errorOrigin: errorOrigin,
                    userGeneratedAI: 1,
                    proactiveAIGenerated: 0,
                    isAIFeature: 1,
                    is5xxError: is5xxError
                });
                // Mark the events corresponding to the latest promptId as published
                // So that any events that arrive after the debounce timeout are ignored
                // This is because having a unique `aiResult viewed` event is more important than having stale data (searchMode) in the event
                lastEventPublishedState[promptId] = 'PUBLISHED'; // Clear lastEventPublished entry to avoid memory leaks
                setTimeout(()=>{
                    delete lastEventPublishedState[promptId];
                }, DUPLICATE_CHECK_CLEAR_TIMEOUT);
            }, DEBOUNCE_TIMEOUT);
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireEventForAIResult: fireEventForAIResult
        };
    };
};
const $585b092fcba8b276$var$useDebouncedReadyEventForAIResult = $585b092fcba8b276$var$createUseDebouncedEventForAIResult();
const $585b092fcba8b276$export$b04216da143ef4b0 = ({ onBack: onBack, userPreferences: userPreferences, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [jqlTooComplex, setJqlTooComplex] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { onSearch: onSearch } = props;
    const onPromptSuccess = (0, $eJOHy.useCallback)((generatedJql)=>{
        onSearch && onSearch(generatedJql);
        setJqlTooComplex(false);
    }, [
        onSearch
    ]);
    const { onJourneyStart: onJourneyStart } = props;
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'aiInlinePrompt', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    const placeholders = (0, $hf0iW.usePlaceholders)();
    const userPreferencesData = (0, $j4oe4.useFragment)((0, $fiZ73.default), userPreferences);
    const { onEndAITour: onEndAITour } = (0, $83x9v.useAITourActions)();
    const [isTourActive] = (0, $gokBr.useIsActiveSpotlightCard)([
        (0, $6sTi7.cardKeys).GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL,
        (0, $6sTi7.cardKeys).JQL_BUILDER_NL_TO_JQL
    ]);
    const handleSearchModeChange = (searchMode, reason)=>{
        setJqlTooComplex(searchMode === (0, $56qWy.SEARCH_MODE_ADVANCED) && reason === 'QueryUnsupported');
    };
    const renderSpotlightCard = ({ onSetActiveCard: onSetActiveCard, onEndTour: onEndTour })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNOMn.default), {
            cardKey: (0, $6sTi7.cardKeys).GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL,
            actions: [
                {
                    onClick: ()=>{
                        onSetActiveCard((0, $6sTi7.cardKeys).GLOBAL_SCOPE_VIEW_SWITCHER);
                    },
                    text: formatMessage((0, $2JKeq.default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: formatMessage((0, $2JKeq.default).skip)
                }
            ],
            heading: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $2JKeq.default).globalTourHeadingIssueTerminologyRefreshM4 : (0, $2JKeq.default).globalTourHeading),
            target: "jql-builder-with-ai.natural-language-to-jql",
            targetRadius: 8,
            targetBgColor: "var(--ds-background-input, #FFFFFF)",
            testId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.spotlight",
            messageId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.spotlight-tour-card.jql-builder-with-ai.natural-language-to-jql.spotlight.1",
            messageType: "transactional"
        }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $2JKeq.default).globalTourBodyIssueTerminologyRefreshM4 : (0, $2JKeq.default).globalTourBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNOMn.default), {
            cardKey: (0, $6sTi7.cardKeys).JQL_BUILDER_NL_TO_JQL,
            actions: [
                {
                    onClick: ()=>{
                        // End the tour in AI tour store
                        onEndAITour(); // End the tour in NIN changeboarding store
                        onEndTour();
                    },
                    text: formatMessage((0, $2JKeq.default).done)
                }
            ],
            heading: formatMessage((0, $2JKeq.default).tourHeading),
            target: "jql-builder-with-ai.natural-language-to-jql",
            targetRadius: 8,
            targetBgColor: "var(--ds-background-input, #FFFFFF)",
            testId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.spotlight",
            messageId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.spotlight-tour-card.jql-builder-with-ai.natural-language-to-jql.spotlight.2",
            messageType: "transactional"
        }, formatMessage((0, $2JKeq.default).tourBody)));
    (0, $eJOHy.useEffect)(()=>{
        setJqlTooComplex(false);
    }, [
        props.query
    ]);
    const { fireEventForAIResult: fireEventForAIResult } = $585b092fcba8b276$var$useDebouncedReadyEventForAIResult();
    const onNLEvent = (0, $eJOHy.useCallback)(({ promptId: promptId, nlResponseType: nlResponseType, is5xxError: is5xxError })=>{
        const jqlErrors = props.jqlMessages?.filter((message)=>message.type === 'error') || [];
        fireEventForAIResult({
            isSuccess: nlResponseType === 'success' && !jqlErrors.length,
            is5xxError: is5xxError,
            promptId: promptId,
            errorOrigin: // eslint-disable-next-line no-nested-ternary
            nlResponseType === 'error' ? 'NL Search Backend' : /* When the nlResponseType is success, it means the NL-to-JQL operation was successful
      However, when props.jqlMessages?.length is not 0, that means there was an error with the jql generated
      Hence it can be marked that the error is coming from NIN
       */ nlResponseType === 'success' && !!jqlErrors.length ? 'NIN' : 'N/A'
        });
    }, [
        fireEventForAIResult,
        props.jqlMessages
    ]);
    const jqlDebuggerStoreActions = (0, $bUnif.useJqlDebuggerStoreActions)(); /**
                                                                 * When the NaturalLanguageToJQLWrapper component unmounts, we want to reset the issue navigator search mode in JQL debugger
                                                                 * This component is mounted when the user is in Natural Language Mode
                                                                 * Currently we use the issueNavigatorSearchMode to enable/disable the JQL debugger proactive experience
                                                                 */ 
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if ((0, $epTsa.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions?.setIssueNavigatorSearchMode(undefined);
        };
    }, [
        jqlDebuggerStoreActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $437hw.default), {
        name: "jql-builder-with-ai.natural-language-to-jql",
        renderSpotlightCard: renderSpotlightCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6mUAz.default), {
        autoFocus: true,
        backButtonLabel: formatMessage((0, $2JKeq.default).backButtonLabel),
        onPromptSuccess: onPromptSuccess,
        onBack: onBack,
        onFocus: onJourneyStart ? onFocus : undefined,
        placeholder: isTourActive ? placeholders[0] : placeholders,
        onNLEvent: onNLEvent
    }, (generatedJql)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3SZaW.default), {
            ...props,
            userPreferences: userPreferencesData ?? null,
            generatedJql: generatedJql,
            onUpdateSearchMode: handleSearchModeChange,
            key: generatedJql
        }), jqlTooComplex && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bZ6RS.AlertMessage), {
            appearance: "info",
            testId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.jql-too-complex"
        }, formatMessage((0, $2JKeq.default).jqlTooComplex)))));
};

});
parcelRegister("fiZ73", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad657a7bbae291e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0688f7e431ddc63994db6a71faf7973>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ad657a7bbae291e2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "naturalLanguageToJqlWrapper_jqlBuilderWithAi",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilderEmbedded_jqlBuilderWithAi"
        }
    ],
    "type": "JiraUserPreferences"
};
$ad657a7bbae291e2$var$node.hash = "7bd16e68fc1878ae6b8f7e375bf28056";
var $ad657a7bbae291e2$export$2e2bcd8739ae039 = $ad657a7bbae291e2$var$node;

});

parcelRegister("6sTi7", function(module, exports) {

$parcel$export(module.exports, "cardKeys", () => $fe025dbff69a9482$export$79399c5778983d77);
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $fe025dbff69a9482$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("gokBr", function(module, exports) {

$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $afabf68402b50fe5$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $afabf68402b50fe5$export$d0297e733168e478);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

const $afabf68402b50fe5$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $afabf68402b50fe5$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $afabf68402b50fe5$var$Store = (0, $GtRbT.createStore)({
    initialState: $afabf68402b50fe5$var$initialState,
    actions: $afabf68402b50fe5$var$actions
});
const $afabf68402b50fe5$export$ac706a6842f43035 = (0, $iJq0l.createHook)($afabf68402b50fe5$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $afabf68402b50fe5$export$d0297e733168e478 = (0, $iJq0l.createActionsHook)($afabf68402b50fe5$var$Store);

});

parcelRegister("fNOMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b9bd65aec627275$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5b9bd65aec627275$var$SpotlightTourCardAsync = (0, $gzcjr.lazyForPaint)(()=>(parcelRequire("mnff5")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $5b9bd65aec627275$var$SpotlightTourCard = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b9bd65aec627275$var$SpotlightTourCardAsync, props)));
var $5b9bd65aec627275$export$2e2bcd8739ae039 = $5b9bd65aec627275$var$SpotlightTourCard;

});
parcelRegister("mnff5", function(module, exports) {

let $04341621556f1065$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $04341621556f1065$var$load("3nRwT").then(()=>parcelRequire('966Nd'));

});


parcelRegister("437hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7042db8e62785d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hZUwi = parcelRequire("hZUwi");
var $gbiVe = parcelRequire("gbiVe");
var $REcGP = parcelRequire("REcGP");

var $gokBr = parcelRequire("gokBr");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $cb7042db8e62785d$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $gokBr.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hZUwi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gbiVe.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $REcGP.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $cb7042db8e62785d$export$2e2bcd8739ae039 = $cb7042db8e62785d$var$SpotlightTourTarget;

});

const $8985fbecf34f047a$export$b8b9d90f9e5bd72b = 'jiraNaturalLanguageToJQL';
const $8985fbecf34f047a$export$d57b6b390e78d90f = 'gravity-ai';
const $8985fbecf34f047a$export$819aee5dd7b4244d = 'NL Search in Jira';

parcelRegister("6mUAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20b5ebed4d6c64e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6BipE = parcelRequire("6BipE");

var $giO9u = parcelRequire("giO9u");
function $c20b5ebed4d6c64e$export$2e2bcd8739ae039({ children: children, ...props }) {
    const onPrompt = (0, $giO9u.useNaturalLanguageToJql)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BipE.default), {
        ...props,
        onPrompt: onPrompt
    }, children);
}

});
parcelRegister("6BipE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dd1f61d94cfbd50$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9skjA = parcelRequire("9skjA");

var $4wc0I = parcelRequire("4wc0I");

var $iyRJ6 = parcelRequire("iyRJ6");

var $9FdI3 = parcelRequire("9FdI3");

function $8dd1f61d94cfbd50$var$AIInlinePrompt({ autoFocus: autoFocus, backButtonLabel: backButtonLabel, children: children, onBack: onBack, onFocus: onFocus, placeholder: placeholder, ...props }) {
    const [isLoading] = (0, $4wc0I.usePromptIsLoading)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        shouldFitContainer: true,
        spacing: "none",
        isLoading: isLoading,
        testId: "atlassian-intelligence.ui.ai-inline-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9FdI3.SearchField), {
        autoFocus: autoFocus,
        backButtonLabel: backButtonLabel,
        onBack: onBack,
        onFocus: onFocus,
        placeholder: placeholder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iyRJ6.PromptResponse), props, children));
}
function $8dd1f61d94cfbd50$var$AIInlinePromptWithContainer({ children: children, onPrompt: onPrompt, onPromptSuccess: onPromptSuccess, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4wc0I.PromptContainer), {
        onPrompt: onPrompt,
        onPromptSuccess: onPromptSuccess
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8dd1f61d94cfbd50$var$AIInlinePrompt, props, children));
}
var $8dd1f61d94cfbd50$export$2e2bcd8739ae039 = $8dd1f61d94cfbd50$var$AIInlinePromptWithContainer;

});
parcelRegister("4wc0I", function(module, exports) {

$parcel$export(module.exports, "PromptContainer", () => $cfea445c515e3746$export$f996e810bab47dad);
$parcel$export(module.exports, "usePromptActions", () => $cfea445c515e3746$export$b69cbf7f2fd4c7ba);
$parcel$export(module.exports, "useResponseFeedbackContext", () => $cfea445c515e3746$export$7737761958d6bb6c);
$parcel$export(module.exports, "usePromptResponse", () => $cfea445c515e3746$export$775e0e2ce513f8e7);
$parcel$export(module.exports, "usePrompt", () => $cfea445c515e3746$export$fc7731b33eb53a93);
$parcel$export(module.exports, "useSubmittedPrompt", () => $cfea445c515e3746$export$80b178470b13c8ae);
$parcel$export(module.exports, "usePromptIsLoading", () => $cfea445c515e3746$export$912d74d2ad112159);
$parcel$export(module.exports, "usePromptIsSubmitted", () => $cfea445c515e3746$export$20b39be031988e7a);
$parcel$export(module.exports, "usePromptId", () => $cfea445c515e3746$export$19f80ca0c5d6d88d);
$parcel$export(module.exports, "useScopedId", () => $cfea445c515e3746$export$1f910160e5ac22b);

var $aXKmr = parcelRequire("aXKmr");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8eQHk = parcelRequire("8eQHk");
const $cfea445c515e3746$var$initialState = {
    idPrefix: '',
    isLoading: false,
    isSubmitted: false,
    prompt: '',
    response: undefined,
    submittedPrompt: '',
    cancellable: undefined,
    promptId: ''
};
const $cfea445c515e3746$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $cfea445c515e3746$var$initialState,
    actions: $8eQHk.actions
});
const $cfea445c515e3746$export$f996e810bab47dad = (0, $6E16M.createContainer)($cfea445c515e3746$export$390f32400eaf98c9, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                idPrefix: (0, $aXKmr.v4)()
            });
        }
});
const $cfea445c515e3746$export$b69cbf7f2fd4c7ba = (0, $iJq0l.createActionsHook)($cfea445c515e3746$export$390f32400eaf98c9);
const $cfea445c515e3746$export$7737761958d6bb6c = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.response?.additionalFeedbackContext
});
const $cfea445c515e3746$var$usePromptResponseGeneric = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.response
});
function $cfea445c515e3746$export$775e0e2ce513f8e7() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $cfea445c515e3746$var$usePromptResponseGeneric();
}
const $cfea445c515e3746$export$fc7731b33eb53a93 = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.prompt
});
const $cfea445c515e3746$export$80b178470b13c8ae = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.submittedPrompt
});
const $cfea445c515e3746$export$912d74d2ad112159 = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.isLoading
});
const $cfea445c515e3746$export$20b39be031988e7a = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.isSubmitted
});
const $cfea445c515e3746$export$19f80ca0c5d6d88d = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.promptId
});
const $cfea445c515e3746$var$getScopedId = (state, idSuffix)=>`${state.idPrefix}_${idSuffix}`;
const $cfea445c515e3746$export$1f910160e5ac22b = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: $cfea445c515e3746$var$getScopedId
});

});
parcelRegister("8eQHk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $54f0760b63195fab$export$e324594224ef24da);

var $aXKmr = parcelRequire("aXKmr");
function $54f0760b63195fab$var$onHandlePrompt(nextPrompt, promptId) {
    return async (_, { onPrompt: onPrompt })=>{
        try {
            return await onPrompt(nextPrompt, promptId);
        } catch (e) {
            // Ignore errors as this is expected to be handled in the consumer
            return undefined;
        }
    };
}
const $54f0760b63195fab$export$e324594224ef24da = {
    onUpdate (prompt) {
        return ({ setState: setState })=>{
            // Update input prompt
            setState({
                prompt: prompt
            });
        };
    },
    onSubmit (nextPrompt) {
        const nextPromptId = (0, $aXKmr.v4)();
        return async ({ getState: getState, setState: setState, dispatch: dispatch }, { onPromptSuccess: onPromptSuccess })=>{
            // Set loading state
            setState({
                isLoading: true,
                isSubmitted: true,
                submittedPrompt: nextPrompt,
                promptId: nextPromptId
            });
            const { cancellable: cancellable } = getState();
            // Cancel any in-flight requests
            if (cancellable) cancellable();
            const cancellablePromise = new Promise((resolve, reject)=>{
                // Allow this request to be cancelled
                setState({
                    cancellable: reject
                });
            });
            try {
                const nextResponse = await Promise.race([
                    dispatch($54f0760b63195fab$var$onHandlePrompt(nextPrompt, nextPromptId)),
                    cancellablePromise
                ]);
                nextResponse?.type === 'success' && onPromptSuccess && onPromptSuccess(nextResponse.payload);
                // Set successful response into state
                setState({
                    isLoading: false,
                    response: nextResponse
                });
            } catch (e) {
            // Pending promise was cancelled
            }
        };
    }
};

});


parcelRegister("iyRJ6", function(module, exports) {

$parcel$export(module.exports, "PromptResponse", () => $247e2bb5d1711f30$export$b0c2912e422f4828);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f1Zdy = parcelRequire("f1Zdy");

var $yaMFh = parcelRequire("yaMFh");

var $4wc0I = parcelRequire("4wc0I");
function $247e2bb5d1711f30$export$b0c2912e422f4828({ children: children, onNLEvent: onNLEvent }) {
    const [response] = (0, $4wc0I.usePromptResponse)();
    const [isLoading] = (0, $4wc0I.usePromptIsLoading)();
    const [searchFieldId] = (0, $4wc0I.useScopedId)('ai-search-field');
    const [promptId] = (0, $4wc0I.usePromptId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (response?.type && response?.is5xxError !== undefined && promptId) onNLEvent({
            promptId: promptId,
            nlResponseType: response.type,
            is5xxError: response.is5xxError
        });
    }, [
        createAnalyticsEvent,
        promptId,
        response?.type,
        response?.is5xxError,
        onNLEvent
    ]);
    if (response === undefined) return null;
    switch(response.type){
        case 'success':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($247e2bb5d1711f30$var$ResponseContainer, null, children(response.payload, promptId));
        case 'warning':
            // Hide warning message while request is in-flight
            return isLoading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($247e2bb5d1711f30$var$ResponseContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yaMFh.HelperMessage), {
                appearance: "warning",
                describedBy: searchFieldId,
                testId: "atlassian-intelligence.ui.prompt-response.warning"
            }, response.payload));
        case 'error':
            // Hide error message while request is in-flight
            return isLoading ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($247e2bb5d1711f30$var$ResponseContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $yaMFh.HelperMessage), {
                appearance: "error",
                describedBy: searchFieldId,
                testId: "atlassian-intelligence.ui.prompt-response.error"
            }, response.payload));
        default:
            return null;
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $247e2bb5d1711f30$var$ResponseContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pku2gc _2hwxutpp _otyru2gc _18u0utpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("yaMFh", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $33ed916bdba580af$export$8fbe3c7d0ed2c683);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Svlt9 = parcelRequire("Svlt9");

var $kibFU = parcelRequire("kibFU");
const $33ed916bdba580af$export$8fbe3c7d0ed2c683 = ({ appearance: appearance, children: children, describedBy: describedBy, testId: testId })=>{
    const Icon = appearance === 'error' ? (0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))) : (0, (/*@__PURE__*/$parcel$interopDefault($kibFU)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33ed916bdba580af$var$Message, {
        appearance: appearance,
        role: "alert",
        "aria-describedby": describedBy,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33ed916bdba580af$var$MessageContent, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33ed916bdba580af$var$Message = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1txw _19pku2gc _vwz41tcg",
            __cmplp.appearance === 'error' ? "_syaz1tmw" : "_syazwx40",
            __cmplp.className
        ])
    });
});
const $33ed916bdba580af$var$MessageContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9FdI3", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $acc768315631273d$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eKx5I = parcelRequire("eKx5I");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $lRq8t = parcelRequire("lRq8t");


var $4R2jN = parcelRequire("4R2jN");

var $4wc0I = parcelRequire("4wc0I");

var $3LCMI = parcelRequire("3LCMI");

var $9JniZ = parcelRequire("9JniZ");

var $5XgKw = parcelRequire("5XgKw");
const $acc768315631273d$var$buttonClicked = {
    action: 'clicked',
    actionSubject: 'button'
};
const $acc768315631273d$export$b94867ecbd698f21 = ({ autoFocus: autoFocus, backButtonLabel: backButtonLabel, placeholder: placeholder, onBack: onBack, onFocus: onFocus })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [searchFieldId] = (0, $4wc0I.useScopedId)('ai-search-field');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [prompt] = (0, $4wc0I.usePrompt)();
    const [isLoading] = (0, $4wc0I.usePromptIsLoading)();
    const [isSubmitted] = (0, $4wc0I.usePromptIsSubmitted)();
    const { onUpdate: onUpdate, onSubmit: onSubmit } = (0, $4wc0I.usePromptActions)();
    const isEmpty = prompt.trim().length === 0;
    const handleSubmit = (0, $eJOHy.useCallback)((e, analyticsEvent, ...attributes)=>{
        if (isEmpty) return;
        onSubmit(prompt);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'aiInlinePromptSubmit', ...attributes);
    }, [
        isEmpty,
        onSubmit,
        prompt
    ]);
    const handleBack = (0, $eJOHy.useCallback)((e, analyticsEvent, ...attributes)=>{
        if (!onBack) return;
        onBack();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'aiInlinePromptBack', ...attributes);
    }, [
        onBack
    ]);
    const handleEnter = (0, $eJOHy.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent($acc768315631273d$var$buttonClicked);
        handleSubmit(e, analyticsEvent, {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        handleSubmit
    ]);
    const handleEscape = (0, $eJOHy.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent($acc768315631273d$var$buttonClicked);
        handleBack(e, analyticsEvent, {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        handleBack
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Escape') handleEscape(event);
        if (event.key === 'Enter') handleEnter(event);
    }, [
        handleEnter,
        handleEscape
    ]);
    const handleChange = (0, $eJOHy.useCallback)((event)=>{
        const nextValue = event.currentTarget.value;
        onUpdate(nextValue);
    }, [
        onUpdate
    ]);
    const placeholderToRender = (0, $3LCMI.useAnimatedPlaceholder)(placeholder, prompt.length === 0);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($acc768315631273d$var$TextfieldContainer, {
        isSubmitted: isSubmitted
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eKx5I.default), {
        id: searchFieldId,
        autoFocus: autoFocus,
        defaultValue: prompt,
        onKeyDown: handleKeyDown,
        onChange: handleChange,
        onFocus: onFocus,
        placeholder: placeholderToRender,
        appearance: "none",
        isCompact: false,
        maxLength: 1200,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4R2jN.AiIcon), {
            label: (0, $8e9abaad3d9cfcae$export$1a33ff8e70228fd6),
            size: "small"
        }),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JniZ.ShortcutButtons), {
            backButtonLabel: backButtonLabel,
            isLoading: isLoading,
            isSubmitDisabled: isEmpty,
            onSubmit: handleSubmit,
            onBack: onBack ? handleBack : undefined
        }),
        "aria-label": formatMessage((0, $5XgKw.messages).enterQueryAriaLabel)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acc768315631273d$var$TextfieldContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSubmitted: isSubmitted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_195gutpp _1mouu2gc _15h815ya _mtcs15ya _xxgkidpf _yg9midpf _k1ufidpf _zzkzidpf _1r9i1ejb _1a0d1ejb _j1xiidpf _1gtmu2gc",
            __cmplp.isSubmitted && "_1f6didpf _1hzeidpf _9de9idpf _1u7cidpf _1r3midpf _j7rp15vq _1ltf15vq _15dgt94y _7m33t94y _1qjqstnw _1weu7mnp _123y1q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3LCMI", function(module, exports) {

$parcel$export(module.exports, "useAnimatedPlaceholder", () => $bd9012b44c9d8269$export$9226afce7feb8c4b);

var $eJOHy = parcelRequire("eJOHy");

const $bd9012b44c9d8269$export$9226afce7feb8c4b = (placeholder, isVisible)=>{
    const defaultPlaceholder = Array.isArray(placeholder) ? placeholder[0] : placeholder;
    const [state, setState] = (0, $eJOHy.useState)({
        placeholderIndex: 0,
        ticksInCurrentPlaceholder: 0,
        visiblePlaceholder: defaultPlaceholder
    });
    const interval = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        // If any of the hook dependencies (placeholder visibility or project key) changes:
        // - Clear any previously created intervals
        // - Reset state back to initial
        clearInterval(interval.current);
        setState({
            placeholderIndex: 0,
            ticksInCurrentPlaceholder: 0,
            visiblePlaceholder: defaultPlaceholder
        });
        // Only animate when a series of placeholders are provided
        if (isVisible && Array.isArray(placeholder) && placeholder.length > 1) interval.current = setInterval(()=>{
            setState(({ placeholderIndex: placeholderIndex, ticksInCurrentPlaceholder: ticksInCurrentPlaceholder, visiblePlaceholder: visiblePlaceholder })=>{
                const targetPlaceholder = placeholder[placeholderIndex];
                if (visiblePlaceholder !== targetPlaceholder) return {
                    placeholderIndex: placeholderIndex,
                    ticksInCurrentPlaceholder: 0,
                    visiblePlaceholder: targetPlaceholder.slice(0, visiblePlaceholder.length + 1)
                };
                if (ticksInCurrentPlaceholder === (0, $1904818d7b923e2c$export$411bcf646d391199)) return {
                    placeholderIndex: placeholderIndex < placeholder.length - 1 ? placeholderIndex + 1 : 0,
                    ticksInCurrentPlaceholder: 0,
                    visiblePlaceholder: ''
                };
                return {
                    placeholderIndex: placeholderIndex,
                    ticksInCurrentPlaceholder: ticksInCurrentPlaceholder + 1,
                    visiblePlaceholder: visiblePlaceholder
                };
            });
        }, (0, $1904818d7b923e2c$export$47272beff44c3250));
        return ()=>clearInterval(interval.current);
    }, [
        defaultPlaceholder,
        isVisible,
        placeholder
    ]);
    return state.visiblePlaceholder;
};

});
/**
 * Duration of each placeholder animation tick (i.e. time it takes to type 1 character)
 */ const $1904818d7b923e2c$export$47272beff44c3250 = 60;
const $1904818d7b923e2c$export$411bcf646d391199 = 30;


parcelRegister("9JniZ", function(module, exports) {

$parcel$export(module.exports, "ShortcutButtons", () => $9d3ba0925d16bd36$export$1580d8f0e94a7ac7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $g17XP = parcelRequire("g17XP");

var $bxHeV = parcelRequire("bxHeV");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $lRq8t = parcelRequire("lRq8t");

var $RPKEk = parcelRequire("RPKEk");
const $9d3ba0925d16bd36$var$goButtonSelectorName = 'atlassian-intelligence.ui.search-field.shortcut-buttons.go-button';
const $9d3ba0925d16bd36$export$373f05fe8d26f4ab = `[data-component-selector="${$9d3ba0925d16bd36$var$goButtonSelectorName}"]`;
const $9d3ba0925d16bd36$var$goButtonContentWrapperStyles = (0, $5Wv5g.xcss)({
    display: 'inline-flex',
    minHeight: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    gap: 'space.050'
});
const $9d3ba0925d16bd36$export$1580d8f0e94a7ac7 = ({ backButtonLabel: backButtonLabel, isLoading: isLoading, isSubmitDisabled: isSubmitDisabled, onSubmit: onSubmit, onBack: onBack })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9d3ba0925d16bd36$var$GoButton, {
        spacing: "none",
        appearance: "primary",
        isDisabled: isSubmitDisabled,
        onClick: onSubmit,
        testId: "atlassian-intelligence.ui.search-field.shortcut-buttons.go-button",
        "data-component-selector": $9d3ba0925d16bd36$var$goButtonSelectorName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        as: "span",
        paddingInline: "space.300",
        xcss: $9d3ba0925d16bd36$var$goButtonContentWrapperStyles
    }, formatMessage((0, $RPKEk.default).go), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        size: "small",
        weight: "bold",
        color: "inherit"
    }, "\u23CE"))), onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9d3ba0925d16bd36$var$BackButton, {
        appearance: "subtle",
        spacing: "none",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g17XP))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: backButtonLabel ?? formatMessage((0, $RPKEk.default).back)
        }),
        onClick: onBack,
        testId: "atlassian-intelligence.ui.search-field.shortcut-buttons.back-button"
    }));
};
const $9d3ba0925d16bd36$var$buttonStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $9d3ba0925d16bd36$var$GoButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $dKpTa.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1wpz1h6o _4t3i1wug _18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $9d3ba0925d16bd36$var$BackButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $dKpTa.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1wpz1h6o _4t3i1wug _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("RPKEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f412f2564ec6b5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $18f412f2564ec6b5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    go: {
        "id": "atlassian-intelligence.search-field.shortcut-buttons.go",
        "defaultMessage": "Go"
    },
    back: {
        "id": "atlassian-intelligence.search-field.shortcut-buttons.back",
        "defaultMessage": "Back - Exit Atlassian Intelligence"
    }
});

});


parcelRegister("5XgKw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4e311d4ab2080460$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4e311d4ab2080460$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    enterQueryAriaLabel: {
        "id": "atlassian-intelligence.search-field.enter-query-aria-label",
        "defaultMessage": "Enter your natural language query, for example:"
    }
});

});



parcelRegister("giO9u", function(module, exports) {

$parcel$export(module.exports, "useNaturalLanguageToJql", () => $96621847e1dfd73d$export$91f40a372bbf523a);

var $fWDzG = parcelRequire("fWDzG");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $epTsa = parcelRequire("epTsa");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $2aY2d = parcelRequire("2aY2d");

var $kEUB1 = parcelRequire("kEUB1");


var $gxVdM = parcelRequire("gxVdM");

var $apzdY = parcelRequire("apzdY");

var $9lKGE = parcelRequire("9lKGE");
const $96621847e1dfd73d$var$RATE_LIMIT_SUPPORT_LINK = 'https://support.atlassian.com/organization-administration/docs/usage-limits-in-atlassian-intelligence/';
const $96621847e1dfd73d$var$SERVER_ERROR_SUPPORT_LINK = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $96621847e1dfd73d$var$fireNLErrorAnalytics = (errorType, error)=>{
    (0, $gYnSx.default)({
        attributes: {
            errorType: errorType
        },
        meta: {
            id: 'useNaturalLanguageToJqlQuery',
            packageName: (0, $8985fbecf34f047a$export$b8b9d90f9e5bd72b),
            teamName: (0, $8985fbecf34f047a$export$d57b6b390e78d90f)
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
const $96621847e1dfd73d$export$91f40a372bbf523a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const projectContext = (0, $2aY2d.useProjectContext)();
    const projectKey = (0, $7jTnu.fg)('jira_nl2jql_forward_proejct_context') ? projectContext.data?.projectKey || null : null;
    return (0, $eJOHy.useCallback)(async (prompt, promptId)=>{
        /**
     * The attributes populated for centralised AI MAU calculation is mentioned here:
     * https://hello.atlassian.net/wiki/spaces/AAI/pages/3115805726/Single+Instrumentation+for+AI+MAU
     * Note: the 1 in userGeneratedAI represents a 'boolean' sort of value
     */ (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', {
            aiFeatureName: (0, $8985fbecf34f047a$export$819aee5dd7b4244d),
            userGeneratedAI: 1,
            proactiveAIGenerated: 0,
            singleInstrumentationID: promptId,
            isAIFeature: 1
        });
        return (0, $j4oe4.fetchQuery)(environment, (0, $fWDzG.default), {
            cloudId: cloudId,
            naturalLanguageInput: prompt,
            iteration: 'ITERATION_2',
            project: projectKey
        }).toPromise().then((data)=>{
            const invalidJqlErrorNonFinalIssueTerminologyRefreshM4Galaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $9lKGE.default).invalidJqlErrorNonFinalIssueTerminologyRefreshM4Galaxia : (0, $9lKGE.default).invalidJqlErrorNonFinalIssueTerminologyRefreshM4;
            if (data) {
                const { jira: { naturalLanguageToJql: { generatedJQL: generatedJQL, generatedJQLError: generatedJQLError } } } = data;
                if (generatedJQL != null) {
                    const additionalFeedbackContext = [
                        {
                            id: 'JQL Response',
                            value: generatedJQL
                        }
                    ];
                    return {
                        type: 'success',
                        is5xxError: false,
                        payload: generatedJQL,
                        additionalFeedbackContext: additionalFeedbackContext
                    };
                }
                // If we have no JQL or relevant errors then show a warning message
                if (generatedJQLError == null) {
                    // TODO - revise error type: JNLIS-488
                    $96621847e1dfd73d$var$fireNLErrorAnalytics('failed_response');
                    return {
                        type: 'warning',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gxVdM.MessageWithFeedbackButton), {
                            message: formatMessage((0, $9lKGE.default).noJqlReturned),
                            linkText: formatMessage((0, $9lKGE.default).helpUsImproveNonFinal)
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraGeneratedJqlInvalidError') {
                    // TODO - revise error type: JNLIS-488
                    $96621847e1dfd73d$var$fireNLErrorAnalytics('server_error');
                    return {
                        type: 'error',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gxVdM.MessageWithFeedbackButton), {
                            message: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? invalidJqlErrorNonFinalIssueTerminologyRefreshM4Galaxia : (0, $9lKGE.default).invalidJqlErrorNonFinal),
                            linkText: formatMessage((0, $9lKGE.default).helpUsImproveNonFinal)
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraUnsupportedLanguageError') {
                    // TODO - revise error type: JNLIS-488
                    $96621847e1dfd73d$var$fireNLErrorAnalytics('server_error');
                    return {
                        type: 'error',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gxVdM.MessageWithFeedbackButton), {
                            message: formatMessage((0, $9lKGE.default).unsupportedLanguageErrorNonFinal),
                            linkText: formatMessage((0, $9lKGE.default).helpUsImproveNonFinal)
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraUsageLimitExceededError') {
                    $96621847e1dfd73d$var$fireNLErrorAnalytics('rate_limit_error');
                    return {
                        type: 'error',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apzdY.MessageWithSupportLink), {
                            message: (0, $9lKGE.default).errorRateLimit,
                            href: $96621847e1dfd73d$var$RATE_LIMIT_SUPPORT_LINK
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraUIExposedError' && generatedJQLError?.message != null) {
                    $96621847e1dfd73d$var$fireNLErrorAnalytics('server_error');
                    return {
                        type: 'error',
                        is5xxError: false,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gxVdM.MessageWithFeedbackButton), {
                            message: generatedJQLError.message,
                            linkText: formatMessage((0, $9lKGE.default).helpUsImproveNonFinal)
                        })
                    };
                }
                if (generatedJQLError?.__typename === 'JiraServerError') {
                    $96621847e1dfd73d$var$fireNLErrorAnalytics('server_error');
                    return {
                        type: 'error',
                        is5xxError: true,
                        payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apzdY.MessageWithSupportLink), {
                            message: (0, $9lKGE.default).serverError,
                            href: $96621847e1dfd73d$var$SERVER_ERROR_SUPPORT_LINK
                        })
                    };
                }
            }
            // TODO - revise error type: JNLIS-488
            $96621847e1dfd73d$var$fireNLErrorAnalytics('server_error');
            return {
                type: 'error',
                is5xxError: true,
                payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apzdY.MessageWithSupportLink), {
                    message: (0, $9lKGE.default).serverError,
                    href: $96621847e1dfd73d$var$SERVER_ERROR_SUPPORT_LINK
                })
            };
        }).catch((error)=>{
            if (error instanceof (0, $1uIew.default) && error.statusCode === 429) {
                $96621847e1dfd73d$var$fireNLErrorAnalytics('rate_limit_error', error);
                return {
                    type: 'error',
                    is5xxError: false,
                    payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apzdY.MessageWithSupportLink), {
                        message: (0, $9lKGE.default).errorRateLimit,
                        href: $96621847e1dfd73d$var$RATE_LIMIT_SUPPORT_LINK
                    })
                };
            }
            // TODO - revise error type: JNLIS-488
            $96621847e1dfd73d$var$fireNLErrorAnalytics('graphql_error', error);
            return {
                type: 'error',
                is5xxError: true,
                payload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apzdY.MessageWithSupportLink), {
                    message: (0, $9lKGE.default).serverError,
                    href: $96621847e1dfd73d$var$SERVER_ERROR_SUPPORT_LINK
                })
            };
        });
    }, [
        cloudId,
        createAnalyticsEvent,
        environment,
        formatMessage,
        projectKey
    ]);
};

});
parcelRegister("fWDzG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b8b1d5aa743e68f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dbc11c79a2fa7e03580e6f6e88e95914>>
 * @relayHash 42c1f0f238e4ad92d4e813a2f1345025
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b
const $3b8b1d5aa743e68f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "iteration"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "naturalLanguageInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "project"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "iteration",
                    "variableName": "iteration"
                },
                {
                    "kind": "Variable",
                    "name": "naturalLanguageInput",
                    "variableName": "naturalLanguageInput"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "project"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "searchContext"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "generatedJQL"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = [
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useNaturalLanguageToJqlQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraJQLFromNaturalLanguage",
                                    "kind": "LinkedField",
                                    "name": "naturalLanguageToJql",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "generatedJQLError",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "JiraUIExposedError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraUsageLimitExceededError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraGeneratedJqlInvalidError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraUnsupportedLanguageError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v8 /*: any*/ ,
                                                    "type": "JiraServerError"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.naturalLanguageToJql"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useNaturalLanguageToJqlQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraJQLFromNaturalLanguage",
                            "kind": "LinkedField",
                            "name": "naturalLanguageToJql",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "generatedJQLError",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ 
                                            ],
                                            "type": "JiraUIExposedError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b",
            "metadata": {},
            "name": "useNaturalLanguageToJqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3b8b1d5aa743e68f$var$node.hash = "fc551bf7230ae7a4cf420565001ddefc";
var $3b8b1d5aa743e68f$export$2e2bcd8739ae039 = $3b8b1d5aa743e68f$var$node;

});

parcelRegister("gxVdM", function(module, exports) {

$parcel$export(module.exports, "MessageWithFeedbackButton", () => $0f4e9e391b21e5aa$export$e626981050b21e27);

var $eJOHy = parcelRequire("eJOHy");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $iffFW = parcelRequire("iffFW");
function $0f4e9e391b21e5aa$export$e626981050b21e27(props) {
    const { message: message, linkText: linkText } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $0f4e9e391b21e5aa$var$messageWrapperStyles,
        as: "span"
    }, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $0f4e9e391b21e5aa$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iffFW.ReportToAtlassianButton), null, linkText)));
}
const $0f4e9e391b21e5aa$var$buttonWrapperStyles = (0, $5Wv5g.xcss)({
    display: 'inline-block'
});
const $0f4e9e391b21e5aa$var$messageWrapperStyles = (0, $5Wv5g.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("iffFW", function(module, exports) {

$parcel$export(module.exports, "ReportToAtlassianButton", () => $d329adb6ad144184$export$ee22a573c1320be1);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $v7053 = parcelRequire("v7053");

var $4wc0I = parcelRequire("4wc0I");

var $cp5xE = parcelRequire("cp5xE");
const $d329adb6ad144184$export$ee22a573c1320be1 = ({ children: children })=>{
    const hasOpened = (0, $eJOHy.useRef)(false);
    const [isSubmitted, setSubmitted] = (0, $eJOHy.useState)(false);
    const [promptId] = (0, $4wc0I.usePromptId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        // Only emit analytics event first time popup is opened
        if (!hasOpened.current) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiFeedback submitted', {
            aiFeatureName: 'NL Search in Jira',
            singleInstrumentationID: promptId,
            proactiveAIGenerated: 0,
            userGeneratedAI: 1,
            isAIFeature: 1,
            aiFeedbackResult: 'down'
        });
        hasOpened.current = true;
    }, [
        createAnalyticsEvent,
        promptId
    ]);
    const onSubmit = (0, $eJOHy.useCallback)(()=>setSubmitted(true), []);
    return isSubmitted ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $v7053.FeedbackButton), {
        appearance: "link",
        isErrorReport: true,
        isDisabled: isSubmitted,
        isPositive: false,
        onClick: onClick,
        onSubmit: onSubmit,
        offset: [
            8,
            16
        ],
        placement: "bottom-end",
        spacing: "none",
        label: typeof children === 'string' ? children : formatMessage((0, $cp5xE.default).reportToAtlassianDefault)
    }, children);
};

});
parcelRegister("v7053", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $5c0a89989c060b91$export$116fedbe5e2e2bd8);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $9JB3T = parcelRequire("9JB3T");

var $cNe2t = parcelRequire("cNe2t");

var $4wc0I = parcelRequire("4wc0I");

var $4HYYg = parcelRequire("4HYYg");

var $71UWI = parcelRequire("71UWI");
const $5c0a89989c060b91$export$116fedbe5e2e2bd8 = ({ appearance: appearance, children: children, iconBefore: iconBefore, isErrorReport: isErrorReport, isDisabled: isDisabled, isPositive: isPositive, isSelected: isSelected, label: label, onClick: onClick, onSubmit: onSubmit, offset: offset, placement: placement, spacing: spacing, testId: testId, tooltipContent: tooltipContent })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [submittedPrompt] = (0, $4wc0I.useSubmittedPrompt)();
    const [feedbackContext] = (0, $4wc0I.useResponseFeedbackContext)();
    const { onSubmitFeedback: onSubmitFeedback } = (0, $4HYYg.useFeedbackService)(submittedPrompt, feedbackContext);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        // Prevent opening of the popup if the click event has been explicity handled by the parent
        const handled = onClick();
        if (handled) return;
        setIsOpen(true);
    }, [
        onClick
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)(async (data, isPositiveFeedback)=>{
        await onSubmitFeedback(data, isPositiveFeedback);
        onSubmit && onSubmit();
    }, [
        onSubmit,
        onSubmitFeedback
    ]);
    const handleClose = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: placement,
        offset: offset,
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $71UWI.FeedbackPopupContent), {
                isErrorReport: isErrorReport,
                isPositive: isPositive,
                onClose: handleClose,
                onSubmit: handleSubmit,
                setInitialFocusRef: setInitialFocusRef
            }),
        messageId: "atlassian-intelligence.common.ui.feedback-button.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
                content: tooltipContent ?? null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
                ...triggerProps,
                "aria-label": label,
                appearance: appearance,
                spacing: spacing,
                iconBefore: iconBefore,
                onClick: handleClick,
                isSelected: isSelected,
                isDisabled: isDisabled,
                testId: testId
            }, children))
    });
};

});
parcelRegister("4HYYg", function(module, exports) {

$parcel$export(module.exports, "useFeedbackService", () => $9c1f040232c6c384$export$fdeb51de8e2ac66d);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $kkHo2 = parcelRequire("kkHo2");

var $c9f6v = parcelRequire("c9f6v");

var $k6bid = parcelRequire("k6bid");

var $5Ovjr = parcelRequire("5Ovjr");
var $9c1f040232c6c384$require$Buffer = $5Ovjr.Buffer;
const $9c1f040232c6c384$var$FEEDBACK_ENDPOINT = '/gateway/api/feedback-collector-api/feedback';
const $9c1f040232c6c384$var$REQUEST_TYPE = '594';
const $9c1f040232c6c384$var$EMBED_KEY = 'a64ab7a8-2ce8-4942-884d-0f3090ef971e';
const $9c1f040232c6c384$var$MAX_SUMMARY_LENGTH = 100;
// The custom fields for consent are defined in this file: src/packages/platform/ui/help-panel/src/services/feedback/index.tsx
// HOWEVER, they are not exported and as this feedback collector is expected to be a temporary solution the change hasn't been
// made to export them.
const $9c1f040232c6c384$var$CONTACT_FIELD_ID = 'customfield_10043';
const $9c1f040232c6c384$var$CONTACT_TRUE_VALUE = '10109';
const $9c1f040232c6c384$var$CONTACT_FALSE_VALUE = '10111';
const $9c1f040232c6c384$var$RESEARCH_FIELD_ID = 'customfield_10044';
const $9c1f040232c6c384$var$RESEARCH_TRUE_VALUE = '10110';
const $9c1f040232c6c384$var$RESEARCH_FALSE_VALUE = '10112';
const $9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG_WITHOUT_APPIFY = {
    id: (0, $hrodw.toFlagId)('atlassian-intelligence.ui.prompt-response.feedback.submitted'),
    type: 'success',
    title: (0, $k6bid.default).feedbackSubmittedFlagTitle,
    description: (0, $k6bid.default).feedbackSubmittedFlagDescription,
    messageId: 'atlassian-intelligence.services.feedback.feedback-submitted-flag-without-appify.success.feedback-submitted-flag-with-project-term.success.feedback-submitted-flag.success.jira-modal',
    messageType: 'transactional'
};
const $9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG = {
    id: (0, $hrodw.toFlagId)('atlassian-intelligence.ui.prompt-response.feedback.submitted'),
    type: 'success',
    title: (0, $k6bid.default).feedbackSubmittedFlagTitle,
    description: (0, $k6bid.default).feedbackSubmittedFlagDescriptionAppify,
    messageId: 'atlassian-intelligence.services.feedback.feedback-submitted-flag.success.feedback-submitted-flagm.success.feedback-submitted-flag-without-project-term.success.feedback-submitted-flag.success.jira-modal',
    messageType: 'transactional'
};
const $9c1f040232c6c384$var$normalizeTextForSummary = (feedbackText)=>{
    if (!feedbackText.length) return '<no summary>';
    const singleLineFeedbackText = feedbackText.replace(/\n/g, ' ');
    return singleLineFeedbackText.length > $9c1f040232c6c384$var$MAX_SUMMARY_LENGTH ? `${singleLineFeedbackText.substring(0, $9c1f040232c6c384$var$MAX_SUMMARY_LENGTH)}...` : singleLineFeedbackText;
};
const $9c1f040232c6c384$var$getFeedbackFieldsWithConsent = ({ data: data, feedbackContext: feedbackContext, isPositive: isPositive, emailAddress: emailAddress, displayName: displayName })=>{
    const { feedbackText: feedbackText, contactConsentPrompt: contactConsentPrompt, researchConsentPrompt: researchConsentPrompt } = data;
    return [
        {
            id: 'summary',
            value: `[${isPositive ? '+' : '-'}] ${$9c1f040232c6c384$var$normalizeTextForSummary(feedbackText)}`
        },
        {
            id: 'description',
            value: feedbackText
        },
        {
            id: 'email',
            value: emailAddress ?? 'do-not-reply@atlassian.com'
        },
        {
            id: 'customfield_10045',
            value: displayName ?? 'unknown'
        },
        {
            id: 'aaidOrHash',
            value: ''
        },
        {
            id: 'customfield_10047',
            value: feedbackContext
        },
        {
            id: $9c1f040232c6c384$var$CONTACT_FIELD_ID,
            value: [
                {
                    id: contactConsentPrompt ? $9c1f040232c6c384$var$CONTACT_TRUE_VALUE : $9c1f040232c6c384$var$CONTACT_FALSE_VALUE
                }
            ]
        },
        {
            id: $9c1f040232c6c384$var$RESEARCH_FIELD_ID,
            value: [
                {
                    id: researchConsentPrompt ? $9c1f040232c6c384$var$RESEARCH_TRUE_VALUE : $9c1f040232c6c384$var$RESEARCH_FALSE_VALUE
                }
            ]
        }
    ];
};
const $9c1f040232c6c384$var$normalizeFeedbackContext = (feedbackContext)=>feedbackContext.map(({ id: id, value: value })=>`${id}: ${value}`).join('\n');
const $9c1f040232c6c384$var$removeName = (prompt, name)=>prompt.replace(new RegExp(name, 'gi'), 'XXX');
const $9c1f040232c6c384$var$removeNames = (prompt, userFullname)=>userFullname.split(' ').reduce((acc, name)=>name === '' ? acc : $9c1f040232c6c384$var$removeName(acc, name), prompt);
const $9c1f040232c6c384$var$removeEmailAddresses = (prompt)=>prompt.replace(new RegExp('([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\\.[a-zA-Z0-9_-]+)', 'gi'), 'XXX@XXX.XXX');
const $9c1f040232c6c384$export$53b1bdb22c0c1228 = (prompt, userFullname)=>$9c1f040232c6c384$var$removeEmailAddresses($9c1f040232c6c384$var$removeNames(prompt, userFullname));
const $9c1f040232c6c384$export$fdeb51de8e2ac66d = (prompt, additionalFeedbackContext)=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const [{ data: loggedInUser }] = (0, $c9f6v.useUserSubscriber)();
    const onSubmitFeedback = (0, $eJOHy.useCallback)(async (data, isPositive)=>{
        if (!data.feedbackText && !data.sharePrompt) {
            (0, $7jTnu.fg)('product-terminology-refresh') ? showFlag($9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG) : showFlag($9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG_WITHOUT_APPIFY);
            // Do nothing, probably the user just wanted to send a thumbs up / thumbs down rating
            return Promise.resolve();
        }
        const feedbackContext = [
            {
                id: 'Location',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: (0, $kkHo2.default)(window?.location?.href ?? '')
            },
            {
                id: 'Screen Resolution',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: `${window?.screen?.width ?? 'unknown'} x ${window?.screen?.height ?? 'unknown'}`
            },
            {
                id: 'User-Agent',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: `${window?.navigator?.userAgent ?? 'unknown'}`
            },
            {
                id: 'Rating',
                value: isPositive ? 'Thumbs up' : 'Thumbs down'
            }
        ];
        if (data.sharePrompt && prompt) feedbackContext.push({
            id: 'Prompt',
            value: $9c1f040232c6c384$export$53b1bdb22c0c1228(prompt, loggedInUser?.displayName ?? '')
        });
        if (additionalFeedbackContext?.length && data.sharePrompt) feedbackContext.push(...additionalFeedbackContext);
        try {
            const body = JSON.stringify({
                feedback: {
                    requestType: $9c1f040232c6c384$var$REQUEST_TYPE,
                    embedKey: $9c1f040232c6c384$var$EMBED_KEY,
                    fields: $9c1f040232c6c384$var$getFeedbackFieldsWithConsent({
                        data: data,
                        feedbackContext: $9c1f040232c6c384$var$normalizeFeedbackContext(feedbackContext),
                        isPositive: isPositive,
                        emailAddress: loggedInUser?.emailAddress,
                        displayName: loggedInUser?.displayName
                    })
                }
            });
            await fetch($9c1f040232c6c384$var$FEEDBACK_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: $9c1f040232c6c384$require$Buffer.from(body).toString('base64')
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'onFeedbackSubmit',
                    packageName: 'jiraAtlassianIntelligence',
                    teamName: 'gravity-ai'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
        (0, $7jTnu.fg)('product-terminology-refresh') ? showFlag($9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG) : showFlag($9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG_WITHOUT_APPIFY);
        return Promise.resolve();
    }, [
        loggedInUser?.displayName,
        loggedInUser?.emailAddress,
        prompt,
        showFlag,
        additionalFeedbackContext
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            onSubmitFeedback: onSubmitFeedback
        }), [
        onSubmitFeedback
    ]);
};

});
parcelRegister("k6bid", function(module, exports) {

$parcel$export(module.exports, "default", () => $e33a929489e20d70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e33a929489e20d70$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    feedbackSubmittedFlagTitle: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-title",
        "defaultMessage": "Thank you for sharing your query"
    },
    feedbackSubmittedFlagDescription: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-description",
        "defaultMessage": "Your valuable feedback helps us continually improve our products."
    },
    feedbackSubmittedFlagDescriptionAppify: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-description-appify",
        "defaultMessage": "Your valuable feedback helps us continually improve our apps."
    }
});

});


parcelRegister("71UWI", function(module, exports) {

$parcel$export(module.exports, "FeedbackPopupContent", () => $a4cb633294b0446f$export$9ca94f39d69b2936);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");
var $OgPfS = parcelRequire("OgPfS");

var $fkBUX = parcelRequire("fkBUX");

var $bvFRW = parcelRequire("bvFRW");

var $g17XP = parcelRequire("g17XP");

var $51Gwp = parcelRequire("51Gwp");

var $bxHeV = parcelRequire("bxHeV");
var $bL3dk = parcelRequire("bL3dk");
var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $isKH0 = parcelRequire("isKH0");

var $lRq8t = parcelRequire("lRq8t");

var $lHJTm = parcelRequire("lHJTm");
const $a4cb633294b0446f$var$FEEDBACK_TEXT_FIELD = 'feedback-text';
const $a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX = 'share-prompt';
const $a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX = 'contact-consent-prompt';
const $a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX = 'research-consent-prompt';
// The height of the text area should be 160px - there is a 12px combined padding and here we have 148px height
const $a4cb633294b0446f$var$MAX_TEXTAREA_HEIGHT = '148px';
const $a4cb633294b0446f$var$MIN_TEXTAREA_ROWS = 7;
const $a4cb633294b0446f$export$9ca94f39d69b2936 = ({ isErrorReport: isErrorReport, isPositive: isPositive, onClose: onClose, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [submitting, setSubmitting] = (0, $eJOHy.useState)(false);
    const handleOnSubmit = async (event)=>{
        event.preventDefault();
        if (!submitting) {
            setSubmitting(true);
            if (isErrorReport) await onSubmit({
                feedbackText: '',
                sharePrompt: true,
                contactConsentPrompt: false,
                researchConsentPrompt: false
            }, isPositive);
            else {
                const data = new FormData(event.currentTarget);
                const feedbackText = data.get($a4cb633294b0446f$var$FEEDBACK_TEXT_FIELD)?.toString() ?? '';
                const sharePrompt = data.get($a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX) === $a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX;
                const contactConsentPrompt = data.get($a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX) === $a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX;
                const researchConsentPrompt = data.get($a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX) === $a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX;
                await onSubmit({
                    feedbackText: feedbackText,
                    sharePrompt: sharePrompt,
                    contactConsentPrompt: contactConsentPrompt,
                    researchConsentPrompt: researchConsentPrompt
                }, isPositive);
            }
            setSubmitting(false);
            onClose();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        padding: "space.300",
        xcss: $a4cb633294b0446f$var$containerStyles,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.feedback-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
        onSubmit: handleOnSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "medium"
    }, formatMessage((0, $lHJTm.default).heading)), !isErrorReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        "aria-label": formatMessage((0, $lHJTm.default).close),
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g17XP))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $lHJTm.default).close)
        }),
        onClick: onClose,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.close-button"
    }))), isErrorReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), null, formatMessage((0, $lHJTm.default).errorReportDescription)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        paddingBlockEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "xxsmall",
        as: "div"
    }, formatMessage((0, $lHJTm.default).textAreaHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $a4cb633294b0446f$var$textAreaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $isKH0.default), {
        name: $a4cb633294b0446f$var$FEEDBACK_TEXT_FIELD,
        appearance: "none",
        minimumRows: $a4cb633294b0446f$var$MIN_TEXTAREA_ROWS,
        maxHeight: $a4cb633294b0446f$var$MAX_TEXTAREA_HEIGHT // This keeps the text area at a constant height alongside min rows
        ,
        "aria-label": formatMessage((0, $lHJTm.default).textAreaHeader),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.text-area",
        ref: setInitialFocusRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkBUX.default), {
        name: $a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX,
        value: $a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $lHJTm.default).shareQueryPromptJnlis612)),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.share-prompt-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkBUX.default), {
        name: $a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX,
        value: $a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $lHJTm.default).contactConsentPromptJnlis612, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
                    href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                    target: "_blank"
                }, chunks)
        })),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.contact-consent-prompt-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkBUX.default), {
        name: $a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX,
        value: $a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $lHJTm.default).researchConsentPromptJnlis612)),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.research-consent-prompt-checkbox"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        space: "space.100",
        alignInline: "end"
    }, isErrorReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
        appearance: "subtle",
        type: "button",
        onClick: onClose
    }, formatMessage((0, $lHJTm.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OgPfS.default), {
        type: "submit",
        appearance: "primary",
        isLoading: submitting,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.submit-button"
    }, formatMessage(isErrorReport ? (0, $lHJTm.default).shareQuery : (0, $lHJTm.default).sendFeedback))))));
};
const $a4cb633294b0446f$var$containerStyles = (0, $5Wv5g.xcss)({
    width: '448px',
    borderRadius: 'border.radius'
});
const $a4cb633294b0446f$var$textAreaContainerStyles = (0, $5Wv5g.xcss)({
    backgroundColor: 'color.background.input',
    borderRadius: 'border.radius.100',
    padding: 'space.075',
    border: `2px solid ${"var(--ds-border-input, #8590A2)"}`,
    marginBottom: 'space.200'
});

});
parcelRegister("lHJTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $723744ee9dea309b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $723744ee9dea309b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorReportDescription: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.error-report-description",
        "defaultMessage": "Share your query to help us improve search results."
    },
    shareQuery: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.share-query",
        "defaultMessage": "Share Query"
    },
    cancel: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.cancel",
        "defaultMessage": "Cancel"
    },
    heading: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.heading",
        "defaultMessage": "Help us improve Atlassian Intelligence"
    },
    close: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.close",
        "defaultMessage": "Close"
    },
    sendFeedback: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.send-feedback",
        "defaultMessage": "Send feedback"
    },
    contactConsentPrompt: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.contact-consent-prompt",
        "defaultMessage": "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <link>Atlassian Privacy Policy</link>."
    },
    researchConsentPrompt: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.research-consent-prompt",
        "defaultMessage": "I'd like to participate in product research."
    },
    textAreaHeader: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.text-area-header",
        "defaultMessage": "How was your search experience?"
    },
    shareQueryPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.share-query-prompt-jnlis-612",
        "defaultMessage": "Include my search query and response in my feedback"
    },
    contactConsentPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.contact-consent-prompt-jnlis-612",
        "defaultMessage": "Atlassian can contact me to learn more about this feedback and I acknowledge the <link>Atlassian Privacy Policy</link>"
    },
    researchConsentPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.research-consent-prompt-jnlis-612",
        "defaultMessage": "I want to participate in Atlassian\u2019s product research"
    }
});

});



parcelRegister("cp5xE", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa03b109e5e86a68$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $aa03b109e5e86a68$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    reportToAtlassianDefault: {
        "id": "atlassian-intelligence.prompt-response.report-to-atlassian-button.report-to-atlassian-default",
        "defaultMessage": "Report to Atlassian"
    }
});

});



parcelRegister("apzdY", function(module, exports) {

$parcel$export(module.exports, "MessageWithSupportLink", () => $e5f497c8eb9fbc84$export$d20e11a08c36750a);

var $eJOHy = parcelRequire("eJOHy");

var $dKpTa = parcelRequire("dKpTa");

var $kDaaB = parcelRequire("kDaaB");
function $e5f497c8eb9fbc84$export$d20e11a08c36750a(props) {
    const { message: message, href: href = '' } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...message,
        values: {
            support_link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
                    spacing: "none",
                    href: href,
                    appearance: "link"
                }, chunks)
        }
    });
}

});

parcelRegister("9lKGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $abf46a22a1ab8a93$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $abf46a22a1ab8a93$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noJqlReturned: {
        "id": "natural-language-to-jql.services.use-natural-language-to-jql.no-jql-returned",
        "defaultMessage": "We couldn\u2019t turn your input into a JQL query. Try adding more details."
    },
    invalidJqlErrorNonFinal: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.invalid-jql-error-non-final",
        "defaultMessage": "Atlassian Intelligence couldn\u2019t process your query. Try including specific fields from your issues or projects."
    },
    errorRateLimit: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.error-rate-limit",
        "defaultMessage": "Excessive use has been detected with Atlassian Intelligence. Try again later. Read more <support_link>in our support documentation</support_link>."
    },
    helpUsImproveNonFinal: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.help-us-improve-non-final",
        "defaultMessage": "Help us improve your search"
    },
    unsupportedLanguageErrorNonFinal: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.unsupported-language-error-non-final",
        "defaultMessage": "Atlassian Intelligence currently can\u2019t translate non-English words. Try editing your query."
    },
    serverError: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.server-error",
        "defaultMessage": "Atlassian Intelligence can't provide a response right now. Read more <support_link>in our support documentation</support_link>."
    },
    invalidJqlErrorNonFinalIssueTerminologyRefreshM4: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.invalid-jql-error-non-final-issue-terminology-refresh-m4",
        "defaultMessage": "Atlassian Intelligence couldn\u2019t process your query. Try including specific fields from your work items or projects."
    },
    invalidJqlErrorNonFinalIssueTerminologyRefreshM4Galaxia: {
        "id": "natural-language-to-jql.use-natural-language-to-jql.invalid-jql-error-non-final-galaxia",
        "defaultMessage": "Atlassian Intelligence couldn\u2019t process your query. Try including specific fields from your work items or spaces."
    }
});

});



parcelRegister("83x9v", function(module, exports) {

$parcel$export(module.exports, "Container", () => $41cc4588a5b9db63$export$42a852a2b6b56249);
$parcel$export(module.exports, "useIsAITourEnabled", () => $41cc4588a5b9db63$export$86ae6680aa96ab9c);
$parcel$export(module.exports, "useAITourActions", () => $41cc4588a5b9db63$export$4749bc2ffa4650e0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $lriOZ = parcelRequire("lriOZ");
const $41cc4588a5b9db63$var$initialState = {
    isAITourEnabled: false
};
const $41cc4588a5b9db63$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $41cc4588a5b9db63$var$initialState,
    actions: $lriOZ.actions
});
const $41cc4588a5b9db63$export$42a852a2b6b56249 = (0, $6E16M.createContainer)($41cc4588a5b9db63$export$390f32400eaf98c9, {
    onInit: ()=>({ setState: setState }, { isAITourUserPreferenceEnabled: isAITourUserPreferenceEnabled })=>{
            setState({
                isAITourEnabled: isAITourUserPreferenceEnabled
            });
        }
});
const $41cc4588a5b9db63$export$86ae6680aa96ab9c = (0, $iJq0l.createHook)($41cc4588a5b9db63$export$390f32400eaf98c9, {
    selector: (state)=>state.isAITourEnabled
});
const $41cc4588a5b9db63$export$4749bc2ffa4650e0 = (0, $iJq0l.createActionsHook)($41cc4588a5b9db63$export$390f32400eaf98c9);

});
parcelRegister("lriOZ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $195c91a713e2cb1f$export$e324594224ef24da);
const $195c91a713e2cb1f$export$e324594224ef24da = {
    onDisableAITourUserPreference: ()=>(_, { onDisableAITourUserPreference: onDisableAITourUserPreference })=>{
            onDisableAITourUserPreference();
        },
    onEndAITour: ()=>({ setState: setState })=>{
            setState({
                isAITourEnabled: false
            });
        }
};

});


parcelRegister("hf0iW", function(module, exports) {

$parcel$export(module.exports, "usePlaceholders", () => $562577e22c4e842a$export$70db0766be197dab);

var $eJOHy = parcelRequire("eJOHy");

var $aX8Tx = parcelRequire("aX8Tx");

var $8eEu3 = parcelRequire("8eEu3");

var $aMWVr = parcelRequire("aMWVr");

var $7jTnu = parcelRequire("7jTnu");

var $2aY2d = parcelRequire("2aY2d");
const $562577e22c4e842a$var$getInitialState = (project = 'Donut Plains')=>{
    // TODO: extract to messages file once we've landed on a more definitive set of prompts
    const projectScopedPlaceholders = [
        `Find work items in project "${project}" that are assigned to me`,
        `What are the highest priority bugs in project "${project}"?`,
        `Stories in project "${project}" updated this month`,
        `Which tasks in project "${project}" don't have an assignee?`,
        `Find work items in project "${project}" that were created in the last 30 days`
    ];
    const projectScopedPlaceholdersOld = [
        `Find issues in project "${project}" that are assigned to me`,
        `What are the highest priority bugs in project "${project}"?`,
        `Stories in project "${project}" updated this month`,
        `Which tasks in project "${project}" don't have an assignee?`,
        `Find issues in project "${project}" that were created in the last 30 days`
    ];
    // TODO: extract to messages file once we've landed on a more definitive set of prompts
    const globalScopedPlaceholders = [
        'Work items about pizza forest with status rolling out',
        'Which epics are in progress?',
        "Find work items that I'm watching",
        'Work items reported by Mike and ordered by priority'
    ];
    // TODO: extract to messages file once we've landed on a more definitive set of prompts
    const globalScopedPlaceholdersOld = [
        'Issues about pizza forest with status rolling out',
        'Which epics are in progress?',
        "Find issues that I'm watching",
        'Issues reported by Mike and ordered by priority'
    ];
    // Randomize order of the placeholders above, making sure a project scoped placeholder always comes first
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($aX8Tx)))((0, (/*@__PURE__*/$parcel$interopDefault($aMWVr)))((0, (/*@__PURE__*/$parcel$interopDefault($8eEu3)))((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? projectScopedPlaceholders : projectScopedPlaceholdersOld), (0, (/*@__PURE__*/$parcel$interopDefault($8eEu3)))((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? globalScopedPlaceholders : globalScopedPlaceholdersOld))).filter((placeholder)=>placeholder !== undefined);
};
const $562577e22c4e842a$export$70db0766be197dab = ()=>{
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    return (0, $eJOHy.useMemo)(()=>$562577e22c4e842a$var$getInitialState(projectContext?.projectKey), [
        projectContext?.projectKey
    ]);
};

});
parcelRegister("aMWVr", function(module, exports) {

var $l76qh = parcelRequire("l76qh");

var $5AzKs = parcelRequire("5AzKs");
/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */ var $7dac187848f944d1$var$zip = $l76qh($5AzKs);
module.exports = $7dac187848f944d1$var$zip;

});
parcelRegister("5AzKs", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $lylkU = parcelRequire("lylkU");

var $9U1Ux = parcelRequire("9U1Ux");

var $8uV2D = parcelRequire("8uV2D");

var $d1ShJ = parcelRequire("d1ShJ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $411c0b668f1adb8b$var$nativeMax = Math.max;
/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */ function $411c0b668f1adb8b$var$unzip(array) {
    if (!(array && array.length)) return [];
    var length = 0;
    array = $821Ou(array, function(group) {
        if ($d1ShJ(group)) {
            length = $411c0b668f1adb8b$var$nativeMax(group.length, length);
            return true;
        }
    });
    return $8uV2D(length, function(index) {
        return $lylkU(array, $9U1Ux(index));
    });
}
module.exports = $411c0b668f1adb8b$var$unzip;

});



parcelRegister("bZ6RS", function(module, exports) {

$parcel$export(module.exports, "AlertMessage", () => $3cfd982e773d81b9$export$8ebcecbecdb22732);

var $eJOHy = parcelRequire("eJOHy");

var $Svlt9 = parcelRequire("Svlt9");

var $lU1m0 = parcelRequire("lU1m0");

var $kibFU = parcelRequire("kibFU");

var $bL3dk = parcelRequire("bL3dk");
var $5Wv5g = parcelRequire("5Wv5g");
const $3cfd982e773d81b9$export$8ebcecbecdb22732 = ({ appearance: appearance, children: children, testId: testId })=>{
    const StyleConfig = $3cfd982e773d81b9$var$getIconAndStyles(appearance);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignBlock: "center",
        testId: testId,
        space: "space.050",
        xcss: StyleConfig.styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StyleConfig.Icon, {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, children));
};
const $3cfd982e773d81b9$var$infoStyles = (0, $5Wv5g.xcss)({
    color: 'color.text.subtle'
});
const $3cfd982e773d81b9$var$warningStyles = (0, $5Wv5g.xcss)({
    color: 'color.text.warning'
});
const $3cfd982e773d81b9$var$errorStyles = (0, $5Wv5g.xcss)({
    color: 'color.text.danger'
});
const $3cfd982e773d81b9$var$getIconAndStyles = (appearence)=>{
    switch(appearence){
        case 'info':
            return {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lU1m0))),
                styles: $3cfd982e773d81b9$var$infoStyles
            };
        case 'warning':
            return {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kibFU))),
                styles: $3cfd982e773d81b9$var$warningStyles
            };
        case 'error':
            return {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($Svlt9))),
                styles: $3cfd982e773d81b9$var$errorStyles
            };
        default:
            return {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lU1m0))),
                styles: $3cfd982e773d81b9$var$infoStyles
            };
    }
};

});

parcelRegister("3SZaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a69c6bbd6be7ffd$export$2e2bcd8739ae039);

var $63r6I = parcelRequire("63r6I");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $56qWy = parcelRequire("56qWy");

var $c1Djs = parcelRequire("c1Djs");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $1RHiq = parcelRequire("1RHiq");
const $6a69c6bbd6be7ffd$var$CustomEditorContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showAdvancedEditor: showAdvancedEditor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlkb7n",
            __cmplp.showAdvancedEditor ? "_19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr" : "_1n261g80 _19pkr5cr _2hwxr5cr _otyridpf _18u0r5cr",
            __cmplp.className
        ])
    });
});
const $6a69c6bbd6be7ffd$var$components = {
    SearchModeSwitcher: $1RHiq.SearchModeSwitcher,
    EditorContainer: $6a69c6bbd6be7ffd$var$CustomEditorContainer
};
const $6a69c6bbd6be7ffd$var$JQLBuilderEmbedded = ({ aiBuilderOverrides: aiBuilderOverrides, generatedJql: generatedJql, query: query, jqlMessages: jqlMessages, onSearch: onSearch, renderExtraControls: renderExtraControls, userPreferences: userPreferences, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleSearch = (0, $eJOHy.useCallback)((jql)=>{
        onSearch && onSearch(jql);
        const isModified = generatedJql !== jql;
        const event = createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'search'
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'jqlBuilderEmbedded', {
            isModified: isModified
        });
    }, [
        createAnalyticsEvent,
        generatedJql,
        onSearch
    ]); // Allow renderExtraControls to be overridden for the embedded AI view.
    const renderExtraControlsOverride = aiBuilderOverrides?.renderExtraControls ?? renderExtraControls;
    const userPreferencesData = (0, $j4oe4.useFragment)((0, $63r6I.default), userPreferences);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c1Djs.default), {
        ...props,
        userPreferencesData: userPreferencesData ?? null,
        query: query,
        jqlMessages: jqlMessages,
        onSearch: onSearch ? handleSearch : undefined,
        renderExtraControls: renderExtraControlsOverride,
        components: $6a69c6bbd6be7ffd$var$components,
        searchModeSwitcherLocation: (0, $56qWy.SEARCH_MODE_SWITCHER_RIGHT_LOCATION)
    });
};
var $6a69c6bbd6be7ffd$export$2e2bcd8739ae039 = $6a69c6bbd6be7ffd$var$JQLBuilderEmbedded;

});
parcelRegister("63r6I", function(module, exports) {

$parcel$export(module.exports, "default", () => $0750cf97c1905187$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<515fc3ab26c9c35442907db000dfbc24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0750cf97c1905187$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilderEmbedded_jqlBuilderWithAi",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_jqlBuilder_JQLBuilder"
        }
    ],
    "type": "JiraUserPreferences"
};
$0750cf97c1905187$var$node.hash = "ff5e8454ba99d859ec81e83043c22b46";
var $0750cf97c1905187$export$2e2bcd8739ae039 = $0750cf97c1905187$var$node;

});

parcelRegister("1RHiq", function(module, exports) {

$parcel$export(module.exports, "SearchModeSwitcher", () => $fc6a952cc47efca6$export$639730063e548c7);

var $eJOHy = parcelRequire("eJOHy");

var $9M9zY = parcelRequire("9M9zY");

var $4i43d = parcelRequire("4i43d");

var $h7qUV = parcelRequire("h7qUV");

var $eTc4B = parcelRequire("eTc4B");
const $fc6a952cc47efca6$export$639730063e548c7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4i43d.Feedback), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h7qUV.DisclaimerTooltip), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eTc4B.SearchModeOverflowMenu), props));

});
parcelRegister("4i43d", function(module, exports) {

$parcel$export(module.exports, "Feedback", () => $7c567c4344809cbe$export$175e500a48a60fd2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6PCzj = parcelRequire("6PCzj");

var $9M9zY = parcelRequire("9M9zY");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");


var $v7053 = parcelRequire("v7053");

var $4wc0I = parcelRequire("4wc0I");


var $9EXJt = parcelRequire("9EXJt");
const $7c567c4344809cbe$var$LikeIcon = ({ isSelected: isSelected = false, isDisabled: isDisabled = false, label: label })=>{
    const primaryColor = isSelected || isDisabled ? undefined : "var(--ds-icon-accent-gray, #758195)";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6PCzj))), {
        spacing: "spacious",
        label: label,
        color: primaryColor,
        LEGACY_primaryColor: primaryColor
    });
};
const $7c567c4344809cbe$var$DislikeIcon = (props)=>// TODO: after visual refresh is completely rolled out, change it to import ThumbsDownIcon from '@atlaskit/icon/core/thumbs-down';
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c567c4344809cbe$var$Flip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c567c4344809cbe$var$LikeIcon, props));
const $7c567c4344809cbe$export$175e500a48a60fd2 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [selected, setSelected] = (0, $eJOHy.useState)((0, $9acd78eacc95628c$export$c53d0f541b41b88e));
    const hasOpened = (0, $eJOHy.useRef)(false);
    const [isLoading] = (0, $4wc0I.usePromptIsLoading)();
    const [promptId] = (0, $4wc0I.usePromptId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Reset internal state whenever a new prompt has been submitted so more feedback can be given
        if (!isLoading) {
            setSelected((0, $9acd78eacc95628c$export$c53d0f541b41b88e));
            hasOpened.current = false;
        }
    }, [
        isLoading
    ]);
    const onRating = (0, $eJOHy.useCallback)((feedbackType)=>()=>{
            setSelected(feedbackType); // Only emit analytics event first time popup is opened
            if (!hasOpened.current) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiFeedback submitted', {
                aiFeatureName: 'NL Search in Jira',
                singleInstrumentationID: promptId,
                proactiveAIGenerated: 0,
                userGeneratedAI: 1,
                isAIFeature: 1,
                aiFeedbackResult: feedbackType === 'LIKE' ? 'up' : 'down'
            });
            hasOpened.current = true;
            return false;
        }, [
        createAnalyticsEvent,
        promptId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9zY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $v7053.FeedbackButton), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c567c4344809cbe$var$LikeIcon, {
            label: formatMessage((0, $9EXJt.default).jnlis645GoodResponse),
            isSelected: selected === (0, $8e9abaad3d9cfcae$export$d0f488901b85b750),
            isDisabled: isLoading
        }),
        isDisabled: isLoading,
        isPositive: true,
        isSelected: selected === (0, $8e9abaad3d9cfcae$export$d0f488901b85b750),
        onClick: onRating((0, $8e9abaad3d9cfcae$export$d0f488901b85b750)),
        offset: [
            40,
            16
        ],
        placement: "bottom-end",
        spacing: "compact",
        testId: "atlassian-intelligence.ui.feedback.like-button",
        tooltipContent: selected === (0, $9acd78eacc95628c$export$c53d0f541b41b88e) && formatMessage((0, $9EXJt.default).jnlis645GoodResponse),
        label: formatMessage((0, $9EXJt.default).jnlis645GoodResponse)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $v7053.FeedbackButton), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c567c4344809cbe$var$DislikeIcon, {
            label: formatMessage((0, $9EXJt.default).jnlis645BadResponse),
            isSelected: selected === (0, $8e9abaad3d9cfcae$export$7ca6708a8b83d828),
            isDisabled: isLoading
        }),
        isDisabled: isLoading,
        isPositive: false,
        isSelected: selected === (0, $8e9abaad3d9cfcae$export$7ca6708a8b83d828),
        onClick: onRating((0, $8e9abaad3d9cfcae$export$7ca6708a8b83d828)),
        offset: [
            8,
            16
        ],
        placement: "bottom-end",
        spacing: "compact",
        testId: "atlassian-intelligence.ui.feedback.dislike-button",
        tooltipContent: selected === (0, $9acd78eacc95628c$export$c53d0f541b41b88e) && formatMessage((0, $9EXJt.default).jnlis645BadResponse),
        label: formatMessage((0, $9EXJt.default).jnlis645BadResponse)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c567c4344809cbe$var$Flip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_t9ec1sub",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6PCzj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34d7d17224c47dbf743afe51a06a375>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f956c64d863658c$var$_react = $4f956c64d863658c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4f956c64d863658c$var$_thumbsUp = $4f956c64d863658c$var$_interopRequireDefault((parcelRequire("h0ZMA")));

var $4f956c64d863658c$var$_like = $4f956c64d863658c$var$_interopRequireDefault((parcelRequire("4yySf")));
function $4f956c64d863658c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ThumbsUpIcon.
 * This component is ThumbsUpIcon, with `UNSAFE_fallbackIcon` set to "LikeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f956c64d863658c$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $4f956c64d863658c$var$_react.default.createElement($4f956c64d863658c$var$_thumbsUp.default, Object.assign({
        LEGACY_fallbackIcon: $4f956c64d863658c$var$_like.default
    }, props));
$4f956c64d863658c$var$ThumbsUpIcon.Name = 'ThumbsUpIconMigration';
var $4f956c64d863658c$var$_default = module.exports.default = $4f956c64d863658c$var$ThumbsUpIcon;

});
parcelRegister("h0ZMA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1671a6ac4d424a875e471692b3026e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6325c7d1341f867$var$_react = $c6325c7d1341f867$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c6325c7d1341f867$var$_baseNew = $c6325c7d1341f867$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $c6325c7d1341f867$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6325c7d1341f867$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $c6325c7d1341f867$var$_react.default.createElement($c6325c7d1341f867$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$c6325c7d1341f867$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $c6325c7d1341f867$var$_default = module.exports.default = $c6325c7d1341f867$var$ThumbsUpIcon;

});

parcelRegister("4yySf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3515639f0489b5cb$var$_react = $3515639f0489b5cb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $3515639f0489b5cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3515639f0489b5cb$var$LikeIcon = (props)=>/*#__PURE__*/ $3515639f0489b5cb$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 12v7a.97.97 0 0 0 .278.704 1 1 0 0 0 .701.296H6v-9H4.98a1 1 0 0 0-.701.296A.97.97 0 0 0 4 12m15.281-.96a3.05 3.05 0 0 0-2.321-1.061h-2.634c.04-.181.08-.36.11-.532.515-2.934 0-4-.504-4.594A2.43 2.43 0 0 0 12.075 4a3.08 3.08 0 0 0-2.968 2.751c-.393 1.839-.454 2-.968 2.725l-.768 1.089a2 2 0 0 0-.363 1.141v6.273c.001.532.216 1.041.596 1.416s.896.585 1.433.584h7.247a3.014 3.014 0 0 0 2.997-2.507l.677-4a2.96 2.96 0 0 0-.677-2.432m-1.998 6.1a1.01 1.01 0 0 1-1 .835H9.038v-6.269l.767-1.089a7.6 7.6 0 0 0 1.302-3.509c.036-.543.255-1.209.969-1.108s.575 1.916.363 3.1a20 20 0 0 1-.868 2.882l5.39-.008c.297-.001.58.128.773.352a1 1 0 0 1 .226.813z"/></svg>`
    }, props));
$3515639f0489b5cb$var$LikeIcon.displayName = 'LikeIcon';
var $3515639f0489b5cb$var$_default = module.exports.default = $3515639f0489b5cb$var$LikeIcon;

});


const $9acd78eacc95628c$export$c53d0f541b41b88e = 'NONE';

parcelRegister("9EXJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef58991a1635c3d2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ef58991a1635c3d2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    jnlis645GoodResponse: {
        "id": "atlassian-intelligence.prompt-response.feedback.jnlis645-good-response",
        "defaultMessage": "Good response"
    },
    jnlis645BadResponse: {
        "id": "atlassian-intelligence.prompt-response.feedback.jnlis645-bad-response",
        "defaultMessage": "Bad response"
    }
});

});


parcelRegister("h7qUV", function(module, exports) {

$parcel$export(module.exports, "DisclaimerTooltip", () => $dbf898b6b486a5e9$export$e0db5370c1c8da59);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $lU1m0 = parcelRequire("lU1m0");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $9JB3T = parcelRequire("9JB3T");

var $cNe2t = parcelRequire("cNe2t");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $4fgwb = parcelRequire("4fgwb");
const $dbf898b6b486a5e9$var$DISCLAIMER_PAGE_HREF = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $dbf898b6b486a5e9$export$e0db5370c1c8da59 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [isPopupOpen, setIsPopupOpen] = (0, $eJOHy.useState)(false);
    const handleTrustDisclaimerClicked = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jqlBuilderAiTrustDisclaimer');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: "bottom",
        messageId: "jql-builder-with-ai.ui.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
                xcss: $dbf898b6b486a5e9$var$PopupStyles
            }, formatMessage((0, $4fgwb.default).aiDisclaimerPopupContent, {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dbf898b6b486a5e9$var$Link, {
                        href: $dbf898b6b486a5e9$var$DISCLAIMER_PAGE_HREF,
                        target: "_blank",
                        onClick: handleTrustDisclaimerClicked
                    }, chunks)
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
                content: formatMessage((0, $4fgwb.default).infoIconTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, $4fgwb.default).infoIconLabel),
                "aria-label": formatMessage((0, $4fgwb.default).infoIconLabel),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lU1m0))), {
                    label: "",
                    LEGACY_size: "small",
                    color: "var(--ds-icon-accent-gray, #758195)"
                }),
                onClick: ()=>setIsPopupOpen(!isPopupOpen),
                ...triggerProps
            }))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dbf898b6b486a5e9$var$Link = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz14q2",
            __cmplp.className
        ])
    });
});
const $dbf898b6b486a5e9$var$PopupStyles = (0, $5Wv5g.xcss)({
    color: 'color.text',
    background: 'color.background.input',
    padding: 'space.200',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay'
});

});
parcelRegister("4fgwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e35da267506c579$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1e35da267506c579$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    aiDisclaimerPopupContent: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.ai-disclaimer-popup-content",
        "defaultMessage": "The quality of AI-generated information may vary. <a>Learn why</a>"
    },
    infoIconLabel: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.info-icon-label",
        "defaultMessage": "Atlassian Intelligence trust information."
    },
    infoIconTooltip: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.info-icon-tooltip",
        "defaultMessage": "About AI"
    }
});

});


parcelRegister("eTc4B", function(module, exports) {

$parcel$export(module.exports, "SearchModeOverflowMenu", () => $3de1eb2a7073efac$export$bd8d5aab7316dc82);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dKpTa = parcelRequire("dKpTa");

var $gtHL8 = parcelRequire("gtHL8");
var $7Ga8U = parcelRequire("7Ga8U");
var $lfSKL = parcelRequire("lfSKL");

var $bUnOI = parcelRequire("bUnOI");

var $bAxQs = parcelRequire("bAxQs");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $2Eyzh = parcelRequire("2Eyzh");

var $cQfYG = parcelRequire("cQfYG");
const $3de1eb2a7073efac$var$TooltipWithDisplayInlineFix = (props)=>// @ts-expect-error Incompatible ref type in tooltip (AK needs "HTMLElement", Compiled provides "HTMLDivElement" somehow these are not compatible in Typescript) */}
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        tag: $3de1eb2a7073efac$var$CustomTooltipTag,
        ...props
    });
const $3de1eb2a7073efac$export$bd8d5aab7316dc82 = ({ defaultOpen: defaultOpen = false, ...searchModeSwitcherProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleOpenChange = ({ isOpen: isOpen })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: isOpen ? 'opened' : 'closed',
            actionSubject: 'dropdown'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jqlBuilderAiSearchModeMenu');
    };
    const handlePrivacyAndLegalClicked = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jqlBuilderAiPrivacyAndLegal');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gtHL8.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3de1eb2a7073efac$var$TooltipWithDisplayInlineFix, {
                hideTooltipOnClick: true,
                content: formatMessage((0, $2Eyzh.messages).dropdownButtonTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dKpTa.default), {
                ...props,
                spacing: "none",
                appearance: "subtle",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAxQs))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    label: formatMessage((0, $2Eyzh.messages).overflowMenuLabel)
                }),
                ref: triggerRef
            })),
        onOpenChange: handleOpenChange,
        defaultOpen: defaultOpen,
        spacing: "compact",
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lfSKL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cQfYG.SearchModeToggleMenuItem), searchModeSwitcherProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Ga8U.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bUnOI))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        }),
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        target: "_blank",
        onClick: handlePrivacyAndLegalClicked
    }, formatMessage((0, $2Eyzh.messages).dataAndPrivacy))));
};
// The following inline-flex fix is for making the "More" icon be aligned with the rest of the feedback buttons
// Prior to this change, this was aligned correctly only because the "More" button had a height of 32px (which is wrong according to the design)
// When the height is fixed, this is no longer working due to the built in styles of the Tooltip
// Hence we override the display property of the tag to inline-flex, so that it is aligned to the center
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3de1eb2a7073efac$var$CustomTooltipTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bUnOI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ab76638cf521088$var$_react = $8ab76638cf521088$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8ab76638cf521088$var$_lockLocked = $8ab76638cf521088$var$_interopRequireDefault((parcelRequire("fUidu")));

var $8ab76638cf521088$var$_lock = $8ab76638cf521088$var$_interopRequireDefault((parcelRequire("aZlO3")));
function $8ab76638cf521088$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ab76638cf521088$var$LockLockedIcon = (props)=>/*#__PURE__*/ $8ab76638cf521088$var$_react.default.createElement($8ab76638cf521088$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $8ab76638cf521088$var$_lock.default
    }, props));
$8ab76638cf521088$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $8ab76638cf521088$var$_default = module.exports.default = $8ab76638cf521088$var$LockLockedIcon;

});
parcelRegister("fUidu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b94a376b829190f2$var$_react = $b94a376b829190f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b94a376b829190f2$var$_baseNew = $b94a376b829190f2$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $b94a376b829190f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b94a376b829190f2$var$LockLockedIcon = (props)=>/*#__PURE__*/ $b94a376b829190f2$var$_react.default.createElement($b94a376b829190f2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$b94a376b829190f2$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $b94a376b829190f2$var$_default = module.exports.default = $b94a376b829190f2$var$LockLockedIcon;

});

parcelRegister("aZlO3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8000842ed9050ab4$var$_react = $8000842ed9050ab4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $8000842ed9050ab4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8000842ed9050ab4$var$LockIcon = (props)=>/*#__PURE__*/ $8000842ed9050ab4$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$8000842ed9050ab4$var$LockIcon.displayName = 'LockIcon';
var $8000842ed9050ab4$var$_default = module.exports.default = $8000842ed9050ab4$var$LockIcon;

});


parcelRegister("2Eyzh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e6c33d087f3f2e9c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e6c33d087f3f2e9c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    dropdownButtonTooltip: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.dropdown-button-tooltip",
        "defaultMessage": "More actions"
    },
    dataAndPrivacy: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.data-and-privacy",
        "defaultMessage": "Data & Privacy"
    },
    overflowMenuLabel: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.overflow-menu-label",
        "defaultMessage": "More query builder options"
    }
});

});

parcelRegister("cQfYG", function(module, exports) {

$parcel$export(module.exports, "SearchModeToggleMenuItem", () => $735427254e25d89f$export$e2cd8687a50b5163);

var $eJOHy = parcelRequire("eJOHy");

var $7Ga8U = parcelRequire("7Ga8U");

var $kT3sa = parcelRequire("kT3sa");

var $hkuM9 = parcelRequire("hkuM9");

var $9JB3T = parcelRequire("9JB3T");

var $lRq8t = parcelRequire("lRq8t");

var $56qWy = parcelRequire("56qWy");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $8qT9y = parcelRequire("8qT9y");
const $735427254e25d89f$export$e2cd8687a50b5163 = ({ isBasicModeDisabled: isBasicModeDisabled, onUpdateSearchMode: onUpdateSearchMode, searchMode: searchMode })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const handleUpdateSearchMode = ()=>{
        const nextSearchMode = searchMode === (0, $56qWy.SEARCH_MODE_BASIC) ? (0, $56qWy.SEARCH_MODE_ADVANCED) : (0, $56qWy.SEARCH_MODE_BASIC);
        onUpdateSearchMode(nextSearchMode);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'jqlBuilderAiSearchModeToggle', {
            searchMode: (0, $56qWy.mapSearchModeToAnalyticAtribute)[nextSearchMode]
        });
    };
    if (searchMode === (0, $56qWy.SEARCH_MODE_BASIC)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Ga8U.default), {
        onClick: handleUpdateSearchMode,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kT3sa))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $8qT9y.messages).advancedModeOverflowMenu));
    const switchToBasicItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Ga8U.default), {
        isDisabled: isBasicModeDisabled,
        onClick: handleUpdateSearchMode,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkuM9))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $8qT9y.messages).basicModeOverflowMenu));
    return isBasicModeDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9JB3T.default), {
        content: formatMessage((0, $8qT9y.messages).basicModeDisabledTooltip),
        tag: "span"
    }, switchToBasicItem) : switchToBasicItem;
};

});
parcelRegister("kT3sa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::892203c72b828429279b82b0b7182ba7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f34b9f73950caba7$var$_react = $f34b9f73950caba7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f34b9f73950caba7$var$_angleBrackets = $f34b9f73950caba7$var$_interopRequireDefault((parcelRequire("4IsAd")));

var $f34b9f73950caba7$var$_code = $f34b9f73950caba7$var$_interopRequireDefault((parcelRequire("9QcWu")));
function $f34b9f73950caba7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "CodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f34b9f73950caba7$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $f34b9f73950caba7$var$_react.default.createElement($f34b9f73950caba7$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $f34b9f73950caba7$var$_code.default
    }, props));
$f34b9f73950caba7$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $f34b9f73950caba7$var$_default = module.exports.default = $f34b9f73950caba7$var$AngleBracketsIcon;

});
parcelRegister("4IsAd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f1717ad0ebe27c$var$_react = $36f1717ad0ebe27c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $36f1717ad0ebe27c$var$_baseNew = $36f1717ad0ebe27c$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $36f1717ad0ebe27c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f1717ad0ebe27c$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $36f1717ad0ebe27c$var$_react.default.createElement($36f1717ad0ebe27c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$36f1717ad0ebe27c$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $36f1717ad0ebe27c$var$_default = module.exports.default = $36f1717ad0ebe27c$var$AngleBracketsIcon;

});

parcelRegister("9QcWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a3027277ba79e2$var$_react = $72a3027277ba79e2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $72a3027277ba79e2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $72a3027277ba79e2$var$CodeIcon = (props)=>/*#__PURE__*/ $72a3027277ba79e2$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
    }, props));
$72a3027277ba79e2$var$CodeIcon.displayName = 'CodeIcon';
var $72a3027277ba79e2$var$_default = module.exports.default = $72a3027277ba79e2$var$CodeIcon;

});


parcelRegister("hkuM9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afb010b77a3674d977e5adddea745303>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9dc2d4c9bfc45b3$var$_react = $c9dc2d4c9bfc45b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c9dc2d4c9bfc45b3$var$_component = $c9dc2d4c9bfc45b3$var$_interopRequireDefault((parcelRequire("kbuNE")));

var $c9dc2d4c9bfc45b3$var$_component2 = $c9dc2d4c9bfc45b3$var$_interopRequireDefault((parcelRequire("dzbq7")));
function $c9dc2d4c9bfc45b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ComponentIcon.
 * This component is ComponentIcon, with `UNSAFE_fallbackIcon` set to "ComponentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9dc2d4c9bfc45b3$var$ComponentIcon = (props)=>/*#__PURE__*/ $c9dc2d4c9bfc45b3$var$_react.default.createElement($c9dc2d4c9bfc45b3$var$_component.default, Object.assign({
        LEGACY_fallbackIcon: $c9dc2d4c9bfc45b3$var$_component2.default
    }, props));
$c9dc2d4c9bfc45b3$var$ComponentIcon.Name = 'ComponentIconMigration';
var $c9dc2d4c9bfc45b3$var$_default = module.exports.default = $c9dc2d4c9bfc45b3$var$ComponentIcon;

});
parcelRegister("kbuNE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1cb9edce980864$var$_react = $eb1cb9edce980864$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $eb1cb9edce980864$var$_baseNew = $eb1cb9edce980864$var$_interopRequireDefault((parcelRequire("8VVQv")));
function $eb1cb9edce980864$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb1cb9edce980864$var$ComponentIcon = (props)=>/*#__PURE__*/ $eb1cb9edce980864$var$_react.default.createElement($eb1cb9edce980864$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$eb1cb9edce980864$var$ComponentIcon.displayName = 'ComponentIcon';
var $eb1cb9edce980864$var$_default = module.exports.default = $eb1cb9edce980864$var$ComponentIcon;

});

parcelRegister("dzbq7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e076717f0568c07$var$_react = $9e076717f0568c07$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $aCmsU = parcelRequire("aCmsU");
function $9e076717f0568c07$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9e076717f0568c07$var$ComponentIcon = (props)=>/*#__PURE__*/ $9e076717f0568c07$var$_react.default.createElement($aCmsU.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991M3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991z"/><path d="M7 8.34h2V6.67H7zM5 6.67C5 5.75 5.9 5 7 5h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.66-2 1.66H7c-1.11 0-2-.75-2-1.66zm10 1.67h2V6.67h-2zm-2-1.67c0-.92.9-1.67 2-1.67h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.67-2 1.67h-2c-1.11-.01-2-.76-2-1.67z"/></g></svg>`
    }, props));
$9e076717f0568c07$var$ComponentIcon.displayName = 'ComponentIcon';
var $9e076717f0568c07$var$_default = module.exports.default = $9e076717f0568c07$var$ComponentIcon;

});


parcelRegister("8qT9y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $209f1ce8d3a3f583$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $209f1ce8d3a3f583$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    basicModeDisabledTooltip: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.basic-mode-disabled-tooltip",
        "defaultMessage": "You can't switch to basic as the query is too complex or is invalid"
    },
    basicModeOverflowMenu: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.basic-mode-overflow-menu",
        "defaultMessage": "Switch to Basic"
    },
    advancedModeOverflowMenu: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.search-mode-overflow-menu.search-mode-toggle-menu-item.advanced-mode-overflow-menu",
        "defaultMessage": "Switch to JQL"
    }
});

});





parcelRegister("2JKeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fd4928bb49af1e1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1fd4928bb49af1e1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    skip: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.skip",
        "defaultMessage": "Skip"
    },
    next: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.next",
        "defaultMessage": "Next"
    },
    done: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.done",
        "defaultMessage": "Done"
    },
    globalTourHeading: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-heading",
        "defaultMessage": "Use AI to find issues faster"
    },
    globalTourBody: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-body",
        "defaultMessage": "Search for issues with Atlassian Intelligence instead of coming up with complex queries."
    },
    tourHeading: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.tour-heading",
        "defaultMessage": "Just start typing"
    },
    tourBody: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.tour-body",
        "defaultMessage": "The more detail you give us, the more accurate the search results."
    },
    backButtonLabel: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.back-button-label",
        "defaultMessage": "Back - Exit Atlassian Intelligence and return to Basic or JQL search"
    },
    jqlTooComplex: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.jql-too-complex",
        "defaultMessage": "This query is too complex for Basic mode. Atlassian Intelligence has switched to JQL mode to improve results."
    },
    globalTourHeadingIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-heading-issue-terminology-refresh-m4",
        "defaultMessage": "Use AI to find work items faster"
    },
    globalTourBodyIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.natural-language-to-jql-wrapper.global-tour-body-issue-terminology-refresh-m4",
        "defaultMessage": "Search for work items with Atlassian Intelligence instead of coming up with complex queries."
    }
});

});


parcelRegister("5wvgO", function(module, exports) {

$parcel$export(module.exports, "NaturalLanguageToggle", () => $7cfb2a80f496b4d4$export$452ca96ca3dd2544);

var $aoeSI = parcelRequire("aoeSI");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $biF5G = parcelRequire("biF5G");

var $bFO5G = parcelRequire("bFO5G");

var $7jTnu = parcelRequire("7jTnu");

var $5ViUX = parcelRequire("5ViUX");

var $lRq8t = parcelRequire("lRq8t");

var $6sTi7 = parcelRequire("6sTi7");

var $gokBr = parcelRequire("gokBr");

var $fNOMn = parcelRequire("fNOMn");

var $437hw = parcelRequire("437hw");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $bUnif = parcelRequire("bUnif");

var $epTsa = parcelRequire("epTsa");

var $ivqdF = parcelRequire("ivqdF");

var $83x9v = parcelRequire("83x9v");

var $l87UM = parcelRequire("l87UM");
function $7cfb2a80f496b4d4$var$deriveAiState(data, isPremium) {
    const disabledAiState = {
        aiAvailable: false,
        aiEnabled: false
    };
    const action = data?.atlassianIntelligenceAction;
    if (!action) return disabledAiState;
    // Case 1: AI is available, but disabled, and non org admins are notified
    if (action.__typename === 'JiraContactOrgAdminToEnableAtlassianIntelligence') return {
        aiAvailable: true,
        aiEnabled: false,
        isOrgAdmin: false,
        orgAdminLink: null
    };
    // Case 2: AI is available, but disabled, and org admins are guided to the admin hub
    if (action?.__typename === 'JiraEnableAtlassianIntelligenceDeepLink' && action?.link) return {
        aiAvailable: true,
        aiEnabled: false,
        isOrgAdmin: true,
        orgAdminLink: action.link
    };
    // Case 3: AI is available, and enabled
    if (action?.__typename === 'JiraAccessAtlassianIntelligenceFeature' && action.isAccessible) {
        if ((0, $7jTnu.fg)('jira_ai_standard_rollout_rm_premium_checks_gravity')) {
            if (isPremium || (0, $7jTnu.fg)('jira_ai_standard_rollout_switch_nl2jql')) return {
                aiAvailable: true,
                aiEnabled: true
            };
        } else return {
            aiAvailable: true,
            aiEnabled: true
        };
    }
    // Default to AI unavailable
    return disabledAiState;
}
const $7cfb2a80f496b4d4$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $7cfb2a80f496b4d4$var$analyticsEventName = 'jqlBuilderAiToggle';
const $7cfb2a80f496b4d4$export$452ca96ca3dd2544 = ({ autoFocus: autoFocus, onClick: onClick, fragmentRef: fragmentRef, onToggleBlur: onToggleBlur })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const { shouldShowYbrMessage: shouldShowYbrMessage } = (0, $biF5G.useYbrFeature)();
    const isPremium = (0, $7jTnu.fg)('jira_ai_standard_rollout_rm_premium_checks_gravity') ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $ivqdF.useIsPremiumProductAgnostic)() : false;
    // Fires a button viewed analytic event on mount, which is used for the primary metric of the NL2JQL CTA experiment
    // https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-90055/updates
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('ai-event-for-nl2jql-cta-change')) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'aiExperience_nl2jql_button viewed');
    }, [
        createAnalyticsEvent
    ]);
    const jqlDebuggerStoreActions = (0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $bUnif.useJqlDebuggerStoreActions)() : undefined;
    const [isAITourEnabled, { onDisableAITourUserPreference: onDisableAITourUserPreference, onEndAITour: onEndAITour }] = (0, $83x9v.useIsAITourEnabled)();
    const { onSetActiveCard: onSetActiveCard, onEndTour: onEndTour } = (0, $gokBr.useSpotlightCoordinationActions)();
    const handleClick = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', $7cfb2a80f496b4d4$var$analyticsEventName, {
            aiAction: 'aiAccessible'
        });
        onClick();
    }, [
        onClick
    ]);
    const handleTourClick = (0, $eJOHy.useCallback)((analyticsEvent, stop)=>{
        // Prevent any user actions before the JQL builder becomes interactive
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', $7cfb2a80f496b4d4$var$analyticsEventName, {
            aiAction: 'aiAccessible',
            isSpotlightTourViewed: true
        });
        onDisableAITourUserPreference();
        onSetActiveCard((0, $6sTi7.cardKeys).JQL_BUILDER_NL_TOGGLE, stop);
    }, [
        onSetActiveCard,
        onDisableAITourUserPreference
    ]);
    const renderSpotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fNOMn.default), {
        cardKey: (0, $6sTi7.cardKeys).JQL_BUILDER_NL_TOGGLE,
        actions: [
            {
                onClick: ()=>{
                    onSetActiveCard((0, $6sTi7.cardKeys).JQL_BUILDER_NL_TO_JQL);
                    onClick();
                },
                text: formatMessage((0, $l87UM.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>{
                    // End the tour in AI tour store
                    onEndAITour();
                    // End the tour in NIN changeboarding store
                    onEndTour();
                    onDisableAITourUserPreference();
                },
                text: formatMessage((0, $l87UM.default).close)
            }
        ],
        heading: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $l87UM.default).tourHeadingIssueTerminologyRefreshM4 : (0, $l87UM.default).tourHeading),
        target: "jql-builder-with-ai.natural-language-toggle",
        // On cleanup of nl-to-jql-cta-change (if the experiment is to be shipped), the border radius should be `4` to match the Atlaskit button
        targetRadius: (0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'FIND_WORK', 'CONTROL') || (0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'QUICK_SEARCH', 'CONTROL') || (0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'ASK_AI', 'CONTROL') ? 4 : 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        testId: "jql-builder-with-ai.ui.natural-language-toggle.spotlight",
        messageId: "jql-builder-with-ai.ui.natural-language-toggle.spotlight-tour-card.jql-builder-with-ai.natural-language-toggle.spotlight",
        messageType: "transactional"
    }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $l87UM.default).tourBodyIssueTerminologyRefreshM4 : (0, $l87UM.default).tourBody));
    const newNaturalLanguageToggleData = (0, $j4oe4.useFragment)((0, $aoeSI.default), fragmentRef);
    // Spotlight tour should be disabled when AI is not enabled for the org since we still show the AI button with the appropriate popup
    const aiState = $7cfb2a80f496b4d4$var$deriveAiState(newNaturalLanguageToggleData ?? null, isPremium);
    if ((0, $epTsa.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false)) {
        // JQL debugger inherits the AI enabled state from NL-to-JQL as that is the parent experience
        // i.e. At this stage the JQL debugger only exists in the context of NL-to-JQL in Issue Navigator
        if ((0, $7jTnu.fg)('jira_ai_standard_rollout_rm_premium_checks_gravity')) {
            if (isPremium || (0, $7jTnu.fg)('jira_ai_standard_rollout_switch_jql_debugger')) jqlDebuggerStoreActions?.setIsAiEnabled(aiState.aiAvailable && aiState.aiEnabled);
        } else jqlDebuggerStoreActions?.setIsAiEnabled(aiState.aiAvailable && aiState.aiEnabled);
    }
    return shouldShowYbrMessage({
        shouldDisplayMessage: isAITourEnabled && aiState.aiAvailable && aiState.aiEnabled
    }) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bFO5G.Pulse), {
        // On cleanup of nl-to-jql-cta-change (if the experiment is to be shipped), the border radius should be `4` to match the Atlaskit button
        radius: (0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'FIND_WORK', 'CONTROL') || (0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'QUICK_SEARCH', 'CONTROL') || (0, $epTsa.expValEquals)('nl-to-jql-cta-change', 'variant', 'ASK_AI', 'CONTROL') ? 4 : 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $437hw.default), {
        name: "jql-builder-with-ai.natural-language-toggle",
        renderSpotlightCard: renderSpotlightCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ViUX.AIButtonPopup), {
        aiState: aiState,
        autoFocus: autoFocus,
        onClick: (_, analyticsEvent)=>handleTourClick(analyticsEvent),
        analyticsSource: "jiraNaturalLanguageToJql",
        analyticsEventName: $7cfb2a80f496b4d4$var$analyticsEventName,
        onToggleBlur: onToggleBlur
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5ViUX.AIButtonPopup), {
        autoFocus: autoFocus,
        onClick: handleClick,
        analyticsSource: "jiraNaturalLanguageToJql",
        aiState: aiState,
        analyticsEventName: $7cfb2a80f496b4d4$var$analyticsEventName,
        onToggleBlur: onToggleBlur
    });
};

});
parcelRegister("aoeSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $177737acd106e0d9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1944cc3d838e0bedffe687cdec79df24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $177737acd106e0d9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "atlassianIntelligenceProductFeature"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "naturalLanguageToggle_jqlBuilderWithAi",
        "selections": [
            {
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "feature",
                                "variableName": "atlassianIntelligenceProductFeature"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "atlassianIntelligenceProductFeatureInput"
                    },
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "LinkedField",
                "name": "atlassianIntelligenceAction",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "isAccessible"
                            }
                        ],
                        "type": "JiraAccessAtlassianIntelligenceFeature"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "link"
                            }
                        ],
                        "type": "JiraEnableAtlassianIntelligenceDeepLink"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ 
                        ],
                        "type": "JiraContactOrgAdminToEnableAtlassianIntelligence"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$177737acd106e0d9$var$node.hash = "363dd572327018fb46f24a58e80b534f";
var $177737acd106e0d9$export$2e2bcd8739ae039 = $177737acd106e0d9$var$node;

});

parcelRegister("biF5G", function(module, exports) {

$parcel$export(module.exports, "useYbrFeature", () => $3964affdc2e6018d$export$f3013a905e8f3491);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");
const $3964affdc2e6018d$export$f3013a905e8f3491 = ()=>{
    const shouldShowYbrMessage = (0, $eJOHy.useCallback)(({ shouldDisplayMessage: shouldDisplayMessage })=>{
        if (!shouldDisplayMessage) return false;
        (0, $epTsa.expVal)('jira_ybr_first_batch_aa', 'isYBREnabled', false);
        (0, $epTsa.expVal)('jira_ybr_first_batch_both_aa', 'isYBREnabled', false);
        // we should not show the message if the experiment is enabled
        return !(0, $epTsa.expVal)('jira_ybr_first_batch', 'isYBREnabled', false);
    }, []);
    const shouldShowYbrMessageForIssueView = (0, $eJOHy.useCallback)(({ shouldDisplayMessage: shouldDisplayMessage })=>{
        if (!shouldDisplayMessage) return false;
        (0, $epTsa.expVal)('jira_ybr_first_batch_issue_view_aa', 'isYBREnabled', false);
        (0, $epTsa.expVal)('jira_ybr_first_batch_both_aa', 'isYBREnabled', false);
        // we should not show the message if the experiment is enabled
        return !(0, $epTsa.expVal)('jira_ybr_first_batch', 'isYBREnabled', false);
    }, []);
    return {
        shouldShowYbrMessage: shouldShowYbrMessage,
        shouldShowYbrMessageForIssueView: shouldShowYbrMessageForIssueView
    };
};

});

parcelRegister("5ViUX", function(module, exports) {

$parcel$export(module.exports, "AIButtonPopup", () => $77fbb221b7775d82$export$2d1eafbc659cd4ac);

var $eJOHy = parcelRequire("eJOHy");

var $51Gwp = parcelRequire("51Gwp");

var $dbq8g = parcelRequire("dbq8g");

var $7jTnu = parcelRequire("7jTnu");

var $cNe2t = parcelRequire("cNe2t");

var $54ctc = parcelRequire("54ctc");

var $epTsa = parcelRequire("epTsa");

var $89dyA = parcelRequire("89dyA");

var $5oMcR = parcelRequire("5oMcR");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");


var $9paWu = parcelRequire("9paWu");

var $fMnin = parcelRequire("fMnin");
const $77fbb221b7775d82$var$AIPopupContainerComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        ref: ref
    }, children));
const $77fbb221b7775d82$export$2d1eafbc659cd4ac = ({ onClick: onClick, autoFocus: autoFocus, analyticsSource: analyticsSource, aiState: aiState, analyticsEventName: analyticsEventName, onToggleBlur: onToggleBlur })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    if (!aiState.aiAvailable) return null;
    if (aiState.aiEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9paWu.AIButton), {
        onClick: onClick,
        autoFocus: autoFocus,
        onToggleBlur: onToggleBlur
    });
    const { isOrgAdmin: isOrgAdmin, orgAdminLink: orgAdminLink } = aiState;
    const aiModalState = isOrgAdmin ? 'adminOptIn' : 'endUserOptIn';
    const getFormattedMessage = (messageObj)=>formatMessage(messageObj, {
            learn_more_link: (message)=>(0, $7jTnu.fg)('replace-anchor-with-link__gravity-ai') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $51Gwp.default), {
                    target: "_blank",
                    onClick: ()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'atassianIntelligenceLearnMore', {
                            aiAction: aiModalState
                        }),
                    href: (0, $8e9abaad3d9cfcae$export$af6d68522cb370b8)
                }, message) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                    target: "_blank",
                    onClick: ()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'atassianIntelligenceLearnMore', {
                            aiAction: aiModalState
                        }),
                    href: (0, $8e9abaad3d9cfcae$export$af6d68522cb370b8)
                }, message),
            // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
            p: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, message),
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null)
        });
    const handleEvent = (e)=>{
        const payload = e.payload || {};
        const payloadData = payload.data || {};
        // Pipe sendUIEvent type events as UI analytics
        if (payload.type === 'sendUIEvent' && payloadData.action && payloadData.actionSubject && payloadData.actionSubjectId) (0, $gCeeo.fireUIAnalytics)(e, `${payloadData.actionSubject} ${payloadData.action}`, payloadData.actionSubjectId);
        // Pipe sendScreenEvent type events as screen analytics
        if (payload.type === 'sendScreenEvent') (0, $gCeeo.fireScreenAnalytics)(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        messageId: "atlassian-intelligence.common.ui.ai-button-popup.popup.ai-opt-in",
        messageType: "marketing",
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        popupComponent: $77fbb221b7775d82$var$AIPopupContainerComponent,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                sourceName: `${analyticsSource}AiOptInDialog`,
                sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
                attributes: {
                    isOrgAdmin: isOrgAdmin
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dbq8g.default), {
                channel: "fabric-elements",
                onEvent: handleEvent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54ctc.default), {
                source: analyticsSource,
                product: "jira",
                isOrgAdmin: isOrgAdmin,
                image: isOrgAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5oMcR.default), {
                    alt: formatMessage((0, $fMnin.default).aiOptInAltMessage)
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89dyA.default), {
                    alt: formatMessage((0, $fMnin.default).aiOptInAltMessage)
                }),
                testId: "atlassian-intelligence.common.ui.ai-button-popup.ai-opt-in",
                onAdminClose: ()=>setIsOpen(false),
                onAdminCTA: ()=>setIsOpen(false),
                adminCTAText: formatMessage((0, $fMnin.default).adminButton),
                adminCloseCTAText: formatMessage((0, $fMnin.default).dismissButton),
                adminLink: orgAdminLink || undefined,
                headerText: formatMessage((0, $fMnin.default).heading),
                adminHeaderText: formatMessage((0, $fMnin.default).heading),
                bodyText: getFormattedMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fMnin.default).userDescriptionIssueTermRefresh : (0, $fMnin.default).userDescription),
                adminBodyText: getFormattedMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fMnin.default).adminDescriptionIssueTermRefresh : (0, $fMnin.default).adminDescription)
            }))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9paWu.AIButton), {
                ...triggerProps,
                onClick: (_, analyticsEvent)=>{
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'button clicked', analyticsEventName, {
                        aiAction: aiModalState
                    });
                    setIsOpen((open)=>!open);
                },
                autoFocus: autoFocus,
                onToggleBlur: onToggleBlur
            }),
        placement: "bottom-start"
    });
};

});
parcelRegister("54ctc", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c3c6291e662102$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $f1Zdy = parcelRequire("f1Zdy");

var $alkjW = parcelRequire("alkjW");
var $kQDPJ = parcelRequire("kQDPJ");

var $51Gwp = parcelRequire("51Gwp");

var $8XtVW = parcelRequire("8XtVW");

var $bxHeV = parcelRequire("bxHeV");
var $5Wv5g = parcelRequire("5Wv5g");

var $fcRdu = parcelRequire("fcRdu");


var $dEYQt = parcelRequire("dEYQt");

var $7k7YP = parcelRequire("7k7YP");
const $83c3c6291e662102$var$VisibleTextOrgAdminStyles = (0, $5Wv5g.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $83c3c6291e662102$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>(0, $8XtVW.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $51Gwp.default), {
                href: (0, $d76404a4513d733f$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                href: (0, $d76404a4513d733f$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $dEYQt.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $dEYQt.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $dEYQt.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $eJOHy.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($fcRdu)))
        ]);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7k7YP.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7k7YP.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7k7YP.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7k7YP.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fcRdu))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7k7YP.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bxHeV.default), {
                            xcss: $83c3c6291e662102$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $dEYQt.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7k7YP.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7k7YP.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7k7YP.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $alkjW.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $dEYQt.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kQDPJ.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $d76404a4513d733f$export$bae9a077d7ed5dfe),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $dEYQt.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $83c3c6291e662102$export$2e2bcd8739ae039 = $83c3c6291e662102$var$AiOptIn;

});
parcelRegister("fcRdu", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $d76404a4513d733f$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $d76404a4513d733f$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("dEYQt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2bff351fc81c255e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2bff351fc81c255e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("7k7YP", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $cda706091768ef8a$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $cda706091768ef8a$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $cda706091768ef8a$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $cda706091768ef8a$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $cda706091768ef8a$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $cda706091768ef8a$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $cda706091768ef8a$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $cda706091768ef8a$export$24c280970213bb11 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1o46 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $cda706091768ef8a$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkosqtm _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $cda706091768ef8a$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $cda706091768ef8a$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $cda706091768ef8a$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nbxd",
            __cmplp.className
        ])
    });
});
const $cda706091768ef8a$export$14966827497f4695 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr",
            __cmplp.className
        ])
    });
});
const $cda706091768ef8a$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("89dyA", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4b32c3c57d2c63$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $ciMhE = parcelRequire("ciMhE");
const $df4b32c3c57d2c63$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($ciMhE)));
const $df4b32c3c57d2c63$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($ciMhE)));
const $df4b32c3c57d2c63$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: $df4b32c3c57d2c63$export$abdf1e325e38b834,
    srcDark: $df4b32c3c57d2c63$export$87ec2877821a8f12
});
var $df4b32c3c57d2c63$export$2e2bcd8739ae039 = $df4b32c3c57d2c63$var$Illustration;
// for advanced use only
const $df4b32c3c57d2c63$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    110
];

});
parcelRegister("ciMhE", function(module, exports) {
module.exports = new URL("ai-enable-banner-end-user.a7576f2c.svg", import.meta.url).toString();

});


parcelRegister("5oMcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ebf290b831006d1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $aIQNu = parcelRequire("aIQNu");
const $5ebf290b831006d1$export$87ec2877821a8f12 = (0, (/*@__PURE__*/$parcel$interopDefault($aIQNu)));
const $5ebf290b831006d1$export$abdf1e325e38b834 = (0, (/*@__PURE__*/$parcel$interopDefault($aIQNu)));
const $5ebf290b831006d1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: $5ebf290b831006d1$export$abdf1e325e38b834,
    srcDark: $5ebf290b831006d1$export$87ec2877821a8f12
});
var $5ebf290b831006d1$export$2e2bcd8739ae039 = $5ebf290b831006d1$var$Illustration;
// for advanced use only
const $5ebf290b831006d1$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    110
];

});
parcelRegister("aIQNu", function(module, exports) {
module.exports = new URL("ai-enable-banner-org-admin.1ceaac44.svg", import.meta.url).toString();

});


parcelRegister("fMnin", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51f840713cd6481$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b51f840713cd6481$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "atlassian-intelligence.common.ai-button-popup.heading",
        "defaultMessage": "Speed up your search"
    },
    adminDescription: {
        "id": "atlassian-intelligence.common.ai-button-popup.admin-description",
        "defaultMessage": "<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), your team can find their issues faster with a simple prompt.</p><p>Activate Atlassian Intelligence for your users from Atlassian Administration.</p>"
    },
    userDescription: {
        "id": "atlassian-intelligence.common.ai-button-popup.user-description",
        "defaultMessage": "<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), find your issues faster by typing a simple prompt.</p><p>Contact your organization admin if you're interested in trying Atlassian Intelligence.</p>"
    },
    learnMore: {
        "id": "atlassian-intelligence.common.ai-button-popup.learn-more",
        "defaultMessage": "Learn more about Atlassian Intelligence"
    },
    dismissButton: {
        "id": "atlassian-intelligence.common.ai-button-popup.dismiss-button",
        "defaultMessage": "Maybe later"
    },
    adminButton: {
        "id": "atlassian-intelligence.common.ai-button-popup.admin-button",
        "defaultMessage": "Get Started"
    },
    userButton: {
        "id": "atlassian-intelligence.common.ai-button-popup.user-button",
        "defaultMessage": "Contact your Admin"
    },
    aiOptInAltMessage: {
        "id": "atlassian-intelligence.common.ai-button-popup.banner-alt",
        "defaultMessage": "Decorative pop up banner"
    },
    adminDescriptionIssueTermRefresh: {
        "id": "atlassian-intelligence.common.ai-button-popup.admin-description-issue-term-refresh",
        "defaultMessage": "<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), your team can find their work faster with a simple prompt.</p><p>Activate Atlassian Intelligence for your users from Atlassian Administration.</p>"
    },
    userDescriptionIssueTermRefresh: {
        "id": "atlassian-intelligence.common.ai-button-popup.user-description-issue-term-refresh",
        "defaultMessage": "<p>With <learn_more_link>Atlassian Intelligence</learn_more_link> (AI), find your work faster by typing a simple prompt.</p><p>Contact your organization admin if you're interested in trying Atlassian Intelligence.</p>"
    }
});

});


parcelRegister("ivqdF", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $b1a6792f3a792a23$export$1bb5840a003dc643);
$parcel$export(module.exports, "useIsPremiumProductAgnostic", () => $b1a6792f3a792a23$export$1c900b6f3db04952);
$parcel$export(module.exports, "useOptInStatus", () => $b1a6792f3a792a23$export$5e56b08674e48311);
$parcel$export(module.exports, "useAIOptIn", () => $b1a6792f3a792a23$export$49e57b9044cda91c);

var $eJOHy = parcelRequire("eJOHy");

var $9id36 = parcelRequire("9id36");
var $igNUx = parcelRequire("igNUx");

var $ln6Iy = parcelRequire("ln6Iy");

var $bmoS1 = parcelRequire("bmoS1");

var $3ASEn = parcelRequire("3ASEn");

var $bNexr = parcelRequire("bNexr");

var $g9Vr6 = parcelRequire("g9Vr6");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $lUto7 = parcelRequire("lUto7");

var $7jTnu = parcelRequire("7jTnu");

var $fbqHd = parcelRequire("fbqHd");

var $fgQXu = parcelRequire("fgQXu");
const $b1a6792f3a792a23$var$DISABLED = 'disabled';
const $b1a6792f3a792a23$var$DISABLED_OPT_IN = 'disabled-opt-in';
const $b1a6792f3a792a23$var$ENABLED = 'enabled';
const $b1a6792f3a792a23$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    switch(projectType){
        case 0, $ln6Iy.CORE_PROJECT:
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return appEditions.software === (0, $a9ldn.PREMIUM_EDITION);
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $a9ldn.PREMIUM_EDITION);
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
            if ((0, $7jTnu.fg)('jira_ai_standard_rollout_rm_premium_checks_gravity')) return appEditions.productDiscovery === (0, $a9ldn.PREMIUM_EDITION);
            return false;
        default:
            return false;
    }
};
const $b1a6792f3a792a23$export$1c900b6f3db04952 = ()=>{
    const { productDiscovery: productDiscovery, serviceDesk: serviceDesk, software: software, core: core, customerService: customerService } = (0, $8vyDv.useAppEditions)();
    return [
        productDiscovery,
        serviceDesk,
        software,
        core,
        customerService
    ].some((edition)=>edition === (0, $a9ldn.PREMIUM_EDITION));
};
const $b1a6792f3a792a23$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $8vyDv.useAppEditions)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $ln6Iy.CORE_PROJECT:
            return appEditions.core === (0, $a9ldn.STANDARD_EDITION);
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return appEditions.software === (0, $a9ldn.STANDARD_EDITION);
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $a9ldn.STANDARD_EDITION);
        default:
            return false;
    }
};
const $b1a6792f3a792a23$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isPremium = $b1a6792f3a792a23$export$1bb5840a003dc643();
    const isSupportedENV = !(0, $igNUx.isFedRamp)();
    return isOrgAdmin && isPremium && isSupportedENV;
};
const $b1a6792f3a792a23$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isStandard = $b1a6792f3a792a23$export$10e0dafdd792475b();
    const isSupportedENV = !(0, $igNUx.isFedRamp)();
    return isOrgAdmin && isStandard && isSupportedENV;
};
const $b1a6792f3a792a23$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $b1a6792f3a792a23$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $b1a6792f3a792a23$export$1276193c77ae88bf();
    if ((0, $igNUx.isFedRamp)()) return $b1a6792f3a792a23$var$DISABLED;
    // AI Upsell In Editor Experiment - implicitly checks product, fedramp, if edition is FREE and user is an admin
    const { experimentValue: aiUpsellInEditorCohort } = (0, $7jTnu.fg)('jira_free_ai_in_editor_v2_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3ASEn.useAIUpsellInEditorRequirements)(product) : {
        experimentValue: 'not-enrolled'
    };
    if (aiUpsellInEditorCohort === 'variation') return $b1a6792f3a792a23$var$DISABLED_OPT_IN;
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $b1a6792f3a792a23$var$DISABLED_OPT_IN : $b1a6792f3a792a23$var$DISABLED;
    return isAIOptedIn ? $b1a6792f3a792a23$var$ENABLED : globalOptInEnabled;
};
const $b1a6792f3a792a23$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $b1a6792f3a792a23$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $lUto7.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $eJOHy.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $eJOHy.useState)(false);
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const canStartTrial = $b1a6792f3a792a23$export$1276193c77ae88bf();
    // AI Upsell In Editor Experiment
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = (0, $7jTnu.fg)('jira_free_ai_in_editor_v2_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3ASEn.useAIUpsellInEditorFree)(optInStatus, product) : {
        isExperimentEnabled: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerUpsellFlow: ()=>{},
        UpsellModal: null
    };
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $eJOHy.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $eJOHy.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $eJOHy.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $9id36.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgQXu.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $eJOHy.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fbqHd.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgQXu.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if ((0, $igNUx.isFedRamp)()) return {
        optInStatus: $b1a6792f3a792a23$var$DISABLED,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerOptInFlow: ()=>{},
        AIOptInModal: null
    };
    if (isAIUpsellInEditorFreeEnabled) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
        AIOptInModal: AIUpsellInEditorFreeModal
    };
    if (optInStatus === $b1a6792f3a792a23$var$DISABLED || optInStatus === $b1a6792f3a792a23$var$ENABLED) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === $b1a6792f3a792a23$var$DISABLED_OPT_IN) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("3ASEn", function(module, exports) {

$parcel$export(module.exports, "useAIUpsellInEditorRequirements", () => $7196f41a17032ef3$export$38bfb0ec25eaa6b2);
$parcel$export(module.exports, "useAIUpsellInEditorFree", () => $7196f41a17032ef3$export$beacfd188d344f95);
$parcel$export(module.exports, "AIUpsellButtonWrapper", () => $7196f41a17032ef3$export$c44b9b0347b51c37);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $igNUx = parcelRequire("igNUx");

var $ln6Iy = parcelRequire("ln6Iy");

var $epTsa = parcelRequire("epTsa");

var $dtWnM = parcelRequire("dtWnM");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $lUto7 = parcelRequire("lUto7");

var $7jTnu = parcelRequire("7jTnu");

var $8JLU7 = parcelRequire("8JLU7");

var $ecGT4 = parcelRequire("ecGT4");
const $7196f41a17032ef3$var$useGetSupportedProjectType = (product)=>{
    const siteHasOnlyJira = (0, $8JLU7.useSiteHasOnlyJira)();
    switch(product){
        case 'JSW':
            return 0, $ln6Iy.SOFTWARE_PROJECT;
        case 'JSM':
            return 0, $ln6Iy.SERVICE_DESK_PROJECT;
        case 'JWM':
            // If tenant is configured with only JWM and JSW, we can provide an upgrade link for JSW
            return siteHasOnlyJira ? (0, $ln6Iy.SOFTWARE_PROJECT) : undefined;
        case 'JPD':
        default:
            return undefined;
    }
};
const $7196f41a17032ef3$var$useGetSupportedEdition = (product)=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const projectType = $7196f41a17032ef3$var$useGetSupportedProjectType(product);
    if (!appEditions) return undefined;
    if (projectType) return (0, $a9ldn.getEditionForProject)(projectType, appEditions);
    return undefined;
};
const $7196f41a17032ef3$export$38bfb0ec25eaa6b2 = (product)=>{
    const isOrgAdmin = (0, $lUto7.useIsSiteAdmin)();
    const supportedEdition = $7196f41a17032ef3$var$useGetSupportedEdition(product);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config, fireExperimentExposure] = (0, $epTsa.UNSAFE_noExposureExp)('jira_free_ai_in_editor_v2_experiment');
    const statsigExperimentValue = config.get('cohort', 'not-enrolled');
    const siteMeetsRequirements = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('jira_free_ai_in_editor_v2_gate') && supportedEdition === (0, $a9ldn.FREE_EDITION) && isOrgAdmin && !(0, $igNUx.isFedRamp)();
    const experimentValue = siteMeetsRequirements ? statsigExperimentValue : 'not-enrolled';
    const fireExposure = (0, $eJOHy.useCallback)(()=>{
        fireExperimentExposure();
    }, [
        fireExperimentExposure
    ]);
    return {
        siteMeetsRequirements: siteMeetsRequirements,
        experimentValue: experimentValue,
        statsigExperimentValue: statsigExperimentValue,
        fireExperimentExposure: fireExposure
    };
};
const $7196f41a17032ef3$export$beacfd188d344f95 = (optInStatus, product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const [showUpsellModal, setShowUpsellModal] = (0, $eJOHy.useState)(false);
    const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $7196f41a17032ef3$export$38bfb0ec25eaa6b2(product);
    const projectType = $7196f41a17032ef3$var$useGetSupportedProjectType(product);
    const siteMeetsOptInRequirements = siteMeetsRequirements && // optInStatus 'disabled' means they are on control, 'disabled-opt-in' on variation
    optInStatus !== 'enabled';
    const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : 'not-enrolled';
    // If the site is not FREE, or not on JSW/JSM, or the user is not billable, they are not enrolled
    const isEnrolledInExperiment = experimentValue !== 'not-enrolled';
    const isExperimentEnabled = isEnrolledInExperiment && experimentValue === 'variation';
    const triggerUpsellFlow = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'triggerUpsellFlow',
            actionSubject: 'aiUpsellInEditorFree'
        }), 'aiUpsellInEditorFreeTrigger', {});
        setShowUpsellModal(true);
        (0, $ecGT4.setUpsellButtonWrapperClicked)(true);
    }, [
        createAnalyticsEvent
    ]);
    const UpsellModal = (0, $eJOHy.useMemo)(()=>showUpsellModal && projectType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dtWnM.AsyncAiUpsellInEditorFreeModal), {
            projectType: projectType,
            testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
            onModalClose: ()=>setShowUpsellModal(false)
        }) : null, [
        showUpsellModal,
        projectType
    ]);
    return {
        isEnrolledInExperiment: isEnrolledInExperiment,
        isExperimentEnabled: isExperimentEnabled,
        fireExperimentExposure: fireExperimentExposure,
        triggerUpsellFlow: triggerUpsellFlow,
        UpsellModal: UpsellModal
    };
};
const $7196f41a17032ef3$export$c44b9b0347b51c37 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const isClicked = (0, $ecGT4.getUpsellButtonWrapperClicked)();
    const hasFired = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasFired.current) {
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {});
            hasFired.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    return !isClicked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7196f41a17032ef3$var$AIUpsellButtonContainer, {
        "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7196f41a17032ef3$var$AIUpsellButtonInner, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7196f41a17032ef3$var$AIUpsellButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
            __cmplp.className
        ])
    });
});
const $7196f41a17032ef3$var$AIUpsellButtonInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dtWnM", function(module, exports) {

$parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", () => $0812a48fe511f837$export$827041a383456a6a);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $gzcjr = parcelRequire("gzcjr");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0812a48fe511f837$var$LazyAiUpsellInEditorFreeModal = (0, $gzcjr.lazyAfterPaint)(()=>(parcelRequire("35syH")), {
    ssr: false,
    moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
});
const $0812a48fe511f837$export$827041a383456a6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "asyncAiUpsellInEditorFreeModal",
        packageName: "jira-growth-ai-upsell-in-editor-free-modal",
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0812a48fe511f837$var$LazyAiUpsellInEditorFreeModal, props));

});
parcelRegister("35syH", function(module, exports) {

let $23f7fde0d7bbb653$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $23f7fde0d7bbb653$var$load("7vqGd"),
    $23f7fde0d7bbb653$var$load("1Y4bq"),
    $23f7fde0d7bbb653$var$load("1VRB2"),
    $23f7fde0d7bbb653$var$load("bABhq"),
    $23f7fde0d7bbb653$var$load("4sqLT")
]).then(()=>parcelRequire('2Honi'));

});


parcelRegister("ecGT4", function(module, exports) {

$parcel$export(module.exports, "getUpsellButtonWrapperClicked", () => $bb9787aee3f3a8f5$export$f7d51ee95145148b);
$parcel$export(module.exports, "setUpsellButtonWrapperClicked", () => $bb9787aee3f3a8f5$export$b595420beb43f9ce);

var $dnU6V = parcelRequire("dnU6V");
const $bb9787aee3f3a8f5$export$c2ed3351cac403d1 = (0, $dnU6V.createLocalStorageProvider)('ai-upsell-in-editor-free');
function $bb9787aee3f3a8f5$export$f7d51ee95145148b() {
    return Boolean($bb9787aee3f3a8f5$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
}
function $bb9787aee3f3a8f5$export$b595420beb43f9ce(value) {
    $bb9787aee3f3a8f5$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
}

});


parcelRegister("fbqHd", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $1d2e3b5497523dc6$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $1d2e3b5497523dc6$export$dd0a751f23b19473);

var $eJOHy = parcelRequire("eJOHy");

var $bbdV2 = parcelRequire("bbdV2");

var $kuFbR = parcelRequire("kuFbR");

var $jM5Jy = parcelRequire("jM5Jy");
const $1d2e3b5497523dc6$export$77aa5ca661b0742c = (0, $kuFbR.createUseEntryPointContext)();
const $1d2e3b5497523dc6$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $bbdV2.useEntryPoint)((0, $jM5Jy.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d2e3b5497523dc6$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("kuFbR", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $38dc9eb5446138c0$export$41bce2223126846b);

var $eJOHy = parcelRequire("eJOHy");
const $38dc9eb5446138c0$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $eJOHy.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("fgQXu", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $0bb97ed6f363167b$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $0bb97ed6f363167b$export$bbf8d259a508a485);

var $eJOHy = parcelRequire("eJOHy");

var $jC5ye = parcelRequire("jC5ye");

var $aC4Bh = parcelRequire("aC4Bh");

var $54ctc = parcelRequire("54ctc");

var $cBavF = parcelRequire("cBavF");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $fbqHd = parcelRequire("fbqHd");

var $7be6P = parcelRequire("7be6P");
const $0bb97ed6f363167b$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jC5ye.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54ctc.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $0bb97ed6f363167b$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $eJOHy.useContext)((0, $fbqHd.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jC5ye.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-premium-trial-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7be6P.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("7be6P", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $ee2053d68bec851c$export$54e4ba490d2c6bb5);

var $eJOHy = parcelRequire("eJOHy");

var $4BzUI = parcelRequire("4BzUI");

var $bvFRW = parcelRequire("bvFRW");

var $iRTqk = parcelRequire("iRTqk");

var $jkibc = parcelRequire("jkibc");
var $bxHeV = parcelRequire("bxHeV");
var $bL3dk = parcelRequire("bL3dk");
var $9LyfF = parcelRequire("9LyfF");
var $jvsV6 = parcelRequire("jvsV6");
var $5Wv5g = parcelRequire("5Wv5g");

var $gaoa9 = parcelRequire("gaoa9");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $40abG = parcelRequire("40abG");

var $ebJ4i = parcelRequire("ebJ4i");
const $ee2053d68bec851c$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bxHeV.default), {
        xcss: $ee2053d68bec851c$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        alignBlock: "stretch",
        xcss: $ee2053d68bec851c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $ee2053d68bec851c$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BzUI.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $40abG.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRTqk)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jkibc.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gaoa9.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9LyfF.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $ee2053d68bec851c$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bvFRW.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $40abG.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvsV6.default), {
        as: "p"
    }, formatMessage((0, $40abG.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bL3dk.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ebJ4i.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $ee2053d68bec851c$var$containerBorderStyles = (0, $5Wv5g.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${"var(--ds-background-accent-blue-subtle, #579DFF)"} 0%,
      ${"var(--ds-background-accent-purple-subtle, #9F8FEF)"} 100%
    )`
});
const $ee2053d68bec851c$var$containerStyles = (0, $5Wv5g.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $ee2053d68bec851c$var$headerStyles = (0, $5Wv5g.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $ee2053d68bec851c$var$textContainerStyles = (0, $5Wv5g.xcss)({
    padding: 'space.300'
});

});
parcelRegister("gaoa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f54c550714c7bd$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $2Ne55 = parcelRequire("2Ne55");

var $fOpQP = parcelRequire("fOpQP");
const $92f54c550714c7bd$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fOpQP)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2Ne55))
});
var $92f54c550714c7bd$export$2e2bcd8739ae039 = $92f54c550714c7bd$var$Illustration;
// for advanced use only
const $92f54c550714c7bd$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("2Ne55", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("fOpQP", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("40abG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $625df7e329ab5e65$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $625df7e329ab5e65$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("ebJ4i", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $d15a51af21f846e9$export$a2651a739f515dd4);

var $eJOHy = parcelRequire("eJOHy");

var $iTElX = parcelRequire("iTElX");

var $dZcLi = parcelRequire("dZcLi");

var $ciFJV = parcelRequire("ciFJV");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $f1Zdy = parcelRequire("f1Zdy");

var $fbqHd = parcelRequire("fbqHd");

var $40abG = parcelRequire("40abG");
const $d15a51af21f846e9$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { entryPointActions: entryPointActions } = (0, $eJOHy.useContext)((0, $fbqHd.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const onClickAnalytics = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iTElX.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZcLi))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $40abG.messages).tryItFreeButton));
};

});




parcelRegister("l87UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c80a447ff586b96$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8c80a447ff586b96$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    close: {
        "id": "jql-builder-with-ai.natural-language-toggle.close",
        "defaultMessage": "Close"
    },
    next: {
        "id": "jql-builder-with-ai.natural-language-toggle.next",
        "defaultMessage": "Next"
    },
    tourHeading: {
        "id": "jql-builder-with-ai.natural-language-toggle.tour-heading",
        "defaultMessage": "Use AI to find issues faster"
    },
    tourBody: {
        "id": "jql-builder-with-ai.natural-language-toggle.tour-body",
        "defaultMessage": "Search for issues with Atlassian Intelligence instead of coming up with complex queries."
    },
    tourHeadingIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.natural-language-toggle.tour-heading-issue-terminology-refresh-m4",
        "defaultMessage": "Use AI to find work items faster"
    },
    tourBodyIssueTerminologyRefreshM4: {
        "id": "jql-builder-with-ai.natural-language-toggle.tour-body-issue-terminology-refresh-m4",
        "defaultMessage": "Search for work items with Atlassian Intelligence instead of coming up with complex queries."
    }
});

});


parcelRegister("4tvLM", function(module, exports) {

$parcel$export(module.exports, "SpotlightTourContainer", () => $2a7a0cf73204f9ee$export$1ea37624009cc192);

var $236JP = parcelRequire("236JP");

var $9lv1M = parcelRequire("9lv1M");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $kEUB1 = parcelRequire("kEUB1");

var $83x9v = parcelRequire("83x9v");
const $2a7a0cf73204f9ee$export$1ea37624009cc192 = ({ children: children, userPreferences: userPreferences })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const data = (0, $j4oe4.useFragment)((0, $9lv1M.default), userPreferences);
    const [commitMutation] = (0, $j4oe4.useMutation)((0, $236JP.default));
    // Disable the user preference when the tour starts so it's not shown on subsequent page loads
    const onDisableAITourUserPreference = (0, $eJOHy.useCallback)(()=>{
        commitMutation({
            variables: {
                cloudId: cloudId,
                isEnabled: false
            }
        });
    }, [
        cloudId,
        commitMutation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $83x9v.Container), {
        isAITourUserPreferenceEnabled: !!data?.isNaturalLanguageSpotlightTourEnabled,
        onDisableAITourUserPreference: onDisableAITourUserPreference
    }, children);
};

});
parcelRegister("236JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c71fbdfd0f463e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<16c73ccf3982bca1cf2f614dba33dfe5>>
 * @relayHash 3d2c5ddeb85976376bf23644a86ec8aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67440c6686cbb6e5d580c5933c5b60b037aaabee039dcba07e13519ee974cdb0
const $63c71fbdfd0f463e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEnabled"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isEnabled",
                                    "variableName": "isEnabled"
                                }
                            ],
                            "concreteType": "JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload",
                            "kind": "LinkedField",
                            "name": "setNaturalLanguageSpotlightTourEnabled",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "67440c6686cbb6e5d580c5933c5b60b037aaabee039dcba07e13519ee974cdb0",
            "metadata": {},
            "name": "spotlightTourContainer_setSpotlightTourEnabledMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$63c71fbdfd0f463e$var$node.hash = "3f359c84a909e0fee178266828c63fb5";
var $63c71fbdfd0f463e$export$2e2bcd8739ae039 = $63c71fbdfd0f463e$var$node;

});

parcelRegister("9lv1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c79a4e1dcc82157$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c41a47c132c7af9affa124c2a948186c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6c79a4e1dcc82157$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "spotlightTourContainer_jqlBuilderWithAi",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isNaturalLanguageSpotlightTourEnabled"
        }
    ],
    "type": "JiraUserPreferences"
};
$6c79a4e1dcc82157$var$node.hash = "c677e86a45a387c3d35af97d3ab14b64";
var $6c79a4e1dcc82157$export$2e2bcd8739ae039 = $6c79a4e1dcc82157$var$node;

});





//# sourceMappingURL=async-jql-builder-with-ai.d8ffe4b7.js.map
